export const QUESTIONS = [
  {
    "id": 1,
    "question": "Which statement about business continuity planning and information security is most correct?",
    "choice_a": "Plans are useful only because they start the development of detailed procedures and processes, and thus, there is no need to maintain or improve such plans.",
    "choice_b": "Planning is more important than the plans it produces.",
    "choice_c": "Plans represent significant investments and decisions and thus, should be updated only when significant changes to objectives or circumstances dictate.",
    "choice_d": "Planning should continuously bring plans and procedures in tune with ongoing operational reality.",
    "correct_answer": "D",
    "explanation": "Planning should be an ongoing, continuous, and iterative process; plans are thus, continually tested against reality so that changes to plans and procedures stay harmonized. Thus, Option D is most correct. <br>Option C, unfortunately, is a commonly held view and can lead to work being done to obsolete ideas or to assumptions long since proven to be incorrect by reality. <br>Option B is good but not as correct and complete as D. <br>Option A is incorrect; effective plans define and prioritize objectives, lay out major tasks and processes, assign resources to achieve those, and define success criteria for each; plans should be manageable and measurable.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      581,
      487,
      488,
      510,
      32
    ],
    "source": ""
  },
  {
    "id": 2,
    "question": "Which of the following statements about social engineering attacks is incorrect?",
    "choice_a": "Most targeted individuals don't see the harm in responding or in answering simple questions posed by the attacker.",
    "choice_b": "Most people believe they are too smart to fall for such obvious ploys, but they do anyway.",
    "choice_c": "Most targeted individuals and organizations have effective tools and procedures to filter out phishing and related scams, so they are now better protected from such attacks.",
    "choice_d": "Most people want to be trusting and helpful.",
    "correct_answer": "C",
    "explanation": "Options A, B, and D all demonstrate the hallmarks of social engineering attacks\u2014they work (and have worked for thousands of years) because people are generally trusting, open, and willing to engage with strangers. <br>Option C, the correct choice, is unfortunately not true; tools may help filter out some email-based social engineering attacks, but few organizations have truly been able to operate with a \u201cloose lips sink ships\u201d approach and deal openly with customers, clients, and many other outside stakeholders.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      81,
      85,
      92,
      78,
      77
    ],
    "source": ""
  },
  {
    "id": 3,
    "question": "In general, what differentiates phishing from whaling attacks?",
    "choice_a": "Phishing attacks tend to be used to gain access to systems via malware payloads or by getting recipients to disclose information, whereas whaling attacks try to get responsible managers to authorize payments to the attacker's accounts.",
    "choice_b": "Phishing attacks are focused on businesses; whaling attacks are focused on high-worth individuals.",
    "choice_c": "Whaling attacks tend to offer something that ought to sound \u201ctoo good to be true,\u201d whereas phishing attacks masquerade as routine business activities such as package delivery confirmations.",
    "choice_d": "Whaling attacks send out huge numbers of emails attempting to lure targeted individuals into responding or following a link; phishing attacks use telephones or other means of making personal contact with a selected target.",
    "correct_answer": "A",
    "explanation": "Option A is correct; phishing tends to seek information, and whaling (and spear phishing) seeks action, typically the release of funds to the attacker. <br>Option B is incorrect; whaling is primarily aimed at senior business leaders, whereas phishing can be aimed at anybody, anywhere, if the attacker perceives there is something worthwhile to learn in doing so. <br>Option C has these reversed; whaling attacks depend on credibility of the business transaction they request. <br>Option D is incorrect, since it reverses key characteristics of whaling and phishing.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      24,
      25,
      29,
      33,
      20
    ],
    "source": ""
  },
  {
    "id": 4,
    "question": "You're the only IT person at a small tool and die machine shop, which uses a LAN and cloud-hosted platforms to run the business on. The previous IT person had told your boss not to worry about the business being the target of a cyberattack. Which statement best lets you explain the real risks the company might face?",
    "choice_a": "Since we don't handle consumer-level payment cards, and we really don't have any proprietary information, we probably don't have to worry about being a target.",
    "choice_b": "We do share an extranet connection with key customers and suppliers, but it should prevent an attack on our systems that could lead to an attack on theirs.",
    "choice_c": "Our cloud systems hosting company provides most of our security, and as long as we keep our systems on the factory floor and the workstations our staff use properly updated, we should be okay.",
    "choice_d": "Since we haven't really done even a basic vulnerabilities assessment, we don't know what risks we could be facing. Let's do that much at least, and let that tell us what the next step should be soon.",
    "correct_answer": "D",
    "explanation": "While Option A may be true, it is naive and incorrect; the air conditioning company that serviced Target stores didn't handle retail (credit card) sales either, yet attackers found it to be an ideal entry into Target's payment processing systems. <br>Option C is also incorrect; your cloud hosts will protect their systems, and their platforms, from malware attacks from your connections, but attackers who spoof bogus, privileged accounts into your systems can still destroy your business's presence in those cloud systems. <br>Option B is incorrect; without doing a detailed vulnerability assessment of that architecture, you are at risk making this assumption. <br>Option D offers the boss a sensible first step.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      73,
      72,
      75,
      89,
      101
    ],
    "source": ""
  },
  {
    "id": 5,
    "question": "Which of these steps would <italic>not</italic> help you limit or prevent attacks on your systems that attempt to spoof, corrupt, or tamper with data?",
    "choice_a": "Ensure that firewalls, routers, and other network infrastructures filter for and block attempts to access network storage without authorization.",
    "choice_b": "Develop and use an organizational data model and data dictionary that contain all data-focused business logic; use them to build and validate business processes and the apps that support them.",
    "choice_c": "Implement data quality processes that ensure all data is fit for all purposes, in accordance with approved business logic.",
    "choice_d": "Implement information classification, and use access control and identity management to enforce it.",
    "correct_answer": "A",
    "explanation": "Option A by itself won't do what is needed; at a minimum, Option D and its implementation of rigorous access control and identity management is necessary to protect network storage resources from being corrupted, tampered with, and so forth. The others are all valuable parts of a data governance and data security/data protection plan.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      254,
      231,
      229,
      217,
      265
    ],
    "source": ""
  },
  {
    "id": 6,
    "question": "Which of the following are not examples of \u201cshadow IT\u201d contributing to an information security problem? <ol type=\"A\"><li>One user defines a format or style sheet for specific types of documents for others in the division to use.</li><li>An end user writes special-purpose database queries and reports used to forecast sales and project production and inventory needs, which are reviewed and used at weekly division meetings.</li><li>Several users build scripts, flows, and other processing logic to implement a customer service help desk/trouble ticket system, using its own database on a shared use/collaboration platform that the company uses.</li><li>Users post documents, spreadsheets, and many other types of information on a company-provided shared storage system, making the information more freely available throughout the company. </li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, C and D",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "A",
    "explanation": "The key determiner of whether user-defined and user-maintained \u201cstuff\u201d is shadow IT is the amount of business logic that it embeds or implements; the more such business logic is built into uncontrolled or unmanaged apps or tools, the greater the risk of something going wrong in undetected ways. Thus, Option A is not a probable risk. <br>Option B seems to have a lot of frequent, intensive reviews of the results of these queries, which would need to correlate or compare with what the production information systems would show. <br>Option C implements customer relationship management and systems/product maintenance business logic; <br>Option D seems to circumvent information classification, segregation of duties, and other access control principles. <br>Both C and D bear close watching.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      266,
      217,
      231,
      227,
      223
    ],
    "source": ""
  },
  {
    "id": 7,
    "question": "Which statement about privacy and data protection is the most correct and most important?",
    "choice_a": "International standards and agreements specify that personally identifiable information (PII) and information about an individual's healthcare, education, work, or credit history must be protected from unauthorized use or disclosure.",
    "choice_b": "It's up to the organization that gathers, produces, uses, or disposes of such private data to determine what protection, if any, is needed.",
    "choice_c": "Storing backup or archive copies of privacy-related information in a datacenter in another country, without doing any processing there, does not subject you to that country's data protection laws.",
    "choice_d": "Sometimes, it seems cheaper to run the risk of fines or loss of business from a data breach involving privacy-related data than to implement proper data protection to prevent such a loss. While this might make financial sense, it is not legal or ethical to do so.",
    "correct_answer": "D",
    "explanation": "Option A is false; no such agreements apply worldwide. At best, regulations like the General Data Protection Regulation (GDPR) apply to EU member states. <br>Option B is true as far as it goes, but with a catch: if the organization guesses wrong, it could end up in serious legal trouble in multiple jurisdictions. <br>Option C is false; storage of data in a center in another country must involve movement of data from your jurisdiction into the one the datacenter is in, and movement in the reverse direction when you need to use the backup. In almost all cases, data protection laws and regulations apply to data in use, at rest, and in motion. <br>Option D correctly illustrates the need to ensure that professional ethics have a voice in making risk management decisions.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      746,
      233,
      227,
      201,
      266
    ],
    "source": ""
  },
  {
    "id": 8,
    "question": "In which phase or phases of a typical data exfiltration attack would an attacker probably not make use of phishing? <ol type=\"A\"><li>Reconnaissance and characterization</li><li>Data gathering, clumping, masking, and aggregating</li><li>Installing and using covert command and control capabilities</li><li>Initial access </li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Phishing and many other social engineering tactics have played a major role in over 60 percent of major data breaches in the past few years. Such tactics have high payoff to the attacker during their search for a possible target, gathering information about its systems and security, and then their initial entry into the target's systems. <br>Thus, Options A and D are likely phases for phishing attacks, and incorrect answers to this question (note the \u201cnot make use\u201d). <br>Option B and C are almost exclusively done surreptitiously, exploiting information that social engineering may have revealed to the attacker; few if any signs of phishing in these activities have been noted.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      259,
      267,
      253,
      233,
      252
    ],
    "source": ""
  },
  {
    "id": 9,
    "question": "When choosing your countermeasures and tactics to protect hardware and systems software, you should start with which of the following?",
    "choice_a": "Published Current Vulnerabilities and Exposures (CVE) databases",
    "choice_b": "The information systems baseline that documents the systems your organization uses",
    "choice_c": "Your organization's business impact analysis",
    "choice_d": "Your organization's IT vulnerabilities assessment",
    "correct_answer": "D",
    "explanation": "Starting with Option A is a common-sense approach to quickly implementing some reasonable and prudent protection, but it lacks any judgment as to which vulnerabilities are important to your organization's risk management strategy and which are not. <br>Option B is the systems inventory, and you will need it because it describes the as-built systems. <br>Option C is what drives D. Therefore, start shopping for countermeasures with D in hand.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      36,
      48,
      43,
      59,
      46
    ],
    "source": ""
  },
  {
    "id": 10,
    "question": "What kind of malware attacks can corrupt or infect device-level firmware? <ol type=\"A\"><li>SNMP-based attacks that can trigger the device to download and install a firmware update remotely</li><li>Remote or onsite device management (or mismanagement) attacks that allow a hacker to initiate a firmware update using a hacked firmware file</li><li>Phishing or misdirection attacks that fool operators or users into initiating an upload of a hacked firmware file</li><li>None, because firmware updates require operator intervention to download trusted updates and patch files from the manufacturer's or vendor's websites, and then initiate and monitor the update and restart of the device</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "A, B and C",
    "choice_d": "D",
    "correct_answer": "B",
    "explanation": "Option A is false; Simple Network Management Protocol (SNMP) by itself cannot trigger a device to download and install a firmware patch file. <br>Option D is false, because that operator action can be misdirected to use the wrong file as the update. <br>Option B may be true in some cases, if the device is set to allow remote management from other than a connected endpoint system such as a laptop or smartphone. Attacks like those in Option C happen a lot!",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      259,
      263,
      264,
      265,
      266
    ],
    "source": ""
  },
  {
    "id": 11,
    "question": "What is a zero day exploit?",
    "choice_a": "An exploit conducted against a vulnerability within the same day as it is reported",
    "choice_b": "An exploit that impacts a system immediately, rather than having a delayed effect like ransomware or scareware does",
    "choice_c": "There are no real zero day exploits, but the mass media has exaggerated the dangers of unreported vulnerabilities",
    "choice_d": "An exploit conducted against a newly discovered vulnerability before it becomes known to the cybersecurity community or the system's vendor or owners",
    "correct_answer": "D",
    "explanation": "While some zero day exploits have been discovered and exploited within the same day, typically after the release of a new software product to the market, attackers need to spend considerable time on most newly discovered vulnerabilities to understand them well enough to design an exploit against them, and then find a suitable target. So Option A is not correct. <br>Option B incorrectly refers to exploits that leave behind payloads or features that will take action later. <br>Option C incorrectly associates the media reporting of cybersecurity, in general, with the time from discovery to exploitation of a vulnerability.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      264,
      260,
      262,
      261,
      259
    ],
    "source": ""
  },
  {
    "id": 12,
    "question": "Which of the following statements best summarizes the benefits of using trusted platform modules (TPMs) as part of an organization's IT infrastructure?",
    "choice_a": "Because they have onboard hardware implementations of encryption, hashing, and key generation, they greatly simplify the use of certificate authorities and the public key infrastructure (PKI).",
    "choice_b": "As a trust root, a TPM can make hierarchies of trust more reliable.",
    "choice_c": "The TPM replaces the host system's random number generators and hash routines with its hardware-accelerated, more secure versions. This enhances system security as well as runtime performance.",
    "choice_d": "As a signed part of operating systems kernels, TPMs make it possible to validate software updates more reliably.",
    "correct_answer": "B",
    "explanation": "Since TPMs are special, sealed hardware modules added to the motherboards of computers or phones by their manufacturers, Option D is incorrect, even though TPM device driver software must be incorporated into most OSs to enable their use. <br>Option A is incorrect; the TPM doesn't simplify this but allows for a more trustworthy hardware storage and management of certificates, digital signatures, and so forth. <br>Option C is not correct; these functions in the OS and host hardware remain, while all the TPM provides is its own implementations with which it secures keys, manages certificates, and hashes (preserves) machine identification information.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      218,
      215,
      212,
      239,
      268
    ],
    "source": ""
  },
  {
    "id": 13,
    "question": "Which statement about how cryptography protects the meaning or content of files and messages is incorrect?",
    "choice_a": "Cryptography obscures meaning by misdirection, concealment, or deception.",
    "choice_b": "Cryptography obscures meaning by making it difficult or impossible for unauthorized users to access it, view it, copy it, or change it.",
    "choice_c": "Cryptography transforms the meaning and content of a file or message into a unique value.",
    "choice_d": "Cryptography is part of digitally signing files and messages to authenticate senders.",
    "correct_answer": "A",
    "explanation": "Options B, C, and D all are parts of what cryptography entails and taken together sum it up. <br>Option A is more suggestive of camouflage, honeypots, or other efforts to draw attackers away from what you wish to defend and divert their energies elsewhere, which do not directly involve the use of encryption, hashing, and so forth.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      107,
      103,
      110,
      116,
      106
    ],
    "source": ""
  },
  {
    "id": 14,
    "question": "Which of the following best explains symmetric encryption?",
    "choice_a": "Uses one key to encrypt blocks of text to be ciphered and another key to decrypt it back",
    "choice_b": "Uses the same key or a simple transform of it to encrypt cleartext into ciphertext, and then decrypt the ciphertext back into plaintext",
    "choice_c": "Was used extensively in classical encryption but has since been superseded by much stronger asymmetric encryption",
    "choice_d": "Is best suited to cleartext that has a very high degree of regularity to its structure and content",
    "correct_answer": "B",
    "explanation": "Option A is an incomplete description of asymmetric encryption; Option C is false, since hybrid systems are in widespread use; and Option D is unrelated to symmetric or asymmetric encryption.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      128,
      130,
      107,
      103,
      673
    ],
    "source": ""
  },
  {
    "id": 15,
    "question": "Properly used, cryptographic techniques improve all aspects of information security except:",
    "choice_a": "Confidentiality",
    "choice_b": "Authentication",
    "choice_c": "Nonrepudiation",
    "choice_d": "Accountability",
    "correct_answer": "D",
    "explanation": "Options A, B, and C are correct. <br>Option D seems to confuse aspects of access control systems, which do have to keep track of\u2014that is, account for\u2014access attempts and allowed accesses.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      498,
      668,
      750,
      105,
      103
    ],
    "source": ""
  },
  {
    "id": 16,
    "question": "Nonrepudiation relies on cryptography to validate that:",
    "choice_a": "The sender or author of a document or file is who the recipient thinks it is",
    "choice_b": "The file or message has not been tampered with during transit or storage",
    "choice_c": "The file or message has not been viewed by others or copied without the sender's and named recipient's knowledge",
    "choice_d": "The certificate, public key, or both associated with the sender or author match what is associated with the file or message",
    "correct_answer": "D",
    "explanation": "While Option A is tempting, cryptographic processes cannot confirm that the certificate and key are correctly associated with a specific human or organization. The Certificate Authority (CA) does that through other (noncryptographic) means, and as an anchor in the chain of trust, attests that this person and this certificate go together. Thus, Option D is correct. <br>Option B refers to integrity and Option C to confidentiality, which are not directly part of nonrepudiation.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      672,
      524,
      104,
      498,
      674
    ],
    "source": ""
  },
  {
    "id": 17,
    "question": "Which statement best describes how digital signatures work?",
    "choice_a": "The sender hashes the message or file to produce a message digest and applies the chosen encryption algorithm and their private key to it. This is the signature. The recipient uses the sender's public key and applies the corresponding decryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "choice_b": "The sender hashes the message or file to produce a message digest and applies the chosen decryption algorithm and their public key to it. This is the signature. The recipient uses the sender's private key and applies the corresponding encryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "choice_c": "The sender hashes the message or file to produce a message digest and applies the chosen decryption algorithm and their private key to it. This is the signature. The recipient uses the sender's public key and applies the corresponding encryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "choice_d": "The sender encrypts the message or file with their private key and hashes the encrypted file to produce the signed message digest. This is the signature. The recipient uses the sender's public key and applies the corresponding decryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "correct_answer": "A",
    "explanation": "The incorrect answers show misapplication of the steps of the process. <br>Option A has reversed who encrypts and who decrypts. <br>Option B confuses the use of the sender's public and private key, and if the recipient knows the sender's private key it must no longer be private. <br>Option D won't work, because decrypting the unencrypted hash won't produce anything that is useful.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      498,
      500,
      124,
      672,
      665
    ],
    "source": ""
  },
  {
    "id": 18,
    "question": "Which statement about subjects and objects is not correct?",
    "choice_a": "Subjects are what users or processes require access to in order to accomplish their assigned duties.",
    "choice_b": "Objects can be people, information (stored in any fashion), devices, processes, or servers.",
    "choice_c": "Objects are the data that subjects want to access in order to read it, write to it, or otherwise use it.",
    "choice_d": "Subjects are people, devices, or processes.",
    "correct_answer": "A",
    "explanation": "Subjects, by definition, want to <italic>do something</italic> that involves an <italic>object</italic> Thus, Option A has these roles reversed. Subjects can be any kind of entity that can take action. Objects contain information but also can provide requested services\u2014that is, take action upon request\u2014so Options B and C are correct.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      555,
      540,
      557,
      556,
      541
    ],
    "source": ""
  },
  {
    "id": 19,
    "question": "Which statement about a reference monitor in an identity management and access control system is correct?",
    "choice_a": "It should be tamper-resistant.",
    "choice_b": "Its design and implementation should be complex so as to defeat reverse engineering attacks.",
    "choice_c": "It's an abstract design concept, which is not actually built into real hardware, operating systems, or access control implementations.",
    "choice_d": "It is part of the secure kernel in the accounting server or services provided by strong access control systems.",
    "correct_answer": "A",
    "explanation": "The reference monitor is the functionality that checks every access attempt to see if it should be authorized or denied. As a result, Option D is false (accounting is a recordkeeping function, necessary to access control but done after the access request is granted or denied). <br>Option C is false, since the reference monitor is in fact implemented in operating systems (typically in their security kernel) or as part of a trusted computing base (TCB) module on a motherboard. <br>Option B is the reverse of what's required; we need to be able to inspect, analyze, and verify that the logic and code of the reference monitor does its job completely and correctly and that it does nothing else if we are to consider it highly trustworthy.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      286,
      330,
      274,
      542,
      557
    ],
    "source": ""
  },
  {
    "id": 20,
    "question": "What kinds of privileges should be part of what your mandatory access control policies can grant or deny to a requesting subject? <ol type=\"A\"><li>Any privilege relating to reading from, writing to, modifying or deleting the object in question if it was created or is owned by the requesting subject</li><li>Reading or writing/modifying the metadata associated with an object</li><li>Modifying access control system constraints, rules, or policies</li><li>Reading, writing, deleting, or asking the system to load the object as an executable task or thread and run it</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Mandatory access control policies do not allow subjects or objects to modify the security-related aspects of the system, its subjects and objects; thus, granting the privileges in Option A or C cannot be allowed. <br>Options B and D reflect reasonable and prudent access control checks that all systems should perform before granting access but that are not part of mandatory access control policies.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      537,
      286,
      539,
      330,
      551
    ],
    "source": ""
  },
  {
    "id": 21,
    "question": "Which set of steps correctly shows the process of identity management? <br><ol><li>Proofing</li><li>Provisioning</li><li>Review</li><li>Revocation</li><li>Deletion</li></ol>",
    "choice_a": "1, 2, 3, 4, and then 5",
    "choice_b": "2, 3, 4",
    "choice_c": "1, 2, 4, 5",
    "choice_d": "2, 3, 5",
    "correct_answer": "B",
    "explanation": "Item 1, proofing, is part of provisioning, and thus, Options A and C are incorrect. Item 5, deletion, happens after revocation, but it is a cleanup of files, assets, and records, and is more properly part of a records retention and housekeeping process. It is not part of identity management per se. Thus, Option D is incorrect. <br>Option B correctly reflects that we start by provisioning an identity, we continually review the privileges assigned to it versus the needs of the job and the organization, and then we revoke it.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      542,
      16,
      273,
      446,
      321
    ],
    "source": ""
  },
  {
    "id": 22,
    "question": "What's the least secure way to authenticate device identity prior to authorizing it to connect to the network?",
    "choice_a": "MAC address whitelisting",
    "choice_b": "Multifactor authentication that considers device identification, physical location, and other attributes",
    "choice_c": "Verifying that the device meets system policy constraints as to software and malware updates",
    "choice_d": "Devices don't authenticate, but the people using them do.",
    "correct_answer": "D",
    "explanation": "Option D is highly risky and therefore correct: plugging a device into an empty network connection should start a connection handshake that is an opportunity to block an unknown or unauthorized device from joining the network. <br>Options A and C are parts of how Option B performs such an authentication, and therefore B is the most secure approach of the three.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      273,
      294,
      310,
      311,
      280
    ],
    "source": ""
  },
  {
    "id": 23,
    "question": "In access control authentication systems, which is riskier, false positive or false negative errors?",
    "choice_a": "False negative, because they lead to a threat actor being granted access",
    "choice_b": "False positive, because they lead to a threat actor being granted access",
    "choice_c": "False negative, because they lead to legitimate subjects being denied access, which impacts business processes",
    "choice_d": "False positive, because they lead to legitimate subjects being denied access, which impacts business processes",
    "correct_answer": "B",
    "explanation": "A positive result in an authentication system means the system believes the claimant is who they claim to be. A false positive occurs when the system incorrectly grants access to an unauthorized user, which is risky because it can lead to a threat actor gaining access. A false negative occurs when the system incorrectly denies access to an authorized user, which can disrupt business operations but does not typically present an immediate security risk. Therefore, the greater risk lies in false positives, as they involve unauthorized access being granted.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      484,
      483,
      342,
      374,
      566
    ],
    "source": ""
  },
  {
    "id": 24,
    "question": "Which statement about single-factor versus multifactor authentication is most correct?",
    "choice_a": "Single-factor is easiest to implement but with strong authentication is the hardest to attack.",
    "choice_b": "Multifactor requires greater implementation, maintenance, and management but can be extremely hard to spoof as a result.",
    "choice_c": "Multifactor authentication requires additional hardware devices to make authentication properly secure.",
    "choice_d": "Multifactor authentication should be reserved for those high-risk functions that require extra security.",
    "correct_answer": "B",
    "explanation": "Option A is false; each additional factor checked increases the challenge an attacker has to overcome to spoof an identity claim. <br>Option C is false; hardware is only needed for factors involving what the subject has, such as a keyfob code generator or biometric factors. <br>Option D is tempting, and high-risk functions might be best protected with additional security measures, but compared to Option B, it is not as compellingly correct.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      726,
      357,
      327,
      293,
      446
    ],
    "source": ""
  },
  {
    "id": 25,
    "question": "When comparing the TCP/IP and OSI reference model as sets of protocols, which statement is most correct?",
    "choice_a": "Network hardware and systems are built on TCP/IP, whereas the OSI reference model only provides concepts and theories.",
    "choice_b": "TCP/IP only provides concepts and theories, whereas network hardware and systems are built using the OSI reference model.",
    "choice_c": "Both sets of protocols provide theories and concepts, but real hardware is built around the data, control, and management planes.",
    "choice_d": "Hardware and systems are built using both models, and both models are vital to threat assessment and network security.",
    "correct_answer": "D",
    "explanation": "Option D accurately reflects the use of both of these as conceptual models and protocol stacks\u2014by builders, attackers, and defenders alike. <br>Option A reflects an incorrect bias of many network engineers who somewhat dismissively ignore things above the Transport layer. <br>Option B is incorrect, because both models drive the design and use of hardware, software, control, and systems management information. <br>Option C is incorrect, since all three sets of concepts drive the design and operation of real hardware, software, and systems.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      179,
      178,
      189,
      190,
      200
    ],
    "source": ""
  },
  {
    "id": 26,
    "question": "Is IPv6 backward compatible with IPv4?",
    "choice_a": "No, because the differences in addressing, packet header structure, and other features would not allow an IPv4 packet to successfully travel on an IPv6 network",
    "choice_b": "No, because IPv4 packets cannot meet the new security considerations built into IPv6",
    "choice_c": "Yes, because IPv6 has services built into the protocol stacks to convert IPv4 packets into IPv6 compatible structures",
    "choice_d": "Yes, because the transport and routing protocols are the same",
    "correct_answer": "A",
    "explanation": "Option B is incorrect, because the changes in address field sizes, and therefore packet header structures, have nothing to do with security (although IPv6 does provide enhancements to security). <br>Option C is incorrect; such a conversion could be done by a gateway, but that is not part of IPv6, although IPv6 supports it. <br>Option D is incorrect, although the transport protocols (like TCP and UDP) have not changed, but this is not where the incompatibility comes from.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      450,
      452,
      454,
      677,
      507
    ],
    "source": ""
  },
  {
    "id": 27,
    "question": "Which statement about subnetting is correct?",
    "choice_a": "Subnetting applies only to IPv4 networks, unless you are using classless interdomain routing.",
    "choice_b": "Both IPv4 and IPv6 provide for subnetting, but the much larger IPv6 address field makes this a lot simpler to design and manage.",
    "choice_c": "Subnetting in IPv4 involves the CIDR protocol, which runs at Layer 3; in IPv6, this protocol, and hence subnetting, is not used.",
    "choice_d": "Because the subnet mask field is so much larger in IPv6, it is easier to subnet in this newer protocol stack than in IPv4.",
    "correct_answer": "B",
    "explanation": "Options A and C both incorrectly leave out subnetting in IPv6 and misstate what classless inter-domain routing (CIDR) is about, even though the two options say different incorrect things about CIDR. <br>Option D is partly correct in that IPv6 does have a 16-bit subnet field, and as Option B says, the overall address field size makes subnetting much easier to do, but there is no subnet field in IPv4.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      450,
      451,
      452,
      470,
      454
    ],
    "source": ""
  },
  {
    "id": 28,
    "question": "Which statement or statements about ports and the Internet is <italic>not</italic> correct? <ol type=\"A\"><li>Using port numbers as part of addressing and routing was necessary during the early days of the Internet, largely because of the small size of the address field, but IPv6 makes most port usage obsolete.</li><li>Standard ports are defined for a number of protocols, and these ports allow sender and receiver to establish connectivity for specific services.</li><li>Standardized port assignments cannot be changed, or things won't work right, but they can be mapped to other port numbers by the protocol stacks on senders' and recipients' systems.</li><li>Many modern devices, such as those using Android, cannot support ports, and so apps have to be redesigned to use alternate service connection strategies.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Ports are a fundamental part of the way apps request services from processes running on other nodes on the Internet. Standardized port numbers make applications designs easier to manage; thus, port 80 and HTTP are associated with each other. Therefore, Options A and D show a misunderstanding of what ports are and why they are necessary.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      453,
      454,
      455,
      507,
      508
    ],
    "source": ""
  },
  {
    "id": 29,
    "question": "Which of the following statements about man-in-the-middle (MITM) attacks is most correct?",
    "choice_a": "Session stealing attacks are not MITM attacks.",
    "choice_b": "MITM attacks can occur at any layer and against connectionless or connection-oriented protocols.",
    "choice_c": "This basic attack strategy can be used at any layer of the protocols where there is connection-oriented, stateful communication between nodes.",
    "choice_d": "MITM attacks can work only at Layer 4.",
    "correct_answer": "B",
    "explanation": "From the Physical layer on up, the injection of unauthorized traffic into a network can cause almost any protocol to fall for a \u201cmistaken identity\u201d that leads to an MITM attack. Session stealing (Layers 5 and 7) is a prime example, making Option A false. <br>Option C is incorrect, since IP (Layer 2) is inherently connectionless and prone to MITM attacks. <br>Option D is also false, as session stealing (and others) demonstrates.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      504,
      179,
      730,
      162,
      200
    ],
    "source": ""
  },
  {
    "id": 30,
    "question": "What important role does systems monitoring perform in support of incident management?",
    "choice_a": "They are not related; monitoring is a routine task that uses trend analysis and data analytics to determine whether past systems behavior and use has been within expected bounds.",
    "choice_b": "Essential; by bringing together alert and alarm indicators from systems and their associated security controls and countermeasures, monitoring is the watchdog capability that activates incident response capabilities and plans.",
    "choice_c": "Incident response includes its own monitoring and alarms capabilities, so systems monitoring provides a good backup or alternate path to determining whether an incident is occurring.",
    "choice_d": "Ongoing, continuous monitoring is used to adjust or fine-tune alarm threshold settings so that false alarm rates can be better managed.",
    "correct_answer": "B",
    "explanation": "Option A misstates the role of ongoing monitoring and conflicts with Option B. <br>Option C suggests a redundant set of capabilities, which may be mission critical for a select few organizations but is not common. <br>Option D may be a useful capability, but it is not the reason for ongoing monitoring.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      61,
      53,
      40,
      59,
      57
    ],
    "source": ""
  },
  {
    "id": 31,
    "question": "How might you keep a gap from becoming a blind spot in your information security defenses?",
    "choice_a": "Transfer this risk to insurers or other parties.",
    "choice_b": "Ensure that systems elements around the gap provide sufficient detection and reporting capabilities so that an event of interest occurring in the gap cannot spread without being detected.",
    "choice_c": "Ensure that other systems elements can either detect or report when an event of interest is happening within the gap.",
    "choice_d": "You can't, as by definition the gap is where you have no appreciable security coverage, and this includes having no monitoring or detection capabilities.",
    "correct_answer": "B",
    "explanation": "If Option A or C was plausible, then you wouldn't actually have a gap. <br>Option D correctly defines the gap but fails to look to how to mitigate the risk posed by the gap.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      51,
      65,
      59,
      53,
      61
    ],
    "source": ""
  },
  {
    "id": 32,
    "question": "CVE data and your own vulnerability assessments indicate that many of your end-user systems do not include recent security patches released by the software vendors. You decide to bring these systems up to date by applying these patches. This is an example of which of the following?",
    "choice_a": "Remediating or mitigating a risk",
    "choice_b": "Transferring a risk",
    "choice_c": "Avoiding a risk",
    "choice_d": "Accepting a risk",
    "correct_answer": "A",
    "explanation": "Fixing or applying patches to eliminate a vulnerability is the definition of remediating, mitigating, fixing, or repairing a vulnerability.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      62,
      59,
      36,
      61,
      57
    ],
    "source": ""
  },
  {
    "id": 33,
    "question": "Which of the following might be legitimate ways to transfer a risk? <ol type=\"A\"><li>Recognize that government agencies have the responsibility to contain, control, or prevent this risk, which your taxes pay them to do.</li><li>Pay insurance premiums for a policy that provides for payment of claims and liabilities in the event the risk does occur.</li><li>Shift the affected business processes to a service provider, along with contractually making sure they are responsible for controlling that risk or have countermeasures in place to address it.</li><li>Change the underlying business process to use more secure software and hardware systems.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option D is typically an example of remediating, sometimes called fixing or mitigating the risk.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      56,
      63,
      62,
      42,
      47
    ],
    "source": ""
  },
  {
    "id": 34,
    "question": "Which statement correctly describes why CVE data should be part of your vulnerability assessments?",
    "choice_a": "It should provide most if not all of the vulnerability information you need to implement risk mitigation.",
    "choice_b": "Since hackers use CVE data to aid in planning their attacks, this should be the first place you look for insight as you do emergency hardening of your IT systems. Once these obvious vulnerabilities have been mitigated, a more complete vulnerability assessment should be done.",
    "choice_c": "It's a great source of information for known systems elements and known vulnerabilities associated with them, but it does nothing for vulnerabilities that haven't been reported yet or for company-developed IT elements.",
    "choice_d": "Since the vast majority of systems in use are based on Windows, if your business does not use Windows platforms you can probably avoid the expense of investigating CVE for vulnerability information.",
    "correct_answer": "C",
    "explanation": "Option B does correctly state the risk that attackers may know more about your systems than you do, if you haven't thoroughly checked CVE data as part of your vulnerabilities assessment. But it incorrectly goes on to suggest that you fix these first\u2014they may not relate to your organization's highest-priority impacts as spelled out by the BIA. <br>Option A is therefore false. <br>Option D is also false, since even the most Linux-based of organizations will probably have non-Linux systems elements (such as network components) that CVE could have information about.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      35,
      46,
      58,
      36,
      56
    ],
    "source": ""
  },
  {
    "id": 35,
    "question": "Which of the following activities are not part of information risk mitigation?",
    "choice_a": "Implementing new systems features or capabilities to enhance product quality",
    "choice_b": "Incident management and investigation, after a suspected information security breach",
    "choice_c": "Installing and testing new firewall, switch, and router systems and settings",
    "choice_d": "Developing an information classification policy and process",
    "correct_answer": "D",
    "explanation": "Improving product quality is a laudable goal, but in and of itself it is not related to information systems security; thus, Option A is incorrect. <br>Option B refers to activities after an incident; mitigation activities happen before an incident occurs or result from lessons learned because of the incident. <br>Option C is most likely being done to implement new or revised security policies. <br>Option D is part of information risk management and should precede information risk mitigation.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      42,
      59,
      57,
      36,
      54
    ],
    "source": ""
  },
  {
    "id": 36,
    "question": "Which of the following shows the major steps of the information risk management process in the correct order?",
    "choice_a": "Assess risks across the organization; identify information security and privacy risks; implement countermeasures; establish security and privacy posture; review supply chain for IT security risk elements",
    "choice_b": "Establish basic security posture; review risks; implement countermeasures; ongoing monitoring and assessment; testing; training",
    "choice_c": "Set priorities; assess risks; select controls and countermeasures; implement controls; validate correct operation; monitor",
    "choice_d": "Develop business impact analysis (BIA); establish risk tolerance levels; implement damage control choices; monitor",
    "correct_answer": "C",
    "explanation": "Option D incorrectly has the BIA first when it has to come after the organization's leadership has agreed to risk tolerance and set priorities. <br>Option B is incorrect, partly because the basic \u201ccommon-sense\u201d posture is not part of a formal risk management process but a bare minimum immediate set of actions to take if needed. <br>Option A has establishing a posture (which is policy and decisions that drive implementation and operation steps) and implementation in the wrong order.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      56,
      58,
      54,
      66,
      57
    ],
    "source": ""
  },
  {
    "id": 37,
    "question": "What is information risk?",
    "choice_a": "The threat that your computers, online storage, or cloud-hosted or other data could be hacked into and data stolen or changed",
    "choice_b": "The probability of an event occurring that disrupts your information and the business processes and systems that use it",
    "choice_c": "Vulnerabilities in your information systems that can be exploited by a threat actor and cause harmful impacts",
    "choice_d": "The probability that management and leadership's directions and communications will be misunderstood, causing the wrong actions to be taken by stakeholders, possibly causing financial loss, injury, or death",
    "correct_answer": "B",
    "explanation": "Option B is the simplest and most effective definition of information risk. <br>Options A and C do not include probability of occurrence (risks are not certain to happen) and describe how risks become events rather than what the risk actually is. <br>Option D is one example, but it does not define information risk.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      34,
      41,
      42,
      43,
      45
    ],
    "source": ""
  },
  {
    "id": 38,
    "question": "Which is the most correct statement as to what it means to have a proactive approach with your information security risk management plans, programs, and systems?",
    "choice_a": "Being proactive means that your countermeasures and controls can actively trace back to identify, locate, and characterize your attackers, which can help you both in defending against them and in potentially seeking legal redress.",
    "choice_b": "Senior leaders and managers in many businesses appreciate active, thoughtful, forward-looking approaches, and you will find it easier to gain their support.",
    "choice_c": "Proactive information security systems allow your security specialists to take real-time control of all systems elements and bring all information about events of interest into one common operational picture. This greatly enhances your ability to detect, characterize, and contain incidents.",
    "choice_d": "Being proactive means that you use the best knowledge you have today, including lessons learned from other organizations' experience with information risk, and you plan ahead to use these lessons to deal with these risks them, rather than wait for them to occur and then investigate how to respond to them.",
    "correct_answer": "D",
    "explanation": "Proactive means (thinking ahead and planning for contingencies), rather than reactive (waiting until things break). <br>Option A is both wrong and probably illegal in most circumstances. <br>Option B might be true, but it is a general statement about \u201cbeing proactive\u201d rather than specifically about information security. <br>Option C describes an integrated information security management approach.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      54,
      57,
      59,
      66,
      62
    ],
    "source": ""
  },
  {
    "id": 39,
    "question": "What kind of information is part of an information risk assessment process? <ol type=\"A\"><li>Lost revenues during the downtime caused by the risk incident, including time it takes to get things back to normal</li><li>Damage to equipment or facilities, or injury or death to people</li><li>Estimated costs to implement chosen solutions, remediations, controls, or countermeasures</li><li>Total costs to create an asset that is damaged or disrupted by the risk event</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option C is the safeguard value, which we cannot compute until we have completed risk assessment and vulnerability assessment, and then designed, specified, or selected such controls or countermeasures. <br>Option D is typically not the loss incurred by damage of an asset; of greater interest regarding impact to an asset would be the cost to repair it (if repairable), replace it, or design and implement new processes to do without it.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      458,
      594,
      42,
      45,
      43
    ],
    "source": ""
  },
  {
    "id": 40,
    "question": "There are three ways in which risk assessments can be done. Choose the option that orders them from best to least in terms of their contribution to risk management decision making.",
    "choice_a": "Qualitative, quantitative, and CVE-based",
    "choice_b": "CVE-based, quantitative, and qualitative",
    "choice_c": "There is no order; they all can and should be used, as each reveals something more about the risks you have to manage.",
    "choice_d": "Quantitative, CVE-based, and qualitative",
    "correct_answer": "C",
    "explanation": "Options A and D reflect biases toward or against qualitative assessments (presumably for being \u201csoft\u201d or potentially based on emotions or intuition) or quantitative ones (the data is too hard to get or validate). Using published common vulnerability and exposure (CVE) information can be quite illuminating, but as in Option D, be careful to not just assume that other people's experiences and systems are a good match for your own, or to bow to authoritative statements without carefully considering whether they fit your situation.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      56,
      46,
      42,
      59,
      614
    ],
    "source": ""
  },
  {
    "id": 41,
    "question": "Patsy is reviewing the quantitative risk assessment spreadsheet for her division, and she sees a number of entries where the annual loss expectancy is far greater than the single loss expectancy. This suggests that:",
    "choice_a": "The RTO is later than the RPO.",
    "choice_b": "The ARO is less than 1.",
    "choice_c": "The particular risk is assessed to happen many times per year; thus, its ARO is much greater than 1.",
    "choice_d": "This looks like an error in estimation or assessment, and should be further investigated.",
    "correct_answer": "C",
    "explanation": "Option B has the annual rate of occurrence (ARO) use incorrect; if the ARO was less than 1, the single loss expectancy is in effect spread over multiple years (as if it were amortized). <br>Option A involves restore time and point objectives, which are not involved in ALE calculation. <br>Option D misunderstands the annualized loss expectancy (ALE) = ARO * SLE (single loss expectancy) as the basic math involved.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      598,
      456,
      612,
      458,
      614
    ],
    "source": ""
  },
  {
    "id": 42,
    "question": "Which statement is incorrect as to how you should use RTO, MAO, and RPO in planning information risk management activities?",
    "choice_a": "Return to operations (RTO) is the desired time to get all business processes back into operation, whether on backup or workaround systems or on production systems brought back to normal. The recovery priority objective (RPO) sets priorities for which systems to bring up first or which business processes to get back into operation before others (of lower priority).",
    "choice_b": "Recovery point objective (RPO) establishes the maximum amount of data that is lost due to a risk event. This could be in numbers of transactions or in units of time and indicates the amount of rework of information that is acceptable to get systems back into normal operation.",
    "choice_c": "Recovery time objective (RTO) must be less than or equal to the maximum acceptable outage. MAO sets a maximum down time (outage time) before mission impact becomes unacceptable; RTO can be used to emphasize faster-than-MAO restoration.",
    "choice_d": "Maximum acceptable outage (MAO) relates to the mission or business objectives; if multiple systems support those objectives, then all of their recovery time objectives (RTOs) must be less than or equal to the MAO.",
    "correct_answer": "A",
    "explanation": "Option A is a misstatement of RTO and RPO.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      477,
      479,
      478,
      58,
      66
    ],
    "source": ""
  },
  {
    "id": 43,
    "question": "What are all of the choices we need to make when considering information risk management, and what's the correct order to do them in? <br><ol><li>Treatment: accept, treat (fix or mitigate), transfer, avoid, recast</li><li>Damage limitation: deter, detect, prevent, avoid</li><li>Perspective: based on outcome, assets, process or threat based</li><li>Impact assessment: quantitative or qualitative</li></ol>",
    "choice_a": "1, 2, 3, then 4",
    "choice_b": "3, 4, 2, then 1",
    "choice_c": "4, 3, 2, then 1",
    "choice_d": "2, 3, 1 then 4",
    "correct_answer": "B",
    "explanation": "Item 3, perspective, should reflect priorities, risk appetite or tolerance, and decision-making culture, and this has to lead all risk management activities. Next comes Item 4, which feeds into the BIA. Item 2 should be a product of the business impact analysis (BIA) process, because it combines costs or magnitude of impacts with acceptable damage limitation strategies. Finally, we choose what to fix, transfer (pay someone else to worry about), accept, or avoid, and any residual risk is recast or re-expressed to reflect these decisions.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      42,
      43,
      54,
      59,
      58
    ],
    "source": ""
  },
  {
    "id": 44,
    "question": "What do we use protocols for? <ol type=\"A\"><li>To conduct ceremonies, parades, or how we salute superiors, sovereigns, or rulers</li><li>To have a conversation with someone, and keep disagreement from turning into a hostile, angry argument</li><li>To connect elements of computer systems together so that they can share tasks and control each other</li><li>As abstract design tools when we are building systems, but we don't actually build hardware or software that implements a protocol</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option D is incorrect; almost everything that holds our IT world together is done via directly building protocols into hardware and software. <br>Options A, B, and C are correct and show the human social communications need for signaling each other about the communication we're trying to achieve.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      25,
      24,
      23,
      22,
      26
    ],
    "source": ""
  },
  {
    "id": 45,
    "question": "As an SSCP, you work at the headquarters of a retail sales company that has many stores around the country. Its training department has prepared different training materials and operations manuals for in-store sales, warehouse staff, and other team members to use in their jobs. Almost all of these describe procedures that people do as they work with each other or with customers. From an information security standpoint, which of the following statements is correct?",
    "choice_a": "Since these all describe people-to-people interactions and processes, they are not implemented by the IT department, and so they're not something that information security is concerned with.",
    "choice_b": "Most of their content is probably common practice in business and retail sales and so would not be trade secrets, company proprietary, or private to the company.",
    "choice_c": "Although these processes are not implemented in IT systems, the documents and videos themselves are hosted in company-provided IT systems, and so information security requirements apply.",
    "choice_d": "If the company has decided that the content of these training materials is proprietary or company confidential, then their confidentiality must be protected. They must also be protected from tampering or unauthorized changes and be available to staff in the stores to use when they need them if the company is to do business successfully. Therefore, information security applies.",
    "correct_answer": "D",
    "explanation": "Options A and C are confusing information, and our systems or processes for using it, with the technologies with which we create, store, and use that information. <br>Option B is a partial answer (it does not address anything other than confidentiality) and might be true, but this is a decision that company leadership and management should make (on advice from the SSCP). <br>Option D is most complete and correct.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      29,
      31,
      32,
      30,
      23
    ],
    "source": ""
  },
  {
    "id": 46,
    "question": "We often hear people talk about the need for information systems to be safe and reliable. Is this the same as saying that they need to be secure?",
    "choice_a": "No, because reliability has to do with failures of equipment, errors in software design or use, or bad data used as input, whereas security is focused on keeping the systems and their data safe from intrusion or unwanted change.",
    "choice_b": "Yes, because the objective of information security is to increase our confidence that we can make sound and prudent decisions based on what those information systems are telling us and, in doing so, cause no harm.",
    "choice_c": "Yes, because all information and information systems are built by humans, and humans make mistakes, so we need strong safety rules and procedures to keep from causing harm.",
    "choice_d": "No, but they have ideas in common. For example, data integrity can lead to unsafe operation, but information security by itself cannot identify possible safety consequences.",
    "correct_answer": "B",
    "explanation": "Option A incorrectly ignores that failures in security design or practice can lead to data input or systems usage that might be safe and reliable tomorrow, for example, but not today. <br>Option C, true as far as it goes, does not address security at all. <br>Option D incorrectly ignores that the vulnerability assessments that should drive security measures are all based on consequences if the risk becomes real.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      25,
      33,
      24,
      23,
      29
    ],
    "source": ""
  },
  {
    "id": 47,
    "question": "Due diligence means which of the following?",
    "choice_a": "Pay your debts completely, on time.",
    "choice_b": "Do what you have to do to fulfill your responsibilities.",
    "choice_c": "Make sure that actions you've taken to fulfill your responsibilities are working correctly and completely.",
    "choice_d": "Read and review the reports from subordinates or from systems monitoring data.",
    "correct_answer": "C",
    "explanation": "Options A and B are both examples of due care; due diligence is the verification that all is being done well and nothing is not done properly. <br>Option D can be an important part of due diligence, but it is missing the potential for follow-up action.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      32,
      31,
      30,
      493,
      491
    ],
    "source": ""
  },
  {
    "id": 48,
    "question": "Protection of intellectual property (IP) is an example of what kind of information security need?",
    "choice_a": "Privacy",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Integrity",
    "correct_answer": "B",
    "explanation": "Disclosure of intellectual property in unauthorized ways can end up giving away any competitive advantage that IP might have had for the business.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      25,
      22,
      27,
      28,
      461
    ],
    "source": ""
  },
  {
    "id": 49,
    "question": "A thunderstorm knocks out the commercial electric power to your company's datacenter, shutting everything down. This impacts which aspect of information security?",
    "choice_a": "Privacy",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "If the equipment cannot run because there is no power, then no data stored in it can be displayed, printed, or shared with users\u2014data is not available. Some transactions may have to be recovered and rerun once the power comes back up and everything is turned on again, but only if transactions were lost completely would there be a data integrity concern.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      24,
      25,
      29,
      33,
      15
    ],
    "source": ""
  },
  {
    "id": 50,
    "question": "Explain the relationship between confidentiality and privacy, if any:",
    "choice_a": "Confidentiality is about keeping information secret so that we retain advantage or do not come to harm; privacy is about choosing who can enter one's life or property.",
    "choice_b": "Confidential information is information that must be kept private, so they really have similar meanings.",
    "choice_c": "Privacy laws allow criminals to hide their actions and intentions from society, but confidentiality allows for the government to protect defense-related information from being leaked to our enemies.",
    "choice_d": "Confidentiality is the freedom to choose whom we share information with; privacy refers to information that is specifically about our individual lives, activities, or interests.",
    "correct_answer": "A",
    "explanation": "Keeping information secret means agreeing to limit or control how (or if) that information can be passed on to others. Privacy is the freedom from intrusion into your own affairs, person, property, or ideas. The other options either confuse confidentiality with privacy or do not use the concepts correctly.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      22,
      20,
      28,
      461,
      25
    ],
    "source": ""
  },
  {
    "id": 51,
    "question": "How do you turn data into knowledge?",
    "choice_a": "These are both names for the same concepts, so no action is required.",
    "choice_b": "You use lots of data to observe general ideas and then test those ideas with more data you observe, until you can finally make broad, general conclusions. These conclusions are what are called knowledge.",
    "choice_c": "You apply data smoothing and machine learning techniques, and the decision rules this produces are called knowledge.",
    "choice_d": "You have to listen to the data to see what it's telling you, and then you'll know.",
    "correct_answer": "B",
    "explanation": "This is the scientific method in action: make observations, ask questions, make informed guesses, get more data, and see if it fits what you think you've learned thus, far. Repeat until you are highly confident. <br>Option C refers to data analysis techniques that by themselves are useful, but still require interpretation to be part of knowledge creation. <br>Option D is vague, imprecise, and not repeatable and, therefore, not scientific. <br>Option A does not fit the definition of the data to wisdom pyramid of concepts, even though to many people, data, information, and knowledge are interchangeable terms.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      25,
      24,
      518,
      725
    ],
    "source": ""
  },
  {
    "id": 52,
    "question": "Which is more important to a business\u2014its information or its information technology?",
    "choice_a": "Neither, since it is the business logic and business processes that give the business its competitive advantage.",
    "choice_b": "The information is more important, because all that the information technology does is make the information available to people to make decisions with.",
    "choice_c": "The information technology is more important, because without it, none of the data could be transformed into information for making decisions with.",
    "choice_d": "Both are equally important, because in most cases, computers and communications systems are where the information is gathered, stored, and made available.",
    "correct_answer": "B",
    "explanation": "People make decisions based on what they know, what they remember, and what they observe; that data, information, and knowledge are independent of the paper, books, computers, or radio waves that brought those observations to them in the first place. <br>Options C and D confuse the role of the technologies with the information itself; option A is a true statement that does not address the actual question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      25,
      24,
      29,
      33
    ],
    "source": ""
  },
  {
    "id": 53,
    "question": "As the IT security director, Paul does not have anybody looking at systems monitoring or event logging data. Which set of responsibilities is Paul in violation of?",
    "choice_a": "Due care",
    "choice_b": "Due diligence",
    "choice_c": "None of the above",
    "choice_d": "Both due care and due diligence",
    "correct_answer": "B",
    "explanation": "The fact that systems monitoring and event data is collected at all indicates that Paul or his staff determined it was a necessary part of keeping the organization's information systems secure\u2014they took (due) care of those responsibilities. But by not reviewing the data to verify proper systems behavior and use, or to look for potential intrusions or compromises, Paul has not been diligent. <br>Option A is incorrect, as due care focuses on planning and setting activities into motion, more so than supervising or monitoring their conduct. Clearly, options C and D cannot, therefore, be correct.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      517,
      575,
      724
    ],
    "source": ""
  },
  {
    "id": 54,
    "question": "Explain the relationship between confidentiality and privacy, if any.",
    "choice_a": "Confidentiality is about keeping information secret so that we retain advantage or do not come to harm; privacy is about choosing who can enter into one's life or property.",
    "choice_b": "Confidential information is information that must be kept private, so they really have similar meanings.",
    "choice_c": "Privacy laws allow criminals to hide their actions and intentions from society, but confidentiality allows for the government to protect defense-related information from being leaked to enemies.",
    "choice_d": "Confidentiality is the freedom to choose with whom you share information; privacy refers to information that is specifically about individuals' lives, activities, or interests.",
    "correct_answer": "A",
    "explanation": "Keeping information secret means agreeing to limit or control how (or if) that information can be passed on to others. Privacy is the freedom from intrusion into your own affairs, person, property or ideas. The other options either confuse confidentiality with privacy or do not use the concepts correctly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      20,
      28,
      461,
      459
    ],
    "source": ""
  },
  {
    "id": 55,
    "question": "Jayne discovers that someone in the company's HR department has been modifying employee performance appraisals. If done without proper authorization, this would be what kind of violation?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Privacy",
    "correct_answer": "A",
    "explanation": "The correctness or wholeness of the data may have been violated, inflating some employees' ratings while deflating others. This violates the presumed integrity of the appraisal data. Presumably, HR staff have legitimate reasons to access the data, and even enter or change it, so it is not a confidentiality violation; since the systems are designed to store such data and make it available for authorized use, privacy has not been violated. Appraisals have not been removed, so there are no availability issues.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      22,
      25,
      24,
      28
    ],
    "source": ""
  },
  {
    "id": 56,
    "question": "At a job interview, Fred is asked by the interviewer about activities, pictures, and statements he's made by posting things on his Facebook and LinkedIn pages. This question by the interviewer:",
    "choice_a": "Is a violation of Fred's right to privacy, as those posts were done on Fred's private pages",
    "choice_b": "Doesn't worry Fred, as the conversation with the interviewer is confidential",
    "choice_c": "Is a legitimate one, since these pages are published by Fred, and therefore they are speech he has made in public places",
    "choice_d": "Doesn't worry Fred, as he took those pages down yesterday and closed those accounts",
    "correct_answer": "C",
    "explanation": "What we say and do in public places is, by definition, visible to anyone who wants to watch or listen. Publishing a letter or a book, or writing on a publicly visible social media page, is also considered public speech. We have no reasonable expectation of privacy in social media\u2014we have no basis on which to assume that by posting something on our private pages, others whom we've invited to those pages will not forward that information on to someone else.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      460,
      459,
      20,
      22,
      461
    ],
    "source": ""
  },
  {
    "id": 57,
    "question": "A thunderstorm knocks out the commercial electric power to your company's datacenter, shutting down everything. This impacts which aspect of information security?",
    "choice_a": "Privacy",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "If the equipment cannot run because there is no power, then no data stored in it can be displayed, printed, or shared with users\u2014data is not available. Some transactions may have to be recovered and rerun once the power comes back up and everything is turned on again, but only if transactions were lost completely would there be a data integrity concern.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      25,
      29,
      33,
      15
    ],
    "source": ""
  },
  {
    "id": 58,
    "question": "Business logic is:",
    "choice_a": "A set of tasks that must be performed to achieve an objective within cost and schedule constraints",
    "choice_b": "The set of rules and constraints that drive a business to design a process that gets business done correctly and effectively",
    "choice_c": "Software and data used to process transactions and maintain accounts or inventories correctly",
    "choice_d": "The design of processes to achieve an objective within the rules and constraints the business must operate within",
    "correct_answer": "D",
    "explanation": "The logic is the set of steps and decisions necessary to achieve the objective; some of those decisions may compare intermediate results with constraints and then branch to alternate steps in the logic to make corrections, for example. The rules and constraints by themselves are not the business logic. Processes (software or people procedures) are not the business logic, but they should accurately and effectively implement that logic. <br>Options A, B, and C are all partially correct, but not complete.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      462,
      487,
      488,
      493,
      515
    ],
    "source": ""
  },
  {
    "id": 59,
    "question": "How does business logic relate to information security?",
    "choice_a": "Business logic represents decisions the company has made and may give it a competitive advantage over others in the marketplace; it needs to be protected from unauthorized disclosure or unauthorized change. Processes that implement the business logic need to be available to be run or used when needed. Thus, confidentiality, integrity, and availability apply.",
    "choice_b": "Business logic for specific tasks tends to be common across many businesses in a given market or industry; therefore, there is nothing confidential about it.",
    "choice_c": "Business logic should dictate the priorities for information security efforts.",
    "choice_d": "Business logic is important during process design; but in daily operations, the company uses its IT systems to get work done, so it has no relationship to operational information security concerns.",
    "correct_answer": "A",
    "explanation": "The sequence of steps in a process (such as a recipe for baking a cake) reflects the logic and knowledge of what needs to be done, in what order, and within what limits, as well as the constraints to achieve the desired conditions or results. That's what business logic is. Most businesses know how to do something that they do better, faster, or cheaper than their competitors, and thus, their business logic gives them an advantage in the marketplace. Protecting that advantage requires preventing one\u2019s competitors from learning how one does that value-creating set of tasks, and ensuring that everything (including information) needed to perform those tasks is on hand and ready to use when required. <br>Option B in effect says that industries have no trade secrets, which is false. <br>Option C is incorrect, because business logic exists for low-priority as well as for high-priority tasks, and Option D mistakenly assumes that all work done uses IT (digital computer) systems, which is false in practice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      27,
      25,
      461,
      462,
      31
    ],
    "source": ""
  },
  {
    "id": 60,
    "question": "Your company uses computer-controlled machine tools on the factory floor as part of its assembly line. This morning, you've discovered that somebody erased a key set of machine control parameter files, and the backups you have will need to be updated and verified before you can use them. This may take most of the day to accomplish. What information security attribute is involved here?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Due care",
    "correct_answer": "B",
    "explanation": "Although it is clear that the necessary parameter files are not available, this seems to have been caused because somebody could violate the integrity requirements of those files\u2014deleting them does not seem to have been an authorized change. That unauthorized change led to (caused) option (C), availability, to be compromised; but lack of availability is not the best statement of the problem. Improper change management and security may have resulted from lack of due care (option D), but that does not identify what needs to be fixed to get machines back into operation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      25,
      24,
      487,
      579
    ],
    "source": ""
  },
  {
    "id": 61,
    "question": "Protection of intellectual property (IP) is an example of what kind of information security need?",
    "choice_a": "Privacy",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Integrity",
    "correct_answer": "B",
    "explanation": "Disclosure of intellectual property in unauthorized ways can end up giving away any competitive advantage that IP might have had for the business. <br>Option A is concerned only with data about personal identities, which are not intellectual property (ideas created by someone). <br>Options C and D are important for all information assets, but do not best address what needs to be protected (kept as secret knowledge) when referring to intellectual property.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      25,
      27,
      461,
      569
    ],
    "source": ""
  },
  {
    "id": 62,
    "question": "John works as the chief information security officer for a medium-sized chemical processing firm. Which of the following groups of people would not be stakeholders in the ongoing operation of this business?",
    "choice_a": "State and local tax authorities",
    "choice_b": "Businesses in the immediate neighborhood of John's company",
    "choice_c": "Vendors, customers, and others who do business with John's company",
    "choice_d": "The employees of the company",
    "correct_answer": "A",
    "explanation": "All other groups have a valid personal or financial interest in the success and safe operation of the company; a major chemical spill or a fire producing toxic smoke, for example, could directly injure them or damage their property. Although tax authorities might also suffer a loss of revenues in such circumstances, they are not involved with the company or its operation in any way.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      462,
      463,
      464,
      31,
      30
    ],
    "source": ""
  },
  {
    "id": 63,
    "question": "When you compare safety to security for information systems, which of the following statements are correct? <ol type=\"A\"><li>When information security measures fail to keep critical data available and correct, the resulting system malfunctions could lead to loss of revenue, property damage, injury, or death.</li><li>Operating a system in an unsafe manner could introduce information that further corrupts the system, violates its integrity, or leads to it crashing, which violates availability needs.</li><li>Keeping a system safe also means \u201csafe from harm,\u201d and thus, means much the same as keeping it secure.</li><li>Safe system operation is the responsibility of its designers, builders, and operators; the information security people have no role in that, and thus, safety and security are unrelated concepts.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "\u201cSafety\u201d for information systems can mean keeping the system from suffering damage, keeping the system from failing in ways that cause damage, or both. Thus, Options A and C are correct, though they are different aspects of safety. <br>Option B is true, but it reverses cause and effect. <br>Option D is incorrect because it tries to separate safety and security when they are in fact related to each other.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      33,
      24,
      23,
      32
    ],
    "source": ""
  },
  {
    "id": 64,
    "question": "Why is the preamble to ISC2's Code of Ethics important to us as SSCPs?",
    "choice_a": "It is vital to understand the code because it sets purpose and intention; it's our mission statement as professionals.",
    "choice_b": "It sounds like it ought to be important, but it just states personal values; the canons tell us what to do and why that matters.",
    "choice_c": "It's not that important, since it only provides a context for the canons, which are the real ethical responsibilities that we have.",
    "choice_d": "It sets the priorities for us to address, highest to lowest, starting with the profession, the organization, the people we work for or our customers, and then society as a whole.",
    "correct_answer": "A",
    "explanation": "Option A correctly interprets the words themselves of the preamble. <br>Option B is incorrect. The preamble does not set personal values (such as honesty); these are in the canons and tied to actions we should take. <br>Option C misses the point of the purpose of the code. <br>Option D incorrectly assumes that the list of these constituencies in the preamble implies a priority order, and it does not.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      31,
      32,
      572,
      570
    ],
    "source": ""
  },
  {
    "id": 65,
    "question": "Due diligence means:",
    "choice_a": "Paying your debts completely, on time",
    "choice_b": "Doing what you must do to fulfill your responsibilities",
    "choice_c": "Making sure that actions you've taken to fulfill your responsibilities are working correctly and completely",
    "choice_d": "Reading and reviewing the reports from subordinates or from systems monitoring data",
    "correct_answer": "C",
    "explanation": "Options A and B are both examples of due care; due diligence is the verification that all is being done well and that nothing is not done properly. <br>Option D can be an important part of due diligence but is missing the potential for follow-up action.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      30,
      493,
      487
    ],
    "source": ""
  },
  {
    "id": 66,
    "question": "Suppose that you work for a business or have a business as your client. As an SSCP, which of the following groups do you have responsibilities to? <ol type=\"A\"><li>Coworkers, managers, and owners of the business that employs you (or is your client)</li><li>Competitors of the business that employs you or is your client</li><li>Customers, suppliers, or other companies that work with this business</li><li>People and groups that have nothing to do with this business</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "D",
    "explanation": "Options A and C represent direct or indirect stakeholders in the business that employs the SSCP. <br>Options B and D represent other members of society, and you owe them professional service as an SSCP as well. The service you owe others in the marketplace would not include divulging your employer's private data, of course!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      31,
      32,
      29,
      27
    ],
    "source": ""
  },
  {
    "id": 67,
    "question": "We often hear people talk about the need for information systems to be safe and reliable. Is this the same as saying that they need to be secure?",
    "choice_a": "No, because reliability has to do with failures of equipment, errors in software design or use, or bad data used as input, whereas security is focused on keeping the systems and their data safe from intrusion or unwanted change.",
    "choice_b": "Yes, because the objective of information security is to increase our confidence that we can make sound and prudent decisions based on what those information systems are telling us, and in doing so cause no harm.",
    "choice_c": "Yes, because all information and information systems are built by humans, and humans make mistakes, so we need strong safety rules and procedures to keep from causing harm.",
    "choice_d": "No, but they have ideas in common. For example, data integrity can lead to unsafe operation, but information security by itself cannot identify possible safety consequences.",
    "correct_answer": "B",
    "explanation": "Option A ignores that failures in security design or practice can lead to data input or systems usage that might be safe and reliable tomorrow, for example, but not today. <br>Option C, true as far as it goes, does not address security at all. <br>Option D ignores that the vulnerability assessments that should drive security measures are all based on consequences if the risk becomes real.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      33,
      515,
      27,
      31
    ],
    "source": ""
  },
  {
    "id": 68,
    "question": "As an SSCP, you work at the headquarters of a retail sales company that has many stores around the country. Its training department has prepared different training materials and operations manuals for in-store sales, warehouse staff, and other team members to use in their jobs. Most of these describe procedures that people do as they work with one another or with customers. From an information security standpoint, which of the following statements are correct?",
    "choice_a": "Since these all describe people-to-people interactions and processes, they are not implemented by the IT department, and so they're not something that information security is concerned with.",
    "choice_b": "Most of their content is probably common practice in business and retail sales and so would not be trade secrets, company proprietary, or private to the company.",
    "choice_c": "Although these processes are not implemented in IT systems, the documents and videos themselves are hosted in company-provided IT systems, and so information security requirements apply.",
    "choice_d": "If the company has decided that the content of these training materials is proprietary or company confidential, then their confidentiality must be protected. They must also be protected from tampering or unauthorized changes and be available to staff in the stores to use when they need them, if the company is to do business successfully. Therefore, information security applies.",
    "correct_answer": "D",
    "explanation": "Options A and C are confusing information, and our systems or processes for using it, with the technologies with which we create, store, and use that information. <br>Option B is a partial answer (it does not address anything other than confidentiality), and it might be true, but this is a decision that company leadership and management should make (with advice from the SSCP). <br>Option D is the most complete and correct answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      30,
      31,
      32,
      23
    ],
    "source": ""
  },
  {
    "id": 69,
    "question": "What do we use protocols for? <ol type=\"A\"><li>To conduct ceremonies, parades, or how we salute superiors, sovereigns, or rulers</li><li>To have a conversation with someone and keep disagreement from turning into a hostile, angry argument</li><li>together so that they can share tasks and control each other</li><li>As abstract design tools when we are building systems, although we don't actually build hardware or software that implements a protocol</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option D is incorrect; almost everything that holds our IT world together is done via directly building protocols into hardware and software. <br>Options A, B, and C are correct, and they show the human social communications need for signaling one another about the communication we're trying to achieve.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      31,
      32,
      29,
      26
    ],
    "source": ""
  },
  {
    "id": 70,
    "question": "Do the terms <italic>cybersecurity, information assurance</italic>, and information security mean the same thing? <ol type=\"A\"><li>No, because cyber refers to control theory, and therefore cybersecurity is the best term to use when talking about securing computers, computer networks, and communications systems.</li><li>Yes, but each finds preference in different markets and communities of practice.</li><li>No, because cybersecurity is about computer and network security, information security is about protecting the confidentiality and integrity of the information, and information assurance is about having reliable data to make decisions with.</li><li>No, because different groups of people in the field choose to interpret these terms differently, and there is no single authoritative view.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "In many respects the debate about what to call what we're studying is somewhat meaningless. <br>Option D shows that in different communities the different terms are held in greater or lesser favor. It is how people use terms that establishes their meaning and not what a \u201clanguage authority\u201d declares the terms to mean. <br>Option B describes this common use of different terms as if they are different ideas\u2014defense and intelligence communities, for example, prefer \u201ccybersecurity,\u201d whereas financial and insurance risk managers prefer \u201cinformation assurance.\u201d And yet defense will use \u201cinformation assurance\u201d to refer to what senior commanders need when making decisions, and everybody talks about \u201cinformation security\u201d as if all it involves is the hard, technical stuff\u2014but didn't cybersecurity cover that? Options A and C are other incomplete expressions of these ideas.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      23,
      24,
      22,
      29
    ],
    "source": ""
  },
  {
    "id": 71,
    "question": "Which of the following shows the major steps of the information risk management process in the correct order?",
    "choice_a": "Assess risks across the organization; identify information security and privacy risks; implement countermeasures; establish security and privacy posture; review supply chain for IT security risk elements",
    "choice_b": "Establish basic security posture; review risks; implement countermeasures; perform ongoing monitoring and assessment, testing, and training",
    "choice_c": "Set priorities; assess risks; select controls and countermeasures; implement controls; validate correct operation; monitor",
    "choice_d": "Develop business impact analysis; establish risk tolerance levels; implement damage control choices; monitor",
    "correct_answer": "C",
    "explanation": "Option D incorrectly has the BIA first, but the BIA has to come after the organization's leadership has agreed to risk tolerance and set priorities. <br>Option B is incorrect partly because the basic \u201ccommon sense\u201d posture is not part of a formal risk management process but a bare-minimum immediate set of actions to take if needed. <br>Option A has establishing a posture (which consists of policies and decisions that drive implementation and operation steps) and implementation in the wrong order.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      58,
      66,
      54,
      57
    ],
    "source": ""
  },
  {
    "id": 72,
    "question": "What is information risk?",
    "choice_a": "The threat that data on your computers, online storage, local or cloud-hosted data, or other data could be hacked into, stolen, or changed",
    "choice_b": "The probability of an event occurring that disrupts your information and the business processes and systems that use it",
    "choice_c": "Vulnerabilities in your information systems that can be exploited by a threat actor and cause harmful impacts",
    "choice_d": "The probability that management's and leadership's directions and communications will be misunderstood, causing the wrong actions to be taken by stakeholders, possibly causing financial loss, injury, or death",
    "correct_answer": "B",
    "explanation": "Option B is the simplest and most effective definition of information risk. <br>Options A and C do not include probability of occurrence (risks are not certain to happen), and describe how risks become events rather than what the risk actually is. <br>Option D is one example, but it does not define information risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      41,
      42,
      43,
      45
    ],
    "source": ""
  },
  {
    "id": 73,
    "question": "How does information risk relate to information systems risk or information technology risk?",
    "choice_a": "These three terms all mean much the same thing, although with a greater or lesser degree of emphasis on securing the underlying computers and networks.",
    "choice_b": "They express the logical flow of making decisions about risk: first, what information do you need; second, how you get it, use it, and share it with others in the decision process; and third, what technologies help make all of that happen. The probability of an event causing a disruption to any step of that decision process is a risk.",
    "choice_c": "They reflect the need to think about risks in outcomes-based, process-based, asset-based, or threat-based terms.",
    "choice_d": "They suggest the levels of organizational leadership and management that need to be part of managing each risk: senior leaders with information risk, tactical unit managers with information systems risks, and the IT department with information technology risks.",
    "correct_answer": "B",
    "explanation": "Option B correctly shows the use of information to make decisions, as well as the roles of processes and technologies in doing so. <br>Option A mistakenly suggests that the IT risks are more important; IT risks may be how important information is lost or compromised, but it is that information loss or impact that puts businesses out of business and not the failure of their IT systems. <br>Option C confuses risk management with information risk. <br>Option D also mistakes the role of information and the roles of processes and technologies, both in achieving objectives and in risk management.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      42,
      43,
      58,
      34
    ],
    "source": ""
  },
  {
    "id": 74,
    "question": "Which statement about risk perspectives or views is most correct?",
    "choice_a": "Outcomes-based risk assessment is best, because it focuses attention on the highest-priority goals and objectives of the organization as the places to start risk identification and assessment.",
    "choice_b": "Asset-based risk assessment is best, because it focuses attention on where your sunk costs or remaining book value of capital assets is greatest, and thus, most expensive to repair or replace if a risk occurs.",
    "choice_c": "Threat-based risk management is best, because it keeps you looking at rapidly evolving exploits and forces you to realize that somebody, somewhere, has their own reasons for stealing every stray bit of information or computer power from you.",
    "choice_d": "Each of these provides great insight as you start your risk management planning and implementation efforts; no one approach by itself covers everything a good risk management strategy must do.",
    "correct_answer": "D",
    "explanation": "Options A, B, and C are correct statements about each perspective, but they each falsely proclaim that their approach is the only one needed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      46,
      44,
      43,
      45
    ],
    "source": ""
  },
  {
    "id": 75,
    "question": "What does it mean to have an integrated information risk management system?",
    "choice_a": "You choose controls and countermeasures that provide all-risk coverage, have graceful degradation or fallback capabilities, and provide end-to-end visibility and management via built-in command, control, and communications capabilities.",
    "choice_b": "You avoid point defense countermeasures or controls, as they tend to make you overlook gaps between them.",
    "choice_c": "You provide the communications capabilities to bring status, state, and health information from all countermeasures and controls, and all systems elements, to information security managers, who can then direct timely changes in these controls in real time as required to respond to an incident.",
    "choice_d": "Vendors of security information and event managers claim that their products are \u201cintegrated,\u201d but they often do not clearly say what this means or help customers achieve greater security because of this.",
    "correct_answer": "C",
    "explanation": "Option C shows both the purpose of an integrated approach (timely incident characterization and management) and the use of communications capabilities in doing so. <br>Options A and D demonstrate that vendor self-description of their products can sound good but does not really address key needs. <br>Option B is true, and partially addresses how point solutions need to be mutually supportive, but does not go far enough.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      51,
      50,
      55,
      57
    ],
    "source": ""
  },
  {
    "id": 76,
    "question": "Which is the most correct statement as to what it means to have a proactive approach with your information security risk management plans, programs, and systems?",
    "choice_a": "Being proactive means that your countermeasures and controls can actively trace back to identify, locate, and characterize your attackers, which can help you both in defending against them and in potentially seeking legal redress.",
    "choice_b": "Senior leaders and managers in many businesses appreciate active, thoughtful, forward-looking approaches, and you will find it easier to gain their support.",
    "choice_c": "Proactive information security systems allow your security specialists to take real-time control of all system elements, and bring all information about events of interest into one common operational picture. This greatly enhances your ability to detect, characterize, and contain incidents.",
    "choice_d": "Being proactive means that you use the best knowledge you have today, including lessons learned from other organizations' experience with information risk, and you plan ahead to deal with them, rather than wait for them to occur and then investigate how to respond to them.",
    "correct_answer": "D",
    "explanation": "Proactive involves thinking ahead and planning for contingencies, as opposed to being reactive, or waiting until things break. <br>Option A is both wrong and probably illegal in most circumstances. <br>Option B might be true, but it is a general statement about \u201cbeing proactive\u201d rather than specifically about information security. <br>Option C describes an integrated information security management approach.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      54,
      57,
      59,
      55,
      65
    ],
    "source": ""
  },
  {
    "id": 77,
    "question": "Tom is the chief information security officer for a medium-sized business. It's been brought to his attention that the company has been storing its backup systems images and database backups in an offsite facility that has no alarm system and no way of knowing whether there were any unauthorized persons entering that facility. Which of the following might apply to this situation?",
    "choice_a": "This could be a failure of due care in that security requirements for the backup information should have been specified and implemented in the storage plan and contracts.",
    "choice_b": "Since there are no records to check to see if any unauthorized persons had access to these backups, there has been no due diligence lapse.",
    "choice_c": "This is at least a failure of due diligence, since there seems to have been no systematic or periodic check of the storage facility or the backup media stored in it.",
    "choice_d": "This could be a case of failing to perform both due care and due diligence.",
    "correct_answer": "D",
    "explanation": "Options A and C highlight what seem to be Tom's failures to adequately plan for or implement offsite backup storage of system images and data, and his failures to institute effective verification of the security of that storage. <br>Option B is incorrect\u2014the lack of records does not relieve Tom of the burden to check that things are working correctly anyway.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      53,
      52,
      59,
      62,
      65
    ],
    "source": ""
  },
  {
    "id": 78,
    "question": "What kind of information is part of an information risk assessment process? <ol type=\"A\"><li>Lost revenues during the downtime caused by the risk incident, including the time it takes to get things back to normal</li><li>Damage to equipment or facilities, or injury or death to people</li><li>Estimated costs to implement chosen solutions, remediations, controls, or countermeasures</li><li>Total costs to create an asset that is damaged or disrupted by the risk event</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option C is the safeguard value, which we cannot compute until we have completed a risk assessment and a vulnerability assessment, and then designed, specified, or selected such controls or countermeasures. <br>Option D is typically not the loss incurred by damage of an asset; of greater interest regarding impact to an asset would be the cost to repair it (if repairable), replace it, or design and implement new processes to do without the damaged or disrupted asset.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      458,
      594,
      42,
      45,
      43
    ],
    "source": ""
  },
  {
    "id": 79,
    "question": "The acronym BIA refers to which of the following?",
    "choice_a": "A document identifying all of the impacts to the business due to the risks it has chosen to assess; forms the basis for risk mitigation planning and implementation",
    "choice_b": "The basic information security needs to provide for the privacy, integrity, and availability of business information",
    "choice_c": "The budgeted implementation and accreditation plan for information security, often required by insurers and financial authorities of businesses dealing with sensitive or safety-related information",
    "choice_d": "The budgeted cost of information availability, which when compared with the actual cost of information availability, lets management assess planned versus actual success of their information risk management programs",
    "correct_answer": "A",
    "explanation": "The business impact analysis (BIA) is an integrated view of the prioritized risks and the projected impacts they could have on the business. <br>Option B is a misstatement of the confidentiality, integrity, and availability (CIA) needs for information security. <br>Options C and D suggest realistic management needs for bringing together plans, costs, budgets, and timelines, but they are incomplete as stated and may not even exist.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      66,
      54,
      42,
      43
    ],
    "source": ""
  },
  {
    "id": 80,
    "question": "There are three ways in which risk assessments can be done. Choose the answer that orders them from best to least in terms of their contribution to risk management decision making.",
    "choice_a": "Qualitative, quantitative, and CVE-based",
    "choice_b": "CVE-based, quantitative, and qualitative",
    "choice_c": "There is no order; they all can and should be used, as each reveals something more about the risks you have to manage.",
    "choice_d": "Quantitative, CVE-based, and qualitative",
    "correct_answer": "C",
    "explanation": "Options A and D reflect biases toward or against qualitative assessments (presumably for being \u201csoft\u201d or potentially based on emotions or intuition) or quantitative ones (the data is too hard to get or validate). Using published common vulnerability and exposure (CVE) information can be quite illuminating, but as in Option D, be careful to not assume that other people's experiences and systems are a good match for your own, or to bow to authoritative statements without carefully considering whether they fit your situation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      46,
      42,
      59,
      614
    ],
    "source": ""
  },
  {
    "id": 81,
    "question": "Terri has recently been assigned to the information security team as a risk assessment analyst. As she goes through the files (on paper and in the company's cloud-based information systems) that the company already has, she realizes that they are inconsistent in format and hard to use to perform analysis, and that there are no controls over who in the company can access these files. Does any of this present an information security concern? <ol type=\"A\"><li>No, because the company would have chosen a cloud systems provider that fully protects any unauthorized persons or outsiders from accessing any company data.</li><li>Yes, because the data in these files could represent significant vulnerabilities of company systems, and its inadvertent or deliberate disclosure could be very damaging to the company.</li><li>Yes, because the lack of controls on access and use suggests that data integrity is lacking or cannot be assessed.</li><li>Yes, because conflicting formats and content might make much of the data unusable for analysis and decision making without a lot of effort, impacting whether that data can support decision making in a timely manner.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "C",
    "explanation": "These are the expression of confidentiality, integrity, and availability for these data sets. Note that in military terms, information that exposes significant vulnerabilities that could place the organization at risk of great harm is often classified as \u201cTop Secret.\u201d.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      38,
      37,
      42,
      56
    ],
    "source": ""
  },
  {
    "id": 82,
    "question": "Patsy is reviewing the quantitative risk assessment spreadsheet for her division, and she sees a number of entries where the annual loss expectancy is far greater than the single loss expectancy. This suggests that:",
    "choice_a": "The RTO is later than the RPO.",
    "choice_b": "The ARO is less than 1.",
    "choice_c": "The particular risk is assessed to happen many times per year; thus, its ARO is much greater than 1.0.",
    "choice_d": "This looks like an error in estimation or assessment, and it should be further investigated.",
    "correct_answer": "C",
    "explanation": "Option B has the annualized rate of occurrence (ARO) use incorrect; if the ARO was less than 1, the single loss expectancy is in effect spread over multiple years (as if it were amortized). <br>Option A involves restore time and point objectives, which are not involved in annualized loss expectancy (ALE) calculation. <br>Option D misunderstands ALE = ARO * SLE (single loss expectancy) as the basic math involved.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      598,
      456,
      612,
      458,
      614
    ],
    "source": ""
  },
  {
    "id": 83,
    "question": "How do you use RTO, MAO, and RPO in planning information risk management activities? <ol type=\"A\"><li>Return to operations (RTO) is the desired time to get all business processes back into operation, whether on backup or workaround systems or on production systems. The recovery point objective (RPO) sets priorities for which systems to bring up first, or for which business processes to get back into operation before others (of lower priority).</li><li>The recovery point objective (RPO) establishes the maximum amount of data that is lost due to a risk event. This could be in numbers of transactions or in units of time, and it indicates the amount of rework of information that is acceptable to get systems back into normal operation.</li><li>The recovery time objective (RTO) must be less than or equal to the maximum acceptable outage. The MAO sets a maximum downtime (outage time) before mission impact becomes unacceptable; the RTO can be used to emphasize faster than MAO restoration.</li><li>The maximum acceptable outage (MAO) relates to the mission or business objectives; if multiple systems support those objectives, then all of their recovery time objectives (RTOs) must be less than or equal to the MAO.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "C",
    "explanation": "Option A is a misstatement of RTO and RPO.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      477,
      479,
      478,
      595,
      599
    ],
    "source": ""
  },
  {
    "id": 84,
    "question": "Threat modeling and threat assessment:",
    "choice_a": "Should be done during risk management so that the threat modeling and assessment can drive the detailed work of risk mitigation planning",
    "choice_b": "Refer to the boundaries of a system and look to identify, understand, assess, and manage anything that attempts to cross that boundary as a way to identify possible threats",
    "choice_c": "Involves highly mathematical approaches, such as predictive code analysis, to produce meaningful results",
    "choice_d": "Is best done using modeling and simulation tools",
    "correct_answer": "B",
    "explanation": "Whether the system is small and simple or large and complex, its owners, builders, and users have to treat it like a \u201cblack box\u201d and know what can happen across every interface it has with the outside world. Thus, Option B is correct. <br>Option A has the steps in the wrong order; detailed threat modeling and assessment needs detailed system architectural information to be valid. <br>Option C misstates how threat modeling is done. While Option D may address a useful set of tools, it does not explain what threat modeling and assessment are or how to do them.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      46,
      36,
      56,
      48,
      34
    ],
    "source": ""
  },
  {
    "id": 85,
    "question": "What are all of the choices you need to make when considering information risk management, and what's the correct order to do them in? <br><ol><li>Treatment: accept, treat (fix or mitigate), transfer, avoid, recast</li><li>Damage limitation: deter, detect, prevent, avoid</li><li>Perspective: outcomes, assets, process or threat based</li><li>Impact assessment: quantitative or qualitative</li></ol>",
    "choice_a": "1, 2, 3, then 4",
    "choice_b": "3, 4, 2, then 1",
    "choice_c": "4, 3, 2, then 1",
    "choice_d": "2, 3, 1 then 4",
    "correct_answer": "B",
    "explanation": "Choice 3, perspective, should reflect priorities, risk appetite, or tolerance, and decision-making culture, and this has to lead all risk management activities. Next comes Choice 4, which feeds into the BIA. Choice 2 should be a product of the BIA process, because it combines costs or magnitude of impacts with acceptable damage limitation strategies. Finally, we choose what to fix, transfer (pay someone else to worry about), accept, or avoid, and any residual risk is recast or re-expressed to reflect these decisions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      43,
      45,
      44,
      54
    ],
    "source": ""
  },
  {
    "id": 86,
    "question": "Jill has recently joined a software development startup company as an information risk analyst, and she notices that the company does not make use of any risk management frameworks. Which is the best advice you could give to Jill?",
    "choice_a": "As a new employee, she'd be speaking out of turn to say anything just yet. Watch and learn.",
    "choice_b": "As an SSCP, Jill knows that risk management frameworks can offer valuable lessons to learn from as organizations start to plan and conduct risk management (and information risk management) activities. Jill should talk with her supervisor, and perhaps propose that she draft a concept for how to select, tailor, and use one of the widely accepted RMFs.",
    "choice_c": "Jill should suggest to her supervisor that key stakeholders, perhaps even the board of directors, would not be pleased to see that the company is \u201creinventing this wheel\u201d on its own. Perhaps the organization should adapt an RMF to its needs, she suggests.",
    "choice_d": "Most RMFs really do not add value to small, entrepreneurial firms just starting out. Jill can keep the use of RMFs in the back of her mind, and maybe find small elements of these large, complex frameworks to introduce, bit by bit, to her company's security processes and posture.",
    "correct_answer": "B",
    "explanation": "Although Options B and C seem to say the same thing, C is more confrontational and perhaps would seem judgmental\u2014probably not an effective way to sell the benefits of using an RMF. <br>Options A and D are similar, but perhaps they advise too much caution. As an SSCP, Jill has pledged to offer her best advice to her employers. Start the dialogue, according to Option B.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      58,
      52,
      57,
      59
    ],
    "source": ""
  },
  {
    "id": 87,
    "question": "Why do SSCPs need to appreciate the culture of the organization they are working with in order to be effective as information risk managers? <ol type=\"A\"><li>Organizational culture determines how willingly managers and workers at all levels will accept greater responsibilities and accountability, which can severely limit the SSCP's ability to get a risk management plan enacted.</li><li>\u201cOld-boy\u201d networks and informal information and decision paths may make anything written down in business processes, manuals, and so forth somewhat suspect.</li><li>Privately held companies tend to be run more loosely than publicly held ones, because shareholder protection law and regulations dictate limits on what executives and board members can do or how they can do it.</li><li>Larger companies have probably had more different people in key positions over time, and so the effect of one domineering personality (as might happen in small entrepreneurial organizations) is probably not as pronounced.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Options C and D may or may not be true in fact, but it's not clear whether these have any bearing on how the company determines priorities and risk tolerance, or what its decision-making processes and styles are. <br>Options A and B are key elements of organizational culture that can impede or facilitate implementation of a risk management approach.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      41,
      43,
      44,
      54
    ],
    "source": ""
  },
  {
    "id": 88,
    "question": "As chief risk officer, you are asked if ignoring a risk is the same thing as accepting it. Which of the following might be part(s) of your reply?",
    "choice_a": "Yes, because in both cases you have decided to do nothing different and just keep on with business as usual.",
    "choice_b": "No, because quite often you choose to ignore something without first really understanding it or assessing its possible impacts to you.",
    "choice_c": "No, because in ignoring a risk you may be violating your own responsibilities for due care or due diligence.",
    "choice_d": "Yes, because as the responsible manager, you still have due care and due diligence responsibilities here.",
    "correct_answer": "A",
    "explanation": "All are correct as far as they go in comparing \u201cignore\u201d and \u201caccept.\u201d However, the key to due care and due diligence is the standard of reasonable and prudent effort. You would not be prudent if you spent millions of dollars to relocate your business from Atlanta, Georgia (1,050 feet above mean sea level [MSL]) to Boulder, Colorado (5,328 feet above MSL) simply to avoid the risk of a tsunami flooding out your facility, given how astronomically huge that tidal wave would have to be! Thus, Options C and D do not apply, and Option B merely restates the due care or due diligence argument.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      52,
      39,
      64,
      47,
      59
    ],
    "source": ""
  },
  {
    "id": 89,
    "question": "When we call an attack a \u201czero day exploit,\u201d we mean that:",
    "choice_a": "The attack exploited a vulnerability within the first 24 hours of its discovery.",
    "choice_b": "The attack exploited a vulnerability within the first 24 hours of its being announced by the affected systems or software vendor, or when it was posted in the CVE.",
    "choice_c": "This term is meaningless hyperbole, invented by the popular press.",
    "choice_d": "The attack exploited a previously unreported vulnerability before the affected systems or software vendor recognized and acknowledged it, reported or disclosed it, or provided warning to its customers.",
    "correct_answer": "D",
    "explanation": "Despite the name, the 24 hours of a day have nothing to do with the element of surprise associated with attacking a heretofore-unknown vulnerability. <br>Option C is false, since the term is well understood in IT security communities. <br>Option D correctly explains the period from discovery in the wild to first recognition by system owners, users, or the IT community, and how this element of surprise may give the attacker an advantage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      34,
      42,
      59,
      61
    ],
    "source": ""
  },
  {
    "id": 90,
    "question": "Kim manages risk for an online publishing company on the island of St. Kitts, which currently uses an on-premises datacenter as its content development facility; it e-ships content to customers who are then responsible for hosting it wherever they want. Kim's division vice president is concerned about risks, and so Kim has done some estimating. The datacenter has enough backup power supply capacity to do a graceful shutdown, but normal round-the-clock, seven-day-per-week development operations must have commercial power available. Recent experience shows that at least once per month, a brownout or blackout lasting at least eight hours occurs. Each disruption costs the company an additional two hours to restore operations. Which statements about risk assessment are not correct? <ol type=\"A\"><li>Risk appetite should determine the MAO, which can then be used as part of estimating SLE.</li><li>If the SLE exceeds the safeguard value, Kim should advise that the company implement that safeguard.</li><li>If the ALE exceeds the safeguard value, Kim should advise that thee company implement that safeguard.</li><li>Once she has estimated the ALE, Kim can assess different safeguards to see how long their payback period might be so that she can advise her management regarding these alternatives.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A is correct in that tolerance or appetite for risk should drive setting the maximum allowable outage time; the costs incurred during a maximum outage are part of computing single loss expectancy. <br>Option B is incorrect, since the power outages seem to be happening monthly, so SLE alone overstates the potential losses. <br>Option C annualizes the expected losses, but comparing it to the safeguard value assumes a one-year payback period is required. <br>Option D reflects that management may be willing to spend significant money on a safeguard that requires more than one year to justify (pay back) its expense in anticipated savings.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      456,
      598,
      599,
      477,
      43
    ],
    "source": ""
  },
  {
    "id": 91,
    "question": "Which of the following activities are not part of information risk mitigation?",
    "choice_a": "Implementing new systems features or capabilities to enhance product quality",
    "choice_b": "Incident management and investigation after a suspected information security breach",
    "choice_c": "Installing and testing new firewall, switch, and router systems and settings",
    "choice_d": "Developing an information classification policy and process",
    "correct_answer": "D",
    "explanation": "Improving product quality is a laudable goal but in and of itself it is not related to information systems security; thus, Option A is incorrect. <br>Option B refers to activities after an incident; mitigation activities happen before an incident occurs, or result from lessons learned because of the incident. <br>Option C is most likely being done to implement new or revised security policies. <br>Option D is part of information risk management and should precede information risk mitigation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      59,
      57,
      36,
      54
    ],
    "source": ""
  },
  {
    "id": 92,
    "question": "An architecture assessment includes which of the following activities? <ol type=\"A\"><li>Review of risk mitigation plans and risk countermeasure log files</li><li>Ongoing monitoring of systems performance, event logs, and alert data</li><li>Review of problem reports, change requests, and change management information</li><li>Review of network and communications connectivity, diagrams, wiring closets, etc.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "C and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Options C and D focus on trying to discern the \u201cas-built\u201d current state of the systems; whether this goes down to the cable-by-cable verification of what's plugged in where could depend on how thorough the baseline needs to be. <br>Options A and B refer to ongoing operation of the system after mitigation steps have been taken to see if incidents of interest are happening or if there is a need for additional risk mitigation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      52,
      57,
      58,
      61,
      53
    ],
    "source": ""
  },
  {
    "id": 93,
    "question": "Which statement about information architectures and IT architectures is most correct?",
    "choice_a": "Securing the IT architecture first provides the fastest path to a prudent security posture; once that is achieved, a vulnerability assessment of the information architecture can be done to reveal other residual risks.",
    "choice_b": "Business needs should drive administrative security policies based on the information architecture; the IT architecture then needs to have its administrative, logical, and physical controls driven to support the information architecture's security needs.",
    "choice_c": "The IT architecture's security is primarily dependent on technical or logical controls; these need to be determined first, and then they will inform policy writers as they create or update administrative security requirements for the information architecture.",
    "choice_d": "Without effective education and training of all members of the organization, the IT architecture cannot be made secure or kept secure.",
    "correct_answer": "B",
    "explanation": "Option D is an exaggeration. <br>Options A and C have the cart driving the horse: the IT architecture should only exist in the first place because it supports achieving business objectives, and the information architecture is where humans work and make decisions. This is what Option B states.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      43,
      44,
      42,
      48
    ],
    "source": ""
  },
  {
    "id": 94,
    "question": "How should IT services such as PaaS, IaaS, and SaaS be evaluated as part of a security assessment?",
    "choice_a": "Since terms-of-service agreements cover your business's use of these services, this transfers all of the information security risk to the cloud service provider and makes the security assessment a lot easier.",
    "choice_b": "PaaS security needs should be adequately covered by the platform services provider, whereas IaaS may or may not provide strong enough security measures to meet your needs and thus, should be avoided if possible.",
    "choice_c": "The BIA and the architectural baselines should make clear what risks are transferred to the cloud services provider either in whole or in part, or where their services are assumed to be parts of the mitigation strategy. The security assessment should clearly identify this to as great a detail as it can, particularly for the risks identified in the BIA as of greatest concern.",
    "choice_d": "Penetration testing, with the consent of the cloud services provider, would be the most reliable way of assessing the security of these services.",
    "correct_answer": "C",
    "explanation": "Option A seems to blindly assume that a contractual transfer of responsibility was necessary, sufficient, and agreed to, and this is normally not the case. <br>Option B is false; platforms and infrastructures still require substantial effort by users (and their IT security team) to establish policies, implement them in controls, and monitor their ongoing correct operation. <br>Option D seems to ignore BIA-driven risk assessment and is inherently misleading.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      43,
      58,
      59,
      53,
      52
    ],
    "source": ""
  },
  {
    "id": 95,
    "question": "Why are shadow IT systems or elements a concern to information security specialists? <ol type=\"A\"><li>These are exploits and malware found on the dark Web and, as such, must be considered hostile to your organization's goals and objectives. They should be banned from the business and its systems by policy.</li><li>Most are written by well-intended users and may be widely used by people in the organization, but quite often they are not subjected to even the most basic software quality assurance measures and are outside of configuration management and control. Hence, they pose potential risks to the IT architecture.</li><li>The more complex and dynamic these shadow systems become, the less confidence management should have in the reliability, integrity, and confidentiality of the results they produce.</li><li>As long as common vulnerabilities have been addressed (for example, by blocking the use of unsigned macros in Microsoft Office), shadow IT components are no more likely to introduce risks than other IT systems.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option B correctly describes what shadow IT systems are; thus, Option A is false. <br>Options B and C demonstrate that in many cases, it cannot be shown that shadow IT systems taken as a whole correctly perform business logic or that they attain the CIA levels commensurate with the impacts if they fail.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      579,
      486,
      487,
      25,
      31
    ],
    "source": ""
  },
  {
    "id": 96,
    "question": "Which statement correctly describes the usefulness of CVE data as part of your risk mitigation planning?",
    "choice_a": "It should provide most, if not all, of the vulnerability information you need to implement risk mitigation.",
    "choice_b": "Since hackers use CVE data to aid in planning their attacks, this should be the first place you look for insight as you do emergency hardening of your IT systems. Once these obvious vulnerabilities have been mitigated, a more complete vulnerability assessment should be done.",
    "choice_c": "It's a great source of information for known systems elements and known vulnerabilities associated with them, but it does nothing for vulnerabilities that haven't been reported yet or for company-developed IT elements.",
    "choice_d": "Since the vast majority of systems in use are based on Windows, if your business does not use Windows platforms you can probably avoid the expense of investigating CVE for vulnerability information.",
    "correct_answer": "C",
    "explanation": "Option B does correctly state the risk that attackers may know more about your systems than you do if you haven't thoroughly checked CVE data as part of your vulnerabilities assessment. But it incorrectly goes on to suggest that you fix those first\u2014they may not relate to your organization's highest-priority impacts as spelled out by the business impact analysis (BIA). <br>Option A is therefore false. <br>Option D is also false, since even the most Linux-based of organizations will probably have non-Linux systems elements (such as network components) that common vulnerabilities and exploits (CVE) could have information about.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      518,
      516,
      487,
      493,
      510
    ],
    "source": ""
  },
  {
    "id": 97,
    "question": "What is the role of threat modeling in performing a vulnerability assessment?",
    "choice_a": "Threat modeling involves creating models of systems, their vulnerabilities, and possible exploits, as well as modeling or simulating attacks to determine which vulnerabilities are in fact most severe. This drives mitigation planning.",
    "choice_b": "Threat modeling focuses attention on boundaries between systems elements and the outside world, and this may help you discover poorly secured VPN or maintenance features or tunnels installed by malware.",
    "choice_c": "Threat modeling can be used to validate that your risk mitigation controls and countermeasures have been successfully implemented, and so it comes after the vulnerability assessment.",
    "choice_d": "Threat modeling is a useful first step when planning penetration testing.",
    "correct_answer": "B",
    "explanation": "Option A is overcomplicating the threat modeling process. <br>Options C and D misstate the purpose of threat modeling.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      46,
      42,
      34,
      36,
      48
    ],
    "source": ""
  },
  {
    "id": 98,
    "question": "How should the SSCP assess the human elements in a system as part of vulnerability assessments? <ol type=\"A\"><li>Since the human user is the weakest element in any IT security system, the vulnerability assessment should start by examining all manual data entry, manipulation, or process interaction steps for possible vulnerabilities.</li><li>The organizational culture and context should determine whether senior leaders and managers create a climate of trust and empowerment or one of rigidly enforced controls and constraints. This sets the bounds within which the SSCP can examine manual interaction with and use of the IT systems for possible vulnerabilities.</li><li>Every step in every process, whether performed by people or machines, is a potential vulnerability and should be assessed in accordance with the BIA's established priorities.</li><li>If the vulnerability assessment indicates that no amount of user training or administrative controls can reduce the risk of an incorrect human action to accessible levels, then further physical or logical controls, or a process redesign, may be needed.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "C and D",
    "correct_answer": "D",
    "explanation": "Option A may be a commonplace statement, but it incorrectly suggests this is where the assessment should start. The BIA should establish the priorities (which processes to assess first and which ones can wait until later). <br>Option B's concerns about culture and context are irrelevant to whether a process step contains a vulnerability and whether the BIA has characterized that as of high interest or concern.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      44,
      58,
      50,
      42,
      47
    ],
    "source": ""
  },
  {
    "id": 99,
    "question": "What does it mean to accept a risk?",
    "choice_a": "Accepting a risk is when management has reviewed and approved the vulnerability assessment prior to authorizing mitigation to proceed.",
    "choice_b": "Accepting a risk means that management knows and understands the probability of occurrence, the possible impacts, and the possible costs of mitigation but chooses nonetheless to not make any changes to business processes or systems. This approach is, in effect, self-insuring against the risk.",
    "choice_c": "Accepting a risk means that management has decided to get insurance coverage that will compensate for loss or damages if the risk event actually occurs.",
    "choice_d": "Accepting a risk means the same thing as ignoring it.",
    "correct_answer": "B",
    "explanation": "Option A confuses accepting a risk with accepting the assessment of all risks as an actionable basis on which to proceed with mitigation efforts. <br>Option C confuses accepting with transferring a risk. <br>Option D confuses accepting with ignoring a risk. Acceptance requires knowing, informed consent; ignoring a risk is simply choosing not to investigate, assess, characterize, or even think about the risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      59,
      63,
      62,
      61
    ],
    "source": ""
  },
  {
    "id": 100,
    "question": "Which of the following might be legitimate ways to transfer a risk?<ol type=\"A\"><li>Recognize that government agencies have the responsibility to contain, control, or prevent this risk, which your taxes pay them to do.</li><li>Pay insurance premiums for a policy that provides for payment of claims and liabilities in the event the risk does occur.</li><li>Shift the affected business processes to a service provider, along with contractually making sure they are responsible for controlling that risk or have countermeasures in place to address it.</li><li>Change the underlying business process to use more secure software and hardware systems.</li></ol>",
    "choice_a": "A, B and C",
    "choice_b": "A, B and D",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "A",
    "explanation": "Option D is typically an example of remediating, sometimes called fixing or mitigating the risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      63,
      42,
      47,
      62
    ],
    "source": ""
  },
  {
    "id": 101,
    "question": "What are some of the reasons you might recommend that risks be avoided? <ol type=\"A\"><li>It might cost more to mitigate or control a risk than the business stands to gain by operating with the risk in place.</li><li>Replacing a vulnerable set of processes with ones that are less vulnerable can be more effective and less costly than attempting to redesign or repair the vulnerable steps or elements.</li><li>In most cases, very few risks can be avoided; you really end up accepting them, ignoring them, or fixing things so that the risks are far less likely to occur or are less damaging if they do.</li><li>Avoidance means that you're refusing to face the facts and trying to ignore what experience is showing you. This is much like ignoring a risk, which makes sense only for risks that are truly beyond the ordinary.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option C makes it seem that businesses are helpless to choose their goals, objectives, and where or how they will operate; this statement exaggerates. <br>Option D confuses psychological avoidance behavior with an informed choice to step out of the way of a risk; it confuses ignoring with avoiding.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      59,
      47,
      43,
      65
    ],
    "source": ""
  },
  {
    "id": 102,
    "question": "CVE data and your own vulnerability assessments indicate that many of your end-user systems do not include recent security patches released by the software vendors. You decide to bring these systems up to date by applying these patches. This is an example of which of the following?",
    "choice_a": "Remediating or mitigating a risk",
    "choice_b": "Transferring a risk",
    "choice_c": "Avoiding a risk",
    "choice_d": "Accepting a risk",
    "correct_answer": "A",
    "explanation": "Fixing or applying patches to eliminate a vulnerability is the definition of remediating, mitigating, fixing, or repairing a vulnerability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      59,
      36,
      61,
      57
    ],
    "source": ""
  },
  {
    "id": 103,
    "question": "How do physical, logical, and administrative controls interact with one another?",
    "choice_a": "Usually, the only way these controls can interact is via postevent analysis.",
    "choice_b": "Administrative controls should direct and inform people; logical controls implement those directions in the IT architecture; physical controls reinforce by preventing or deterring disruptions to the hardware, systems, and support infrastructures themselves.",
    "choice_c": "After determining the physical security and asset protection needs and controls, the administrative and logical controls can be tailored to eliminate or reduce gaps in risk mitigation coverage.",
    "choice_d": "It may seem like these should harmonize well, but in practice, that rarely happens since administrators seldom appreciate what IT security needs actually entail.",
    "correct_answer": "B",
    "explanation": "Option A misunderstands that controls are chosen and then implemented, and proper mitigation planning seeks to have controls or countermeasures mutually reinforce each other. <br>Option C misstates the mitigation planning task. <br>Option D suggests that if \u201cadministrators\u201d are network or systems administrators, then we hope they <italic>do</italic> understand something about IT security; if they are not, they are probably not the ones who have to work to ensure these controls are part of an interlocking system of information security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      516,
      574,
      573,
      517,
      490
    ],
    "source": ""
  },
  {
    "id": 104,
    "question": "How might you keep a gap from becoming a blind spot in your information security defenses? ",
    "choice_a": "Transfer this risk to insurers or other parties.",
    "choice_b": "Ensure that systems elements around the gap provide sufficient detection and reporting capabilities so that an event of interest occurring in the gap cannot spread without being detected.",
    "choice_c": "Ensure that other systems elements can either detect or report when an event of interest is happening within the gap.",
    "choice_d": "You can't, as by definition the gap is where you have no appreciable security coverage, and this includes having no monitoring or detection capabilities.",
    "correct_answer": "B",
    "explanation": "If Option A or C was plausible, then you wouldn't actually have a gap. <br>Option D correctly defines the gap but fails to look to how to mitigate the risk posed by the gap.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      51,
      65,
      59,
      61,
      53
    ],
    "source": ""
  },
  {
    "id": 105,
    "question": "What roles do testing and verification play in information security? <ol type=\"A\"><li>Provide continued confidence in the security of the information systems under test and verification</li><li>Highlight the need for further risk mitigation, controls, and countermeasures</li><li>Confirm that countermeasures and controls are still achieving the required degree of protection</li><li>Verify that penetration testing subcontractors have satisfactorily fulfilled their contract with the business</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option D may reflect a legitimate need for ongoing insight, but this is rather like testing to verify that your testing was done correctly. It's not clear such a step would be productive.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      59,
      54,
      58
    ],
    "source": ""
  },
  {
    "id": 106,
    "question": "Which of the following most correctly address whether penetration testing is suitable for use during systems security verification or is best suited to ongoing monitoring and assessment? <ol type=\"A\"><li>Penetration testing is most revealing when performed against a baseline already in use for some time, because the risks of people becoming complacent and mitigation controls becoming out of date increase with time.</li><li>Penetration testing is not useful during verification testing or systems assessment, because by its nature penetration testing is a somewhat covert attempt to simulate a hostile attack, whereas verification testing is a formalized, planned, and monitored activity.</li><li>Penetration testing has a valid and valuable contribution to make at any point in the lifecycle of a system, from initial systems analysis throughout its deployed operational use.</li><li>Penetration testing is normally used during postdeployment systems assessment and starts with current knowledge of how threat actors attempt to reconnoiter, surveil, select, and penetrate a target; verification starts with a functional security requirements baseline and confirms (via audit, test, or inspection) that each requirement in that baseline still functions properly. Both techniques complement each other during ongoing operational assessment.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "A, B and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "C",
    "explanation": "Option C is incorrect\u2014you cannot test systems before they are built (i.e. during the systems analysis phase).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      602,
      629,
      53,
      57,
      59
    ],
    "source": ""
  },
  {
    "id": 107,
    "question": "How do we perform ongoing monitoring of our IT systems to ensure that all risk mitigation controls and countermeasures are still protecting us? <ol type=\"A\"><li>Periodically, gather up all of the event logs and monitoring log files, collate them, and see if potential events of interest are apparent.</li><li>Routinely poll or ask users if abnormal systems behaviors have been noted.</li><li>Review systems performance parameters, such as throughputs, systems loading levels, resource utilization, etc., to see if they meet with expectations.</li><li>Review current postings in CVE and NVD systems to determine if the vulnerability assessment is still effective.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option D is an important task to do on a routine basis, but it involves monitoring the outside threat world and not the behavior or performance of the systems we are protecting.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      53,
      61,
      609,
      51,
      52
    ],
    "source": ""
  },
  {
    "id": 108,
    "question": "What important role does systems monitoring perform in support of incident management?",
    "choice_a": "They are not related\u2014monitoring is a routine task that uses trend analysis and data analytics to determine if past systems behavior and use have been within expected bounds.",
    "choice_b": "The role is essential; by bringing together alert and alarm indicators from systems and their associated security controls and countermeasures, monitoring is the watchdog capability that activates incident response capabilities and plans.",
    "choice_c": "Incident response includes its own monitoring and alarms capabilities, so systems monitoring provides a good backup or alternate path to determining whether an incident is occurring.",
    "choice_d": "Ongoing, continuous monitoring is used to adjust or fine-tune alarm threshold settings so that false alarm rates can be better managed.",
    "correct_answer": "B",
    "explanation": "Option A misstates the role of ongoing monitoring, and conflicts with Option B. <br>Option C suggests a redundant set of capabilities, which may be mission critical for a select few organizations but is not common. <br>Option D may be a useful capability, but it is not the reason for ongoing monitoring.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      53,
      40,
      59,
      57
    ],
    "source": ""
  },
  {
    "id": 109,
    "question": "How are dashboards used as part of systems monitoring or incident response?",
    "choice_a": "Dashboards typically display highly summarized key performance indicators, which are suitable for long-term business planning; as such, they're not useful in real-time systems monitoring or incident response.",
    "choice_b": "Dashboards can be useful in systems monitoring; they can flag IT staff when events are occurring that may indicate systems loading issues or even failures of systems components. But they are not usually suitable for detecting security incidents.",
    "choice_c": "By summarizing systems status, such as which elements are healthy and which are nonresponsive, dashboards can be helpful in incident response decisions. But the details below the level of the dashboard are what ongoing monitoring depends on.",
    "choice_d": "By combining highly summarized key performance parameters with ongoing and recent event data, systems managers can see at a glance whether systems are behaving within expected limits, detect whether subsystems have failed (or are under attack), and drill down to get further data to inform incident response decision making.",
    "correct_answer": "D",
    "explanation": "Options A and C both underestimate the value of a good key performance indicator, whether for real-time incident detection and response or for trending and analysis. <br>Option B is also mistaken in that it suggests that aggregate measures such as link loading, resource utilization, and so forth have no value in incident detection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      61,
      59,
      623,
      624
    ],
    "source": ""
  },
  {
    "id": 110,
    "question": "What is the role of incident response and management in risk mitigation and risk management?",
    "choice_a": "Incident response and management are vital to risk mitigation; they provide the timely detection, notification, and intervention capabilities that contain the impact of a risk event and manage efforts to recover from it and restore operations to normal.",
    "choice_b": "Although it comes after the risk assessment and mitigation planning, implementation, and verification, incident response is not part of risk mitigation or risk management.",
    "choice_c": "Incident management is a part of risk mitigation but not part of risk management.",
    "choice_d": "Incident management is a part of risk management, but not of risk mitigation.",
    "correct_answer": "A",
    "explanation": "Option B is incorrect; incident response and management is a vital part of risk management. <br>Options C and D do not recognize that risk management includes all processes necessary to identify, assess, characterize, control, respond to, and recover from risks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      61,
      56,
      54,
      58
    ],
    "source": ""
  },
  {
    "id": 111,
    "question": "When comparing the TCP/IP and OSI 7-layer reference model as sets of protocols, which statement is most correct?",
    "choice_a": "Network hardware and systems are actually built on TCP/IP, whereas the OSI reference model provides only concepts and theories.",
    "choice_b": "TCP/IP provides only concepts and theories, whereas network hardware and systems are actually built using the OSI reference model.",
    "choice_c": "Both sets of protocols provide theories and concepts, but real hardware is built around the data, control, and management planes.",
    "choice_d": "Hardware and systems are built using both models, and both models are vital to threat assessment and network security.",
    "correct_answer": "D",
    "explanation": "Option D accurately reflects the use of both of these as conceptual models and protocol stacks\u2014by builders, attackers, and defenders alike. <br>Option A reflects an incorrect bias that many network engineers have, who somewhat dismissively ignore things above the Transport layer. <br>Option B is its logical opposite, also false. <br>Option C is incorrect, as all three sets of concepts drive the design and operation of real hardware, software, and systems.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      179,
      178,
      200,
      189
    ],
    "source": ""
  },
  {
    "id": 112,
    "question": "Is IPv6 backward compatible with IPv4?",
    "choice_a": "No, because the differences in addressing, packet header structure, and other features would not allow an IPv4 packet to successfully travel on an IPv6 network.",
    "choice_b": "No, because IPv4 packets cannot meet the new security considerations built into IPv6.",
    "choice_c": "Yes, because IPv6 has services built into the protocol stacks to convert IPv4 packets into IPv6-compatible structures.",
    "choice_d": "Yes, because the transport and routing protocols are the same.",
    "correct_answer": "A",
    "explanation": "Option B is incorrect, because the changes in address field sizes, and therefore packet header structures, have nothing to do with security (although IPv6 does provide enhancements to security). <br>Option C is incorrect; such a conversion could be done by a gateway, but that is not part of IPv6 and is only supported by it. <br>Option D is incorrect, although the transport protocols (like TCP and UDP) have not changed, but this is not where the incompatibility comes from.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      450,
      452,
      451,
      454,
      507
    ],
    "source": ""
  },
  {
    "id": 113,
    "question": "Which basic network topology best describes the Internet?",
    "choice_a": "Star",
    "choice_b": "Mesh",
    "choice_c": "Ring",
    "choice_d": "Bus",
    "correct_answer": "B",
    "explanation": "Option A is false, as there is no one central node that serves the entire net; further, millions of Internet nodes have connections between them. <br>Option C is incorrect, as many nodes on the Internet can fail, but this does not prevent alternate routing of frames around the failure; the Internet is \u201cself-annealing\u201d in this way. <br>Option D is false, as there is no one straight line connection from the first Internet node to the last. <br>Option B correctly identifies the billions of nodes on the Internet as being part of a very large mesh.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      465,
      504,
      179,
      730,
      200
    ],
    "source": ""
  },
  {
    "id": 114,
    "question": "Which relationship between nodes provides the greatest degree of control over service delivery?",
    "choice_a": "VPN tunnel",
    "choice_b": "Peer-to-peer",
    "choice_c": "Client-server",
    "choice_d": "Peer-to-server",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; VPNs provide connectivity but have no more role in service delivery than other Layer 1 or Layer 2 network elements do. <br>Option B is incorrect, as neither peer controls the other in service sharing. <br>Option D is incorrect; in such a case, either the server is a peer to the other server or the peer is actually a client. <br>Option C correctly identifies that most services need one node to control the service delivery process, and the other node, requesting the service, follows the first node's control of the conversation.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      465,
      467,
      170,
      160,
      187
    ],
    "source": ""
  },
  {
    "id": 115,
    "question": "Which statement about subnetting is correct?",
    "choice_a": "Subnetting applies only to IPv4 networks, unless you are using Classless Inter-Domain Routing (CIDR).",
    "choice_b": "Both IPv4 and IPv6 provide for subnetting, but the much larger IPv6 address field makes this a lot simpler to design and manage.",
    "choice_c": "Subnetting in IPv4 involves the CIDR protocol, which runs at Layer 3; in IPv6, this protocol, and hence subnetting, is not used.",
    "choice_d": "Because the subnet mask field is so much larger in IPv6, it is easier to subnet in this newer protocol stack than in IPv4.",
    "correct_answer": "B",
    "explanation": "Options A and C both incorrectly leave out subnetting in IPv6 and misstate what CIDR is about, even though the two options say this differently. <br>Option D is partly correct in that IPv6 does have a 16-bit subnet field, and (as Option B says) the overall address field size makes subnetting much easier to do, but there is no subnet field in IPv4.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      450,
      451,
      452,
      454,
      470
    ],
    "source": ""
  },
  {
    "id": 116,
    "question": "Which of the following transmission media presents the greatest security challenges for a network administrator?",
    "choice_a": "Twisted-pair wiring",
    "choice_b": "Fiber optic",
    "choice_c": "Radio frequency wireless",
    "choice_d": "Light waves, either infrared or visible, but not in a fiber",
    "correct_answer": "C",
    "explanation": "Option A is the backbone of most LANs, because physical cables can be protected in a variety of ways, and unless a hacker can access your patch panels or other hardware, it is difficult to intrude at the Physical layer. <br>Option B is also very secure; it is harder to physically tap into a fiber as well. <br>Option D tends to see use in limited circumstances, but this may change in time. <br>Option C is correct because Wi-Fi is, quite literally, everywhere; it is <italic>expected</italic> to be available; people and businesses demand it; and many Wi-Fi devices, such as SOHO routers, are trivially easy to set up and leave unsecured. Wi-Fi is subject to many kinds of eavesdropping, snooping, and spoofing attacks unless properly secured.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      682,
      504,
      179,
      178,
      200
    ],
    "source": ""
  },
  {
    "id": 117,
    "question": "Which statement (or statements) about ports and the Internet is/are not correct? <ol type=\"A\"><li>Using port numbers as part of addressing and routing was necessary during the early days of the Internet, largely because of the small size of the address field, but IPv6 makes most port usage obsolete.</li><li>Standard ports are defined for a number of protocols, and these ports allow sender and receiver to establish connectivity for specific services.</li><li>Standardized port assignments cannot be changed or things won't work right, but they can be mapped to other port numbers by the protocol stacks on the sender's and recipient's systems.</li><li>Many modern devices, such as those using Android, cannot support ports, and so apps have to be redesigned to use alternate service connection strategies.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Ports are a fundamental part of the way apps request services from processes running on other nodes on the Internet. Standardized port numbers make applications designs easier to manage; thus, port 80 and HTTP are associated with each other. Thus, Options A and D show a misunderstanding of what ports are and why they are necessary.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      453,
      454,
      455,
      507,
      508
    ],
    "source": ""
  },
  {
    "id": 118,
    "question": "Which of the following statements about man-in-the-middle (MITM) attacks is most correct?",
    "choice_a": "Session stealing attacks are not MITM attacks.",
    "choice_b": "MITM attacks can occur at any layer and against connectionless or connection-oriented protocols.",
    "choice_c": "This basic attack strategy can be used at any layer of the protocols where there is connection-oriented, stateful communication between nodes.",
    "choice_d": "MITM attacks can only work at Layer 4.",
    "correct_answer": "B",
    "explanation": "From the Physical layer on up, the injection of unauthorized traffic into a network can cause almost any protocol to fall for a \u201cmistaken identity\u201d that leads to an Man-in-the-Middle (MITM) attack. Session stealing (Layers 5 and 7) is a prime example; thus, Option A is false. <br>Option C is incorrect, since IP (Layer 2) is inherently connectionless and is prone to MITM attacks. <br>Option D is also false, as session stealing (and others) demonstrates.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      179,
      730,
      200,
      195
    ],
    "source": ""
  },
  {
    "id": 119,
    "question": "Which statement about cache poisoning is most correct?",
    "choice_a": "The cache on a user's local machine is immune from being poisoned by an attacker.",
    "choice_b": "Privately maintained DNS servers are the most lucrative targets of attackers, and thus, the best strategy is to use commercial DNS service providers with proven security and reliability records.",
    "choice_c": "Almost every device on the network, from a smartphone or laptop on up, has address and DNS cache on it; these can be poisoned in a variety of ways, exposing the user and the network to various attacks.",
    "choice_d": "Cache poisoning can be prevented by encrypting the cache.",
    "correct_answer": "C",
    "explanation": "Option A is incorrect, since the local host file (cache) is quite easily corrupted as part of an attack. <br>Option B shows a misunderstanding of DNS and the role of DNS servers. <br>Option D sounds tempting, but without this being part of an extensive data-at-rest protection scheme it may not work and would probably impede network operations.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      730,
      200,
      178,
      179,
      199
    ],
    "source": ""
  },
  {
    "id": 120,
    "question": "What happens to datagrams as they are passed through the protocol stack from the Data Link layer to the Transport layer?",
    "choice_a": "They get shorter as the headers and footers are removed as the datagrams move from one layer to the next.",
    "choice_b": "They get longer as more header and footer information is wrapped around the datagram.",
    "choice_c": "They get converted from character or graphic information and formatting into byte formats.",
    "choice_d": "If an encryption protocol is being used, they get encrypted.",
    "correct_answer": "A",
    "explanation": "Option A is correct; this is \u201cunwrapping\u201d as datagrams have their headers and footers removed on their way up the stack. <br>Option B is incorrect\u2014wrapping happens on the way down from Transport (or higher) to Physical (by way of Data Link). <br>Options C and D describe what the presentation layer does as it passes datagrams to applications, which is beyond the Transport layer and going up, not down, the stack.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      505,
      179,
      501,
      675
    ],
    "source": ""
  },
  {
    "id": 121,
    "question": "Which layer of the OSI protocol stack does IPSec function?",
    "choice_a": "Layer 2",
    "choice_b": "Layer 3",
    "choice_c": "Layer 4",
    "choice_d": "Layer 5",
    "correct_answer": "B",
    "explanation": "Option B is correct; it is an internetworking layer security process and protocol set added to IPv4. <br>Option A is incorrect; IPSec works with packets, not frames (IP addresses, not MAC addresses). <br>Option C is also incorrect, because IPSec is not a transport protocol. <br>Option D is incorrect; IPSec is not a session layer protocol.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      505,
      525,
      180,
      183
    ],
    "source": ""
  },
  {
    "id": 122,
    "question": "You're trying to diagnose why a system is not connecting to the Internet. You've been able to find out that your system's IP address is 169.254.0.0. Which of the following statements correctly suggests the next best step?",
    "choice_a": "It sounds like you've got a corrupted local DNS cache, which you should flush and then reset the connection.",
    "choice_b": "Try connecting via another browser.",
    "choice_c": "Check the DHCP server on your LAN to see if it's functioning correctly.",
    "choice_d": "Check to see if any router and modem between your system and your ISP are functioning correctly; you may need to do a hardware (cold) reset of them.",
    "correct_answer": "C",
    "explanation": "This IP address is the link local address, which is assigned to your system by the operating system and its network protocol stack when a DHCP server does not respond. Check the configuration settings for any switches, routers, and modems between your system and your ISP so that you know where the DHCP service resides; then find that device. Thus, Options A and B are incorrect. <br>Option D may be a good step <italic>after</italic> you determine which device is supposed to be your DHCP server. <br>Option C is your best next step. Ping it or use tracert it to see if it responds.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      468,
      469,
      505,
      470,
      506
    ],
    "source": ""
  },
  {
    "id": 123,
    "question": "Your IT team has a limited budget for intrusion detection and prevention systems and wants to start with a central server and a small number of remote IDS / IPS devices. Your team lead asks you where you think the remote devices should go. Which answer would you suggest?",
    "choice_a": "Place them in the datacenter on the key access paths to its switch fabric.",
    "choice_b": "Place them on the links between your ISP's point of presence and your internal systems.",
    "choice_c": "Identify the links between high-risk internal systems (such as software development) and mission-critical systems (such as customer order processing, manufacturing control, or finance), and put them on the links between those systems.",
    "choice_d": "The central server is a good start, and you can save even more money by skipping the remote devices for right now.",
    "correct_answer": "B",
    "explanation": "In almost all circumstances, the boundary between an organization's information infrastructure and the outside world of the Internet is the highest-risk threat surface. Any channel crossing this boundary should be rigorously assessed for vulnerabilities, and all access via should be it well controlled and well monitored. Thus, Option B is probably the best recommendation. Internal systems links, such as Options A and C, might help in containment of intrusions, but there may be other ways to do this than with IDS/IPS remotes. <br>Option D restricts the effectiveness of the IPS or IDS to just those network segments and resources it can directly see and control, which may be a very small subset of your network.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      689,
      200,
      178,
      730,
      198
    ],
    "source": ""
  },
  {
    "id": 124,
    "question": "Which measures would you recommend be used to reduce the security risks of allowing Wi-Fi, Bluetooth, and NFC devices to be used to access your company's networks and information systems? <ol type=\"A\"><li>MDM systems</li><li>Effective access control and identity management, including device-level control</li><li>Because the Physical layer is wireless, there is no need to protect anything at this layer.</li><li>Whitelisting of authorized devices</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option C is false; the physical access point itself needs to be protected from somebody attacking it with an unauthorized firmware update, for example, or simply plugging into an unblocked network jack on it. <br>Option D is one component of mobile device management, but it is not sufficient. <br>Option B can reduce exposure to many threats related to mobile device access, whereas a mobile device management system can help track, force compliance, block, or lock down a device reported lost or stolen.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      196,
      178,
      163,
      200,
      181
    ],
    "source": ""
  },
  {
    "id": 125,
    "question": "You've been asked to investigate a possible intrusion on your company's networks. Which set of protocols or design concepts would you find most valuable, and why? Choose the most correct statement.",
    "choice_a": "Start with the TCP/IP protocol stack; you don't need anything else.",
    "choice_b": "The OSI 7-layer reference model may help you understand the nature of the intrusion to a layer or set of layers; next, you can use the TCP/IP protocol to help investigate the details with a protocol analyzer.",
    "choice_c": "The data, control, and management planes aren't going to be useful to you now; they're only a high-level design concept.",
    "choice_d": "You'll most likely need TCP/IP, the OSI 7-layer reference model, and the data, control, and management diagrams and information about your company's networks to fully understand and contain this incident.",
    "correct_answer": "D",
    "explanation": "Option C is false; even if your company didn't use these planes as part of its design and build-out of the networks, this viewpoint can still help you as you look at what the protocol analyzers, SIEMs, IDSs, and IPSs are reporting to you. <br>Options A and B are therefore partly correct; Option D brings all of your tools to bear on the problem.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      730,
      200,
      197,
      178,
      184
    ],
    "source": ""
  },
  {
    "id": 126,
    "question": "What can traffic shaping, traffic management, or load balancing systems do to help identify or solve information security problems? <ol type=\"A\"><li>Nothing, since they work autonomously to accomplish their assigned functions.</li><li>Log data they generate and keep during operation may provide some useful insight after an incident, but nothing in real time would be helpful.</li><li>Such tools usually can generate alarms on out-of-limits conditions, which may be indicative of a system or component failure or an attack or intrusion in progress.</li><li>Given sufficient historical data, such systems may help network administrators see that greater-than-normal systems usage is occurring, which may be worthy of closer attention or investigation.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "C",
    "explanation": "Options B, C, and D all describe ways that having better insight into how your systems and networks are being used, right now, can help you determine if they might be suffering some kind of problems. And if they are, that data can help you resolve whether this is a security event or not. <br>Option A is false and also lacks the insight to apply these systems to your overall information systems security strategy.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      197,
      198,
      176,
      178,
      181
    ],
    "source": ""
  },
  {
    "id": 127,
    "question": "What is the risk of leaving the default settings on the access control lists in routers or firewalls?",
    "choice_a": "Since the defaults tend to allow any device, any protocol, any port, any time, you risk leaving yourself wide open to any attacker or reconnaissance probes. Thus, the risk is very great.",
    "choice_b": "The default settings tend to have everything locked down tightly until the network administrator deliberately opens up apps, time periods, or ports to access and use. Thus, the risk is very low.",
    "choice_c": "Although the default settings leave everything wide open, the normal access control and identity management you have in place on systems, servers, and other resources is all that you need; the risk is very low.",
    "choice_d": "As long as you've changed the administrator login ID and password on the device, you have nothing to worry about.",
    "correct_answer": "A",
    "explanation": "Option B is false; these products ship with everything wide open for a number of practical reasons, including making it easier for administrators to initially configure them. <br>Option C is tempting fate. <br>Option D is a little bit less risky than Option C, since at least you've prevented an intruder from reconfiguring your device to suit their needs and not yours.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      178,
      689,
      187,
      174,
      185
    ],
    "source": ""
  },
  {
    "id": 128,
    "question": "Which of the following is the best form of Wi-Fi security to use today?",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA TKIP",
    "choice_d": "WPA2",
    "correct_answer": "D",
    "explanation": "Option D brings AES encryption to Wi-Fi. <br>Option A is incorrect; WEP was easily broken early on. <br>Option B, WPA, is also incorrect, since this was a step in the right direction while IEEE 802.11i was being developed as a standard. <br>Option C, also incorrect, was part of the interim WPA design, and WPA2 supersedes WPA in all respects.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      180,
      183,
      527,
      200
    ],
    "source": ""
  },
  {
    "id": 129,
    "question": "Your team chief is worried about all of those Bluetooth devices being used at the office; she's heard they are not very secure and could be putting the company's information and systems at great risk. How might you respond?",
    "choice_a": "Even with a maximum range of 10 meters (30 feet), you shouldn't have to worry about eavesdroppers or hackers out in the parking lot. Look to how you control visitor access instead.",
    "choice_b": "Bluetooth devices don't have a lot of bandwidth, so it's very unlikely that they present a data exfiltration or an intrusion threat.",
    "choice_c": "The biggest threat you might face is that Bluetooth on most of your staff's smartphones is probably not secure; talk with your MDM service provider and see if they can help reduce that exposure.",
    "choice_d": "You're right, chief! Bluephishing is fast becoming a social engineering threat, and you need to figure out a strategy to deal with it.",
    "correct_answer": "C",
    "explanation": "Option A is true in part (the range) but ignores other aspects of Bluetooth vulnerabilities. <br>Option B is incorrect\u2014it seems to assume keyboards and mice are the only Bluetooth devices to worry about. <br>Option C is very real and not very well understood by many organizations. <br>Option D isn't real. Yet.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      178,
      179,
      532,
      502
    ],
    "source": ""
  },
  {
    "id": 130,
    "question": "Which of the following statements about a NOC and a SOC is correct? <ol type=\"A\"><li>Both perform essentially the same functions.</li><li>With the increased emphasis on security, senior managers and stakeholders may feel that not having a security operations center is not taking the risks seriously enough.</li><li>The focus of a NOC is different than that of a SOC.</li><li>It's usually a mistake to try to overload the NOC with the security functions the SOC has to take on.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A shows a conceptual misunderstanding about network operations and security operations, regardless of who conducts them or is responsible for them. <br>Option D is also incorrect; many smaller organizations can easily and affordably have their network operations team handle the key security operations functions. <br>Option B may indeed be true in some organizations and in some marketplaces, but the organization should always let its business case for security drive the decision. <br>Option C is correct; NOC focuses on design, deployment, operation, and maintenance of the network and changes to it, and the SOC focus is on keeping it secure, detecting events and characterizing them, and containing and responding to them if necessary.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      198,
      199,
      683,
      179,
      178
    ],
    "source": ""
  },
  {
    "id": 131,
    "question": "Which statement about single-factor vs. multifactor authentication is most correct?",
    "choice_a": "Single-factor is easiest to implement but with strong authentication is the hardest to attack.",
    "choice_b": "Multifactor requires greater implementation, maintenance, and management, but it can be extremely hard to spoof as a result.",
    "choice_c": "Multifactor authentication requires additional hardware devices to make properly secure.",
    "choice_d": "Multifactor authentication should be reserved for those high-risk functions that require extra security.",
    "correct_answer": "B",
    "explanation": "Option A is false; each additional factor checked increases the challenge an attacker has to overcome to spoof an identity claim. <br>Option C is false; hardware is only needed for factors involving what the subject has, such as a keyfob code generator, or biometric factors. <br>Option D is tempting, and high-risk functions might be best protected with additional security measures, but compared to Option B, it is not as compellingly correct.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      357,
      327,
      293,
      446
    ],
    "source": ""
  },
  {
    "id": 132,
    "question": "Multifactor authentication means that our systems validate claims to subject identity based on:",
    "choice_a": "Third-party trusted identity proofing services",
    "choice_b": "Digital identity platforms",
    "choice_c": "Some aspect of what the subject is, knows, or has",
    "choice_d": "Two different biometric measurements",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; proofing establishes the truthfulness of documents or other information that attest to a person's claim to be that person and is used during the identity provisioning process. <br>Option B can be used as single-factor or as part of a multifactor system, for example, by using a Microsoft account to sign on to a Web service. <br>Option D is incorrect; while this is two different measurements, they both attest to what the subject is (the physical body), and multifactor would require us to look at what the subject has or knows as well.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      542,
      556,
      281,
      5
    ],
    "source": ""
  },
  {
    "id": 133,
    "question": "In access control authentication systems, which is riskier, false positive or false negative errors?",
    "choice_a": "False negatives, because they lead to a threat actor being granted access",
    "choice_b": "False positives, because they lead to a threat actor being granted access",
    "choice_c": "False negatives, because they lead to legitimate subjects being denied access, which impacts business processes",
    "choice_d": "False positives, because they lead to legitimate subjects being denied access, which impacts business processes",
    "correct_answer": "B",
    "explanation": "A positive result in an authentication system means the system believes the claimant is who they claim to be. A false positive occurs when the system incorrectly grants access to an unauthorized user, which is risky because it can lead to a threat actor gaining access. A false negative occurs when the system incorrectly denies access to an authorized user, which can disrupt business operations but does not typically present an immediate security risk. Therefore, the greater risk lies in false positives, as they involve unauthorized access being granted.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      484,
      483,
      342,
      374,
      566
    ],
    "source": ""
  },
  {
    "id": 134,
    "question": "Your IT department head wants to implement SSO, but some of the other division heads think it adds too much risk. She asks for your advice. Which statement best helps her address other managers' concerns?",
    "choice_a": "They're right; by bridging multiple systems together with one common access credential, you risk opening everything to an attacker.",
    "choice_b": "Yes and no; single sign-on by itself would be risky, but thorough and rigorous access control at the system, application, and data level, tied to job functions or other attributes, should provide one-stop login but good protection.",
    "choice_c": "Single sign-off involves very little risk; you do, however, need to ensure that all apps and services that users could connect to have timeout provisions that result in clean closing of files and task terminations.",
    "choice_d": "Since support for single sign-on is built into the protocols and operating systems you use, there's very little risk involved in implementation or managing its use.",
    "correct_answer": "B",
    "explanation": "Option B is correct, as it emphasizes the need to have a rigorous threat modeling or vulnerability assessment drive the way you design and use access control at a very fine-grain level. <br>Option A is only partially correct, because it considers SSO as if it's a one-ingredient answer to a complex situation. <br>Option C confuses single sign-OFF with single sign-ON; it's correct in what it says, but single sign-off is relatively minor issue of little security risk. <br>Option D is incorrect, as it exaggerates basic OS and network capabilities into a \u201csupport\u201d that isn't really there. It also misinterprets managements' concern about security risk and addresses implementation risk instead.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      306,
      446,
      273,
      357,
      286
    ],
    "source": ""
  },
  {
    "id": 135,
    "question": "What's the most secure way to authenticate device identity prior to authorizing it to connect to the network?",
    "choice_a": "MAC address whitelisting",
    "choice_b": "Multifactor authentication that considers device identification, physical location, and other attributes",
    "choice_c": "Verifying that the device meets system policy constraints as to software and malware updates",
    "choice_d": "Devices don't authenticate, but the people using them do.",
    "correct_answer": "B",
    "explanation": "Option D is high risk, and therefore incorrect; plugging a device into an empty network connection should start a connection handshake that is an opportunity to block an unknown or unauthorized device from joining the network. <br>Options A and C are parts of how Option B performs such an authentication, and therefore B is the most correct answer and the most secure approach of the three.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      273,
      294,
      288,
      310,
      357
    ],
    "source": ""
  },
  {
    "id": 136,
    "question": "Which statement about federated access systems is most correct?",
    "choice_a": "SSO and federated access provide comparable capabilities and security.",
    "choice_b": "By making identity more portable, federated access allows multiple organizations to collaborate, but it does require greater attention to access control for each organization and its systems.",
    "choice_c": "Once you've established the proper trust architecture, federated access systems are simple to implement and keep secure.",
    "choice_d": "Most federated access systems need to use a digital identity platform or IDaaS to provide proper authentication.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; SSO is a subset of both the capabilities and security (issues and security solutions) that federated access can support. <br>Option C correctly raises the issue of the trust architecture, but going from there to a full federated access control system, and keeping that secure, can be challenging. Keeping it secure will always require monitoring, analysis, and testing. <br>Option D is incorrect; federated access, like SSO, can use any means of identity authentication that meets the organization's CIANA needs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      543,
      420,
      446,
      354,
      286
    ],
    "source": ""
  },
  {
    "id": 137,
    "question": "Which statement about extranets and trust architectures is most correct?",
    "choice_a": "Proper implementation of federated access provides safe and secure ways to bring an extranet into an organization's overall network system; thus, an internetwork trust architecture is not needed.",
    "choice_b": "Extranets present high-risk ways for those outside of an organization to collaborate with the organization and thus, need to be kept separate from the trust architecture used for other internetwork activities.",
    "choice_c": "Extranets provide extensions to an organization's intranet and thus, need to use the same trust architecture as implemented in the main organizational network.",
    "choice_d": "Trust architectures are the integrated set of capabilities, connections, systems, and devices that provide different organizations safe, contained, and secure ways to collaborate together by sharing networks, platforms, and data as required; thus, extranets are an example of a trust architecture.",
    "correct_answer": "D",
    "explanation": "Option A demonstrates misunderstanding of the concept of a trust architecture, which Option D clarifies. <br>Option B also misstates the purpose and intent of trust architectures and their role in reducing the risk of an unconstrained (or totally trusted) extranet. <br>Option C does not correctly state what an extranet is (it allows those external to the organization to share in using the sponsoring organization's internal systems and data); it also is mistaken in saying that the same systems, technologies, connections, etc., that are the internal trust architecture would therefore be appropriate to secure and protect the extranet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      328,
      420,
      353,
      333,
      327
    ],
    "source": ""
  },
  {
    "id": 138,
    "question": "What role should zero trust architectures play in your organization's information security strategy, plans, and programs?",
    "choice_a": "None just yet; this is a theoretical concept that is still being developed by the IETF and government-industry working groups.",
    "choice_b": "If you've done your threat modeling and vulnerability assessment correctly, you don't need the added complexity of a zero trust architecture.",
    "choice_c": "By guiding you to micro-segment your networks and systems into smaller, finer-grain zones of trust, you focus your attention on ensuring that any attempts to cross a connection between such zones has to meet proper authentication standards.",
    "choice_d": "Since the protocols you need to support zero trust do not work on IPv4, you need to wait to include zero trust architectures until you've transitioned your systems to IPv6.",
    "correct_answer": "C",
    "explanation": "Option A is false; zero trust architectures have been used since 2007, and many systems vendors are actively supporting them with additional protocols and capabilities. <br>Option B is only the first step in the process; risk mitigation is where implementation of network designs, including zero trust features, takes place. <br>Option D is false; as an architecture, first you plan how to segment, secure, and \u201cnever trust, always verify.\u201d Then you build that design, and existing IPv4 commodity products are more than adequate to support such architectures.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      317,
      446,
      420,
      439,
      328
    ],
    "source": ""
  },
  {
    "id": 139,
    "question": "Which statement about trust relationships and access control is most correct?",
    "choice_a": "One-way trust relationships provide the infrastructure for SSO architectures.",
    "choice_b": "Transitive trust relationships are similar to trust chains but for individual users rather than digital certificates.",
    "choice_c": "Trust relationships describe the way different organizations are willing to trust each other's domain of users when developing federated access arrangements.",
    "choice_d": "Transitive trust relationships cannot be supported by federated access technologies.",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; single sign on (SSO) provides sign-on capabilities for an organization's domain of users, while trust relationships refers to interorganizational trust of each other's users as domains or sets. <br>Option B is correct as far as it goes, but it does not relate this to access control; Option C does this correctly. <br>Option D is incorrect; federated access control deals with this in almost all cases.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      543,
      274,
      328,
      420,
      557
    ],
    "source": ""
  },
  {
    "id": 140,
    "question": "Which set of steps correctly shows the process of identity management? <br><ol><li>Proofing</li><li>Provisioning</li><li>Review</li><li>Revocation</li><li>Deletion</li></ol>",
    "choice_a": "1, 2, 3, 4, and then 5",
    "choice_b": "2, 3, 4",
    "choice_c": "1, 2, 4, 5",
    "choice_d": "2, 3, 5",
    "correct_answer": "B",
    "explanation": "Step 1, Proofing, is part of provisioning, and thus, Options A and C are incorrect. Step 5, Deletion, happens after revocation, but it is a cleanup of files, assets, and records, and it is more properly part of a records retention and housekeeping process. It is not part of identity management. Thus, Option D is incorrect. <br>Option B correctly reflects that we start by provisioning an identity, we continually review the privileges assigned to it versus the needs of the job and the organization, and then we revoke it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      542,
      16,
      446,
      273,
      368
    ],
    "source": ""
  },
  {
    "id": 141,
    "question": "Which statements about AAA in access control are correct? <ol type=\"A\"><li>Accounting provides the authorization to access resources as part of chargeback systems.</li><li>Analysis, auditing, and accounting are the services provided by an access control system\u2019s server.</li><li>Authorization checks to see if an identity has the right(s) to access a resource, while authentication validates that the identity is what it claims to be. Accounting tracks everything that is requested, approved, or denied.</li><li>Authentication checks to see if an identity has been granted access privileges, using the access control tables in the central repository; authorization validates the identity is allowed to access the system. Accounting keeps track of all requests, approvals, and denials.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Access control is not involved with resource chargeback, that is, billing; thus, Option A is not correct. <br>Option D has confused the roles of authorization and authentication, which Option C states correctly. <br>Option B is correct\u2014this is the \u201ctriple A\u201d of access control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      540,
      555,
      566,
      286
    ],
    "source": ""
  },
  {
    "id": 142,
    "question": "Which of the following are allowed under mandatory access control policies?",
    "choice_a": "Passing information about the object to another subject",
    "choice_b": "Changing or creating new security attributes for an object or another subject",
    "choice_c": "Granting privileges to another subject",
    "choice_d": "None of these are allowed under mandatory access control policies.",
    "correct_answer": "D",
    "explanation": "Each of the options (A, B, C) is allowing a subject to modify the security enforcements in the system, either for an object it has been granted access to or for some other part of the system. Mandatory access control does not permit this. Thus, Option D is correct.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      286,
      555,
      556,
      274,
      330
    ],
    "source": ""
  },
  {
    "id": 143,
    "question": "Which of the following statements are true about discretionary access control policies? <ol type=\"A\"><li>Subjects cannot be allowed to pass information about the object to another subject.</li><li>Changing or creating new security attributes for an object or another subject can only be done by the access control system.</li><li>Subjects can change rules pertaining to access control but only if this is uniformly permitted across the system for all subjects.</li><li>Subjects can be permitted to pass on or grant their own privileges to other subjects.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "C and D",
    "correct_answer": "D",
    "explanation": "Discretionary access control policies allow the systems administrators to grant capabilities (permissions) to subjects to modify aspects of access control restraints, but these must be uniformly defined for all subjects. Thus, Option C is correct, as is Option D. <br>Options A and B apply to mandatory or nondiscretionary access control policies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      540,
      710,
      326,
      551
    ],
    "source": ""
  },
  {
    "id": 144,
    "question": "Which form of access control depends on well-defined and up-to-date job descriptions?",
    "choice_a": "Role-based",
    "choice_b": "Subject-based",
    "choice_c": "Object-based",
    "choice_d": "Attribute-based",
    "correct_answer": "A",
    "explanation": "Option B looks at specific aspects of the subject, which might include duties and tasks in their job description, but Option A is more correct in that role-based access control can apply to subjects and objects both. <br>Option D can contain role-based criteria, but normally this looks at many more conditions and criteria. <br>Option C focuses more on the nature of the object\u2014which may be used by more than one role.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      539,
      550,
      540,
      555,
      556
    ],
    "source": ""
  },
  {
    "id": 145,
    "question": "Which form of access control is probably best for zero trust architectures to use?",
    "choice_a": "Role-based",
    "choice_b": "Subject-based",
    "choice_c": "Object-based",
    "choice_d": "Attribute-based",
    "correct_answer": "D",
    "explanation": "Option D, attribute-based, can use complex Boolean logic statements to conditionally evaluate almost any criteria, environmental or situational conditions, and so forth, to authorize an access request. Each of the others provides limited capabilities by comparison; zero trust typically requires the most rigorous access control possible.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      539,
      554,
      317,
      420
    ],
    "source": ""
  },
  {
    "id": 146,
    "question": "What kinds of privileges should not be part of what your mandatory access control policies can grant or deny to a requesting subject? <ol type=\"A\"><li>Any privilege relating to reading from, writing to, modifying, or deleting the object in question, if it was created or is owned by the requesting subject</li><li>Reading or writing/modifying the metadata associated with an object</li><li>Modifying access control system constraints, rules, or policies</li><li>Reading, writing, deleting, or asking the system to load the object as an executable task or thread and run it</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Be careful of the negative in the question! Mandatory access control policies do not allow subjects or objects to modify the security-related aspects of the systems, its subjects, and its objects; thus, granting the privileges in Option A or C cannot be allowed. <br>Options B and D reflect reasonable and prudent access control checks that all systems should perform before granting access.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      286,
      537,
      555,
      540,
      334
    ],
    "source": ""
  },
  {
    "id": 147,
    "question": "Which statements about a reference monitor in an identity management and access control system are correct?",
    "choice_a": "It should be tamper-resistant.",
    "choice_b": "Its design and implementation should be complex so as to defeat reverse engineering attacks.",
    "choice_c": "It's an abstract design concept, which is not actually built into real hardware, operating systems, or access control implementations.",
    "choice_d": "It is part of the secure kernel in the accounting server or services provided by strong access control systems.",
    "correct_answer": "A",
    "explanation": "The reference monitor is the functionality that checks every access attempt to see if it should be authorized or denied. As a result, Option D is false (accounting is a recordkeeping function, necessary to access control but done after the access request is granted or denied). <br>Option C is false, as the reference monitor is in fact implemented in operating systems (typically in their security kernel), or as part of a trusted computing base (TCB) module on a motherboard. <br>Option B is the reverse of what's required; we need to be able to inspect, analyze, and verify that the logic and code of the reference monitor does its job completely and correctly and that it does nothing else if we are to consider it highly trustworthy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      286,
      330,
      274,
      542,
      557
    ],
    "source": ""
  },
  {
    "id": 148,
    "question": "A key employee seems to have gone missing while on an overseas holiday trip. What would you recommend that management do immediately, with respect to identity management and access control, for your federated access systems? Choose the most appropriate statement.",
    "choice_a": "Deprovision the employee's identity.",
    "choice_b": "Suspend all access privileges for the employee's identity, except for email, in case the employee tries to use it to contact the company for help.",
    "choice_c": "Suspend all access privileges for the employee's identity, and notify all federated systems partners to ensure that they take similar steps.",
    "choice_d": "Suspend all access privileges for devices normally used by the employee, such as their laptop, phablet, or phone (employee-owned, company-provided, or both). If possible, quickly establish a captive portal or quarantine subnet to route access attempts from these devices to.",
    "correct_answer": "D",
    "explanation": "Option A unnecessarily removes the identity from your systems and those of other systems in your federated access system; this would not be called for until the fate of the employee is known to warrant a permanent removal of access privileges. <br>Options B and C still allow devices that the employee had been known to use to access your systems; if the employee, these devices, or both are in hostile hands, this places your systems at risk. <br>Option D is the most secure response.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      542,
      543,
      546,
      281,
      557
    ],
    "source": ""
  },
  {
    "id": 149,
    "question": "What is the role of third parties in identity management and access control? <ol type=\"A\"><li>Third parties are those who have access to your systems via federated access, and as such, are part of your trust architectures.</li><li>Credential service can be provided by third parties or by internal services as part of your systems.</li><li>Identity proofing can be provided by external third parties.</li><li>Identity as a service, usually via a cloud or Web-based service, is provided by numerous third parties.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, C and D",
    "correct_answer": "C",
    "explanation": "Option A confuses the roles of third-party service providers with those of organizations and individuals that collaborate with you via federated access and is not correct. The others are legitimate examples of third-party roles; note that Option D is still a relatively immature market, and if you're tempted to use IDaaS, choose your vendor with care!",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      349,
      279,
      543,
      353,
      562
    ],
    "source": ""
  },
  {
    "id": 150,
    "question": "Which statement about subjects and objects is not correct?",
    "choice_a": "Subjects are what users or processes require access to in order to accomplish their assigned duties.",
    "choice_b": "Objects can be people, information (stored in any fashion), devices, processes, or servers.",
    "choice_c": "Objects are the data that subjects want to access in order to read it, write to it, or otherwise use it.",
    "choice_d": "Subjects are people, devices, or processes.",
    "correct_answer": "A",
    "explanation": "Subjects, by definition, want to <italic>do something</italic> that involves an <italic>object</italic>. Thus, Option A has these roles reversed. Subjects can be any kind of entity that can take action. Objects contain information, but also can provide requested services (that is, take action upon request), so Options B and C are correct.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      555,
      540,
      557,
      556,
      542
    ],
    "source": ""
  },
  {
    "id": 151,
    "question": "John has talked with his IT director about getting an upgrade to their network access control tools that will allow them to implement remediation and quarantine measures. His director thinks this is unnecessary because their enterprise antimalware system provides for quarantine. Is John's director correct? Which of the following should John share with his director?",
    "choice_a": "No, because malware quarantine moves infected files into safe storage where they cannot be executed or copied by users; network access control quarantine prevents devices that are not up-to-date with software updates or other features from connecting to the Internet without performing required updates.",
    "choice_b": "Yes, because both kinds of technologies can support quarantine of suspect or questionable systems.",
    "choice_c": "No, because network access quarantine prevents HTTP or HTTPS connection attempts from systems that do not meet policy requirements by restricting them to webpages with update instructions; malware quarantine puts infected or suspected files out of reach of users to prevent inadvertent or deliberate execution or read attempts on them.",
    "choice_d": "Yes, because the antimalware system will prevent devices that are infected from accessing any systems resources, whether files, other CPUs, or other nodes on the network.",
    "correct_answer": "A",
    "explanation": "Option A correctly describes malware quarantine, and remediation by quarantine networks for systems not meeting requirements. <br>Option B is incorrect, since antimalware systems do not quarantine systems but only files they encounter during scanning. <br>Option C correctly describes captive portal quarantine by network access control systems, which differs from antimalware file-based quarantine. <br>Option D misstates the capabilities of antimalware systems (unless they fully incorporate access control and identity management functions, of course).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      181,
      178,
      182,
      189,
      200
    ],
    "source": ""
  },
  {
    "id": 152,
    "question": "Your IT director has asked you for a recommendation about which access control standard your team should be looking to implement. He's suggested either Diameter or XTACACS, as they used those in his last job. Which of the following gives you the best information to use in replying to your boss?",
    "choice_a": "The standard is IEEE 802.1X; Diameter and XTACACS are implementations of the standard.",
    "choice_b": "Diameter is an enhanced RADIUS and has been quite successful.",
    "choice_c": "XTACACS replaced TACACS+, which could be a good solution for you.",
    "choice_d": "RADIUS is the standard to work with.",
    "correct_answer": "A",
    "explanation": "Option B is partly correct, but Diameter never caught on in the market for a variety of reasons and is probably out of date by now. <br>Option C is also incorrect\u2014first came TACACS, which gave rise to both XTACACS, a proprietary product, and TACAC+, not the other way around. <br>Option D is incorrect, since systems may be de facto \u201cstandards\u201d (because a lot of companies use them), but they are not published standards by appropriate standards agencies.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      183,
      182,
      195,
      167,
      160
    ],
    "source": ""
  },
  {
    "id": 153,
    "question": "Why do we need IPSec?",
    "choice_a": "Now that IPv6 is here, we don't, since its built-in functions replace IPsec, which was for IPv4.",
    "choice_b": "Since more and more apps are moving to PKI for encryption of data on the move, we no longer need IPSec.",
    "choice_c": "IPSec provides key protocols and services that use encryption to provide confidentiality, authentication, integrity, and nonrepudiation at the packet level; without it, many of the Layer 2, 3, and 4 protocols are still unprotected from attack.",
    "choice_d": "Since IPv6 encrypts all traffic at all layers, once you've transitioned your systems to IPv6, you won't need IPSec, except for those legacy IPv4 systems you communicate with.",
    "correct_answer": "C",
    "explanation": "Option A is false; not only does IPv6 contain and support IPSec, it also makes it mandatory. <br>Option B is false; app-level encryption does not protect lower-layer traffic from being snooped or spoofed. Thus, Option C is correct. <br>Option D is false; IPv6 doesn't do this encryption, but it builds the features into the protocol stack so that user organizations can choose to implement it. IPv6 and IPv4 are not compatible, so a gateway of some kind will be required anyway, and the issue of security through the gateway will still need to be addressed.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      525,
      179,
      677,
      451,
      452
    ],
    "source": ""
  },
  {
    "id": 154,
    "question": "Cryptography protects the meaning or content of files and messages by means of all of the following except which?",
    "choice_a": "Obscuring meaning by misdirection, concealment, or deception",
    "choice_b": "Obscuring meaning by making it difficult or impossible for unauthorized users to access, view, copy, or change it",
    "choice_c": "Transforming the meaning and content of something into a unique value",
    "choice_d": "Digitally signing files and messages to authenticate senders",
    "correct_answer": "A",
    "explanation": "Options B, C, and D all are parts of what cryptography entails, and taken together sum it up. <br>Option A is more suggestive of camouflage, honeypots, or other efforts to draw attackers away from what you wish to defend and divert their energies elsewhere.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      103,
      128,
      106,
      102
    ],
    "source": ""
  },
  {
    "id": 155,
    "question": "Which of the following best describes symmetric encryption?",
    "choice_a": "Uses one key to encrypt blocks of text to be ciphered and another key to decrypt it back",
    "choice_b": "Uses the same key or a simple transform of it to encrypt plaintext into ciphertext, and to then decrypt the ciphertext back into plaintext",
    "choice_c": "Was used extensively in classical encryption but has since been superseded by much stronger asymmetric encryption",
    "choice_d": "Is best suited to plaintext that has a very high degree of regularity to its structure and content",
    "correct_answer": "B",
    "explanation": "Option A is an incomplete description of asymmetric encryption; Option C is false, since hybrid systems are in widespread use; and Option D is unrelated to symmetric or asymmetric encryption.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      128,
      107,
      116,
      103,
      129
    ],
    "source": ""
  },
  {
    "id": 156,
    "question": "Which statement about hashing is most correct?",
    "choice_a": "Hashing performs lossy compression on the input cleartext data file by representing the digest of its meaning in a much smaller number of bits.",
    "choice_b": "Hashing is almost exclusively used to produce indexes and pointers for database and file systems.",
    "choice_c": "Hashing is one-way cryptography in that you transform a meaningful plaintext into a meaningless but unique hash value but you cannot go from hash value back to the original meaning or plaintext.",
    "choice_d": "Hashing the contents of a file or a message is the first step in producing a private key.",
    "correct_answer": "C",
    "explanation": "Option A is false; this option confuses the message digest with the hash itself; a has value contains no meaning. <br>Option B is one use of hashing, but there are so many more, particularly in cryptographic systems like PKI and digital signatures. <br>Option D contains a misunderstanding of the digital signature process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      663,
      664,
      672,
      522,
      750
    ],
    "source": ""
  },
  {
    "id": 157,
    "question": "How would you use cryptographic techniques to protect the integrity of data in a file if you do not require its content to remain confidential? <ol type=\"A\"><li>Use pervasive encryption techniques to secure the file contents at rest, in motion, and in use.</li><li>Encrypt the file using the private key of the creator, and make sure all legitimate users can find the corresponding public key.</li><li>Digitally sign the file, as is done with software patch files, device driver executables, and so forth.</li><li>Use an encrypting hash to produce a message digest; even a single bit change in the file will cause a subsequent message digest to be different, indicating a loss of integrity.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "C and D",
    "correct_answer": "D",
    "explanation": "Options A and B both suggest encrypting the file in some way, which hides its meaning; Option B is a concept being explored by IBM and is not readily available anyway. <br>Options C and D would both accomplish this; Windows, Office, and many software systems use both techniques in their distribution and update processes.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      663,
      664,
      665,
      672,
      107
    ],
    "source": ""
  },
  {
    "id": 158,
    "question": "Properly used, cryptographic techniques improve all aspects of CIANA (confidentiality, integrity, availability, nonrepudiation, authentication) except which of the following?",
    "choice_a": "Confidentiality",
    "choice_b": "Authentication",
    "choice_c": "Nonrepudiation",
    "choice_d": "All aspects of CIANA can be enhanced via proper cryptographic techniques.",
    "correct_answer": "D",
    "explanation": "Using proper cryptographic techniques, all aspects of CIANA can be enhanced, even availability and integrity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      124,
      663,
      498,
      107
    ],
    "source": ""
  },
  {
    "id": 159,
    "question": "Nonrepudiation relies on cryptography to validate which of the following?",
    "choice_a": "The sender or author of a document or file is who the recipient thinks it is.",
    "choice_b": "The file or message has not been tampered with during transit or storage.",
    "choice_c": "The file or message has not been viewed by others or copied without the sender's and named recipient's knowledge.",
    "choice_d": "The certificate, public key, or both associated with the sender or author match what is associated with the file or message.",
    "correct_answer": "D",
    "explanation": "Although Option A is tempting, cryptographic processes cannot confirm that the certificate and key are correctly associated with a specific human or organization. The CA does that through other (noncryptographic) means and, as an anchor in the chain of trust, attests that this person and this certificate go together. Thus, Option D is correct. <br>Option B refers to integrity and Option C to confidentiality, which are not directly part of nonrepudiation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      522,
      672,
      124,
      104,
      498
    ],
    "source": ""
  },
  {
    "id": 160,
    "question": "How can cryptography provide confidentiality and integrity across both time and space? <ol type=\"A\"><li>By protecting data in transit (via Internet or other means), it protects data when en route between two or more physically separated points (in space).</li><li>Since much of the Internet is carried on long-haul backbone circuits that go via satellite, encryption is used to protect data while being transmitted via radio through space to and from the satellite and ground stations. Without encryption, anybody could receive these signals and break out the data being exchanged.</li><li>Despite traveling at the speed of light, Internet traffic takes time to go from one user's system to another (i.e. from a client to a server); thus, encryption protects the data in motion during this time.</li><li>Encrypting a file for storage ensures that it cannot be read or tampered with by unauthorized users or processes (which do not have the key); later, authorized users with the key can read the file.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Option B confuses where the signals go (through space) with the movement of the information from one user as an endpoint to another. Similarly, Option C misses the point about protecting data at rest, which is from when it is written to storage to some time later, in the future, when it is read back.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      666,
      668,
      667,
      107,
      104
    ],
    "source": ""
  },
  {
    "id": 161,
    "question": "Which statement best describes how digital signatures work?",
    "choice_a": "The sender hashes the message or file to produce a message digest and applies the chosen encryption algorithm and their private key to it. This is the signature. The recipient uses the sender's public key and applies the corresponding decryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "choice_b": "The sender hashes the message or file to produce a message digest and applies the chosen decryption algorithm and their public key to it. This is the signature. The recipient uses the sender's private key and applies the corresponding encryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "choice_c": "The sender hashes the message or file to produce a message digest and applies the chosen decryption algorithm and their private key to it. This is the signature. The recipient uses the sender's public key and applies the corresponding encryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "choice_d": "The sender encrypts the message or file with their private key and hashes the encrypted file to produce the signed message digest. This is the signature. The recipient uses the sender's public key and applies the corresponding decryption algorithm to the signature, which will produce a matching message digest only if the message or file is authentically from the sender.",
    "correct_answer": "C",
    "explanation": "The incorrect answers show misapplication of the steps of the process. <br>Option A has reversed who encrypts and who decrypts. <br>Option B confuses the use of the sender's public and private key, and if the recipient knows the sender's private key it must no longer be private! Option D won't work, because decrypting the unencrypted hash won't produce anything that is useful.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      498,
      500,
      672,
      673,
      124
    ],
    "source": ""
  },
  {
    "id": 162,
    "question": "What is the role of a hierarchy of trust in using digital signatures? Select the best answer.",
    "choice_a": "Digital signature processes work at the transport layer of TCP/IP, which is below where browser-supported hierarchies of trust function.",
    "choice_b": "The client's operating system, browsers, and applications either embed certificate authorities as trust anchors or use peer-to-peer trust anchors; the client's user must then trust these systems vendors and the installation of their products, and the client's user own use of them, to completely trust that received digitally signed files or messages are legitimate.",
    "choice_c": "The client's operating system, browsers, and applications either embed certificate authorities as trust anchors or use peer-to-peer trust anchors; the recipient of digitally signed files or messages from that client trusts that the client is properly configured and uses valid certificates, and thus, can trust the received content.",
    "choice_d": "Certificate authorities, working with government agencies, establish trust anchors on which digital signatures are based; this assures recipients that digitally signed content they receive is from authenticated senders.",
    "correct_answer": "B",
    "explanation": "Option A shows incomplete understanding of the digital signature process. <br>Option C confuses whether the sender or recipient needs to trust signed content and signatures. <br>Option D is incorrect, as it is missing the receiving client's need for installed, trustworthy operating systems, browsers, or other signature-handling applications; it also misstates the role of government in the CA process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      522,
      523,
      524,
      674
    ],
    "source": ""
  },
  {
    "id": 163,
    "question": "Which statements correctly describe the information security risks to most routine uses of email systems? <ol type=\"A\"><li>Almost all emails are sent unencrypted, with content, file attachment content, and address and routing information open to anyone who chooses to intercept it. This also means that content can be altered en route, and senders and recipients have no reasonable way to detect this.</li><li>No existing email systems have strong nonrepudiation capabilities, allowing senders to claim they never received emails or received ones with different content than what was sent.</li><li>Since most email server connections use HTTPS, only the routing information is exposed to potential disclosure via traffic analysis.</li><li>Most email systems provide ways of using encryption for message content, including attachments, or users can use peer-to-peer solutions like PGP, which will minimize the risk if used properly.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option C starts with an incorrect assumption, since many email systems use POP, IMAP, or other nonsecure connections. <br>Option D may be correct as far as it goes, but this represents a tiny fraction of the routine uses of email.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      116,
      122,
      147,
      128
    ],
    "source": ""
  },
  {
    "id": 164,
    "question": "What is required to make a one-time pad encryption system truly unbreakable?",
    "choice_a": "Use an obscure, published book, with a secret way of choosing the key from words, lines, or phrases in that book; this secret must be known only to sender and recipient. This simplifies the key distribution and management process.",
    "choice_b": "Generate the one-time pad key using a cryptographically strong pseudorandom number generator, with a very large random number as seed. Ensure that no portion of it is ever reused, and ensure that only one sender and one recipient have copies of it. Destroy sections of the pad as they are used. Protect the one-time pads at both sender and recipient from loss, theft, or compromise. Provide secure, immediate means to signal both parties of any loss or compromise or change in identity of sender or recipient.",
    "choice_c": "Generate the one-time pad key in a truly random fashion, ensure that no portion of it is ever reused, and ensure that only one sender and one recipient have copies of it. Destroy sections of the pad as they are used. Protect the one-time pads at both sender and recipient from loss, theft, or compromise. Provide secure, immediate means to signal both parties of any loss or compromise or change in identity of sender or recipient.",
    "choice_d": "Combine it with asymmetric encryption systems to create a hybrid architecture, using peer-to-peer certificate authority mechanisms that mask the real identity of the CA, sender, and recipient. This keeps the public keys very private (rather than published) for improved reliability.",
    "correct_answer": "C",
    "explanation": "Option A is one classical approach to using a one-time pad, but the key itself is the process for choosing key values out of the book, and that algorithm can easily be compromised, typically with lexical analysis. <br>Option B is incorrect, as Shannon's work shows one-time pad is unbreakable only if truly random numbers are used as a key. <br>Option D may be partially correct, but it does not address how the one-time pad itself is generated.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      500,
      498,
      104,
      103
    ],
    "source": ""
  },
  {
    "id": 165,
    "question": "How do webs of trust and hierarchies of trust differ? <ol type=\"A\"><li>Webs of trust are based on peer-to-peer architectures and as such are not very scalable to large numbers of users. Hierarchies of trust rely on certificate authorities as publishers of intermediate certificates, which supports much larger numbers of users.</li><li>Webs of trust work best when the peer trust anchors are incorporated into the IT logistics supply chain; hierarchies of trust do not need to have information embedded in vendor-provided product systems such as operating systems or browsers.</li><li>Webs of trust, as peer-to-peer architectures, are not part of the IT logistics supply chain; hierarchies of trust work best when CAs become part of the architecture of hardware, operating systems, browsers, and other applications.</li><li>They are actually common terms for the same set of architectures and implementations.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option B is incorrect, reversing which concept (webs or hierarchies) have their trust anchors as part of the supply chain. <br>Option D is incorrect, as the differences shown in Options A and C would indicate.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      522,
      524,
      672,
      673,
      674
    ],
    "source": ""
  },
  {
    "id": 166,
    "question": "What are information risks that cryptography cannot address? <ol type=\"A\"><li>Display of data to humans, or output of data as device commands in control systems, needs to be in an unencrypted form to be usable. </li><li>Even cryptographic support for nonrepudiation cannot prove that a recipient (authorized or not) actually read and understood or made use of the contents of a protected file or message; it can only prove that they accessed it.</li><li>Cryptography cannot be used to reduce risks to information availability.</li><li>Users with legitimate access to a variety of information at one level of classification, when decrypted for use, may be able to infer the existence or value of information at higher levels of classification.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and D",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option C is incorrect; by making significant contributions to access control, information integrity, and confidentiality, cryptography can reduce or eliminate many vulnerabilities that could lead to information or systems being unavailable when and where needed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      107,
      124,
      106,
      122
    ],
    "source": ""
  },
  {
    "id": 167,
    "question": "Which statements about the use of cryptography by private businesses are true?",
    "choice_a": "In most countries, public law and government policy severely restrict the use of cryptography by anyone but the government.",
    "choice_b": "Government policies and actions mean that most cryptographic systems available to business are easily broken when government needs to, for law enforcement or national security needs.",
    "choice_c": "In many jurisdictions, law and regulation place significant responsibilities for information protection and due diligence on businesses; these can only be met in practical ways by using cryptographic systems.",
    "choice_d": "Governments implement cryptographic module verifications programs, which assure businesses that systems they use that contain such modules will meet regulatory and legal constraints for privacy, data protection, and product safety.",
    "correct_answer": "C",
    "explanation": "Options A and B are high on the \u201cwish lists\u201d of many governments but are just not obtainable, nor would they make widespread e-commerce possible, as there would be no basis of trust for it. <br>Option D overstates the role of cryptographic module verification programs, since they validate only that the module does what it claims to and not whether it is suitable for any specific information security need.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      103,
      523,
      106,
      673,
      105
    ],
    "source": ""
  },
  {
    "id": 168,
    "question": "How would you compare the relative security of character, block, or stream ciphers against cryptanalytic attacks?",
    "choice_a": "They all depend on the security of the cryptographic key being used.",
    "choice_b": "Character ciphers are the least secure, and stream ciphers the most secure.",
    "choice_c": "Block ciphers support the best levels of security but with performance penalties that make stream ciphers suitable for some applications.",
    "choice_d": "They all have comparable levels of security and depend on algorithms, control parameters, keys, implementation, and use to deliver the required security.",
    "correct_answer": "C",
    "explanation": "Arguably, Option D as a blanket statement might be true, but in practice it's not true. Stream ciphers depend on the stream being shorter than the key (no repeat use of the key), which leads to implementations that are susceptible to algorithm attacks. <br>Option B is also false for this reason. <br>Option A is true but incomplete for the same reason.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      664,
      130,
      106,
      104
    ],
    "source": ""
  },
  {
    "id": 169,
    "question": "Why does cryptographic security tend to increase as the key size gets larger?",
    "choice_a": "No matter what kind of cryptanalytic attack, the larger the key, the larger the possible space of key values that an attacker must test; each additional binary bit doubles this search or testing time. Ultimately, this requires more computing power and storage than even the most well-funded governments can afford.",
    "choice_b": "This is a commonly held belief, but it's not actually true in most cases. Properly chosen algorithms and properly managed cryptosystems are proven to be unbreakable at current key sizes, and making the keys larger will only cause additional throughput delays.",
    "choice_c": "This is only a concern for block ciphers, since if the key size is too small, these ciphers are easily broken with rainbow table or dictionary attacks.",
    "choice_d": "Larger keys require more complex algorithms to execute without unacceptable runtime impacts, and this combines to provide even greater security.",
    "correct_answer": "A",
    "explanation": "Option B demonstrates complacency that's been disproven time and again; continued cryptanalysis suggests that even the largest keys in use today on RSA are not as secure as we think. <br>Option C is true but for character and stream ciphers as well. <br>Option D makes a mistaken assumption about requiring more complex algorithms.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      498,
      500,
      663,
      750
    ],
    "source": ""
  },
  {
    "id": 170,
    "question": "What are the most common attacks that business or commercial use of cryptography might be exposed to",
    "choice_a": "Invalid, expired, or fraudulent certificates accepted for use",
    "choice_b": "Optical, acoustic, or power line technical monitoring and analysis",
    "choice_c": "Social engineering",
    "choice_d": "Operational errors in use, such as incorrectly choosing control parameters or mismanaging keys or certificates",
    "correct_answer": "C",
    "explanation": "Although all are real threats, Option B is probably of lowest likelihood for most small and medium-sized businesses. <br>Options A and D are not technically attacks but vulnerabilities that user organizations inflict upon themselves.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      106,
      143,
      149,
      147,
      145
    ],
    "source": ""
  },
  {
    "id": 171,
    "question": "What is the most common source of exploitable vulnerabilities that business or commercial use of cryptography might present to attackers?",
    "choice_a": "Invalid, expired, or fraudulent certificates accepted for use",
    "choice_b": "Optical, acoustic, or power line technical monitoring and analysis",
    "choice_c": "IT supply chain compromises that allow corrupted cryptographic modules to be inserted into systems",
    "choice_d": "Operational errors in use, such as incorrectly choosing control parameters or mismanaging keys or certificates",
    "correct_answer": "D",
    "explanation": "Although all are real vulnerabilities, Option B typically arises only when disposing of equipment (or if physical security of equipment is lacking). <br>Option C can be an issue, especially for software-based cryptographic systems, if access control and configuration management allow unauthorized or uncontrolled software update and installation. <br>Option A is a subset of Option D.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      668,
      129,
      106,
      105
    ],
    "source": ""
  },
  {
    "id": 172,
    "question": "Should a hash function be reversible?",
    "choice_a": "No, because this would allow the plaintext to be decrypted from the hash, rendering message digests and digital signatures unworkable.",
    "choice_b": "Yes, because this would allow the hash to contribute to error detection and correction operations.",
    "choice_c": "In a limited way, they are reversible, because the hash acts as a pointer or key into database and file management systems where the plaintext comes from.",
    "choice_d": "No, because a hash is a many-to-one function and thus, must have a collision detection and avoidance mechanism as part of its implementation; being reversible would negate this.",
    "correct_answer": "A",
    "explanation": "Option B is incorrect; hash comparisons for purportedly the same text will reveal even a single bit difference in the inputs, which some error correcting and detecting codes cannot provide; reversible hashes do not improve on this. <br>Option C incorrectly states what \u201creversibility\u201d means for an algorithm. <br>Option D is incorrect, because hash functions must be one-to-one; any attempt at collision avoidance (many-to-one) would negate reversibility and uniqueness, which are the essence of what we need secure hash functions for.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      663,
      665,
      750,
      666,
      107
    ],
    "source": ""
  },
  {
    "id": 173,
    "question": "What conditions might cause you to stop using a key? <ol type=\"A\"><li>Notification that a key has been lost or compromised</li><li>Suspicion that a user of that key is not who or what they claim to be</li><li>Indications that your public key has been hijacked by someone masquerading as you</li><li>You've used it more than 2048 times.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option C misunderstands the use of a public key, which can only be used to authenticate your identity by decrypting something you've digitally signed with your corresponding private key. <br>Option D seems to confuse key length with usage: although having key change intervals is something that policy and systems choices should dictate, it's probably not a fixed (suspiciously binary) number like this.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      500,
      498,
      672,
      104,
      106
    ],
    "source": ""
  },
  {
    "id": 174,
    "question": "When choosing your countermeasures and tactics to protect hardware and systems software, you should start with which of the following?",
    "choice_a": "Published Current Vulnerabilities and Exposures (CVE) databases",
    "choice_b": "The information systems baseline that documents the systems your organization uses",
    "choice_c": "Your organization's business impact analysis",
    "choice_d": "Your organization's IT vulnerabilities assessment",
    "correct_answer": "D",
    "explanation": "Starting with Option A is a commonsense approach to quickly implementing some reasonable and prudent protection, but it lacks any judgment as to which vulnerabilities are important to your organization's risk management strategy and which are not. <br>Option B is the systems inventory, and you will need it, as it describes the as-built systems. <br>Option C is what drives Option D. Therefore, start shopping for countermeasures with Option D in hand.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      695,
      734,
      265,
      267,
      266
    ],
    "source": ""
  },
  {
    "id": 175,
    "question": "Does the SSCP have a role in IT supply chain security issues? (Select the most correct statement.)",
    "choice_a": "No, because this really is for the logistics, purchasing, or IT departments to focus on.",
    "choice_b": "No, because if supply chain security is a concern to the company, it needs to be addressed by senior directors via a strategic partnership or relationship with key vendors or suppliers.",
    "choice_c": "Yes, because the SSCP can and should advise on all potential security considerations affecting purchase, installation, use, maintenance, and disposal of IT equipment and systems.",
    "choice_d": "Yes, because most of the supply chain risks to IT stem from purchasing or leasing systems at lowest cost, typically from discounters who offer little product support.",
    "correct_answer": "C",
    "explanation": "Although Options A and B correctly indicate roles that others in the company fulfill in securing the IT supply chain, the SSCP does have the responsibility and opportunity to advise and assist. <br>Option D may be a factor, but it is not the sole factor in IT supply chain risk management.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      264,
      746,
      215,
      255,
      222
    ],
    "source": ""
  },
  {
    "id": 176,
    "question": "What kind of malware attacks can corrupt or infect device-level firmware? <ol type=\"A\"><li>SNMP-based attacks that can trigger the device to download and install a firmware update remotely</li><li>Remote or onsite device management (or mismanagement) attacks that allow a hacker to initiate a firmware update using a hacked firmware file</li><li>Phishing or misdirection attacks that fool operators or users into initiating an upload of a hacked firmware file</li><li>None, because firmware updates require operator intervention to download trusted updates and patch files from the manufacturer's or vendor's websites, and then initiate and monitor the update and restart of the device</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A is false\u2014SNMP by itself cannot trigger a device to download and install a firmware patch file. <br>Option D is false\u2014that operator action can be misdirected to use the wrong file as the update. <br>Option B may be true in some cases, if the device is set to allow remote management from other than a connected endpoint system such as a laptop or smartphone. <br>Option C happens a lot!",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      259,
      264,
      266,
      702,
      256
    ],
    "source": ""
  },
  {
    "id": 177,
    "question": "What is a zero day exploit?",
    "choice_a": "An exploit conducted against a vulnerability within the same day as it is reported",
    "choice_b": "An exploit that impacts a system immediately, rather than having a delayed effect like ransomware or scareware",
    "choice_c": "There are no real zero day exploits, but the mass media has exaggerated the dangers of unreported vulnerabilities.",
    "choice_d": "An exploit conducted against a newly discovered vulnerability before it becomes known to the cybersecurity community or the system's vendor or owners",
    "correct_answer": "D",
    "explanation": "While some zero day exploits have been discovered and exploited within the same day, typically after the release of a new software product to the market, most take the attackers understand a newly discovered vulnerability, design an exploit against it, and then find a suitable target. So Option A is not correct. <br>Option B incorrectly refers to exploits that leave behind payloads or features that will take action later. <br>Option C incorrectly associates the media reporting of cybersecurity, in general, with the time from discovery to exploitation of a vulnerability.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      267,
      260,
      259,
      201,
      223
    ],
    "source": ""
  },
  {
    "id": 178,
    "question": "The most important security vulnerability to your IT infrastructure's hardware elements would be which of the following?",
    "choice_a": "Being \u201corphaned\u201d when the manufacturer no longer provides technical support, spare parts, or firmware updates",
    "choice_b": "Electrical power fluctuations, air conditioning issues, or other workplace environmental issues",
    "choice_c": "Unauthorized devices or software installed during maintenance by an off-site maintenance vendor or computer store",
    "choice_d": "Theft, or being misplaced or lost",
    "correct_answer": "D",
    "explanation": "All of these are legitimate risks to worry about; some big box stores' computer repair services are known to do full scans and voluntarily report what they find to law enforcement, or possibly others, for example. <br>Option A happens frequently, but it's more of an impact to ongoing availability than it is an exploitable vulnerability. <br>Option B can cause equipment to fail or behave erratically. <br>Option D is far and away the most prevalent hardware-related cause of data loss, systems breach, or information security failures, of the items on this list.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      261,
      264,
      218,
      256,
      259
    ],
    "source": ""
  },
  {
    "id": 179,
    "question": "Trusted platform modules provide which of the following benefits to an organization's IT infrastructure?",
    "choice_a": "By means of hardware implementations of encryption, hashing and key generation, they greatly simplify the use of certificate authorities and PKI.",
    "choice_b": "As a trust root, a TPM can make hierarchies of trust more reliable.",
    "choice_c": "The TPM replaces the host system's random number generators and hash routines with its hardware-accelerated, more secure versions. This enhances system security as well as runtime performance.",
    "choice_d": "As a signed part of operating systems kernels, TPMs make it possible to validate software updates more reliably.",
    "correct_answer": "B",
    "explanation": "Since trusted platform modules (TPMs) are special, sealed hardware modules added to the motherboards of computers or phones by their manufacturers, Option D is incorrect, even though TPM device driver software must be incorporated into most OSs to enable their use. <br>Option A is incorrect; the TPM doesn't simplify this but allows for a more trustworthy hardware storage and management of certificates, digital signatures, and so forth. <br>Option C is not correct; these functions in the OS and host hardware remain, while all the TPM provides is its own implementations with which it secures keys, manages certificates, and hashes (preserves) machine identification information.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      218,
      215,
      268,
      239,
      261
    ],
    "source": ""
  },
  {
    "id": 180,
    "question": "Malware is best classified and understood by which of the following?",
    "choice_a": "The ways that it spreads from one system to another",
    "choice_b": "The capabilities it grants the exploiter, and the impacts it has on the target system",
    "choice_c": "Which of many strains of code, originally developed by national governments, it is descended from or modeled after",
    "choice_d": "Which operating systems, applications, or network systems it targets",
    "correct_answer": "B",
    "explanation": "Option A was originally used, differentiating between Trojan horses (or \u201cgiftware\u201d), worms, and viruses, for example; this has proved to be inadequate. <br>Option C has merit for signature analysis, either as patterns of behavior or patterns in the executable code and other files that are part of the malware. <br>Option D is of use when looking to specific systems and their vulnerabilities. <br>Option B combines purpose, intent, design, and effect and is arguably the more important characterization to use.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      267,
      265,
      262,
      272,
      225
    ],
    "source": ""
  },
  {
    "id": 181,
    "question": "How is malware detected when it has infected a target system? <ol type=\"A\"><li>Users notice abnormal behavior of their systems, ranging from sluggish response, to strange crashes, to unusual warning messages or pop-ups.</li><li>User files disappear, are corrupted, or become unusable, and then inexplicably they come back.</li><li>It's very difficult to detect without examining the executable code of systems kernel files.</li><li>Malware scanner programs look for signatures in program files that match known malware, or look for patterns of behavior that are suspicious.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Option B would be unusual for malware\u2014but it might signify anything from loose connections to storage devices through congestion on networks slowing down directory updates. <br>Option C is not correct; many behavioral effects are noticeable by the non-geeky user. <br>Option D is how malware detection systems actually work.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      701,
      269,
      272,
      266
    ],
    "source": ""
  },
  {
    "id": 182,
    "question": "Do firewalls play a role in countering or preventing a malware infestation from striking a system?",
    "choice_a": "Yes, because firewalls can be programmed to allow only known and approved files to be received by the systems on their network, thus, implementing software whitelisting as a form of protection.",
    "choice_b": "Yes, because firewalls can use sandboxes or quarantine areas to analyze suspected files to see if they match known malware signatures or show anomalous behavior that indicates the presence of malware.",
    "choice_c": "Yes, because firewalls can restrict or filter connections by outside devices to the network, and block connections to ports or the use of protocols or services that may be attempts to infiltrate your systems and possibly bring malware with them.",
    "choice_d": "No, because firewalls look only at network traffic and network protocols, and do not inspect the contents of files that might contain malware.",
    "correct_answer": "C",
    "explanation": "Options A and B misstate the role of application whitelisting or an antivirus program; firewalls do not do these functions. <br>Option C is what a network firewall does. <br>Option D describes what a network firewall does but misstates the firewall's role in malware defense.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      693,
      694,
      732,
      695
    ],
    "source": ""
  },
  {
    "id": 183,
    "question": "Which statements about host-based firewalls are correct?",
    "choice_a": "Host-based firewalls can be set to prevent applications programs from other systems from connecting to resources on the host computer, including preventing those applications from loading and executing on the host.",
    "choice_b": "Host-based firewalls can filter, restrict, or block connection attempts by programs running on the host computer to external networks.",
    "choice_c": "Host-based firewalls are very similar to antimalware systems in that they scan files or packets coming into and out of the host system for possible malware.",
    "choice_d": "Network-based firewalls offer greater protection against malware intrusions than host-based firewalls can.",
    "correct_answer": "B",
    "explanation": "Option A misses the \u201cdestination\u201d end of the connection attempt to the host: a program running on it. <br>Option C is incorrect; firewalls do not do this. <br>Option D is incorrect; although network-based firewalls may protect a lot of systems, they cannot control attempts by software on a host from exceeding prescribed limits of behavior.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 184,
    "question": "What information do you need to manage your IT infrastructure security activities? <ol type=\"A\"><li>Incident characterization and warning data, in real time</li><li>Status of planned systems upgrades and performance improvements</li><li>Traffic, systems utilization, and systems health and status information, updated in near real time</li><li>Status of open vulnerabilities, planned resolution efforts, and affected systems</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, C and D",
    "correct_answer": "D",
    "explanation": "Option B does not typically shed light on security-specific features, fixes, vendor-supplied updates, or patches. The other options go from real-time indications and warnings, to health and status monitoring in real or near-real time, to mitigation plans and status.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      265,
      245,
      246,
      231,
      264
    ],
    "source": ""
  },
  {
    "id": 185,
    "question": "Is secure browsing the same as private browsing? Why or why not? <ol type=\"A\"><li>They are different in that private browsing may not effectively mask your identity or the identity of your system but secure browsing can.</li><li>They started out being different but are rapidly converging to offer the same set of privacy and system protection features.</li><li>The only truly secure and private browsing is what you do on a sterile, sandbox system, with no PII or company data made available to the browser or sites you browse, and no files transferred from the sterile sandbox system into your protected systems.</li><li>No matter how secure your browser, it's your use of search engines that compromises your privacy.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "A and C",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Option B overstates how the line between private and secure browsing is blurring; the \u201cbrowser wars\u201d continue to hold security and privacy hostage to revenue generation based on users and their history being products. <br>Option D is only partly true, as it misses out browser telemetry, your own interaction with webpages, and other ways that browsers leak information about you and your system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      233,
      227,
      266,
      269,
      242
    ],
    "source": ""
  },
  {
    "id": 186,
    "question": "Malware can be introduced into your protected systems by all of these methods except:",
    "choice_a": "Using removable media such as thumb drives",
    "choice_b": "Connecting to a webpage containing malware embedded in its pages",
    "choice_c": "Opening data files on a webpage via your Web browser",
    "choice_d": "Watching a streaming video or listening to streaming music or audio files",
    "correct_answer": "D",
    "explanation": "In almost all cases, using a media player built into your browser will not allow malware to be stored on your computer. All of the rest are known vectors (paths) for malware infection.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      732,
      733,
      702,
      690,
      692
    ],
    "source": ""
  },
  {
    "id": 187,
    "question": "What are the limitations of mobile device management (MDM) when it comes to security needs? <ol type=\"A\"><li>MDM systems can handle company-owned devices well, but most cannot support the wide range of user preferences that bring-your-own situations can involve.</li><li>Most MDM systems can handle only market-leading mobile phones and laptops and cannot support wearable computing, smart watches, and so forth.</li><li>MDM systems, by themselves, cannot make up for shortcomings in organizational policies or plans for risk management.</li><li>MDM systems usually do not provide visibility or management control over mobile device software updates.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A may be confusing a \u201cblacklisting\u201d approach (thou shalt nots) for bring your own devices (BYOD) and mobile device management systems (MDMs), rather than a whitelisting (permitted activities); nonetheless, this is a major problem with mobile devices regardless of ownership. <br>Option D is one of the major problems MDMs are designed to help manage or solve, so this is false.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      705,
      707,
      695,
      266,
      265
    ],
    "source": ""
  },
  {
    "id": 188,
    "question": "Can encryption solve all of your endpoint security problems?",
    "choice_a": "No; by itself, this does not offer protection if the device is lost or stolen.",
    "choice_b": "No; many endpoints may still allow users to create covert paths that move information across security boundaries or aggregate information in ways they should not.",
    "choice_c": "Yes, provided the endpoint device has a TPM in it to implement PKI in reliable ways.",
    "choice_d": "Yes, if encryption fully protects both endpoint communications and data storage and use.",
    "correct_answer": "B",
    "explanation": "Option A requires other capabilities, such as mobile device management, to provide this protection. <br>Option C overlooks many complexities of using encryption on an endpoint device. <br>Option D seems tempting, but current practice does not provide seamless encryption-based protection of data in use, especially on most mobile / smartphone endpoints.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      269,
      266,
      227,
      217,
      259
    ],
    "source": ""
  },
  {
    "id": 189,
    "question": "How does bring your own infrastructure (BYOI) affect information security planning? <ol type=\"A\"><li>Since it's just a special case of bringing your own devices, it adds very little in the way of new concerns or issues.</li><li>By including mobile hotspots, cloud services, and other elements in the mobile device category, BYOI actually makes the security planner's job easier by transferring these concerns to the mobile system's users.</li><li>BYOI potentially opens the organization's infrastructure up to previously unknown connections with other people, organizations, and so forth; the potential for new and surprising risks is very great.</li><li>BYOI often uses consumer-grade services, particularly for cloud services, which are not compatible with typical enterprise systems.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "C and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Option A is false; BYOI brings the potential for dynamic subnets of people and organizations becoming part of your infrastructure, and for loosely coupled cloud storage and processing to impact your business logic's use of enterprise systems. <br>Option B is tempting but misleading, as most of your employees using BYOI capabilities do not have the capacity to solve the risks those capabilities can introduce.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      698,
      245,
      256
    ],
    "source": ""
  },
  {
    "id": 190,
    "question": "What do you have to do differently to protect virtual machines, as compared to protecting your physical hardware systems?",
    "choice_a": "Nothing; you'll still need to do everything you do to protect the operating systems, applications, data, and networks that your real machines use, for your virtual machines.",
    "choice_b": "Since virtual machines are more easily sandboxed, you can run on them unprotected, and not have the performance penalties associated with malware scanning or firewalls.",
    "choice_c": "Because it's so easy to create (and destroy) VMs, you may need policy and procedural controls over who can do this and what protections need to be in place.",
    "choice_d": "Because it's so easy to create (and destroy) VMs, you don't really need to worry about them. The protections in place on the rest of your systems will keep them isolated.",
    "correct_answer": "C",
    "explanation": "Option A is safe, but may overstate the need. <br>Option B may apply for VMs executing in a sandboxed or partially isolated way, but does not address VMs used for production systems. <br>Option D does not recognize that VM software\u2014the OS and applications\u2014can still become infected with malware, or that software-defined networks that support the VMs can still suffer intrusions if not adequately protected.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      696,
      265,
      266,
      259,
      227
    ],
    "source": ""
  },
  {
    "id": 191,
    "question": "Of the many things you could do to improve endpoint security, which would you recommend as most effective?",
    "choice_a": "Ensure that users promptly report missing, lost, or stolen endpoint hardware devices.",
    "choice_b": "Ensure that each endpoint has multiple, secure means to connect to your systems to enhance availability and productivity.",
    "choice_c": "Ensure that identity management and access control systems will not allow unauthorized users or processes access to system resources, regardless of what device they are from.",
    "choice_d": "Provide fully encrypted links for all data flows to and from endpoint devices.",
    "correct_answer": "C",
    "explanation": "Option A fails in practice, as lost or stolen devices may not be noticed as \u201cmissing\u201d right away. <br>Option B seems to subvert system security planning. <br>Option D does not address identity or access control.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      254,
      228,
      201,
      705,
      266
    ],
    "source": ""
  },
  {
    "id": 192,
    "question": "Which of the following statements about malware are not true? ",
    "choice_a": "Malware may corrupt your data and software, but it cannot damage your hardware.",
    "choice_b": "Most SOHO environments have very little to lose to a malware infection, so they are justified in not spending a lot of effort or money on defensive systems.",
    "choice_c": "If you operate your system within a hierarchy of trust, and you do not go beyond its boundaries, you do not need to do anything else to protect against malware.",
    "choice_d": "Doing all of your browsing in fully secure (HTTPS) sessions will prevent any malware from entering your system.",
    "correct_answer": "E",
    "explanation": "Option A ignores the many instances where malware has shut off safety features in computers or destroyed hard disk drives. <br>Option B ignores the losses a small business can suffer if even one employee's or customer's PII is compromised, or if critical data is lost. <br>Options C and D are strongly related to each other, but both ignore the many other pathways that malware can enter a system that don't involve a browser.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      704,
      702,
      733,
      692
    ],
    "source": "",
    "choice_e": "None of these statements are true."
  },
  {
    "id": 193,
    "question": "Which of the following statements about email and malware are correct? <ol type=\"A\"><li>For most enterprise systems, a separate server that scans all incoming email and attachments, before email is sent to its addressees, should be used.</li><li>As long as all of your email is digitally signed, such as with S/MIME, even the attachments will be free from malware.</li><li>Limiting the total size of an incoming email and all of its attachments is a practical way to prevent malware coming into your systems.</li><li>Email scanning for malware may be 100% effective at stopping malware from entering your systems directly, but it will not help with phishing, whaling, or other such attack vectors.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Option B confuses what signing an email does (it merely authenticates the sender's identity); it does nothing to ensure that the contents or attachments are safe. <br>Option C mistakenly assumes that malware must be large executable files, when a few hundred bytes may be all that is needed.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      250,
      690,
      229,
      702,
      733
    ],
    "source": ""
  },
  {
    "id": 194,
    "question": "Which statements best explains why applications programs have exploitable vulnerabilities in them?",
    "choice_a": "Commercial software companies rush their products to market and pay little attention to designing or testing for security.",
    "choice_b": "In-house developers often do not rigorously use design frameworks and coding standards that promote or enforce secure programming.",
    "choice_c": "End users write most of the real applications that businesses use, but without configuration management, they're impossible to update and keep secure.",
    "choice_d": "Most users do not keep their software updated, so they are missing out on security patches.",
    "correct_answer": "B",
    "explanation": "While many people feel that Option A is true, it's an overgeneralization; most commercial apps go through rigorous design and testing, and include information security requirements. <br>Option C exaggerates how much shadow IT exists, while ignoring the widespread use of platforms and services, productivity suites, etc. <br>Option D addresses why apps already installed still have known vulnerabilities in them, but it does not address how those vulnerabilities got there in the first place. <br>Option B is the number one reason we see the same kinds of errors, decade after decade, baked into new programs as they are written.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      266,
      702,
      732,
      223,
      213
    ],
    "source": ""
  },
  {
    "id": 195,
    "question": "Why is allowed listing a better approach to applications security than blocked listing? Choose the most correct statement.",
    "choice_a": "allowed listing depends on government-certified lists of trusted software providers, whereas blocked listing needs to recognize patterns of malicious code behavior, or malware signatures, to block the malware from being installed and executed.",
    "choice_b": "For most organizations, the list of applications they have chosen to trust is far smaller and easier to administer than huge lists of malware signatures and behavioral models.",
    "choice_c": "Administering a allowed listing system can require a lot of effort, but when an unknown program is trying to execute (or be installed), you know it is not yet trusted and can prevent harm.",
    "choice_d": "With blocked listing only, new malware may not be recognized as such before it installs, executes, and begins to harm your systems and information.",
    "correct_answer": "C",
    "explanation": "Option C is correct in terms of the major benefit of allowed listing; Option D, its logical opposite, addresses the zero day risks of blocked listing approaches without saying why any other approach (such as allowed listing) is better. <br>Option A is false on its face; no such program (thankfully!) exists to \u201ctrust-mark\u201d applications. However, digitally signed installation kits do give some assurance that the software came from the vendor you thought provided it. <br>Option B is true on its face but does not say why one approach provides better security than the other.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      265,
      221,
      268,
      259,
      202
    ],
    "source": ""
  },
  {
    "id": 196,
    "question": "What is the role of threat modeling when an organization is planning to migrate its business processes into a cloud-hosted environment? Choose the most correct statement.",
    "choice_a": "Private cloud deployments should see no change in threat modeling or threat surfaces.",
    "choice_b": "Migrating to the cloud may not change the logical relationship between information assets and subjects requesting to use them, or the way privileges are set based on roles, needs, and trust, but the connection path to them may change; this probably changes the threat surface.",
    "choice_c": "This really depends on the choice of IaaS, SaaS, or PaaS service models.",
    "choice_d": "Shared responsibility models will transfer much of the organization's needs for information security services to the cloud-hosting provider, and they will apply their standard threat models to the chosen service and deployment models",
    "correct_answer": "B",
    "explanation": "Option A is false; it effectively assumes that private clouds are as secure as private datacenters or LANs and desktops. <br>Option C is correct as far as it goes, since PaaS (for example) may provide platform-based controls while introducing additional boundaries (or threat surfaces). <br>Option D is false and misstates the shared responsibility concept. <br>Option B focuses on where to start thinking about the proposed migration and the role of threat modeling in planning for information security in the chosen cloud.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      697,
      201,
      222,
      268
    ],
    "source": ""
  },
  {
    "id": 197,
    "question": "\u201cMaintaining or improving information security while migrating to the clouds is more of a contractual than technical problem to solve.\u201d Which statement best shows why this is either true or false?",
    "choice_a": "It is false. The contractual side is similar to any other service provider relationship and is done once; the technical challenge of mastering a whole new set of features and capabilities is far larger and is always ongoing.",
    "choice_b": "It is true. Cloud service models are constantly changing, and this means that the contracts, terms of service, or service level agreements are continually being updated. The underlying software technologies, however, don't change as much or as frequently.",
    "choice_c": "It is false. The contractual agreements do change quite frequently as the underlying technologies, threats, and business case for both the cloud host and the customer change with time. These changes cause about equal amounts of work on both administrative and technical elements of the customer organization.",
    "choice_d": "It is false. The contractual agreements do change quite frequently as the underlying technologies, threats, and business case for both the cloud host and the customer change with time. However, even these changes cause less work, less frequently, for the administrative elements and more for the technical elements of the typical customer organization.",
    "correct_answer": "D",
    "explanation": "Option A is incorrect by oversimplifying the ongoing need to understand changing conditions and how these affect the business relationship between host and customer. <br>Option B is false; cloud systems technologies, whether Azure, Google Cloud, or Amazon Web Services, are updated virtually every week, with changes impacting customer-migrated systems utility and security. <br>Option C overemphasizes the administrative/contractual burden of change. <br>Option D better reflects the need to thoroughly understand both the contractual and the technical up front and how the effort spent on both will likely change over time.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      237,
      268,
      243,
      246,
      257
    ],
    "source": ""
  },
  {
    "id": 198,
    "question": "Fred is on the IT team migrating his company's business systems into a public cloud provider, which will host the company's processes and data on its datacenters in three different countries to provide load balancing, failover/restart, and backup and restore capabilities. Which statement or statements best addresses key legal and regulatory concerns about this plan? <ol type=\"A\"><li>Because Fred's company does not have a business office or presence in the countries where the cloud host's datacenters are, those countries do not have legal or regulatory jurisdiction over company data.</li><li>The countries where the cloud host's datacenters are located, plus all of the countries in which Fred's company has a business presence, office, or other facility, have jurisdiction over company data.</li><li>In addition to staying compliant with all of those different countries' laws and regulations, Fred's company must also ensure that it does not violate cultural, religious, or political taboos in any of those countries.</li><li>These jurisdictional arguments only apply to data stored on servers or systems within a given country, or that is being used in that country; nations do not control the movement of data across their borders.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A is false; the laws of the host nation apply to the cloud datacenter operator in that country, and that means they apply to all of the data and processing performed on that cloud datacenter. <br>Option D is false, as nearly all countries claim the right to control the import and export of information, particularly (as in Option C) where that information violates, attacks, or ridicules a strong cultural, religious, or political value in that country. <br>Options B and C are true.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      746,
      233,
      227,
      201,
      535
    ],
    "source": ""
  },
  {
    "id": 199,
    "question": "Many issues are involved when planning for a third party to perform services involving data storage, backup and restore, and destruction or processing services for your company. Which of the following statements is not correct with regard to such planning or to your actual conduct of operations with that third party? <ol type=\"A\"><li>Your data protection responsibilities remain with you; you need to be able to actively verify that such third parties are doing what you've contracted with them to do. Otherwise, you are blindly trusting them.</li><li>Your contracts with these third parties should use a shared responsibility model to clearly delineate which party has which responsibilities; this will, in most cases, hold you harmless when the third party goes outside of the contract</li><li>Since third parties are by definition on a contract with you, as your subcontractor, you are not liable or responsible for mistakes they make in performing their duties.</li><li>What your third party providers, subcontractors, or employees (for that matter) do in your name and in your service, you are ultimately responsible for.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option D most correctly states the bottom line to most organizations in terms of how stakeholders, investors, legal and regulatory authorities, customers, and others will judge responsibility when things go wrong. <br>Option A is a specific example; due care requires that you have the contractual, technical, and administrative ways to do such verifications, while due diligence requires that you actually <italic>do</italic> such verifications and hold the third party to task. <br>Option B can only set day-to-day expectations; when a major data breach happens, Option D suggests that even if the service provider failed to fulfill their contract, your stakeholders will still hold you responsible. <br>Option C is false.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      746,
      697,
      535,
      201,
      229
    ],
    "source": ""
  },
  {
    "id": 200,
    "question": "Which statements about the role(s) of archiving, backup, and restore in meeting information security needs are most correct? <ol type=\"A\"><li>These each contribute to availability in similar ways.</li><li>These each contribute to availability and nonrepudiation.</li><li>As part of an incident response or disaster recovery plan, prompt restore to a known good data configuration may prevent other data from being compromised or breached, thus, contributing to confidentiality.</li><li>These have no role to play in achieving authentication needs.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option D is incorrect. Authentication data, which defines user and process privileges, identity verification, and so forth, is as subject to being wiped out, corrupted, lost, or stolen as any other data on any information system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      201,
      231,
      252,
      228,
      229
    ],
    "source": ""
  },
  {
    "id": 201,
    "question": "How does securing a virtual machine differ from securing a physical computer system?",
    "choice_a": "The basic tasks of defining the needs, configuring system capabilities in support of those needs, and then operationally deploying the VM are conceptually the same as when deploying the same OS and apps on a desktop or laptop. You use many of the same tools, OS features, and utilities.",
    "choice_b": "VMs cannot run without some kind of software-defined network and a hypervisor, which bring many more complex security concerns that administrators need to deal with to achieve required information security performance.",
    "choice_c": "VMs can access any resource on the bare metal machine that is hosting them through the hypervisor, which requires administrators to take many extra precautions to prevent security breaches.",
    "choice_d": "The bare metal server, host OS (if used), and hypervisor provide none of the security features you'll need to configure to keep other system users, processes, and data, and those in each VM, safe, secure, and protected from each other.",
    "correct_answer": "A",
    "explanation": "Option B is partly correct but exaggerates the effort to set up an SDN or hypervisor. <br>Option C is false, as it requires explicit actions by administrators to allow access to other system resources, devices, and so forth. <br>Option D is also false, as the hardware, hypervisor, and host OS if used are where you start to define and configure VM images and the parameters that control their being dispatched to run and then retired.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      696,
      254,
      231,
      227,
      266
    ],
    "source": ""
  },
  {
    "id": 202,
    "question": "Why is endpoint security so important to an organization?",
    "choice_a": "Users, who interact with organizational IT infrastructures and information at the endpoints, are notoriously difficult to control; if we can better control and secure the endpoints themselves, then we can prevent most end user\u2013introduced security problems.",
    "choice_b": "Endpoints are where information turns into action, and that action produces value; on the way into the system, it is where action produces valuable information. This is where business actually gets done and work accomplished. Without the endpoints, the system is meaningless.",
    "choice_c": "Endpoints are what most users and customers see, and if endpoints are not secure, users and customers will not engage with our security programs and help us keep the system safe.",
    "choice_d": "While endpoints are where many users do information work, organizational managers and leaders draw their decision support at the systems level, and not from an endpoint device such as a smartphone. Data quality and software quality processes need to ensure that once data enters the system from an endpoint, it is then protected to meet CIANA+PS needs throughout its life.",
    "correct_answer": "B",
    "explanation": "Option A is true insofar as it describes a common malware vector, but it misses the key point. <br>Option C may be true in a very limited sense (police call this the \u201cbroken window\u201d theory of urban crime control), but it misunderstands the role of the endpoints in an IT system. <br>Option D is false; all output that humans can use is done at an endpoint, be that a laptop, a phone, an annunciator, a process control status board, or even a printer. <br>Option B correctly captures the value proposition of information work and the high-leverage role of action that happens at endpoints.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      697,
      245,
      266,
      228,
      217
    ],
    "source": ""
  },
  {
    "id": 203,
    "question": "Jayne's company is considering the use of IoT devices as part of its buildings, grounds, and facilities maintenance tasks. Which statements give Jayne sound advice to consider for this project?",
    "choice_a": "Since IoT devices can easily be configured, updated, or patched, they are just as capable of being secure as are laptops, desktops, or smartphones.",
    "choice_b": "Functions that change frequently are well suited to IoT devices.",
    "choice_c": "Typical IoT devices are best suited to use where security or human safety are a primary concern.",
    "choice_d": "It may be better to consider industrial process control modules, rather than IoT devices, to interact with machinery, such as pumps and landscaping equipment.",
    "correct_answer": "D",
    "explanation": "Currently, most Internet of Things (IoT) devices are limited to performing only a few related functions; it is also as difficult if not impossible to configure their access control or other security features (if they have any), or update or patch their onboard firmware. This means that Options A and B are probably not correct. <br>Option C is also doubtful for this same reason\u2014would Jayne's bosses want her to specify a human safety function be managed by an IoT device that anyone could hack into and subvert? Option D provides a sound alternative; the process control marketplace has many solutions available, all highly modularized.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      234,
      254,
      266,
      231,
      211
    ],
    "source": ""
  },
  {
    "id": 204,
    "question": "Which statements about continuity and resilience are correct? <ol type=\"A\"><li>Continuity measures a system's ability to deal with events the designers didn't anticipate.</li><li>Continuity and resilience are basically the same idea, since they both deal with how systems handle errors, component or subsystem failures, or abnormal operational commands from users or other system elements.</li><li>Resilience measures a system's ability to tolerate events or conditions not anticipated by the designers.</li><li>Continuity measures a system's ability to deal with out-of-limits conditions, component or subsystems failures, or abnormal operating commands from users or other system elements, by means of designed-in redundancy, load shedding, or other strategies.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "C and D",
    "correct_answer": "D",
    "explanation": "Continuity is about planning for alternative modes of action\u2014having a stack of \u201cjust in case\u201d options already laid out in plans, procedures, software, or other IT elements. Thus, Option D is correct and Option A is false. Resilience is the ability to bend, adapt, tolerate, or even ignore unanticipated disruptions, without completely breaking down. Thus, Option B is incorrect, and Option C is correct.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      231,
      234,
      265,
      266,
      201
    ],
    "source": ""
  },
  {
    "id": 205,
    "question": "In which phase or phases of a typical data exfiltration attack would a hacker be making use of phishing? <ol type=\"A\"><li>Reconnaissance and characterization</li><li>Data gathering, clumping, masking, and aggregating</li><li>Installing and using covert command and control capabilities</li><li>Initial access</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Phishing and many other social engineering tactics have played a major role in over 60 percent of major data breaches in the past few years. Such tactics have high payoff to the attacker during their search for a possible target, gathering information about its systems and security, and then their initial entry into the target's systems. Thus, Options A and D are correct. <br>Options B and C are almost exclusively done surreptitiously, exploiting information that social engineering may have revealed to the attacker; few if any signs of phishing in these activities have been noted.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      259,
      201,
      222,
      267,
      214
    ],
    "source": ""
  },
  {
    "id": 206,
    "question": "What are some effective, practical strategies to detect data exfiltration attacks? <ol type=\"A\"><li>Analyze of access control and resource usage log data to alert when abnormal patterns of behavior are noted.</li><li>Alert when failed attempts to access a resource (whether it is protected by encryption or not) exceed a specified limit.</li><li>Use digital rights management in addition to other identity management and access control capabilities.</li><li>Set filters and rules on network traffic, inspecting suspicious packets, streams, or addresses to check for data being exfiltrated.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option C makes it harder for an unauthorized user to use a resource, whether it's in its original form or it's been copied and exfiltrated; this does not help detect an ongoing attack beyond what proper access control should do. <br>Option D is easily thwarted by attackers when they restructure, clump, aggregate, encrypt, or disguise the data; the rules and filters don't know what to look for as a result. <br>Option A can reveal an attack in the early stages, but it is analysis intensive. <br>Option B might usefully warn of attacks against data that is encrypted at rest but for which access control is not sensing a violation of privilege.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      272,
      263,
      231,
      201,
      254
    ],
    "source": ""
  },
  {
    "id": 207,
    "question": "Which statement about privacy and data protection is most correct?",
    "choice_a": "International standards and agreements specify that personally identifiable information (PII) and information about an individual's healthcare, education, and work or credit history must be protected from unauthorized use or disclosure.",
    "choice_b": "Some countries, or regions like the EU, have laws and regulations that specify how personally identifiable information (PII) and information about an individual's healthcare, education, and work or credit history must be protected from unauthorized use or disclosure. Other countries do not. It's up to the organization that gathers, produces, uses, or disposes of such private data to determine what protection, if any, is needed.",
    "choice_c": "Storing backup or archive copies of privacy-related information in a datacenter in another country, without doing any processing there, does not subject you to that country's data protection laws.",
    "choice_d": "Sometimes, it seems cheaper to run the risk of fines or loss of business from a data breach involving privacy-related data than to implement proper data protection to prevent such a loss. Although this might make financial sense, it is not legal or ethical to do so.",
    "correct_answer": "D",
    "explanation": "Option A is false; no such agreements apply worldwide. At best, regulations like the General Data Protection Regulation (GDPR) apply to EU member states. <br>Option B is true as far as it goes, but with a catch: if the organization guesses wrong, it could end up in serious legal trouble in multiple jurisdictions. <br>Option C is false; storage of data in a center in another country must involve movement of data from your jurisdiction into the one the datacenter is in and movement in the reverse direction when you need to use the backup. In almost all cases, data protection laws and regulations apply to data in use, at rest, and in motion.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      746,
      233,
      227,
      252,
      268
    ],
    "source": ""
  },
  {
    "id": 208,
    "question": "The \u201cgarbage-in, garbage-out\u201d (GIGO) problem means:",
    "choice_a": "Noise on power supplies or signal cables can corrupt data in motion, which if processed can result in abnormal or incorrect \u201cgarbage\u201d results.",
    "choice_b": "Most information processes involve a set of related data items that represent or model a real person, activity, or part of the world. When that set of data is mutually inconsistent, or inconsistent with other data on hand about that real entity, each field may be within range but the overall meaning of the data set is corrupt. This \u201cgarbage,\u201d when processed (as input) by apps, produces equally meaningless but valid-looking outputs.",
    "choice_c": "Organizations that just throw away damaged storage devices; printed copies of their data, application source code, design notes; and so forth are putting this \u201cgarbage\u201d right where a \u201cdumpster diver\u201d hacker attack can collect it, examine it, and possibly find exploitable vulnerabilities.",
    "choice_d": "Data input attacks can cause some applications to abort or execute abnormally, sometimes in ways that allow the garbage data that was input to be executed as if it is command strings or machine language instructions.",
    "correct_answer": "B",
    "explanation": "Option A is a real risk but not what GIGO is about. <br>Option C may involve throwing things in the \u201cgarbage\u201d that should have been destroyed or zeroized first, but it's also incorrect. <br>Option D is a very common attack attempt against many apps, but it usually does not lead to the application producing what looks like correctly formed outputs with distorted meanings. GIGO processing, as in Option B, can result in incorrect transactions being posted to an account, such as when a patient billing record has too many copies of the same lab procedure billed incorrectly to it.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      695,
      694,
      266,
      201,
      227
    ],
    "source": ""
  },
  {
    "id": 209,
    "question": "Which of the following might be serious example(s) of \u201cshadow IT\u201d contributing to an information security problem? <ol type=\"A\"><li>One user defines a format or style sheet for specific types of documents that other users will create and manage.</li><li>An end user writes special-purpose database queries and reports used to forecast sales and project production and inventory needs, which are reviewed and used at weekly division meetings.</li><li>Several users build scripts, flows, and other processing logic to implement a customer service help desk/trouble ticket system, using its own database on a shared use/collaboration platform that the company uses.</li><li>Users post documents, spreadsheets, and many other types of information on a company-provided shared storage system, making the information more freely available throughout the company.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "C and D",
    "correct_answer": "D",
    "explanation": "The key determiner of whether user-defined and user-maintained \u201cstuff\u201d is shadow IT is the amount of business logic that it embeds or implements; the more such business logic is built into uncontrolled or unmanaged apps or tools, the greater the risk of something going wrong in undetected ways. Thus, Option A is not a probable risk; Option B seems to have a lot of frequent, intensive review of the results of these queries, which would need to correlate or compare with what the production information systems would show. <br>Option C implements customer relationship management and systems/product maintenance business logic; Option D seems to circumvent information classification, segregation of duties, and other access control principles. Both Options C and D bear close watching.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      217,
      231,
      266,
      227,
      228
    ],
    "source": ""
  },
  {
    "id": 210,
    "question": "Sandi has suggested to her boss that their small company should be using a cloud-based shared storage service, such as OneDrive, Dropbox, or Google Drive. Her boss believes these are inherently insecure. Which of the following statements would not help Sandi make her case?",
    "choice_a": "Check the reputation and business model of the shared storage providers; check what national/legal jurisdiction they operate in, compared to the one her business operates in.",
    "choice_b": "Examine their stated, posted privacy and security policies; ask for a sample contract, terms of reference, or service level agreement, and see if they claim to provide what her company needs.",
    "choice_c": "Sandi can always encrypt her files before moving them into storage; that way, even if another user, a hacker, or the provider themselves try to read the file, they can't.",
    "choice_d": "Sandi can take advantage of a free trial offer and see if her information security staff can hack into other users' storage or into system logs and account information on the provider. If her \u201cwhite hats\u201d can't break in and peek, the system is safe enough for her.",
    "correct_answer": "D",
    "explanation": "Option D is probably illegal in most of the jurisdictions in question; even where it is not, it is certainly unethical to attempt to evaluate a storage provider's security by trying to hack into other customers' data without their express written consent and the consent of the provider. The rest are reasonable and prudent parts of due care and due diligence checks on a candidate third-party provider of this type.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      746,
      257,
      223,
      218,
      233
    ],
    "source": ""
  },
  {
    "id": 211,
    "question": "Your boss tells you that securing the endpoints should consider all of the measures you would use to secure the information infrastructures themselves. Is she correct? Which statement best confirms or refutes her statement?",
    "choice_a": "False. Many of the things we do to secure operating systems and networks, for example, just don't apply to an endpoint device, the apps on it, and the user's interactions with it.",
    "choice_b": "True. After all, each endpoint is (by definition) embedded in or part of one or more threat surfaces; from there, the same threat modeling and assessment processes will lead us through the same risk management and mitigation processes, with choices tailored as needed.",
    "choice_c": "True. All of the same risk management, vulnerability assessment, risk mitigation, and operational risk management processes apply to each node of our system and to the system as a whole, tailored to the specific risks, vulnerabilities, technologies, and operational needs.",
    "choice_d": "False. What happens at the endpoints is a special case of information security and needs special attention that is very different than how we assess risk to servers, networks, or applications platforms.",
    "correct_answer": "B",
    "explanation": "Option A glosses over the growing \u201cBYOx,\u201d where x can be infrastructure, device, or most any service; you might argue that Option A also ignores the blurring of the boundary between an endpoint and the information system itself. <br>Option B reminds us to do integrated, coherent threat modeling and analysis across our total systems environment. <br>Option C just echoes what the boss said, although it does add a minor bit about tailoring; overall, it doesn't contribute much to the conversation with the boss. <br>Option D offers no support for this rather unusual viewpoint.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      231,
      201,
      266,
      237,
      257
    ],
    "source": ""
  },
  {
    "id": 212,
    "question": "What steps can you take to limit or prevent attacks on your systems that attempt to spoof, corrupt, or tamper with data? <ol type=\"A\"><li>Ensure that firewalls, routers, and other network infrastructures filter for and block attempts to access network storage without authorization.</li><li>Develop and use an organizational data model and data dictionary that contain all data-focused business logic; use them to build and validate business processes and the apps that support them.</li><li>Implement data quality processes that ensure all data is fit for all purposes, in accordance with approved business logic.</li><li>Implement information classification, and use access control and identity management to enforce it.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "C",
    "explanation": "Option A by itself won't do what is needed; at a minimum, Option D and its implementation of rigorous access control and identity management is necessary to protect network storage resources from being corrupted, tampered with, and so on. The others are all valuable parts of a data governance and data security/data protection plan.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      254,
      228,
      249,
      231,
      201
    ],
    "source": ""
  },
  {
    "id": 213,
    "question": "Your coworkers don't agree with you when you say that data quality is a fundamental part of information security. Which of the following lines of argument are true in the context of your discussion with them? <ol type=\"A\"><li>If our business logic doesn't establish the data quality rules and constraints, we have no idea if an input or a whole set of inputs makes valid business sense or is a spoof attack trying to subvert our systems.</li><li>Since we don't have a data quality program now, if we get served with a digital discovery order, who knows whether the data we surrender to the authorities is correct and complete? The attorneys might care, but that really has no effect on us.</li><li>We have users who complain that when they try to test and evaluate backup data sets, the backup data makes no sense. If a real disruption or disaster strikes, and our backups don't make any business sense, we could be out of business pretty quickly.</li><li>We mitigate information risk to achieve the CIANA+PS needs that the business impact analysis and the risk management plan called for; since those high-level plans didn't conclude that we need a data quality program, then we probably don't.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option B is scary; it seems to assume that we can drown in data the government inspectors, auditors, or the attorneys who are suing us, and they'll never figure out it is meaningless. Very risky business! Option D suggests that perhaps senior leadership just did not realize the potential impacts that bad data (or a lack of data quality) can have on maintaining confidentiality, integrity, availability, nonrepudiation, and authentication of all information-based business processes. <br>Options A and C are real risks that many organizations face each day.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      201,
      229,
      231,
      252,
      746
    ],
    "source": ""
  },
  {
    "id": 214,
    "question": "You're part of the CSIRT for your organization; during an incident, you take a call from a rather upset production manager who demands you put their systems back online right away. You explain that the team hasn't finished containment activities yet. He insists that their systems were working fine until you pulled the connections to everything and that production activities could continue while you're doing that. Which statement or statements would best support you in your reply? <ol type=\"A\"><li>We could assume that your systems were not contaminated by the attack, and let you run on them. We'd take them down and inspect them later, when you're not using them.</li><li>We cannot run the risk that whatever caused the attack isn't dormant in your systems and that it wouldn't spread to our other systems or back out onto the Internet if we did that.</li><li>We have to comply with our policies that tell us how to handle incidents like this, and so, we can't do that.</li><li>Yours are not the only systems affected by this attack; we've had to shut down most of our IT operations to make sure that our critical data and systems are protected.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; this is a very high-risk strategy, as it allows the attacker to roam freely around some of your systems for an indeterminate period of time. Although Option C is probably true, it won't help defuse the production manager's frustration very much. <br>Options B and D clearly explain the risk and put it in the context of impacts across the organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      72,
      77,
      83,
      69,
      101
    ],
    "source": ""
  },
  {
    "id": 215,
    "question": "You're the only IT person at a small tool and die machine shop, which uses a LAN and cloud-hosted platforms to run the business on. Your boss is not worried about the business being the target of a cyberattack and doesn't want you to spend time preparing the company to respond to such an incident. What would you advise your boss to consider? <ol type=\"A\"><li>Since we don't handle consumer-level payment cards, and we don't have any proprietary information, we probably don't have to worry about being a target.</li><li>We do share an extranet connection with key customers and suppliers, and an attack on our systems could lead to an attack on theirs; whether we'd be liable for the damages or not, it could cost us our relationships with those companies.</li><li>Our cloud systems hosting company provides most of our security, and as long as we keep our systems on the factory floor and the workstations our staff use properly updated, we should be okay.</li><li>Since we've not really done even a basic vulnerabilities assessment, we don't know what risks we could be facing. Let's do that much at least, and let that tell us what the next step should be. Soon.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Although Option A may be true, it is naive and incorrect; the air conditioning company that serviced Target stores didn't handle retail (credit card) sales either, yet attackers found it to be an ideal entry into Target's payment processing systems. <br>Option C is also incorrect; your cloud hosts will protect their systems, and their platforms, from malware attacks from your connections, but attackers who spoof bogus, privileged accounts into your systems can still destroy your business's presence in those cloud systems. <br>Option B points out a real business risks; Option D offers the boss a sensible first step.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      72,
      75,
      73,
      77,
      83
    ],
    "source": ""
  },
  {
    "id": 216,
    "question": "As an SSCP, you're a CERT team member at your company. At a team meeting, some of the team members seem confused as to whether they have a role in disaster recovery or business continuity. How would you answer their question? <ol type=\"A\"><li>Since even a disaster starts with an incident, and we're the first responders, we quickly have to figure out how disruptive the incident could be; the more disruptive, the greater the impact on our ability to keep doing business. We don't execute those other plans, but we do have to call our bosses and let them know what we think. They decide whether to activate those other plans.</li><li>Since all incidents have the potential for disrupting business operations, the BCP should cover everything and provide us the framework and scope to respond within. It also covers the DRP.</li><li>Those other plans focus primarily on people issues, facilities, and cash flow kinds of problems, and those don't concern the CERT.</li><li>Those other plans mostly handle legal, regulatory, and shareholder notification requirements, so we're not involved with those.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option D is false; the business continuity plan (BCP) and disaster recovery plan (DRP) should start with the broad strategic goals and flow them down into all activities necessary to keep the business operating, and to help it recover from a major disruption, respectively; this certainly includes the actions of the computer emergency response team (CERT) and the systems they support. <br>Option C is true as far as it goes, but since all of those depend on continued use of business processes, which depend on the IT systems, the CERT plays a pivotal support role to those plans and the people who execute them. <br>Options B and A are correct.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      648,
      101,
      71,
      69
    ],
    "source": ""
  },
  {
    "id": 217,
    "question": "What role, if any, does an incident response team play in supporting any subsequent forensics investigation? <ol type=\"A\"><li>None. The investigators have their own procedures to follow, and it's best if the incident response team just cooperate but stay out of their way.</li><li>Since any information security incident might lead to a follow-on forensics investigation, the team needs to make sure that any of the data they collect, or systems they restore or rebuild, are first preserved and cataloged to meet chain-of-custody requirements as evidence. Thus, the responders also need to be trained and certified as investigators.</li><li>As the first responders, the team should take steps to control the scene of the incident, and keep good logs or records of the state of systems and information throughout their response activities. These records need to be retained in case there is a later investigation.</li><li>Management needs to make sure that the procedures used by the response team will preserve the incident scene and information gathered during the incident response in ways that will meet rules of evidence; if that cannot be done without interfering with prompt incident response and recovery, management has to take responsibility for that risk.</li></ol>",
    "choice_a": "A",
    "choice_b": "B and C",
    "choice_c": "B, C and D",
    "choice_d": "C and D",
    "correct_answer": "C",
    "explanation": "Option A is incorrect. Note that the question asks regarding a subsequent investigation; the team has to act in ways that don't make such an investigation pointless by destroying the evidence the forensics investigation may need. Thus, Options B, C, and D spell out what the responders should be mindful of and take due care to do, while management has the responsibility to strike the balance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      711,
      84,
      71,
      101
    ],
    "source": ""
  },
  {
    "id": 218,
    "question": "Which of the following sets of information would not be useful to a CSIRT during an incident response? <ol type=\"A\"><li>Contracts with service providers, systems vendors, or suppliers</li><li>Information systems baseline information</li><li>Information technology baseline information</li><li>IT hardware maintenance manuals</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Option A is not normally useful; what the computer security incident response team (CSIRT) does need at their fingertips is the emergency contact information for technical support, or information security incident coordination, with such organizations. <br>Option D is also not normally useful, because the CSIRT will more than likely work at the systems and networks level (data, control, and management planes), and if a hardware unit is not responding properly, they'll just isolate it, flag it for later maintenance, and move on. <br>Option B captures business logic and translates it into major information flows or processes, akin to Layer 7 (Applications) in the OSI model. <br>Option C is vital to problem analysis and correction.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      91,
      73,
      99,
      87,
      69
    ],
    "source": ""
  },
  {
    "id": 219,
    "question": "Which of the following information about networks and infrastructures should be readily available for information systems security incident responders to consult during an incident response? <ol type=\"A\"><li>Networks and systems designs showing data, control, and management planes</li><li>OSI reference model design descriptions of networks, systems, and platforms</li><li>Organization charts and staff directories, including contact information</li><li>Systems requirements documentation</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option D would not normally be useful during incident response, as the responders are dealing with abnormal behavior of as-built systems; the requirements that drove the design of these systems usually aren't helpful at that point. <br>Option C is also not correct; what the team needs is more of a focused directory of key users and managers for different applications platforms or systems. <br>Options A and B may prove valuable as the team tries to identify, characterize, and then deal with an attack or abnormal behavior. These both can guide choices about containment, eradication, and restoration tactics and priorities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      73,
      69,
      99,
      93,
      76
    ],
    "source": ""
  },
  {
    "id": 220,
    "question": "The CSIRT team members are discussing incident detection. They seem convinced that it's almost impossible to detect an information security incident until it's already started to disrupt business operations. They're trying to find actions they can take now to help deal with this. They ask your opinion. Which of the following statements would you not use as you reply? <ol type=\"A\"><li>Most incident precursors are so general that they provide broad warning, but nothing specific you can act on.</li><li>We miss the most important incident precursors because we've set our IDS alarm thresholds too low.</li><li>Many indicators of a possible attack can also be indicators of routine and legitimate business activities or network traffic; since we cannot investigate them all, we just have to hope that the first damage an attack causes is small enough not to hurt badly, but visible enough that we'll see it in time to react.</li><li>Actually, this is because we've designed our networks wrong. We can fix this, but it will take time, money, and effort.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Option B has the alarm thresholds described backward: setting them low would let many more alarms through, setting them high filters more alarms out, passing fewer reports up to the security operations or response team. <br>Option D may be correct\u2014taking more of a zero trust approach and re-segmenting the network, for example, might be worth considering\u2014but it won't help the response team today. <br>Options A and C are correct statements regarding precursors (such as email threats claiming to be from activist groups) and indicators (such as changes to access control and accounting settings on a subject or object).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      96,
      70,
      75,
      94
    ],
    "source": ""
  },
  {
    "id": 221,
    "question": "Which statement about precursors and indicators is most correct?",
    "choice_a": "Precursors are events that prepare the way for an attack, such as an intrusion, to take place.",
    "choice_b": "Precursors are the observable signals from an event, which may suggest that an information systems security event may happen later.",
    "choice_c": "Indicators are the observable signals from an event, which may suggest that an information systems security event may happen later.",
    "choice_d": "Indicators are events that are part of an information security incident kill chain; warnings are the observable effects that we can detect, that tell us of the occurrence of the indicator.",
    "correct_answer": "B",
    "explanation": "When it comes to incident detection, a precursor is an observable signal or result of an event, which may suggest to us that an event of interest (such as a security-related event) may happen in the near future. Precursors do not, in themselves, suggest that the incident is currently happening. Thus, Option A is false. <br>Option C mistakes indicators for precursors. <br>Option D confuses events with the observable signals from them (such as the changes they make to target systems, which we can observe). \u201cWarnings\u201d in this context has no meaning\u2014that is, our IDS or IPS technologies detect indicators and issue alarms. Thus, Option B is most correct.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      75,
      96,
      94,
      69
    ],
    "source": ""
  },
  {
    "id": 222,
    "question": "Why is escalation part of the detection and analysis phase of an incident response?",
    "choice_a": "It will require additional resources, such as IT staff, to begin carrying out the next phases of the response plan, and this would require management approval and action.",
    "choice_b": "Management and leadership need to know that an information security incident may have occurred and that investigation continues. Depending on the nature of the incident as understood thus, far, management may need to take additional action.",
    "choice_c": "Most organizations are unwilling to delegate authority to an incident response team leader and thus, need to control every action in order to exercise due diligence.",
    "choice_d": "This is required by NIST SP800-61 Rev. 2 and in regulations that apply to the particular business or organization.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; this may be a consequence of the way that the team's detection, response, and recovery responsibilities are defined and supported, but it's not generally the case. <br>Option C is incorrect; though this might be true in some organizations, it is not related to due diligence and misstates that concept. <br>Option D is incorrect; NIST publications provide guidance, while federal regulations can make them obligatory on federal and other government activities, they do not in general dictate what the private sector must do. <br>Option B is correct; management and leadership may have legal, regulatory, or business reasons for knowing immediately that an incident might have occurred or might be occurring, but they cannot fulfill those obligations if no one on the response team tells them about it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      83,
      99,
      97,
      69
    ],
    "source": ""
  },
  {
    "id": 223,
    "question": "What are some of the key tasks to consider as part of containment of an information security incident? <ol type=\"A\"><li>Suspending processes related to applications platforms</li><li>Disabling network traffic at the points of presence with ISPs</li><li>Disabling connections to servers or hosts suspected of having been attacked</li><li>Notifying external users of extranet or other shared resources and requesting that they suspend activities</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Containment looks to isolating systems that have been infected by a causal agent such as malware, or whose software and data may have been corrupted, so as to prevent either the causal agent or the damage from spreading. Thus, Option A wouldn't achieve containment, since an infected or corrupted application could have many service requests already sent to systems services, any of which could be a vector to spread the damage to other systems. <br>Option D does not contain anything; the attack agent or damaged software and data can still flow from the affected systems to others. Shutting down that link, however, would contain the casual agent (shutting down two-way traffic). <br>Option B isolates the organization's LAN from the Internet, which is effective containment of the incident to the organization's systems. <br>Option C addresses segmenting the organization's systems into infected (and thus, contained or isolated) and not infected systems. Whether there's enough connectivity between the \u201cbelieved healthy\u201d systems to function as a network, or whether they are only capable of being islands of automation, will be determined by the network design and the incident's effects.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      70,
      77,
      78,
      92
    ],
    "source": ""
  },
  {
    "id": 224,
    "question": "Which statements about containment and eradication are most correct?",
    "choice_a": "Containment and eradication are separate and distinct tasks; once containment is complete, the incident response team moves on to eradication of the causal agent(s).",
    "choice_b": "Containment and eradication usually involve the same tools and procedures, and so they often are performed simultaneously.",
    "choice_c": "Malware quarantine operations are an example of containment and eradication achieved with the same task",
    "choice_d": "Containment primarily addresses shutting down connectivity between networks, subnets, systems, and servers. Eradication addresses locating the causal agents (malware, bogus user IDs, etc.) and removing them from each system.",
    "correct_answer": "D",
    "explanation": "Option A is incorrect; containment may occur system by system or host by host as the networks are segmented and isolated, and thus, the eradication specialists can start cleaning systems as they are isolated (or the causal agents on them are contained). <br>Option B is incorrect, since different tools are needed to disable network connections than you'd use to scan systems for malware, as an example. <br>Option C is incorrect; malware quarantine is more an example of eradication combined with recovery. <br>Option D correctly explains isolating systems and then cleaning them.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      636,
      638,
      70,
      75,
      92
    ],
    "source": ""
  },
  {
    "id": 225,
    "question": "Which of the following are not legal or regulatory issues that a CSIRT would have to be concerned with?",
    "choice_a": "Incidents caused by employee negligence or accident",
    "choice_b": "Incidents caused by misuse of systems by an employee",
    "choice_c": "Incidents that may involve competitors attempting to access company proprietary information",
    "choice_d": "Incidents that disrupt normal business operations",
    "correct_answer": "A",
    "explanation": "Option A usually does not have a legal or regulatory obligation that the CSIRT must respond to (although there may be requirements for the organization to report statistics on such incidents to regulators or other authorities). <br>Option B could lead to disciplinary actions or firing the employee involved, which could result in litigation. <br>Option C may be criminal trespass or violation of other criminal laws. <br>Option D may, depending on the nature of the business and its activities, require safety, security, or investor and consumer protection reporting and notification actions by the organization, regardless of cause.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      659,
      77,
      84,
      83
    ],
    "source": ""
  },
  {
    "id": 226,
    "question": "What are some of the key steps or processes in the recovery phase of responding to an information security incident? <ol type=\"A\"><li>Documenting lessons learned</li><li>Restoring, rebuilding, or reloading servers and hosts with clean backup images or distribution kits</li><li>Restoring databases and network storage systems to backup copies made prior to the incident</li><li>Setting filters and rules on network traffic, and inspecting suspicious packets, streams, or addresses to check that containment and eradication have been successful</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A, documenting lessons learned, is a critical part of post-recovery activities and thus, is incorrect. <br>Option D is incorrect; verification of complete containment and eradication should be done as part of containment and eradication, prior to starting recovery tasks. <br>Option B, restoring or rebuilding systems, and Option C, restoring databases and storage systems, are correct.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      71,
      75,
      636,
      497,
      94
    ],
    "source": ""
  },
  {
    "id": 227,
    "question": "Which set of plans and procedures should define how the organization makes backups of systems, applications, device settings, databases, and other data, for use during the recovery phase of an information systems security incident response?",
    "choice_a": "Information security incident response plans and procedures",
    "choice_b": "Disaster recovery plans and procedures",
    "choice_c": "Business continuity plans and procedures",
    "choice_d": "Information technology configuration management plans and procedures",
    "correct_answer": "C",
    "explanation": "Option A is false; the response team should only need to know how to find and use such backups and should not be responsible for their initial generation or routine update. <br>Option B is false; the DRP would address options spelled out in the BCP as to alternative processing locations, contingency plans, and so forth, all of which need the backups that the BCP directs be made. <br>Option D is false; configuration management is the decision process that allows or prevents changes to hardware, software, or key data items or structures, but it doesn't manage backups. <br>Option C correctly links the purpose of backups\u2014continuing to get business done in the face of accidents, systems failures, attacks, or natural disasters\u2014with the need for a specific set of resources, such as backups.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      79,
      77,
      78,
      88,
      87
    ],
    "source": ""
  },
  {
    "id": 228,
    "question": "You're the only SSCP in your small company's four-person IT team, and you've just been part of an emergency response team that's spent six nonstop days of overtime dealing with a major malware incident. The chief operating officer (COO) wants to skip the post-recovery phase, both to save costs and to get you and the other team members back onto your regularly assigned job tasks. Which statements would you base a reply to the COO on? Choose the statements that best support your reply.<ol type=\"A\"><li>Although it's recommended that we produce a lessons-learned file from this and every incident, we can do that as a part-time, background task, over the next several weeks or months, so we won't miss anything important.</li><li>Right now, the data we gathered as we investigated the incident is just in working files, notes, and such, and if we need to retain any of it, for any reasons, we've got some housekeeping to do before we're done.</li><li>The labor days we'd spend doing proper post-recovery procedures review, update, and process improvement will have us much better prepared for the next time something like this happens.</li><li>Since we don't really know how the malware came into our systems in the first place, we might want to continue that investigation now, while it's still fresh in our minds.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; delaying a post-event debriefing allows human memory to fade, and important insights can get lost very quickly. <br>Option D may be true in this circumstance, but this is not strictly a post-recovery phase activity. It may very well be a great task for your many-talented IT team to take on, but just not as a CSIRT task. <br>Option B addresses due care and due diligence, since there are many reasons why data from such incidents needs to be retained and kept secure. <br>Option C is also a sound investment strategy, which will need to be weighed against the lost opportunity costs of your team continuing to fall behind on routine work tasks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      84,
      83,
      99,
      101,
      80
    ],
    "source": ""
  },
  {
    "id": 229,
    "question": "You've suggested to the IT team that all systems and servers, and all network devices, have their clocks synchronized and that synchronization checked frequently. One of their team members says this is not necessary. Which of these statements would be best to support your reply?",
    "choice_a": "When we see a device whose clock is not in sync, it's probably because of a spoofed Wi-Fi access point, but if we don't have the clocks synchronized by policy, we can't see this.",
    "choice_b": "This should be easy to do; just have every device initialization script make network time service calls.",
    "choice_c": "Clocks that aren't synchronized properly might indicate anomalies on that system or device, which could be a precursor of an information security incident.",
    "choice_d": "In the event we're investigating an anomaly or an incident, having all systems event logs using the same time standard will make them a lot easier to correlate and analyze.",
    "correct_answer": "D",
    "explanation": "Option A might conceivably be true, but it's doubtful this could be a good indicator of an incident. <br>Option B is technically correct, but it doesn't offer a justification for making clock synchronization be required. <br>Option C, like Option A, might theoretically be true, but it's not clear this can easily be an indicator or precursor of a security incident. <br>Option D correctly states the simple justification; networks with hundreds of devices, each producing dozens of event logs, will quickly overwhelm any manual attempts to bias the clocks in each log file to get things to collate together usefully.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      471,
      622,
      61,
      40,
      57
    ],
    "source": ""
  },
  {
    "id": 230,
    "question": "Several months ago, your company suffered from a serious information systems security incident, which crippled its production operations for days. As a result, the CSIRT and other managers have seen the need to make a number of changes to a number of information security procedures, including those for incident response and continuity of operations. As CSIRT team chief, they've asked you what else they should consider, and why. Which of the following might you recommend? <ol type=\"A\"><li>Exercise the new procedures to verify that they work and deliver the improvements we need.</li><li>Increase our penetration testing activities to see if our new procedures help us detect and respond better.</li><li>Train the key team members, managers, and leadership on the new procedures.</li><li>Keep the news about the new procedures very low-key; most of our employees don't have a need to know about them, and letting them become widely known may inadvertently disclose other vulnerabilities.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option D is incorrect; even if most employees won't need to know the details of new procedures, the fact of learning the lessons from the most recent, painful event will restore confidence in the \u201cIT wizards\u201d and in management. <br>Option B is incorrect, or at least not strongly advised; it does not provide a strong link between pen testing, failure to detect and respond, and the new procedures. <br>Option A should be a part of any procedural change process (how do you know the change did what you were promised it would?). <br>Option C is critical to preparing these key people to respond properly when the next incident occurs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      79,
      85,
      72,
      99,
      83
    ],
    "source": ""
  },
  {
    "id": 231,
    "question": "Which of the following kinds of events might not be part of an advanced persistent threat attack?",
    "choice_a": "Inquiries or requests for employee or staff contact information",
    "choice_b": "Anomalies in applications behavior",
    "choice_c": "Recurrent problems with data corruption in database entries",
    "choice_d": "Routine ping or other ICMP packets coming to your systems",
    "correct_answer": "D",
    "explanation": "Option A could be social engineering or other attempts to gain entry into your systems. <br>Option B could be caused by malware, corrupted data entered by a user in attempting to exploit a vulnerability in the application. <br>Option C could be the result of bogus data being entered in via an exploited vulnerability in a process or application, or it could indicate a corrupted application task (malware infected or otherwise exploited). <br>Option D could be from any number of sources, most of which are not attackers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      46,
      42,
      59,
      61
    ],
    "source": ""
  },
  {
    "id": 232,
    "question": "You've suggested that your CSIRT should create its own timeline of an incident, as part of their efforts to understand and assess it. Other team members say that this is what correlating event logs should take care of. Which statements would you base your reply on? <ol type=\"A\"><li>Our timeline is how we capture our assessment of the cause and effect relationships between events; the systems logs show us only events that happened.</li><li>Event logs need to be annotated to show relationships between events, and if we had the right set of security information and event management tools, that would be all we need.</li><li>Event logs only show when the hardware, operating systems, or applications saw an event and logged it; they don't cover actions taken by us or by other staff members.</li><li>We have to explain to management, in simple terms, what happened and when; they don't want to see hundreds of events in a log, which are nothing more than the evidence that led us to conclusions about what happened.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and C",
    "choice_c": "A, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "C",
    "explanation": "Option B is incorrect; not only does it miss the actual value-added purposes of having the team do its own timeline analysis, but it also confuses the role of detailed evidence with broader cause-and-effect relationships (as in Option A). <br>Option C is correct, as is Option D, in justifying the use of timeline analysis in incident investigation and response.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      97,
      100,
      96,
      98
    ],
    "source": ""
  },
  {
    "id": 233,
    "question": "Which statements about the role of end users in detecting information security incidents are correct?",
    "choice_a": "Most end users may have significant experience with the routine operation of the business systems and applications that they use, but they really cannot produce useful precursor or indicator information regarding possible information security incidents.",
    "choice_b": "Most end users and their first-level supervisors have the best, most current insight as to the normal business rhythm and flow, and therefore normal loads on the systems and their throughput. They will most likely see anything abnormal quickly as a result.",
    "choice_c": "Users think that they know a lot about business normal, but we need to rely more heavily on well-instrumented intrusion detection systems, access control, and other monitoring capabilities.",
    "choice_d": "Since most APT kill chains use low and slow attack methods to reconnoiter and gain access, by the time users see things behaving abnormally, it's too late.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; it's actually rather dismissive of the knowledge that most line workers have when it comes to how business actually gets done every day. Users may need better training as to what to do when they think they see a problem, but that's not addressed by this answer. <br>Option C is incorrect, demonstrating a narrow vision that only sees the technological solutions as useful. <br>Option D is incorrect, notably that it is never too late to sound an alarm. <br>Option B correctly expresses the value of knowledge and experience. Harnessing this insight in real time as part of an intrusion or anomaly detection process, however, is another story.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      85,
      95,
      96,
      97,
      69
    ],
    "source": ""
  },
  {
    "id": 234,
    "question": "Which of the following types of actions or responses would you not expect to see in an information security incident response plan? <ol type=\"A\"><li>Relocation of business operations to alternate sites</li><li>Temporary staffing</li><li>Using off-site systems and data archives</li><li>Engaging with senior organizational leadership</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option A is incorrect; relocation of business operations is typically part of disaster recovery plans. <br>Option B is incorrect, as temporary staffing implies that existing staff are not available to work or cannot work for some reason, and this is more in the scope of disaster recovery. <br>Option C, off-site systems and data archives, may well be used in the restoration phase of an information security incident response. <br>Option D is part of all incident response, continuity, and recovery planning.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      478,
      477,
      595,
      605,
      52
    ],
    "source": ""
  },
  {
    "id": 235,
    "question": "Your boss believes that your company must follow NIST guidelines for disaster recovery planning and wants you to develop the company's plans based on those guidelines. Which statement might you use to respond to your boss?",
    "choice_a": "As a government contractor, we actually have to follow ISO and ITIL, not NIST.",
    "choice_b": "Although we are not a government contractor, NIST frameworks and guidelines are mandatory for all US businesses, and so this is correct.",
    "choice_c": "NIST publications are mandatory only for government agencies or companies on government contracts, and since we are neither of those, we don't have to follow them. But they have some great ideas we should see about putting to use, tailored to our risk management plans.",
    "choice_d": "NIST publications are specifically for government agencies and their contractors, and most of what they say is just not applicable to the private sector.",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; NIST is mandatory for US government agencies and their contractors. <br>Option B is incorrect, because NIST publications are not mandatory for the private sector. <br>Option C correctly expresses the relationship of NIST publications to the private sector for this and many other aspects of information systems risk management. <br>Option D is incorrect; most private organizations can learn a great many valuable lessons from NIST's publications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      474,
      36,
      475,
      479,
      599
    ],
    "source": ""
  },
  {
    "id": 236,
    "question": "Your boss has asked you to start planning for disaster recovery. Where would you start to understand what your organization needs to do to be prepared? <ol type=\"A\"><li>Business impact analysis</li><li>Business continuity plan</li><li>Critical asset protection plan</li><li>Physical security and safety plan</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option A is correct; it is the focal point for linking organizational priorities, goals, and objectives to risks and vulnerabilities and thence to impacts. The BIA should drive all other response plans. <br>Option B is also correct; this is (or should be!) driven by the BIA, is the result of looking at significant disruptions to business operations, and shows concepts, plans, and resources needed to recover from the disruptions and continue to operate or get back to normal operations. <br>Option C is incorrect; this would typically not address how the organization recovers from loss or damage to such an asset. <br>Option D is incorrect, as like Option C, it looks at prevention and deterrence rather than recovery.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      43,
      477,
      479,
      54
    ],
    "source": ""
  },
  {
    "id": 237,
    "question": "Which plans would you expect to be driven by assessments such as SLE, ARO, or ALE?",
    "choice_a": "Business continuity plan",
    "choice_b": "Contingency operations plan",
    "choice_c": "Information security incident response plan",
    "choice_d": "Risk management plan",
    "correct_answer": "D",
    "explanation": "These assessments look at cost and likelihood of loss or impact from a risk; thus, Option D is the right place to find them being used as part of the risk management decision process. The other answers all are incorrect, since they are response plans; these should be built to meet the time-based (or data loss\u2013based) assessments such as recovery time objective as best as they can; during the incident response, you're not particularly worried about a probability of a loss when it's actually happening.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      456,
      458,
      597,
      59,
      477
    ],
    "source": ""
  },
  {
    "id": 238,
    "question": "Which statement best explains the relationship between incident response or disaster recovery, and configuration management of your IT architecture baseline? <ol type=\"A\"><li>There is no relationship; managing the IT baseline is useful during normal operations, but it has no role during incident response or disaster recovery.</li><li>As you're restoring operations, you may need to redo changes or updates done since the time the backup copies were made; your configuration management system should tell you this.</li><li>Without a documented and managed baseline, you may not know sufficient detail to build, buy, or lease replacement systems, software, and platforms needed for the business</li><li>There is no relationship, because the contingency operations procedures should provide for this.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; without a known baseline to restore to (or rebuild if the primary systems are destroyed), you have no place to start from. <br>Option B is correct, since restoring from backups needs to check for changes made to the production systems after the date/time of the backup. <br>Option C is correct; in the event of major damage to the production systems, hardware, or facilities, you need to know what to start putting together to get back into operations. <br>Option D is incorrect; the contingency operations procedures may identify assets (computers, etc.) in place for alternate operations locations, or for reduced capabilities, but they won't document the in-use production system at the requirements, design, and implementation detail level that the configuration managed baselines should do.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      606,
      478,
      479,
      471,
      472
    ],
    "source": ""
  },
  {
    "id": 239,
    "question": "Which statement about recovery times and outages is most correct?",
    "choice_a": "MAO should exceed RTO.",
    "choice_b": "RTO should exceed MAO.",
    "choice_c": "RTO should be less than or equal to MAO.",
    "choice_d": "RTO and MAO are always equal.",
    "correct_answer": "C",
    "explanation": "Option A is nearly correct\u2014recovery time objective less than maximum allowable outage allows for some slack or reserve time before hitting the MAO constraint; however, the true condition is that expressed in Option C, which allows for when RTO and MAO are equal. <br>Option B has this relationship backward; we plan to achieve the objective (RTO) so as to not exceed the maximum allowed. <br>Option D is false; they do not have to be equal.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      477,
      479,
      478,
      599,
      54
    ],
    "source": ""
  },
  {
    "id": 240,
    "question": "Which value reflects a quantitative assessment of the maximum allowable loss of data due to a risk event?",
    "choice_a": "RTO",
    "choice_b": "RPO",
    "choice_c": "MAO",
    "choice_d": "ARO",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; recovery time objective (RTO) is not related to data loss. <br>Option C, maximum allowable outage time (MAO), is incorrect. <br>Option D, annual rate of occurrence (ARO), or the number of such events expected on a yearly basis, is incorrect. <br>Option B is correct; the recovery point objective (RPO) sets the maximum time lag or latency time for data in order to be considered useful for business operations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      598,
      456,
      612,
      597,
      599
    ],
    "source": ""
  },
  {
    "id": 241,
    "question": "Which of the following statements about information security risks is most correct regarding the use of collaborative workspace tools and platforms?",
    "choice_a": "Because these tools encourage open, trusting sharing of information and collaboration on ideas, they cannot be used to securely work with proprietary or sensitive data.",
    "choice_b": "These tools require strong identity management and access control, as part of the infrastructure beneath them, to protect sensitive or proprietary information.",
    "choice_c": "Granting access to such collaboration environments should first be determined by legitimate business need to know and be based upon trustworthiness.",
    "choice_d": "First, the organizations collaborating with them should agree on how sensitive data used by or created by the team members must be restricted, protected, or kept safe and secure. Then, the people using the tool need to be fully aware of those restrictions. Without this, the technical risk controls, such as access control systems, can do very little to keep information safe and secure.",
    "correct_answer": "D",
    "explanation": "Option A is false; appropriate administrative and technical controls can and should be used to reduce information security risks to acceptable levels. <br>Option B is correct in part, but without the users of the tool being fully aware of the CIANA needs pertaining to the data, information, and knowledge that are being collaborated upon, the technical controls are meaningless. <br>Option C is correct in part, but it does not address user awareness, education, or training. <br>Option D covers the key elements of user awareness and education, and supports the CIANA requirements for this collaboration; thus, the technical controls can do their job more effectively.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      25,
      27,
      32,
      31
    ],
    "source": ""
  },
  {
    "id": 242,
    "question": "Which statement about phishing attacks is most correct?",
    "choice_a": "Phishing attacks are rarely successful, and so they pose very low risk to organizations.",
    "choice_b": "Spear phishing attacks are easy to detect with scanners or filters.",
    "choice_c": "Attackers learn nothing of value from you, if you simply reply to an email, your suspect is part of a spear phishing or whaling attack and say \u201cplease remove me from your list.\u201d",
    "choice_d": "Phishing attacks of all kinds are still in use, because they can be effective social engineering tools when trying to do reconnaissance or gain illicit entry into an organization or its systems.",
    "correct_answer": "D",
    "explanation": "Option A is false; even if thousands of phishing emails are sent as part of a low-and-slow attack, one response can generate exploitable information for the attacker. <br>Option C is false; in doing so, you confirm that your email address connects to a real (and somewhat underinformed) person. Expect more. <br>Option B is false; attackers work hard to mimic the style, format, expression, and construction of their phishing emails, and continually attempt to spoof email addresses, domain names, and so forth. Tools may filter a lot of such junk email for you, but they won't catch it all. <br>Option D is most correct.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      28,
      26,
      25,
      20
    ],
    "source": ""
  },
  {
    "id": 243,
    "question": "In general, what differentiates phishing from whaling attacks?",
    "choice_a": "Phishing attacks tend to be used to gain access to systems via malware payloads or by getting recipients to disclose information, whereas whaling attacks try to get responsible managers to authorize payments to the attacker's accounts.",
    "choice_b": "Phishing attacks are focused on businesses; whaling attacks are focused on high-worth individuals.",
    "choice_c": "Whaling attacks tend to offer something that ought to sound \u201ctoo good to be true,\u201d whereas phishing attacks masquerade as routine business activities such as package delivery confirmations.",
    "choice_d": "There's really no difference.",
    "correct_answer": "A",
    "explanation": "Option A is correct; phishing tends to seek information, and whaling (and spear phishing) seek action, typically the release of funds to the attacker. <br>Option B is incorrect; whaling is primarily aimed at senior business leaders, whereas phishing can be aimed at anybody, anywhere, if the attacker perceives there is something worthwhile to learn in doing so. <br>Option C has these reversed; whaling attacks depend on credibility of the business transaction they request. <br>Option D is false on its face; there is a significant difference, as shown in Option A.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 244,
    "question": "Which statement best describes how does the separation of duties relate to education and training of end users, managers, and leaders in an organization?",
    "choice_a": "Separation of duties would dictate that general education and awareness training be done by different people than those who provide detailed skills-based training for the proper handling of sensitive information.",
    "choice_b": "Separation of duties should identify groups or teams that have little need for information security awareness, training, and education so that effort can be better focused on ones with greater needs.",
    "choice_c": "Separation of duties should segment the organization into teams focused on their job responsibilities, with clear interfaces to other teams. Effective awareness training and education can help each team, and each team member, see how successfully fulfilling their duties depends on keeping information safe, secure, and reliable.",
    "choice_d": "Separation of duties would dictate that workers outside of one team's span of control or duties have no business need to know what that team works with; education and training would reinforce this.",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; in general, the same core information security team members should actively shape and guide all information security awareness, education, and training efforts across the organization. <br>Option B is incorrect; it shows a misunderstanding of separation of duties, which typically breaks a task for one trustworthy person or group into two or more sets of tasks for two (or more) trustworthy people or groups so as to provide a check and balance arrangement. This would typically involve information at the same level of sensitivity or classification. <br>Option C is correct, since it links the opportunities that separation of duties can suggest for focusing such education and training. <br>Option D, like Option B, does not apply separation of duties correctly. It is not intended to produce \u201ccompartments\u201d that others cannot know about, in and of itself; rather, it drives the design of access controls or administrative controls to prevent one person from taking incorrect action.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      592,
      31,
      32,
      573,
      575
    ],
    "source": ""
  },
  {
    "id": 245,
    "question": "What should be your highest priority as you consider improving the information security of your organization's telephone and voice communications systems?",
    "choice_a": "Having in-depth, current technical knowledge on the systems and technologies being used",
    "choice_b": "Understanding the contractual or terms of service conditions, with each provider, as they pertain to information security",
    "choice_c": "Ensuring that users, managers, and leaders understand the risks of sharing sensitive information with the wrong parties and that effective administrative controls support everyone in protecting information accordingly",
    "choice_d": "Ensuring that all sensitive information, of any kind, is covered by nondisclosure agreements (NDAs)",
    "correct_answer": "C",
    "explanation": "Option A is not correct; most of the risk is in what people say to each other over these systems, and technical controls can do little to mitigate this. <br>Option B is incorrect; the service provider has no role in how you keep your people from saying the wrong things to the wrong parties. <br>Option C correctly focuses on what people in your organization need to know: how and why to protect the organization, by controlling what they say to others. <br>Option D is incorrect; a signed NDA may make the employee signing it aware of the restrictions, and provide authority for sanctions (such as litigation, termination, etc.), but it doesn't help operationally in achieving information security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      32,
      30,
      22
    ],
    "source": ""
  },
  {
    "id": 246,
    "question": "Social engineering attacks still present a threat to organizations and individuals for all of the following reasons except:",
    "choice_a": "Most targeted individuals don't see the harm in responding or in answering simple questions posed by the attacker.",
    "choice_b": "Most people believe they are too smart to fall for such obvious ploys, but they do anyway.",
    "choice_c": "Most targeted individuals and organizations have effective tools and procedures to filter out phishing and related scams, so they are now better protected from such attacks.",
    "choice_d": "Most people want to be trusting and helpful.",
    "correct_answer": "C",
    "explanation": "Options A, B, and D all demonstrate the hallmarks of social engineering attacks\u2014they work (and have worked for thousands of years) because people are generally trusting, open, and willing to engage with strangers. <br>Option C, the correct choice, is unfortunately not true; tools may help filter out some email-based social engineering attacks, but few organizations have truly been able to operate with a \u201cloose lips sink ships\u201d approach and deal openly with customers, clients, and many other outside stakeholders.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      81,
      85,
      84,
      78,
      76
    ],
    "source": ""
  },
  {
    "id": 247,
    "question": "You're the lone SSCP in the IT group of a small start-up business, which has perhaps 25 or so full-time employees performing various duties. Much of the work the company does depends on dynamic collaboration with many outside agencies, companies, and academic organizations, as well as with potential customers. The managing director wants to talk with you about ways to help protect the rapidly evolving intellectual property, market development ideas, and other information that she believes give the company its competitive advantage. She's especially worried that with the high rate of open conversation in the collaborations, this advantage is at risk. Which of the following would you recommend be the first that the company invest in and make use of?",
    "choice_a": "More rigorous access control systems, using multifactor authentication",
    "choice_b": "More secure, compartmented collaboration software suites, tools, and procedures",
    "choice_c": "Better, more focused education and open dialogue with company staff about the risks of too much open collaboration",
    "choice_d": "Better work on our information risk management efforts, to include an information security classification process that our teammates can use effectively",
    "correct_answer": "C",
    "explanation": "Options A and B are incorrect; tempting as they are to the geek in us, they are not the first place that effort needs to be spent. <br>Option D is a necessary and vital task, but given the dynamics of this organization, it sounds like Option C is the most immediate need. Getting this small group of people totally focused on protecting their own future while collaborating with many others in building that future is going to be key to success; thus, more dialogue (Option C) can lead to a better, more informed and effective information risk management and classification approach (Option D).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      32,
      569,
      570,
      30
    ],
    "source": ""
  },
  {
    "id": 248,
    "question": "You've recently determined that some recent systems glitches might be being caused by the software or hardware that a few employees have installed and are using with their company-provided endpoints; in some cases, employee-owned devices are being used instead of company-provided ones. What are some of the steps you should take right away to address this? <ol type=\"A\"><li>Check to see if your company's acceptable use policy addresses this.</li><li>Review your IT team's approach to configuration management and control.</li><li>Conduct remote configuration inspections and audits on the devices in question.</li><li>Get your manager to escalate this issue before things get worse.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option D is inadvisable as a first step; you need to first check to see if the company has policies that effectively set boundaries or constraints for acceptable use, bring your own device or software, and configuration management and control. <br>Option C is also inadvisable, without first checking (again) with company policy and perhaps with company legal advisers, especially if you wish to scan employee-owned devices. <br>Options A and B, starting with reviewing current policy, are your best first starts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      581,
      487,
      570,
      31,
      32
    ],
    "source": ""
  },
  {
    "id": 249,
    "question": "You've just started a new job as an information security analyst at a medium-sized company, one with about 500 employees across its seven locations. In a conversation with your team chief, you learn that the company's approach to risk management and information security includes an annual review and update of its risk register. Which of the following might be worth asking your team chief about? <ol type=\"A\"><li>What do we do when an incident response makes us aware of previously unknown vulnerabilities?</li><li>How does that relate to our ongoing monitoring of our IT infrastructure and key applications platforms and systems?</li><li>Does that result in any tangible cost savings for us?</li><li>Why do that every year, as opposed to doing it on some other periodic basis? </li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "A",
    "explanation": "Option D is inadvisable; it's a legitimate thing for you to think about, but you might want to avoid such a confrontational question that seems to challenge the company's logic and reasoning for this practice. <br>Option C is also inadvisable; it might be part of the decision logic to set the review period, but it shouldn't be high on your list of things to know as a new team member. <br>Option A is a good, task-focused question that could very well be something you'd expect to encounter during or after incident response efforts. <br>Option B is a good question, looking to the overall risk information architecture itself (what does the company learn from its monitoring for precursors and indicators?).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      518,
      575,
      486,
      725,
      579
    ],
    "source": ""
  },
  {
    "id": 250,
    "question": "The company you work for does medical insurance billing, payments processing, and reconciliation, using both Web-based transaction systems as well as batch file processing of hundreds of transactions in one file. As the SSCP on the IT team, you've been asked to consider changes to their backup and restore strategies to help reduce costs. Which quantitative risk assessment parameter might this affect most?",
    "choice_a": "Recovery time objective",
    "choice_b": "Recovery point objective",
    "choice_c": "None; this operational change would not impact information security risks.",
    "choice_d": "Maximum allowable outage",
    "correct_answer": "B",
    "explanation": "Option B is correct; changing backup and restore strategies may affect backup data latency\u2014the time between the last backup of the data, and the need to have the data in the system current and up to date, accurately reflecting all transactions since that last backup. <br>Option A is incorrect, as RTO would set the goal for getting the system capabilities restored and able to accept new data; data latency is often assumed to be something that can be dealt with in parallel to processing new transactions after the system has been restored. <br>Option C is incorrect; clearly, the ability to get back to normal business depends on the data being correct, complete, and current (that is, meeting integrity and availability needs). <br>Option D is not correct; this is most likely set by business and market conditions, and not by the \u201chow do we achieve this\u201d that choices about data backup may affect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      25,
      33,
      23,
      32
    ],
    "source": ""
  },
  {
    "id": 251,
    "question": "Which statement about business continuity planning and information security is most correct?",
    "choice_a": "Plans are more important than the planning process itself.",
    "choice_b": "Planning is more important than the plans it produces.",
    "choice_c": "Plans represent significant investments and decisions, and thus, should be updated only when significant changes to objectives or circumstances dictate.",
    "choice_d": "Planning should continuously bring plans and procedures in tune with ongoing operational reality.",
    "correct_answer": "D",
    "explanation": "Planning should be an ongoing, continuous, and iterative process; plans are thus, continually tested against reality so that changes to plans and procedures stay harmonized. Thus, Option D is most correct. <br>Option C, unfortunately, is a commonly held view and can lead to work being done to obsolete ideas or to assumptions long since proven to be incorrect by reality. <br>Option B is good, but not as correct and complete as Option D. <br>Option A is incorrect; plans are good, useful and necessary, but it is the planning process that brings the team together to better understand needs versus resources.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      581,
      487,
      488,
      510,
      586
    ],
    "source": ""
  },
  {
    "id": 252,
    "question": "One of your co-workers stated that he thought business continuity planning was a heartless, bottom line\u2013driven exercise that cared only about the money and not about anything else. You disagree. Which of the following points would you not raise in discussing this with your colleague? <ol type=\"A\"><li>Insurance coverage should provide for meeting the needs of workers or others who are disrupted by the incident and our responses to it.</li><li>Due care places on all of us the burden to protect the safety and security of the business, its people, and stakeholders in it, as well as the society we're part of.</li><li>As a professional, we're expected to take steps to ensure that the systems we're responsible for do not harm people or the property of others.</li><li>The workers and managers are part of what makes the company productive and profitable in normal times, and even more so during the recovery from a significant disruption.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "D",
    "explanation": "Options B and C both flow directly from the ISC2 code of professional ethics, and they express the responsibilities we have to take due care of the people our actions might affect. They are points worth bringing up in this discussion. <br>Option A may be technically or legally correct, but it suggests that the bottom-line financial measure of disruption and restitution is all that is required; this seems and may be heartless. <br>Option D seems to treat people in the company, at any level, as objects that are merely parts of the productive processes that the company uses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      32,
      30,
      33,
      27
    ],
    "source": ""
  },
  {
    "id": 253,
    "question": "How can ideas from the identity management lifecycle be applied to helping an organization's workforce, at all levels, defend against sophisticated social engineering attack attempts? <ol type=\"A\"><li>Most end users may have significant experience with the routine operation of the business systems and applications that they use; this can be applied, much like identity proofing, to determine whether a suspected social engineering attempt is taking place.</li><li>Most end users and their first-level supervisors have the best, most current insight as to the normal business rhythm, flow, inputs, and outcomes. This experience should be part of authenticating an unusual access request (via email, phone, in person, or by any means).</li><li>Users think that they know a lot about \u201cbusiness normal,\u201d but they tend to know only the narrow scope of their jobs and responsibilities; this does not equip them to contribute to detecting social engineering attacks.</li><li>Contact requests by email, by phone, in person, or by other means are akin to access attempts, and they can and should be accounted for.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A, B and D",
    "choice_c": "B, C and D",
    "choice_d": "A, B, C and D",
    "correct_answer": "B",
    "explanation": "Option C is incorrect; it ignores the ability of human experience, combined with focused awareness and training, to detect out-of-tolerance conditions and raise an alarm. <br>Option A is a valid comparison of proofing (verifying that the offered claims of identity are legitimate). <br>Option B is a valid comparison of authenticating that the person or subject in question is recognized as one entitled to access. <br>Option D is a valid application of accounting for access attempts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      542,
      420,
      413,
      447,
      375
    ],
    "source": ""
  },
  {
    "id": 254,
    "question": "Access control is based on which set of elements?",
    "choice_a": "Objects, subjects, and rules",
    "choice_b": "Multifactor authentication and access tokens",
    "choice_c": "Attributes and roles",
    "choice_d": "Hierarchies of trust",
    "correct_answer": "A",
    "explanation": "Access control defines a setup of rules that constrain or allow access to objects by subjects.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      540,
      555,
      537,
      539,
      556
    ],
    "source": ""
  },
  {
    "id": 255,
    "question": "What is the difference between a synchronous and asynchronous password token?",
    "choice_a": "Asynchronous tokens contain a password that is physically hidden and then transmitted for each authentication whereas synchronous tokens do not.",
    "choice_b": "Synchronous tokens are generated with the use of a timer whereas asynchronous tokens do not use a clock for generation.",
    "choice_c": "Synchronous tokens contain a password that is physically hidden and then transmitted for each authentication whereas asynchronous tokens do not.",
    "choice_d": "Asynchronous tokens are generated with the use of a timer whereas synchronous tokens do not use a clock for generation.",
    "correct_answer": "B",
    "explanation": "Option B correctly demonstrates synchronous (same time); Option D has this backward. Once the password is validated, the token is passed to subsequent processes that need to authenticate that subject's access, such as in single sign-on systems. Thus, Options A and C are incorrect.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      480,
      481,
      482,
      543,
      4
    ],
    "source": ""
  },
  {
    "id": 256,
    "question": "Which of the following is a principal component of an access control system?",
    "choice_a": "Objects",
    "choice_b": "Biometrics",
    "choice_c": "Crossover error rate",
    "choice_d": "Auditing/accounting",
    "correct_answer": "A",
    "explanation": "Access control defines a set of rules that constrain or allow access to objects.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      540,
      555,
      537,
      539,
      542
    ],
    "source": ""
  },
  {
    "id": 257,
    "question": "A key employee seems to have gone missing while on an overseas holiday trip. What would you recommend that management do immediately, with respect to identity management and access control, for your federated access systems? <ol type=\"A\"><li>De-provision the employee's identity.</li><li>Suspend all access privileges for the employee's identity, except for email, in case the employee tries to use it to contact the company for help.</li><li>Suspend all access privileges for the employee's identity, and notify all federated systems partners to ensure that they take similar steps.</li><li>Suspend all access privileges for devices normally used by the employee, such as their laptop, phablet, or phone (employee-owned, company-provided, or both). If possible, quickly establish a captive portal or quarantine subnet to route access attempts from these devices to.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "C and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Option A unnecessarily removes the identity from your systems, and those of other systems in your federated access system; this would not be called for until the fate of the employee is known to warrant a permanent removal of access privileges. <br>Options B and C still allow devices that the employee had been known to use to access your systems; if the employee, these devices, or both are in hostile hands, this places your systems at risk. <br>Option D is the most secure response.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      546,
      542,
      281,
      557,
      555
    ],
    "source": ""
  },
  {
    "id": 258,
    "question": "In the measurement of biometric accuracy, which of the following is commonly referred to as a \u201cType 2 error\u201d?",
    "choice_a": "Cross-over error rate (CER)",
    "choice_b": "Rate of false rejection\u2014false rejection rate (FRR)",
    "choice_c": "Input/output per second (IOPS)",
    "choice_d": "Rate of false acceptance\u2014false acceptance rate (FAR)",
    "correct_answer": "D",
    "explanation": "Type 1 errors are false rejections.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      483,
      484,
      374,
      298,
      342
    ],
    "source": ""
  },
  {
    "id": 259,
    "question": "Which statement about subjects and objects is <italic>not</italic> correct?",
    "choice_a": "Subjects are what users or processes require access to in order to accomplish their assigned duties.",
    "choice_b": "Objects can be people, information (stored in any fashion), devices, processes, or servers.",
    "choice_c": "Objects are the data that subjects want to access in order to read it, write to it, or otherwise use it.",
    "choice_d": "Subjects are people, devices, or processes.",
    "correct_answer": "A",
    "explanation": "Subjects, by definition, want to do something that involves an object. Thus, Option A has these roles reversed. Subjects can be any kind of entity that can take action. Objects contain information, but also can provide requested services (i.e., take action upon request), so B and C are correct.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      555,
      540,
      556,
      557,
      542
    ],
    "source": ""
  },
  {
    "id": 260,
    "question": "Which step in the identity management process is where credentials or other attestations are confirmed or validated?",
    "choice_a": "Proofing",
    "choice_b": "Provisioning",
    "choice_c": "Revocation",
    "choice_d": "Deletion",
    "correct_answer": "B",
    "explanation": "The other options address how an identity is established, managed, or terminated once the subject's claims to that identity have been ascertained to be true.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      542,
      540,
      708,
      726,
      281
    ],
    "source": ""
  },
  {
    "id": 261,
    "question": "A university records database application is used by academic advisers to access records about course enrollment, financial aid, and other information. If a record contains information about a special needs accommodation, the adviser may be denied access to the existence of the student's request for such accommodations or information such as doctors' statements that attest to the need. Only specific university staff would have the necessary access control rights to view records that contain any information about medical or other justifications for special accommodation. In this scenario, what would be the most appropriate access control model to deploy?",
    "choice_a": "Discretionary access control",
    "choice_b": "Context-based access control",
    "choice_c": "Content-dependent access control",
    "choice_d": "Role-based access control",
    "correct_answer": "C",
    "explanation": "Option D is incorrect, since same employee can access all fields of other records. <br>Option B is incorrect, since there are no constraints set for time of day and so forth. <br>Option A is incorrect, because nothing in the scenario addresses changes to security policies or attributes. <br>Option C is correct: content-dependent means presence or absence of data that meets constraint conditions.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      555,
      557,
      330,
      345,
      354
    ],
    "source": ""
  },
  {
    "id": 262,
    "question": "An access control implementation where access permissions are allocated based on several subjects performing identical or similar functions is referred to as:",
    "choice_a": "Rule-based access control",
    "choice_b": "Discretionary access control",
    "choice_c": "Role-based access control",
    "choice_d": "Temporal access control",
    "correct_answer": "C",
    "explanation": "One subject (person or process) may be capable of performing many functions (roles), each of which may require different access control constraints or conditions.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      539,
      537,
      538,
      540,
      555
    ],
    "source": ""
  },
  {
    "id": 263,
    "question": "RADIUS uses what kind of security model?",
    "choice_a": "Centralized",
    "choice_b": "Token-based",
    "choice_c": "Decentralized",
    "choice_d": "Whitelisting",
    "correct_answer": "C",
    "explanation": "Note that <italic>centralized</italic> and <italic>decentralized</italic> can be used to refer either to one vs. several servers, working in collaboration, to implement a single access control system,which is what RADIUS does, as well as refer to the strategy choice about one versus many places that decisions can be made across larger systems.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      345,
      273,
      557,
      333,
      5
    ],
    "source": ""
  },
  {
    "id": 264,
    "question": "What is an authorization table?",
    "choice_a": "A matrix of access control objects, access control subjects, and their respective rights",
    "choice_b": "A service or program where access control information is stored and where access control decisions are made",
    "choice_c": "A listing of access control objects, policies, and procedures and their respective rights",
    "choice_d": "A record of all denied and permitted access control attempts",
    "correct_answer": "A",
    "explanation": "The table contains the information for making access control decisions; it does not make them, nor track the instances of results of such decisions. Thus, Options B and D are incorrect. Policies and procedures are not part of this table.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      537,
      286,
      273,
      557,
      354
    ],
    "source": ""
  },
  {
    "id": 265,
    "question": "Due care means:",
    "choice_a": "Auditing your systems and procedures for compliance",
    "choice_b": "Doing what you have to do to fulfill your responsibilities",
    "choice_c": "Making sure that actions you've taken to fulfill your responsibilities are working correctly and completely",
    "choice_d": "Reading and reviewing the reports from subordinates or from systems monitoring data",
    "correct_answer": "B",
    "explanation": "Options A and C are both examples of due care; due diligence is the verification that all is being done well and that nothing is not done properly. <br>Option D can be an important part of due diligence but is missing the potential for follow-up action. <br>Option B is a correct example of due care.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      32,
      31,
      30,
      33,
      29
    ],
    "source": ""
  },
  {
    "id": 266,
    "question": "Which canon of the ISC2 Code of Ethics would best apply in the following scenario? You work on the IT team at a medical insurance claims processing company that handles over a million patient claims per year. A recent vulnerabilities assessment indicates that patient data of all types is not encrypted, at all, and that the systems could easily be breached and the data exfiltrated from the company. Rather than spend the money and effort to harden the system, management has chosen to transfer this risk in part to liability insurance for its managing directors, and in part to the patients themselves in case a breach and data loss does occur.",
    "choice_a": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_b": "Provide diligent and competent service to your principals.",
    "choice_c": "Advance and protect the profession.",
    "choice_d": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "correct_answer": "D",
    "explanation": "The greater potential for harm is to the individual patients, who have implicitly trusted your company to protect their data, their money, and their lives as you handle their claims.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      31,
      32,
      30,
      28,
      20
    ],
    "source": ""
  },
  {
    "id": 267,
    "question": "Accountability for protecting information rests with whom?",
    "choice_a": "Owner",
    "choice_b": "User(s)",
    "choice_c": "Data custodian",
    "choice_d": "Systems administrators",
    "correct_answer": "A",
    "explanation": "Owners may depend on these or other persons as part of achieving required levels of information security, but they cannot delegate their ultimate responsibilities.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      30,
      31,
      32,
      21,
      461
    ],
    "source": ""
  },
  {
    "id": 268,
    "question": "Everyone is responsible for following information policies, but who is ultimately responsible for information security?",
    "choice_a": "Senior management",
    "choice_b": "Information security team",
    "choice_c": "Users",
    "choice_d": "Auditors",
    "correct_answer": "A",
    "explanation": "Managing directors and even board of directors' members are, legally, the ones with total responsibility for the organization, its assets, liabilities, and decisions. This does not and cannot change by delegating decisions and authority downward to subordinates.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      30,
      31,
      32,
      21,
      29
    ],
    "source": ""
  },
  {
    "id": 269,
    "question": "Keeping your information systems safe and secure requires all of the following actions be taken, except one. Which is not required?",
    "choice_a": "Installing security systems that are easy to use, maintain, and monitor",
    "choice_b": "Integrating security systems with effective end-user security training",
    "choice_c": "Using organization wide risk assessments to set priorities for identifying and resolving vulnerabilities in IT systems",
    "choice_d": "Contracting with professional IT security firms to establish, operate, and monitor your information security systems and practices",
    "correct_answer": "D",
    "explanation": "Organizations may need outside talent for a variety of reasons, but they are not required to attain cost-effective information security.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      29,
      25,
      31,
      30,
      491
    ],
    "source": ""
  },
  {
    "id": 270,
    "question": "Nonrepudiation of a message ensures that a message:",
    "choice_a": "Can be attributed to a particular author",
    "choice_b": "Is always sent to the intended recipient",
    "choice_c": "Can be attributed to a particular recipient",
    "choice_d": "Is always received by the intended recipient",
    "correct_answer": "A",
    "explanation": "Nonrepudiation means that a subject cannot later deny that they sent a message, took an action, or attempted to take an action. Other forms of information security, such as integrity, address the concerns in the other options.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      576,
      25,
      578,
      27,
      23
    ],
    "source": ""
  },
  {
    "id": 271,
    "question": "The primary concerns of the information security practitioner are:",
    "choice_a": "That network and systems access controls prevent any unauthorized access or penetration into the organization's systems",
    "choice_b": "That all security plans, procedures, and policies issued by senior organizational management and leadership are implemented effectively",
    "choice_c": "The security and availability of the hardware, software, communications, and data that make up the IT infrastructure the organization depends on",
    "choice_d": "That all information systems, assets, processes, and data are kept secure, safe, reliable and available, in accordance with the organization's overall risk management posture and plan",
    "correct_answer": "D",
    "explanation": "All risks pertaining to the information the organization needs in order to survive and conduct its business are what the information security professional must focus on. That includes all of the other options and more.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      25,
      27,
      31,
      32,
      30
    ],
    "source": ""
  },
  {
    "id": 272,
    "question": "What term is associated with criticality?",
    "choice_a": "Availability",
    "choice_b": "Reliability",
    "choice_c": "Integrity",
    "choice_d": "Resiliency",
    "correct_answer": "A",
    "explanation": "Availability embraces concepts such as maximum allowable outage or time to restore, all based on mission needs; this is what \u201ccritical\u201d means.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      24,
      25,
      29,
      27,
      33
    ],
    "source": ""
  },
  {
    "id": 273,
    "question": "Your boss says that since everything the company does with its information is all in the cloud platforms they use, the company have no need for physical security. How might you best respond?",
    "choice_a": "That's correct, since the cloud services provider and our ISP handle physical security for their systems and everything using them.",
    "choice_b": "Actually, we still rely on our endpoint devices and our local area networks and connectivity; plus, we still have a lot of paper-based business processes and records that we keep.",
    "choice_c": "That's a good point, and since our office spaces are secured and alarmed by the building's owners and managers, they've provided for the rest.",
    "choice_d": "We could simplify the physical IT security situation even more, or eliminate it as a worry completely, if we shifted over to a bring-your-own-device strategy for everything.",
    "correct_answer": "B",
    "explanation": "Endpoint security and noncomputerized information still need physical protection, including paying due care and due diligence to back up, restore, archive, and other needs. No amount of bring-your-own (be it device, cloud, or infrastructure) will make that part of your threat surface go away.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      32,
      31,
      30,
      588,
      722
    ],
    "source": ""
  },
  {
    "id": 274,
    "question": "Business logic is:",
    "choice_a": "A set of tasks that must be performed to achieve and objective within cost and schedule constraints",
    "choice_b": "The set of rules and constraints that drive a business to design a process that gets business done correctly and effectively",
    "choice_c": "Software and data used to process transactions and maintain accounts or inventories correctly",
    "choice_d": "The design of processes to achieve an objective within the rules and constraints the business must operate within",
    "correct_answer": "D",
    "explanation": "The logic is the set of steps and decisions necessary to achieve the objective; some of those decisions may compare intermediate results with constraints and then branch to alternate steps in the logic to make corrections, for example. The rules and constraints by themselves are not the business logic. Processes (software or people procedures) are not the business logic, but they should accurately and effectively implement that logic.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      462,
      487,
      493,
      515,
      570
    ],
    "source": ""
  },
  {
    "id": 275,
    "question": "When you compare safety to security for information systems, which of the following statements is correct?",
    "choice_a": "When information security measures fail to keep critical data available and correct, the resulting system malfunctions could lead to loss of revenue, property damage, injury, or death.",
    "choice_b": "Operating a system in an unsafe manner could be introducing information that further corrupts the system, violating its integrity or leading to it crashing, which violates availability needs.",
    "choice_c": "Keeping a system safe also means \u201csafe from harm,\u201d and thus, means much the same as keeping it secure.",
    "choice_d": "Safe system operation is the responsibility of its designers, builders, and operators; the information security people have no role in that, and thus, safety and security are unrelated concepts.",
    "correct_answer": "A",
    "explanation": "\u201cSafety\u201d for information systems can mean keeping the system causing injury to others or damage to their property\u2014to customers, users, or bystanders. Thus, Option A is most correct. <br>Option B is true as stated, but it reverses cause and effect and is thus, incorrect. <br>Option C makes no distinction between safety and security, which is incorrect. <br>Option D is incorrect in that it tries to separate safety and security when they are in fact related to each other.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      25,
      33,
      26,
      27,
      31
    ],
    "source": ""
  },
  {
    "id": 276,
    "question": "Which statement about phishing attacks is most correct?",
    "choice_a": "Phishing attacks are rarely successful, and so they pose very low risk to organizations.",
    "choice_b": "Spear phishing attacks are easy to detect with scanners or filters.",
    "choice_c": "You can safely reply to an email you don't recognize and ask to be removed from their mailing list; this is not part of a phishing attack.",
    "choice_d": "Phishing attacks of all kinds are still in use, because they can be effective social engineering tools when trying to do reconnaissance or gain illicit entry into an organization or its systems.",
    "correct_answer": "D",
    "explanation": "Option A is false; even if thousands of phishing emails are sent as part of a low and slow attack, one response can generate exploitable information for the attacker. <br>Option C is false; in doing so, you confirm that your email address connects to a real (and somewhat under-informed) person. Expect more. <br>Option B is false; attackers work hard to mimic the style, format, expression, and construction of their phishing emails and continually attempt to spoof email addresses, domain names, and so forth. Tools may filter a lot of such junk email for you, but it won't catch it all. <br>Option D is most correct.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      29,
      724,
      725,
      28,
      26
    ],
    "source": ""
  },
  {
    "id": 277,
    "question": "You work with a small start-up company that depends on dynamic collaboration with many outside agencies, companies, and academic organizations, as well as with its potential customers and investors, to turn ideas into products and marketing strategies. These ideas and strategies are the intellectual property of your employer and need to be protected, while at the same time they depend on collaboration to produce in the first place. Which of the following would you recommend be the first that the company invest in and make use of?",
    "choice_a": "More rigorous access control systems, using multifactor authentication",
    "choice_b": "More secure, compartmented collaboration software suites, tools, and procedures",
    "choice_c": "Better, more focused education and open dialogue with company staff about the risks of too much open collaboration",
    "choice_d": "Better work on our information risk management efforts, to include an information security classification process which our teammates can use effectively",
    "correct_answer": "C",
    "explanation": "Options A and B are incorrect; tempting as they are to the geek in us, they are not the first place that effort needs to be spent. <br>Option D is a necessary and vital task, but given the dynamics of this organization, it sounds like Option C is the most immediate need. Getting this small group of people totally focused on protecting their own future while collaborating with many others in building that future is going to be key to success; thus, more dialogue (C) can lead to a better, more informed, and effective information risk management and classification approach (D).",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      30,
      32,
      569,
      26,
      20
    ],
    "source": ""
  },
  {
    "id": 278,
    "question": "As an SSCP, which statement bests describes your involvement with physical security?",
    "choice_a": "Little or no involvement; building or facilities management and any security guards should handle this.",
    "choice_b": "You ensure that key systems elements, such as server rooms and wiring closets, are kept locked at all times.",
    "choice_c": "You're only involved with physical security of information assets and systems elements during security audits or penetration testing.",
    "choice_d": "You plan, help implement, review, and assess the physical security of IT systems and information assets, based on your organization's prioritized risk mitigation strategy.",
    "correct_answer": "D",
    "explanation": "As an SSCP, all that you do should (moral imperative) be driven by the organization's mission needs, including its risk management and mitigation strategies.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      30,
      572,
      722,
      462,
      27
    ],
    "source": ""
  },
  {
    "id": 279,
    "question": "Which of the following is <italic>not</italic> true of policies?",
    "choice_a": "Policies are what are called \u201cdirective\u201d controls.",
    "choice_b": "Policies direct or mandate the behavior of the employees of the organization.",
    "choice_c": "Policies prescribe how an organization manages, protects, and distributes information.",
    "choice_d": "Policies are often a collection of ideas.",
    "correct_answer": "D",
    "explanation": "Policies state, assert, or direct required behavior.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      570,
      572,
      31,
      30,
      579
    ],
    "source": ""
  },
  {
    "id": 280,
    "question": "As part of your organization's IT security team, how would you expect to be involved in changes or updates to the system?",
    "choice_a": "Reviewing every proposed change to the software, hardware, communications, or data",
    "choice_b": "Participating during audits of the configuration management and systems build logs and records",
    "choice_c": "Testing major changes or updates to operating systems or applications",
    "choice_d": "No involvement; the IT staff of developers, testers, and the configuration management technicians should be the only ones involved with systems changes.",
    "correct_answer": "B",
    "explanation": "Most organizations do not need IT security staff involved in reviewing every patch, update, or change being applied to a system; thus, A and C are incorrect. <br>Option B identifies a key due diligence role that IT security can perform and directly contradicts Option D, which is incorrect.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      32,
      486,
      487,
      581,
      491
    ],
    "source": ""
  },
  {
    "id": 281,
    "question": "Which of the following is the last step in any change control process?",
    "choice_a": "Implementation of change",
    "choice_b": "Monitoring of the change",
    "choice_c": "Notification of the completion",
    "choice_d": "Testing of the change",
    "correct_answer": "C",
    "explanation": "The correct order for change control is to plan, assess, decide/direct, implement, test/verify, and notify upon completion. Monitoring throughout, as well as informed user involvement, is vital to informed consent and control.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      487,
      488,
      486,
      579,
      580
    ],
    "source": ""
  },
  {
    "id": 282,
    "question": "Which of these tasks would be part of managing information assets or IT assets?",
    "choice_a": "Implementing an acceptable use policy",
    "choice_b": "Reviewing your IT team's approach to configuration management and control of software, hardware, and data",
    "choice_c": "Letting users decide when and how to perform software updates on endpoint devices they use",
    "choice_d": "Ensuring that all sensitive information, of any kind, is covered by nondisclosure agreements",
    "correct_answer": "B",
    "explanation": "Asset management involves knowing what systems, hardware, software, and other elements are used by the organization and ensuring that they are maintained and changed in authorized and controlled ways. Thus, Option B is most correct. <br>Option C suggests no management of endpoint software, which is very risky. <br>Options A and D have nothing to do directly with managing IT or information assets, although they are important elements of an information security posture and program.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      579,
      581,
      486,
      492,
      491
    ],
    "source": ""
  },
  {
    "id": 283,
    "question": "Does each layer of security need to have preventive, detective, and corrective capabilities?",
    "choice_a": "No, only the highest-priority vulnerabilities in your threat surface need all three control types.",
    "choice_b": "Yes, because you'll need to be able to detect, isolate, contain, and correct even threats that are not layer dependent.",
    "choice_c": "Yes, but there will be situations in which elements at higher levels of security in your architecture will have to manage, direct, or perform these functions for elements at lower levels.",
    "choice_d": "Yes, but oftentimes, other elements in other layers of your security architecture will need to reach further in, in order to be able to detect, isolate, or correct.",
    "correct_answer": "C",
    "explanation": "Risk mitigation by means of countermeasures (to detect, prevent, correct) must be cost-effective; trade-offs will have to be made. When this happens, the \u201creach\u201d should be from higher levels of security down to detect, prevent, or correct.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      516,
      518,
      487,
      515,
      493
    ],
    "source": ""
  },
  {
    "id": 284,
    "question": "How should you use CVE data as part of risk assessment?",
    "choice_a": "It should provide most, if not all, of the vulnerability information you need to implement risk mitigation.",
    "choice_b": "It should be a source of vulnerabilities to check your systems against while you're conducting a more thorough business impact assessment.",
    "choice_c": "It provides good insight as to vulnerabilities that might exist in company-developed IT elements.",
    "choice_d": "Since the vast majority of systems in use are based on Windows, if your business does not use Windows platforms you can probably avoid the expense of investigating CVE for vulnerability information.",
    "correct_answer": "B",
    "explanation": "Option B correctly states that the business impact analysis (BIA) should drive how you assess systems for vulnerabilities and choose to mitigate them, based on business or organizational mission priorities. <br>Option A is false, as common vulnerabilities and exploits data won't help you find improper configuration settings (such as using default sysadmin passwords) or other procedural weaknesses in your systems' design and use. <br>Option C is false; \u201ccommon\u201d does mean common to many users of operating systems or commercial product applications. <br>Option D is false.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      518,
      462,
      27,
      25,
      31
    ],
    "source": ""
  },
  {
    "id": 285,
    "question": "Under what circumstances can an information systems security audit be conducted without relying on certified, qualified external auditors?",
    "choice_a": "There are no such circumstances in which this could be legal or advisable.",
    "choice_b": "As part of informal or in-house efforts to assess risk or identify management challenges",
    "choice_c": "As part of the response to a serious information security incident",
    "choice_d": "As a way to reduce costs and complexity involved in preparing compliance reports",
    "correct_answer": "B",
    "explanation": "Informal audits can be great ways to familiarize staff with compliance requirements and controls used by the organization, or to illuminate possible risks or the absence of controls. They should never be used in circumstances involving legal or regulatory compliance concerns, or possible litigation.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      489,
      490,
      491,
      492,
      493
    ],
    "source": ""
  },
  {
    "id": 286,
    "question": "What might be the most important things that an audit report should communicate to senior management?",
    "choice_a": "Specific details of systems, data, and files audited",
    "choice_b": "Identify missing or out-of-date procedures and documentation",
    "choice_c": "Specific details of errors discovered by the auditors",
    "choice_d": "Recommendations for reducing risks, increasing compliance to required levels, or other recommendations for process and product improvement",
    "correct_answer": "D",
    "explanation": "Recommendations as to achieving better audit compliance in the future are most likely inferred, implied, or based on the more detailed evidence addressed by the other options.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      492,
      493,
      489,
      491,
      488
    ],
    "source": ""
  },
  {
    "id": 287,
    "question": "Which of the following would not be included as part of \u201chardening\u201d?",
    "choice_a": "Disabling certain functionality",
    "choice_b": "Changing default passwords",
    "choice_c": "Initial information security training for all newly hired employees",
    "choice_d": "Physical security",
    "correct_answer": "C",
    "explanation": "While a well-trained work force with a strongly held security consciousness or culture is vital to safety and security, it takes far more than typical initial orientation training to achieve this. The rest are (or should be) part of normal computer security hygiene measures to the degree required by the risk assessment.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      29,
      31,
      487,
      579,
      581
    ],
    "source": ""
  },
  {
    "id": 288,
    "question": "Which statement correctly describes the usefulness of CVE data as part of your risk mitigation planning?",
    "choice_a": "It should provide most, if not all, of the vulnerability information you need to implement risk mitigation.",
    "choice_b": "Since hackers use CVE data to aid in planning their attacks, this should be the first place you look for insight as you do emergency hardening of your IT systems. Once these obvious vulnerabilities have been mitigated, a more complete vulnerability assessment should be done.",
    "choice_c": "It's a great source of information for known systems elements and known vulnerabilities associated with them, but it does nothing for vulnerabilities that haven't been reported yet or for company-developed IT elements.",
    "choice_d": "Since the vast majority of systems in use are based on Windows, if your business does not use Windows platforms you can probably avoid the expense of investigating CVE for vulnerability information.",
    "correct_answer": "C",
    "explanation": "Option B does correctly state the risk that attackers may know more about your systems than you do if you haven't thoroughly checked CVE data as part of your vulnerabilities assessment. But it incorrectly goes on to suggest that you fix those first\u2014they may not relate to your organization's highest-priority impacts as spelled out by the business impact analysis (BIA). <br>Option A is therefore false. <br>Option D is also false, since even the most Linux-based of organizations will probably have non-Linux systems elements (such as network components) that CVE could have information about.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      516,
      518,
      487,
      493,
      569
    ],
    "source": ""
  },
  {
    "id": 289,
    "question": "Audit reports usually contain which of the following sets of sections?",
    "choice_a": "Executive summary, detailed report",
    "choice_b": "Scope, summary report",
    "choice_c": "Executive summary, audit recommendations",
    "choice_d": "Management response, audit findings",
    "correct_answer": "A",
    "explanation": "Management responds to the audit report after reading it; findings need to be reported before making recommendations.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      492,
      493,
      517,
      518,
      487
    ],
    "source": ""
  },
  {
    "id": 290,
    "question": "There are many good reasons why even the smallest business or organizations should worry about configuration management and patch management, including all of the following except:",
    "choice_a": "Uncontrolled and unmanaged \u201cpush\u201d updates to operating systems and critical applications can disrupt your business activities.",
    "choice_b": "Your employees can make changes to their endpoints, or to systems they access with those endpoint devices, in ways that can disrupt your business.",
    "choice_c": "Change management, including access control systems, are your first line of defense against attackers.",
    "choice_d": "Change management and control processes can help your users be better informed so that they can do their jobs better.",
    "correct_answer": "D",
    "explanation": "User knowledge and awareness of changes is a vital part of change management and control, but it is part of the process, not the goal. The other options all address aspects of risks and vulnerabilities, and the role of change management in reducing those risks.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      581,
      487,
      488,
      486,
      579
    ],
    "source": ""
  },
  {
    "id": 291,
    "question": "Why are shadow IT systems an issue for information security?",
    "choice_a": "These are exploits and malware found on the dark web and, as such, must be considered hostile to your organization's goals and objectives. They should be banned from the business and its systems by policy.",
    "choice_b": "Most are written by well-intended users and may be widely used by people in the organization, but quite often they are not subjected to even the most basic software quality assurance measures and are outside of configuration management and control. Hence, they pose potential risks to the IT architecture.",
    "choice_c": "Organizations routinely spend more time double-checking the results of such systems, which is effort that could be spent on other problems.",
    "choice_d": "As long as common vulnerabilities have been addressed (for example, by blocking the use of unsigned macros in Microsoft Office), shadow IT components are no more likely to introduce risks than other IT systems.",
    "correct_answer": "B",
    "explanation": "Option B correctly describes what shadow IT systems are; thus, Option A is false. <br>Option C demonstrates that in many cases, it cannot be shown that shadow IT systems taken as a whole correctly perform business logic or that they attain the C-I-A levels commensurate with the impacts if they fail. <br>Option D is false; custom software systems such as these are normally not reported to common vulnerability channels.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      486,
      579,
      581,
      25,
      29
    ],
    "source": ""
  },
  {
    "id": 292,
    "question": "Does a security awareness program need to be reinforced by policy?",
    "choice_a": "No, because specific constraints, such as acceptable use, address details necessary for effective security.",
    "choice_b": "Yes, to avoid users from being lulled into complacency and thinking that information security is someone else's job.",
    "choice_c": "Yes, because the policies would carry the constraints and incentives for correct security behavior, while providing directives as to required tasks to perform.",
    "choice_d": "No; policies in general are not related to user training and education.",
    "correct_answer": "C",
    "explanation": "Policies are the best vehicle to communicate broad and enduring direction to the organization's workforce or constituents; as such, they should reinforce and be reinforced by education, training, and on the job procedures.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      29,
      30,
      31,
      32,
      490
    ],
    "source": ""
  },
  {
    "id": 293,
    "question": "Baselines are:",
    "choice_a": "Collection of hardware and software",
    "choice_b": "Minimum levels of security",
    "choice_c": "Step-by-step instructions",
    "choice_d": "Suggestions",
    "correct_answer": "B",
    "explanation": "Baselines are both the sets of hardware, software, connections, and procedures, and the inventory listings of everything in a baseline and what its current version is.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      606,
      617,
      36,
      45,
      39
    ],
    "source": ""
  },
  {
    "id": 294,
    "question": "The process of identifying and evaluating risk based on level of importance is referred to as:",
    "choice_a": "Risk management",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transference",
    "choice_d": "Risk assessment",
    "correct_answer": "D",
    "explanation": "Risk management includes multiple activities, such as risk assessment. Transference and acceptance are choices about how to deal with risks.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      56,
      42,
      66,
      36,
      54
    ],
    "source": ""
  },
  {
    "id": 295,
    "question": "What is the most often-overlooked weakness in the way that layered defenses are built and operated?",
    "choice_a": "Integrated, automated systems status, state, and health checks that can validate proper update and patch levels, malware definition files, etc., are installed correctly",
    "choice_b": "Synchronizing the clocks on all devices throughout the organization's systems and networks",
    "choice_c": "Monitoring and analysis of data from all security sensor devices",
    "choice_d": "Having seamless, integrated communications with all elements, at all layers, of the defense, as part of integrated command and control of the total security architecture",
    "correct_answer": "D",
    "explanation": "While the other options are vital components of a strong, layered security architecture, without the communications, command, and control ability to integrate it and operate it seamlessly, the systems are still at significant risk.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      40,
      51,
      49,
      65,
      55
    ],
    "source": ""
  },
  {
    "id": 296,
    "question": "Which of the following statements about information risk management is true?",
    "choice_a": "Risk management is a major investment of time, effort, and money, and should only be done when major changes outside of the organization are happening.",
    "choice_b": "Risk management should be an ongoing, cyclic set of tasks, as part of maintaining constant awareness to a changing business and threat landscape.",
    "choice_c": "Risk management should be no more than an annual review activity, resulting in few actions to perform, for most small to medium-sized organizations.",
    "choice_d": "Risk management, like risk itself, is often best transferred to outside experts.",
    "correct_answer": "B",
    "explanation": "The people who own and run a business have ultimate responsibility for success or failure; if they choose to ignore risk by under-managing it, at best, they are gambling on bad things not happening.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      64,
      58,
      59,
      41,
      56
    ],
    "source": ""
  },
  {
    "id": 297,
    "question": "A security audit is best defined as?",
    "choice_a": "A covert series of tests designed to test network authentication, hosts, and perimeter security",
    "choice_b": "A technical assessment that measures how well an organization uses security policies and controls to protect its information assets",
    "choice_c": "The use of intrusion detection systems (IDSs) to monitor anomalous traffic on a network segment and logging attempted break-ins",
    "choice_d": "The hardening of systems before deploying them on the corporate network",
    "correct_answer": "B",
    "explanation": "Audits in general compare how well you understand, implement, and follow standards, practices, policies, and procedures.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      57,
      52,
      39,
      36,
      58
    ],
    "source": ""
  },
  {
    "id": 298,
    "question": "In penetration testing, which of the following equates to zero, partial, and full knowledge testing?",
    "choice_a": "Blind, double blind, and white",
    "choice_b": "Reconnaissance, foot-printing, gathering",
    "choice_c": "Black, gray, white",
    "choice_d": "Black, full, double blind",
    "correct_answer": "C",
    "explanation": "A \u201cblack box\u201d test is one in which you know nothing about what's inside the box; you only know what you can learn by watching how it interacts with the outside world. A blind test is the test team having zero (insider) knowledge of the system being pen tested.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      628,
      629,
      617,
      36,
      57
    ],
    "source": ""
  },
  {
    "id": 299,
    "question": "Security requirements should be considered as what type of requirements?",
    "choice_a": "Functional requirements",
    "choice_b": "Nonfunctional requirements",
    "choice_c": "Unallocated requirements",
    "choice_d": "Allocated requirements",
    "correct_answer": "A",
    "explanation": "With today's greater (and wiser) emphasis on security, nearly every security need can and should be linked to a verifiable, testable aspect or feature of the information architecture and the hardware, software, data, and procedures used with it.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      36,
      42,
      38,
      50,
      57
    ],
    "source": ""
  },
  {
    "id": 300,
    "question": "The ALE (annualized loss expectancy) calculation is an example of which of the following?",
    "choice_a": "Threat identification",
    "choice_b": "Qualitative risk analysis",
    "choice_c": "Quantitative risk analysis",
    "choice_d": "Vulnerability management",
    "correct_answer": "C",
    "explanation": "Identify the threat and the corresponding vulnerabilities; if you can, estimate the numbers for frequency of occurrence, single loss exposure, and so forth. If you cannot reasonably estimate, you can characterize as high/medium/low (qualitative analysis). Vulnerability management, not a normal term that we use, would refer to mitigation efforts.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      456,
      598,
      597,
      596,
      614
    ],
    "source": ""
  },
  {
    "id": 301,
    "question": "Which of the following penetration testing strategies best models what a real attacker might be able to achieve in an attack against an organization's information systems?",
    "choice_a": "Double-blind",
    "choice_b": "Blind",
    "choice_c": "Internal",
    "choice_d": "Targeted",
    "correct_answer": "A",
    "explanation": "Double-blind testing requires that the bare minimum of senior leadership, IT, and operational managers and staff know of the test, and that test team \u201cattackers\u201d are realistically acting as naive outsiders, to make the test as realistic as possible.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      629,
      628,
      57,
      54,
      53
    ],
    "source": ""
  },
  {
    "id": 302,
    "question": "Which statement regarding Recovery Point Objective (RPO) and Recovery Time Objective (RTO) is correct?",
    "choice_a": "RTO is always greater than RPO.",
    "choice_b": "RPO is about data recovery; RTO is about lost time from business activities.",
    "choice_c": "RTO refers to time before the disruption occurs, whereas RPO refers to a time after the disruption's occurrence.",
    "choice_d": "RPO and RTO are always equal periods of time.",
    "correct_answer": "B",
    "explanation": "RPO is about how far back in time you fall back to re-accomplish transactions or other data changes; RTO is about how long you can afford to spend in incident response and recovery before lost business or other mission needs become too costly.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      477,
      479,
      478,
      599,
      58
    ],
    "source": ""
  },
  {
    "id": 303,
    "question": "Your organization is considering adding a series of penetration tests as part of its ongoing security assessments. It's never done penetration testing before. What kind of tests would probably not be the best to start with?",
    "choice_a": "Double-blind testing against live production systems and environments",
    "choice_b": "Full knowledge testing against test and development environments",
    "choice_c": "Internal testing",
    "choice_d": "Targeted testing",
    "correct_answer": "B",
    "explanation": "Growing your organizational abilities to make good use of penetration testing should (as in all things) start small and work your way up and out. Starting on test and development systems, which are not (normally) externally visible, is prudent.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      629,
      602,
      57,
      54,
      36
    ],
    "source": ""
  },
  {
    "id": 304,
    "question": "Social engineering attacks still present a threat to organizations and individuals for all of the following reasons, except:",
    "choice_a": "Most targeted individuals don't see the harm in responding or in answering simple questions posed by the attacker.",
    "choice_b": "Most people believe they are too smart to fall for such obvious ploys, but they do anyway.",
    "choice_c": "Most targeted individuals and organizations have effective tools and procedures to filter out phishing and related scams, so they are now better protected from such attacks.",
    "choice_d": "Most people want to be trusting and helpful.",
    "correct_answer": "C",
    "explanation": "Options A, B, and D all demonstrate the hallmarks of social engineering attacks\u2014they work (and have worked for thousands of years) because people are generally trusting, open, and willing to engage with strangers. <br>Option C, the correct choice, is unfortunately not true; tools may help filter out some email-based social engineering attacks, but few organizations have truly been able to operate with a \u201cloose lips sink ships\u201d approach and deal openly with customers, clients, and many other outside stakeholders.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      81,
      85,
      84,
      76,
      77
    ],
    "source": ""
  },
  {
    "id": 305,
    "question": "Which statement about containment and eradication is most correct?",
    "choice_a": "Containment and eradication are separate and distinct tasks; once containment is complete, the incident response team moves on to eradication of the causal agent(s).",
    "choice_b": "Containment and eradication usually involve the same tools and procedures, and so they often are performed simultaneously.",
    "choice_c": "Malware quarantine operations are an example of containment and eradication achieved with the same task.",
    "choice_d": "Containment primarily addresses shutting down connectivity between networks, subnets, systems, and servers. Eradication addresses locating the causal agents (malware, bogus user IDs, etc.) and removing them from each system.",
    "correct_answer": "D",
    "explanation": "Option A is incorrect; containment may occur system by system or host by host as the networks are segmented and isolated, and thus, the eradication specialists can start cleaning systems as they are isolated (or the causal agents on them are contained). <br>Option B is incorrect, because different tools are needed to disable network connections than you'd use to scan systems for malware, as an example. <br>Option C is incorrect; malware quarantine is more an example of eradication combined with recovery. <br>Option D correctly explains isolating systems and then cleaning them.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      636,
      638,
      70,
      75,
      87
    ],
    "source": ""
  },
  {
    "id": 306,
    "question": "Why is escalation part of the detection and analysis phase of an incident response?",
    "choice_a": "It will require additional resources, such as IT staff, to begin carrying out the next phases of the response plan, and this would require management approval and action.",
    "choice_b": "Management and leadership need to know that an information security incident may have occurred, and that investigation continues. Depending on the nature of the incident as understood thus, far, management may need to take additional action.",
    "choice_c": "Most organizations are unwilling to delegate authority to an incident response team leader, and thus, need to control every action, in order to exercise due diligence.",
    "choice_d": "This is required by NIST SP 800-61 Rev. 2, and in regulations that apply to the particular business or organization.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; this may be a consequence of the way that the team's detection, response, and recovery responsibilities are defined and supported, but it's not generally the case. <br>Option C is incorrect; though this might be true in some organizations, it is not related to due diligence and misstates that concept. <br>Option D is incorrect; NIST publications provide guidance, while federal regulations can make them obligatory on federal and other government activities, they do not in general dictate what the private sector must do. <br>Option B is correct; management and leadership may have legal, regulatory, or business reasons for knowing immediately that an incident might have occurred or might be occurring, but they cannot fulfill those obligations if no one on the response team tells them about it.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      101,
      83,
      99,
      97,
      69
    ],
    "source": ""
  },
  {
    "id": 307,
    "question": "Which statement about precursors and indicators is most correct?",
    "choice_a": "Precursors are events that prepare the way for an attack, such as an intrusion, to take place.",
    "choice_b": "Precursors are the observable signals from an event, which may suggest that an information systems security event may happen later.",
    "choice_c": "Indicators are the observable signals from an event, which may suggest that an information systems security event may happen later.",
    "choice_d": "Indicators are events which are part of an information security incident kill chain; warnings are the observable effects that we can detect, that tell us of the occurrence of the indicator",
    "correct_answer": "B",
    "explanation": "When it comes to incident detection, a precursor is an observable signal or result of an event, which may suggest to us that an event of interest\u2014that is, a security-related event\u2014may happen in the near future. Precursors do not, in themselves, suggest that the incident is currently happening. Thus, A is false. <br>Option C mistakes indicators for precursors. <br>Option D confuses events with the observable signals from them\u2014that is, the changes they make to target systems, which we can observe. \u201cWarnings\u201d in this context has no meaning\u2014that is, our intrusion detection system (IDS) or intrusion prevention system (IPS) technologies detect indicators and issue alarms. Thus, B is most correct.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      99,
      75,
      96,
      69,
      70
    ],
    "source": ""
  },
  {
    "id": 308,
    "question": "What is the first phase of an incident response process once the incident response team has been activated?",
    "choice_a": "Preparation",
    "choice_b": "Notification and escalation",
    "choice_c": "Containment and analysis",
    "choice_d": "Triage",
    "correct_answer": "D",
    "explanation": "First, identify the most critical potential impact or aspects of the incident, and work to contain and remediate those. The other options happen either before detection, or during all phases of response.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      99,
      69,
      71,
      96,
      101
    ],
    "source": ""
  },
  {
    "id": 309,
    "question": "Which of the following is true regarding computer intrusions?",
    "choice_a": "Covert attacks such as a distributed denial-of-service (DDoS) attack harm public opinion of an organization.",
    "choice_b": "Overt attacks are easier to defend against because they can be readily identified.",
    "choice_c": "Network intrusion detection systems (NIDSs) help mitigate computer intrusions by notifying personnel in real time.",
    "choice_d": "Social engineering attacks are less effective than technical attacks.",
    "correct_answer": "C",
    "explanation": "DDoSs are not typically done via intrusions. Just because you know the attack is coming or is happening may not make defending against it any easier. Social engineering is a fundamental part of most advanced persistent threat kill chains for one reason; it gains the attacker information and access.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      70,
      76,
      81,
      69,
      75
    ],
    "source": ""
  },
  {
    "id": 310,
    "question": "Why is effective incident management dependent on a well-written and communicated policy?",
    "choice_a": "Because it gives senior leaders and managers the tools they need to manage the incident responders.",
    "choice_b": "If things go wrong during incident response, such policies can provide proof of prior due care and due diligence.",
    "choice_c": "Personal stress levels can be high during incident response; written, well-understood policy and procedures form a solid base for training, which can contribute to minimizing overreaction or impulsivity.",
    "choice_d": "The absence of such policies, and demonstrated efforts to communicate them to staff, can jeopardize post-incident forensics investigation.",
    "correct_answer": "C",
    "explanation": "Proper preparation prevents poor performance, whether before, during, or after an incident.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      79,
      71,
      99,
      87,
      83
    ],
    "source": ""
  },
  {
    "id": 311,
    "question": "During an incident response, what's the most important set of limitations to keep in mind when searching or scanning systems, storage media, or an incident scene?",
    "choice_a": "Having the right connectivity to those systems or elements",
    "choice_b": "Legal limits regarding search or entry",
    "choice_c": "Company policies regarding access privileges",
    "choice_d": "Having the right tools and procedures to make the search meaningful during the incident response",
    "correct_answer": "B",
    "explanation": "Violating legal limits, such as searching a suspected attacker's system, could put you in jeopardy of committing a computer crime yourself!",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      659,
      660,
      662,
      658,
      639
    ],
    "source": ""
  },
  {
    "id": 312,
    "question": "You are a member of your IT department's incident response team, but you are not a trained forensics investigator. Which statement is most correct, regarding how your duties and tasks during or after an incident should consider the chain of custody?",
    "choice_a": "It has no real effect on your duties or tasks.",
    "choice_b": "It should dictate how thoroughly you make log entries or journal notes about each step you perform.",
    "choice_c": "It only affects your tasks if you have to zeroize, randomize, or cold start and restore a system or its memory.",
    "choice_d": "It limits what you can do without a forensics investigator's approval or help.",
    "correct_answer": "B",
    "explanation": "Every action you take, whether on a computer or with papers and other objects at the scene, can change or corrupt evidence. The other options may, by themselves, put you at risk of corrupting evidence.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      659,
      639,
      99,
      75,
      81
    ],
    "source": ""
  },
  {
    "id": 313,
    "question": "Selecting this type of alternate processing site would be appropriate when an organization needs a low-cost recovery strategy and does not have immediate system recovery requirements:",
    "choice_a": "Mirror site",
    "choice_b": "Warm site",
    "choice_c": "Hot site",
    "choice_d": "Mobile site",
    "correct_answer": "B",
    "explanation": "Hot site and mirror site mean the same thing (mirror all ongoing operations, as if in parallel).",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      496,
      495,
      654,
      653,
      497
    ],
    "source": ""
  },
  {
    "id": 314,
    "question": "The type of data backup that only backs up files that have been changed since the last full backup is called?",
    "choice_a": "Full backup",
    "choice_b": "Incremental backup",
    "choice_c": "Partial backup",
    "choice_d": "Differential backup",
    "correct_answer": "D",
    "explanation": "Incremental backs up subsets of files regardless of the last update date but works through all files eventually. Partial just does a selected set of files\u2014for example, for one user.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      653,
      497,
      521,
      656,
      90
    ],
    "source": ""
  },
  {
    "id": 315,
    "question": "This data backup strategy allows data backup to an offsite location via a WAN or Internet connection:",
    "choice_a": "Remote journaling",
    "choice_b": "Electronic vaulting",
    "choice_c": "RAID",
    "choice_d": "Clustering",
    "correct_answer": "B",
    "explanation": "Journaling makes note of changes (transactional). Vaulting provides full dataset backup. Other options address storage technologies.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      653,
      497,
      656,
      651,
      632
    ],
    "source": ""
  },
  {
    "id": 316,
    "question": "Which document documents the steps that should be performed to restore IT functions after a business disruption event?",
    "choice_a": "Critical business functions",
    "choice_b": "Business continuity plan",
    "choice_c": "Disaster recovery plan",
    "choice_d": "Crisis communications plan",
    "correct_answer": "C",
    "explanation": "The disaster recovery plan (DRP) lays out the step-by-step activation of more detailed response procedures. The other plans provide framework, context, or specific support (communications to public and staff alike).",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      654,
      495,
      653,
      655,
      656
    ],
    "source": ""
  },
  {
    "id": 317,
    "question": "A key escrow service is intended to allow for which of the following?",
    "choice_a": "Recovery of private keys",
    "choice_b": "Recovery of compromised public keys",
    "choice_c": "Transfer of private keys between users",
    "choice_d": "Storage of public keys",
    "correct_answer": "A",
    "explanation": "Note that any protocol supporting key escrow is only as secure as the escrow agent is trustworthy. So far, very few such proposals have won widespread trust and confidence in the market, and for good reason.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      500,
      498,
      522,
      523,
      524
    ],
    "source": ""
  },
  {
    "id": 318,
    "question": "Cryptographic implementation attacks include:",
    "choice_a": "Random number generators",
    "choice_b": "Side channel",
    "choice_c": "Fault analysis",
    "choice_d": "Probing",
    "correct_answer": "B",
    "explanation": "Side-channel attacks rely on trying to infer internal behavior of the cryptosystem by externally observable signatures, such as noise or ripple on power lines and timing variations. Probing is a reconnaissance technique against web apps. The others are not related to cryptoattacks.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      147,
      145,
      143,
      663,
      664
    ],
    "source": ""
  },
  {
    "id": 319,
    "question": "Key clustering represents the significant failure of an algorithm because?",
    "choice_a": "A single key should not generate different ciphertext from the same plain text, using the same cipher algorithm.",
    "choice_b": "Two different keys should not generate the same ciphertext from the same plain text, using the same cipher algorithm.",
    "choice_c": "Two different keys should not generate different ciphertext from the same plain text, using the same cipher algorithm.",
    "choice_d": "A single key should not generate the same ciphertext from the same plain text, using the same cipher algorithm.",
    "correct_answer": "B",
    "explanation": "If this were to happen, it becomes much easier to decrypt ciphertext without knowledge of the original key. The other options show a misunderstanding of how keys map plain text to ciphertext.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      498,
      500,
      499,
      104,
      106
    ],
    "source": ""
  },
  {
    "id": 320,
    "question": "Stream ciphers are normally selected over block ciphers because of?",
    "choice_a": "The high degree of strength behind the encryption algorithms",
    "choice_b": "The high degree of speed behind the encryption algorithms",
    "choice_c": "Their ability to use large amounts of padding in encryption functions",
    "choice_d": "Their ability to encrypt large chunks of data at a time",
    "correct_answer": "B",
    "explanation": "Stream ciphers are typically used for highly variable length plain-text inputs, such a streaming multimedia, digitized voice, and so forth.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      499,
      103,
      104,
      122,
      116
    ],
    "source": ""
  },
  {
    "id": 321,
    "question": "The amount of time or effort required to break an encryption algorithm is referred to as the:",
    "choice_a": "Key strength",
    "choice_b": "Computational infeasibility",
    "choice_c": "Measure of merit",
    "choice_d": "Work factor",
    "correct_answer": "D",
    "explanation": "Computational infeasibility means it's just not practical or possible to invert (logically reverse) some encryption algorithms; hence, they are asymmetric. Key strength is related to key length for a given algorithm. Measure of merit generally means how well suited the chosen algorithm is, all around, to the needs of the users.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      499,
      498,
      500,
      668,
      107
    ],
    "source": ""
  },
  {
    "id": 322,
    "question": "Which of the following is <italic>not</italic> an element of key management?",
    "choice_a": "Key storage",
    "choice_b": "Key space",
    "choice_c": "Key creation",
    "choice_d": "Key distribution",
    "correct_answer": "B",
    "explanation": "The key space is fixed by the choice of algorithm and the size (number of bits) of the key. The other options talk directly to what key management has to accomplish across a user population.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      500,
      498,
      499,
      523,
      672
    ],
    "source": ""
  },
  {
    "id": 323,
    "question": "Which of the following is a major problem associated with cryptography?",
    "choice_a": "Key management",
    "choice_b": "Education",
    "choice_c": "Out-of-band communications",
    "choice_d": "Permutations and transpositions",
    "correct_answer": "A",
    "explanation": "If your keys are not kept secret, you have no security. All else are details of building, using, and managing cryptosystems.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      104,
      103,
      128,
      141,
      106
    ],
    "source": ""
  },
  {
    "id": 324,
    "question": "Which of these is a characteristic of cryptosystems using symmetric encryption?",
    "choice_a": "Efficient and secure key distribution",
    "choice_b": "Fast encryption rates",
    "choice_c": "Very high work factors",
    "choice_d": "Well suited to user selection of keys and seeds",
    "correct_answer": "B",
    "explanation": "Key management is difficult to scale to large numbers of users; symmetric algorithms can be broken faster than asymmetric ones can. Thus, all that symmetric has going for it as an approach is its speed (which is why we use it in hybrid systems).",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      498,
      500,
      499,
      130,
      103
    ],
    "source": ""
  },
  {
    "id": 325,
    "question": "Asymmetric key cryptography is used for which of the following?",
    "choice_a": "Steganography, access control, nonrepudiation",
    "choice_b": "Encryption of data, nonrepudiation, access control",
    "choice_c": "Nonrepudiation, steganography, encryption of data",
    "choice_d": "Encryption of data, access control, steganography",
    "correct_answer": "B",
    "explanation": "Steganography, so far, has not shown utility or need to use encryption algorithms on top of its watermarking application.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      500,
      498,
      499,
      104,
      672
    ],
    "source": ""
  },
  {
    "id": 326,
    "question": "Which statement best explains whether cryptography can protect data in use?",
    "choice_a": "Yes, provided asymmetric encryption is used.",
    "choice_b": "Yes, provided that endpoint device security using Mobile Device Management (MDM) systems are installed and working properly.",
    "choice_c": "No, because most use of data, by people or other systems, requires data to be decrypted for use to be meaningful.",
    "choice_d": "No, because homomorphic encryption is not in widespread use as part of the infrastructure.",
    "correct_answer": "C",
    "explanation": "MDM approaches to device security help but do not keep data encrypted while it is being used. Choice of algorithm has no bearing on this. And while some analytics processing may be possible on data encrypted homomorphically, actual transaction processing of encrypted data seems unlikely.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      666,
      668,
      663,
      128,
      108
    ],
    "source": ""
  },
  {
    "id": 327,
    "question": "The correct choice for encrypting the entire original data packet in a tunneled mode for an IPSec solution is?",
    "choice_a": "Generic Routing Encapsulation (GRE)",
    "choice_b": "Authentication Header (AH)",
    "choice_c": "Encapsulating Security Payload (ESP)",
    "choice_d": "Point-to-Point Tunneling Protocol (PPTP)",
    "correct_answer": "C",
    "explanation": "The other options don't address encryption of the data packet.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      124,
      110,
      107,
      146,
      116
    ],
    "source": ""
  },
  {
    "id": 328,
    "question": "Which of the following supports secure transmission of HTTP traffic?",
    "choice_a": "Kerberos",
    "choice_b": "Transport Layer Security (TLS)",
    "choice_c": "Secure Remote Password (SRP)",
    "choice_d": "Layer 2 Tunneling Protocol (L2TP)",
    "correct_answer": "B",
    "explanation": "TLS works at Layer 4 and above, which is where HTTPS operates.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      147,
      122,
      121,
      116,
      107
    ],
    "source": ""
  },
  {
    "id": 329,
    "question": "A Hashed Message Authentication Code (HMAC) works by?",
    "choice_a": "Adding a non-secret key value to the input function along with the source message",
    "choice_b": "Adding a secret key value to the output function along with the source message",
    "choice_c": "Adding a secret key value to the input function along with the source message",
    "choice_d": "Adding a non-secret key value to the output function along with the source message",
    "correct_answer": "C",
    "explanation": "The other options would not improve the integrity of the resulting hash value.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      664,
      663,
      665,
      499,
      104
    ],
    "source": ""
  },
  {
    "id": 330,
    "question": "What is the process of using a key encrypting key (KEK) to protect session keys called?",
    "choice_a": "Key storage",
    "choice_b": "Key escrow",
    "choice_c": "Key generation",
    "choice_d": "Key wrapping",
    "correct_answer": "D",
    "explanation": "The other options reflect different aspects of key generation, management and recovery, but do not address session key encapsulation (wrapping).",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      500,
      498,
      110,
      672,
      122
    ],
    "source": ""
  },
  {
    "id": 331,
    "question": "Which of the following does a digital signature <italic>not</italic> provide?",
    "choice_a": "Authentication",
    "choice_b": "Confidentiality",
    "choice_c": "Nonrepudiation",
    "choice_d": "Integrity",
    "correct_answer": "B",
    "explanation": "If confidentiality is required, encrypt the content after generating its digital signature.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      124,
      668,
      523,
      499,
      116
    ],
    "source": ""
  },
  {
    "id": 332,
    "question": "Having a voice conversation over the Internet is referred to as:",
    "choice_a": "Multicasting",
    "choice_b": "Virtual collaboration",
    "choice_c": "VOIP",
    "choice_d": "Streaming",
    "correct_answer": "C",
    "explanation": "VoIP is defined as voice over Internet Protocol.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      501,
      502,
      503,
      504,
      179
    ],
    "source": ""
  },
  {
    "id": 333,
    "question": "How is the data plane used in digital networks?",
    "choice_a": "It is used to pass control parameters to network devices such as routers, switches, and firewalls.",
    "choice_b": "It separates the flow of user data from the flow of network management information, thus, providing additional security.",
    "choice_c": "It describes how payload data flows between and within network elements.",
    "choice_d": "It is both the circuits and mechanisms by which data flows through the network, and the logical description of data flows within a network.",
    "correct_answer": "D",
    "explanation": "The \u201cplanes\u201d provide both a logical perspective on networks, as well as very effective circuit-level design and implementation.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      179,
      505,
      178,
      184,
      687
    ],
    "source": ""
  },
  {
    "id": 334,
    "question": "When comparing Transmission Control Protocol (TCP) and User Datagram Protocol (UDP), which statement is most correct?",
    "choice_a": "As a connectionless protocol, UDP provides greater reliability than TCP.",
    "choice_b": "As a connectionless protocol, UDP is well suited to multicasting of streaming media.",
    "choice_c": "As a connection protocol, UDP provides greater reliability and error correction.",
    "choice_d": "TCP lacks the ability to handle error detection and retransmission, so is more of a best-efforts protocol.",
    "correct_answer": "B",
    "explanation": "Best-efforts basis with no handshake for retransmit request means UDP is connectionless and suited for uses that are tolerant of packet dropout.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      189,
      717,
      718,
      182,
      501
    ],
    "source": ""
  },
  {
    "id": 335,
    "question": "Where would you find Address Resolution Protocol (ARP) being used?",
    "choice_a": "At the Transport layer",
    "choice_b": "At the Application layer",
    "choice_c": "At the Physical layer",
    "choice_d": "At the Data Link layer",
    "correct_answer": "D",
    "explanation": "ARP resolves IP to MAC addresses at the Data Link layer.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      505,
      504,
      179,
      180,
      468
    ],
    "source": ""
  },
  {
    "id": 336,
    "question": "Which of the following describes a bus topology?",
    "choice_a": "Each node is connected to a single backbone cable.",
    "choice_b": "Each node is connected to a device such as a switch.",
    "choice_c": "Each node requires a physical connection to a bridge.",
    "choice_d": "Each node is separated using a dividing router.",
    "correct_answer": "A",
    "explanation": "A bus does not require any one node to be functioning or to pass information and control along to the next node, unlike a ring.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      465,
      179,
      178,
      504,
      681
    ],
    "source": ""
  },
  {
    "id": 337,
    "question": "Which of the following is <italic>not</italic> an example of data packet switching technologies?",
    "choice_a": "X25",
    "choice_b": "ATM",
    "choice_c": "Frame relay",
    "choice_d": "Peer-to-peer",
    "correct_answer": "D",
    "explanation": "Peer-to-peer normally applies to services provided by one system to another without a server, thus, at higher than the network layer.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      501,
      467,
      504,
      505,
      717
    ],
    "source": ""
  },
  {
    "id": 338,
    "question": "Which statement correctly places layers of the Open Systems Interconnection (OSI) model in the correct order from highest to lowest?",
    "choice_a": "Transport, Application, Presentation",
    "choice_b": "Application, Presentation, Data Link",
    "choice_c": "Physical, Presentation, Session",
    "choice_d": "Session, Network, Transport",
    "correct_answer": "B",
    "explanation": "The layers from most abstract to least abstract are Application, Presentation, Session, Transport, Network, Data Link, and Physical.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      504,
      501,
      505,
      681,
      685
    ],
    "source": ""
  },
  {
    "id": 339,
    "question": "Most attacks today are happening at which layers of the Open Systems Interconnection (OSI) protocol stack?",
    "choice_a": "Presentation, Session, and Application",
    "choice_b": "Physical",
    "choice_c": "Data Link and Network",
    "choice_d": "Transport",
    "correct_answer": "A",
    "explanation": "The vast majority of attacks focus on web apps, which require protocols above the Transport layer.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      504,
      505,
      768,
      770,
      729
    ],
    "source": ""
  },
  {
    "id": 340,
    "question": "Which types of networks are not prone to sniffing or eavesdropping?",
    "choice_a": "Wi-Fi",
    "choice_b": "IP over fiber",
    "choice_c": "Virtual private networks (VPNs)",
    "choice_d": "IPv6",
    "correct_answer": "C",
    "explanation": "Packet sniffing or eavesdropping is not confined to the physical layer. VPNs, with their bulk encryption of routing and payload data, all but exclude packet sniffing type of attacks.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      525,
      527,
      200,
      179,
      504
    ],
    "source": ""
  },
  {
    "id": 341,
    "question": "A customer wants to keep cost to a minimum and has only ordered a single static IP address from an Internet service provider (ISP). Which of the following must be configured on the router to allow for all the computers to share the same public IP address?",
    "choice_a": "Virtual private network (VPN)",
    "choice_b": "Port Address Translation (PAT)",
    "choice_c": "Virtual local area network (VLAN)",
    "choice_d": "Power over Ethernet (PoE)",
    "correct_answer": "B",
    "explanation": "Dynamic Host Configuration Protocol (DHCP) will also be required, but if the router cannot map addresses and ports WAN-to-LAN, this won't work.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      509,
      507,
      505,
      506,
      469
    ],
    "source": ""
  },
  {
    "id": 342,
    "question": "Intrusion detection systems (IDSs) and intrusion prevention system (IPSs) use analysis engines to make decisions. Which types of algorithms do many of these analysis engines use?",
    "choice_a": "Pattern and anomaly",
    "choice_b": "Blacklisting and anomaly",
    "choice_c": "Signature and protocol",
    "choice_d": "Anomaly and signature",
    "correct_answer": "C",
    "explanation": "\u201cAnomaly detection\u201d suggests detecting something not quite normal, which current analysis engines don't support. Blacklisting is more of an access control or software installation and execution control.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      197,
      198,
      730,
      176,
      199
    ],
    "source": ""
  },
  {
    "id": 343,
    "question": "Which of the following provides a security benefit of using fiber-optic cabling over any other cabling technology?",
    "choice_a": "Faster data rates and throughput",
    "choice_b": "Less data remanence possibilities",
    "choice_c": "Harder to tap into",
    "choice_d": "Less attenuation",
    "correct_answer": "C",
    "explanation": "None of the physical media themselves have much of a data remanence vulnerability; the other options do not affect security.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      682,
      179,
      504,
      681,
      683
    ],
    "source": ""
  },
  {
    "id": 344,
    "question": "Which of the following technologies provides a means to evaluate network traffic flows and, based on a range of configurable rules, alert of possible compromise or rule anomalies?",
    "choice_a": "Terminal Access Controller Access Control System (TACACS)",
    "choice_b": "Network Intrusion Prevention (NIPS)  or  Detection (NIDS) Systems",
    "choice_c": "Server-based firewalls",
    "choice_d": "Security information and event management (SIEM)",
    "correct_answer": "B",
    "explanation": "None of the other options examine network traffic flows.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      730,
      731,
      198,
      199,
      684
    ],
    "source": ""
  },
  {
    "id": 345,
    "question": "Which statement highlights the major security benefit when comparing webs of trust with hierarchies of trust?",
    "choice_a": "Individual user decisions in webs of trust provide greater end-user confidence based on reputation.",
    "choice_b": "Hierarchies of trust systems are often implemented with open source solutions, free from vendor bias or manipulation.",
    "choice_c": "Both web and hierarchy systems provide comparable levels of security.",
    "choice_d": "The use of recognized and accepted authorities gives hierarchies of trust greater scalability and trustworthiness over time.",
    "correct_answer": "D",
    "explanation": "Certificate revocation (that is, publishing distrust of a user or trust provider) can be problematic in web of trust systems.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      192,
      168,
      164,
      163,
      167
    ],
    "source": ""
  },
  {
    "id": 346,
    "question": "Which of the following is an example of a network device that uses context-based access control?",
    "choice_a": "Static packet filter",
    "choice_b": "Network intrusion detection system",
    "choice_c": "Stateful inspection firewall",
    "choice_d": "Virtual local area network",
    "correct_answer": "C",
    "explanation": "The correct option is C, which involves keeping track of how the client and server move through activities in a session, and looking for the abnormal, using a state table to define allowable transitions.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      198,
      178,
      175,
      200,
      181
    ],
    "source": ""
  },
  {
    "id": 347,
    "question": "Which of the following is <italic>not</italic> a Bluetooth-related attack?",
    "choice_a": "Bluesnarfing",
    "choice_b": "Bluebugging",
    "choice_c": "Bluejacking",
    "choice_d": "Bluetapping",
    "correct_answer": "D",
    "explanation": "The others involve unsolicited messaging (possibly leading to denial of service), data exfiltration by fraudulent access, and taking remote control of the Bluetooth device.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 348,
    "question": "A botnet can be characterized as which of the following?",
    "choice_a": "Type of virus",
    "choice_b": "Group of dispersed, compromised machines controlled remotely for illicit reasons",
    "choice_c": "Group of dispersed machines controlled remotely",
    "choice_d": "Network used solely for internal communications",
    "correct_answer": "B",
    "explanation": "Botnets do need networks to run on, and while viruses may be part of the ways that attackers capture (take control) of a system, the tools to take such control are not part of the network of bots (or zombies, as they are also known). By definition, conversion of a system to a zombie or element of a botnet is an attack.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      264,
      267,
      231,
      265,
      201
    ],
    "source": ""
  },
  {
    "id": 349,
    "question": "One of the most common types of vulnerabilities in web-based applications is related to:",
    "choice_a": "Hard coding of encryption or other security control parameters in HTML or other web page source code",
    "choice_b": "Failure to properly validate all input data",
    "choice_c": "Allowing users to run unsigned macros or scripts as part of using the application's features and logic",
    "choice_d": "Inadequately protecting or securing built-in test or diagnostic capabilities in the application itself",
    "correct_answer": "B",
    "explanation": "This classic security flaw is completely preventable, if only software developers and their managers enforced lessons learned regarding input data validation.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      266,
      702,
      212,
      233,
      217
    ],
    "source": ""
  },
  {
    "id": 350,
    "question": "Which of the following social engineering attacks do not attempt to masquerade as legitimate business or social correspondence?",
    "choice_a": "Phishing",
    "choice_b": "Whaling",
    "choice_c": "Spear phishing",
    "choice_d": "Scareware",
    "correct_answer": "D",
    "explanation": "Scareware attempts to masquerade as warnings from antimalware or other security software.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      259,
      263,
      701,
      702,
      703
    ],
    "source": ""
  },
  {
    "id": 351,
    "question": "Mobile device management (MDM) solutions are a good way for organizations to manage the requirements for protecting the use of mobile devices in accessing the network and its services. Which of the following is <italic>not</italic> supported by MDM solutions?",
    "choice_a": "Remote device locking",
    "choice_b": "Remote wiping capabilities",
    "choice_c": "Protection of the pin access to the device",
    "choice_d": "Virtual private network (VPN) configuration",
    "correct_answer": "C",
    "explanation": "Ultimately, endpoint security will rely on what the user knows, even if other factors are used as well.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      705,
      707,
      706,
      259,
      265
    ],
    "source": ""
  },
  {
    "id": 352,
    "question": "Which of the following is <italic>not</italic> a standard service model in cloud computing?",
    "choice_a": "Software as a service",
    "choice_b": "Platform as a service",
    "choice_c": "Private cloud as a service",
    "choice_d": "Application as a service",
    "correct_answer": "C",
    "explanation": "\u201cPrivate\u201d refers to a single organizational tenant or user of the cloud, while the other options define how that cloud's services will be provisioned, managed and used. Thus, a \u201ccloud\u201d is not a \u201cservice.\u201d.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      535,
      697,
      746,
      745,
      201
    ],
    "source": ""
  },
  {
    "id": 353,
    "question": "Which of the following cloud deployment models would be best suited for state and local governments to use with businesses and individuals in their service areas?",
    "choice_a": "Public cloud",
    "choice_b": "Community cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "GovCloud",
    "correct_answer": "A",
    "explanation": "GovCloud is used for highly secure government activities. Community cloud is shared infrastructure, probably raising costs to each sponsoring organization, and potentially adds complexity to delivering public-facing information and services.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      746,
      536,
      534,
      697,
      698
    ],
    "source": ""
  },
  {
    "id": 354,
    "question": "Which of the following statements about virtualization is correct?",
    "choice_a": "A Type 2 hypervisor runs directly on the bare metal",
    "choice_b": "Virtualization provides a way to reduce software licensing costs, since only one copy of an operating system or applications platform is needed.",
    "choice_c": "Only a Type 1 hypervisor can support using the same bare-metal processor to host multiple, different operating systems.",
    "choice_d": "Individual virtual machines can communicate with each other via networks, passing files in shared storage areas, but not by direct memory-to-memory transfer of data.",
    "correct_answer": "D",
    "explanation": "It's important to appreciate that virtual machines (VMs) need to communicate to what's outside of them, and in doing so, they're as much a part of the threat surface as real central processing units (CPUs) are.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      534,
      696,
      732,
      261,
      269
    ],
    "source": ""
  },
  {
    "id": 355,
    "question": "Strong authentication requires which of the following?",
    "choice_a": "One-time password schemes",
    "choice_b": "Biometrics",
    "choice_c": "At least two of the three authentication factors",
    "choice_d": "Role-based access control",
    "correct_answer": "C",
    "explanation": "The three authentication factors are what the subject has, knows, and is.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      726,
      564,
      728,
      482,
      483
    ],
    "source": ""
  },
  {
    "id": 356,
    "question": "When implementing a password-based access control solution, what function should be used to help avoid rainbow table collisions?",
    "choice_a": "Multistring concatenation",
    "choice_b": "Modular addition",
    "choice_c": "Message pad",
    "choice_d": "Salt",
    "correct_answer": "D",
    "explanation": "Salting involves injecting another randomly chosen value into the encryption process used to protect the password plain text.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      748,
      404,
      538,
      345,
      330
    ],
    "source": ""
  },
  {
    "id": 357,
    "question": "Which of the following is one of the three primary rules in the Biba model?",
    "choice_a": "A subject cannot request services from an object that has a higher integrity level.",
    "choice_b": "A subject cannot modify an object that has a lower integrity level.",
    "choice_c": "A subject can read an object that has a lower integrity level.",
    "choice_d": "A subject cannot read or modify an object of either a lower or higher integrity level.",
    "correct_answer": "A",
    "explanation": "\u201cRead-Up\u201d is restricted in Biba's simple integrity model.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 358,
    "question": "A key employee reports that he left his personal smartphone on a train; he uses it with company systems and data extensively when he travels or commutes. What would you recommend that management do immediately, with respect to identity management and access control, for your federated access systems? Choose the most appropriate statement.<ol type=\"A\"><li>Deprovision the employee's identity.</li><li>Use the mobile device management (MDM) system to lock or \u201cbrick\u201d the device if it can, and attempt to track its location.</li><li>Suspend all access privileges for the employee's identity, and notify all federated systems partners to ensure that they take similar steps.</li><li>Suspend all access privileges for devices normally used by the employee, such as their laptop, phablet, or phone (employee-owned, company-provided, or both). If possible, quickly establish a captive portal or quarantine subnet to route access attempts from these devices to.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "C",
    "explanation": "Option A unnecessarily removes the identity from your systems and those of other systems in your federated access system; this would not be called for. <br>Option C still allows devices that the employee had been known to use to access your systems; if the employee, these devices, or both are in hostile hands, this places your systems at risk. <br>Option B correctly addresses trying to freeze or protect data on the device, and Option D prevents it from being used to attempt access to company systems.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      542,
      546,
      294,
      281,
      368
    ],
    "source": ""
  },
  {
    "id": 359,
    "question": "Which of the following are behavioral traits in a biometric device?",
    "choice_a": "Voice pattern and keystroke dynamics",
    "choice_b": "Signature dynamics and iris scan",
    "choice_c": "Retina scan and hand geometry",
    "choice_d": "Fingerprint and facial recognition",
    "correct_answer": "A",
    "explanation": "The other options are not subject to conscious control or action by the subject.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      485,
      726,
      293,
      440,
      447
    ],
    "source": ""
  },
  {
    "id": 360,
    "question": "Which statements about authentication, authorization, and accounting (AAA)\u00a0in access control are correct? <ol type=\"A\"><li>Accounting provides the authorization to access resources as part of chargeback systems.</li><li>Analysis, auditing, and accounting are the services provided by an access control system's server.</li><li>Authorization checks to see if an identity has the right(s) to access a resource, whereas authentication validates that the identity is what it claims to be. Accounting tracks everything that is requested, approved, or denied.</li><li>Authentication checks to see if an identity has been granted access privileges, using the access control tables in the central repository; authorization validates the identity is allowed to access the system. Accounting keeps track of all requests, approvals, and denials.</li></ol>",
    "choice_a": "A and B",
    "choice_b": "B and C",
    "choice_c": "B and D",
    "choice_d": "A and D",
    "correct_answer": "B",
    "explanation": "Access control is not involved with resource chargeback\u2014that is, billing; thus, A is not correct. <br>Option D has confused the roles of authorization and authentication, which Option C states correctly. <br>Option B is correct\u2014this is the \u201ctriple A\u201d of access control.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      537,
      540,
      555,
      538,
      539
    ],
    "source": ""
  },
  {
    "id": 361,
    "question": "Which step in the identity management process is where privileges are removed?",
    "choice_a": "Proofing",
    "choice_b": "Provisioning",
    "choice_c": "Revocation",
    "choice_d": "Deletion",
    "correct_answer": "B",
    "explanation": "Privileges may be altered (including being removed) throughout the life cycle of an identity; deletion removes the identity completely from the system.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      542,
      540,
      345,
      321,
      273
    ],
    "source": ""
  },
  {
    "id": 362,
    "question": "Access to organizational IT systems by remote users needs to address a number of information security concerns. Which of these concerns is addressed by mobile device management (MDM) solutions?",
    "choice_a": "Encryption of communications and data links to the user's mobile endpoint device",
    "choice_b": "Data loss prevention due to lost or stolen mobile endpoint devices",
    "choice_c": "Physical security of the remote work location, devices, and data used or stored there",
    "choice_d": "Encryption of data while stored on the mobile endpoint device",
    "correct_answer": "B",
    "explanation": "MDM systems can lock or randomize content on a device declared as lost or missing. The other issues are handled by other aspects of IT security.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      294,
      307,
      321,
      446,
      273
    ],
    "source": ""
  },
  {
    "id": 363,
    "question": "Identity and access management is an implementation of access control. Access control can be implemented in one of two broad ways. They are:",
    "choice_a": "Centralized and decentralized",
    "choice_b": "Mandatory and discretionary",
    "choice_c": "Role-based and identity-based",
    "choice_d": "Subject-based and object-based",
    "correct_answer": "A",
    "explanation": "Option A is correct; there is one system and one decision point for all subjects, objects, and rules, or multiple systems for subsets of those. Other options refer to aspects of implementing this broader choice, which can create hybrid approaches.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      538,
      537,
      540,
      542,
      556
    ],
    "source": ""
  },
  {
    "id": 364,
    "question": "View-based access controls are an example of:",
    "choice_a": "Audit control",
    "choice_b": "Constrained user interface",
    "choice_c": "Temporal constraint",
    "choice_d": "Side channel",
    "correct_answer": "B",
    "explanation": "A view is a selected set of data items and relationships shown to a user; this limits or constrains the user's ability to learn the presence or values of other items, and thus, is a constrained interface (Option B is correct).",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      273,
      429,
      357,
      446,
      321
    ],
    "source": ""
  },
  {
    "id": 365,
    "question": "Which of the following implementations provides the most rigorous access control possible?",
    "choice_a": "Role-based",
    "choice_b": "Rule-based",
    "choice_c": "Temporal-based",
    "choice_d": "Attribute-based",
    "correct_answer": "D",
    "explanation": "Attribute-based systems use complex logical rule sets (Boolean logic) to check multiple sets of constraints such as roles, time, or other conditions.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      286,
      274,
      330,
      554,
      542
    ],
    "source": ""
  },
  {
    "id": 366,
    "question": "Due diligence means:",
    "choice_a": "Pay your debts completely, on time",
    "choice_b": "Doing what you have to do to fulfill your responsibilities",
    "choice_c": "Making sure that actions you've taken to fulfill your responsibilities are working correctly and completely",
    "choice_d": "Reading and reviewing the reports from subordinates or from systems monitoring data",
    "correct_answer": "C",
    "explanation": "Options A and B are both examples of due care; due diligence is the verification that all is being done well and properly. <br>Option D can be an important part of due diligence, but it is missing the potential for follow-up action.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      32,
      31,
      30,
      33,
      29
    ],
    "source": ""
  },
  {
    "id": 367,
    "question": "Why is the preamble to ISC2's Code of Ethics important to us as SSCPs?",
    "choice_a": "It is vital to understanding the code because it sets purpose and intention; it's our mission statement as professionals.",
    "choice_b": "It sounds like it ought to be important, but it just states personal values; the canons tell us what to do and why that matters.",
    "choice_c": "It's not that important, since it only provides a context for the canons, which are the real ethical responsibilities that we have.",
    "choice_d": "It sets the priorities for us to address, highest to lowest, starting with the profession, the organization, the people we work for or our customers, and then society as a whole.",
    "correct_answer": "A",
    "explanation": "Option A correctly interprets the words themselves of the preamble. <br>Option B is incorrect. The preamble does not set personal values (such as \u201chonesty\u201d); these are in the canons and tied to actions we should take. <br>Option C misses the point of the code.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      30,
      31,
      32,
      570,
      572
    ],
    "source": ""
  },
  {
    "id": 368,
    "question": "Blacklisting is an example of:",
    "choice_a": "Positive security model",
    "choice_b": "Identity management",
    "choice_c": "Threat modeling",
    "choice_d": "Negative security model",
    "correct_answer": "D",
    "explanation": "Blacklisting involves eexcluding something based on what it is and is thus, a negative security model.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      25,
      22,
      26,
      27,
      29
    ],
    "source": ""
  },
  {
    "id": 369,
    "question": "Fred discovers that someone in the company's payroll department has been modifying employee timecard data.If done without proper authorization, this would be what kind of violation?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Privacy",
    "correct_answer": "A",
    "explanation": "The taken-together correctness or wholeness of the data may have been violated, causing some employees to be paid more or less than they deserve. This violates the presumed integrity of the timecard and payroll data. Presumably, payroll staff have legitimate reasons to access the data, and even enter or change it, so it is not a confidentiality violation; since the systems are designed to store such data and make it available for authorized use, privacy has not been violated. Timecard data records have not been removed, so there are no availability issues.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      23,
      25,
      22,
      24,
      29
    ],
    "source": ""
  },
  {
    "id": 370,
    "question": "Most attacks and compromises are the result of:",
    "choice_a": "Highly sophisticated advanced persistent threats",
    "choice_b": "Social engineering attacks",
    "choice_c": "Misconfiguration, default passwords, unpatched systems, and basic lack of adequate controls",
    "choice_d": "Failures by management to adequately fund, resource, and manage information systems security measures",
    "correct_answer": "C",
    "explanation": "Known vulnerabilities left unmitigated provide the easiest path for attackers to take; this includes obvious social engineering techniques. Many things, including lack of due care and due diligence by management, can contribute to this.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      32,
      31,
      30,
      29,
      487
    ],
    "source": ""
  },
  {
    "id": 371,
    "question": "Protection of intellectual property (IP) is an example of what kind of information security need?",
    "choice_a": "Privacy",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Integrity",
    "correct_answer": "B",
    "explanation": "Disclosure of intellectual property in unauthorized ways can end up giving away any competitive advantage that IP might have had for the business.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      25,
      22,
      27,
      28,
      461
    ],
    "source": ""
  },
  {
    "id": 372,
    "question": "What is the core objective of an information security program?",
    "choice_a": "Support business mission",
    "choice_b": "Protect assets",
    "choice_c": "Ensure confidentiality",
    "choice_d": "Enforce least privilege",
    "correct_answer": "A",
    "explanation": "The other options are part of the how and the why, but the organization's purpose and mission are what information security must support.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      30,
      32,
      31,
      29,
      27
    ],
    "source": ""
  },
  {
    "id": 373,
    "question": "Whitelisting as a security approach:",
    "choice_a": "Requires effective, integrated identity management and access control",
    "choice_b": "Includes what is known to be trustworthy",
    "choice_c": "Excludes what is known to be untrustworthy",
    "choice_d": "Requires digitally signed software or data",
    "correct_answer": "B",
    "explanation": "Whitelisting may be implemented via integrated identity management and access control, or rely on digital signatures; it can also be done in other ways.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      577,
      592,
      722,
      591,
      576
    ],
    "source": ""
  },
  {
    "id": 374,
    "question": "A thunderstorm knocks out the commercial electric power to your company's datacenter, shutting everything down. This impacts which aspect of information security?",
    "choice_a": "Privacy",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "If the equipment cannot run because there is no power, then no data stored in it can be displayed, printed, or shared with users\u2014data is not available. Some transactions may have to be recovered and rerun once the power comes back up and everything is turned on again, but only if transactions were lost completely would there be a data integrity concern.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      24,
      25,
      29,
      33,
      15
    ],
    "source": ""
  },
  {
    "id": 375,
    "question": "In general, what differentiates phishing from whaling attacks?",
    "choice_a": "Phishing attacks tend to be used to gain access to systems via malware payloads or by getting recipients to disclose information, whereas whaling attacks try to get responsible managers to authorize payments to the attacker's accounts.",
    "choice_b": "Phishing attacks are focused on businesses; whaling attacks are focused on high-worth individuals.",
    "choice_c": "Whaling attacks tend to offer something that ought to sound \u201ctoo good to be true,\u201d whereas phishing attacks masquerade as routine business activities such as package delivery confirmations.",
    "choice_d": "Whaling attacks send out huge numbers of emails attempting to lure targeted individuals into responding or following a link; phishing attacks use telephone or other means of making personal contact with a selected target.",
    "correct_answer": "A",
    "explanation": "Option A is correct; phishing tends to seek information, whereas whaling (and spear phishing) seeks action, typically the release of funds to the attacker. <br>Option B is incorrect; whaling is primarily aimed at senior business leaders, whereas phishing can be aimed at anybody, anywhere, if the attacker perceives there is something worthwhile to learn in doing so. <br>Option C has these reversed; whaling attacks depend on credibility of the business transaction they request. <br>Option D is incorrect, since it reverses key characteristics of whaling and phishing.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 376,
    "question": "Which of the following statements about information security risks is most correct regarding the use of collaborative workspace tools and platforms?",
    "choice_a": "Because these tools encourage open, trusting sharing of information and collaboration on ideas, they cannot be used to securely work with proprietary or sensitive data.",
    "choice_b": "These tools require strong identity management and access control, as part of the infrastructure beneath them, to protect sensitive or proprietary information.",
    "choice_c": "Granting access to such collaboration environments should first be determined by legitimate business need to know and also upon trustworthiness.",
    "choice_d": "First, the organizations collaborating with them should agree on how sensitive data used by or created by the team members must be restricted, protected, or kept safe and secure. Then, the people using the tool need to be fully aware of those restrictions. Without this, the technical risk controls, such as access control systems, can do very little to keep information safe and secure.",
    "correct_answer": "D",
    "explanation": "Option A is false; appropriate administrative and technical controls can and should be used to reduce information security risks to acceptable levels. <br>Option B is correct in part, but without the users of the tool being fully aware of the CIANA needs pertaining to the data, information, and knowledge that is being collaborated upon, the technical controls are meaningless. <br>Option C is correct in part but does not address user awareness, education, or training. <br>Option D covers the key elements of user awareness and education and support the CIANA requirements for this collaboration; thus, the technical controls can do their job more effectively.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      29,
      25,
      27,
      32,
      31
    ],
    "source": ""
  },
  {
    "id": 377,
    "question": "Which statement best describes how does the separation of duties relate to education and training of end users, managers, and leaders in an organization?",
    "choice_a": "Separation of duties would dictate that general education and awareness training be done by different people than those who provide detailed skills-based training for the proper handling of sensitive information.",
    "choice_b": "Separation of duties should identify groups or teams that have little need for information security awareness, training, and education so that effort can be better focused on ones with greater needs.",
    "choice_c": "Separation of duties should segment the organization into teams focused on their job responsibilities, with clear interfaces to other teams. Effective awareness training and education can help each team, and each team member, see how successfully fulfilling their duties depends on keeping information safe, secure, and reliable.",
    "choice_d": "Separation of duties would dictate that workers outside of one team's span of control or duties have no business need to know what that team works with; education and training would reinforce this.",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; in general, the same core information security team members should actively shape and guide all information security awareness, education, and training efforts across the organization. <br>Option B is incorrect; it shows a misunderstanding of separation of duties, which typically breaks a task for one trustworthy person or group into two or more sets of tasks for two (or more) trustworthy people or groups, so as to provide a check and balance arrangement. This would typically involve information at the same level of sensitivity or classification. <br>Option C is correct, as it links the opportunities that separation of duties can suggest for focusing such education and training. <br>Option D, like Option B, does not apply separation of duties correctly. It is not intended to produce \u201ccompartments\u201d that others cannot know about; rather, it drives the design of access controls or administrative controls to prevent one person from taking incorrect action.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      572,
      570,
      579,
      575,
      573
    ],
    "source": ""
  },
  {
    "id": 378,
    "question": "Your company uses computer-controlled machine tools on the factory floor as part of its assembly line. This morning, you've discovered that somebody erased a key set of machine control parameter files, and the backups you have will need to be updated and verified before you can use them. This may take most of the day to accomplish. What information security attribute is involved here?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Due care",
    "correct_answer": "B",
    "explanation": "Although it is clear that the necessary parameter files are not available, this seems to have been caused because somebody could violate the integrity requirements of those files\u2014deleting them does not seem to have been an authorized change.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      23,
      25,
      24,
      487,
      33
    ],
    "source": ""
  },
  {
    "id": 379,
    "question": "Which of the following best describes the capabilities of camera systems in physical security?",
    "choice_a": "Cameras provide deterrence and corrective capabilities.",
    "choice_b": "Cameras can provide a preventive type of control.",
    "choice_c": "Cameras can be effective without monitoring.",
    "choice_d": "Cameras provide surveillance, incident detection, and response capabilities.",
    "correct_answer": "D",
    "explanation": "Remote visual surveillance by itself cannot correct, contain, or respond to an incident. Their obvious or suspected presence can provide some deterrent value, whether or not the attacker can know they are monitored.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      26,
      722,
      724,
      459,
      25
    ],
    "source": ""
  },
  {
    "id": 380,
    "question": "As a security flaw, buffer overflow is caused by:",
    "choice_a": "Lack of effective scanning or filtering of incoming packets",
    "choice_b": "Failure to configure the presentation layer properly",
    "choice_c": "Poorly designed and poorly tested code",
    "choice_d": "Improper user training",
    "correct_answer": "C",
    "explanation": "This classic security flaw is completely preventable, if only software developers and their managers enforced lessons learned regarding input data validation.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      494,
      490,
      581,
      488,
      570
    ],
    "source": ""
  },
  {
    "id": 381,
    "question": "Source code escrow can be used to protect against:",
    "choice_a": "Vendor-placed backdoors",
    "choice_b": "Breaches of licensing agreements",
    "choice_c": "Lack of documentation",
    "choice_d": "Vendor bankruptcy",
    "correct_answer": "D",
    "explanation": "The other three options are difficult to impossible to evaluate until its vendor/creator goes out of business.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      510,
      511,
      512,
      516,
      518
    ],
    "source": ""
  },
  {
    "id": 382,
    "question": "Which of the following statements is correct in regard to source code escrow?",
    "choice_a": "Allows organizations to meet contractual obligations in regards to software licensing",
    "choice_b": "Protects against software vendor bankruptcy",
    "choice_c": "Allows detection of vulnerabilities in software",
    "choice_d": "Allows backing up of critical software",
    "correct_answer": "B",
    "explanation": "Source code escrow can also be applied to reduce the risk of technology obsolescence, such as for device drivers, by paying a licensing (escrow) fee to the vendor.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      510,
      512,
      511,
      487,
      518
    ],
    "source": ""
  },
  {
    "id": 383,
    "question": "A double blind test is:",
    "choice_a": "A strategy for operational test and evaluation to see if day-to-day business activities are still working correctly with a new or modified system",
    "choice_b": "A penetration test strategy without the knowledge of the incident response teams",
    "choice_c": "A penetration test strategy in which the test team has no insider knowledge of systems, procedures, or security posture, and the incident response teams have no knowledge of the upcoming or ongoing test",
    "choice_d": "A black box style of testing used during systems development",
    "correct_answer": "C",
    "explanation": "Double-blind testing requires that the bare minimum of senior leadership, IT, and operational managers and staff know of the test, and that test team \u201cattackers\u201d are realistically acting as naive outsiders, to make the test as realistic as possible.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      514,
      513,
      515,
      487,
      462
    ],
    "source": ""
  },
  {
    "id": 384,
    "question": "Every control must be tested to ensure correct operation. Three questions should be addressed by control assessment. Which of the following is <italic>not</italic> a question that addresses this need?",
    "choice_a": "Was the control implement correctly?",
    "choice_b": "Was the control approved by audit?",
    "choice_c": "Is the control operating correctly?",
    "choice_d": "Is the control meeting its desired result?",
    "correct_answer": "B",
    "explanation": "Audits neither approve nor disapprove controls; they may assess whether your process for choosing, implementing, using, and monitoring the control meets audit standards, however.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      516,
      517,
      491,
      489,
      492
    ],
    "source": ""
  },
  {
    "id": 385,
    "question": "Treating risk may include four options. They are avoiding risk, accepting risk, mitigating risk, and ______.",
    "choice_a": "Deterring risk",
    "choice_b": "Ignoring risk",
    "choice_c": "Transferring risk",
    "choice_d": "Insuring risk",
    "correct_answer": "C",
    "explanation": "Transferring involves making someone else responsible for the efforts and costs of recovery if the risk becomes an event. Usually this is done via insurance or other contracts.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      510,
      511,
      516,
      486,
      487
    ],
    "source": ""
  },
  {
    "id": 386,
    "question": "What are the three broad types of risk mitigation controls or countermeasures?",
    "choice_a": "Physical, logical, and administrative",
    "choice_b": "Legal, regulatory, and ethical",
    "choice_c": "Role-based, rule-based, and attribute-based",
    "choice_d": "Deter, avoid, accept, and prevent",
    "correct_answer": "A",
    "explanation": "Types of controls indicate whether people, information technology parameters and settings, or walls, doors, locks, guards, and guns deliver the control or countermeasure effect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      574,
      516,
      588,
      591,
      592
    ],
    "source": ""
  },
  {
    "id": 387,
    "question": "What type of standards should be followed when conducting information security audits?",
    "choice_a": "The organization's business plan, business impact analysis, and risk management plan",
    "choice_b": "Standards appropriate to the type and purpose of the audit",
    "choice_c": "COBIT 5 and ITIL",
    "choice_d": "ISO 27002",
    "correct_answer": "B",
    "explanation": "Audits may be done for many purposes; the right standard should be used to ensure that audit procedures, activity, and the auditors themselves produce audit findings that are credible and actionable.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      491,
      489,
      493,
      492,
      490
    ],
    "source": ""
  },
  {
    "id": 388,
    "question": "Which statement about how different types of controls provide greater information security is <italic>most</italic> correct?",
    "choice_a": "Physical controls provide the greatest security, because they restrict physical movement into protected spaces or actual contact with hardware and systems.",
    "choice_b": "Administrative controls provide the greatest security, since they ensure that all company personnel follow the best procedures to keep information systems safe and secure.",
    "choice_c": "Logical controls provide the greatest security, because these implement management and policy decisions into features and settings in systems software and hardware.",
    "choice_d": "There is no real comparison between these types of controls, since they all address risks very differently.",
    "correct_answer": "D",
    "explanation": "Options A, B, and C are all false; the choice of the best risk control for a specific vulnerability in a particular situation must reflect a trade-off of risk, cost, ease of implementation, and residual risk, among other factors. Thus, Option D is correct.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      581,
      579,
      573,
      575,
      490
    ],
    "source": ""
  },
  {
    "id": 389,
    "question": "Which term refers to disabling unnecessary services, features, and accounts or identities on a system, as a way to reduce its potential attack surface?",
    "choice_a": "Mitigation",
    "choice_b": "Hardening",
    "choice_c": "Penetration testing",
    "choice_d": "Vulnerability assessment",
    "correct_answer": "B",
    "explanation": "Hardening is a subset of all possible mitigation approaches.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 390,
    "question": "The proper way to manage and oversee change management in any organization is to:",
    "choice_a": "Delegate change management and control to the IT or systems departments responsible for particular systems, platforms, or apps.",
    "choice_b": "Require that change requests, implementation plans, and regression tests are reviewed and accepted by all affected elements of the organization.",
    "choice_c": "Adopt appropriate builds and controls technologies that help you control, manage, and track changes to software, hardware, and data configuration items, and establish formal management procedures to have all affected parties participate in such change decisions.",
    "choice_d": "Migrate your business into the cloud via platform as a service, and then delegate all configuration management problems to your cloud services provider via your service level agreement with them.",
    "correct_answer": "C",
    "explanation": "Informed management provides better decision making and gains more support from those affected by change.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      579,
      580,
      488,
      486,
      581
    ],
    "source": ""
  },
  {
    "id": 391,
    "question": "What measures can be taken to reduce the information security risk of shadow IT systems?",
    "choice_a": "Implement dual-factor authentication and more stringent access controls",
    "choice_b": "Disable or lock features in applications suites that make shadow IT systems easy to write and spread through the organization",
    "choice_c": "Make greater use of Common Vulnerabilities and Exposures (CVE) data in designing and maintaining such systems",
    "choice_d": "Enforce standards for regular management review of all data produced by such systems before it is used in operational decision making",
    "correct_answer": "D",
    "explanation": "Option D puts the burden of verification and validation on the managers depending on the results of such shadow IT systems, which incentivizes them to better maintain and control their design and use. <br>Option C is false, as CVE data is for systems and software in widespread use and not for customized one-of-a-kind programs. <br>Option B is false, because this has proven unworkable in practice and denies the potential of significant payback to the organization if they make better, more well-managed use of these features (and the shadow IT they build using them). <br>Option A is false, since identity management and access control have nothing to do with homegrown software being vulnerable or prone to exploitation.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      31,
      32,
      579,
      486,
      491
    ],
    "source": ""
  },
  {
    "id": 392,
    "question": "Why should configuration management should be based on a foundation of policies, standards, and procedures?",
    "choice_a": "These provide the starting point to make configuration management and control reliable, repeatable, and verifiable, thus, reducing risk.",
    "choice_b": "All organizations work better with written policies and procedures.",
    "choice_c": "Regulatory and legal needs for compliance dictate these.",
    "choice_d": "These form a valuable knowledge base for systems operation and maintenance.",
    "correct_answer": "A",
    "explanation": "The goal of configuration management is to reduce risk to systems and processes necessary to achieve organizational objectives. Reliability increases with well-defined, clear procedures and standards.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      581,
      579,
      486,
      487,
      31
    ],
    "source": ""
  },
  {
    "id": 393,
    "question": "What is the role of users having good security awareness in dealing with the risk of social engineering?",
    "choice_a": "By itself, minimal; when coupled with focused task-based or role-based information security training, it can enable employees to better detect potential social engineering attacks, while providing guidance as to how they should respond.",
    "choice_b": "Unlimited; it can inform each employee's reaction to small but not-quite-normal events, as they find the right best way to respond to people and situations.",
    "choice_c": "Minimal; awareness training is typically done when the employee first joins the organization and has little effectiveness without specific job-based training.",
    "choice_d": "Minimal; although it gets users to think about information security as a risk to the company, their jobs, and others, it doesn't help them deal with new or novel situations, contacts by outsiders, and so forth.",
    "correct_answer": "A",
    "explanation": "Combining awareness of the constantly evolving threat landscape with practical ways to detect, characterize, and respond to something new is critical to effective defense against social engineering attacks.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      29,
      593,
      490,
      724,
      725
    ],
    "source": ""
  },
  {
    "id": 394,
    "question": "The business impact analysis (BIA) is considered the most important component of business continuity planning because:",
    "choice_a": "It provides the foundation for understanding the criticality of the organization's functions.",
    "choice_b": "It translates the prioritized results of the vulnerability assessment into a risk mitigation plan.",
    "choice_c": "It dictates day-to-day application of risk mitigation controls and countermeasures.",
    "choice_d": "It demonstrates the commitment of senior management and leadership to the information risk mitigation strategy.",
    "correct_answer": "A",
    "explanation": "The other options refer to other steps in the overall risk management process; the BIA puts risks in terms of bottom-line impacts to survival or accomplishing prioritized objectives.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      42,
      44,
      479,
      58,
      54
    ],
    "source": ""
  },
  {
    "id": 395,
    "question": "The third step in risk management is:",
    "choice_a": "Frame risk",
    "choice_b": "Analyze risk",
    "choice_c": "Treat risk",
    "choice_d": "Quantify risk",
    "correct_answer": "C",
    "explanation": "Framing risk means to state it, in human language, in ways that communicate effectively to decision makers; this is important. Quantify is part of analysis and assessment; thus, frame, analyze, and treat.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      56,
      42,
      43,
      44,
      46
    ],
    "source": ""
  },
  {
    "id": 396,
    "question": "Which of the following is true?",
    "choice_a": "Senior management's attitude is not important in risk management.",
    "choice_b": "Risk management must always be conducted in alignment with the goals, mission, and culture of the organization.",
    "choice_c": "External factors should not be a consideration in risk management.",
    "choice_d": "All risk can and should be managed.",
    "correct_answer": "B",
    "explanation": "All aspects of risk management require balancing exposure to loss, opportunities to improve, and available resources against goals and objectives. Management and leadership make these decisions, in part based on their tolerance for ambiguity.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      43,
      42,
      58,
      59,
      66
    ],
    "source": ""
  },
  {
    "id": 397,
    "question": "Who is ultimately accountable for risk management?",
    "choice_a": "Systems administrators",
    "choice_b": "Workgroup managers and supervisors",
    "choice_c": "Senior management and leadership",
    "choice_d": "End users",
    "correct_answer": "C",
    "explanation": "Others in the organization have responsibilities for what has been delegated to them, but senior leaders and managers own it all.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      52,
      58,
      36,
      41,
      57
    ],
    "source": ""
  },
  {
    "id": 398,
    "question": "Determining whether a chosen safeguard is cost-effective means that:",
    "choice_a": "You must compare the total expected losses, over time, with the total costs to acquire, install, and use the safeguard.",
    "choice_b": "The single loss expectancy (SLE) is greater than the safeguard value.",
    "choice_c": "The total of replacement costs or values of the asset at risk, other related business losses including lost opportunity costs, is greater than the safeguard value.",
    "choice_d": "The annualized loss expectancy is less than the safeguard value.",
    "correct_answer": "A",
    "explanation": "We often simplify risk assessment by using annualized exposure, loss (which reflects fraction of asset value harmed, not total asset value), and safeguard costs; many safeguards have high initial costs and lower annual recurring operational costs. So, the real comparison typically looks across a number of years.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      598,
      597,
      614,
      596,
      456
    ],
    "source": ""
  },
  {
    "id": 399,
    "question": "It's time for a compliance audit of your security systems and procedures. Your boss wants to save money and have an internal team do the audit. Which statement would be your best response to your boss?",
    "choice_a": "Our internal people may have the right skills and knowledge to do this audit, so this might be a good idea.",
    "choice_b": "We don't really have anyone on our team who understands the audit standards, so we may need an external auditor anyway.",
    "choice_c": "We've got people who could do the audit, but their workloads and our priorities would mean the audit has to be delayed by several months.",
    "choice_d": "Compliance requirements and standards may dictate that the auditors be independent and certified, or the findings may not be acceptable.",
    "correct_answer": "D",
    "explanation": "In most cases, compliance audits must be done by trained and certified external auditors if the results are to be acceptable to legal, regulatory, insurance, or financial authorities.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      52,
      476,
      474,
      53,
      57
    ],
    "source": ""
  },
  {
    "id": 400,
    "question": "SLE = _____ \u00d7 exposure factor.",
    "choice_a": "Safeguard value",
    "choice_b": "Asset value",
    "choice_c": "(Asset value minus safeguard value)",
    "choice_d": "Asset value \u00d7 annualized rate of occurrence",
    "correct_answer": "B",
    "explanation": "Exposure to loss by a single loss expectancy (SLE) considers all assets damaged by the event and the fraction of their value that is lost or compromised.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      456,
      597,
      596,
      594,
      598
    ],
    "source": ""
  },
  {
    "id": 401,
    "question": "Which of the following is <italic>not</italic> true?",
    "choice_a": "The implementation of a control addresses a vulnerability.",
    "choice_b": "The implementation of effective controls will eliminate all quantified risks.",
    "choice_c": "A control that is proactive and tries to stop something before it happens is often called a safeguard.",
    "choice_d": "A control that is reactive and attempts to limit the effect of an attack is called a countermeasure.",
    "correct_answer": "B",
    "explanation": "Some risks cannot be quantified but can still be effectively controlled.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      42,
      34,
      61,
      46,
      54
    ],
    "source": ""
  },
  {
    "id": 402,
    "question": "Which of the following statements is true?",
    "choice_a": "Business continuity planning (BCP) and disaster recovery planning (DRP) are the same.",
    "choice_b": "BCP is part of DRP.",
    "choice_c": "Both BCP and DRP are mutually exclusive.",
    "choice_d": "DRP is part of BCP",
    "correct_answer": "D",
    "explanation": "The goal of all of this planning is to stay in business despite risk events large and small. Disasters are large events and thus, a subset of the overall business continuity planning.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      595,
      477,
      43,
      59,
      36
    ],
    "source": ""
  },
  {
    "id": 403,
    "question": "Why should a security practitioner be alert to identifying single points of failure in systems, processes, or business logic?",
    "choice_a": "Such points of failure usually indicate poorly performed systems maintenance and upgrades.",
    "choice_b": "Each such point may be a possible opportunity for product or process improvement and is worth investigating.",
    "choice_c": "Single points of failure can bring entire chains of business processes to a halt and thus, represent a potentially critical vulnerability.",
    "choice_d": "During incident investigation, these should be checked to see if one or more of these had become the proximate cause.",
    "correct_answer": "C",
    "explanation": "Availability is put at great risk by such single points of failure, regardless of whether they are exploited by accident, other failures, or attackers. Prevention of such impacts should be prioritized and addressed properly.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      44,
      59,
      43,
      42,
      65
    ],
    "source": ""
  },
  {
    "id": 404,
    "question": "What is the primary purpose of testing an intrusion prevention system (IPS)?",
    "choice_a": "To verify that the IPS is detecting and initiating an appropriate response to a suspicious activity",
    "choice_b": "To determine whether the IPS is capable of discarding suspect packets",
    "choice_c": "To analyze processor utilization to verify whether hardware upgrades are necessary",
    "choice_d": "To test whether the IPS can log every possible event on the network",
    "correct_answer": "A",
    "explanation": "IPSs are not limited to just discarding suspect packets; testing verifies that the IPS you've installed is giving you the right mix of protection at acceptable error levels.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      53,
      52,
      57,
      55,
      65
    ],
    "source": ""
  },
  {
    "id": 405,
    "question": "Which of the following statements about social engineering attacks is incorrect?",
    "choice_a": "Most targeted individuals don't see the harm in responding or in answering simple questions posed by the attacker.",
    "choice_b": "Most people believe they are too smart to fall for such obvious ploys, but they do anyway.",
    "choice_c": "Most targeted individuals and organizations have effective tools and procedures to filter out phishing and related scams, so they are now better protected from such attacks.",
    "choice_d": "Most people want to be trusting and helpful.",
    "correct_answer": "C",
    "explanation": "Options A, B, and D all demonstrate the hallmarks of social engineering attacks\u2014they work (and have worked for thousands of years) because people are generally trusting, open, and willing to engage with strangers. <br>Option C, the correct choice, is unfortunately not true; tools may help filter out some email-based social engineering attacks, but few organizations have truly been able to operate with a \u201cloose lips sink ships\u201d approach and deal openly with customers, clients, and many other outside stakeholders.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      81,
      85,
      77,
      72,
      76
    ],
    "source": ""
  },
  {
    "id": 406,
    "question": "Which statement about the role of end users in detecting information security incidents is correct?",
    "choice_a": "Most end users may have significant experience with the routine operation of the business systems and applications that they use, but they cannot produce useful precursor or indicator information regarding possible information security incidents.",
    "choice_b": "Most end users and their first-level supervisors have the best, most current insight as to the normal business rhythm, flow, and therefore normal loads on the systems and their throughput. They will most likely see anything \u201cabnormal\u201d quickly as a result.",
    "choice_c": "Users think that they know a lot about \u201cbusiness normal,\u201d but we need to rely more heavily on well-instrumented intrusion detection systems, access control, and other monitoring capabilities.",
    "choice_d": "Since most advanced persistent threat (APT) kill chains use low and slow attack methods to reconnoiter and gain access, by the time users see things behaving abnormally, it's too late.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; it's rather dismissive of the knowledge that most line workers have when it comes to how business actually gets done every day. Users may need better training as to what to do when they think they see a problem, but that's not addressed by this option. <br>Option C is incorrect, demonstrating a narrow vision that only sees the technological solutions as useful. <br>Option D is incorrect, notably that it is never too late to sound an alarm. <br>Option B correctly expresses the value of knowledge and experience. Harnessing this insight in real time as part of an intrusion or anomaly detection process, however, is another story.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      85,
      99,
      97,
      81,
      69
    ],
    "source": ""
  },
  {
    "id": 407,
    "question": "Which set of plans and procedures should define how the organization makes backups of systems, applications, device settings, databases, and other data for use during the recovery phase of an information systems security incident response?",
    "choice_a": "Information security incident response plans and procedures",
    "choice_b": "Disaster recovery plans (DRPs) and procedures",
    "choice_c": "Business continuity plans (BCP) and procedures",
    "choice_d": "Information technology configuration management plans and procedures",
    "correct_answer": "C",
    "explanation": "Option A is false; the response team should need to know only how to find and use such backups and not be responsible for their initial generation or routine update. <br>Option B is false; the DRP would address options spelled out in the BCP as to alternative processing locations, contingency plans, and so forth, all of which need the backups that the BCP directs be made. <br>Option D is false; configuration management is the decision process that allows or prevents changes to hardware, software, or key data items or structures, but it doesn't manage backups. <br>Option C correctly links the purpose of backups\u2014continuing to get business done in the face of accidents, systems failures, attacks, or natural disasters\u2014with the need for a specific set of resources\u2014that is, backups.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      79,
      77,
      78,
      650,
      87
    ],
    "source": ""
  },
  {
    "id": 408,
    "question": "Creating incident response policies for an organization would be an example of which of the following?",
    "choice_a": "Technical control",
    "choice_b": "Administrative control",
    "choice_c": "Logical control",
    "choice_d": "Physical control",
    "correct_answer": "B",
    "explanation": "Note that many IT systems have software controls called \u201cpolicies,\u201d which should not be confused with documents that tell people what to do and why.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      735,
      79,
      71,
      72,
      83
    ],
    "source": ""
  },
  {
    "id": 409,
    "question": "Which of the following is the most time-critical phase of activity in incident response?",
    "choice_a": "Eradication",
    "choice_b": "Detection",
    "choice_c": "Containment",
    "choice_d": "Preparation",
    "correct_answer": "B",
    "explanation": "The other phases cannot start until you've detected something that might need responding to.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      99,
      69,
      70,
      96,
      84
    ],
    "source": ""
  },
  {
    "id": 410,
    "question": "Which of the following statements is the most correct in incident response?",
    "choice_a": "The goal of incident response is to minimize the damage and learn from the incident as to prevent it from happening again.",
    "choice_b": "The goal is to prevent incidents from happening.",
    "choice_c": "Incident response does not require a policy that provides its foundation.",
    "choice_d": "Incident response does not involve problem management.",
    "correct_answer": "A",
    "explanation": "Incidents will happen; 100 percent prevention is not a reality we can achieve. Thus, be prepared to detect, contain, and respond. This requires management and leadership commitment and prioritization, which usually requires written policy and direction.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      83,
      99,
      84,
      69,
      79
    ],
    "source": ""
  },
  {
    "id": 411,
    "question": "You're the only IT person at a small tool and die machine shop, which uses a local area network (LAN) and cloud-hosted platforms to run the business on. The previous IT person had told your boss not to worry about the business being the target of a cyberattack. Which statement best lets you explain the real risks the company might face?",
    "choice_a": "Since we don't handle consumer-level payment cards, and we don't have any proprietary information, we probably don't have to worry about being a target.",
    "choice_b": "We do share an extranet connection with key customers and suppliers, but it should prevent an attack on our systems that could lead to an attack on theirs.",
    "choice_c": "Our cloud systems hosting company provides most of our security, and as long as we keep our systems on the factory floor and the workstations our staff use properly updated, we should be okay.",
    "choice_d": "Since we haven't done even a basic vulnerabilities assessment, we don't know what risks we could be facing. Let's do that much at least, and let that tell us what the next step should be. Soon.",
    "correct_answer": "D",
    "explanation": "Although Option A may be true, it is naive and incorrect; the air-conditioning company that serviced Target stores didn't handle retail (credit card) sales either, yet attackers found it to be an ideal entry into Target's payment processing systems. <br>Option C is also incorrect; your cloud hosts will protect their systems, and their platforms, from malware attacks from your connections, but attackers who spoof bogus, privileged accounts into your systems can still destroy your business's presence in those cloud systems. <br>Option B is incorrect; without doing a detailed vulnerability assessment of that architecture, you are at risk making this assumption. <br>Option D offers the boss a sensible first step.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      72,
      73,
      75,
      101,
      89
    ],
    "source": ""
  },
  {
    "id": 412,
    "question": "Which of the following would be the first step to be conducted as an investigator arrives at a crime scene?",
    "choice_a": "Maintain chain of custody",
    "choice_b": "Prove the integrity of the scene",
    "choice_c": "Secure the scene",
    "choice_d": "Interview potential witnesses",
    "correct_answer": "C",
    "explanation": "Securing the scene limits the opportunity for evidence to be corrupted by other people or processes. It's the first step in the chain of custody.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      659,
      639,
      658,
      99,
      75
    ],
    "source": ""
  },
  {
    "id": 413,
    "question": "Which of the following is <italic>not</italic> a legal or regulatory issue that a computer security incident response team (CSIRT) would have to be concerned with?",
    "choice_a": "Incidents caused by employee negligence or accident",
    "choice_b": "Incidents caused by misuse of systems by an employee",
    "choice_c": "Incidents that may involve competitors attempting to access company proprietary information",
    "choice_d": "Incidents that disrupt normal business operations",
    "correct_answer": "A",
    "explanation": "Option A usually does not have a legal or regulatory obligation that the CSIRT must respond to (although there may be requirements for the organization to report statistics on such incidents to regulators or other authorities). <br>Option B could lead to disciplinary actions or firing the employee involved, which could result in litigation. <br>Option C may be criminal trespass or violation of other criminal laws. <br>Option D may, depending on the nature of the business and its activities, require safety, security, or investor and consumer protection reporting and notification actions by the organization, regardless of cause.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      101,
      659,
      99,
      84,
      83
    ],
    "source": ""
  },
  {
    "id": 414,
    "question": "What is the most important component of business continuity planning?",
    "choice_a": "Business impact analysis (BIA)",
    "choice_b": "Vulnerability assessment",
    "choice_c": "Disaster recovery plan",
    "choice_d": "Incident response plan",
    "correct_answer": "A",
    "explanation": "The BIA sets the priorities that all else follow from.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      72,
      648,
      649,
      73,
      79
    ],
    "source": ""
  },
  {
    "id": 415,
    "question": "Which concept refers to the point in time to which data could be restored in the event of a business disruption?",
    "choice_a": "Recovery time objective (RTO)",
    "choice_b": "Business impact analysis (BIA)",
    "choice_c": "Recovery point objective (RPO)",
    "choice_d": "Maximum tolerable downtime (MTD)",
    "correct_answer": "C",
    "explanation": "The RTO and MTD express how quickly after an incident that services need to be restored. RPO looks at how far back in time before the incident you have to find and restore data, or re-accomplish transactions and updates.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      495,
      496,
      72,
      77,
      94
    ],
    "source": ""
  },
  {
    "id": 416,
    "question": "What type of testing that should be performed when initially testing a disaster recovery plan?",
    "choice_a": "Simulation",
    "choice_b": "Structured walkthrough",
    "choice_c": "Parallel",
    "choice_d": "Full interruption",
    "correct_answer": "B",
    "explanation": "Structured walkthroughs are inexpensive ways to \u201cdesk-check\u201d the recovery plan, while beginning to familiarize people with the roles they'll need to perform during an actual recovery.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      655,
      654,
      648,
      71,
      79
    ],
    "source": ""
  },
  {
    "id": 417,
    "question": "Which RAID level uses block-level striping with parity information distributed across multiple disks?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 4",
    "choice_d": "RAID 5",
    "correct_answer": "D",
    "explanation": "RAID 0 provides higher throughput but no redundancy. RAID 1 mirrors a whole disk. RAID 4 doesn't exist.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      646,
      520,
      519,
      645,
      647
    ],
    "source": ""
  },
  {
    "id": 418,
    "question": "Applied against a given block of data, what does a hash function create?",
    "choice_a": "A chunk of the original block used to ensure its confidentiality",
    "choice_b": "A block of new data used to ensure the original block's confidentiality",
    "choice_c": "A chunk of the original block used to ensure its integrity",
    "choice_d": "A block of new data used to ensure the original block's integrity",
    "correct_answer": "D",
    "explanation": "Be careful here; hashing does not change the contents of the original plain text but creates a unique new data block (the hash value) from the original, which can be used to verify the original has not been changed since the hash was generated.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      663,
      664,
      665,
      750,
      751
    ],
    "source": ""
  },
  {
    "id": 419,
    "question": "In symmetric key cryptography, what should each party use?",
    "choice_a": "Key encrypting key",
    "choice_b": "Previously exchanged secret key",
    "choice_c": "Randomly generated value unknown to anyone",
    "choice_d": "Public key exchanged with the message",
    "correct_answer": "B",
    "explanation": "A random key value unknown to the recipient will not support decryption. The other options either refer to public/private key systems.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      500,
      499,
      104,
      128,
      524
    ],
    "source": ""
  },
  {
    "id": 420,
    "question": "Steganography uses cryptographic means to:",
    "choice_a": "Corrupt the integrity of a message or file in ways not easily detectable",
    "choice_b": "Reduce the likelihood of key clustering",
    "choice_c": "Hide the plain text within another unencrypted data stream, message, or file",
    "choice_d": "Provide for nonrepudiation by watermarking",
    "correct_answer": "C",
    "explanation": "Watermarking is an example of using steganography to achieve a purpose such as nonrepudiation; it is not, however, what steganography is. It won't help with key clustering, and a simple hash of the plain text will show that the plain text has been changed.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      104,
      663,
      498,
      103,
      106
    ],
    "source": ""
  },
  {
    "id": 421,
    "question": "Symmetric cryptography is best characterized by:",
    "choice_a": "Using in-band communications for key distribution and management",
    "choice_b": "Using the same key for encryption and decryption",
    "choice_c": "Having much greater work factors than other forms of encryption",
    "choice_d": "Providing for very fast encryption and decryption only in streaming mode",
    "correct_answer": "B",
    "explanation": "Symmetric encryption must rely on out-of-band key management; it can be significantly easier to break (lower work factor) than asymmetric approaches for same key length.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      500,
      498,
      499,
      104,
      107
    ],
    "source": ""
  },
  {
    "id": 422,
    "question": "What is the input that controls the operation of the cryptographic algorithm?",
    "choice_a": "Decoder Wheel",
    "choice_b": "Encoder",
    "choice_c": "Cryptovariable",
    "choice_d": "Cryptographic routine",
    "correct_answer": "C",
    "explanation": "Cryptovariables tend to specify block size, transposition, or substitution lengths; seeds for random number generators; or salt values. In some cryptosystems, they are fixed by the implementers; in others, they can be user specified.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      750,
      752,
      499,
      498,
      663
    ],
    "source": ""
  },
  {
    "id": 423,
    "question": "Which of the following describes the Caesar Cipher?",
    "choice_a": "Substitution and transposition cipher",
    "choice_b": "Transposition by three characters",
    "choice_c": "Plaintext only cipher",
    "choice_d": "Substitution cipher by three characters",
    "correct_answer": "D",
    "explanation": "No transposition is involved.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      104,
      117,
      103,
      106,
      108
    ],
    "source": ""
  },
  {
    "id": 424,
    "question": "Which of the following is not directly provided as a result of using cryptography?",
    "choice_a": "Authentication",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "Cryptographic support of identity management, access control, file or system integrity checks, and so forth can contribute to availability, but encrypting files or messages without those other security measures alone will not.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      107,
      103,
      663,
      664,
      151
    ],
    "source": ""
  },
  {
    "id": 425,
    "question": "All of the following address integrity except:",
    "choice_a": "Message Authentication Code (MAC)",
    "choice_b": "Data Encryption Standard (DES)",
    "choice_c": "Parity protection",
    "choice_d": "Message Digest 5 (MD5)",
    "correct_answer": "B",
    "explanation": "Integrity requires a way to verify that message or file plain text has not been altered over time; anything one could conceivably decrypt could lend itself to attacking the plain text's integrity. Encryption, such as DES, may or may not be a part of a chosen integrity implementation.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      665,
      664,
      663,
      107,
      499
    ],
    "source": ""
  },
  {
    "id": 426,
    "question": "Does the use of asymmetric algorithms have a scalability problem as more people require confidential communications?",
    "choice_a": "Yes, as indicated by the dramatic growth in Internet of Things (IoT) devices becoming part of the Internet.",
    "choice_b": "No, so long as full Internet Protocol Security (IPSec) implementations in IPv6 are used.",
    "choice_c": "No, as long as you're using webs of trust as part of certificate/signature authentication.",
    "choice_d": "No, as long as you're using hierarchies of trust as part of certificate/signature authentication.",
    "correct_answer": "D",
    "explanation": "Managing the expiration (or compromise) of certificates is problematic in webs of trust. IPSec doesn't address this.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      672,
      674,
      673,
      523,
      124
    ],
    "source": ""
  },
  {
    "id": 427,
    "question": "Advanced Encryption Standard (AES) is a block cipher with variable key lengths of?",
    "choice_a": "128, 192, or 256 bits",
    "choice_b": "32, 128, or 448 bits",
    "choice_c": "8, 64, or 128 bits",
    "choice_d": "128, 256, or 448 bits",
    "correct_answer": "A",
    "explanation": "This standard was set in 2001 by the U.S. National Institute of Standards and Technologies (NIST).",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      499,
      500,
      498,
      668,
      104
    ],
    "source": ""
  },
  {
    "id": 428,
    "question": "What kind of encryption is used in Wi-Fi Protected Access\u00a02 (WPA2)?",
    "choice_a": "Data Encryption Standard\u00a0(DES) in streaming mode",
    "choice_b": "Advanced Encryption Standard (AES) in cipher block chaining (CBC) mode",
    "choice_c": "AES in a combination of cipher block chaining (CBC) and counter (CTR) mode",
    "choice_d": "Public key infrastructure\u00a0(PKI) using ElGamal and DES",
    "correct_answer": "C",
    "explanation": "Set as the standard in 2004 by the Wi-Fi Alliance; the other options are incomplete and incorrect.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      130,
      133,
      154,
      107,
      128
    ],
    "source": ""
  },
  {
    "id": 429,
    "question": "A certificate authority (CA) provides which benefit to a user?",
    "choice_a": "Protection of private keys of all users",
    "choice_b": "History of symmetric keys",
    "choice_c": "Proof of nonrepudiation of origin",
    "choice_d": "Validation that a public key is associated with a particular user",
    "correct_answer": "D",
    "explanation": "CA authentication of a public key is the bedrock of public key infrastructure\u00a0(PKI) systems. The other options do not relate to this or misapply public/private key concepts.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      672,
      522,
      674,
      524,
      104
    ],
    "source": ""
  },
  {
    "id": 430,
    "question": "In its simplest form, how many parties are involved in a transitive trust relationship within a domain?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four or more",
    "correct_answer": "C",
    "explanation": "For parties A, B, C, if Party B trusts C, and A trusts B, A can infer that C is trustworthy based on B's endorsement or referral.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      523,
      522,
      524,
      672,
      103
    ],
    "source": ""
  },
  {
    "id": 431,
    "question": "Which of the following algorithms supports asymmetric key cryptography?",
    "choice_a": "Diffie-Hellman",
    "choice_b": "Blowfish",
    "choice_c": "SHA-256",
    "choice_d": "Rijndael",
    "correct_answer": "A",
    "explanation": "Blowfish and Rijndael are symmetric algorithms; SHA-256 is a hash algorithm.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      672,
      499,
      498,
      663,
      500
    ],
    "source": ""
  },
  {
    "id": 432,
    "question": "Which statement best compares transmission control protocol (TCP) and user datagram protocol (UDP)?",
    "choice_a": "UDP is a best-efforts protocol and thus, provides high reliability.",
    "choice_b": "TCP provides retransmission and sequencing control, thus, providing high reliability.",
    "choice_c": "TCP is a best-efforts protocol and thus, provides high reliability.",
    "choice_d": "UDP provides retransmission and sequencing control, thus, providing high reliability.",
    "correct_answer": "B",
    "explanation": "Both TCP and UDP are Layer 4 protocols. The difference between them is that TCP is connection-oriented and provides reliable transport services, whereas UDP in connectionless and provides best-effort transport services. The other options reverse the nature of TCP (connection) and UDP (connectionless).",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      717,
      718,
      182,
      189,
      179
    ],
    "source": ""
  },
  {
    "id": 433,
    "question": "How do circuit-switched networks work?",
    "choice_a": "They divide data into packets and transmit it over a virtual network",
    "choice_b": "They establish a dedicated circuit between endpoints.",
    "choice_c": "They divide data into packets and transmit it over a shared network",
    "choice_d": "They establish an on-demand circuit between endpoints.",
    "correct_answer": "D",
    "explanation": "Plain old telephone service (POTS) is the clearest example of a circuit-switched network, with each phone call on a logical connection or circuit for its duration.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      179,
      717,
      718,
      465,
      453
    ],
    "source": ""
  },
  {
    "id": 434,
    "question": "What ports are commonly used for a Transport Layer Security\u00a0(TLS) connection?",
    "choice_a": "53 and 25",
    "choice_b": "21 and 22",
    "choice_c": "53 and 88",
    "choice_d": "443 and 80",
    "correct_answer": "D",
    "explanation": "The ports are defined in Internet Engineering Task Force requests for comments and can be reconfigured/reassigned by systems and network designers to meet specific needs.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      455,
      453,
      454,
      504,
      182
    ],
    "source": ""
  },
  {
    "id": 435,
    "question": "When establishing connections between hosts, which four identifiers are used to identify the specific connection?",
    "choice_a": "Source URL, source port, destination URL, destination port",
    "choice_b": "Source MAC, source port, destination MAC, destination port",
    "choice_c": "Source IP, destination IP",
    "choice_d": "Source IP, source port, destination IP, and destination port",
    "correct_answer": "D",
    "explanation": "Host connections are at the network layer and thus, use IP addresses and port numbers.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      719,
      454,
      508,
      504,
      505
    ],
    "source": ""
  },
  {
    "id": 436,
    "question": "Which of the following are valid host addresses for network address translation (NAT) according to Request for Comments (RFC) 1918?",
    "choice_a": "172.168.10.31",
    "choice_b": "10.168.10.17",
    "choice_c": "192.168.10.257",
    "choice_d": "172.15.10.29",
    "correct_answer": "B",
    "explanation": "RFC 1918 defined private address ranges (pre\u2013Classless Inter-Domain Routing\u00a0[CIDR]), using host ID sizes of 24, 20, and 16 bits for classes A, B, C, respectively. Count the bits from the left.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      470,
      507,
      450,
      508,
      452
    ],
    "source": ""
  },
  {
    "id": 437,
    "question": "Which of the following does <italic>not</italic> apply to Secure Sockets Layer (SSL)/Transport Layer Security (TLS)?",
    "choice_a": "Supports secure e-commerce transactions",
    "choice_b": "Provides secure connections between client and server",
    "choice_c": "Authenticates both client and server",
    "choice_d": "Does not use asymmetric algorithms",
    "correct_answer": "D",
    "explanation": "HTTPS or other protocols using SSL or TLS may provide session key wrapping, but SSL/TLS themselves do not.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      525,
      527,
      526,
      531,
      529
    ],
    "source": ""
  },
  {
    "id": 438,
    "question": "Which of the following would not be a good choice for a secure email system for a typical small business?",
    "choice_a": "Providing end users with suites of encryption tools they can use as they need to, to protect content",
    "choice_b": "Using third-party secure email services",
    "choice_c": "Using browser email client plug-ins or extensions",
    "choice_d": "Deploying a private secure email server and configuring encryption services for email as needed",
    "correct_answer": "A",
    "explanation": "The other options provide capabilities to set policies to encourage, require, or enforce the use of secure email capabilities.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      529,
      528,
      530,
      185,
      174
    ],
    "source": ""
  },
  {
    "id": 439,
    "question": "Which statement has the protocol layers in the correct top-to-bottom order?",
    "choice_a": "Physical, Data Link, Network, Transport",
    "choice_b": "Transport, Data Link, Network, Physical",
    "choice_c": "Presentation, Application, Session, Transport",
    "choice_d": "Presentation, Session, Transport, Network",
    "correct_answer": "D",
    "explanation": "The layers from most abstract to least abstract are as follows: Application, Presentation, Session, Transport, Network, Data Link, and Physical.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      504,
      179,
      501,
      525,
      180
    ],
    "source": ""
  },
  {
    "id": 440,
    "question": "What is the biggest security issue associated with the use of a Multiprotocol Label Switching (MPLS) network?",
    "choice_a": "Lack of native encryption services",
    "choice_b": "Lack of native authentication services",
    "choice_c": "Use of Wired Equivalent Privacy (WEP) and Data Encryption Standard (DES) algorithms",
    "choice_d": "The need to establish peering relationships to cross Tier 1 carrier boundaries",
    "correct_answer": "A",
    "explanation": "Most MPLS implementations provide encryption at higher protocol layers as a way around this. The other options do not apply to MPLS.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      525,
      527,
      504,
      178,
      180
    ],
    "source": ""
  },
  {
    "id": 441,
    "question": "When setting up firewall rules, which is the best practice to follow?",
    "choice_a": "Allow all and then take away",
    "choice_b": "Allow none and then add specific rules",
    "choice_c": "Use a mix of allow-none and allow-all based on a segmented network and systems view",
    "choice_d": "Use your risk assessment findings to guide this decision for each business process",
    "correct_answer": "B",
    "explanation": "This approach forces you to systematically identify required services and connections, and constrain by date, time, or other attributes, one by one. It also precludes overlooking a factory-default connection that you may not need or want.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      686,
      685,
      174,
      200,
      187
    ],
    "source": ""
  },
  {
    "id": 442,
    "question": "A new installation requires a network in a heavy manufacturing area with substantial amounts of electromagnetic radiation and power fluctuations. Which media is best suited for this environment if little traffic degradation is tolerated?",
    "choice_a": "Shielded twisted pair",
    "choice_b": "Coax",
    "choice_c": "Fiber",
    "choice_d": "Wireless",
    "correct_answer": "C",
    "explanation": "Other physical technologies are more prone to electromagnetic interference.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      682,
      681,
      675,
      504,
      677
    ],
    "source": ""
  },
  {
    "id": 443,
    "question": "Which of the following is typically deployed as a screening proxy for web servers?",
    "choice_a": "Intrusion prevention system",
    "choice_b": "Kernel proxies",
    "choice_c": "Packet filters",
    "choice_d": "Reverse proxies",
    "correct_answer": "D",
    "explanation": "Kernel proxies can help accelerate Secure Sockets Layer (SSL) but do not provide screening of service or resource requests. The other options are not proxies.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      531,
      532,
      533,
      529,
      769
    ],
    "source": ""
  },
  {
    "id": 444,
    "question": "Which of the following should be part of a network's perimeter defense?",
    "choice_a": "Virtual local area network (VLAN)",
    "choice_b": "Domain Name System (DNS) server",
    "choice_c": "Switch",
    "choice_d": "Firewall",
    "correct_answer": "D",
    "explanation": "The other options by themselves provide no security capabilities.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      689,
      533,
      532,
      730,
      180
    ],
    "source": ""
  },
  {
    "id": 445,
    "question": "Which statement best describes what security information and event management systems can do?",
    "choice_a": "Provide script-based management of incident response team actions, to help preserve chain of custody of evidence",
    "choice_b": "Collect data from multiple sources and bring it together for meaningful analysis",
    "choice_c": "Manage network and systems resources, devices, apps, and so forth to ensure policies are consistently enabled and monitored",
    "choice_d": "Provide predictive analytics as a means of identifying event precursors",
    "correct_answer": "B",
    "explanation": "The other options take some very smart people to accomplish.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      197,
      199,
      167,
      165,
      162
    ],
    "source": ""
  },
  {
    "id": 446,
    "question": "A security incident event management (SIEM) service performs which of the following function?",
    "choice_a": "Configures software for security policies and procedures",
    "choice_b": "Aggregates logs from security devices and application servers looking for suspicious activity",
    "choice_c": "Documents incident handling and communication",
    "choice_d": "Matches user system authorization with physical access permissions",
    "correct_answer": "B",
    "explanation": "Though the other options are useful, if not vital, security tactics, they're not what SIEMs do.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      731,
      730,
      199,
      770,
      533
    ],
    "source": ""
  },
  {
    "id": 447,
    "question": "Which type of technology can examine network traffic at much deeper levels?",
    "choice_a": "Host-based firewalls",
    "choice_b": "Proxy firewalls",
    "choice_c": "Network-based intrusion detection systems",
    "choice_d": "Antimalware systems",
    "correct_answer": "B",
    "explanation": "The others do not allow for application-layer traffic inspection.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      770,
      532,
      533,
      689,
      730
    ],
    "source": ""
  },
  {
    "id": 448,
    "question": "Which of the following should be used to protect wireless local area network (WLAN) communications?",
    "choice_a": "Wired Equivalent Privacy (WEP)",
    "choice_b": "Wireless\u00a0Application Protocol\u00a0(WAP)",
    "choice_c": "Wireless\u00a0Application Protocol\u00a02 (WPA2)",
    "choice_d": "Temporal Key Integrity Protocol\u00a0(TKIP)",
    "correct_answer": "C",
    "explanation": "WEP and WAP have been shown to be vulnerable; TKIP was a short-lived Band-Aid for WEP and should no longer be used.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 449,
    "question": "All of the following are examples of social engineering attacks, except:",
    "choice_a": "Phishing",
    "choice_b": "Whaling",
    "choice_c": "Spear phishing",
    "choice_d": "Ransom",
    "correct_answer": "D",
    "explanation": "Ransom attacks (whether by ransomware or not) may involve social engineering as part of gaining access, but they don't use social engineering to implement the attack.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      259,
      263,
      261,
      262,
      265
    ],
    "source": ""
  },
  {
    "id": 450,
    "question": "Which of the following is <italic>not</italic> an example of malware?",
    "choice_a": "Ransomware",
    "choice_b": "Logic bomb",
    "choice_c": "Trojan horse",
    "choice_d": "Tailgating",
    "correct_answer": "D",
    "explanation": "Humans tailgate other humans through checkpoints.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      267,
      204,
      202,
      207,
      201
    ],
    "source": ""
  },
  {
    "id": 451,
    "question": "What is a type of device with limited local storage capacity known as?",
    "choice_a": "Thick client",
    "choice_b": "Thin client",
    "choice_c": "Endpoint",
    "choice_d": "Peer",
    "correct_answer": "B",
    "explanation": "Thick clients have extensive \u201clocal\u201d files, often needing synchronization with servers or cloud backups. Peers, as in peer-to-peer, are part of service relationships.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      705,
      706,
      707,
      535,
      697
    ],
    "source": ""
  },
  {
    "id": 452,
    "question": "Which of the following should <italic>not</italic> be addressed as part of endpoint security",
    "choice_a": "Monitor network traffic across the demilitarized zone (DMZ)",
    "choice_b": "Physical security",
    "choice_c": "Antivirus protection",
    "choice_d": "Access control",
    "correct_answer": "A",
    "explanation": "Endpoints cannot (or should not) have such visibility across all segments of your networks.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      245,
      217,
      218,
      219,
      252
    ],
    "source": ""
  },
  {
    "id": 453,
    "question": "Which of the following is <italic>not</italic> an essential characteristic of cloud computing?",
    "choice_a": "On-demand self-service",
    "choice_b": "Broad network access",
    "choice_c": "Rapid elasticity",
    "choice_d": "Single tenancy",
    "correct_answer": "D",
    "explanation": "While one deployment model (private clouds) does support single tenants, that does not make \u201csingle tenant\u201d a defining characteristic of cloud computing.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      746,
      535,
      536,
      534,
      696
    ],
    "source": ""
  },
  {
    "id": 454,
    "question": "Which of the following hypervisor types would be most attractive to an attacker to compromise?",
    "choice_a": "Type 1, because it runs on hardware and provides lower-layer attack capabilities",
    "choice_b": "Type 2, because it runs on an operating system and therefore provides more opportunities",
    "choice_c": "Neither, because they are almost impossible to compromise",
    "choice_d": "Both Types 1 and 2, since they both exist in all environments",
    "correct_answer": "B",
    "explanation": "Attacking the host operating system (or subverting built-in features in it, via illicit access) may provide greater opportunity to attack or subvert the hypervisor.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      536,
      535,
      534,
      696,
      697
    ],
    "source": ""
  },
  {
    "id": 455,
    "question": "Which of the following statements is the best description of the hypervisor?",
    "choice_a": "Allows multiple hosts to share a single operating system",
    "choice_b": "Allows multiple applications to share multiple operating systems",
    "choice_c": "Allows multiple tasks to share a single operating system",
    "choice_d": "Allows multiple operating systems to share a single host",
    "correct_answer": "D",
    "explanation": "The other options address other multiprocessing or software deployment strategies not involving virtualization.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      535,
      201,
      220,
      268,
      240
    ],
    "source": ""
  },
  {
    "id": 456,
    "question": "Greg is the network administrator for a large stadium that hosts many events throughout the course of the year. They equip ushers with handheld scanners to verify tickets. Ushers turn over frequently and are often hired at the last minute. Scanners are handed out to ushers before each event, but different ushers may use different scanners. Scanners are secured in a locked safe when not in use. What network access control approach would be most effective for this scenario?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Device authentication",
    "choice_c": "Password authentication",
    "choice_d": "No authentication",
    "correct_answer": "B",
    "explanation": "Device authentication allows the venue to restrict network access to authorized scanners but does not require individual ushers to sign in to the device. This seems an acceptable level of security for this environment, as the scanners are carefully controlled. Moving to any authentication scheme that requires user authentication would be unwieldy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      273,
      726,
      280,
      566,
      420
    ],
    "source": ""
  },
  {
    "id": 457,
    "question": "Norma is helping her organization create a specialized network designed for vendors that need to connect to Norma's organization's network to process invoices and upload inventory. This network should be segmented from the rest of the corporate network but have a much higher degree of access than the general public. What type of network is Norma building?",
    "choice_a": "Internet",
    "choice_b": "Intranet",
    "choice_c": "Outranet",
    "choice_d": "Extranet",
    "correct_answer": "D",
    "explanation": "The purpose of an extranet is to allow outside organizations that are business partners to access limited resources on the corporate network. That describes the situation in this scenario, so Norma is building an extranet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      273,
      425,
      420,
      10,
      334
    ],
    "source": ""
  },
  {
    "id": 458,
    "question": "Which one of the following is an example of a nondiscretionary access control system?",
    "choice_a": "File ACLs",
    "choice_b": "MAC",
    "choice_c": "DAC",
    "choice_d": "Visitor list",
    "correct_answer": "B",
    "explanation": "A mandatory access control (MAC) scheme is an example of a nondiscretionary approach to access control, as the owner of objects does not have the ability to set permissions on those objects. It is possible for a visitor list or file ACLs to be configured using a nondiscretionary scheme, but these approaches can also be configured as discretionary access control (DAC) implementations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      710,
      539,
      540,
      555
    ],
    "source": ""
  },
  {
    "id": 459,
    "question": "Wanda is configuring device-based authentication for systems on her network. Which one of the following approaches offers the strongest way to authenticate devices?",
    "choice_a": "IP address",
    "choice_b": "MAC address",
    "choice_c": "Digital certificate",
    "choice_d": "Password",
    "correct_answer": "C",
    "explanation": "Digital certificates are the strongest device-based access control mechanism listed in this scenario. Administrators may create certificates for each device and tie them to the physical device. Passwords are easily transferred to other devices and are not as strong an approach. IP addresses are easily changed and should not be used. MAC addresses theoretically identify devices uniquely, but it is possible to alter a MAC address, so they should not be relied upon for authentication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      728,
      726,
      404,
      273,
      274
    ],
    "source": ""
  },
  {
    "id": 460,
    "question": "Kaiden is creating an extranet for his organization and is concerned about unauthorized eavesdropping on network communications. Which one of the following technologies can he use to mitigate this risk?",
    "choice_a": "VPN",
    "choice_b": "Firewall",
    "choice_c": "Content filter",
    "choice_d": "Proxy server",
    "correct_answer": "A",
    "explanation": "Kaiden should use a virtual private network (VPN) for all remote connections to the extranet. The VPN will encrypt traffic sent over public networks and protect it from eavesdropping.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      304,
      425,
      357,
      437,
      273
    ],
    "source": ""
  },
  {
    "id": 461,
    "question": "When Ben lists the files on a Linux system, he sees the set of attributes shown here. <br><img src=\"/question_assets/SSCP/c01uf001.png\"/><br>The letters <code>rwx</code> indicate different levels of what?",
    "choice_a": "Identification",
    "choice_b": "Authorization",
    "choice_c": "Authentication",
    "choice_d": "Accountability",
    "correct_answer": "B",
    "explanation": "The permissions granted on files in Linux designate what authorized users can do with those files\u2014read, write, or execute. In the image shown, all users can read, write, and execute <code>index.html</code>, whereas the owner can read, write, and execute <code>example.txt</code>, the group cannot, and everyone can write and execute it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      539,
      541,
      4,
      6,
      13
    ],
    "source": ""
  },
  {
    "id": 462,
    "question": "Which one of the following tools is most often used for identification purposes and is not suitable for use as an authenticator?",
    "choice_a": "Password",
    "choice_b": "Retinal scan",
    "choice_c": "Username",
    "choice_d": "Token",
    "correct_answer": "C",
    "explanation": "Usernames are an identification tool. They are not secret, so they are not suitable for use as a password.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      322,
      357,
      327,
      5
    ],
    "source": ""
  },
  {
    "id": 463,
    "question": "Gary is preparing to create an account for a new user and assign privileges to the HR database. What two elements of information must Gary verify before granting this access?",
    "choice_a": "Credentials and need to know",
    "choice_b": "Clearance and need to know",
    "choice_c": "Password and clearance",
    "choice_d": "Password and biometric scan",
    "correct_answer": "B",
    "explanation": "Before granting access, Gary should verify that the user has a valid security clearance and a business need to know the information. Gary is performing an authorization task, so he does not need to verify the user's credentials, such as a password or biometric scan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      420,
      281,
      337,
      446,
      1
    ],
    "source": ""
  },
  {
    "id": 464,
    "question": "Ben's organization is adopting biometric authentication for its high-security building's access control system. Use the following chart to answer questions about the organization's adoption of the technology. <br><img src=\"/question_assets/SSCP/c01uf002.png\"/><br>Ben's company is considering configuring its systems to work at the level shown by point A on the diagram. To what level is it setting the sensitivity?",
    "choice_a": "The FRR crossover",
    "choice_b": "The FAR point",
    "choice_c": "The CER",
    "choice_d": "The CFR",
    "correct_answer": "C",
    "explanation": "The crossover error rate is the point where false acceptance rate and false rejection rate cross over and is a standard assessment used to compare the accuracy of biometric devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      484,
      483,
      485,
      374,
      298
    ],
    "source": ""
  },
  {
    "id": 465,
    "question": "Ben's organization is adopting biometric authentication for its high-security building's access control system. Use the following chart to answer questions about the organization's adoption of the technology. <br><img src=\"/question_assets/SSCP/c01uf002.png\"/><br> At point B, what problem is likely to occur?",
    "choice_a": "False acceptance will be very high.",
    "choice_b": "False rejection will be very high.",
    "choice_c": "False rejection will be very low.",
    "choice_d": "False acceptance will be very low.",
    "correct_answer": "A",
    "explanation": "At point B, the false acceptance rate, or FAR, is quite high, while the false rejection rate, or FRR, is relatively low. This may be acceptable in some circumstances, but in organizations where a false acceptance can cause a major problem, it is likely that they should instead choose a point to the right of point A.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      484,
      483,
      374,
      298,
      280
    ],
    "source": ""
  },
  {
    "id": 466,
    "question": "Ben's organization is adopting biometric authentication for its high-security building's access control system. Use the following chart to answer questions about the organization's adoption of the technology. <br><img src=\"/question_assets/SSCP/c01uf002.png\"/><br>What should Ben do if the FAR and FRR shown in this diagram does not provide an acceptable performance level for his organization's needs?",
    "choice_a": "Adjust the sensitivity of the biometric devices.",
    "choice_b": "Assess other biometric systems to compare them.",
    "choice_c": "Move the CER.",
    "choice_d": "Adjust the FRR settings in software.",
    "correct_answer": "B",
    "explanation": "CER is a standard used to assess biometric devices. If the CER for this device does not fit the needs of the organization, Ben should assess other biometric systems to find one with a lower CER. Sensitivity is already accounted for in CER charts, and moving the CER isn't something Ben can do. FRR is not a setting in software, so Ben can't use that as an option either.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      484,
      280,
      273,
      357,
      321
    ],
    "source": ""
  },
  {
    "id": 467,
    "question": "When a subject claims an identity, what process is occurring?",
    "choice_a": "Login",
    "choice_b": "Identification",
    "choice_c": "Authorization",
    "choice_d": "Token presentation",
    "correct_answer": "B",
    "explanation": "The process of a subject claiming or professing an identity is known as <italic>identification</italic>. Authorization verifies the identity of a subject by checking a factor such as a password. Logins typically include both identification and authorization, and token presentation is a type of authentication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      556,
      323,
      281,
      544,
      420
    ],
    "source": ""
  },
  {
    "id": 468,
    "question": "Files, databases, computers, programs, processes, devices, and media are all examples of what?",
    "choice_a": "Subjects",
    "choice_b": "Objects",
    "choice_c": "File stores",
    "choice_d": "Users",
    "correct_answer": "B",
    "explanation": "All of these are objects. Although some of these items can be subjects, files, databases, and storage media can't be. Processes and programs aren't file stores, and of course none of these is a user.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      541,
      4,
      290,
      539,
      353
    ],
    "source": ""
  },
  {
    "id": 469,
    "question": "MAC models use three types of environments. Which of the following is not a mandatory access control design?",
    "choice_a": "Hierarchical",
    "choice_b": "Bracketed",
    "choice_c": "Compartmentalized",
    "choice_d": "Hybrid",
    "correct_answer": "B",
    "explanation": "Mandatory access control systems can be hierarchical, where each domain is ordered and related to other domains above and below it; compartmentalized, where there is no relationship between each domain; or hybrid, where both hierarchy and compartments are used. There is no concept of bracketing in mandatory access control design.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      540,
      555,
      556,
      273
    ],
    "source": ""
  },
  {
    "id": 470,
    "question": "Ryan would like to implement an access control technology that is likely to both improve security and increase user satisfaction.  Which one of the following technologies meets this requirement?",
    "choice_a": "Mandatory access controls",
    "choice_b": "Single sign-on",
    "choice_c": "Multifactor authentication",
    "choice_d": "Automated deprovisioning",
    "correct_answer": "B",
    "explanation": "All of the controls listed here, if properly implemented, have the potential to improve the organization's security posture.  However, only single sign-on is likely to improve the user experience by eliminating barriers to authentication across multiple systems.  Mandatory access control and multifactor authentication will likely be seen as inconveniences by users, while automated deprovisioning will improve the experience of identity and access management administrators but not affect the end user experience.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      543,
      726,
      542,
      708,
      345
    ],
    "source": ""
  },
  {
    "id": 471,
    "question": "The leadership at Susan's company has asked her to implement an access control system that can support rule declarations like \u201cOnly allow access to salespeople from managed devices on the wireless network between 8 a.m. and 6 p.m.\u201d What type of access control system would be Susan's best choice?",
    "choice_a": "ABAC",
    "choice_b": "Rule-based access control (RBAC)",
    "choice_c": "DAC",
    "choice_d": "MAC",
    "correct_answer": "A",
    "explanation": "An attribute-based access control (ABAC) system will allow Susan to specify details about subjects, objects, and access, allowing granular control. Although a rule-based access control system (RBAC) might allow this, the attribute-based access control system can be more specific and thus, is more flexible. Discretionary access control (DAC) would allow object owners to make decisions, and mandatory access controls (MACs) would use classifications; neither of these capabilities was described in the requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      539,
      429,
      739,
      345
    ],
    "source": ""
  },
  {
    "id": 472,
    "question": "What is the primary advantage of decentralized access control?",
    "choice_a": "It provides better redundancy.",
    "choice_b": "It provides control of access to people closer to the resources.",
    "choice_c": "It is less expensive.",
    "choice_d": "It provides more granular control of access.",
    "correct_answer": "B",
    "explanation": "Decentralized access control empowers people closer to the resources to control access but does not provide consistent control. It does not provide redundancy, since it merely moves control points, the cost of access control depends on its implementation and methods, and granularity can be achieved in both centralized and decentralized models.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      539,
      273,
      274,
      551
    ],
    "source": ""
  },
  {
    "id": 473,
    "question": "Which of the following is best described as an access control model that focuses on subjects and identifies the objects that each subject can access?",
    "choice_a": "An access control list",
    "choice_b": "An implicit denial list",
    "choice_c": "A capability table",
    "choice_d": "A rights management matrix",
    "correct_answer": "C",
    "explanation": "Capability tables list the privileges assigned to subjects and identify the objects that subjects can access. Access control lists are object-focused rather than subject-focused. Implicit deny is a principle that states that anything that is not explicitly allowed is denied, and a rights management matrix is not an access control model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      539,
      541,
      540,
      557,
      555
    ],
    "source": ""
  },
  {
    "id": 474,
    "question": "Susan wants to integrate her website to allow users to use accounts from sites like Google. What technology should she adopt?",
    "choice_a": "Kerberos",
    "choice_b": "LDAP",
    "choice_c": "OpenID",
    "choice_d": "SESAME",
    "correct_answer": "C",
    "explanation": "OpenID is a widely supported standard that allows a user to use a single account to log into multiple sites, and Google accounts are frequently used with OpenID.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      544,
      545,
      543,
      708,
      6
    ],
    "source": ""
  },
  {
    "id": 475,
    "question": "Ben uses a software-based token that changes its code every minute. What type of token is he using?",
    "choice_a": "Asynchronous",
    "choice_b": "Smart card",
    "choice_c": "Synchronous",
    "choice_d": "Static",
    "correct_answer": "C",
    "explanation": "Synchronous soft tokens, such as Google Authenticator, use a time-based algorithm that generates a constantly changing series of codes. Asynchronous tokens typically require a challenge to be entered on the token to allow it to calculate a response, which the server compares to the response it expects. Smartcards typically present a certificate but may have other token capabilities built in. Static tokens are physical devices that can contain credentials and include smart cards and memory cards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      480,
      481,
      482,
      544,
      293
    ],
    "source": ""
  },
  {
    "id": 476,
    "question": "How does single sign-on increase security?",
    "choice_a": "It decreases the number of accounts required for a subject.",
    "choice_b": "It helps decrease the likelihood that users will write down their passwords.",
    "choice_c": "It provides logging for each system that it is connected to.",
    "choice_d": "It provides better encryption for authentication data.",
    "correct_answer": "B",
    "explanation": "Studies consistently show that users are more likely to write down passwords if they have more accounts. Central control of a single account is also easier to shut off if something does go wrong. Simply decreasing the number of accounts required for a subject doesn't increase security by itself, and SSO does not guarantee individual system logging, although it should provide central logging of SSO activity. Since an SSO system was not specified, there is no way of determining whether a given SSO system provides better or worse encryption for authentication data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      543,
      545,
      544,
      726,
      273
    ],
    "source": ""
  },
  {
    "id": 477,
    "question": "Which of the following multifactor authentication technologies provides both low management overhead and flexibility?",
    "choice_a": "Biometrics",
    "choice_b": "Software tokens",
    "choice_c": "Synchronous hardware tokens",
    "choice_d": "Asynchronous hardware tokens",
    "correct_answer": "B",
    "explanation": "Software tokens are flexible, with delivery options including mobile applications, SMS, and phone delivery. They have a relatively low administrative overhead, as users can typically self-manage. Biometrics require significant effort to register users and to deploy and maintain infrastructure, and they require hardware at each authentication location. Both types of hardware tokens can require additional overhead for distribution and maintenance, and token failure can cause support challenges.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      727,
      480,
      481,
      328
    ],
    "source": ""
  },
  {
    "id": 478,
    "question": "Tom is planning to terminate an employee this afternoon for fraud and expects that the meeting will be somewhat hostile. He is coordinating the meeting with human resources and wants to protect the company against damage. Which one of the following steps is most important to coordinate in time with the termination meeting?",
    "choice_a": "Informing other employees of the termination",
    "choice_b": "Retrieving the employee's photo ID",
    "choice_c": "Calculating the final paycheck",
    "choice_d": "Revoking electronic access rights",
    "correct_answer": "D",
    "explanation": "Electronic access to company resources must be carefully coordinated. An employee who retains access after being terminated may use that access to take retaliatory action. On the other hand, if access is terminated too early, the employee may figure out that he or she is about to be terminated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      547,
      542,
      273,
      345,
      383
    ],
    "source": ""
  },
  {
    "id": 479,
    "question": "Jim wants to allow a partner organization's Active Directory forest (B) to access his domain forest's (A)'s resources but doesn't want to allow users in his domain to access B's resources. He also does not want the trust to flow upward through the domain tree as it is formed. What should he do?",
    "choice_a": "Set up a two-way transitive trust.",
    "choice_b": "Set up a one-way transitive trust.",
    "choice_c": "Set up a one-way nontransitive trust.",
    "choice_d": "Set up a two-way nontransitive trust.",
    "correct_answer": "C",
    "explanation": "A trust that allows one forest to access another's resources without the reverse being possible is an example of a one-way trust. Since Jim doesn't want the trust path to flow as the domain tree is formed, this trust has to be nontransitive.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      555,
      557,
      328,
      273,
      446
    ],
    "source": ""
  },
  {
    "id": 480,
    "question": "The financial services company that Susan works for provides a web portal for its users. When users need to verify their identity, the company uses information from third-party sources to ask questions based on their past credit reports, such as \u201cWhich of the following streets did you live on in 2007?\u201d What process is Susan's organization using?",
    "choice_a": "Identity proofing",
    "choice_b": "Password verification",
    "choice_c": "Authenticating with Type 2 authentication factor",
    "choice_d": "Out-of-band identity proofing",
    "correct_answer": "A",
    "explanation": "Verifying information that an individual should know about themselves using third-party factual information (a Type 1 authentication factor) is sometimes known as dynamic knowledge-based authentication and is a type of identity proofing. Out-of-band identity proofing would use another means of contacting the user, such as a text message or phone call, and password verification requires a password.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      564,
      726,
      544,
      5,
      420
    ],
    "source": ""
  },
  {
    "id": 481,
    "question": "Lauren's team of system administrators each deal with hundreds of systems with varying levels of security requirements and find it difficult to handle the multitude of usernames and passwords they each have. What type of solution should she recommend to ensure that passwords are properly handled and that features such as logging and password rotation occur?",
    "choice_a": "A credential management system",
    "choice_b": "A strong password policy",
    "choice_c": "Separation of duties",
    "choice_d": "Single sign-on",
    "correct_answer": "A",
    "explanation": "Lauren's team would benefit from a credential management system. Credential management systems offer features such as password management, multifactor authentication to retrieve passwords, logging, audit, and password rotation capabilities. A strong password policy would only make maintenance of passwords for many systems a more difficult task if done manually. Single sign-on would help if all of the systems had the same sensitivity levels, but different credentials are normally required for higher-sensitivity systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      566,
      552,
      543,
      554,
      749
    ],
    "source": ""
  },
  {
    "id": 482,
    "question": "What type of trust relationship extends beyond the two domains participating in the trust to one or more of their subdomains?",
    "choice_a": "Transitive trust",
    "choice_b": "Inheritable trust",
    "choice_c": "Nontransitive trust",
    "choice_d": "Noninheritable trust",
    "correct_answer": "A",
    "explanation": "Transitive trusts go beyond the two domains directly involved in the trust relationship and extend to their subdomains. Nontransitive trusts are not inheritable to other domains. The terms <italic>inheritable trust</italic> and <italic>noninheritable trust</italic> are not normally used.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 483,
    "question": "Adam is accessing a standalone file server using a username and password provided to him by the server administrator. Which one of the following entities is guaranteed to have information necessary to complete the authorization process?",
    "choice_a": "Adam",
    "choice_b": "File server",
    "choice_c": "Server administrator",
    "choice_d": "Adam's supervisor",
    "correct_answer": "B",
    "explanation": "We know that both Adam and the server administrator have the username and password, but this is information used for identification and authentication, not authorization. We do not know what information Adam's supervisor might have. The server is a standalone file server, so it must have information about the activities that Adam is authorized to perform.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      273,
      726,
      5,
      446,
      334
    ],
    "source": ""
  },
  {
    "id": 484,
    "question": "After 10 years working in her organization, Cassandra is moving into her fourth role, this time as a manager in the accounting department. What issue is likely to show up during an account review if her organization does not have strong account maintenance practices?",
    "choice_a": "An issue with least privilege",
    "choice_b": "Privilege creep",
    "choice_c": "Account creep",
    "choice_d": "Account termination",
    "correct_answer": "B",
    "explanation": "Privilege creep is a common problem when employees change roles over time and their privileges and permissions are not properly modified to reflect their new roles. Least privilege issues are a design or implementation problem, and switching roles isn't typically what causes them to occur. Account creep is not a common industry term, and account termination would imply that someone has removed her account instead of switching her to new groups or new roles.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      549,
      550,
      537,
      709,
      557
    ],
    "source": ""
  },
  {
    "id": 485,
    "question": "Adam recently configured permissions on an NTFS filesystem to describe the access that different users may have to a file by listing each user individually. What did Adam create?",
    "choice_a": "An access control list",
    "choice_b": "An access control entry",
    "choice_c": "Role-based access control",
    "choice_d": "Mandatory access control",
    "correct_answer": "A",
    "explanation": "Adam created a list of individual users that may access the file. This is an access control list, which consists of multiple access control entries. It includes the names of users, so it is not role-based, and Adam was able to modify the list, so it is not mandatory access control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      539,
      537,
      555,
      557,
      286
    ],
    "source": ""
  },
  {
    "id": 486,
    "question": "Questions like \u201cWhat is your pet's name?\u201d are examples of what type of identity proofing?",
    "choice_a": "Knowledge-based authentication",
    "choice_b": "Dynamic knowledge-based authentication",
    "choice_c": "Out-of-band identity proofing",
    "choice_d": "A Type 3 authentication factor",
    "correct_answer": "A",
    "explanation": "Knowledge-based authentication relies on preset questions such as \u201cWhat is your pet's name?\u201d and the answers. It can be susceptible to attacks because of the availability of the answers on social media or other sites. Dynamic knowledge-based authentication relies on facts or data that the user already knows that can be used to create questions they can answer on an as-needed basis (for example, a previous address, or a school they attended). Out-of-band identity proofing relies on an alternate channel like a phone call or text message. Finally, Type 3 authentication factors are biometric, or \u201csomething you are,\u201d rather than knowledge-based.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      564,
      726,
      727,
      562,
      483
    ],
    "source": ""
  },
  {
    "id": 487,
    "question": "What access management concept defines what rights or privileges a user has?",
    "choice_a": "Identification",
    "choice_b": "Accountability",
    "choice_c": "Authorization",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "Authorization defines what a subject can or can't do. Identification occurs when a subject claims an identity, accountability is provided by the logs and audit trail that track what occurs on a system, and authorization occurs when that identity is validated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      538,
      562,
      556,
      274
    ],
    "source": ""
  },
  {
    "id": 488,
    "question": "Susan has been asked to recommend whether her organization should use a MAC scheme or a DAC scheme. If flexibility and scalability are important requirements for implementing access controls, which scheme should she recommend and why?",
    "choice_a": "MAC, because it provides greater scalability and flexibility because you can simply add more labels as needed",
    "choice_b": "DAC, because allowing individual administrators to make choices about the objects they control provides scalability and flexibility",
    "choice_c": "MAC, because compartmentalization is well suited to flexibility and adding compartments will allow it to scale well",
    "choice_d": "DAC, because a central decision process allows quick responses and will provide scalability by reducing the number of decisions required and flexibility by moving those decisions to a central authority",
    "correct_answer": "B",
    "explanation": "Discretionary access control (DAC) can provide greater scalability by leveraging many administrators, and those administrators can add flexibility by making decisions about access to their objects without fitting into an inflexible mandatory access control (MAC) system. MAC is more secure because of the strong set of controls it provides, but it does not scale as well as DAC and is relatively inflexible in comparison.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      539,
      538,
      551,
      429
    ],
    "source": ""
  },
  {
    "id": 489,
    "question": "Which of the following tools is not typically used to verify that a provisioning process was followed in a way that ensures that the organization's security policy is being followed?",
    "choice_a": "Log review",
    "choice_b": "Manual review of permissions",
    "choice_c": "Signature-based detection",
    "choice_d": "Review the audit trail",
    "correct_answer": "C",
    "explanation": "While signature-based detection is used to detect attacks, review of provisioning processes typically involves checking logs, reviewing the audit trail, or performing a manual review of permissions granted during the provisioning process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      542,
      708,
      709,
      710,
      420
    ],
    "source": ""
  },
  {
    "id": 490,
    "question": "Joe is the security administrator for an ERP system. He is preparing to create accounts for several new employees. What default access should he give to all of the new employees as he creates the accounts?",
    "choice_a": "Read only",
    "choice_b": "Editor",
    "choice_c": "Administrator",
    "choice_d": "No access",
    "correct_answer": "D",
    "explanation": "The principle of least privilege should guide Joe in this case. He should apply no access permissions by default and then give each user the necessary permissions to perform their job responsibilities. Read-only, editor, and administrator permissions may be necessary for one or more of these users, but those permissions should be assigned based upon business need and not by default.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      273,
      557,
      19,
      13
    ],
    "source": ""
  },
  {
    "id": 491,
    "question": "A new customer at a bank that uses fingerprint scanners to authenticate its users is surprised when he scans his fingerprint and is logged in to another customer's account. What type of biometric factor error occurred?",
    "choice_a": "A registration error",
    "choice_b": "A Type 1 error",
    "choice_c": "A Type 2 error",
    "choice_d": "A time-of-use, method-of-use error",
    "correct_answer": "C",
    "explanation": "Type 2 errors occur in biometric systems when an invalid subject is incorrectly authenticated as a valid user. In this case, nobody except the actual customer should be validated when fingerprints are scanned. Type 2 errors are also known as false positive errors. Type 1 (or false negative) errors occur when a valid subject is not authenticated; if the existing customer was rejected, it would be a Type 1 error. Registration is the process of adding users, but registration errors and time-of-use, method-of-use errors are not specific biometric authentication terms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      483,
      484,
      485,
      374,
      564
    ],
    "source": ""
  },
  {
    "id": 492,
    "question": "Laura is in the process of logging into a system and she just entered her password.  What term best describes this activity?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "Identification",
    "correct_answer": "A",
    "explanation": "Entering a password is an act that proves a user's identity and, therefore, is an authentication step.  Laura likely already identified herself by providing her username or performing a similar identification function.  Authorization occurs after authentication when the system determines what actions Laura is allowed to take.  Accounting occurs when the system logs Laura's activity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      562,
      544,
      323,
      552,
      273
    ],
    "source": ""
  },
  {
    "id": 493,
    "question": "Kelly is adjusting her organization's password requirements to make them consistent with best practice guidance from NIST. What should she choose as the most appropriate time period for password expiration?",
    "choice_a": "30 days",
    "choice_b": "90 days",
    "choice_c": "180 days",
    "choice_d": "No expiration",
    "correct_answer": "D",
    "explanation": "Current best practice guidance from NIST, published in NIST Special Publication 800-63b, suggests that organizations should not impose password expiration requirements on end users.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      552,
      553,
      559,
      747,
      748
    ],
    "source": ""
  },
  {
    "id": 494,
    "question": "Ben is working on integrating a federated identity management system and needs to exchange authentication and authorization information for browser-based single sign-on. What technology is his best option?",
    "choice_a": "HTML",
    "choice_b": "XACML",
    "choice_c": "SAML",
    "choice_d": "SPML",
    "correct_answer": "C",
    "explanation": "Security Assertion Markup Language (SAML) is the best choice for providing authentication and authorization information, particularly for browser-based SSO. HTML is primarily used for web pages, SPML is used to exchange user information for SSO, and XACML is used for access control policy markup.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      739,
      545,
      543,
      562,
      537
    ],
    "source": ""
  },
  {
    "id": 495,
    "question": "What access control scheme labels subjects and objects and allows subjects to access objects when the labels match?",
    "choice_a": "DAC",
    "choice_b": "MAC",
    "choice_c": "Rule-based access control (RBAC)",
    "choice_d": "Role-based access control (RBAC)",
    "correct_answer": "B",
    "explanation": "Mandatory access control (MAC) applies labels to subjects and objects and allows subjects to access objects when their labels match. Discretionary access control (DAC) is controlled by the owner of objects, rule-based access control applies rules throughout a system, and role-based access control bases rights on roles, which are often handled as groups of users.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      539,
      710,
      738,
      286
    ],
    "source": ""
  },
  {
    "id": 496,
    "question": "Mandatory access control is based on what type of model?",
    "choice_a": "Discretionary",
    "choice_b": "Group-based",
    "choice_c": "Lattice-based",
    "choice_d": "Rule-based",
    "correct_answer": "C",
    "explanation": "Mandatory access control systems are based on a lattice-based model. Lattice-based models use a matrix of classification labels to compartmentalize data. Discretionary access models allow object owners to determine access to the objects they control, role-based access controls are often group-based, and rule-based access controls like firewall ACLs apply rules to all subjects they apply to.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      539,
      710,
      345,
      286
    ],
    "source": ""
  },
  {
    "id": 497,
    "question": "Ricky would like to access a remote file server through a VPN connection. He begins this process by connecting to the VPN and attempting to log in. Applying the subject/object model to this request, what is the subject of Ricky's login attempt?",
    "choice_a": "Ricky",
    "choice_b": "VPN",
    "choice_c": "Remote file server",
    "choice_d": "Files contained on the remote server",
    "correct_answer": "A",
    "explanation": "In the subject/object model of access control, the user or process making the request for a resource is the subject of that request. In this example, Ricky is requesting access to the VPN (the object of the request) and is, therefore, the subject.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      555,
      556,
      557,
      304,
      354
    ],
    "source": ""
  },
  {
    "id": 498,
    "question": "What type of access control is typically used by firewalls?",
    "choice_a": "Discretionary access controls",
    "choice_b": "Rule-based access controls",
    "choice_c": "Task-based access control",
    "choice_d": "Mandatory access controls",
    "correct_answer": "B",
    "explanation": "Firewalls use rule-based access control in their access control lists and apply rules created by administrators to all traffic that passes through them. DAC, or discretionary access control, allows owners to determine who can access objects they control, while task-based access control lists tasks for users. MAC, or mandatory access control, uses classifications to determine access.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      710,
      739,
      286,
      345
    ],
    "source": ""
  },
  {
    "id": 499,
    "question": "Gabe is concerned about the security of passwords used as a cornerstone of his organization's information security program. Which one of the following controls would provide the greatest improvement in Gabe's ability to authenticate users?",
    "choice_a": "More complex passwords",
    "choice_b": "User education against social engineering",
    "choice_c": "Multifactor authentication",
    "choice_d": "Addition of security questions based on personal knowledge",
    "correct_answer": "C",
    "explanation": "While all of the listed controls would improve authentication security, most simply strengthen the use of knowledge-based authentication. The best way to improve the authentication process would be to add a factor not based on knowledge through the use of multifactor authentication. This may include the use of biometric controls or token-based authentication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      566,
      748,
      447,
      273
    ],
    "source": ""
  },
  {
    "id": 500,
    "question": "During a review of support incidents, Ben's organization discovered that password changes accounted for more than a quarter of its help desk's cases. Which of the following options would be most likely to decrease that number significantly?",
    "choice_a": "Two-factor authentication",
    "choice_b": "Biometric authentication",
    "choice_c": "Self-service password reset",
    "choice_d": "Passphrases",
    "correct_answer": "C",
    "explanation": "Self-service password reset tools typically have a significant impact on the number of password reset contacts that a help desk has. Two-factor and biometric authentication both add additional complexity and may actually increase the number of contacts. Passphrases can be easier to remember than traditional complex passwords and may decrease calls, but they don't have the same impact that a self-service system does.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      559,
      560,
      558,
      552,
      726
    ],
    "source": ""
  },
  {
    "id": 501,
    "question": "Jim wants to allow cloud-based applications to act on his behalf to access information from other sites. Which of the following tools can allow that?",
    "choice_a": "Kerberos",
    "choice_b": "OAuth",
    "choice_c": "OpenID",
    "choice_d": "LDAP",
    "correct_answer": "B",
    "explanation": "OAuth provides the ability to access resources from another service and would meet Jim's needs. OpenID would allow him to use an account from another service with his application, and Kerberos and LDAP are used more frequently for in-house services.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      561,
      563,
      545,
      349,
      542
    ],
    "source": ""
  },
  {
    "id": 502,
    "question": "Which one of the following activities is an example of an authorization process?",
    "choice_a": "User providing a password",
    "choice_b": "User passing a facial recognition check",
    "choice_c": "System logging user activity",
    "choice_d": "System consulting an access control list",
    "correct_answer": "D",
    "explanation": "Authorization occurs when a system determines whether an authenticated user is permitted to perform an activity, such as by consulting an access control list.  Authentication occurs when a user proves his or her identity to a system, such as by providing a password or completing a facial recognition scan.  When a system logs user activity, this is an example of accounting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      543,
      544,
      708,
      429
    ],
    "source": ""
  },
  {
    "id": 503,
    "question": "Raul is creating a trust relationship between his company and a vendor.  He is implementing the system so that it will allow users from the vendor's organization to access his accounts payable system using the accounts created for them by the vendor.  What type of authentication is Raul implementing?",
    "choice_a": "Federated authentication",
    "choice_b": "Transitive trust",
    "choice_c": "Multifactor authentication",
    "choice_d": "Single sign-on",
    "correct_answer": "A",
    "explanation": "This type of authentication, where one domain trusts users from another domain, is called federation.  Federation may involve transitive trusts, where the trusts may be followed through a series of domains, but this scenario only describes the use of two domains.  The scenario only describes use of credentials for a single system and does not describe a multiple-system scenario where single sign-on would be relevant.  There is no requirement described for the use of multifactor authentication, which would require the use of two or more diverse authentication techniques.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      543,
      544,
      354,
      420,
      1
    ],
    "source": ""
  },
  {
    "id": 504,
    "question": "In Luke's company, users change job positions on a regular basis.  Luke would like the company's access control system to make it easy for administrators to adjust permissions when these changes occur.  Which model of access control is best suited for Luke's needs?",
    "choice_a": "Mandatory access control",
    "choice_b": "Discretionary access control",
    "choice_c": "Rule-based access control",
    "choice_d": "Role-based access control",
    "correct_answer": "D",
    "explanation": "Role-based access control would be an excellent solution for Luke's requirements.  Administrators would assign permissions to roles and then simply adjust the role of a user when he or she changes jobs, rather than changing all of the individual permissions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      539,
      550,
      542,
      345,
      537
    ],
    "source": ""
  },
  {
    "id": 505,
    "question": "When you input a user ID and password, you are performing what important identity and access management activity?",
    "choice_a": "Authorization",
    "choice_b": "Validation",
    "choice_c": "Authentication",
    "choice_d": "Login",
    "correct_answer": "C",
    "explanation": "When you input a username and password, you are authenticating yourself by providing a unique identifier and a verification that you are the person who should have that identifier (the password). Authorization is the process of determining what a user is allowed to do. Validation and login both describe elements of what is happening in the process; however, they aren't the most important identity and access management activity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      543,
      542,
      708,
      281
    ],
    "source": ""
  },
  {
    "id": 506,
    "question": "Which of the following is a ticket-based authentication protocol designed to provide secure communication?",
    "choice_a": "RADIUS",
    "choice_b": "OAuth",
    "choice_c": "SAML",
    "choice_d": "Kerberos",
    "correct_answer": "D",
    "explanation": "Kerberos is an authentication protocol that uses tickets and provides secure communications between the client, key distribution center (KDC), ticket-granting service (TGS), authentication server (AS), and endpoint services. RADIUS does not provide the same level of security by default, SAML is a markup language, and OAuth is designed to allow third-party websites to rely on credentials from other sites like Google or Microsoft.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      562,
      545,
      561,
      563,
      566
    ],
    "source": ""
  },
  {
    "id": 507,
    "question": "Which of the following Type 3 authenticators is appropriate to use by itself rather than in combination with other biometric factors?",
    "choice_a": "Voice pattern recognition",
    "choice_b": "Hand geometry",
    "choice_c": "Palm scans",
    "choice_d": "Heart/pulse patterns",
    "correct_answer": "C",
    "explanation": "Palm scans compare the vein patterns in the palm to a database to authenticate a user. Vein patterns are unique, and this method is a better single-factor authentication method than voice pattern recognition, hand geometry, and pulse patterns, each of which can be more difficult to uniquely identify between individuals or can be fooled more easily.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      565,
      564,
      483,
      420,
      338
    ],
    "source": ""
  },
  {
    "id": 508,
    "question": "What type of token-based authentication system uses a challenge/response process in which the challenge must be entered on the token?",
    "choice_a": "Asynchronous",
    "choice_b": "Smart card",
    "choice_c": "Synchronous",
    "choice_d": "RFID",
    "correct_answer": "A",
    "explanation": "Asynchronous tokens use a challenge/response process in which the system sends a challenge and the user responds with a PIN and a calculated response to the challenge. The server performs the same calculations, and if both match, it authenticates the user. Synchronous tokens use a time-based calculation to generate codes. Smart cards are paired with readers and don't need to have challenges entered, and RFID devices are not used for challenge/response tokens.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      480,
      482,
      6,
      293,
      376
    ],
    "source": ""
  },
  {
    "id": 509,
    "question": "As part of hiring a new employee, Kathleen's identity management team creates a new user object and ensures that the user object is available in the directories and systems where it is needed. What is this process called?",
    "choice_a": "Registration",
    "choice_b": "Provisioning",
    "choice_c": "Population",
    "choice_d": "Authenticator loading",
    "correct_answer": "B",
    "explanation": "Provisioning includes the creation, maintenance, and removal of user objects from applications, systems, and directories. Registration occurs when users are enrolled in a biometric system; population and authenticator loading are not common industry terms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      542,
      708,
      556,
      557,
      281
    ],
    "source": ""
  },
  {
    "id": 510,
    "question": "What access control system lets owners decide who has access to the objects they own?",
    "choice_a": "Role-based access control",
    "choice_b": "Task-based access control",
    "choice_c": "Discretionary access control",
    "choice_d": "Rule-based access control",
    "correct_answer": "C",
    "explanation": "Discretionary access control gives owners the right to decide who has access to the objects they own. Role-based access control uses administrators to make that decision for roles or groups of people with a role, task-based access control uses lists of tasks for each user, and rule-based access control applies a set of rules to all subjects.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      710,
      537,
      539,
      538,
      708
    ],
    "source": ""
  },
  {
    "id": 511,
    "question": "When Alex sets the permissions shown in the following image as one of many users on a Linux server, what type of access control model is he leveraging? <br><img src=\"/question_assets/SSCP/c01uf003.png\"/>",
    "choice_a": "Role-based access control",
    "choice_b": "Rule-based access control",
    "choice_c": "Mandatory access control (MAC)",
    "choice_d": "Discretionary access control (DAC)",
    "correct_answer": "D",
    "explanation": "The Linux filesystem allows the owners of objects to determine the access rights that subjects have to them. This means that it is a discretionary access control. If the system enforced a role-based access control, Alex wouldn't set the controls; they would be set based on the roles assigned to each subject. A rule-based access control system would apply rules throughout the system, and a mandatory access control system uses classification labels.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      539,
      537,
      555,
      540,
      556
    ],
    "source": ""
  },
  {
    "id": 512,
    "question": "The U.S. government CAC is an example of what form of Type 2 authentication factor?",
    "choice_a": "A token",
    "choice_b": "A biometric identifier",
    "choice_c": "A smart card",
    "choice_d": "A PIV",
    "correct_answer": "C",
    "explanation": "The U.S. government's Common Access Card is a smart card. The U.S. government also issues PIV cards, or personal identity verification cards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      564,
      542,
      566,
      273
    ],
    "source": ""
  },
  {
    "id": 513,
    "question": "What term is used to describe the problem that occurs when users change jobs in an organization but never have the access rights associated with their old jobs removed?",
    "choice_a": "Rights management",
    "choice_b": "Privilege creep",
    "choice_c": "Two-person control",
    "choice_d": "Least privilege",
    "correct_answer": "B",
    "explanation": "Privilege creep is the term used to describe the security issue that arises when users move between jobs in an organization and accumulate privileges that are never revoked when no longer necessary.  This is a violation of the principle of least privilege.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      549,
      330,
      420,
      273,
      447
    ],
    "source": ""
  },
  {
    "id": 514,
    "question": "Which objects and subjects have a label in a MAC model?",
    "choice_a": "Objects and subjects that are classified as Confidential, Secret, or Top Secret have a label.",
    "choice_b": "All objects have a label, and all subjects have a compartment.",
    "choice_c": "All objects and subjects have a label.",
    "choice_d": "All subjects have a label and all objects have a compartment.",
    "correct_answer": "C",
    "explanation": "In a mandatory access control system, all subjects and objects have a label. Compartments may or may not be used, but there is not a specific requirement for either subjects or objects to be compartmentalized. The specific labels of Confidential, Secret, and Top Secret are not required by MAC.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      540,
      555,
      542,
      541,
      556
    ],
    "source": ""
  },
  {
    "id": 515,
    "question": "Jack's organization is a government agency that handles very sensitive information. They need to implement an access control system that allows administrators to set access rights but does not allow the delegation of those rights to other users. What is the best type of access control design for Jack's organization?",
    "choice_a": "Discretionary access control",
    "choice_b": "Mandatory access control",
    "choice_c": "Decentralized access control",
    "choice_d": "Rule-based access control",
    "correct_answer": "B",
    "explanation": "Mandatory access control systems allow an administrator to configure access permissions but do not allow users to delegate permission to others. Discretionary access control systems do allow this delegation. The scenario does not provide information to indicate whether a decentralized or rule-based approach is appropriate.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      537,
      539,
      710,
      540,
      538
    ],
    "source": ""
  },
  {
    "id": 516,
    "question": "Kathleen works for a data center hosting facility that provides physical data center space for individuals and organizations. Until recently, each client was given a magnetic-strip-based keycard to access the section of the facility where their servers are located, and they were also given a key to access the cage or rack where their servers reside. In the past month, several servers have been stolen, but the logs for the pass cards show only valid IDs. What is Kathleen's best option to make sure that the users of the pass cards are who they are supposed to be?",
    "choice_a": "Add a reader that requires a PIN for passcard users.",
    "choice_b": "Add a camera system to the facility to observe who is accessing servers.",
    "choice_c": "Add a biometric factor.",
    "choice_d": "Replace the magnetic stripe keycards with smartcards.",
    "correct_answer": "C",
    "explanation": "Kathleen should implement a biometric factor. The cards and keys are an example of a Type 2 factor, or \u201csomething you have.\u201d Using a smart card replaces this with another Type 2 factor, but the cards could still be loaned out or stolen. Adding a PIN suffers from the same problem: A PIN can be stolen. Adding cameras doesn't prevent access to the facility and thus, doesn't solve the immediate problem (but it is a good idea!).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      420,
      280,
      273,
      308
    ],
    "source": ""
  },
  {
    "id": 517,
    "question": "What term is used to describe the default set of privileges assigned to a user when a new account is created?",
    "choice_a": "Aggregation",
    "choice_b": "Transitivity",
    "choice_c": "Baseline",
    "choice_d": "Entitlement",
    "correct_answer": "D",
    "explanation": "Entitlement refers to the privileges granted to users when an account is first provisioned. Aggregation is the accumulation of privileges over time. Transitivity is the inheritance of privileges and trust through relationships. Baselines are snapshots of a system or application's security that allow analysts to detect future modifications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      549,
      708,
      321,
      446,
      420
    ],
    "source": ""
  },
  {
    "id": 518,
    "question": "Kathleen is implementing an access control system for her organization and builds the following array: <br><li>Reviewers: update files, delete files</li><li>Submitters: upload files</li><li>Editors: upload files, update files</li><li>Archivists: delete files</li><br> What type of access control system has Kathleen implemented?<br>",
    "choice_a": "Role-based access control",
    "choice_b": "Task-based access control",
    "choice_c": "Rule-based access control",
    "choice_d": "Discretionary access control",
    "correct_answer": "A",
    "explanation": "Role-based access control gives each user an array of permissions based on their position in the organization, such as the scheme shown here. Task-based access control is not a standard approach. Rule-based access controls use rules that apply to all subjects, which isn't something we see in the list. Discretionary access control gives object owners rights to choose how the objects they own are accessed, which is not what this list shows.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      539,
      537,
      538,
      710,
      551
    ],
    "source": ""
  },
  {
    "id": 519,
    "question": "When a user attempts to log into their online account, Google sends a text message with a code to their cell phone. What type of verification is this?",
    "choice_a": "Knowledge-based authentication",
    "choice_b": "Dynamic knowledge-based authentication",
    "choice_c": "Out-of-band identity proofing",
    "choice_d": "Risk-based identity proofing",
    "correct_answer": "C",
    "explanation": "Identity proofing that relies on a type of verification outside the initial environment that required the verification is out-of-band identity proofing. This type of verification relies on the owner of the phone or phone number having control of it but removes the ability for attackers to use only Internet-based resources to compromise an account. Knowledge-based authentication relies on answers to preselected information, whereas dynamic knowledge\u2013based authentication builds questions using facts or data about the user. Risk-based identity proofing uses risk-based metrics to determine whether identities should be permitted or denied access. It is used to limit fraud in financial transactions, such as credit card purchases. This is a valid form of proofing but does not necessarily use an out-of-band channel, such as SMS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      726,
      564,
      544,
      429,
      420
    ],
    "source": ""
  },
  {
    "id": 520,
    "question": "Maddox is conducting an information audit for his organization. Which one of the following elements that he discovered is least likely to be classified as PII when used in isolation?",
    "choice_a": "Street addresses",
    "choice_b": "Item codes",
    "choice_c": "Mobile phone numbers",
    "choice_d": "Social Security numbers",
    "correct_answer": "B",
    "explanation": "Privacy is of the utmost concern when handling personally identifiable information (PII). PII includes any information that may be reasonably tied to a specific person. This would include street addresses, telephone numbers, and national ID numbers (such as Social Security numbers). Item codes, when not tied to a name or other identifier, would not constitute PII.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      568,
      567,
      28,
      22,
      20
    ],
    "source": ""
  },
  {
    "id": 521,
    "question": "Carl recently assisted in the implementation of a new set of security controls designed to comply with legal requirements. He is concerned about the long-term maintenance of those controls. Which one of the following is a good way for Carl to ease his concerns?",
    "choice_a": "Firewall rules",
    "choice_b": "Policy documents",
    "choice_c": "Security standards",
    "choice_d": "Periodic audits",
    "correct_answer": "D",
    "explanation": "While all of the items listed are components of a strong security program, periodic audits would provide Carl with the assurance that controls continue to operate effectively over the long term.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      491,
      489,
      575,
      574,
      579
    ],
    "source": ""
  },
  {
    "id": 522,
    "question": "Darlene was recently offered a consulting opportunity as a side job. She is concerned that the opportunity might constitute a conflict of interest. Which one of the following sources is most likely to provide her with appropriate guidance?",
    "choice_a": "Organizational code of ethics",
    "choice_b": "ISC2 code of ethics",
    "choice_c": "Organizational security policy",
    "choice_d": "ISC2 security policy",
    "correct_answer": "A",
    "explanation": "The situation Darlene finds herself in is an ethical dilemma, and a code of ethics would be the best place to look for guidance. This situation is specific to her employer, so she should turn to her organization's code of ethics, rather than the more general ISC2 Code of Ethics.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      571,
      570,
      572,
      30,
      31
    ],
    "source": ""
  },
  {
    "id": 523,
    "question": "Which one of the following is an administrative control that can protect the confidentiality of information?",
    "choice_a": "Encryption",
    "choice_b": "Nondisclosure agreement",
    "choice_c": "Firewall",
    "choice_d": "Fault tolerance",
    "correct_answer": "B",
    "explanation": "Nondisclosure agreements (NDAs) protect the confidentiality of sensitive information by requiring that employees and affiliates not share confidential information with third parties. NDAs normally remain in force after an employee leaves the company.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      461,
      22,
      28,
      30,
      32
    ],
    "source": ""
  },
  {
    "id": 524,
    "question": "Chris is worried that the laptops that his organization has recently acquired were modified by a third party to include keyloggers before they were delivered. Where should he focus his efforts to prevent this?",
    "choice_a": "His supply chain",
    "choice_b": "His vendor contracts",
    "choice_c": "His post-purchase build process",
    "choice_d": "The original equipment manufacturer (OEM)",
    "correct_answer": "A",
    "explanation": "Supply chain management can help ensure the security of hardware, software, and services that an organization acquires. Chris should focus on each step that his laptops take from the original equipment manufacturer to delivery.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      581,
      579,
      487,
      488,
      491
    ],
    "source": ""
  },
  {
    "id": 525,
    "question": "The ISC2 code of ethics applies to all SSCP holders. Which of the following is not one of the four mandatory canons of the code?",
    "choice_a": "Protect society, the common good, the necessary public trust and confidence, and the infrastructure.",
    "choice_b": "Disclose breaches of privacy, trust, and ethics.",
    "choice_c": "Provide diligent and competent service to the principles.",
    "choice_d": "Advance and protect the profession.",
    "correct_answer": "B",
    "explanation": "The ISC2 code of ethics also includes \u201cAct honorably, honestly, justly, responsibly, and legally\u201d but does not specifically require credential holders to disclose all breaches of privacy, trust, or ethics.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      30,
      32,
      25,
      28
    ],
    "source": ""
  },
  {
    "id": 526,
    "question": "Which one of the following control categories does not accurately describe a fence around a facility?",
    "choice_a": "Physical",
    "choice_b": "Detective",
    "choice_c": "Deterrent",
    "choice_d": "Preventive",
    "correct_answer": "B",
    "explanation": "A fence does not have the ability to detect intrusions. It does, however, have the ability to prevent and deter an intrusion. Fences are an example of a physical control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      588,
      720,
      591,
      516,
      518
    ],
    "source": ""
  },
  {
    "id": 527,
    "question": "Which one of the following actions might be taken as part of a business continuity plan?",
    "choice_a": "Restoring from backup tapes",
    "choice_b": "Implementing RAID",
    "choice_c": "Relocating to a cold site",
    "choice_d": "Restarting business operations",
    "correct_answer": "B",
    "explanation": "RAID technology provides fault tolerance for hard drive failures and is an example of a business continuity action. Restoring from backup tapes, relocating to a cold site, and restarting business operations are all disaster recovery actions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      716,
      510,
      511,
      586,
      487
    ],
    "source": ""
  },
  {
    "id": 528,
    "question": "Which one of the following is an example of physical infrastructure hardening?",
    "choice_a": "Antivirus software",
    "choice_b": "Hardware-based network firewall",
    "choice_c": "Two-factor authentication",
    "choice_d": "Fire suppression system",
    "correct_answer": "D",
    "explanation": "Fire suppression systems protect infrastructure from physical damage. Along with uninterruptible power supplies, fire suppression systems are good examples of technology used to harden physical infrastructure. Antivirus software, hardware firewalls, and two-factor authentication are all examples of logical controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      716,
      714,
      722,
      588,
      584
    ],
    "source": ""
  },
  {
    "id": 529,
    "question": "Mary is helping a computer user who sees the following message appear on his computer screen. What type of attack has occurred? image <br><img src=\"/question_assets/SSCP/c02uf001.png\"/>",
    "choice_a": "Availability",
    "choice_b": "Confidentiality",
    "choice_c": "Disclosure",
    "choice_d": "Distributed",
    "correct_answer": "A",
    "explanation": "The message displayed is an example of ransomware, which encrypts the contents of a user's computer to prevent legitimate use. This is an example of an availability attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      25,
      33,
      29,
      27
    ],
    "source": ""
  },
  {
    "id": 530,
    "question": "The Acme Widgets Company is putting new controls in place for its accounting department. Management is concerned that a rogue accountant may be able to create a new false vendor and then issue checks to that vendor as payment for services that were never rendered. What security control can best help prevent this situation?",
    "choice_a": "Mandatory vacation",
    "choice_b": "Separation of duties",
    "choice_c": "Defense in depth",
    "choice_d": "Job rotation",
    "correct_answer": "B",
    "explanation": "When following the separation of duties principle, organizations divide critical tasks into discrete components and ensure that no one individual has the ability to perform both actions. This prevents a single rogue individual from performing that task in an unauthorized manner.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      592,
      574,
      573,
      581,
      487
    ],
    "source": ""
  },
  {
    "id": 531,
    "question": "Beth is the security administrator for a public school district. She is implementing a new student information system and is testing the code to ensure that students are not able to alter their own grades. What principle of information security is Beth enforcing?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Denial",
    "correct_answer": "A",
    "explanation": "Integrity controls, such as the one Beth is implementing in this example, are designed to prevent the unauthorized modification of information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      25,
      29,
      33,
      515
    ],
    "source": ""
  },
  {
    "id": 532,
    "question": "Juniper Content is a web content development company with 40 employees located in two offices: one in New York and a smaller office in the San Francisco Bay Area. Each office has a local area network protected by a perimeter firewall. The local area network (LAN) contains modern switch equipment connected to both wired and wireless networks. <br>Each office has its own file server, and the information technology (IT) team runs software every hour to synchronize files between the two servers, distributing content between the offices. These servers are primarily used to store images and other files related to web content developed by the company. The team also uses a SaaS-based email and document collaboration solution for much of their work. <br>You are the newly appointed IT manager for Juniper Content, and you are working to augment existing security controls to improve the organization's security. <br>Users in the two offices would like to access each other's file servers over the Internet. What control would provide confidentiality for those communications?",
    "choice_a": "Digital signatures",
    "choice_b": "Virtual private network",
    "choice_c": "Virtual LAN",
    "choice_d": "Digital content management",
    "correct_answer": "B",
    "explanation": "Virtual private networks (VPNs) provide secure communications channels over otherwise insecure networks (such as the Internet) using encryption. If you establish a VPN connection between the two offices, users in one office could securely access content located on the other office's server over the Internet. Digital signatures are used to provide nonrepudiation, not confidentiality. Virtual LANs (VLANs) provide network segmentation on local networks but do not cross the Internet. Digital content management solutions are designed to manage web content, not access shared files located on a file server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      22,
      28,
      577,
      586
    ],
    "source": ""
  },
  {
    "id": 533,
    "question": "Juniper Content is a web content development company with 40 employees located in two offices: one in New York and a smaller office in the San Francisco Bay Area. Each office has a local area network protected by a perimeter firewall. The local area network (LAN) contains modern switch equipment connected to both wired and wireless networks. <br>Each office has its own file server, and the information technology (IT) team runs software every hour to synchronize files between the two servers, distributing content between the offices. These servers are primarily used to store images and other files related to web content developed by the company. The team also uses a SaaS-based email and document collaboration solution for much of their work. <br>You are the newly appointed IT manager for Juniper Content, and you are working to augment existing security controls to improve the organization's security. <br>You are also concerned about the availability of data stored on each office's server. You would like to add technology that would enable continued access to files located on the server even if a hard drive in a server fails. What integrity control allows you to add robustness without adding additional servers?",
    "choice_a": "Server clustering",
    "choice_b": "Load balancing",
    "choice_c": "RAID",
    "choice_d": "Scheduled backups",
    "correct_answer": "C",
    "explanation": "RAID uses additional hard drives to protect the server against the failure of a single device. Load balancing and server clustering do add robustness but require the addition of a server. Scheduled backups protect against data loss but do not provide immediate access to data in the event of a hard drive failure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      23,
      25,
      33,
      487
    ],
    "source": ""
  },
  {
    "id": 534,
    "question": "Juniper Content is a web content development company with 40 employees located in two offices: one in New York and a smaller office in the San Francisco Bay Area. Each office has a local area network protected by a perimeter firewall. The local area network (LAN) contains modern switch equipment connected to both wired and wireless networks. <br>Each office has its own file server, and the information technology (IT) team runs software every hour to synchronize files between the two servers, distributing content between the offices. These servers are primarily used to store images and other files related to web content developed by the company. The team also uses a SaaS-based email and document collaboration solution for much of their work. <br>You are the newly appointed IT manager for Juniper Content, and you are working to augment existing security controls to improve the organization's security. <br>Finally, there are historical records stored on the server that are extremely important to the business and should never be modified. You would like to add an integrity control that allows you to verify on a periodic basis that the files were not modified. What control can you add?",
    "choice_a": "Hashing",
    "choice_b": "ACLs",
    "choice_c": "Read-only attributes",
    "choice_d": "Firewalls",
    "correct_answer": "A",
    "explanation": "Hashing allows you to computationally verify that a file has not been modified between hash evaluations. ACLs and read-only attributes are useful controls that may help you prevent unauthorized modification, but they cannot verify that files were not modified. Firewalls are network security controls and do not verify file integrity.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      25,
      518,
      574,
      575
    ],
    "source": ""
  },
  {
    "id": 535,
    "question": "An accounting employee at Doolittle Industries was recently arrested for participation in an embezzlement scheme. The employee transferred money to a personal account and then shifted funds around between other accounts every day to disguise the fraud for months. Which one of the following controls might have best allowed the earlier detection of this fraud?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Defense in depth",
    "choice_d": "Mandatory vacation",
    "correct_answer": "D",
    "explanation": "Mandatory vacation programs require that employees take continuous periods of time off each year and revoke their system privileges during that time. This will ideally disrupt any attempt to engage in the cover-up actions necessary to hide fraud and result in exposing the threat. Separation of duties, least privilege, and defense in depth controls all may help prevent the fraud in the first place but are unlikely to speed the detection of fraud that has already occurred.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      573,
      574,
      575,
      723,
      725
    ],
    "source": ""
  },
  {
    "id": 536,
    "question": "Yolanda is writing a document that will provide configuration information regarding the minimum level of security that every system in the organization must meet. What type of document is she preparing?",
    "choice_a": "Policy",
    "choice_b": "Baseline",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "B",
    "explanation": "Baselines provide the minimum level of security that every system throughout the organization must meet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      25,
      29,
      30,
      31
    ],
    "source": ""
  },
  {
    "id": 537,
    "question": "Frank discovers a keylogger hidden on the laptop of his company's chief executive officer. What information security principle is the keylogger most likely designed to disrupt?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Denial",
    "correct_answer": "A",
    "explanation": "Keyloggers monitor the keystrokes of an individual and report them back to an attacker. They are designed to steal sensitive information, a disruption of the goal of confidentiality.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      25,
      28,
      29,
      20
    ],
    "source": ""
  },
  {
    "id": 538,
    "question": "Susan is working with the management team in her company to classify data in an attempt to apply extra security controls that will limit the likelihood of a data breach. What principle of information security is Susan trying to enforce?",
    "choice_a": "Availability",
    "choice_b": "Denial",
    "choice_c": "Confidentiality",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "Confidentiality controls prevent the disclosure of sensitive information to unauthorized individuals. Limiting the likelihood of a data breach is an attempt to prevent unauthorized disclosure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      22,
      28,
      569,
      26
    ],
    "source": ""
  },
  {
    "id": 539,
    "question": "Gary is implementing a new website architecture that uses multiple small web servers behind a load balancer. What principle of information security is Gary seeking to enforce?",
    "choice_a": "Denial",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "Keeping a server up and running is an example of an availability control because it increases the likelihood that a server will remain available to answer user requests.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      25,
      29,
      33,
      27
    ],
    "source": ""
  },
  {
    "id": 540,
    "question": "Which one of the following is not an example of a technical control?",
    "choice_a": "Router ACL",
    "choice_b": "Firewall rule",
    "choice_c": "Encryption",
    "choice_d": "Data classification",
    "correct_answer": "D",
    "explanation": "Router ACLs, encryption, and firewall rules are all examples of technical controls. Data classification is an administrative control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      569,
      568,
      22,
      28,
      29
    ],
    "source": ""
  },
  {
    "id": 541,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through their website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>Jasper would like to establish a governing body for the organization's change management efforts. What individual or group within an organization is typically responsible for reviewing the impact of proposed changes?",
    "choice_a": "Chief information officer",
    "choice_b": "Senior leadership team",
    "choice_c": "Change control board",
    "choice_d": "Software developer",
    "correct_answer": "C",
    "explanation": "The change control board (CCB) has primary responsibility for reviewing the impact of a proposed change and coordinating the review and approval processes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      581,
      486,
      579,
      487,
      488
    ],
    "source": ""
  },
  {
    "id": 542,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through their website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>During what phase of the change management process does the organization conduct peer review of the change for accuracy and completeness?",
    "choice_a": "Recording",
    "choice_b": "Analysis/Impact Assessment",
    "choice_c": "Approval",
    "choice_d": "Decision Making and Prioritization",
    "correct_answer": "B",
    "explanation": "During the Analysis/Impact Assessment phase, the organization subjects the change to peer review.  In the peer review, technologists verify the accuracy and completeness of the change request and attempt to uncover any impact on other systems that might occur as a result of the change.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      486,
      487,
      581,
      579,
      580
    ],
    "source": ""
  },
  {
    "id": 543,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through their website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>Who should the organization appoint to manage the policies and procedures surrounding change management?",
    "choice_a": "Project manager",
    "choice_b": "Change manager",
    "choice_c": "System security officer",
    "choice_d": "Architect",
    "correct_answer": "B",
    "explanation": "Organizations adopting change management practices should appoint a change manager who will be responsible for managing policies and procedures.  The change manager is also responsible for developing and maintaining the processes for requesting, approving, testing, and controlling changes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      581,
      486,
      579,
      487,
      488
    ],
    "source": ""
  },
  {
    "id": 544,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through their website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>Which one of the following elements is not a crucial component of a change request?",
    "choice_a": "Description of the change",
    "choice_b": "Implementation plan",
    "choice_c": "Backout plan",
    "choice_d": "Incident response plan",
    "correct_answer": "D",
    "explanation": "An organization's incident response plan may be invoked as a result of a change gone awry, but the incident response plan itself is a stand-alone process and does not need to be included in a change request.  The change request should definitely include a description of the change, an implementation plan, and a backout plan, among other components.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      486,
      487,
      579,
      580,
      488
    ],
    "source": ""
  },
  {
    "id": 545,
    "question": "Ben is designing a messaging system for a bank and would like to include a feature that allows the recipient of a message to prove to a third party that the message did indeed come from the purported originator. What goal is Ben trying to achieve?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Integrity",
    "choice_d": "Nonrepudiation",
    "correct_answer": "D",
    "explanation": "Nonrepudiation allows a recipient to prove to a third party that a message came from a purported source. Authentication would provide proof to Ben that the sender was authentic, but Ben would not be able to prove this to a third party.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      576,
      25,
      578,
      29,
      24
    ],
    "source": ""
  },
  {
    "id": 546,
    "question": "What principle of information security states that an organization should implement overlapping security controls whenever possible?",
    "choice_a": "Least privilege",
    "choice_b": "Separation of duties",
    "choice_c": "Defense in depth",
    "choice_d": "Security through obscurity",
    "correct_answer": "C",
    "explanation": "Defense in depth states that organizations should have overlapping security controls designed to meet the same security objectives whenever possible. This approach provides security in the event of a single control failure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      23,
      24,
      515,
      490
    ],
    "source": ""
  },
  {
    "id": 547,
    "question": "Which one of the following is not a goal of a formal change management program?",
    "choice_a": "Implement change in an orderly fashion.",
    "choice_b": "Test changes prior to implementation.",
    "choice_c": "Provide rollback plans for changes.",
    "choice_d": "Inform stakeholders of changes after they occur.",
    "correct_answer": "D",
    "explanation": "Stakeholders should be informed of changes before, not after, they occur. The other items listed are goals of change management programs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      579,
      580,
      581,
      487,
      488
    ],
    "source": ""
  },
  {
    "id": 548,
    "question": "Ben is responsible for the security of payment card information stored in a database. Policy directs that he remove the information from the database, but he cannot do this for operational reasons. He obtained an exception to policy and is seeking an appropriate compensating control to mitigate the risk. What would be his best option?",
    "choice_a": "Purchasing insurance",
    "choice_b": "Encrypting the database contents",
    "choice_c": "Removing the data",
    "choice_d": "Objecting to the exception",
    "correct_answer": "B",
    "explanation": "Ben should encrypt the data to provide an additional layer of protection as a compensating control. The organization has already made a policy exception, so he should not react by objecting to the exception or removing the data without authorization. Purchasing insurance may transfer some of the risk but is not a mitigating control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      516,
      518,
      22,
      569,
      32
    ],
    "source": ""
  },
  {
    "id": 549,
    "question": "You discover that a user on your network has been using the Wireshark tool, as shown here. Further investigation revealed that he was using it for illicit purposes. What pillar of information security has most likely been violated? <br><img src=\"/question_assets/SSCP/c02uf002.png\"/>",
    "choice_a": "Integrity",
    "choice_b": "Denial",
    "choice_c": "Availability",
    "choice_d": "Confidentiality",
    "correct_answer": "D",
    "explanation": "Wireshark is a protocol analyzer and may be used to eavesdrop on network connections. Eavesdropping is an attack against confidentiality.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      25,
      29,
      461,
      28
    ],
    "source": ""
  },
  {
    "id": 550,
    "question": "Which one of the following is the first step in developing an organization's vital records program?",
    "choice_a": "Identifying vital records",
    "choice_b": "Locating vital records",
    "choice_c": "Archiving vital records",
    "choice_d": "Preserving vital records",
    "correct_answer": "A",
    "explanation": "An organization pursuing a vital records management program should begin by identifying all of the documentation that qualifies as a vital business record. This should include all of the records necessary to restart the business in a new location should the organization invoke its business continuity plan.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      510,
      511,
      587,
      579,
      462
    ],
    "source": ""
  },
  {
    "id": 551,
    "question": "Which one of the following security programs is designed to provide employees with the knowledge they need to perform their specific work tasks?",
    "choice_a": "Awareness",
    "choice_b": "Training",
    "choice_c": "Education",
    "choice_d": "Indoctrination",
    "correct_answer": "B",
    "explanation": "Security training is designed to provide employees with the specific knowledge they need to fulfill their job functions. It is usually designed for individuals with similar job functions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      32,
      31,
      30,
      570
    ],
    "source": ""
  },
  {
    "id": 552,
    "question": "Which one of the following security programs is designed to establish a minimum standard common denominator of security understanding?",
    "choice_a": "Training",
    "choice_b": "Education",
    "choice_c": "Indoctrination",
    "choice_d": "Awareness",
    "correct_answer": "D",
    "explanation": "Awareness establishes a minimum standard of information security understanding. It is designed to accommodate all personnel in an organization, regardless of their assigned tasks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      490,
      491,
      31,
      30
    ],
    "source": ""
  },
  {
    "id": 553,
    "question": "Chris is responsible for workstations throughout his company and knows that some of the company's workstations are used to handle proprietary information. Which option best describes what should happen at the end of their lifecycle for workstations he is responsible for?",
    "choice_a": "Erasing",
    "choice_b": "Clearing",
    "choice_c": "Sanitization",
    "choice_d": "Destruction",
    "correct_answer": "C",
    "explanation": "Sanitization is a combination of processes that ensure that data from a system cannot be recovered by any means. Erasing and clearing are both prone to mistakes and technical problems that can result in remnant data and don't make sense for systems that handled proprietary information. Destruction is the most complete method of ensuring that data cannot be exposed, and some organizations opt to destroy the entire workstation, but that is not a typical solution because of the cost involved.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      22,
      461,
      569,
      32
    ],
    "source": ""
  },
  {
    "id": 554,
    "question": "What term is used to describe a set of common security configurations, often provided by a third party?",
    "choice_a": "Security policy",
    "choice_b": "Baseline",
    "choice_c": "DSS",
    "choice_d": "NIST SP 800-53",
    "correct_answer": "B",
    "explanation": "A baseline is a set of security configurations that can be adopted and modified to fit an organization's security needs. A security policy is written to describe an organization's approach to security, while DSS is the second half of the Payment Card Industry Data Security Standard. The NIST SP-800 series of documents address computer security in a variety of areas.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      581,
      487,
      491,
      573,
      575
    ],
    "source": ""
  },
  {
    "id": 555,
    "question": "Which one of the following administrative processes assists organizations in assigning appropriate levels of security control to sensitive information?",
    "choice_a": "Information classification",
    "choice_b": "Remanence",
    "choice_c": "Transmitting data",
    "choice_d": "Clearing",
    "correct_answer": "A",
    "explanation": "The need to protect sensitive data drives information classification. This allows organizations to focus on data that needs to be protected rather than spending effort on less important data. Remanence describes data left on media after an attempt is made to remove the data. Transmitting data isn't a driver for an administrative process to protect sensitive data, and clearing is a technical process for removing data from media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      569,
      568,
      28,
      22,
      21
    ],
    "source": ""
  },
  {
    "id": 556,
    "question": "Ben is following the National Institute of Standards and Technology (NIST) Special Publication 800-88 guidelines for sanitization and disposition as shown here. He is handling information that his organization classified as sensitive, which is a moderate security categorization in the NIST model. If the media is going to be sold as surplus, what process does Ben need to follow? <br><img src=\"/question_assets/SSCP/c02uf003.png\"/>Source: NIST SP 800-88",
    "choice_a": "Destroy, validate, document",
    "choice_b": "Clear, purge, document",
    "choice_c": "Purge, document, validate",
    "choice_d": "Purge, validate, document",
    "correct_answer": "D",
    "explanation": "The NIST SP 800-88 process for sanitization and disposition shows that media that will be reused and was classified at a moderate level should be purged and then that purge should be validated. Finally, it should be documented.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      569,
      28,
      22,
      486,
      487
    ],
    "source": ""
  },
  {
    "id": 557,
    "question": "Ben has been tasked with identifying security controls for systems covered by his organization's information classification system. Why might Ben choose to use a security baseline?",
    "choice_a": "It applies in all circumstances, allowing consistent security controls.",
    "choice_b": "They are approved by industry standards bodies, preventing liability.",
    "choice_c": "They provide a good starting point that can be tailored to organizational needs.",
    "choice_d": "They ensure that systems are always in a secure state.",
    "correct_answer": "C",
    "explanation": "Security baselines provide a starting point to scope and tailor security controls to your organization's needs. They aren't always appropriate to specific organizational needs, they cannot ensure that systems are always in a secure state, and they do not prevent liability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      569,
      518,
      581,
      487,
      490
    ],
    "source": ""
  },
  {
    "id": 558,
    "question": "Retaining and maintaining information for as long as it is needed is known as what?",
    "choice_a": "Data storage policy",
    "choice_b": "Data storage",
    "choice_c": "Asset maintenance",
    "choice_d": "Record retention",
    "correct_answer": "D",
    "explanation": "Record retention is the process of retaining and maintaining information for as long as it is needed. A data storage policy describes how and why data is stored, while data storage is the process of actually keeping the data. Asset maintenance is a process for maintaining physical assets that is not related to information security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      491,
      32,
      30,
      31,
      488
    ],
    "source": ""
  },
  {
    "id": 559,
    "question": "Referring to the figure shown here, what is the earliest stage of a fire where it is possible to use detection technology to identify it? <br><img src=\"/question_assets/SSCP/c02uf004.png\"/>Image reprinted from <italic>CISSP ISC2 Certified Information Systems Security Professional Official Study Guide, 7th Edition</italic> \u00a9 John Wiley & Sons 2015, reprinted with permission.",
    "choice_a": "Incipient",
    "choice_b": "Smoke",
    "choice_c": "Flame",
    "choice_d": "Heat",
    "correct_answer": "A",
    "explanation": "Fires may be detected as early as the incipient stage. During this stage, air ionization takes place, and specialized incipient fire detection systems can identify these changes to provide early warning of a fire.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      582,
      583,
      584,
      716,
      714
    ],
    "source": ""
  },
  {
    "id": 560,
    "question": "What type of fire suppression system fills with water when the initial stages of a fire are detected and then requires a sprinkler head heat activation before dispensing water?",
    "choice_a": "Wet pipe",
    "choice_b": "Dry pipe",
    "choice_c": "Deluge",
    "choice_d": "Preaction",
    "correct_answer": "D",
    "explanation": "A preaction fire suppression system activates in two steps. The pipes fill with water once the early signs of a fire are detected. The system does not dispense water until heat sensors on the sprinkler heads trigger the second phase.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      716,
      714,
      715,
      582,
      584
    ],
    "source": ""
  },
  {
    "id": 561,
    "question": "Ralph is designing a physical security infrastructure for a new computing facility that will remain largely unstaffed. He plans to implement motion detectors in the facility but would also like to include a secondary verification control for physical presence. Which one of the following would best meet his needs?",
    "choice_a": "CCTV",
    "choice_b": "IPS",
    "choice_c": "Turnstiles",
    "choice_d": "Faraday cages",
    "correct_answer": "A",
    "explanation": "Closed-circuit television (CCTV) systems act as a secondary verification mechanism for physical presence because they allow security officials to view the interior of the facility when a motion alarm sounds to determine the current occupants and their activities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      722,
      26,
      724,
      720,
      588
    ],
    "source": ""
  },
  {
    "id": 562,
    "question": "Referring to the figure shown here, what is the name of the security control indicated by the arrow? <br><img src=\"/question_assets/SSCP/c02uf005.png\"/>Image reprinted from <italic>CISSP ISC2 Certified Information Systems Security Professional Official Study Guide, 7th Edition</italic> \u00a9 John Wiley & Sons 2015, reprinted with permission.",
    "choice_a": "Mantrap",
    "choice_b": "Turnstile",
    "choice_c": "Intrusion prevention system",
    "choice_d": "Portal",
    "correct_answer": "A",
    "explanation": "Mantraps use a double set of doors to prevent piggybacking by allowing only a single individual to enter a facility at a time.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      722,
      588,
      590,
      592,
      26
    ],
    "source": ""
  },
  {
    "id": 563,
    "question": "Which one of the following does not describe a standard physical security requirement for wiring closets?",
    "choice_a": "Place only in areas monitored by security guards.",
    "choice_b": "Do not store flammable items in the closet.",
    "choice_c": "Use sensors on doors to log entries.",
    "choice_d": "Perform regular inspections of the closet.",
    "correct_answer": "A",
    "explanation": "While it would be ideal to have wiring closets in a location where they are monitored by security staff, this is not feasible in most environments. Wiring closets must be distributed geographically in multiple locations across each building used by an organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      722,
      588,
      591,
      720,
      26
    ],
    "source": ""
  },
  {
    "id": 564,
    "question": "Betty is concerned about the use of buffer overflow attacks against a custom application developed for use in her organization. What security control would provide the strongest defense against these attacks?",
    "choice_a": "Firewall",
    "choice_b": "Intrusion detection system",
    "choice_c": "Parameter checking",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "C",
    "explanation": "Parameter checking, or input validation, is used to ensure that input provided by users to an application matches the expected parameters for the application. Developers may use parameter checking to ensure that input does not exceed the expected length, preventing a buffer overflow attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      30,
      31,
      32,
      25
    ],
    "source": ""
  },
  {
    "id": 565,
    "question": "Juan is retrofitting an existing door to his facility to include a lock with automation capabilities.  Which one of the following types of lock is easiest to install as a retrofit to the existing door?",
    "choice_a": "Mantrap",
    "choice_b": "Electric lock",
    "choice_c": "Magnetic lock",
    "choice_d": "Turnstile",
    "correct_answer": "C",
    "explanation": "A magnetic lock may usually be retrofitted to an existing door with a minimum of effort.  Installing an electric lock usually requires replacing the entire door.  Mantraps and turnstiles will require significant renovation projects.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      589,
      588,
      590,
      722,
      487
    ],
    "source": ""
  },
  {
    "id": 566,
    "question": "Rhonda is considering the use of new identification cards for physical access control in her organization. She comes across a military system that uses the card shown here. What type of card is this? <br><img src=\"/question_assets/SSCP/c02uf006.png\"/>",
    "choice_a": "Smart card",
    "choice_b": "Proximity card",
    "choice_c": "Magnetic stripe card",
    "choice_d": "Phase three card",
    "correct_answer": "A",
    "explanation": "The card shown in the image has a smart chip underneath the American flag. Therefore, it is an example of a smart card. This is the most secure type of identification card technology.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      591,
      720,
      588,
      592,
      25
    ],
    "source": ""
  },
  {
    "id": 567,
    "question": "Which one of the following facilities would have the highest level of physical security requirements?",
    "choice_a": "Data center",
    "choice_b": "Network closet",
    "choice_c": "SCIF",
    "choice_d": "Cubicle work areas",
    "correct_answer": "C",
    "explanation": "Sensitive compartmented information facilities (SCIFs) are highly secure government facilities designed for processing classified information.  They would have stricter physical security requirements than any other type of facility.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      722,
      720,
      588,
      591,
      27
    ],
    "source": ""
  },
  {
    "id": 568,
    "question": "Glenda is investigating a potential privacy violation within her organization.\u00a0 The organization notified users that it was collecting data for product research that would last for six months and then disposed of the data at the end of that period.\u00a0 During the time that they had the data, they also used it to target a marketing campaign.\u00a0 Which principle of data privacy was most directly violated?",
    "choice_a": "Data minimization",
    "choice_b": "Accuracy",
    "choice_c": "Storage limitations",
    "choice_d": "Purpose limitations",
    "correct_answer": "D",
    "explanation": "In this case, the organization used the data that they collected for a purpose other than the one that they obtained consent for from the data subjects.\u00a0 This is a violation of purpose limitations.\u00a0 There is no evidence presented that the organization collected more data than was necessary, which would violate data minimization.\u00a0 They disposed of the data promptly, so there was no violation of storage limitations.\u00a0 There is also no indication that any of the data was inaccurate.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      20,
      22,
      461,
      21,
      28
    ],
    "source": ""
  },
  {
    "id": 569,
    "question": "What type of access control is composed of policies and procedures that support regulations, requirements, and the organization's own policies?",
    "choice_a": "Corrective",
    "choice_b": "Logical",
    "choice_c": "Compensating",
    "choice_d": "Administrative",
    "correct_answer": "D",
    "explanation": "Administrative access controls are procedures and the policies from which they derive. They are based on regulations, requirements, and the organization's own policies. Corrective access controls return an environment to its original status after an issue, while logical controls are technical access controls that rely on hardware or software to protect systems and data. Compensating controls are used in addition to or as an alternative to other controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      571,
      487,
      579,
      31,
      490
    ],
    "source": ""
  },
  {
    "id": 570,
    "question": "Which of the following access control categories would not include a door lock?",
    "choice_a": "Physical",
    "choice_b": "Directive",
    "choice_c": "Preventative",
    "choice_d": "Deterrent",
    "correct_answer": "B",
    "explanation": "Locks can be preventative access controls by stopping unwanted access, can deter potential intruders by making access difficult, and are physical access controls. They are not directive controls because they don't control the actions of subjects.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      574,
      588,
      722,
      573,
      592
    ],
    "source": ""
  },
  {
    "id": 571,
    "question": "Gary was recently hired as the first chief information security officer (CISO) for a local government agency. The agency recently suffered a security breach and is attempting to build a new information security program. Gary would like to apply some best practices for security operations as he is designing this program. <br>As Gary decides what access permissions he should grant to each user, what principle should guide his decisions about default permissions?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Aggregation",
    "choice_d": "Separation of privileges",
    "correct_answer": "B",
    "explanation": "Gary should follow the least privilege principle and assign users only the permissions they need to perform their job responsibilities. Aggregation is a term used to describe the unintentional accumulation of privileges over time, also known as privilege creep. Separation of duties and separation of privileges are principles used to secure sensitive processes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      32,
      22,
      593,
      572
    ],
    "source": ""
  },
  {
    "id": 572,
    "question": "Gary was recently hired as the first chief information security officer (CISO) for a local government agency. The agency recently suffered a security breach and is attempting to build a new information security program. Gary would like to apply some best practices for security operations as he is designing this program. <br>As Gary designs the program, he uses the matrix shown here. What principle of information security does this matrix most directly help enforce? <br><img src=\"/question_assets/SSCP/c02uf007.png\"/>",
    "choice_a": "Segregation of duties",
    "choice_b": "Aggregation",
    "choice_c": "Two-person control",
    "choice_d": "Defense in depth",
    "correct_answer": "A",
    "explanation": "The matrix shown in the figure is known as a segregation of duties matrix. It is used to ensure that one person does not obtain two privileges that would create a potential conflict. Aggregation describes the unintentional accumulation of privileges over time, also known as privilege creep. Two-person control is used when two people must work together to perform a sensitive action. Defense in depth is a general security principle used to describe a philosophy of overlapping security controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      593,
      592,
      575,
      573,
      31
    ],
    "source": ""
  },
  {
    "id": 573,
    "question": "Lydia is processing access control requests for her organization. She comes across a request where the user does have the required security clearance, but there is no business justification for the access. Lydia denies this request. What security principle is she following?",
    "choice_a": "Need to know",
    "choice_b": "Least privilege",
    "choice_c": "Separation of duties",
    "choice_d": "Two-person control",
    "correct_answer": "A",
    "explanation": "Lydia is following the need-to-know principle. While the user may have the appropriate security clearance to access this information, there is no business justification provided, so she does not know that the user has an appropriate need to know the information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      25,
      32,
      30,
      31
    ],
    "source": ""
  },
  {
    "id": 574,
    "question": "Helen is implementing a new security mechanism for granting employees administrative privileges in the accounting system. She designs the process so that both the employee's manager and the accounting manager must approve the request before the access is granted. What information security principle is Helen enforcing?",
    "choice_a": "Least privilege",
    "choice_b": "Two-person control",
    "choice_c": "Job rotation",
    "choice_d": "Separation of duties",
    "correct_answer": "B",
    "explanation": "In this scenario, Helen designed a process that requires the concurrence of two people to perform a sensitive action. This is an example of two-person control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      22,
      23,
      571
    ],
    "source": ""
  },
  {
    "id": 575,
    "question": "Which of the following is not true about the ISC2 code of ethics?",
    "choice_a": "Adherence to the code is a condition of certification.",
    "choice_b": "Failure to comply with the code may result in revocation of certification.",
    "choice_c": "The code applies to all members of the information security profession.",
    "choice_d": "Members who observe a breach of the code are required to report the possible violation.",
    "correct_answer": "C",
    "explanation": "The ISC2 code of ethics applies only to information security professionals who are members of ISC2. Adherence to the code is a condition of certification, and individuals found in violation of the code may have their certifications revoked. ISC2 members who observe a breach of the code are required to report the possible violation by following the ethics complaint procedures.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      31,
      32,
      571,
      491
    ],
    "source": ""
  },
  {
    "id": 576,
    "question": "Javier is verifying that only IT system administrators have the ability to log on to servers used for administrative purposes. What principle of information security is he enforcing?",
    "choice_a": "Need to know",
    "choice_b": "Least privilege",
    "choice_c": "Two-person control",
    "choice_d": "Transitive trust",
    "correct_answer": "B",
    "explanation": "The principle of least privilege says that an individual should only have the privileges necessary to complete their job functions. Removing administrative privileges from nonadministrative users is an example of least privilege.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      32,
      31,
      22,
      25,
      20
    ],
    "source": ""
  },
  {
    "id": 577,
    "question": "Connor's company recently experienced a denial-of-service attack that Connor believes came from an inside source. If true, what type of event has the company experienced?",
    "choice_a": "Espionage",
    "choice_b": "Confidentiality breach",
    "choice_c": "Sabotage",
    "choice_d": "Integrity breach",
    "correct_answer": "C",
    "explanation": "An attack committed against an organization by an insider, such as an employee, is known as sabotage. Espionage and confidentiality breaches involve the theft of sensitive information, which is not alleged to have occurred in this case. Integrity breaches involve the unauthorized modification of information, which is not described in this scenario.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      23,
      22,
      33,
      570
    ],
    "source": ""
  },
  {
    "id": 578,
    "question": "Which one of the following is not a canon of the ISC2 code of ethics?",
    "choice_a": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "choice_b": "Promptly report security vulnerabilities to relevant authorities.",
    "choice_c": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_d": "Provide diligent and competent service to principals.",
    "correct_answer": "B",
    "explanation": "The four canons of the ISC2 code of ethics are to protect society, the common good, necessary public trust and confidence and the infrastructure; act honorably, honestly, justly, responsibly and legally; provide diligent and competent service to principals; and advance and protect the profession.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      30,
      32,
      29,
      33
    ],
    "source": ""
  },
  {
    "id": 579,
    "question": "When designing an access control scheme, Hilda set up roles so that the same person does not have the ability to provision a new user account and assign superuser privileges to an account. What information security principle is Hilda following?",
    "choice_a": "Least privilege",
    "choice_b": "Separation of duties",
    "choice_c": "Job rotation",
    "choice_d": "Security through obscurity",
    "correct_answer": "B",
    "explanation": "Hilda's design follows the principle of separation of duties. Giving one user the ability to both create new accounts and grant administrative privileges combines two actions that would result in a significant security change that should be divided among two users.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      592,
      22,
      31,
      581,
      579
    ],
    "source": ""
  },
  {
    "id": 580,
    "question": "Which one of the following tools helps system administrators by providing a standard, secure template of configuration settings for operating systems and applications?",
    "choice_a": "Security guidelines",
    "choice_b": "Security policy",
    "choice_c": "Baseline configuration",
    "choice_d": "Running configuration",
    "correct_answer": "C",
    "explanation": "Baseline configurations serve as the starting point for configuring secure systems and applications. They contain the security settings necessary to comply with an organization's security policy and may then be customized to meet the specific needs of an implementation. While security policies and guidelines may contain information needed to secure a system, they do not contain a set of configuration settings that may be applied to a system. The running configuration of a system is the set of currently applied settings, which may or may not be secure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      30,
      31,
      32,
      570,
      572
    ],
    "source": ""
  },
  {
    "id": 581,
    "question": "Tracy is preparing to apply a patch to her organization's enterprise resource planning system. She is concerned that the patch may introduce flaws that did not exist in prior versions, so she plans to conduct a test that will compare previous responses to input with those produced by the newly patched application. What type of testing is Tracy planning?",
    "choice_a": "Unit testing",
    "choice_b": "Acceptance testing",
    "choice_c": "Regression testing",
    "choice_d": "Vulnerability testing",
    "correct_answer": "C",
    "explanation": "Regression testing is software testing that runs a set of known inputs against an application and then compares the results to those produced by an earlier version of the software. It is designed to capture unanticipated consequences of deploying new code versions prior to introducing them into a production environment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      487,
      581,
      579,
      516,
      518
    ],
    "source": ""
  },
  {
    "id": 582,
    "question": "Which one of the following security practices suggests that an organization should deploy multiple, overlapping security controls to meet security objectives?",
    "choice_a": "Defense in depth",
    "choice_b": "Security through obscurity",
    "choice_c": "Least privilege",
    "choice_d": "Separation of duties",
    "correct_answer": "A",
    "explanation": "The defense-in-depth principle states that an organization should prepare for the failure of a single security control by ensuring that each security objective is covered by two or more overlapping controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      722,
      588,
      574,
      516,
      490
    ],
    "source": ""
  },
  {
    "id": 583,
    "question": "What technology asset management practice would an organization use to ensure that systems meet baseline security standards?",
    "choice_a": "Change management",
    "choice_b": "Patch management",
    "choice_c": "Configuration management",
    "choice_d": "Identity management",
    "correct_answer": "C",
    "explanation": "Configuration management practices ensure that an organization manages the configuration of systems in an organized and automated fashion.  This would include ensuring that systems remain in compliance with the baseline requirements of the organization's security standards.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      579,
      581,
      489,
      491,
      575
    ],
    "source": ""
  },
  {
    "id": 584,
    "question": "HAL Systems recently decided to stop offering public NTP services because of a fear that its NTP servers would be used in amplification DDoS attacks. What type of risk management strategy did HAL pursue with respect to its NTP services?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transference",
    "choice_d": "Risk avoidance",
    "correct_answer": "D",
    "explanation": "HAL Systems decided to stop offering the service because of the risk. This is an example of a risk avoidance strategy. The company altered its operations in a manner that eliminates the risk of NTP misuse.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      59,
      62,
      60,
      61
    ],
    "source": ""
  },
  {
    "id": 585,
    "question": "Tom is responding to a recent security incident and is seeking information on the approval process for a recent modification to a system's security settings. Where would he most likely find this information?",
    "choice_a": "Change log",
    "choice_b": "System log",
    "choice_c": "Security log",
    "choice_d": "Application log",
    "correct_answer": "A",
    "explanation": "The change log contains information about approved changes and the change management process. While other logs may contain details about the change's effect, the audit trail for change management would be found in the change log.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      743,
      52,
      36,
      57,
      61
    ],
    "source": ""
  },
  {
    "id": 586,
    "question": "Alex wants to use an automated tool to fill web application forms to test for format string vulnerabilities. What type of tool should he use?",
    "choice_a": "A black box",
    "choice_b": "A brute-force tool",
    "choice_c": "A fuzzer",
    "choice_d": "A static analysis tool",
    "correct_answer": "C",
    "explanation": "Fuzzers are tools that are designed to provide invalid or unexpected input to applications, testing for vulnerabilities like format string vulnerabilities, buffer overflow issues, and other problems. A static analysis relies on examining code without running the application or code and thus, would not fill forms as part of a web application. Brute-force tools attempt to bypass security by trying every possible combination for passwords or other values. A black box is a type of penetration test where the testers do not know anything about the environment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      602,
      600,
      601,
      629,
      46
    ],
    "source": ""
  },
  {
    "id": 587,
    "question": "Henry is the risk manager for Atwood Landing, a resort community in the midwestern United States. The resort's main data center is located in northern Indiana in an area that is prone to tornados. Henry recently undertook a replacement cost analysis and determined that rebuilding and reconfiguring the data center would cost $10 million. <br>Henry consulted with tornado experts, data center specialists, and structural engineers. Together, they determined that a typical tornado would cause approximately $5 million of damage to the facility. The meteorologists determined that Atwood's facility lies in an area where they are likely to experience a tornado once every 200 years. <br>Based upon the information in this scenario, what is the exposure factor for the effect of a tornado on Atwood Landing's data center?",
    "choice_a": "10 percent",
    "choice_b": "25 percent",
    "choice_c": "50 percent",
    "choice_d": "75 percent",
    "correct_answer": "C",
    "explanation": "The exposure factor is the percentage of the facility that risk managers expect will be damaged if a risk materializes. It is calculated by dividing the amount of damage by the asset value. In this case, that is $5 million in damage divided by the $10 million facility value, or 50 percent.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      594,
      596,
      42,
      48,
      614
    ],
    "source": ""
  },
  {
    "id": 588,
    "question": "Henry is the risk manager for Atwood Landing, a resort community in the midwestern United States. The resort's main data center is located in northern Indiana in an area that is prone to tornados. Henry recently undertook a replacement cost analysis and determined that rebuilding and reconfiguring the data center would cost $10 million. <br>Henry consulted with tornado experts, data center specialists, and structural engineers. Together, they determined that a typical tornado would cause approximately $5 million of damage to the facility. The meteorologists determined that Atwood's facility lies in an area where they are likely to experience a tornado once every 200 years. <br>Based upon the information in this scenario, what is the annualized rate of occurrence for a tornado at Atwood Landing's data center?",
    "choice_a": "0.0025",
    "choice_b": "0.005",
    "choice_c": "0.01",
    "choice_d": "0.015",
    "correct_answer": "B",
    "explanation": "The annualized rate of occurrence is the number of times that risk analysts expect a risk to happen in any given year. In this case, the analysts expect tornados once every 200 years, or 0.005 times per year.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      612,
      456,
      614,
      597,
      598
    ],
    "source": ""
  },
  {
    "id": 589,
    "question": "Henry is the risk manager for Atwood Landing, a resort community in the midwestern United States. The resort's main data center is located in northern Indiana in an area that is prone to tornados. Henry recently undertook a replacement cost analysis and determined that rebuilding and reconfiguring the data center would cost $10 million. <br>Henry consulted with tornado experts, data center specialists, and structural engineers. Together, they determined that a typical tornado would cause approximately $5 million of damage to the facility. The meteorologists determined that Atwood's facility lies in an area where they are likely to experience a tornado once every 200 years. <br>Based upon the information in this scenario, what is the annualized loss expectancy for a tornado at Atwood Landing's data center?",
    "choice_a": "$25,000",
    "choice_b": "$50,000",
    "choice_c": "$250,000",
    "choice_d": "$500,000",
    "correct_answer": "A",
    "explanation": "The annualized loss expectancy is calculated by multiplying the single loss expectancy (SLE) by the annualized rate of occurrence (ARO). In this case, the SLE is $5,000,000, and the ARO is 0.005. Multiplying these numbers together gives you the ALE of $25,000.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      598,
      456,
      612,
      597,
      614
    ],
    "source": ""
  },
  {
    "id": 590,
    "question": "Earlier this year, the information security team at Jim's employer identified a vulnerability in the web server that Jim is responsible for maintaining. He immediately applied the patch and is sure that it installed properly, but the vulnerability scanner has continued to incorrectly flag the system as vulnerable because of the version number it is finding even though Jim is sure the patch is installed. Which of the following options is Jim's best choice to deal with the issue?",
    "choice_a": "Uninstall and reinstall the patch.",
    "choice_b": "Ask the information security team to flag the system as patched and not vulnerable.",
    "choice_c": "Update the version information in the web server's configuration.",
    "choice_d": "Review the vulnerability report and use alternate remediation options.",
    "correct_answer": "B",
    "explanation": "Jim should ask the information security team to flag the issue as resolved if he is sure the patch was installed. Many vulnerability scanners rely on version information or banner information and may flag patched versions if the software provider does not update the information they see. Uninstalling and reinstalling the patch will not change this. Changing the version information may not change all of the details that are being flagged by the scanner and may cause issues at a later date. Reviewing the vulnerability information for a workaround may be a good idea but should not be necessary if the proper patch is installed; it can create maintenance issues later.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      53,
      57,
      64,
      36
    ],
    "source": ""
  },
  {
    "id": 591,
    "question": "Which NIST special publication covers the assessment of security and privacy controls?",
    "choice_a": "800-12",
    "choice_b": "800-53A",
    "choice_c": "800-34",
    "choice_d": "800-86",
    "correct_answer": "B",
    "explanation": "NIST SP 800-53A is titled \u201cAssessing Security and Privacy Controls in Federal Information Systems and Organizations: Building Effective Assessment Plans\u201d and covers methods for assessing and measuring controls. <br>NIST 800-12 is an introduction to computer security, 800-34 covers contingency planning, and 800-86 is the \u201cGuide to Integrating Forensic Techniques into Incident Response.\u201d.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      57,
      58,
      475,
      53
    ],
    "source": ""
  },
  {
    "id": 592,
    "question": "Saria's team is working to persuade their management that their network has extensive vulnerabilities that attackers could exploit. If she wants to conduct a realistic attack as part of a penetration test, what type of penetration test should she conduct?",
    "choice_a": "Crystal box",
    "choice_b": "Gray box",
    "choice_c": "White box",
    "choice_d": "Black box",
    "correct_answer": "D",
    "explanation": "Black-box testing is the most realistic type of penetration test because it does not provide the penetration tester with inside information about the configuration or design of systems, software, or networks. A gray-box test provides some information, whereas a white- or crystal-box test provides significant or full detail.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      629,
      628,
      617,
      55,
      59
    ],
    "source": ""
  },
  {
    "id": 593,
    "question": "Tom enables an application firewall provided by his cloud infrastructure as a service provider that is designed to block many types of application attacks. When viewed from a\u00a0risk management perspective, what metric is Tom attempting to lower?",
    "choice_a": "Impact",
    "choice_b": "RPO",
    "choice_c": "MTO",
    "choice_d": "Likelihood",
    "correct_answer": "D",
    "explanation": "Installing a device that will block attacks is an attempt to lower risk by reducing the likelihood of a successful application attack.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      59,
      46,
      42,
      56
    ],
    "source": ""
  },
  {
    "id": 594,
    "question": "Jim uses a tool that scans a system for available services and then connects to them to collect banner information to determine what version of the service is running. It then provides a report detailing what it gathers, basing results on service fingerprinting, banner information, and similar details it gathers combined with CVE information. What type of tool is Jim using?",
    "choice_a": "A port scanner",
    "choice_b": "A service validator",
    "choice_c": "A vulnerability scanner",
    "choice_d": "A patch management tool",
    "correct_answer": "C",
    "explanation": "Vulnerability scanners that do not have administrative rights to access a machine or that are not using an agent scan remote machines to gather information, including fingerprints from responses to queries and connections, banner information from services, and related data. CVE information is Common Vulnerabilities and Exposures information, or vulnerability information. A port scanner gathers information about what service ports are open, although some port scanners blur the line between port and vulnerability scanners. Patch management tools typically run as an agent on a system to allow them to both monitor patch levels and update the system as needed. Service validation typically involves testing the functionality of a service, not its banner and response patterns.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      602,
      617,
      620,
      35,
      601
    ],
    "source": ""
  },
  {
    "id": 595,
    "question": "What term describes software testing that is intended to uncover new bugs introduced by patches or configuration changes?",
    "choice_a": "Nonregression testing",
    "choice_b": "Evolution testing",
    "choice_c": "Smoke testing",
    "choice_d": "Regression testing",
    "correct_answer": "D",
    "explanation": "Regression testing, which is a type of functional or unit testing, tests to ensure that changes have not introduced new issues. Nonregression testing checks to see whether a change has had the effect it was supposed to, smoke testing focuses on simple problems with impact on critical functionality, and evolution testing is not a software testing technique.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 596,
    "question": "Mike recently implemented an intrusion prevention system designed to block common network attacks from affecting his organization. What type of risk management strategy is Mike pursuing?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Risk mitigation strategies attempt to lower the probability and/or impact of a risk occurring. Intrusion prevention systems attempt to reduce the probability of a successful attack and are, therefore, examples of risk mitigation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      62,
      65,
      60,
      61
    ],
    "source": ""
  },
  {
    "id": 597,
    "question": "During a port scan, Lauren found TCP port 443 open on a system. Which tool is best suited to scanning the service that is most likely running on that port?",
    "choice_a": "zzuf",
    "choice_b": "Nikto",
    "choice_c": "Metasploit",
    "choice_d": "sqlmap",
    "correct_answer": "B",
    "explanation": "TCP port 443 normally indicates an HTTPS server. Nikto is useful for vulnerability scanning web servers and applications and is the best choice listed for a web server. Metasploit includes some scanning functionality but is not a purpose-built tool for vulnerability scanning. zzuf is a fuzzing tool and isn't relevant for vulnerability scans, whereas sqlmap is a SQL injection testing tool.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      601,
      600,
      602,
      616,
      620
    ],
    "source": ""
  },
  {
    "id": 598,
    "question": "When developing a business impact analysis, the team should first create a list of assets. What should happen next?",
    "choice_a": "Identify vulnerabilities in each asset.",
    "choice_b": "Determine the risks facing the asset.",
    "choice_c": "Develop a value for each asset.",
    "choice_d": "Identify threats facing each asset.",
    "correct_answer": "C",
    "explanation": "After developing a list of assets, the business impact analysis team should assign values to each asset.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      45,
      458,
      596,
      597,
      614
    ],
    "source": ""
  },
  {
    "id": 599,
    "question": "In this image, what issue may occur because of the log handling settings? <br><img src=\"/question_assets/SSCP/c03uf001.png\"/>",
    "choice_a": "Log data may be lost when the log is archived.",
    "choice_b": "Log data may be overwritten.",
    "choice_c": "Log data may not include needed information.",
    "choice_d": "Log data may fill the system disk.",
    "correct_answer": "D",
    "explanation": "The menu shown will archive logs when they reach the maximum size allowed (20 MB). These archives will be retained, which could fill the disk. Log data will not be overwritten, and log data should not be lost when the data is archived. The question does not include enough information to determine if needed information may not be logged.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      603,
      742,
      604,
      741,
      743
    ],
    "source": ""
  },
  {
    "id": 600,
    "question": "What message logging standard is commonly used by network devices, Linux and Unix systems, and many other enterprise devices?",
    "choice_a": "Syslog",
    "choice_b": "Netlog",
    "choice_c": "Eventlog",
    "choice_d": "Remote Log Protocol (RLP)",
    "correct_answer": "A",
    "explanation": "Syslog is a widely used protocol for event and message logging. Eventlog, netlog, and Remote Log Protocol are all made-up terms.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      609,
      610,
      611,
      622,
      603
    ],
    "source": ""
  },
  {
    "id": 601,
    "question": "Ryan is a security risk analyst for an insurance company. He is currently examining a scenario in which a malicious hacker might use a SQL injection attack to deface a web server because of a missing patch in the company's web application. In this scenario, what is the threat?",
    "choice_a": "Unpatched web application",
    "choice_b": "Web defacement",
    "choice_c": "Malicious hacker",
    "choice_d": "Operating system",
    "correct_answer": "C",
    "explanation": "Risks are the combination of a threat and a vulnerability. Threats are the external forces seeking to undermine security, such as the malicious hacker in this case. Vulnerabilities are the internal weaknesses that might allow a threat to succeed. In this case, the missing patch is the vulnerability. In this scenario, if the malicious hacker (threat) attempts a SQL injection attack against the unpatched server (vulnerability), the result is website defacement.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      46,
      34,
      35,
      59
    ],
    "source": ""
  },
  {
    "id": 602,
    "question": "Chris is responsible for his organization's security standards and has guided the selection and implementation of a security baseline for Windows PCs in his organization. How can Chris most effectively make sure that the workstations he is responsible for are being checked for compliance and that settings are being applied as necessary?",
    "choice_a": "Assign users to spot-check baseline compliance.",
    "choice_b": "Use Microsoft Group Policy.",
    "choice_c": "Create startup scripts to apply policy at system start.",
    "choice_d": "Periodically review the baselines with the data owner and system owners.",
    "correct_answer": "B",
    "explanation": "Group Policy provides the ability to monitor and apply settings in a security baseline. Manual checks by users and using startup scripts provide fewer reviews and may be prone to failure, while periodic review of the baseline won't result in compliance being checked.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      607,
      53,
      57,
      606,
      52
    ],
    "source": ""
  },
  {
    "id": 603,
    "question": "The company that Jennifer works for has implemented a central logging infrastructure, as shown in the following image. Use this diagram and your knowledge of logging systems to answer the following questions. <br><img src=\"/question_assets/SSCP/c03uf002.png\"/>Jennifer needs to ensure that all Windows systems provide identical logging information to the SIEM. How can she best ensure that all Windows desktops have the same log settings?",
    "choice_a": "Perform periodic configuration audits.",
    "choice_b": "Use Group Policy.",
    "choice_c": "Use Local Policy.",
    "choice_d": "Deploy a Windows syslog client.",
    "correct_answer": "B",
    "explanation": "Group Policy enforced by Active Directory can ensure consistent logging settings and can provide regular enforcement of policy on systems. Periodic configuration audits won't catch changes made between audits, and local policies can drift because of local changes or differences in deployments. A Windows syslog client will enable the Windows systems to send syslog to the SIEM appliance but won't ensure consistent logging of events.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      607,
      608,
      609,
      622,
      53
    ],
    "source": ""
  },
  {
    "id": 604,
    "question": "The company that Jennifer works for has implemented a central logging infrastructure, as shown in the following image. Use this diagram and your knowledge of logging systems to answer the following questions. <br><img src=\"/question_assets/SSCP/c03uf002.png\"/><br>During normal operations, Jennifer's team uses the SIEM appliance to monitor for exceptions received via syslog. What system shown does not natively have support for syslog events?",
    "choice_a": "Enterprise wireless access points",
    "choice_b": "Windows desktop systems",
    "choice_c": "Linux web servers",
    "choice_d": "Enterprise firewall devices",
    "correct_answer": "B",
    "explanation": "Windows systems generate logs in the Windows native logging format. To send syslog events, Windows systems require a helper application or tool. Enterprise wireless access points, firewalls, and Linux systems all typically support syslog.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      609,
      610,
      611,
      622,
      40
    ],
    "source": ""
  },
  {
    "id": 605,
    "question": "The company that Jennifer works for has implemented a central logging infrastructure, as shown in the following image. Use this diagram and your knowledge of logging systems to answer the following questions. <br><img src=\"/question_assets/SSCP/c03uf002.png\"/>What technology should an organization use for each of the devices shown in the diagram to ensure that logs can be time sequenced across the entire infrastructure?",
    "choice_a": "Syslog",
    "choice_b": "NTP",
    "choice_c": "Logsync",
    "choice_d": "SNAP",
    "correct_answer": "B",
    "explanation": "Network Time Protocol (NTP) can ensure that systems are using the same time, allowing time sequencing for logs throughout a centralized logging infrastructure. Syslog is a way for systems to send logs to a logging server and won't address time sequencing. Neither logsync nor SNAP is an industry term.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      473,
      622,
      609,
      621,
      40
    ],
    "source": ""
  },
  {
    "id": 606,
    "question": "Susan needs to predict high-risk areas for her organization and wants to use metrics to assess risk trends as they occur. What should she do to handle this?",
    "choice_a": "Perform yearly risk assessments.",
    "choice_b": "Hire a penetration testing company to regularly test organizational security.",
    "choice_c": "Identify and track key risk indicators.",
    "choice_d": "Monitor logs and events using a SIEM device.",
    "correct_answer": "C",
    "explanation": "Key risk indicators are used to tell those in charge of risk management how risky an activity is and how much impact changes are having on that risk profile. Identifying key risk indicators and monitoring them can help to identify high-risk areas earlier in their lifecycle. Yearly risk assessments may be a good idea but only provide a point-in-time view, whereas penetration tests may miss out on risks that are not directly security related. Monitoring logs and events using a SIEM device can help detect issues as they occur but won't necessarily show trends in risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      53,
      56,
      61,
      59,
      54
    ],
    "source": ""
  },
  {
    "id": 607,
    "question": "Tom is considering locating a business in the downtown area of Miami, Florida. He consults the FEMA flood plain map for the region, shown here, and determines that the area he is considering lies within a 100-year flood plain. <br><img src=\"/question_assets/SSCP/c03uf003.png\"/>What is the ARO of a flood in this area?",
    "choice_a": "100",
    "choice_b": "1",
    "choice_c": "0.1",
    "choice_d": "0.01",
    "correct_answer": "D",
    "explanation": "The annualized rate of occurrence (ARO) is the frequency at which you should expect a risk to materialize each year. In a 100-year flood plain, risk analysts expect a flood to occur once every 100 years, or 0.01 times per year.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      612,
      457,
      456,
      613,
      614
    ],
    "source": ""
  },
  {
    "id": 608,
    "question": "Which of the following strategies is not a reasonable approach for remediating a vulnerability identified by a vulnerability scanner?",
    "choice_a": "Install a patch.",
    "choice_b": "Use a workaround fix.",
    "choice_c": "Update the banner or version number.",
    "choice_d": "Use an application layer firewall or IPS to prevent attacks against the identified vulnerability.",
    "correct_answer": "C",
    "explanation": "Simply updating the version that an application provides may stop the vulnerability scanner from flagging it, but it won't fix the underlying issue. Patching, using workarounds, or installing an application layer firewall or IPS can all help to remediate or limit the impact of the vulnerability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      61,
      59,
      35,
      600
    ],
    "source": ""
  },
  {
    "id": 609,
    "question": "Bruce is seeing quite a bit of suspicious activity on his network. It appears that an outside entity is attempting to connect to all of his systems using a TCP connection on port 22. What type of scanning is the outsider likely engaging in?",
    "choice_a": "FTP scanning",
    "choice_b": "Telnet scanning",
    "choice_c": "SSH scanning",
    "choice_d": "HTTP scanning",
    "correct_answer": "C",
    "explanation": "SSH uses TCP port 22, so this attack is likely an attempt to scan for open or weakly secured SSH servers. FTP uses ports 20 and 21. Telnet uses port 23, and HTTP uses port 80.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      618,
      620,
      617,
      62,
      55
    ],
    "source": ""
  },
  {
    "id": 610,
    "question": "Jim would like to identify compromised systems on his network that may be participating in a botnet. He plans to do this by watching for connections made to known command-and-control servers. Which one of the following techniques would be most likely to provide this information if Jim has access to a list of known servers?",
    "choice_a": "Netflow records",
    "choice_b": "IDS logs",
    "choice_c": "Authentication logs",
    "choice_d": "RFC logs",
    "correct_answer": "A",
    "explanation": "Netflow records contain an entry for every network communication session that took place on a network and can be compared to a list of known malicious hosts. IDS logs may contain a relevant record, but it is less likely because they would create log entries only if the traffic triggers the IDS, as opposed to netflow records, which encompass all communications. Authentication logs and RFC logs would not have records of any network traffic.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      40,
      59,
      53,
      55
    ],
    "source": ""
  },
  {
    "id": 611,
    "question": "Susan needs to scan a system for vulnerabilities, and she wants to use an open source tool to test the system remotely. Which of the following tools will meet her requirements and allow vulnerability scanning?",
    "choice_a": "Nmap",
    "choice_b": "OpenVAS",
    "choice_c": "MBSA",
    "choice_d": "Nessus",
    "correct_answer": "B",
    "explanation": "OpenVAS is an open source vulnerability scanning tool that will provide Susan with a report of the vulnerabilities that it can identify from a remote, network-based scan. Nmap is an open source port scanner. Both the Microsoft Baseline Security Analyzer (MBSA) and Nessus are closed source tools, although Nessus was originally open source.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      600,
      602,
      617,
      620,
      628
    ],
    "source": ""
  },
  {
    "id": 612,
    "question": "Jim is designing his organization's log management systems and knows that he needs to carefully plan to handle the organization's log data. Which of the following is not a factor that Jim should be concerned with?",
    "choice_a": "The volume of log data",
    "choice_b": "A lack of sufficient log sources",
    "choice_c": "Data storage security requirements",
    "choice_d": "Network bandwidth",
    "correct_answer": "B",
    "explanation": "Not having enough log sources is not a key consideration in log management system design, although it may be a worry for security managers who can't capture the data they need. Log management system designs must take into account the volume of log data and the network bandwidth it consumes, the security of the data, and the amount of effort required to analyze the data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      603,
      604,
      741,
      622,
      624
    ],
    "source": ""
  },
  {
    "id": 613,
    "question": "Kara used nmap to perform a scan of a system under her control and received the results shown here. <br><img src=\"/question_assets/SSCP/c03uf004.png\"/>If Kara's primary concern is preventing eavesdropping attacks, which port should she block?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "1433",
    "correct_answer": "B",
    "explanation": "Port 80 is used by the HTTP protocol for unencrypted web communications. If Kara wants to protect against eavesdropping, she should block this port and restrict web access to encrypted HTTPS connections on port 443.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      616,
      615,
      617,
      62,
      619
    ],
    "source": ""
  },
  {
    "id": 614,
    "question": "Kara used nmap to perform a scan of a system under her control and received the results shown here. <br><img src=\"/question_assets/SSCP/c03uf004.png\"/>If Kara's primary concern is preventing administrative connections to the server, which port should she block?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "1433",
    "correct_answer": "A",
    "explanation": "Port 22 is used by the Secure Shell (SSH) protocol for administrative connections. If Kara wants to restrict administrative connections, she should block access on this port.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      618,
      620,
      617,
      62,
      619
    ],
    "source": ""
  },
  {
    "id": 615,
    "question": "During a port scan, Susan discovers a system running services on TCP and UDP 137-139 and TCP 445, as well as TCP 1433. What type of system is she likely to find if she connects to the machine?",
    "choice_a": "A Linux email server",
    "choice_b": "A Windows SQL server",
    "choice_c": "A Linux file server",
    "choice_d": "A Windows workstation",
    "correct_answer": "B",
    "explanation": "TCP and UDP ports 137\u2013139 are used for NetBIOS services, whereas 445 is used for Active Directory. TCP 1433 is the default port for Microsoft SQL, indicating that this is probably a Windows server providing SQL services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      618,
      620,
      607,
      619,
      600
    ],
    "source": ""
  },
  {
    "id": 616,
    "question": "After conducting a qualitative risk assessment of her organization, Sally recommends purchasing cybersecurity breach insurance. What type of risk response behavior is she recommending?",
    "choice_a": "Accept",
    "choice_b": "Transfer",
    "choice_c": "Reduce",
    "choice_d": "Reject",
    "correct_answer": "B",
    "explanation": "Purchasing insurance is a means of transferring risk. If Sally had worked to decrease the likelihood of the events occurring, she would have been using a reduce or risk mitigation strategy, while simply continuing to function as the organization has would be an example of an acceptance strategy. Rejection, or denial of the risk, is not a valid strategy, even though it occurs!",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      64,
      63,
      62,
      47
    ],
    "source": ""
  },
  {
    "id": 617,
    "question": "What is the best way to provide accountability for the use of identities?",
    "choice_a": "Logging",
    "choice_b": "Authorization",
    "choice_c": "Digital signatures",
    "choice_d": "Type 1 authentication",
    "correct_answer": "A",
    "explanation": "Logging systems can provide accountability for identity systems by tracking the actions, changes, and other activities a user or account performs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      609,
      610,
      622,
      40,
      53
    ],
    "source": ""
  },
  {
    "id": 618,
    "question": "Robin recently conducted a vulnerability scan and found a critical vulnerability on a server that handles sensitive information. What should Robin do next?",
    "choice_a": "Patching",
    "choice_b": "Reporting",
    "choice_c": "Remediation",
    "choice_d": "Validation",
    "correct_answer": "D",
    "explanation": "Once a vulnerability scanner identifies a potential problem, validation is necessary to verify that the issue exists. Reporting, patching, or other remediation actions can be conducted once the vulnerability has been confirmed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      53,
      56,
      59,
      34
    ],
    "source": ""
  },
  {
    "id": 619,
    "question": "Rolando is a risk manager with a large-scale enterprise. The firm recently evaluated the risk of California mudslides on its operations in the region and determined that the cost of responding outweighed the benefits of any controls it could implement. The company chose to take no action at this time. What risk management strategy did Rolando's organization pursue?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk transference",
    "choice_d": "Risk acceptance",
    "correct_answer": "D",
    "explanation": "In a risk acceptance strategy, the organization decides that taking no action is the most beneficial route to managing a risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      59,
      63,
      62,
      65
    ],
    "source": ""
  },
  {
    "id": 620,
    "question": "During a log review, Danielle discovers a series of logs that show login failures. <br> <code>Jan 31 11:39:12 ip-10-0-0-2 sshd[29092]: Invalid user admin from remotehost passwd=aaaaaaaa</code> <br> <code>Jan 31 11:39:20 ip-10-0-0-2 sshd[29098]: Invalid user admin from remotehost passwd=aaaaaaab</code> <br> <code>Jan 31 11:39:23 ip-10-0-0-2 sshd[29100]: Invalid user admin from remotehost passwd=aaaaaaac</code> <br> <code>Jan 31 11:39:31 ip-10-0-0-2 sshd[29106]: Invalid user admin from remotehost passwd=aaaaaaad</code> <br> <code>Jan 31 20:40:53 ip-10-0-0-254 sshd[30520]: Invalid user admin from remotehost passwd=aaaaaaae</code> <br> What type of attack has Danielle discovered?",
    "choice_a": "A pass-the-hash attack",
    "choice_b": "A brute-force attack",
    "choice_c": "A man-in-the-middle attack",
    "choice_d": "A dictionary attack",
    "correct_answer": "B",
    "explanation": "Brute-force attacks try every possible password. In this attack, the password is changing by one letter at each attempt, which indicates that it is a brute-force attack. A dictionary attack would use dictionary words for the attack, whereas a man-in-the-middle or pass-the-hash attack would most likely not be visible in an authentication log except as a successful login.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      472,
      55,
      62,
      59
    ],
    "source": ""
  },
  {
    "id": 621,
    "question": "During a third-party audit, Jim's company receives a finding that states, \u201cThe administrator should review backup success and failure logs on a daily basis, and take action in a timely manner to resolve reported exceptions.\u201d What is the biggest issue that is likely to result if Jim's IT staff need to restore from a backup?",
    "choice_a": "They will not know if the backups succeeded or failed.",
    "choice_b": "The backups may not be properly logged.",
    "choice_c": "The backups may not be usable.",
    "choice_d": "The backup logs may not be properly reviewed.",
    "correct_answer": "C",
    "explanation": "The audit finding indicates that the backup administrator may not be monitoring backup logs and taking appropriate action based on what they report, thus, resulting in potentially unusable backups. Issues with review, logging, or being aware of the success or failure of backups are less important than not having usable backups.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      605,
      53,
      52,
      57,
      61
    ],
    "source": ""
  },
  {
    "id": 622,
    "question": "Ben's organization has begun to use STRIDE to assess its software and has identified threat agents and the business impacts that these threats could have. Now they are working to identify appropriate controls for the issues they have identified. <br>Ben's development team needs to address an authorization issue, resulting in an elevation of privilege threat. Which of the following controls is most appropriate to this type of issue?",
    "choice_a": "Auditing and logging are enabled.",
    "choice_b": "Role-based access control is used for specific operations.",
    "choice_c": "Data type and format checks are enabled.",
    "choice_d": "User input is tested against a whitelist.",
    "correct_answer": "B",
    "explanation": "Microsoft's STRIDE threat assessment model places threats into one of six categories: <br>Spoofing\u2014threats that involve user credentials and authentication, or falsifying legitimate communications <br>Tampering\u2014threats that involve the malicious modification of data <br>Repudiation\u2014threats that cause actions to occur that cannot be denied by a user <br>Information disclosure\u2014threats that involve exposure of data to unauthorized individuals <br>Denial of service\u2014threats that deny service to legitimate users <br>Elevation of privilege\u2014threats that provide higher privileges to unauthorized users <br>Using role-based access controls (RBACs) for specific operations will help to ensure that users cannot perform actions that they should not be able to. Auditing and logging can help detect abuse but won't prevent it, and data type, format checks, and whitelisting are all useful for preventing attacks like SQL injection and buffer overflow attacks but are not as directly aimed at authorization issues.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      50,
      59,
      42,
      52
    ],
    "source": ""
  },
  {
    "id": 623,
    "question": "Ben's organization has begun to use STRIDE to assess its software and has identified threat agents and the business impacts that these threats could have. Now they are working to identify appropriate controls for the issues they have identified. <br>Ben's team is attempting to categorize a transaction identification issue that is caused by use of a symmetric key shared by multiple servers. What STRIDE category should this fall into?",
    "choice_a": "Information disclosure",
    "choice_b": "Denial of service",
    "choice_c": "Tampering",
    "choice_d": "Repudiation",
    "correct_answer": "D",
    "explanation": "Since a shared symmetric key could be used by any of the servers, transaction identification problems caused by a shared key are likely to involve a repudiation issue. If encrypted transactions cannot be uniquely identified by server, they cannot be proved to have come from a specific server.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      38,
      46,
      48,
      53
    ],
    "source": ""
  },
  {
    "id": 624,
    "question": "Ben's organization has begun to use STRIDE to assess its software and has identified threat agents and the business impacts that these threats could have. Now they are working to identify appropriate controls for the issues they have identified. <br>Ben wants to prevent or detect tampering with data. Which of the following is not an appropriate solution?",
    "choice_a": "Hashes",
    "choice_b": "Digital signatures",
    "choice_c": "Filtering",
    "choice_d": "Authorization controls",
    "correct_answer": "C",
    "explanation": "Filtering is useful for preventing denial-of-service attacks but won't prevent tampering with data. Hashes and digital signatures can both be used to verify the integrity of data, and authorization controls can help ensure that only those with the proper rights can modify the data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      38,
      59,
      65,
      50
    ],
    "source": ""
  },
  {
    "id": 625,
    "question": "During a port scan of his network, Alex finds that a number of hosts respond on TCP ports 80, 443, 515, and 9100 in offices throughout his organization. What type of devices is Alex likely discovering?",
    "choice_a": "Web servers",
    "choice_b": "File servers",
    "choice_c": "Wireless access points",
    "choice_d": "Printers",
    "correct_answer": "D",
    "explanation": "Network-enabled printers often provide services via TCP 515 and 9100 and have both nonsecure and secure web-enabled management interfaces on TCP 80 and 443. Web servers, access points, and file servers would not typically provide service on the LPR and LPD ports (515 and 9100).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      618,
      620,
      616,
      619,
      601
    ],
    "source": ""
  },
  {
    "id": 626,
    "question": "Alan is performing threat modeling and decides that it would be useful to decompose the system into the key elements shown here. What tool is he using? <br><img src=\"/question_assets/SSCP/c03uf005.png\"/>Image reprinted from <italic>CISSP ISC2 Certified Information Systems Security Professional Official Study Guide</italic>,7th Edition \u00a9 John Wiley & Sons 2015, reprinted with permission.",
    "choice_a": "Vulnerability assessment",
    "choice_b": "Fuzzing",
    "choice_c": "Reduction analysis",
    "choice_d": "Data modeling",
    "correct_answer": "C",
    "explanation": "In reduction analysis, the security professional breaks the system down into five key elements: trust boundaries, data flow paths, input points, privileged operations, and details about security controls.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      46,
      48,
      50,
      36
    ],
    "source": ""
  },
  {
    "id": 627,
    "question": "Which of the following is not a hazard associated with penetration testing?",
    "choice_a": "Application crashes",
    "choice_b": "Denial of service",
    "choice_c": "Exploitation of vulnerabilities",
    "choice_d": "Data corruption",
    "correct_answer": "C",
    "explanation": "Penetration tests are intended to help identify vulnerabilities, and exploiting them is part of the process rather than a hazard. Application crashes; denial of service due to system, network, or application failures; and even data corruption can all be hazards of penetration tests.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      46,
      59,
      60,
      61
    ],
    "source": ""
  },
  {
    "id": 628,
    "question": "Nmap is an example of what type of tool?",
    "choice_a": "Vulnerability scanner",
    "choice_b": "Web application fuzzer",
    "choice_c": "Network design and layout",
    "choice_d": "Port scanner",
    "correct_answer": "D",
    "explanation": "Nmap is a popular open source port scanner. Nmap is not a vulnerability scanner, nor is it a web application fuzzer. While port scanners can be used to partially map a network and its name stands for Network Mapper, it is not a network design tool.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      617,
      618,
      620,
      600,
      628
    ],
    "source": ""
  },
  {
    "id": 629,
    "question": "Which of the following is a method used to design new software tests and to ensure the quality of tests?",
    "choice_a": "Code auditing",
    "choice_b": "Static code analysis",
    "choice_c": "Regression testing",
    "choice_d": "Mutation testing",
    "correct_answer": "D",
    "explanation": "Mutation testing modifies a program in small ways and then tests that mutant to determine whether it behaves as it should or whether it fails. This technique is used to design and test software tests through mutation. Static code analysis and regression testing are both means of testing code, whereas code auditing is an analysis of source code rather than a means of designing and testing software tests.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      602,
      628,
      629,
      623,
      617
    ],
    "source": ""
  },
  {
    "id": 630,
    "question": "When a Windows system is rebooted, what type of log is generated?",
    "choice_a": "Error",
    "choice_b": "Warning",
    "choice_c": "Information",
    "choice_d": "Failure audit",
    "correct_answer": "C",
    "explanation": "Rebooting a Windows machine results in an information log entry. Windows defines five types of events: errors, which indicate a significant problem; warnings, which may indicate future problems; information, which describes successful operation; success audits, which record successful security accesses; and failure audits, which record failed security access attempts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      610,
      609,
      607,
      741,
      622
    ],
    "source": ""
  },
  {
    "id": 631,
    "question": "What is the first step that should occur before a penetration test is performed?",
    "choice_a": "Data gathering",
    "choice_b": "Port scanning",
    "choice_c": "Getting permission",
    "choice_d": "Planning",
    "correct_answer": "C",
    "explanation": "The most important first step for a penetration test is getting permission. Once permission has been received, planning, data gathering, and then elements of the actual test like port scanning can commence.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      54,
      60,
      62,
      59
    ],
    "source": ""
  },
  {
    "id": 632,
    "question": "Bobbi is investigating a security incident and discovers that an attacker began with a normal user account but managed to exploit a system vulnerability to provide that account with administrative rights. What type of attack took place under the STRIDE threat model?",
    "choice_a": "Spoofing",
    "choice_b": "Repudiation",
    "choice_c": "Tampering",
    "choice_d": "Elevation of privilege",
    "correct_answer": "D",
    "explanation": "In an elevation of privilege attack, the attacker transforms a limited user account into an account with greater privileges, powers, and/or access to the system. Spoofing attacks falsify an identity, while repudiation attacks attempt to deny accountability for an action. Tampering attacks attempt to violate the integrity of information or resources.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      46,
      35,
      50,
      57
    ],
    "source": ""
  },
  {
    "id": 633,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>At this point in the incident response process, what term best describes what has occurred in Ann's organization?",
    "choice_a": "Security occurrence",
    "choice_b": "Security incident",
    "choice_c": "Security event",
    "choice_d": "Security intrusion",
    "correct_answer": "C",
    "explanation": "At this point in the process, Ann has no reason to believe that any actual security compromise or policy violation took place, so this situation does not meet the criteria for a security incident or intrusion. Rather, the alert generated by the intrusion detection system is simply a security event requiring further investigation. Security occurrence is not a term commonly used in incident handling.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      59,
      34,
      472,
      624
    ],
    "source": ""
  },
  {
    "id": 634,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>Ann continues her investigation and realizes that the traffic generating the alert is abnormally high volumes of inbound UDP traffic on port 53. What service typically uses this port?",
    "choice_a": "DNS",
    "choice_b": "SSH/SCP",
    "choice_c": "SSL/TLS",
    "choice_d": "HTTP",
    "correct_answer": "A",
    "explanation": "DNS traffic commonly uses port 53 for both TCP and UDP communications. SSH and SCP use TCP port 22. SSL and TLS do not have ports assigned to them but are commonly used for HTTPS traffic on port 443. Unencrypted web traffic over HTTP often uses port 80.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      618,
      616,
      619,
      61,
      623
    ],
    "source": ""
  },
  {
    "id": 635,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>As Ann analyzes the traffic further, she realizes that the traffic is coming from many different sources and has overwhelmed the network, preventing legitimate uses. The inbound packets are responses to queries that she does not see in outbound traffic. The responses are abnormally large for their type. What type of attack should Ann suspect?",
    "choice_a": "Reconnaissance",
    "choice_b": "Malicious code",
    "choice_c": "System penetration",
    "choice_d": "Denial of service",
    "correct_answer": "D",
    "explanation": "The attack described in this scenario has all of the hallmarks of a denial-of-service attack. More specifically, Ann's organization is likely experiencing a DNS amplification attack where an attacker sends false requests to third-party DNS servers with a forged source IP address belonging to the targeted system. Because the attack uses UDP requests, there is no three-way handshake. The attack packets are carefully crafted to elicit a lengthy response from a short query. The purpose of these queries is to generate responses headed to the target system that are sufficiently large and numerous enough to overwhelm the targeted network or system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      61,
      62,
      65,
      55
    ],
    "source": ""
  },
  {
    "id": 636,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>Now that Ann understands that an attack has taken place that violates her organization's security policy, what term best describes what has occurred in Ann's organization?",
    "choice_a": "Security occurrence",
    "choice_b": "Security incident",
    "choice_c": "Security event",
    "choice_d": "Security intrusion",
    "correct_answer": "B",
    "explanation": "Now that Ann suspects an attack against her organization, she has sufficient evidence to declare a security incident. The attack underway seems to have undermined the availability of her network, meeting one of the criteria for a security incident. This is an escalation beyond a security event but does not reach the level of an intrusion because there is no evidence that the attacker has even attempted to gain access to systems on Ann's network. Security occurrence is not a term commonly used in incident handling.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      59,
      34,
      40,
      472
    ],
    "source": ""
  },
  {
    "id": 637,
    "question": "During a log review, Saria discovers a series of logs that show login failures, as shown here: <br><img src=\"/question_assets/SSCP/3_image1.png\"/>What type of attack has Saria discovered?",
    "choice_a": "A brute-force attack",
    "choice_b": "A man-in-the-middle attack",
    "choice_c": "A dictionary attack",
    "choice_d": "A rainbow table attack",
    "correct_answer": "C",
    "explanation": "Dictionary attacks use a dictionary or list of common passwords as well as variations of those words to attempt to log in as an authorized user. This attack shows a variety of passwords based on a similar base word, which is often a good indicator of a dictionary attack. A brute-force attack will typically show simple iteration of passwords, while a man-in-the-middle attack would not be visible in the authentication log. A rainbow table attack is used when attackers already have password hashes in their possession and would also not show up in logs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      472,
      61,
      471,
      623,
      53
    ],
    "source": ""
  },
  {
    "id": 638,
    "question": "Ben is seeking a control objective framework that is widely accepted around the world and focuses specifically on information security controls. Which one of the following frameworks would best meet his needs?",
    "choice_a": "ITIL",
    "choice_b": "ISO 27002",
    "choice_c": "CMM",
    "choice_d": "PMBOK Guide",
    "correct_answer": "B",
    "explanation": "ISO 27002 is an international standard focused on information security and titled \u201cInformation technology\u2014Security techniques\u2014Code of practice for information security management.\u201d The Information Technology Infrastructure Library (ITIL) does contain security management practices, but it is not the sole focus of the document, and the ITIL security section is derived from ISO 27002. The Capability Maturity Model (CMM) is focused on software development, and the Project Management Body of Knowledge (PMBOK) Guide focuses on project management.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      475,
      36,
      56,
      476,
      474
    ],
    "source": ""
  },
  {
    "id": 639,
    "question": "Tony is developing a business continuity plan and is having difficulty prioritizing resources because of the difficulty of combining information about tangible and intangible assets. What would be the most effective risk assessment approach for him to use?",
    "choice_a": "Quantitative risk assessment",
    "choice_b": "Qualitative risk assessment",
    "choice_c": "Neither quantitative nor qualitative risk assessment",
    "choice_d": "Combination of quantitative and qualitative risk assessment",
    "correct_answer": "D",
    "explanation": "Tony would see the best results by combining elements of quantitative and qualitative risk assessment. Quantitative risk assessment excels at analyzing financial risk, while qualitative risk assessment is a good tool for intangible risks. Combining the two techniques provides a well-rounded risk picture.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      45,
      456,
      458,
      596
    ],
    "source": ""
  },
  {
    "id": 640,
    "question": "Angela wants to test a web browser's handling of unexpected data using an automated tool. What tool should she choose?",
    "choice_a": "Nmap",
    "choice_b": "zzuf",
    "choice_c": "Nessus",
    "choice_d": "Nikto",
    "correct_answer": "B",
    "explanation": "zzuf is the only fuzzer on the list, and zzuf is specifically designed to work with tools like web browsers, image viewers, and similar software by modifying network and file input to application. Nmap is a port scanner, Nessus is a vulnerability scanner, and Nikto is a web server scanner.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      602,
      600,
      601,
      618,
      617
    ],
    "source": ""
  },
  {
    "id": 641,
    "question": "Saria wants to log and review traffic information between parts of her network. What type of network logging should she enable on her routers to allow her to perform this analysis?",
    "choice_a": "Audit logging",
    "choice_b": "Flow logging",
    "choice_c": "Trace logging",
    "choice_d": "Route logging",
    "correct_answer": "B",
    "explanation": "Flows, also often called network flows, are captured to provide insight into network traffic for security, troubleshooting, and performance management. Audit logging provides information about events on the routers, route logging is not a common network logging function, and trace logs are used in troubleshooting specific software packages as they perform their functions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      611,
      609,
      622,
      53
    ],
    "source": ""
  },
  {
    "id": 642,
    "question": "Jim is working with a penetration testing contractor who proposes using Metasploit as part of her penetration testing effort. What should Jim expect to occur when Metasploit is used?",
    "choice_a": "Systems will be scanned for vulnerabilities.",
    "choice_b": "Systems will have known vulnerabilities exploited.",
    "choice_c": "Services will be probed for buffer overflow and other unknown flaws.",
    "choice_d": "Systems will be tested for zero-day exploits.",
    "correct_answer": "B",
    "explanation": "Metasploit is an exploitation package that is designed to assist penetration testers. A tester using Metasploit can exploit known vulnerabilities for which an exploit has been created or can create their own exploits using the tool. While Metasploit provides built-in access to some vulnerability scanning functionality, a tester using Metasploit should primarily be expected to perform actual tests of exploitable vulnerabilities. Similarly, Metasploit supports creating buffer overflow attacks, but it is not a purpose-built buffer overflow testing tool, and of course testing systems for zero-day exploits doesn't work unless they have been released.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      602,
      600,
      35,
      629,
      46
    ],
    "source": ""
  },
  {
    "id": 643,
    "question": "You are completing your business continuity planning effort and have decided that you wish to accept one of the risks. What should you do next?",
    "choice_a": "Implement new security controls to reduce the risk level.",
    "choice_b": "Design a disaster recovery plan.",
    "choice_c": "Repeat the business impact assessment.",
    "choice_d": "Document your decision-making process.",
    "correct_answer": "D",
    "explanation": "Whenever you choose to accept a risk, you should maintain detailed documentation of the risk acceptance process to satisfy auditors in the future. This should happen before implementing security controls, designing a disaster recovery plan, or repeating the business impact analysis (BIA).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      52,
      56,
      59,
      57
    ],
    "source": ""
  },
  {
    "id": 644,
    "question": "During a port scan, Ben uses nmap's default settings and sees the following results. <br><img src=\"/question_assets/SSCP/c03uf006.png\"/>If Ben is conducting a penetration test, what should his next step be after receiving these results?",
    "choice_a": "Connect to the web server using a web browser.",
    "choice_b": "Connect via Telnet to test for vulnerable accounts.",
    "choice_c": "Identify interesting ports for further scanning.",
    "choice_d": "Use sqlmap against the open databases.",
    "correct_answer": "C",
    "explanation": "After scanning for open ports using a port scanning tool like nmap, penetration testers will identify interesting ports and then conduct vulnerability scans to determine what services may be vulnerable. This will perform many of the same activities as connecting to a web server.  It will also typically be more useful than trying to manually test for vulnerable accounts via Telnet. sqlmap would typically be used after a vulnerability scanner identifies additional information about services, and the vulnerability scanner will normally provide a wider range of useful information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      600,
      601,
      602,
      617,
      620
    ],
    "source": ""
  },
  {
    "id": 645,
    "question": "During a port scan, Ben uses nmap's default settings and sees the following results. <br><img src=\"/question_assets/SSCP/c03uf006.png\"/>Based on the scan results, what operating system (OS) was the system that was scanned most likely running?",
    "choice_a": "Windows Desktop",
    "choice_b": "Linux",
    "choice_c": "Network device",
    "choice_d": "Windows Server",
    "correct_answer": "B",
    "explanation": "The system is likely a Linux system. The system shows X11, as well as login, shell, and nfs ports, all of which are more commonly found on Linux systems than Windows systems or network devices. This system is also very poorly secured; many of the services running on it should not be exposed in a modern secure network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      618,
      620,
      617,
      610,
      46
    ],
    "source": ""
  },
  {
    "id": 646,
    "question": "During a port scan, Ben uses nmap's default settings and sees the following results. <br><img src=\"/question_assets/SSCP/c03uf006.png\"/>Ben's manager expresses concern about the coverage of his scan. Why might his manager have this concern?",
    "choice_a": "Ben did not test UDP services",
    "choice_b": "Ben did not discover ports outside the \u201cwell-known ports.\u201d",
    "choice_c": "Ben did not perform OS fingerprinting.",
    "choice_d": "Ben tested only a limited number of ports.",
    "correct_answer": "D",
    "explanation": "Nmap only scans 1000 TCP and UDP ports by default, including ports outside the 0\u20131024 range of \u201cwell-known\u201d ports. By using the defaults for nmap, Ben missed 64,535 ports. OS fingerprinting won't cover more ports but would have provided a best guess of the OS running on the scanned system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      617,
      618,
      620,
      54,
      59
    ],
    "source": ""
  },
  {
    "id": 647,
    "question": "What is the formula used to determine risk?",
    "choice_a": "Risk = Threat * Vulnerability",
    "choice_b": "Risk = Threat / Vulnerability",
    "choice_c": "Risk = Asset * Threat",
    "choice_d": "Risk = Asset / Threat",
    "correct_answer": "A",
    "explanation": "Risks exist when there is an intersection of a threat and a vulnerability. This is described using the equation Risk = Threat * Vulnerability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      46,
      34,
      42,
      48,
      56
    ],
    "source": ""
  },
  {
    "id": 648,
    "question": "A zero-day vulnerability is announced for the popular Apache web server in the middle of a workday. In Jacob's role as an information security analyst, he needs to quickly scan his network to determine what servers are vulnerable to the issue. What is Jacob's best route to quickly identify vulnerable systems?",
    "choice_a": "Immediately run Nessus against all of the servers to identify which systems are vulnerable.",
    "choice_b": "Review the CVE database to find the vulnerability information and patch information.",
    "choice_c": "Create a custom IDS or IPS signature.",
    "choice_d": "Identify affected versions and check systems for that version number using an automated scanner.",
    "correct_answer": "D",
    "explanation": "In many cases when an exploit is initially reported, there are no prebuilt signatures or detections for vulnerability scanners, and the CVE database may not immediately have information about the attack. Jacob's best option is to quickly gather information and review potentially vulnerable servers based on their current configuration. As more information becomes available, signatures and CVE information are likely to be published. Unfortunately for Jacob, IDS and IPS signatures will only detect attacks and won't detect whether systems are vulnerable unless he sees the systems being exploited.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      600,
      61,
      54,
      55
    ],
    "source": ""
  },
  {
    "id": 649,
    "question": "During a review of access logs, Alex notices that Danielle logged into her workstation in New York at 8 a.m. daily but that she was recorded as logging into her department's main web application shortly after 3 a.m. daily. What common logging issue has Alex likely encountered?",
    "choice_a": "Inconsistent log formatting",
    "choice_b": "Modified logs",
    "choice_c": "Inconsistent timestamps",
    "choice_d": "Multiple log sources",
    "correct_answer": "C",
    "explanation": "Inconsistent time stamps are a common problem, often caused by improperly set time zones or because of differences in how system clocks are set. In this case, a consistent time difference often indicates that one system uses local time, and the other is using Greenwich mean time (GMT). Logs from multiple sources tend to cause problems with centralization and collection, whereas different log formats can create challenges in parsing log data. Finally, modified logs are often a sign of intrusion or malicious intent.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      621,
      622,
      473,
      610,
      609
    ],
    "source": ""
  },
  {
    "id": 650,
    "question": "What is the final step of a quantitative risk analysis?",
    "choice_a": "Determine asset value.",
    "choice_b": "Assess the annualized rate of occurrence.",
    "choice_c": "Derive the annualized loss expectancy.",
    "choice_d": "Conduct a cost/benefit analysis.",
    "correct_answer": "D",
    "explanation": "The final step of a quantitative risk analysis is conducting a cost-benefit analysis to determine whether the organization should implement proposed countermeasure(s).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      614,
      597,
      456,
      596,
      64
    ],
    "source": ""
  },
  {
    "id": 651,
    "question": "Carrie is analyzing the application logs for her web-based application and comes across the following string: <br> <code>../../../../../../../../../etc/passwd</code> <br>What type of attack was likely attempted against Carrie's application?",
    "choice_a": "Command injection",
    "choice_b": "Session hijacking",
    "choice_c": "Directory traversal",
    "choice_d": "Brute force",
    "correct_answer": "C",
    "explanation": "The string shown in the logs is characteristic of a directory traversal attack where the attacker attempts to force the web application to navigate up the file hierarchy and retrieve a file that should not normally be provided to a web user, such as the password file. The series of \u201cdouble dots\u201d is indicative of a directory traversal attack because it is the character string used to reference the directory one level up in a hierarchy.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      601,
      472,
      62,
      49,
      55
    ],
    "source": ""
  },
  {
    "id": 652,
    "question": "Allie is responsible for reviewing authentication logs on her organization's network. She does not have the time to review all logs, so she decides to choose only records where there have been four or more invalid authentication attempts. What technique is Allie using to reduce the size of the pool?",
    "choice_a": "Sampling",
    "choice_b": "Random selection",
    "choice_c": "Clipping",
    "choice_d": "Statistical analysis",
    "correct_answer": "C",
    "explanation": "The two main methods of choosing records from a large pool for further analysis are sampling and clipping. Sampling uses statistical techniques to choose a sample that is representative of the entire pool, while clipping uses threshold values to select those records that exceed a predefined threshold because they may be of most interest to analysts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      626,
      625,
      61,
      53,
      40
    ],
    "source": ""
  },
  {
    "id": 653,
    "question": "During a penetration test of her organization, Kathleen's IPS detects a port scan that has the URG, FIN, and PSH flags set and produces an alarm. What type of scan is the penetration tester attempting?",
    "choice_a": "A SYN scan",
    "choice_b": "A TCP flag scan",
    "choice_c": "An Xmas scan",
    "choice_d": "An ACK scan",
    "correct_answer": "C",
    "explanation": "A TCP scan that sets all or most of the possible TCP flags is called a Christmas tree, or Xmas, scan since it is said to \u201clight up like a Christmas tree\u201d with the flags. A SYN scan would attempt to open TCP connections, whereas an ACK scan sends packets with the ACK flag set. There is no such type of scan known as a TCP flag scan.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      620,
      628,
      61,
      55,
      59
    ],
    "source": ""
  },
  {
    "id": 654,
    "question": "Which type of business impact assessment tool is most appropriate when attempting to evaluate the impact of a failure on customer confidence?",
    "choice_a": "Quantitative",
    "choice_b": "Qualitative",
    "choice_c": "Annualized loss expectancy",
    "choice_d": "Reduction",
    "correct_answer": "B",
    "explanation": "Qualitative tools are often used in business impact assessment to capture the impact on intangible factors such as customer confidence, employee morale, and reputation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      45,
      456,
      458,
      477,
      595
    ],
    "source": ""
  },
  {
    "id": 655,
    "question": "What type of vulnerabilities will not be found by a vulnerability scanner?",
    "choice_a": "Local vulnerabilities",
    "choice_b": "Service vulnerabilities",
    "choice_c": "Zero-day vulnerabilities",
    "choice_d": "Vulnerabilities that require authentication",
    "correct_answer": "C",
    "explanation": "Vulnerability scanners cannot detect vulnerabilities for which they do not have a test, plug-in, or signature. Signatures often include version numbers, service fingerprints, or configuration data. They can detect local vulnerabilities as well as those that require authentication if they are provided with credentials, and of course, they can detect service vulnerabilities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      600,
      602,
      35,
      46,
      617
    ],
    "source": ""
  },
  {
    "id": 656,
    "question": "Which of the following vulnerabilities is unlikely to be found by a web vulnerability scanner?",
    "choice_a": "Path disclosure",
    "choice_b": "Local file inclusion",
    "choice_c": "Race condition",
    "choice_d": "Buffer overflow",
    "correct_answer": "C",
    "explanation": "Path disclosures, local file inclusions, and buffer overflows are all vulnerabilities that may be found by a web vulnerability scanner, but race conditions that take advantage of timing issues tend to be found either by code analysis or using automated tools that specifically test for race conditions as part of software testing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      602,
      601,
      600,
      617,
      53
    ],
    "source": ""
  },
  {
    "id": 657,
    "question": "Jim has been contracted to conduct a gray box penetration test, and his clients have provided him with the following information about their networks so that he can scan them: <br>Data center: 10.10.10.0/24 <br>Sales: 10.10.11.0/24 <br>Billing: 10.10.12.0/24 <br>Wireless: 192.168.0.0/16 <br>What problem will Jim encounter if he is contracted to conduct a scan from offsite?",
    "choice_a": "The IP ranges are too large to scan efficiently.",
    "choice_b": "The IP addresses provided cannot be scanned.",
    "choice_c": "The IP ranges overlap and will cause scanning issues.",
    "choice_d": "The IP addresses provided are RFC 1918 addresses.",
    "correct_answer": "D",
    "explanation": "The IP addresses that his clients have provided are RFC 1918 nonroutable IP addresses, and Jim will not be able to scan them from off-site. To succeed in his penetration test, he will have to either first penetrate their network border or place a machine inside their network to scan from the inside. IP addresses overlapping is not a real concern for scanning, and the ranges can easily be handled by current scanning systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      628,
      627,
      629,
      52,
      39
    ],
    "source": ""
  },
  {
    "id": 658,
    "question": "Tara recently detected a security incident in progress on her network. What action should be her highest priority at this point?",
    "choice_a": "Eradication",
    "choice_b": "Recovery",
    "choice_c": "Containment",
    "choice_d": "Detection",
    "correct_answer": "C",
    "explanation": "Tara's highest priority should be containing the damage to prevent the spread of the incident to other systems and networks. She has already detected the incident, so detection is not a priority. Eradication and recovery should occur only after the incident has been contained.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      69,
      71,
      101,
      636
    ],
    "source": ""
  },
  {
    "id": 659,
    "question": "Alan is responding to a security incident and receives a hard drive image from a cooperating organization that contains evidence. What additional information should he request to verify the integrity of the evidence?",
    "choice_a": "Private key",
    "choice_b": "Public key",
    "choice_c": "Hash",
    "choice_d": "Drive capacity",
    "correct_answer": "C",
    "explanation": "Alan should request that the organization provide him with a securely generated hash value that was created when the evidence was originally collected. Alan can then compare the hash value of the current drive contents with that value to verify that the evidence was not altered.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      659,
      640,
      639,
      658,
      99
    ],
    "source": ""
  },
  {
    "id": 660,
    "question": "Jeff discovers a series of JPEG photos on a drive that he is analyzing for evidentiary purposes. He uses exiftool to collect metadata from those files. Which information is <italic>not</italic> likely to be included in that metadata?",
    "choice_a": "GPS location",
    "choice_b": "Camera type",
    "choice_c": "Number of copies made",
    "choice_d": "Timestamp",
    "correct_answer": "C",
    "explanation": "Photo metadata commonly includes the GPS location, the type of camera used to capture the photo, and the timestamp when the photo was taken. It does not include the number of times that the file was copied.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      630,
      631,
      632,
      99,
      100
    ],
    "source": ""
  },
  {
    "id": 661,
    "question": "Chris would like to use John the Ripper to test the security of passwords on a compromised Linux system. What files does he need to conduct this analysis?",
    "choice_a": "<code>/etc/shadow</code> and <code>/etc/user</code>",
    "choice_b": "<code>/etc/passwd</code> and <code>/etc/user</code>",
    "choice_c": "<code>/etc/user</code> and <code>/etc/account</code>",
    "choice_d": "<code>/etc/passwd</code> and <code>/etc/shadow</code>",
    "correct_answer": "D",
    "explanation": "John the Ripper is a password cracking tool. Using it on a Linux system requires copies of both the <code>/etc/passwd</code> and <code>/etc/shadow</code> files.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      634,
      633,
      86,
      75,
      76
    ],
    "source": ""
  },
  {
    "id": 662,
    "question": "Alex's organization uses the NIST incident classification scheme. Alex discovers that a laptop belonging to a senior executive had keylogging software installed on it. How should Alex classify this occurrence?",
    "choice_a": "Event",
    "choice_b": "Adverse event",
    "choice_c": "Incident",
    "choice_d": "Policy violation",
    "correct_answer": "C",
    "explanation": "NIST describes this type of event as a security incident because it is a violation or imminent threat of violation of security policies and practices. An adverse event is any event with negative consequences, and an event is any observable occurrence on a system or network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      96,
      97,
      69,
      75,
      76
    ],
    "source": ""
  },
  {
    "id": 663,
    "question": "When working to restore systems to their original configuration after a long-term APT compromise, Charles has three options: <br> <strong>Option 1</strong>: He can restore from a backup and then update patches on the system. <br> <strong>Option 2</strong>: He can rebuild and patch the system using the original installation media and application software and his organization's build documentation. <br> <strong>Option 3</strong>: He can remove the compromised accounts and rootkit tools and then fix the issues that allowed the attackers to access the systems. <br> Which option should Charles choose in this scenario?",
    "choice_a": "Option 1",
    "choice_b": "Option 2",
    "choice_c": "Option 3",
    "choice_d": "None of the above. Charles should hire a third party to assess the systems before proceeding.",
    "correct_answer": "B",
    "explanation": "In cases where an advanced persistent threat (APT) has been present for an unknown period of time, backups should be assumed to be compromised. Since APTs often have tools that cannot be detected by normal anti-malware techniques, the best option that Charles has is to carefully rebuild the systems from the ground up and then ensure that they are fully patched and secured before returning them to service.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      72,
      87,
      84,
      75,
      99
    ],
    "source": ""
  },
  {
    "id": 664,
    "question": "If Danielle wants to purge a drive, which of the following options will accomplish her goal?",
    "choice_a": "Cryptographic erase",
    "choice_b": "Reformat",
    "choice_c": "Overwrite",
    "choice_d": "Partition",
    "correct_answer": "A",
    "explanation": "Purging requires complete removal of data, and cryptographic erase is the only option that will fully destroy the contents of a drive from this list. Reformatting will leave the original data in place, overwriting leaves the potential for file remnants in slack space, and repartitioning will also leave data intact in the new partitions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      637,
      636,
      638,
      88,
      497
    ],
    "source": ""
  },
  {
    "id": 665,
    "question": "Cynthia is building a series of scripts to detect malware beaconing behavior on her network. Which of the following is <italic>not</italic> a typical means of identifying malware beaconing?",
    "choice_a": "Persistence of the beaconing",
    "choice_b": "Beacon protocol",
    "choice_c": "Beaconing interval",
    "choice_d": "Removal of known traffic",
    "correct_answer": "B",
    "explanation": "Unless she already knows the protocol that a particular beacon uses, filtering out beacons by protocol may cause her to miss beaconing behavior. Attackers want to dodge common analytical tools and will use protocols that are less likely to attract attention. Filtering network traffic for beacons based on the intervals and frequency they are sent at, if the beacon persists over time, and removing known traffic are common means of filtering traffic to identify beacons.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      70,
      75,
      96,
      94,
      76
    ],
    "source": ""
  },
  {
    "id": 666,
    "question": "While performing post-rebuild validation efforts, Scott scans a server from a remote network and sees no vulnerabilities. Joanna, the administrator of the machine, runs a scan and discovered two critical vulnerabilities and five moderate issues. What is most likely causing the difference in their reports?",
    "choice_a": "Different patch levels during the scans",
    "choice_b": "Scanning through a load balancer",
    "choice_c": "Firewall between the remote network and the server",
    "choice_d": "Running the scan with different settings",
    "correct_answer": "C",
    "explanation": "Local scans often provide more information than remote scans because of network or host firewalls that block access to services. This is the most likely problem. The second most likely answer is that Scott or Joanna used different settings when they scanned.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      76,
      72,
      96,
      99,
      87
    ],
    "source": ""
  },
  {
    "id": 667,
    "question": "Mika wants to analyze the contents of a drive without causing any changes to the drive. What method is best suited to ensuring this?",
    "choice_a": "Set the read-only jumper on the drive.",
    "choice_b": "Use a write blocker.",
    "choice_c": "Use a read blocker.",
    "choice_d": "Use a forensic software package.",
    "correct_answer": "B",
    "explanation": "A hardware write blocker can ensure that connecting or mounting the drive does not cause any changes to occur on the drive. Mika should create one or more forensic images of the original drive and then work with the copy or copies as needed. She may then opt to use forensic software, possibly including a software write blocker.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      641,
      640,
      639,
      653,
      88
    ],
    "source": ""
  },
  {
    "id": 668,
    "question": "What type of forensic investigation-related form is shown here? <br><img src=\"/question_assets/SSCP/c04uf001.png\"/>",
    "choice_a": "Chain of custody",
    "choice_b": "Report of examination",
    "choice_c": "Forensic discovery log",
    "choice_d": "Policy custody release",
    "correct_answer": "A",
    "explanation": "This form is a chain of custody form. It includes information about the case, copies of drives that were created, and who was in possession of drives, devices, and copies during the investigation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      659,
      639,
      640,
      657,
      632
    ],
    "source": ""
  },
  {
    "id": 669,
    "question": "Eric has access to a full suite of network monitoring tools and wants to use appropriate tools to monitor network bandwidth consumption. Which of the following is <italic>not</italic> a common method of monitoring network bandwidth usage?",
    "choice_a": "SNMP",
    "choice_b": "Portmon",
    "choice_c": "Packet sniffing",
    "choice_d": "Netflow",
    "correct_answer": "B",
    "explanation": "SNMP, packet sniffing, and Netflow are commonly used when monitoring bandwidth consumption. Portmon is an aging Windows tool used to monitor serial ports, not exactly the sort of tool that you'd use to monitor network bandwidth!",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 670,
    "question": "After completing an incident response process and providing a final report to management, what step should Casey use to identify improvement to her incident response plan?",
    "choice_a": "Update system documentation.",
    "choice_b": "Conduct a lessons-learned session.",
    "choice_c": "Review patching status and vulnerability scans.",
    "choice_d": "Engage third-party consultants.",
    "correct_answer": "B",
    "explanation": "Conducting a lessons-learned review after using an incident response plan can help to identify improvements and to ensure that the plan is up-to-date and ready to handle future events.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      71,
      655,
      79,
      84,
      72
    ],
    "source": ""
  },
  {
    "id": 671,
    "question": "The senior management of Kathleen's company is concerned about rogue devices on the network. If Kathleen wants to identify rogue devices on her wired network, which of the following solutions will quickly provide the most accurate information?",
    "choice_a": "Discovery scan with a port scanner",
    "choice_b": "Router and switch-based MAC address reporting",
    "choice_c": "Physical survey",
    "choice_d": "Reviewing a central administration tool, such as SCCM",
    "correct_answer": "B",
    "explanation": "If Kathleen's company uses a management system or inventory process to capture the MAC addresses of known systems, then a MAC address report from her routers and switches will show her devices that are connected to the network but not in the inventory. She can then track down where the devices are physically connected to a switch port and investigate the device.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      93,
      88,
      87,
      94,
      89
    ],
    "source": ""
  },
  {
    "id": 672,
    "question": "During a forensic investigation, Charles discovers that he needs to capture a virtual machine that is part of the critical operations of his company's website. If he cannot suspend or shut down the machine for business reasons, what imaging process should he follow?",
    "choice_a": "Perform a snapshot of the system, boot it, suspend the copied version, and copy the directory it resides in.",
    "choice_b": "Copy the virtual disk files and then use a memory capture tool.",
    "choice_c": "Escalate to management to get permission to suspend the system to allow a true forensic copy.",
    "choice_d": "Use a tool like the Volatility Framework to capture the live machine completely.",
    "correct_answer": "B",
    "explanation": "If business concerns override his ability to suspend the system, the best option that Charles has is to copy the virtual disk files and then use a live memory imaging tool. This will give him the best forensic copy achievable under the circumstances. Snapshotting the system and booting it will result in a loss of live memory artifacts. Escalating may be possible in some circumstances, but the scenario specifies that the system must remain online. Finally, Volatility can capture memory artifacts, but is not designed to capture a full virtual machine.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      640,
      644,
      71,
      69,
      83
    ],
    "source": ""
  },
  {
    "id": 673,
    "question": "Lauren is the IT manager for a small company and occasionally serves as the organization's information security officer. Which of the following roles should she include as the leader of her organization's CSIRT?",
    "choice_a": "Her lead IT support staff technician",
    "choice_b": "Her organization's legal counsel",
    "choice_c": "A third-party IR team lead",
    "choice_d": "She should select herself.",
    "correct_answer": "D",
    "explanation": "A CSIRT leader must have authority to direct the incident response process and should be able to act as a liaison with organizational management. While Lauren may not have deep incident response experience, she is in the right role to provide those connections and leadership. She should look at retaining third-party experts for incidents if she needs additional skills or expertise on her IR team.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      71,
      83,
      650
    ],
    "source": ""
  },
  {
    "id": 674,
    "question": "Because of external factors, Eric has only a limited time period to collect an image from a workstation. If he collects only specific files of interest, what type of acquisition has he performed?",
    "choice_a": "Logical",
    "choice_b": "Bit-by-bit",
    "choice_c": "Sparse",
    "choice_d": "None of the above",
    "correct_answer": "A",
    "explanation": "A logical acquisition focuses on specific files of interest, such as a specific type of file, or files from a specific location. In Eric's case, a logical acquisition meets his needs. A sparse acquisition also collects data from unallocated space. A bit-by-bit acquisition is typically performed for a full drive and will take longer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      642,
      643,
      644,
      639,
      657
    ],
    "source": ""
  },
  {
    "id": 675,
    "question": "Which one of the following groups would be least likely to included in an organization's cybersecurity incident communications plans?",
    "choice_a": "Law enforcement",
    "choice_b": "Security vendors",
    "choice_c": "Utilities",
    "choice_d": "Media",
    "correct_answer": "C",
    "explanation": "An organization's incident response communications plan should include details of appropriate contacts with all entities who may be involved in incident response.  This likely includes law enforcement agencies, the media, and security vendors.  It is less likely that an organization would need to contact utility providers during a cybersecurity incident response effort.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      71,
      97,
      96
    ],
    "source": ""
  },
  {
    "id": 676,
    "question": "Which of the following is not an important part of the incident response communication process?",
    "choice_a": "Limiting communication to trusted parties",
    "choice_b": "Disclosure based on public feedback",
    "choice_c": "Using a secure method of communication",
    "choice_d": "Preventing accidental release of incident related information",
    "correct_answer": "B",
    "explanation": "Disclosure based on regulatory or legislative requirements is commonly part of an incident response process; however, public feedback is typically a guiding element of information release. Limiting communication to trusted parties and ensuring that data and communications about the incident are properly secured are both critical to the security of the incident response process. This also means that responders should work to limit the potential for accidental release of incident related information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      660,
      71,
      81,
      636
    ],
    "source": ""
  },
  {
    "id": 677,
    "question": "As the CISO of her organization, Jennifer is working on an incident classification scheme and wants to base her design on NIST's definitions. Which of the following options should she use to best describe a user accessing a file that they are not authorized to view?",
    "choice_a": "An incident",
    "choice_b": "An event",
    "choice_c": "An adverse event",
    "choice_d": "A security incident",
    "correct_answer": "C",
    "explanation": "NIST describes events with negative consequences as adverse events. It might be tempting to immediately call this a security incident; however, this wouldn't be classified that way until an investigation was conducted. If the user accidentally accessed the file, it would typically not change classification. Intentional or malicious access would cause the adverse event to become a security incident.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      96,
      100,
      75,
      70,
      69
    ],
    "source": ""
  },
  {
    "id": 678,
    "question": "In his role as a forensic examiner, Lucas has been asked to produce forensic evidence related to a civil case. What is this process called?",
    "choice_a": "Criminal forensics",
    "choice_b": "eDiscovery",
    "choice_c": "Cyber production",
    "choice_d": "Civil tort",
    "correct_answer": "B",
    "explanation": "NIST describes events with negative consequences as adverse events. It might be tempting to immediately call this a security incident; however, this wouldn't be classified that way until an investigation was conducted. If the user accidentally accessed the file, it would typically not change classification. Intentional or malicious access would cause the adverse event to become a security incident.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      640,
      644,
      711,
      632,
      713
    ],
    "source": ""
  },
  {
    "id": 679,
    "question": "Darcy is designing a fault-tolerant system and wants to implement RAID level 5 for her system. What is the minimum number of physical hard disks she can use to build this system?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Five",
    "correct_answer": "C",
    "explanation": "RAID level 5, disk striping with parity, requires a minimum of three physical hard disks to operate.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      646,
      645,
      519,
      647,
      521
    ],
    "source": ""
  },
  {
    "id": 680,
    "question": "What important function do senior managers normally fill on a business continuity planning team?",
    "choice_a": "Arbitrating disputes about criticality",
    "choice_b": "Evaluating the legal environment",
    "choice_c": "Training staff",
    "choice_d": "Designing failure controls",
    "correct_answer": "A",
    "explanation": "Senior managers play several business continuity planning roles. These include setting priorities, obtaining resources, and arbitrating disputes among team members.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      648,
      649,
      83,
      650,
      101
    ],
    "source": ""
  },
  {
    "id": 681,
    "question": "Which one of the following is not normally included in business continuity plan documentation?",
    "choice_a": "Statement of accounts",
    "choice_b": "Statement of importance",
    "choice_c": "Statement of priorities",
    "choice_d": "Statement of organizational responsibility",
    "correct_answer": "A",
    "explanation": "Business continuity plan documentation normally includes the continuity planning goals, a statement of importance, statement of priorities, statement of organizational responsibility, statement of urgency and timing, risk assessment and risk acceptance and mitigation documentation, a vital records program, emergency response guidelines, and documentation for maintaining and testing the plan.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      648,
      649,
      650,
      654,
      655
    ],
    "source": ""
  },
  {
    "id": 682,
    "question": "Which one of the following is not normally considered a business continuity task?",
    "choice_a": "Business impact assessment",
    "choice_b": "Emergency response guidelines",
    "choice_c": "Electronic vaulting",
    "choice_d": "Vital records program",
    "correct_answer": "C",
    "explanation": "Electronic vaulting is a data backup task that is part of disaster recovery, not business continuity, efforts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      654,
      648,
      650,
      653,
      497
    ],
    "source": ""
  },
  {
    "id": 683,
    "question": "Who should receive initial business continuity plan training in an organization?",
    "choice_a": "Senior executives",
    "choice_b": "Those with specific business continuity roles",
    "choice_c": "Everyone in the organization",
    "choice_d": "First responders",
    "correct_answer": "C",
    "explanation": "Everyone in the organization should receive a basic awareness training for the business continuity program. Those with specific roles, such as first responders and senior executives, should also receive detailed, role-specific training.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      648,
      650,
      649,
      79,
      85
    ],
    "source": ""
  },
  {
    "id": 684,
    "question": "Which one of the following components should be included in an organization's emergency response guidelines?",
    "choice_a": "List of individuals who should be notified of an emergency incident",
    "choice_b": "Long-term business continuity protocols",
    "choice_c": "Activation procedures for the organization's cold sites",
    "choice_d": "Contact information for ordering equipment",
    "correct_answer": "A",
    "explanation": "The emergency response guidelines should include the immediate steps an organization should follow in response to an emergency situation. These include immediate response procedures, a list of individuals who should be notified of the emergency and secondary response procedures for first responders. They do not include long-term actions such as activating business continuity protocols, ordering equipment, or activating DR sites.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      71,
      69,
      101,
      648
    ],
    "source": ""
  },
  {
    "id": 685,
    "question": "Alejandro is an incident response analyst for a large corporation. He is on the midnight shift when an intrusion detection system alerts him to a potential brute-force password attack against one of the company's critical information systems. He performs an initial triage of the event before taking any additional action. <br>What stage of the incident response process is Alejandro currently conducting?",
    "choice_a": "Detection",
    "choice_b": "Response",
    "choice_c": "Recovery",
    "choice_d": "Mitigation",
    "correct_answer": "A",
    "explanation": "Alejandro is in the first stage of the incident response process, detection. During this stage, the intrusion detection system provides the initial alert, and Alejandro performs preliminary triaging to determine whether an intrusion is actually taking place and whether the scenario fits the criteria for activating further steps of the incident response process (which include response, mitigation, reporting, recovery, remediation, and lessons learned).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      96,
      69,
      71,
      94
    ],
    "source": ""
  },
  {
    "id": 686,
    "question": "Alejandro is an incident response analyst for a large corporation. He is on the midnight shift when an intrusion detection system alerts him to a potential brute-force password attack against one of the company's critical information systems. He performs an initial triage of the event before taking any additional action. <br>If Alejandro's initial investigation determines that a security incident is likely taking place, what should be his next step?",
    "choice_a": "Investigate the root cause.",
    "choice_b": "File a written report.",
    "choice_c": "Activate the incident response team.",
    "choice_d": "Attempt to restore the system to normal operations.",
    "correct_answer": "C",
    "explanation": "After detection of a security incident, the next step in the process is response, which should follow the organization's formal incident response procedure. The first step of this procedure is activating the appropriate teams, including the organization's computer security incident response team (CSIRT).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      101,
      71,
      70,
      69
    ],
    "source": ""
  },
  {
    "id": 687,
    "question": "Alejandro is an incident response analyst for a large corporation. He is on the midnight shift when an intrusion detection system alerts him to a potential brute-force password attack against one of the company's critical information systems. He performs an initial triage of the event before taking any additional action. <br>As the incident response progresses, during which stage should the team conduct a root-cause analysis?",
    "choice_a": "Response",
    "choice_b": "Reporting",
    "choice_c": "Remediation",
    "choice_d": "Lessons learned",
    "correct_answer": "C",
    "explanation": "The root-cause analysis examines the incident to determine what allowed it to happen and provides critical information for repairing systems so that the incident does not recur. This is a component of the remediation step of the incident response process because the root cause analysis output is necessary to fully remediate affected systems and processes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      71,
      75,
      77,
      72,
      99
    ],
    "source": ""
  },
  {
    "id": 688,
    "question": "The Domer Industries risk assessment team recently conducted a qualitative risk assessment and developed a matrix similar to the one shown here. Which quadrant contains the risks that require the most immediate attention? <br><img src=\"/question_assets/SSCP/c04uf002.png\"/>",
    "choice_a": "I",
    "choice_b": "II",
    "choice_c": "III",
    "choice_d": "IV",
    "correct_answer": "A",
    "explanation": "The risk assessment team should pay the most immediate attention to those risks that appear in quadrant I. These are the risks with a high probability of occurring and a high impact on the organization if they do occur.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      77,
      68,
      72,
      79,
      101
    ],
    "source": ""
  },
  {
    "id": 689,
    "question": "Which one of the following stakeholders is not typically included on a business continuity planning team?",
    "choice_a": "Core business function leaders",
    "choice_b": "Information technology staff",
    "choice_c": "CEO",
    "choice_d": "Support departments",
    "correct_answer": "C",
    "explanation": "While senior management should be represented on the BCP team, it would be highly unusual for the CEO to fill this role personally.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      649,
      648,
      650,
      83,
      495
    ],
    "source": ""
  },
  {
    "id": 690,
    "question": "Craig is selecting the site for a new data center and must choose a location somewhere within the United States. He obtained the earthquake risk map shown here from the United States Geological Survey. Which of the following would be the safest location to build his facility if he were primarily concerned with earthquake risk? <br><img src=\"/question_assets/SSCP/c04uf003.png\"/> Image reprinted from <italic>CISSP ISC2 Certified Information Systems Security Professional Official Study Guide</italic>, 7th Edition \u00a9 John Wiley & Sons 2015, reprinted with permission.",
    "choice_a": "New York",
    "choice_b": "North Carolina",
    "choice_c": "Indiana",
    "choice_d": "Florida",
    "correct_answer": "D",
    "explanation": "Of the states listed, Florida is the only one that is not shaded to indicate a serious risk of a major earthquake.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      651,
      77,
      68,
      73,
      92
    ],
    "source": ""
  },
  {
    "id": 691,
    "question": "As part of his incident response process, Charles securely wipes the drive of a compromised machine and reinstalls the operating system (OS) from original media. Once he is done, he patches the machine fully and applies his organization's security templates before reconnecting the system to the network. Almost immediately after the system is returned to service, he discovers that it has reconnected to the same botnet it was part of before. Where should Charles look for the malware that is causing this behavior?",
    "choice_a": "The operating system partition",
    "choice_b": "The system BIOS or firmware",
    "choice_c": "The system memory",
    "choice_d": "The installation media",
    "correct_answer": "B",
    "explanation": "The system Charles is remediating may have a firmware or BIOS infection, with malware resident on the system board. While uncommon, this type of malware can be difficult to find and remove. Since he used original media, it is unlikely that the malware came from the software vendor. Charles wiped the system partition, and the system would have been rebooted before being rebuilt, thus, clearing system memory.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      88,
      87,
      84,
      92,
      99
    ],
    "source": ""
  },
  {
    "id": 692,
    "question": "As part of his team's forensic investigation process, Matt signs drives and other evidence out of storage before working with them. What type of documentation is he creating?",
    "choice_a": "Criminal",
    "choice_b": "Chain of custody",
    "choice_c": "Civil",
    "choice_d": "CYA",
    "correct_answer": "B",
    "explanation": "Matt is helping to maintain the chain of custody documentation for his electronic evidence. This can be important if his organization needs to prove that the digital evidence they handled has not been tampered with. A better process would involve more than one person to ensure that no tampering was possible.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      659,
      639,
      658,
      640,
      644
    ],
    "source": ""
  },
  {
    "id": 693,
    "question": "Karen's organization has been performing system backups for years but has not used the backups frequently. During a recent system outage, when administrators tried to restore from backups, they found that the backups had errors and could not be restored. Which of the following options should Karen avoid when selecting ways to ensure that her organization's backups will work next time?",
    "choice_a": "Log review",
    "choice_b": "MTD verification",
    "choice_c": "Hashing",
    "choice_d": "Periodic testing",
    "correct_answer": "B",
    "explanation": "Karen can't use MTD verification because MTD is the maximum tolerable downtime. Verifying it will only tell her how long systems can be offline without significant business impact. Reviewing logs, using hashing to verify that the logs are intact, and performing periodic tests are all valid ways to verify that the backups are working properly.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      656,
      647,
      72,
      84,
      94
    ],
    "source": ""
  },
  {
    "id": 694,
    "question": "Referring to the following figure, what technology is shown that provides fault tolerance for the database servers? <br><img src=\"/question_assets/SSCP/c04uf004.png\"/>",
    "choice_a": "Failover cluster",
    "choice_b": "UPS",
    "choice_c": "Tape backup",
    "choice_d": "Cold site",
    "correct_answer": "A",
    "explanation": "The illustration shows an example of a failover cluster, where DB1 and DB2 are both configured as database servers. At any given time, only one will function as the active database server, while the other remains ready to assume responsibility if the first one fails. While the environment may use UPS, tape backup, and cold sites as disaster recovery and business continuity controls, they are not shown in the diagram.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      645,
      519,
      495,
      496,
      87
    ],
    "source": ""
  },
  {
    "id": 695,
    "question": "Which one of the following tasks is performed by a forensic disk controller?",
    "choice_a": "Masking error conditions reported by the storage device",
    "choice_b": "Transmitting write commands to the storage device",
    "choice_c": "Intercepting and modifying or discarding commands sent to the storage device",
    "choice_d": "Preventing data from being returned by a read operation sent to the device",
    "correct_answer": "C",
    "explanation": "A forensic disk controller performs four functions. One of those, write blocking, intercepts write commands sent to the device and prevents them from modifying data on the device. The other three functions include returning data requested by a read operation, returning access-significant information from the device, and reporting errors from the device back to the forensic host.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      639,
      641,
      640,
      632,
      631
    ],
    "source": ""
  },
  {
    "id": 696,
    "question": "Glenda would like to conduct a disaster recovery test and is seeking a test that will allow a review of the plan with no disruption to normal information system activities and as minimal a commitment of time as possible. What type of test should she choose?",
    "choice_a": "Tabletop exercise",
    "choice_b": "Parallel test",
    "choice_c": "Full interruption test",
    "choice_d": "Checklist review",
    "correct_answer": "D",
    "explanation": "The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems. During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      655,
      656,
      654,
      495,
      653
    ],
    "source": ""
  },
  {
    "id": 697,
    "question": "Which one of the following is not an example of a backup tape rotation scheme?",
    "choice_a": "Grandfather/Father/Son",
    "choice_b": "Meet-in-the-middle",
    "choice_c": "Tower of Hanoi",
    "choice_d": "Six Cartridge Weekly",
    "correct_answer": "B",
    "explanation": "The Grandfather/Father/Son, Tower of Hanoi, and Six Cartridge Weekly schemes are all different approaches to rotating backup media that balance reuse of media with data retention concerns. Meet-in-the-middle is a cryptographic attack against 2DES encryption.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      653,
      497,
      521,
      90,
      79
    ],
    "source": ""
  },
  {
    "id": 698,
    "question": "Which one of the following is not a requirement for evidence to be admissible in court?",
    "choice_a": "The evidence must be relevant.",
    "choice_b": "The evidence must be material.",
    "choice_c": "The evidence must be tangible.",
    "choice_d": "The evidence must be competent.",
    "correct_answer": "C",
    "explanation": "Evidence provided in court must be relevant to determining a fact in question, material to the case at hand, and competently obtained. Evidence does not need to be tangible. Witness testimony is an example of intangible evidence that may be offered in court.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      657,
      658,
      659,
      639,
      640
    ],
    "source": ""
  },
  {
    "id": 699,
    "question": "Sam is responsible for backing up his company's primary file server. He configured a backup schedule that performs full backups every Monday evening at 9 p.m. and differential backups on other days of the week at that same time. Files change according to the information shown in the following figure. How many files will be copied in Wednesday's backup? <br><img src=\"/question_assets/SSCP/c04uf005.png\"/>",
    "choice_a": "2",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "6",
    "correct_answer": "C",
    "explanation": "In this scenario, all of the files on the server will be backed up on Monday evening during the full backup. The differential backup on Wednesday will then copy all files modified since the last full backup. These include files 1, 2, 3, 5, and 6: a total of five files.<br><img src=\"/question_assets/SSCP/c04uf006.png\"/>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      87,
      79,
      632,
      94,
      84
    ],
    "source": ""
  },
  {
    "id": 700,
    "question": "Tim is a forensic analyst who is attempting to retrieve information from a hard drive. It appears that the user attempted to erase the data, and Tim is trying to reconstruct it. What type of forensic analysis is Tim performing?",
    "choice_a": "Software analysis",
    "choice_b": "Media analysis",
    "choice_c": "Embedded device analysis",
    "choice_d": "Network analysis",
    "correct_answer": "B",
    "explanation": "The scrutiny of hard drives for forensic purposes is an example of media analysis. Embedded device analysis looks at the computers included in other large systems, such as automobiles or security systems. Software analysis analyzes applications and their logs. Network analysis looks at network traffic and logs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      640,
      641,
      632,
      631,
      713
    ],
    "source": ""
  },
  {
    "id": 701,
    "question": "Which one of the following is an example of a computer security incident?",
    "choice_a": "Completion of a backup schedule",
    "choice_b": "System access recorded in a log",
    "choice_c": "Unauthorized vulnerability scan of a file server",
    "choice_d": "Update of antivirus signatures",
    "correct_answer": "C",
    "explanation": "Security incidents negatively affect the confidentiality, integrity, or availability of information or assets and/or violate a security policy. The unauthorized vulnerability scan of a server does violate security policy and may negatively affect the security of that system, so it qualifies as a security incident. The completion of a backup schedule, logging of system access, and update of antivirus signatures are all routine actions that do not violate policy or jeopardize security, so they are all events rather than incidents.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      75,
      72,
      77,
      101,
      84
    ],
    "source": ""
  },
  {
    "id": 702,
    "question": "Florian is building a disaster recovery plan for his organization and would like to determine the amount of time that a particular IT service may be down without causing serious damage to business operations. What variable is Florian calculating?",
    "choice_a": "RTO",
    "choice_b": "MTD",
    "choice_c": "RPO",
    "choice_d": "SLA",
    "correct_answer": "B",
    "explanation": "The maximum tolerable downtime (MTD) is the longest amount of time that an IT service or component may be unavailable without causing serious damage to the organization. The recovery time objective (RTO) is the amount of time expected to return an IT service or component to operation after a failure. The recovery point objective (RPO) identifies the maximum amount of data, measured in time, that may be lost during a recovery effort. Service-level agreements (SLAs) are written contracts that document service expectations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      496,
      495,
      654,
      653,
      656
    ],
    "source": ""
  },
  {
    "id": 703,
    "question": "During an incident investigation, investigators meet with a system administrator who may have information about the incident but is not a suspect. What type of conversation is taking place during this meeting?",
    "choice_a": "Interview",
    "choice_b": "Interrogation",
    "choice_c": "Both an interview and an interrogation",
    "choice_d": "Neither an interview nor an interrogation",
    "correct_answer": "A",
    "explanation": "Interviews occur when investigators meet with an individual who may have information relevant to their investigation but is not a suspect. If the individual is a suspect, then the meeting is an interrogation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      660,
      661,
      99,
      100,
      71
    ],
    "source": ""
  },
  {
    "id": 704,
    "question": "Veronica is considering the implementation of a database recovery mechanism recommended by a consultant. In the recommended approach, an automated process will move database backups from the primary facility to an off-site location each night. What type of database recovery technique is the consultant describing?",
    "choice_a": "Remote journaling",
    "choice_b": "Remote mirroring",
    "choice_c": "Electronic vaulting",
    "choice_d": "Transaction logging",
    "correct_answer": "C",
    "explanation": "In an electronic vaulting approach, automated technology moves database backups from the primary database server to a remote site on a scheduled basis, typically daily. Transaction logging is not a recovery technique alone; it is a process for generating the logs used in remote journaling. Remote journaling transfers transaction logs to a remote site on a more frequent basis than electronic vaulting, typically hourly. Remote mirroring maintains a live database server at the backup site and mirrors all transactions at the primary site on the server at the backup site.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      497,
      654,
      656,
      653,
      77
    ],
    "source": ""
  },
  {
    "id": 705,
    "question": "Which one of the following events marks the completion of a disaster recovery process?",
    "choice_a": "Securing property and life safety",
    "choice_b": "Restoring operations in an alternate facility",
    "choice_c": "Restoring operations in the primary facility",
    "choice_d": "Standing down first responders",
    "correct_answer": "C",
    "explanation": "The end goal of the disaster recovery process is restoring normal business operations in the primary facility. All of the other actions listed may take place during the disaster recovery process, but the process is not complete until the organization is once again functioning normally in its primary facilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      495,
      653,
      654,
      650,
      638
    ],
    "source": ""
  },
  {
    "id": 706,
    "question": "During what phase of the incident response process do administrators take action to limit the effect or scope of an incident?",
    "choice_a": "Detection",
    "choice_b": "Response",
    "choice_c": "Mitigation",
    "choice_d": "Recovery",
    "correct_answer": "C",
    "explanation": "The Mitigation phase of incident response focuses on actions that can contain the damage incurred during an incident. This includes limiting the scope and or effectiveness of the incident.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      71,
      69,
      70,
      96
    ],
    "source": ""
  },
  {
    "id": 707,
    "question": "Greg is redesigning his organization's incident response process, seeking to improve its efficiency and effectiveness.  Which one of the following actions is not likely to improve his incident response plan?",
    "choice_a": "Create a mentoring program for technical staff",
    "choice_b": "Provide team members with opportunities to work on other tasks",
    "choice_c": "Keep all members of the team on permanent assignment to the team",
    "choice_d": "Conduct training exercises for the team",
    "correct_answer": "C",
    "explanation": "The National Institute for Standards and Technologies recommends that organizations implement a mentoring program for incident response team members and provide team members with the opportunity to work on other tasks.  They also recommend periodic exercises to evaluate the team's effectiveness.  Rather than assigning all members of the team on a permanent basis, NIST recommends rotating members on and off the team periodically.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      655,
      650,
      71,
      99,
      85
    ],
    "source": ""
  },
  {
    "id": 708,
    "question": "Gordon suspects that a hacker has penetrated a system belonging to his company. The system does not contain any regulated information, andss Gordon wants to conduct an investigation on behalf of his company. He has permission from his supervisor to conduct the investigation. Which of the following statements is true?",
    "choice_a": "Gordon is legally required to contact law enforcement before beginning the investigation.",
    "choice_b": "Gordon may not conduct his own investigation.",
    "choice_c": "Gordon's investigation may include examining the contents of hard disks, network traffic, and any other systems or information belonging to the company.",
    "choice_d": "Gordon may ethically perform \u201chack back\u201d activities after identifying the perpetrator.",
    "correct_answer": "C",
    "explanation": "Gordon may conduct his investigation as he wants and use any information that is legally available to him, including information and systems belonging to his employer. There is no obligation to contact law enforcement. However, Gordon may not perform \u201chack back\u201d activities because those may constitute violations of the law and/or ISC2 Code of Ethics.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      71,
      99,
      81,
      100,
      68
    ],
    "source": ""
  },
  {
    "id": 709,
    "question": "You are performing an investigation into a potential bot infection on your network and want to perform a forensic analysis of the information that passed between different systems on your network and those on the Internet. You believe that the information was likely encrypted. You are beginning your investigation after the activity concluded. What would be the best and easiest way to obtain the source of this information?",
    "choice_a": "Packet captures",
    "choice_b": "Netflow data",
    "choice_c": "Intrusion detection system logs",
    "choice_d": "Centralized authentication records",
    "correct_answer": "B",
    "explanation": "Netflow data contains information on the source, destination, and size of all network communications and is routinely saved as a matter of normal activity. Packet capture data would provide relevant information, but it must be captured during the suspicious activity and cannot be re-created after the fact unless the organization is already conducting 100 percent packet capture, which is rare. Additionally, the use of encryption limits the effectiveness of packet capture. Intrusion detection system logs would not likely contain relevant information because the encrypted traffic would probably not match intrusion signatures. Centralized authentication records would not contain information about network traffic.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      95,
      99,
      90,
      96,
      80
    ],
    "source": ""
  },
  {
    "id": 710,
    "question": "What type of disaster recovery test activates the alternate processing facility and uses it to conduct transactions but leaves the primary site up and running?",
    "choice_a": "Full interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Checklist review",
    "choice_d": "Tabletop exercise",
    "correct_answer": "B",
    "explanation": "During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      656,
      654,
      655,
      495,
      653
    ],
    "source": ""
  },
  {
    "id": 711,
    "question": "During which phase of the incident response process would an analyst receive an intrusion detection system alert and verify its accuracy?",
    "choice_a": "Response",
    "choice_b": "Mitigation",
    "choice_c": "Detection",
    "choice_d": "Reporting",
    "correct_answer": "C",
    "explanation": "Both the receipt of alerts and the verification of their accuracy occur during the Detection phase of the incident response process.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      96,
      97,
      711,
      94
    ],
    "source": ""
  },
  {
    "id": 712,
    "question": "In what virtualization model do full guest operating systems run on top of a virtualization platform?",
    "choice_a": "Virtual machines",
    "choice_b": "Software-defined networking",
    "choice_c": "Virtual SAN",
    "choice_d": "Application virtualization",
    "correct_answer": "A",
    "explanation": "Virtual machines run full guest operating systems on top of a host platform known as the hypervisor.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 713,
    "question": "During what phase of the incident response process would security professionals analyze the process itself to determine whether any improvements are warranted?",
    "choice_a": "Lessons learned",
    "choice_b": "Remediation",
    "choice_c": "Recovery",
    "choice_d": "Reporting",
    "correct_answer": "A",
    "explanation": "During the lessons learned phase, analysts close out an incident by conducting a review of the entire incident response process. This may include making recommendations for improvements to the process that will streamline the efficiency and effectiveness of future incident response efforts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      71,
      99,
      101,
      661,
      96
    ],
    "source": ""
  },
  {
    "id": 714,
    "question": "Which one of the following information sources is most likely to detect a security incident involving unauthorized modification of information by an employee?",
    "choice_a": "Intrusion detection system",
    "choice_b": "Antivirus software",
    "choice_c": "File integrity monitoring system",
    "choice_d": "Firewall logs",
    "correct_answer": "C",
    "explanation": "In this case, the person perpretrating the security incident is an employee.  This person is likely able to bypass many of the organization's security controls and the activity would not likely be identified by an intrusion detection system or firewall logs.  There is no mention of malicious software, so antivirus software would also be unlikely to detect the issue.  However, file integrity monitoring systems would likely detect the unauthorized data modification.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      91,
      84,
      94,
      99,
      96
    ],
    "source": ""
  },
  {
    "id": 715,
    "question": "During what phase of incident response is the primary goal to limit the damage caused by an incident?",
    "choice_a": "Detection",
    "choice_b": "Containment",
    "choice_c": "Eradication",
    "choice_d": "Recovery",
    "correct_answer": "B",
    "explanation": "During the containment phase, the incident response team's goal is to limit the damage caused by an incident.  They do this by isolating impacted systems and restricting access to resources to prevent the spread of the incident.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      99,
      69,
      70,
      71,
      72
    ],
    "source": ""
  },
  {
    "id": 716,
    "question": "Darcy is a computer security specialist who is assisting with the prosecution of a hacker. The prosecutor requests that Darcy give testimony in court about whether, in her opinion, the logs and other records in a case are indicative of a hacking attempt. What type of evidence is Darcy being asked to provide?",
    "choice_a": "Expert opinion",
    "choice_b": "Direct evidence",
    "choice_c": "Real evidence",
    "choice_d": "Documentary evidence",
    "correct_answer": "A",
    "explanation": "Expert opinion evidence allows individuals to offer their opinion based upon the facts in evidence and their personal knowledge. Expert opinion evidence may be offered only if the court accepts the witness as an expert in a particular field. Direct evidence is when witnesses testify about their direct observations. Real evidence consists of tangible items brought into court as evidence. Documentary evidence consists of written records used as evidence in court.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      657,
      658,
      662,
      659,
      643
    ],
    "source": ""
  },
  {
    "id": 717,
    "question": "Jerome is conducting a forensic investigation and is reviewing database server logs to investigate query contents for evidence of SQL injection attacks. What type of analysis is he performing?",
    "choice_a": "Hardware analysis",
    "choice_b": "Software analysis",
    "choice_c": "Network analysis",
    "choice_d": "Media analysis",
    "correct_answer": "B",
    "explanation": "The analysis of application logs is one of the core tasks of software analysis. This is the correct answer because SQL injection attacks are application attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      711,
      713,
      96,
      658,
      659
    ],
    "source": ""
  },
  {
    "id": 718,
    "question": "What documentation is typically prepared after a postmortem review of an incident has been completed?",
    "choice_a": "A lessons learned document",
    "choice_b": "A risk assessment",
    "choice_c": "A remediation list",
    "choice_d": "A mitigation checklist",
    "correct_answer": "A",
    "explanation": "A lessons learned document is often created and distributed to involved parties after a postmortem review to ensure that those who were involved in the incident and others who may benefit from the knowledge are aware of what they can do to prevent future issues and to improve response in the event that one occurs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      71,
      69,
      99,
      101,
      655
    ],
    "source": ""
  },
  {
    "id": 719,
    "question": "Ed has been tasked with identifying a service that will provide a low-latency, high-performance, and high-availability way to host content for his employer. What type of solution should he seek out to ensure that his employer's customers around the world can access their content quickly, easily, and reliably?",
    "choice_a": "A hot site",
    "choice_b": "A CDN",
    "choice_c": "Redundant servers",
    "choice_d": "A P2P CDN",
    "correct_answer": "B",
    "explanation": "A content distribution network (CDN) is designed to provide reliable, low-latency, geographically distributed content distribution. In this scenario, a CDN is an ideal solution. A P2P CDN like BitTorrent isn't a typical choice for a commercial entity, whereas redundant servers or a hot site can provide high availability but won't provide the remaining requirements.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      654,
      496,
      497,
      653,
      496
    ],
    "source": ""
  },
  {
    "id": 720,
    "question": "Who is the ideal person to approve an organization's business continuity plan?",
    "choice_a": "Chief information officer",
    "choice_b": "Chief executive officer",
    "choice_c": "Chief information security officer",
    "choice_d": "Chief operating officer",
    "correct_answer": "B",
    "explanation": "Although the CEO will not normally serve on a BCP team, it is best to obtain top-level management approval for your plan to increase the likelihood of successful adoption.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      648,
      649,
      83,
      101,
      79
    ],
    "source": ""
  },
  {
    "id": 721,
    "question": "Which one of the following actions is not normally part of the project scope and planning phase of business continuity planning?",
    "choice_a": "Structured analysis of the organization",
    "choice_b": "Review of the legal and regulatory landscape",
    "choice_c": "Creation of a BCP team",
    "choice_d": "Documentation of the plan",
    "correct_answer": "D",
    "explanation": "The project scope and planning phase includes four actions: a structured analysis of the organization, the creation of a BCP team, an assessment of available resources, and an analysis of the legal and regulatory landscape.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      648,
      649,
      651,
      495,
      72
    ],
    "source": ""
  },
  {
    "id": 722,
    "question": "Carla's organization recently suffered a data breach when an employee misplaced a laptop containing sensitive customer information. Which one of the following controls would be <italic>least</italic> likely to prevent this type of breach from reoccurring in the future?",
    "choice_a": "Full disk encryption",
    "choice_b": "File encryption",
    "choice_c": "File integrity monitoring",
    "choice_d": "Data minimization",
    "correct_answer": "C",
    "explanation": "Protecting the sensitive information with either full disk encryption or file encryption would render it unreadable to anyone finding the device. Data minimization would involve the removal of sensitive information from the device. File integrity monitoring would detect any changes in information stored on the device but would not protect against data loss.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      666,
      665,
      153,
      663
    ],
    "source": ""
  },
  {
    "id": 723,
    "question": "Margot is considering the use of a self-signed certificate to reduce the costs associated with maintaining a public-facing web server. What is the primary risk associated with the use of self-signed certificates?",
    "choice_a": "Self-signed certificates use weak encryption.",
    "choice_b": "Self-signed certificates are not trusted by default.",
    "choice_c": "Self-signed certificates have short expiration periods.",
    "choice_d": "Self-signed certificates cannot be used with most browsers.",
    "correct_answer": "B",
    "explanation": "Self-signed certificates are functionally equivalent to those purchased from a trusted certificate authority. The fundamental difference is that they don't carry the trusted signature of a CA and, therefore, won't be trusted by web browsers by default. They are generally only appropriate for internal use.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      673,
      674,
      522,
      524
    ],
    "source": ""
  },
  {
    "id": 724,
    "question": "Which one of the following cryptographic systems is most closely associated with the Web of Trust?",
    "choice_a": "RC4",
    "choice_b": "SHA",
    "choice_c": "AES",
    "choice_d": "PGP",
    "correct_answer": "D",
    "explanation": "Phil Zimmerman's Pretty Good Privacy (PGP) software is an encryption technology based upon the Web of Trust (WoT). This approach extends the social trust relationship to encryption keys.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      522,
      524,
      672,
      674,
      663
    ],
    "source": ""
  },
  {
    "id": 725,
    "question": "Kevin is an internal auditor at a major retailer and would like to ensure that the information contained in audit logs is not changed after it is created. Which one of the following controls would best meet his goal?",
    "choice_a": "Cryptographic hashing",
    "choice_b": "Data loss prevention",
    "choice_c": "File encryption",
    "choice_d": "Certificate management",
    "correct_answer": "A",
    "explanation": "Kevin can take a cryptographic hash of the log files when they are created and then later repeat the use of the same hash function and compare the two hash values. If the hash values are identical, Kevin can be confident that the file was not altered.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      665,
      663,
      668,
      156,
      159
    ],
    "source": ""
  },
  {
    "id": 726,
    "question": "Greg is designing a defense-in-depth approach to securing his organization's information and would like to select cryptographic tools that are appropriate for different use cases and provide strong encryption. Which one of the following pairings is the best use of encryption tools?",
    "choice_a": "SSL for data in motion and AES for data at rest",
    "choice_b": "SSL for data in motion and AES for data at rest",
    "choice_c": "TLS for data in motion and AES for data at rest",
    "choice_d": "SSL for data in motion and TLS for data at rest",
    "correct_answer": "C",
    "explanation": "Secure Sockets Layer (SSL), Transport Layer Security (TLS), and virtual private networks (VPNs) are all used to protect data in motion. AES cryptography may be used to protect data at rest. SSL is no longer considered secure, so it is not a good choice for Greg. The only answer choice that matches each tool with the appropriate type of information and does not use SSL is using TLS for data in motion and AES for data at rest.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      128,
      124,
      666,
      668
    ],
    "source": ""
  },
  {
    "id": 727,
    "question": "Max is the security administrator for an organization that uses a remote access VPN. The VPN depends upon RADIUS authentication, and Max would like to assess the security of that service. Which one of the following hash functions is the strongest cryptographic hash protocol supported by RADIUS?",
    "choice_a": "MD5",
    "choice_b": "SHA 2",
    "choice_c": "SHA-512",
    "choice_d": "HMAC",
    "correct_answer": "A",
    "explanation": "Unfortunately, the RADIUS protocol only supports the weak MD5 hash function. This is the major criticism of the RADIUS protocol. Most organizations require that RADIUS be protected with additional encryption to compensate for this vulnerability.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      128,
      663,
      133,
      665,
      104
    ],
    "source": ""
  },
  {
    "id": 728,
    "question": "Angela is an information security architect at a bank and has been assigned to ensure that transactions are secure as they traverse the network. She recommends that all transactions use TLS. What threat is she most likely attempting to stop, and what method is she using to protect against it?",
    "choice_a": "Man-in-the-middle, VPN",
    "choice_b": "Packet injection, encryption",
    "choice_c": "Sniffing, encryption",
    "choice_d": "Sniffing, TEMPEST",
    "correct_answer": "C",
    "explanation": "Encryption is often used to protect traffic like bank transactions from sniffing. While packet injection and man-in-the-middle attacks are possible, they are far less likely to occur, and if a VPN were used, it would be used to provide encryption. TEMPEST is a specification for techniques used to prevent spying using electromagnetic emissions and wouldn't be used to stop attacks at any normal bank.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      128,
      147,
      116,
      106,
      104
    ],
    "source": ""
  },
  {
    "id": 729,
    "question": "Your organization regularly handles three types of data: information that it shares with customers, information that it uses internally to conduct business, and trade secret information that offers the organization significant competitive advantages. Information shared with customers is used and stored on web servers, while both the internal business data and the trade secret information are stored on internal file servers and employee workstations. <br>What civilian data classifications best fit this data?",
    "choice_a": "Unclassified, confidential, top secret",
    "choice_b": "Public, sensitive, private",
    "choice_c": "Public, sensitive, proprietary",
    "choice_d": "Public, confidential, private",
    "correct_answer": "C",
    "explanation": "Information shared with customers is public, internal business could be sensitive or private, and trade secrets are proprietary. Thus, public, sensitive, proprietary matches this most closely. Confidential is a military classification, which removes two of the remaining options, and trade secrets are more damaging to lose than a private classification would allow.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      105,
      104,
      668,
      107,
      669
    ],
    "source": ""
  },
  {
    "id": 730,
    "question": "Your organization regularly handles three types of data: information that it shares with customers, information that it uses internally to conduct business, and trade secret information that offers the organization significant competitive advantages. Information shared with customers is used and stored on web servers, while both the internal business data and the trade secret information are stored on internal file servers and employee workstations. <br>What technique could you use to mark your trade secret information in case it was released or stolen and you need to identify it?",
    "choice_a": "Classification",
    "choice_b": "Symmetric encryption",
    "choice_c": "Watermarks",
    "choice_d": "Metadata",
    "correct_answer": "C",
    "explanation": "A watermark is used to digitally label data and can be used to indicate ownership. Encryption would have prevented the data from being accessed if it was lost, while classification is part of the set of security practices that can help make sure the right controls are in place. Finally, metadata is used to label data and might help a data loss prevention system flag it before it leaves your organization.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      153,
      669,
      670,
      667
    ],
    "source": ""
  },
  {
    "id": 731,
    "question": "Your organization regularly handles three types of data: information that it shares with customers, information that it uses internally to conduct business, and trade secret information that offers the organization significant competitive advantages. Information shared with customers is used and stored on web servers, while both the internal business data and the trade secret information are stored on internal file servers and employee workstations. <br>What type of encryption should you use on the file servers for the proprietary data, and how might you secure the data when it is in motion?",
    "choice_a": "TLS at rest and AES in motion",
    "choice_b": "AES at rest and TLS in motion",
    "choice_c": "VPN at rest and TLS in motion",
    "choice_d": "DES at rest and AES in motion",
    "correct_answer": "B",
    "explanation": "AES is a strong modern symmetric encryption algorithm that is appropriate for encrypting data at rest. TLS is frequently used to secure data when it is in transit. A virtual private network is not necessarily an encrypted connection and would be used for data in motion, while DES is an outdated algorithm and should not be used for data that needs strong security.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      666,
      107,
      117,
      104
    ],
    "source": ""
  },
  {
    "id": 732,
    "question": "The following diagram shows a typical workstation and server and their connections to each other and the Internet. <br><img src=\"/question_assets/SSCP/c05uf001.png\"/>Which letters on this diagram are locations where you might find data at rest?",
    "choice_a": "A, B, and C",
    "choice_b": "C and E",
    "choice_c": "A and E",
    "choice_d": "B, D, and F",
    "correct_answer": "C",
    "explanation": "A and E can both be expected to have data at rest. C, the Internet, is an unknown, and the data can't be guaranteed to be at rest. B, D, and F are all data in transit across network links.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      666,
      667,
      668,
      107,
      110
    ],
    "source": ""
  },
  {
    "id": 733,
    "question": "The following diagram shows a typical workstation and server and their connections to each other and the Internet. <br><img src=\"/question_assets/SSCP/c05uf001.png\"/>What would be the best way to secure data at points B, D, and F?",
    "choice_a": "AES-256",
    "choice_b": "SSL",
    "choice_c": "TLS",
    "choice_d": "3DES",
    "correct_answer": "C",
    "explanation": "B, D, and F all show network links. Of the answers provided, Transport Layer Security (TLS) provides the best security for data in motion. AES-256 and 3DES are both symmetric ciphers and are more likely to be used for data at rest. SSL has been replaced with TLS and should not be a preferred solution.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      121,
      124,
      147,
      117
    ],
    "source": ""
  },
  {
    "id": 734,
    "question": "The following diagram shows a typical workstation and server and their connections to each other and the Internet. <br><img src=\"/question_assets/SSCP/c05uf001.png\"/>What is the best way to secure files that are sent from workstation A via the Internet service (C) to remote server E?",
    "choice_a": "Use AES at rest at point A, and use TLS in transit via B and D.",
    "choice_b": "Encrypt the data files and send them.",
    "choice_c": "Use 3DES and TLS to provide double security.",
    "choice_d": "Use full disk encryption at A and E, and use SSL at B and D.",
    "correct_answer": "B",
    "explanation": "Sending a file that is encrypted before it leaves means that exposure of the file in transit will not result in a confidentiality breach, and the file will remain secure until decrypted at location E. Since answers A, C, and D do not provide any information about what happens at point C, they should be considered insecure, as the file may be at rest at point C in an unencrypted form.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      666,
      124,
      116,
      128
    ],
    "source": ""
  },
  {
    "id": 735,
    "question": "What scenario describes data at rest?",
    "choice_a": "Data in an IPSec tunnel",
    "choice_b": "Data in an e-commerce transaction",
    "choice_c": "Data stored on a hard drive",
    "choice_d": "Data stored in RAM",
    "correct_answer": "C",
    "explanation": "Data at rest is inactive data that is physically stored. Data in an IPsec tunnel or part of an e-commerce transaction is data in motion. Data in RAM is ephemeral and is not inactive.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      666,
      668,
      667,
      107,
      128
    ],
    "source": ""
  },
  {
    "id": 736,
    "question": "What problem with FTP and Telnet makes using SFTP and SSH better alternatives?",
    "choice_a": "FTP and Telnet aren't installed on many systems.",
    "choice_b": "FTP and Telnet do not encrypt data.",
    "choice_c": "FTP and Telnet have known bugs and are no longer maintained.",
    "choice_d": "FTP and Telnet are difficult to use, making SFTP and SSH the preferred solution.",
    "correct_answer": "B",
    "explanation": "FTP and Telnet do not provide encryption for the data they transmit and should not be used if they can be avoided. SFTP and SSH provide encryption to protect both the data they send and the credentials that are used to log in via both utilities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      128,
      111,
      116,
      149
    ],
    "source": ""
  },
  {
    "id": 737,
    "question": "Information maintained about an individual that can be used to distinguish or trace their identity is known as what type of information?",
    "choice_a": "Personally identifiable information (PII)",
    "choice_b": "Personal health information (PHI)",
    "choice_c": "Social Security number (SSN)",
    "choice_d": "Secure identity information (SII)",
    "correct_answer": "A",
    "explanation": "NIST Special Publication 800-122 defines PII as any information that can be used to distinguish or trace an individual's identity, such as name, Social Security number, date and place of birth, mother's maiden name, biometric records, and other information that is linked or linkable to an individual such as medical, educational, financial, and employment information. PHI is health-related information about a specific person, Social Security numbers are issued to individuals in the United States, and SII is a made-up term.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      669,
      670,
      671,
      104,
      105
    ],
    "source": ""
  },
  {
    "id": 738,
    "question": "The healthcare company that Lauren works for handles HIPAA data as well as internal business data, protected health information, and day-to-day business communications. Its internal policy uses the following requirements for securing HIPAA data at rest and in transit. <br><img src=\"/question_assets/SSCP/5_image2.png\"/>What encryption technology would be appropriate for HIPAA documents in transit?",
    "choice_a": "BitLocker",
    "choice_b": "DES",
    "choice_c": "TLS",
    "choice_d": "SSL",
    "correct_answer": "C",
    "explanation": "TLS is a modern encryption method used to encrypt and protect data in transit. BitLocker is a full disk encryption technology used for data at rest. DES and SSL are both outdated encryption methods and should not be used for data that requires high levels of security.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      666,
      668,
      147,
      104
    ],
    "source": ""
  },
  {
    "id": 739,
    "question": "What encryption algorithm is used by both BitLocker and Microsoft's Encrypting File System?",
    "choice_a": "Blowfish",
    "choice_b": "Serpent",
    "choice_c": "AES",
    "choice_d": "3DES",
    "correct_answer": "C",
    "explanation": "By default, BitLocker and Microsoft's Encrypting File System (EFS) both use AES (Advanced Encryption Standard), which is the NIST-approved replacement for DES (Data Encryption Standard). Serpent was a competitor of AES, and 3DES was created as a possible replacement for DES.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      499,
      130,
      128,
      116
    ],
    "source": ""
  },
  {
    "id": 740,
    "question": "Which attack helped drive vendors to move away from SSL toward TLS-only by default?",
    "choice_a": "POODLE",
    "choice_b": "Stuxnet",
    "choice_c": "BEAST",
    "choice_d": "CRIME",
    "correct_answer": "A",
    "explanation": "The POODLE (or Padding Oracle On Downgraded Legacy Encryption) attack helped force the move from SSL 3.0 to TLS because it allowed attackers to easily access SSL encrypted messages. Stuxnet was a worm aimed at the Iranian nuclear program, while CRIME and BEAST were earlier attacks against SSL.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      147,
      128,
      107,
      103,
      108
    ],
    "source": ""
  },
  {
    "id": 741,
    "question": "What security measure can provide an additional security control in the event that backup tapes are stolen or lost?",
    "choice_a": "Keep multiple copies of the tapes.",
    "choice_b": "Replace tape media with hard drives.",
    "choice_c": "Use appropriate security labels.",
    "choice_d": "Use AES-256 encryption.",
    "correct_answer": "D",
    "explanation": "Using strong encryption, like AES-256, can help ensure that loss of removable media like tapes doesn't result in a data breach. Security labels may help with handling processes, but they won't help once the media is stolen or lost. Having multiple copies will ensure that you can still access the data but won't increase the security of the media. Finally, using hard drives instead of tape only changes the media type and not the risk from theft or loss.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      666,
      664,
      107,
      105
    ],
    "source": ""
  },
  {
    "id": 742,
    "question": "Joe works at a major pharmaceutical research and development company and has been tasked with writing his organization's data retention policy. As part of its legal requirements, the organization must comply with the U.S. Food and Drug Administration's Code of Federal Regulations Title 21. To do so, it is required to retain records with electronic signatures. Why would a signature be part of a retention requirement?",
    "choice_a": "It ensures that someone has reviewed the data.",
    "choice_b": "It provides confidentiality.",
    "choice_c": "It ensures that the data has not been changed.",
    "choice_d": "It validates who approved the data.",
    "correct_answer": "D",
    "explanation": "Electronic signatures, as used in this rule, prove that the signature was provided by the intended signer. Electronic signatures as part of the FDA code are intended to ensure that electronic records are \u201ctrustworthy, reliable, and generally equivalent to paper records and handwritten signatures executed on paper.\u201d Signatures cannot provide confidentiality or integrity and don't ensure that someone has reviewed the data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      105,
      106,
      107,
      668
    ],
    "source": ""
  },
  {
    "id": 743,
    "question": "What protocol is preferred over Telnet for remote server administration via the command line?",
    "choice_a": "SCP",
    "choice_b": "SFTP",
    "choice_c": "WDS",
    "choice_d": "SSH",
    "correct_answer": "D",
    "explanation": "Secure Shell (SSH) is an encrypted protocol for remote login and command-line access. SCP and SFTP are both secure file transfer protocols, while WDS is the acronym for Windows Deployment Services, which provides remote installation capabilities for Windows operating systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      122,
      108,
      117,
      149,
      104
    ],
    "source": ""
  },
  {
    "id": 744,
    "question": "What methods are often used to protect data in transit?",
    "choice_a": "Telnet, ISDN, UDP",
    "choice_b": "BitLocker, FileVault",
    "choice_c": "AES, Serpent, IDEA",
    "choice_d": "TLS, VPN, IPSec",
    "correct_answer": "D",
    "explanation": "Data in transit is data that is traversing a network or is otherwise in motion. TLS, VPNs, and IPsec tunnels are all techniques used to protect data in transit. AES, Serpent, and IDEA are all symmetric algorithms, while Telnet, ISDN, and UDP are all protocols. BitLocker and FileVault are both used to encrypt data, but they protect only stored data, not data in transit.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      128,
      668,
      110,
      103
    ],
    "source": ""
  },
  {
    "id": 745,
    "question": "Linux systems that use bcrypt are using a tool based on what DES alternative encryption scheme?",
    "choice_a": "3DES",
    "choice_b": "AES",
    "choice_c": "Diffie\u2013Hellman",
    "choice_d": "Blowfish",
    "correct_answer": "D",
    "explanation": "Bcrypt is based on Blowfish (the b is a key hint here). AES and 3DES are both replacements for DES, while Diffie-Hellman is a protocol for key exchange.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      500,
      498,
      668,
      672
    ],
    "source": ""
  },
  {
    "id": 746,
    "question": "Which one of the following is not considered PII under U.S. federal government regulations?",
    "choice_a": "Name",
    "choice_b": "Social Security number",
    "choice_c": "Student ID number",
    "choice_d": "ZIP code",
    "correct_answer": "D",
    "explanation": "Personally identifiable information includes any information that can uniquely identify an individual. This would include name, Social Security number, and any other unique identifier (including a student ID number). ZIP code, by itself, does not uniquely identify an individual.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      669,
      670,
      671,
      104,
      105
    ],
    "source": ""
  },
  {
    "id": 747,
    "question": "What encryption algorithm would provide strong protection for data stored on a USB thumb drive?",
    "choice_a": "TLS",
    "choice_b": "SHA1",
    "choice_c": "AES",
    "choice_d": "DES",
    "correct_answer": "C",
    "explanation": "AES is a strong symmetric cipher that is appropriate for use with data at rest. SHA1 is a cryptographic hash, while TLS is appropriate for data in motion. DES is an outdated and insecure symmetric encryption method.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      666,
      499,
      663,
      107
    ],
    "source": ""
  },
  {
    "id": 748,
    "question": "What type of encryption is typically used for data at rest?",
    "choice_a": "Asymmetric encryption",
    "choice_b": "Symmetric encryption",
    "choice_c": "DES",
    "choice_d": "OTP",
    "correct_answer": "B",
    "explanation": "Symmetric encryption like AES is typically used for data at rest. Asymmetric encryption is often used during transactions or communications when the ability to have public and private keys is necessary. DES is an outdated encryption standard, and OTP is the acronym for onetime password.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      666,
      107,
      124,
      104
    ],
    "source": ""
  },
  {
    "id": 749,
    "question": "Fred is preparing to send backup tapes off-site to a secure third-party storage facility. What steps should Fred take before sending the tapes to that facility?",
    "choice_a": "Ensure that the tapes are handled the same way the original media would be handled based on their classification.",
    "choice_b": "Increase the classification level of the tapes because they are leaving the possession of the company.",
    "choice_c": "Purge the tapes to ensure that classified data is not lost.",
    "choice_d": "Decrypt the tapes in case they are lost in transit.",
    "correct_answer": "A",
    "explanation": "Tapes are frequently exposed because of theft or loss in transit. That means that tapes that are leaving their normal storage facility should be handled according to the organization's classification schemes and handling requirements. Purging the tapes would cause the loss of data, while increasing the classification level of the tapes. The tapes should be encrypted rather than decrypted.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      666,
      498,
      500,
      667,
      105
    ],
    "source": ""
  },
  {
    "id": 750,
    "question": "Ed has been asked to send data that his organization classifies as confidential and proprietary via email. What encryption technology would be appropriate to ensure that the contents of the files attached to the email remain confidential as they traverse the Internet?",
    "choice_a": "SSL",
    "choice_b": "TLS",
    "choice_c": "PGP",
    "choice_d": "VPN",
    "correct_answer": "C",
    "explanation": "PGP, or Pretty Good Privacy (or its open source alternative, GPG), provides strong encryption of files, which can then be sent via email. Email traverses multiple servers and will be unencrypted at rest at multiple points along its path as it is stored and forwarded to its destination.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      107,
      666,
      668,
      124,
      128
    ],
    "source": ""
  },
  {
    "id": 751,
    "question": "Chris wants to verify that a software package that he downloaded matches the original version. What hashing tool should he use if he believes that technically sophisticated attackers may have replaced the software package with a version containing a backdoor?",
    "choice_a": "MD5",
    "choice_b": "3DES",
    "choice_c": "SHA1",
    "choice_d": "SHA 256",
    "correct_answer": "D",
    "explanation": "Intentional collisions have been created with MD5, and a real-world collision attack against SHA 1 was announced in early 2017. 3DES is not a hashing tool, leaving SHA 256 (sometimes called SHA 2) as the only real choice that Chris has in this list.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      663,
      664,
      499,
      104,
      116
    ],
    "source": ""
  },
  {
    "id": 752,
    "question": "What name is given to the random value added to a password in an attempt to defeat rainbow table attacks?",
    "choice_a": "Hash",
    "choice_b": "Salt",
    "choice_c": "Extender",
    "choice_d": "Rebar",
    "correct_answer": "B",
    "explanation": "The salt is a random value added to a password before it is hashed by the operating system. The salt is then stored in a password file with the hashed password. This increases the complexity of cryptanalytic attacks by negating the usefulness of attacks that use precomputed hash values, such as rainbow tables.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      750,
      751,
      752,
      499,
      665
    ],
    "source": ""
  },
  {
    "id": 753,
    "question": "Which one of the following is not an attribute of a hashing algorithm?",
    "choice_a": "They require a cryptographic key.",
    "choice_b": "They are irreversible.",
    "choice_c": "It is very difficult to find two messages with the same hash value.",
    "choice_d": "They take variable-length input.",
    "correct_answer": "A",
    "explanation": "Hash functions do not include any element of secrecy and, therefore, do not require a cryptographic key.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      663,
      750,
      498,
      499,
      124
    ],
    "source": ""
  },
  {
    "id": 754,
    "question": "Susan would like to configure IPsec in a manner that provides confidentiality for the content of packets. What component of IPsec provides this capability?",
    "choice_a": "AH",
    "choice_b": "ESP",
    "choice_c": "IKE",
    "choice_d": "ISAKMP",
    "correct_answer": "B",
    "explanation": "The Encapsulating Security Payload (ESP) protocol provides confidentiality and integrity for packet contents. It encrypts packet payloads and provides limited authentication and protection against replay attacks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      124,
      128,
      104,
      110,
      117
    ],
    "source": ""
  },
  {
    "id": 755,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>If Alice wants to send Bob an encrypted message, what key does she use to encrypt the message?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "C",
    "explanation": "In an asymmetric cryptosystem, the sender of a message always encrypts the message using the recipient's public key.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      522,
      524,
      664,
      104
    ],
    "source": ""
  },
  {
    "id": 756,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When Bob receives the encrypted message from Alice, what key does he use to decrypt the message?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "D",
    "explanation": "When Bob receives the message, he uses his own private key to decrypt it. Since he is the only one with his private key, he is the only one who should be able to decrypt it, thus, preserving confidentiality.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      500,
      498,
      524,
      104
    ],
    "source": ""
  },
  {
    "id": 757,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>Which one of the following keys would Bob not possess in this scenario?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "B",
    "explanation": "Each user retains their private key as secret information. In this scenario, Bob would only have access to his own private key and would not have access to the private key of Alice or any other user.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      522,
      524,
      500,
      498
    ],
    "source": ""
  },
  {
    "id": 758,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>Alice would also like to digitally sign the message that she sends to Bob. What key should she use to create the digital signature?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "B",
    "explanation": "Alice creates the digital signature using her own private key. Then Bob, or any other user, can verify the digital signature using Alice's public key.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      522,
      672,
      524,
      674
    ],
    "source": ""
  },
  {
    "id": 759,
    "question": "Which one of the following cryptographic goals protects against the risks posed when a device is lost or stolen?",
    "choice_a": "Nonrepudiation",
    "choice_b": "Authentication",
    "choice_c": "Integrity",
    "choice_d": "Confidentiality",
    "correct_answer": "D",
    "explanation": "The greatest risk when a device is lost or stolen is that sensitive data contained on the device will fall into the wrong hands. Confidentiality protects against this risk.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      105,
      498,
      663,
      664
    ],
    "source": ""
  },
  {
    "id": 760,
    "question": "How many bits of keying material does the Data Encryption Standard use for encrypting information?",
    "choice_a": "56 bits",
    "choice_b": "64 bits",
    "choice_c": "128 bits",
    "choice_d": "256 bits",
    "correct_answer": "A",
    "explanation": "DES uses a 64-bit encryption key, but only 56 of those bits are actually used as keying material in the encryption operation. The remaining 8 bits are used to detect tampering or corruption of the key.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      130
    ],
    "source": ""
  },
  {
    "id": 761,
    "question": "Florian and Tobias would like to begin communicating using a symmetric cryptosystem, but they have no prearranged secret and are not able to meet in person to exchange keys. What algorithm can they use to securely exchange the secret key?",
    "choice_a": "IDEA",
    "choice_b": "Diffie-Hellman",
    "choice_c": "RSA",
    "choice_d": "MD5",
    "correct_answer": "B",
    "explanation": "The Diffie-Hellman algorithm allows for the secure exchange of symmetric encryption keys over a public network.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      128,
      104,
      103,
      106
    ],
    "source": ""
  },
  {
    "id": 762,
    "question": "Which one of the following is not one of the basic requirements for a cryptographic hash\u00a0function?",
    "choice_a": "The function must work on fixed-length input.",
    "choice_b": "The function must be relatively easy to compute for any input.",
    "choice_c": "The function must be one way.",
    "choice_d": "The function must be collision free.",
    "correct_answer": "A",
    "explanation": "Hash functions must be able to work on any variable-length input and produce a fixed-length output from that input, regardless of the length of the input.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      663,
      665,
      750,
      499,
      124
    ],
    "source": ""
  },
  {
    "id": 763,
    "question": "How many possible keys exist for a cipher that uses a key containing 5 bits?",
    "choice_a": "10",
    "choice_b": "16",
    "choice_c": "32",
    "choice_d": "64",
    "correct_answer": "C",
    "explanation": "Binary keyspaces contain a number of keys equal to two raised to the power of the number of bits. Two to the fifth power is 32, so a 5-bit keyspace contains 32 possible keys.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      130,
      140,
      138,
      104
    ],
    "source": ""
  },
  {
    "id": 764,
    "question": "What cryptographic principle stands behind the idea that cryptographic algorithms should be open to public inspection?",
    "choice_a": "Security through obscurity",
    "choice_b": "Kerckhoff's principle",
    "choice_c": "Defense in depth",
    "choice_d": "Heisenburg principle",
    "correct_answer": "B",
    "explanation": "Kerckhoff's principle says that a cryptographic system should be secure even if everything about the system, except the key, is public knowledge.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      498,
      128,
      524,
      104
    ],
    "source": ""
  },
  {
    "id": 765,
    "question": "Alice sent a message to Bob. Bob would like to demonstrate to Charlie that the message he received definitely came from Alice. What goal of cryptography is Bob attempting to achieve?",
    "choice_a": "Authentication",
    "choice_b": "Confidentiality",
    "choice_c": "Nonrepudiation",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "Nonrepudiation occurs when the recipient of a message is able to demonstrate to a third party that the message came from the purported sender.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      524,
      124,
      664,
      663
    ],
    "source": ""
  },
  {
    "id": 766,
    "question": "Sherry conducted an inventory of the cryptographic technologies in use within her organization and found the following algorithms and protocols in use. Which one of these technologies should she replace because it is no longer considered secure?",
    "choice_a": "MD5",
    "choice_b": "3DES",
    "choice_c": "PGP",
    "choice_d": "WPA2",
    "correct_answer": "A",
    "explanation": "The MD5 hash algorithm has known collisions and, as of 2005, is no longer considered secure for use in modern environments.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      663,
      665,
      499,
      130,
      128
    ],
    "source": ""
  },
  {
    "id": 767,
    "question": "Tom is a cryptanalyst and is working on breaking a cryptographic algorithm's secret key. He has a copy of an intercepted message that is encrypted, and he also has a copy of the decrypted version of that message. He wants to use both the encrypted message and its decrypted plaintext to retrieve the secret key for use in decrypting other messages. What type of attack is Tom engaging in?",
    "choice_a": "Chosen ciphertext",
    "choice_b": "Chosen plaintext",
    "choice_c": "Known plaintext",
    "choice_d": "Brute force",
    "correct_answer": "C",
    "explanation": "In a known plaintext attack, the attacker has a copy of the encrypted message along with the plaintext message used to generate that ciphertext.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      106,
      664,
      663,
      105
    ],
    "source": ""
  },
  {
    "id": 768,
    "question": "What standard governs the creation and validation of digital certificates for use in a public key infrastructure?",
    "choice_a": "X.509",
    "choice_b": "TLS",
    "choice_c": "SSL",
    "choice_d": "802.1x",
    "correct_answer": "A",
    "explanation": "The X.509 standard, developed by the International Telecommunications Union, contains the specification for digital certificates.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      522,
      524,
      500,
      498
    ],
    "source": ""
  },
  {
    "id": 769,
    "question": "Alan intercepts an encrypted message and wants to determine what type of algorithm was used to create the message. He first performs a frequency analysis and notes that the frequency of letters in the message closely matches the distribution of letters in the English language. What type of cipher was most likely used to create this message?",
    "choice_a": "Substitution cipher",
    "choice_b": "AES",
    "choice_c": "Transposition cipher",
    "choice_d": "3DES",
    "correct_answer": "C",
    "explanation": "This message was most likely encrypted with a transposition cipher. The use of a substitution cipher, a category that includes AES and 3DES, would change the frequency distribution so that it did not mirror that of the English language.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      498,
      664,
      130,
      106
    ],
    "source": ""
  },
  {
    "id": 770,
    "question": "The Double DES (2DES) encryption algorithm was never used as a viable alternative to the original DES algorithm. What attack is 2DES vulnerable to that does not exist for the DES or 3DES approach?",
    "choice_a": "Chosen ciphertext",
    "choice_b": "Brute force",
    "choice_c": "Man-in-the-middle",
    "choice_d": "Meet-in-the-middle",
    "correct_answer": "D",
    "explanation": "The meet-in-the-middle attack uses a known plaintext message and uses both encryption of the plaintext and decryption of the ciphertext simultaneously in a brute-force manner to identify the encryption key in approximately double the time of a brute-force attack against the basic DES algorithm.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      668,
      664,
      107,
      145
    ],
    "source": ""
  },
  {
    "id": 771,
    "question": "Raj is selecting an encryption algorithm for use in his organization and would like to be able to vary the strength of the encryption with the sensitivity of the information. Which one of the following algorithms allows the use of different key strengths?",
    "choice_a": "Blowfish",
    "choice_b": "DES",
    "choice_c": "Skipjack",
    "choice_d": "IDEA",
    "correct_answer": "A",
    "explanation": "Blowfish allows the user to select any key length between 32 and 448 bits.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      500,
      498,
      668,
      104
    ],
    "source": ""
  },
  {
    "id": 772,
    "question": "Howard is choosing a cryptographic algorithm for his organization, and he would like to choose an algorithm that supports the creation of digital signatures. Which one of the following algorithms would meet his requirement?",
    "choice_a": "RSA",
    "choice_b": "DES",
    "choice_c": "AES",
    "choice_d": "Blowfish",
    "correct_answer": "A",
    "explanation": "Digital signatures are possible only when using an asymmetric encryption algorithm. Of the algorithms listed, only RSA is asymmetric and supports digital signature capabilities.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      498,
      663,
      668,
      672,
      128
    ],
    "source": ""
  },
  {
    "id": 773,
    "question": "In Transport Layer Security, what type of key is used to encrypt the actual content of communications between a web server and a client?",
    "choice_a": "Ephemeral session key",
    "choice_b": "Client's public key",
    "choice_c": "Server's public key",
    "choice_d": "Server's private key",
    "correct_answer": "A",
    "explanation": "In TLS, both the server and the client first communicate using an ephemeral symmetric session key. They exchange this key using asymmetric cryptography, but all encrypted content is protected using symmetric cryptography.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      498,
      500,
      107,
      147,
      672
    ],
    "source": ""
  },
  {
    "id": 774,
    "question": "Chris is designing a cryptographic system for use within his company. The company has 1,000 employees, and they plan to use an asymmetric encryption system. How many total keys will they need?",
    "choice_a": "500",
    "choice_b": "1,000",
    "choice_c": "2,000",
    "choice_d": "4,950",
    "correct_answer": "C",
    "explanation": "Asymmetric cryptosystems use a pair of keys for each user. In this case, with 1,000 users, the system will require 2,000 keys.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      104,
      663,
      128,
      106
    ],
    "source": ""
  },
  {
    "id": 775,
    "question": "Todd wants to add a certificate to a certificate revocation list. What element of the certificate goes on the list?",
    "choice_a": "Serial number",
    "choice_b": "Public key",
    "choice_c": "Digital signature",
    "choice_d": "Private key",
    "correct_answer": "A",
    "explanation": "The certificate revocation list contains the serial numbers of digital certificates issued by a certificate authority that have later been revoked.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      523,
      522,
      674,
      668
    ],
    "source": ""
  },
  {
    "id": 776,
    "question": "Alison is examining a digital certificate presented to her by her bank's website. Which one of the following requirements is not necessary for her to trust the digital certificate?",
    "choice_a": "She knows that the server belongs to the bank.",
    "choice_b": "She trusts the certificate authority.",
    "choice_c": "She verifies that the certificate is not listed on a CRL.",
    "choice_d": "She verifies the digital signature on the certificate.",
    "correct_answer": "A",
    "explanation": "The point of the digital certificate is to prove to Alison that the server belongs to the bank, so she does not need to have this trust in advance. To trust the certificate, she must verify the CA's digital signature on the certificate, trust the CA, verify that the certificate is not listed on a CRL, and verify that the certificate contains the name of the bank.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      522,
      674,
      523,
      104
    ],
    "source": ""
  },
  {
    "id": 777,
    "question": "Which one of the following would be a reasonable application for the use of self-signed digital certificates?",
    "choice_a": "E-commerce website",
    "choice_b": "Banking application",
    "choice_c": "Internal scheduling application",
    "choice_d": "Customer portal",
    "correct_answer": "C",
    "explanation": "Self-signed digital certificates should be used only for internal-facing applications, where the user base trusts the internally generated digital certificate.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      673,
      672,
      674,
      523,
      104
    ],
    "source": ""
  },
  {
    "id": 778,
    "question": "Quantum Computing regularly ships tapes of backup data across the country to a secondary facility. These tapes contain confidential information. What is the most important security control that Quantum can use to protect these tapes?",
    "choice_a": "Locked shipping containers",
    "choice_b": "Private couriers",
    "choice_c": "Data encryption",
    "choice_d": "Media rotation",
    "correct_answer": "C",
    "explanation": "Quantum may choose to use any or all of these security controls, but data encryption is, by far, the most important control. It protects the confidentiality of data stored on the tapes, which are most vulnerable to theft while in transit between two secure locations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      668,
      666,
      107,
      663,
      524
    ],
    "source": ""
  },
  {
    "id": 779,
    "question": "Alice is designing a cryptosystem for use by six users and would like to use a symmetric encryption algorithm. She wants any two users to be able to communicate with each other without worrying about eavesdropping by a third user. How many symmetric encryption keys will she need to generate?",
    "choice_a": "6",
    "choice_b": "12",
    "choice_c": "15",
    "choice_d": "30",
    "correct_answer": "C",
    "explanation": "The formula for determining the number of encryption keys required by a symmetric algorithm is ((n*(n \u2212 1))/2). With six users, you will need ((6*5)/2), or 15 keys.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      499,
      104,
      103,
      668,
      106
    ],
    "source": ""
  },
  {
    "id": 780,
    "question": "Sally is using IPsec's ESP component in transport mode. What important information should she be aware of about transport mode?",
    "choice_a": "Transport mode provides full encryption of the entire IP packet.",
    "choice_b": "Transport mode adds a new, unencrypted header to ensure that packets reach their destination.",
    "choice_c": "Transport mode does not encrypt the header of the packet.",
    "choice_d": "Transport mode provides no encryption; only tunnel mode provides encryption.",
    "correct_answer": "C",
    "explanation": "ESP's Transport mode encrypts IP packet data but leaves the packet header unencrypted. Tunnel mode encrypts the entire packet and adds a new header to support transmission through the tunnel.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      124,
      128,
      110,
      120,
      107
    ],
    "source": ""
  },
  {
    "id": 781,
    "question": "Which one of the following cryptographic algorithms supports the goal of nonrepudiation?",
    "choice_a": "Blowfish",
    "choice_b": "DES",
    "choice_c": "AES",
    "choice_d": "RSA",
    "correct_answer": "D",
    "explanation": "Nonrepudiation is possible only with an asymmetric encryption algorithm. RSA is an asymmetric algorithm. AES, DES, and Blowfish are all symmetric encryption algorithms that do not provide nonrepudiation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      104,
      124,
      498,
      663,
      105
    ],
    "source": ""
  },
  {
    "id": 782,
    "question": "Andrew believes that a digital certificate belonging to his organization was compromised and would like to add it to a Certificate Revocation List. Who must add the certificate to the CRL?",
    "choice_a": "Andrew",
    "choice_b": "The root authority for the top-level domain",
    "choice_c": "The CA that issued the certificate",
    "choice_d": "The revocation authority for the top-level domain",
    "correct_answer": "C",
    "explanation": "Certificates may only be added to a Certificate Revocation List by the certificate authority that created the digital certificate.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      672,
      522,
      674,
      673,
      524
    ],
    "source": ""
  },
  {
    "id": 783,
    "question": "Attackers who compromise websites often acquire databases of hashed passwords. What technique can best protect these passwords against automated password cracking attacks that use precomputed values?",
    "choice_a": "Using the MD5 hashing algorithm",
    "choice_b": "Using the SHA-1 hashing algorithm",
    "choice_c": "Salting",
    "choice_d": "Double-hashing",
    "correct_answer": "C",
    "explanation": "Salting adds random text to the password before hashing in an attempt to defeat automated password cracking attacks that use precomputed values. MD5 and SHA-1 are both common hashing algorithms, so using them does not add any security. Double-hashing would only be a minor inconvenience for an attacker and would not be as effective as the use of salting.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      751,
      750,
      752,
      663,
      664
    ],
    "source": ""
  },
  {
    "id": 784,
    "question": "Barry recently received a message from Melody that Melody encrypted using symmetric cryptography. What key should Barry use to decrypt the message?",
    "choice_a": "Barry's public key",
    "choice_b": "Barry's private key",
    "choice_c": "Melody's public key",
    "choice_d": "Shared secret key",
    "correct_answer": "D",
    "explanation": "When using symmetric cryptography, the sender encrypts a message using a shared secret key, and the recipient then decrypts the message with that same key. Only asymmetric cryptography uses the concept of public and private key pairs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      500,
      498,
      672,
      664,
      663
    ],
    "source": ""
  },
  {
    "id": 785,
    "question": "Skip needs to transfer files from his PC to a remote server. What protocol should he use instead of FTP?",
    "choice_a": "SCP",
    "choice_b": "SSH",
    "choice_c": "HTTP",
    "choice_d": "Telnet",
    "correct_answer": "A",
    "explanation": "Skip should use SCP\u2014Secure Copy is a secure file transfer method. SSH is a secure command-line and login protocol, whereas HTTP is used for unencrypted web traffic. Telnet is an unencrypted command-line and login protocol.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      122,
      128,
      116,
      108,
      103
    ],
    "source": ""
  },
  {
    "id": 786,
    "question": "Which information security goal is impacted when an organization experiences a DoS or DDoS attack?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Denial",
    "correct_answer": "C",
    "explanation": "Denial-of-service (DoS) attacks and distributed denial-of-service (DDoS) attacks try to disrupt the availability of information systems and networks by flooding a victim with traffic or otherwise disrupting service.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      729,
      730,
      162,
      160,
      178
    ],
    "source": ""
  },
  {
    "id": 787,
    "question": "Chris is building an Ethernet network and knows that he needs to span a distance of more than 150 meters with his 1000BaseT network. What network technology should he use to help with this?",
    "choice_a": "Install a repeater or a concentrator before 100 meters.",
    "choice_b": "Use Category 7 cable, which has better shielding for higher speeds.",
    "choice_c": "Install a gateway to handle the distance.",
    "choice_d": "Use STP cable to handle the longer distance at high speeds.",
    "correct_answer": "A",
    "explanation": "A repeater or concentrator will amplify the signal, ensuring that the 100-meter distance limitation of 1000BaseT is not an issue. A gateway would be useful if network protocols were changing, while Cat7 cable is appropriate for a 10Gbps network at much shorter distances. STP cable is limited to 155 Mbps and 100 meters, which would leave Chris with network problems.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      676,
      675,
      677,
      681,
      504
    ],
    "source": ""
  },
  {
    "id": 788,
    "question": "What topology correctly describes Ethernet?",
    "choice_a": "A ring",
    "choice_b": "A star",
    "choice_c": "A mesh",
    "choice_d": "A bus",
    "correct_answer": "D",
    "explanation": "Ethernet uses a bus topology. While devices may be physically connected to a switch in a physical topology that looks like a star, systems using Ethernet can all transmit on the bus simultaneously, possibly leading to collisions.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      467,
      465,
      504,
      179,
      681
    ],
    "source": ""
  },
  {
    "id": 789,
    "question": "During a wireless network penetration test, Susan runs aircrack-ng against the network using a password file. What might cause her to fail in her password-cracking efforts?",
    "choice_a": "Use of WPA2 encryption",
    "choice_b": "Running WPA2 in Enterprise mode",
    "choice_c": "Use of WEP encryption",
    "choice_d": "Running WPA2 in PSK mode",
    "correct_answer": "B",
    "explanation": "WPA2 enterprise uses RADIUS authentication for users rather than a preshared key. This means a password attack is more likely to fail as password attempts for a given user may result in account lockout. WPA2 encryption will not stop a password attack, and WPA2's preshared key mode is specifically targeted by password attacks that attempt to find the key. Not only is WEP encryption outdated, but it can also frequently be cracked quickly by tools like aircrack-ng.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      182,
      189,
      183,
      195,
      178
    ],
    "source": ""
  },
  {
    "id": 790,
    "question": "What network topology is shown here? <br><img src=\"/question_assets/SSCP/c06uf001.png\"/>",
    "choice_a": "A ring",
    "choice_b": "A bus",
    "choice_c": "A star",
    "choice_d": "A mesh",
    "correct_answer": "D",
    "explanation": "Fully connected mesh networks provide each system with a direct physical link to every other system in the mesh. This is expensive but can provide performance advantages for specific types of computational work.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      467,
      465,
      504,
      682,
      675
    ],
    "source": ""
  },
  {
    "id": 791,
    "question": "During a review of her organization's network, Angela discovered that it was suffering from broadcast storms and that contractors, guests, and organizational administrative staff were on the same network segment. What design change should Angela recommend?",
    "choice_a": "Require encryption for all users.",
    "choice_b": "Install a firewall at the network border.",
    "choice_c": "Enable spanning tree loop detection.",
    "choice_d": "Segment the network based on functional requirements.",
    "correct_answer": "D",
    "explanation": "Network segmentation can reduce issues with performance as well as diminish the chance of broadcast storms by limiting the number of systems in a segment. This decreases broadcast traffic visible to each system and can reduce congestion. Segmentation can also help provide security by separating functional groups who don't need to be able to access each other's systems. Installing a firewall at the border would only help with inbound and outbound traffic, not cross-network traffic. Spanning tree loop prevention helps prevent loops in Ethernet networks (for example, when you plug a switch into a switch via two ports on each), but it won't solve broadcast storms that aren't caused by a loop or security issues. Encryption might help prevent some problems between functional groups, but it won't stop them from scanning other systems, and it definitely won't stop a broadcast storm!",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      688,
      200,
      178,
      174,
      175
    ],
    "source": ""
  },
  {
    "id": 792,
    "question": "In her role as an information security professional, Susan has been asked to identify areas where her organization's wireless network may be accessible even though it isn't intended to be. What should Susan do to determine where her organization's wireless network is accessible?",
    "choice_a": "A site survey",
    "choice_b": "Warwalking",
    "choice_c": "Wardriving",
    "choice_d": "A design map",
    "correct_answer": "A",
    "explanation": "Wardriving and warwalking are both processes used to locate wireless networks but are not typically as detailed and thorough as a site survey, and design map is a made-up term.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      178,
      184,
      689,
      505
    ],
    "source": ""
  },
  {
    "id": 793,
    "question": "Which OSI layer includes electrical specifications, protocols, and interface standards?",
    "choice_a": "The Transport layer",
    "choice_b": "The Device layer",
    "choice_c": "The Physical layer",
    "choice_d": "The Data Link layer",
    "correct_answer": "C",
    "explanation": "The Physical layer includes electrical specifications, protocols, and standards that allow control of throughput, handling line noise, and a variety of other electrical interface and signaling requirements. The OSI layer doesn't have a Device layer. The Transport layer connects the Network and Session layers, and the Data Link layer packages packets from the network layer for transmission and receipt by devices operating on the Physical layer.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      682,
      675,
      681,
      179
    ],
    "source": ""
  },
  {
    "id": 794,
    "question": "Sarah is manually reviewing a packet capture of TCP traffic and finds that a system is setting the RST flag in the TCP packets it sends repeatedly during a short period of time. What does this flag mean in the TCP packet header?",
    "choice_a": "RST flags mean \u201cRest.\u201d The server needs traffic to briefly pause.",
    "choice_b": "RST flags mean \u201cRelay-set.\u201d The packets will be forwarded to the address set in the packet.",
    "choice_c": "RST flags mean \u201cResume Standard.\u201d Communications will resume in their normal format.",
    "choice_d": "RST means \u201cReset.\u201d The TCP session will be disconnected.",
    "correct_answer": "D",
    "explanation": "The RST flag is used to reset or disconnect a session. It can be resumed by restarting the connection via a new three-way handshake.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      719,
      717,
      718,
      684,
      179
    ],
    "source": ""
  },
  {
    "id": 795,
    "question": "Sue's organization recently failed a security assessment because their network was a single flat broadcast domain, and sniffing traffic was possible between different functional groups. What solution should she recommend to help prevent the issues that were identified?",
    "choice_a": "Use VLANs.",
    "choice_b": "Change the subnet mask for all systems.",
    "choice_c": "Deploy gateways.",
    "choice_d": "Turn on port security.",
    "correct_answer": "A",
    "explanation": "A well-designed set of VLANs based on functional groupings will logically separate segments of the network, making it difficult to have data exposure issues between VLANs. Changing the subnet mask will only modify the broadcast domain and will not fix issues with packet sniffing. Gateways would be appropriate if network protocols were different on different segments. Port security is designed to limit which systems can connect to a given port.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      178,
      175,
      174,
      177
    ],
    "source": ""
  },
  {
    "id": 796,
    "question": "Lauren wants to provide port-based authentication on her network to ensure that clients must authenticate before using the network. What technology is an appropriate solution for this requirement?",
    "choice_a": "802.11a",
    "choice_b": "802.3",
    "choice_c": "802.15.1",
    "choice_d": "802.1x",
    "correct_answer": "D",
    "explanation": "802.1x provides port-based authentication and can be used with technologies like EAP, the Extensible Authentication Protocol. 802.11a is a wireless standard, 802.3 is the standard for Ethernet, and 802.15.1 was the original Bluetooth IEEE standard.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      180,
      178,
      182,
      167,
      181
    ],
    "source": ""
  },
  {
    "id": 797,
    "question": "What network technology is best described as a token-passing network that uses a pair of rings with traffic flowing in opposite directions?",
    "choice_a": "A ring topology",
    "choice_b": "Token Ring",
    "choice_c": "FDDI",
    "choice_d": "SONET",
    "correct_answer": "C",
    "explanation": "FDDI, or Fiber Distributed Data Interface, is a token-passing network that uses a pair of rings with traffic flowing in opposite directions. It can bypass broken segments by dropping the broken point and using the second, unbroken ring to continue to function. Token Ring also uses tokens, but it does not use a dual loop. SONET is a protocol for sending multiple optical streams over fiber, and a ring topology is a design, not a technology.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      180,
      677,
      505,
      465
    ],
    "source": ""
  },
  {
    "id": 798,
    "question": "Chris is designing layered network security for his organization. <br><img src=\"/question_assets/SSCP/c06uf002.png\"/>What type of firewall design is shown in the diagram?",
    "choice_a": "A single-tier firewall",
    "choice_b": "A two-tier firewall",
    "choice_c": "A three-tier firewall",
    "choice_d": "A four-tier firewall",
    "correct_answer": "B",
    "explanation": "The firewall in the diagram has two protected zones behind it, making it a two-tier firewall design.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      687,
      688,
      689,
      684,
      770
    ],
    "source": ""
  },
  {
    "id": 799,
    "question": "Chris is designing layered network security for his organization. <br><img src=\"/question_assets/SSCP/c06uf002.png\"/>If the VPN grants remote users the same access to network and system resources as local workstations have, what security issue should Chris raise?",
    "choice_a": "VPN users will not be able to access the web server.",
    "choice_b": "There is no additional security issue; the VPN concentrator's logical network location matches the logical network location of the workstations.",
    "choice_c": "Web server traffic is not subjected to stateful inspection.",
    "choice_d": "VPN users should only connect from managed PCs.",
    "correct_answer": "D",
    "explanation": "Remote PCs that connect to a protected network need to comply with security settings and standards that match those required for the internal network. The VPN concentrator logically places remote users in the protected zone behind the firewall, but that means user workstations (and users) must be trusted in the same way that local workstations are.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      181,
      178,
      160,
      174,
      689
    ],
    "source": ""
  },
  {
    "id": 800,
    "question": "Chris is designing layered network security for his organization. <br><img src=\"/question_assets/SSCP/c06uf002.png\"/>If Chris wants to stop cross-site scripting attacks against the web server, what is the best device for this purpose, and where should he put it?",
    "choice_a": "A firewall, location A",
    "choice_b": "An IDS, location A",
    "choice_c": "An IPS, location B",
    "choice_d": "A WAF, location C",
    "correct_answer": "C",
    "explanation": "An intrusion protection system can scan traffic and stop both known and unknown attacks. A web application firewall, or WAF, is also a suitable technology, but placing it at location C would only protect from attacks via the organization's VPN, which should only be used by trusted users. A firewall typically won't have the ability to identify and stop cross-site scripting attacks, and IDS systems only monitor and don't stop attacks.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      770,
      532,
      768,
      688,
      686
    ],
    "source": ""
  },
  {
    "id": 801,
    "question": "What network topology is shown in the following image? <br><img src=\"/question_assets/SSCP/c06uf003.png\"/>",
    "choice_a": "A ring",
    "choice_b": "A star",
    "choice_c": "A bus",
    "choice_d": "A mesh",
    "correct_answer": "C",
    "explanation": "A bus can be linear or tree-shaped and connects each system to trunk or backbone cable. Ethernet networks operate on a bus topology.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      467,
      465,
      179,
      681,
      675
    ],
    "source": ""
  },
  {
    "id": 802,
    "question": "A remote access tool that copies what is displayed on a desktop PC to a remote computer is an example of what type of technology?",
    "choice_a": "Remote node operation",
    "choice_b": "Screen scraping",
    "choice_c": "Remote control",
    "choice_d": "RDP",
    "correct_answer": "B",
    "explanation": "Screen scrapers copy the actual screen displayed and display it at a remote location. RDP provides terminal sessions without doing screen scraping, remote node operation is the same as dial-up access, and remote control is a means of controlling a remote system (screen scraping is a specialized subset of remote control).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      678,
      679,
      680,
      182,
      465
    ],
    "source": ""
  },
  {
    "id": 803,
    "question": "Ben is designing a Wi-Fi network and has been asked to choose the most secure option for the network. Which wireless security standard should he choose?",
    "choice_a": "WPA2",
    "choice_b": "WPA",
    "choice_c": "WEP",
    "choice_d": "AES",
    "correct_answer": "A",
    "explanation": "WPA2, the replacement for WPA, does not suffer from the security issues that WEP, the original wireless security protocol, and WPA, its successor, both suffer from. AES is used in WPA2 but is not specifically a wireless security standard.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      182,
      178,
      181,
      200
    ],
    "source": ""
  },
  {
    "id": 804,
    "question": "Which one of the following protocols is commonly used to provide backend authentication services for a VPN?",
    "choice_a": "HTTPS",
    "choice_b": "RADIUS",
    "choice_c": "ESP",
    "choice_d": "AH",
    "correct_answer": "B",
    "explanation": "The Remote Authentication Dial-in User Service (RADIUS) protocol was originally designed to support dial-up modem connections but is still commonly used for VPN-based authentication. HTTPS is not an authentication protocol. ESP and AH are IPsec protocols but do not provide authentication services for other systems.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      182,
      183,
      167,
      466,
      180
    ],
    "source": ""
  },
  {
    "id": 805,
    "question": "Ben is troubleshooting a network and discovers that the NAT router he is connected to has the 192.168.x.x subnet as its internal network and that its external IP is 192.168.1.40. What problem is he encountering?",
    "choice_a": "192.168.x.x is a nonroutable network and will not be carried to the Internet.",
    "choice_b": "192.168.1.40 is not a valid address because it is reserved by RFC 1918.",
    "choice_c": "Double NATing is not possible using the same IP range.",
    "choice_d": "The upstream system is unable to de-encapsulate his packets, and he needs to use PAT instead.",
    "correct_answer": "C",
    "explanation": "Double NATing isn't possible with the same IP range; the same IP addresses cannot appear inside and outside a NAT router. RFC 1918 addresses are reserved, but only so they are not used and routable on the Internet, and changing to PAT would not fix the issue.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      507,
      470,
      509,
      508,
      506
    ],
    "source": ""
  },
  {
    "id": 806,
    "question": "Susan sets up a firewall that keeps track of the status of the communication between two systems and allows a remote system to respond to a local system after the local system starts communication. What type of firewall is Susan using?",
    "choice_a": "A static packet filtering firewall",
    "choice_b": "An application-level gateway firewall",
    "choice_c": "A stateful packet inspection firewall",
    "choice_d": "A circuit-level gateway firewall",
    "correct_answer": "C",
    "explanation": "Stateful packet inspection firewalls, also known as dynamic packet filtering firewalls, track the state of a conversation and can allow a response from a remote system based on an internal system being allowed to start the communication. Static packet filtering and circuit-level gateways only filter based on source, destination, and ports, whereas application-level gateway firewalls proxy traffic for specific applications.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      684,
      685,
      688,
      532,
      719
    ],
    "source": ""
  },
  {
    "id": 807,
    "question": "What type of networking device is most commonly used to assign endpoint systems to VLANs?",
    "choice_a": "Firewall",
    "choice_b": "Router",
    "choice_c": "Switch",
    "choice_d": "Hub",
    "correct_answer": "C",
    "explanation": "The assignment of endpoint systems to VLANs is normally performed by a network switch.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      505,
      676,
      681,
      501
    ],
    "source": ""
  },
  {
    "id": 808,
    "question": "Chris needs to design a firewall architecture that can support a DMZ, a database, and a private internal network in a secure manner that separates each function. What type of design should he use, and how many firewalls does he need?",
    "choice_a": "A four-tier firewall design with two firewalls",
    "choice_b": "A two-tier firewall design with three firewalls",
    "choice_c": "A three-tier firewall design with at least one firewall",
    "choice_d": "A single-tier firewall design with three firewalls",
    "correct_answer": "C",
    "explanation": "A three-tier design separates three distinct protected zones and can be accomplished with a single firewall that has multiple interfaces. Single- and two-tier designs don't support the number of protected networks needed in this scenario, while a four-tier design would provide a tier that isn't needed.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      687,
      689,
      688,
      452,
      686
    ],
    "source": ""
  },
  {
    "id": 809,
    "question": "Which of the following is not a potential problem with active wireless scanning?",
    "choice_a": "Accidently scanning apparent rogue devices that actually belong to guests",
    "choice_b": "Causing alarms on the organization's wireless IPS",
    "choice_c": "Scanning devices that belong to nearby organizations",
    "choice_d": "Misidentifying rogue devices",
    "correct_answer": "B",
    "explanation": "Not only should active scanning be expected to cause wireless IPS alarms, but they may actually be desired if the test is done to test responses. Accidentally scanning guests or neighbors or misidentifying devices belonging to third parties are all potential problems with active scanning and require the security assessor to carefully verify the systems that she is scanning.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      178,
      181,
      197,
      200
    ],
    "source": ""
  },
  {
    "id": 810,
    "question": "The Address Resolution Protocol (ARP) and the Reverse Address Resolution Protocol (RARP) operate at what layer of the OSI model?",
    "choice_a": "Layer 1",
    "choice_b": "Layer 2",
    "choice_c": "Layer 3",
    "choice_d": "Layer 4",
    "correct_answer": "B",
    "explanation": "ARP and RARP operate at the Data Link layer, the second layer of the OSI model. Both protocols deal with physical (MAC) hardware addresses, which are used above the Physical layer (layer 1) and below the Network layer (layer 3), thus, falling at the Data Link layer.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      505,
      179,
      507,
      450
    ],
    "source": ""
  },
  {
    "id": 811,
    "question": "John's network begins to experience symptoms of slowness. Upon investigation, he realizes that the network is being bombarded with TCP SYN packets and believes that his organization is the victim of a denial-of-service attack. What principle of information security is being violated?",
    "choice_a": "Availability",
    "choice_b": "Integrity",
    "choice_c": "Confidentiality",
    "choice_d": "Denial",
    "correct_answer": "A",
    "explanation": "A smurf attack is an example of a denial-of-service attack, which jeopardizes the availability of a targeted network.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      729,
      718,
      717,
      162,
      200
    ],
    "source": ""
  },
  {
    "id": 812,
    "question": "What speed is Category 3 UTP cable rated for?",
    "choice_a": "5 Mbps",
    "choice_b": "10 Mbps",
    "choice_c": "100 Mbps",
    "choice_d": "1000 Mbps",
    "correct_answer": "B",
    "explanation": "Category 3 UTP cable is primarily used for phone cables and was also used for early Ethernet networks where it provided 10 Mbps of throughput. Cat 5 cable provides 100 Mbps (and 1000 Mbps if it is Cat 5e). Cat 6 cable can also provide 1000 Mbps.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      681,
      675,
      679,
      452,
      179
    ],
    "source": ""
  },
  {
    "id": 813,
    "question": "Lauren's organization has used a popular messaging service for a number of years. Recently, concerns have been raised about the use of messaging. <br><img src=\"/question_assets/SSCP/c06uf004.png\"/>What protocol is the messaging traffic most likely to use based on the diagram?",
    "choice_a": "SLACK",
    "choice_b": "HTTP",
    "choice_c": "SMTP",
    "choice_d": "HTTPS",
    "correct_answer": "B",
    "explanation": "The use of TCP port 80 indicates that the messaging service is using the HTTP protocol. Slack is a messaging service that runs over HTTPS, which uses port 443. SMTP is an email protocol that uses port 25.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      453,
      454,
      455,
      501,
      529
    ],
    "source": ""
  },
  {
    "id": 814,
    "question": "Lauren's organization has used a popular messaging service for a number of years. Recently, concerns have been raised about the use of messaging. <br><img src=\"/question_assets/SSCP/c06uf004.png\"/>What security concern does sending internal communications from A to B raise?",
    "choice_a": "The firewall does not protect system B",
    "choice_b": "System C can see the broadcast traffic from system A to B.",
    "choice_c": "It is traveling via an unencrypted protocol.",
    "choice_d": "Messaging does not provide nonrepudiation.",
    "correct_answer": "C",
    "explanation": "HTTP traffic is typically sent via TCP 80. Unencrypted HTTP traffic can be easily captured at any point between A and B, meaning that the messaging solution chosen does not provide confidentiality for the organization's corporate communications.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      162,
      179,
      200,
      501,
      529
    ],
    "source": ""
  },
  {
    "id": 815,
    "question": "Lauren's organization has used a popular messaging service for a number of years. Recently, concerns have been raised about the use of messaging. <br><img src=\"/question_assets/SSCP/c06uf004.png\"/>How could Lauren's company best address a desire for secure messaging for users of internal systems A and C?",
    "choice_a": "Use a third-party messaging service.",
    "choice_b": "Implement and use a locally hosted service.",
    "choice_c": "Use HTTPS.",
    "choice_d": "Discontinue use of messaging and instead use email, which is more secure.",
    "correct_answer": "B",
    "explanation": "If a business need requires messaging, using a local messaging server is the best option. This prevents traffic from traveling to a third-party server and can offer additional benefits such as logging, archiving, and control of security options like the use of encryption.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      189,
      195,
      529,
      160,
      162
    ],
    "source": ""
  },
  {
    "id": 816,
    "question": "Chris is configuring an IDS to monitor for unencrypted FTP traffic. What ports should Chris use in his configuration?",
    "choice_a": "TCP 20 and 21",
    "choice_b": "TCP 21 only",
    "choice_c": "UDP port 69",
    "choice_d": "TCP port 21 and UDP port 21",
    "correct_answer": "A",
    "explanation": "The File Transfer Protocol (FTP) operates on TCP ports 20 and 21. UDP port 69 is used for the Trivial File Transfer Protocol, or TFTP, while UDP port 21 is not used for any common file transfer protocol.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      453,
      455,
      719,
      507,
      179
    ],
    "source": ""
  },
  {
    "id": 817,
    "question": "During a penetration test, Lauren is asked to test the organization's Bluetooth security. Which of the following is not a concern she should explain to her employers?",
    "choice_a": "Bluetooth scanning can be time-consuming.",
    "choice_b": "Many devices that may be scanned are likely to be personal devices.",
    "choice_c": "Bluetooth passive scans may require multiple visits at different times to identify all targets.",
    "choice_d": "Bluetooth active scans can't evaluate the security mode of Bluetooth devices.",
    "correct_answer": "D",
    "explanation": "Bluetooth active scans can determine both the strength of the PIN and what security mode the device is operating in. Unfortunately, Bluetooth scans can be challenging because of the limited range of Bluetooth and the prevalence of personally owned Bluetooth-enabled devices. Passive Bluetooth scanning only detects active connections and typically requires multiple visits to have a chance of identifying all devices.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 818,
    "question": "What network tool can be used to protect the identity of clients while providing Internet access by accepting client requests, altering the source addresses of the requests, mapping requests to clients, and sending the modified requests out to their destination?",
    "choice_a": "A gateway",
    "choice_b": "A proxy",
    "choice_c": "A router",
    "choice_d": "A firewall",
    "correct_answer": "B",
    "explanation": "A proxy is a form of gateway that provide clients with a filtering, caching, or other service that protects their information from remote systems. A router connects networks, while a firewall uses rules to limit traffic permitted through it. A gateway translates between protocols.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      532,
      178,
      180,
      677,
      179
    ],
    "source": ""
  },
  {
    "id": 819,
    "question": "In the OSI model, when a packet changes from a datastream to a segment or a datagram, what layer has it traversed?",
    "choice_a": "The Transport layer",
    "choice_b": "The Application layer",
    "choice_c": "The Data Link layer",
    "choice_d": "The Physical layer",
    "correct_answer": "A",
    "explanation": "When a data stream is converted into a segment (TCP) or a datagram (UDP), it transitions from the Session layer to the Transport layer. This change from a message sent to an encoded segment allows it to then traverse the Network layer.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      505,
      179,
      717,
      501
    ],
    "source": ""
  },
  {
    "id": 820,
    "question": "The Windows <code>ipconfig</code> command displays the following information: <br>BC-5F-F4-7B-4B-7D <br>What term describes this, and what information can usually be gathered from it?",
    "choice_a": "The IP address, the network location of the system",
    "choice_b": "The MAC address, the network interface card's manufacturer",
    "choice_c": "The MAC address, the media type in use",
    "choice_d": "The IPv6 client ID, the network interface card's manufacturer",
    "correct_answer": "B",
    "explanation": "Media Access Control (MAC) addresses are the hardware address the machine uses for layer 2 communications. The MAC addresses include an organizationally unique identifier (OUI), which identifies the manufacturer. MAC addresses can be changed, so this is not a guarantee of accuracy, but under normal circumstances you can tell what manufacturer made the device by using the MAC address.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      179,
      682,
      470,
      178
    ],
    "source": ""
  },
  {
    "id": 821,
    "question": "Why should passive scanning be conducted in addition to implementing wireless security technologies like wireless intrusion detection systems?",
    "choice_a": "It can help identify rogue devices.",
    "choice_b": "It can test the security of the wireless network via scripted attacks.",
    "choice_c": "Their short dwell time on each wireless channel can allow them to capture more packets.",
    "choice_d": "They can help test wireless IDS or IPS systems.",
    "correct_answer": "A",
    "explanation": "Passive scanning can help identify rogue devices by capturing MAC address vendor IDs that do not match deployed devices, by verifying that systems match inventories of organizationally owned hardware by hardware address, and by monitoring for rogue SSIDs or connections.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      178,
      730,
      181,
      680,
      199
    ],
    "source": ""
  },
  {
    "id": 822,
    "question": "What network topology is shown in the following image? <br><img src=\"/question_assets/SSCP/c06uf005.png\"/>",
    "choice_a": "A ring",
    "choice_b": "A bus",
    "choice_c": "A star",
    "choice_d": "A mesh",
    "correct_answer": "A",
    "explanation": "A ring connects all systems like points on a circle. A ring topology was used with Token Ring networks, and a token was passed between systems around the ring to allow each system to communicate. More modern networks may be described as a ring but are only physically a ring and not logically using a ring topology.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      467,
      465,
      179,
      178,
      186
    ],
    "source": ""
  },
  {
    "id": 823,
    "question": "Chris is setting up a hotel network and needs to ensure that systems in each room or suite can connect to each other, but systems in other suites or rooms cannot. At the same time, he needs to ensure that all systems in the hotel can reach the Internet. What solution should he recommend as the most effective business solution?",
    "choice_a": "Per-room VPNs",
    "choice_b": "VLANs",
    "choice_c": "Port security",
    "choice_d": "Firewalls",
    "correct_answer": "B",
    "explanation": "VLANs can be used to logically separate groups of network ports while still providing access to an uplink. Per-room VPNs would create significant overhead for support as well as create additional expenses. Port security is used to limit what systems can connect to ports, but it doesn't provide network security between systems. Finally, while firewalls might work, they would add additional expense and complexity without adding any benefits over a VLAN solution.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      178,
      175,
      177,
      181
    ],
    "source": ""
  },
  {
    "id": 824,
    "question": "John deploys his website to multiple regions using load balancers around the world through his cloud infrastructure as a service provider. What availability concept is he using?",
    "choice_a": "Multiple processing sites",
    "choice_b": "Warm sites",
    "choice_c": "Cold sites",
    "choice_d": "A honeynet",
    "correct_answer": "A",
    "explanation": "John's design provides multiple processing sites, distributing load to multiple regions. Not only does this provide business continuity and disaster recovery functionality, but it also means that his design will be more resilient to denial-of-service attacks.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      531,
      729,
      687,
      689,
      505
    ],
    "source": ""
  },
  {
    "id": 825,
    "question": "There are four common VPN protocols. Which group listed contains all of the common VPN protocols?",
    "choice_a": "PPTP, LTP, L2TP, IPsec",
    "choice_b": "PPP, L2TP, IPsec, VNC",
    "choice_c": "PPTP, L2F, L2TP, IPsec",
    "choice_d": "PPTP, L2TP, IPsec, SPAP",
    "correct_answer": "C",
    "explanation": "PPTP, L2F, L2TP, and IPsec are the most common VPN protocols. TLS is also used for an increasingly large percentage of VPN connections and may appear at some point in the exam. PPP is a dial-up protocol, LTP is not a protocol, and SPAP is the Shiva Password Authentication Protocol sometimes used with PPTP.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      182,
      183,
      180,
      193
    ],
    "source": ""
  },
  {
    "id": 826,
    "question": "Lauren's organization has deployed VoIP phones on the same switches that the desktop PCs are on. What security issue could this create, and what solution would help?",
    "choice_a": "VLAN hopping; use physically separate switches.",
    "choice_b": "VLAN hopping; use encryption.",
    "choice_c": "Caller ID spoofing; MAC filtering",
    "choice_d": "Denial-of-service attacks; use a firewall between networks.",
    "correct_answer": "A",
    "explanation": "VLAN hopping between the voice and computer VLANs can be accomplished when devices share the same switch infrastructure. Using physically separate switches can prevent this attack. Encryption won't help with VLAN hopping because it relies on header data that the switch needs to read (and this is unencrypted), while Caller ID spoofing is an inherent problem with VoIP systems. A denial of service is always a possibility, but it isn't specifically a VoIP issue and a firewall may not stop the problem if it's on a port that must be allowed through.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      502,
      200,
      181,
      179,
      688
    ],
    "source": ""
  },
  {
    "id": 827,
    "question": "Staff from Susan's company often travel internationally. Susan believes that they may be targeted for corporate espionage activities because of the technologies that her company is developing. What practice should Susan recommend that they adopt for connecting to networks while they travel?",
    "choice_a": "Only connect to public Wi-Fi.",
    "choice_b": "Use a VPN for all connections.",
    "choice_c": "Only use websites that support TLS.",
    "choice_d": "Do not connect to networks while traveling.",
    "correct_answer": "B",
    "explanation": "While it may be tempting to tell her staff to simply not connect to any network, Susan knows that they will need connectivity to do their work. Using a VPN to connect their laptops and mobile devices to a trusted network and ensuring that all traffic is tunneled through the VPN is her best bet to secure their Internet usage. Susan may also want to ensure that they take \u201cclean\u201d laptops and devices that do not contain sensitive information or documents and that those systems are fully wiped and reviewed when they return.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      678,
      198,
      176,
      178
    ],
    "source": ""
  },
  {
    "id": 828,
    "question": "One of Susan's attacks during a penetration test involves inserting false ARP data into a system's ARP cache. When the system attempts to send traffic to the address it believes belongs to a legitimate system, it will instead send that traffic to a system she controls. What is this attack called?",
    "choice_a": "RARP flooding",
    "choice_b": "ARP cache poisoning",
    "choice_c": "A denial-of-ARP attack",
    "choice_d": "ARP buffer blasting",
    "correct_answer": "B",
    "explanation": "ARP cache poisoning occurs when false ARP data is inserted into a system's ARP cache, allowing the attacker to modify its behavior. RARP flooding, denial-of-ARP attacks, and ARP buffer blasting are all made-up terms.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      505,
      504,
      729,
      178
    ],
    "source": ""
  },
  {
    "id": 829,
    "question": "Which one of the following traffic types should not be blocked by an organization's egress filtering policy?",
    "choice_a": "Traffic destined to a private IP address",
    "choice_b": "Traffic with a broadcast destination",
    "choice_c": "Traffic with a source address from an external network",
    "choice_d": "Traffic with a destination address on an external network",
    "correct_answer": "D",
    "explanation": "Egress filtering scans outbound traffic for potential security policy violations. This includes traffic with a private IP address as the destination, traffic with a broadcast address as the destination, and traffic that has a falsified source address not belonging to the organization.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      470,
      452,
      450,
      507,
      684
    ],
    "source": ""
  },
  {
    "id": 830,
    "question": "A denial-of-service (DoS) attack that sends fragmented TCP packets is known as what kind of attack?",
    "choice_a": "Christmas tree",
    "choice_b": "Teardrop",
    "choice_c": "Stack killer",
    "choice_d": "Frag grenade",
    "correct_answer": "B",
    "explanation": "A teardrop attack uses fragmented packets to target a flaw in how the TCP stack on a system handles fragment reassembly. If the attack is successful, the TCP stack fails, resulting in a denial of service. Christmas tree attacks set all of the possible TCP flags on a packet, thus, \u201clighting it up like a Christmas tree.\u201d Stack killer and frag grenade attacks are made-up answers.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      729,
      730,
      718,
      719,
      768
    ],
    "source": ""
  },
  {
    "id": 831,
    "question": "Angela uses a sniffer to monitor traffic from a RADIUS server configured with default settings. What protocol should she monitor, and what traffic will she be able to read?",
    "choice_a": "UDP, none. All RADIUS traffic is encrypted",
    "choice_b": "TCP, all traffic but the passwords, which are encrypted",
    "choice_c": "UDP, all traffic but the passwords, which are encrypted.",
    "choice_d": "TCP, none. All RADIUS traffic is encrypted.",
    "correct_answer": "C",
    "explanation": "By default, RADIUS uses UDP and only encrypts passwords. RADIUS supports TCP and TLS, but this is not a default setting.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      182,
      189,
      183,
      186,
      180
    ],
    "source": ""
  },
  {
    "id": 832,
    "question": "Segmentation, sequencing, and error checking all occur at what layer of the OSI model that is associated with SSL, TLS, and UDP?",
    "choice_a": "The Transport layer",
    "choice_b": "The Network layer",
    "choice_c": "The Session layer",
    "choice_d": "The Presentation layer",
    "correct_answer": "A",
    "explanation": "The Transport layer provides logical connections between devices, including end-to-end transport services to ensure that data is delivered. Transport layer protocols include TCP, UDP, SSL, and TLS.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      454,
      179,
      719,
      675
    ],
    "source": ""
  },
  {
    "id": 833,
    "question": "In what type of attack do attackers manage to insert themselves into a connection between a user and a legitimate website?",
    "choice_a": "Man-in-the-middle",
    "choice_b": "Fraggle",
    "choice_c": "Wardriving",
    "choice_d": "Meet-in-the-middle",
    "correct_answer": "A",
    "explanation": "In a man-in-the-middle attack, attackers manage to insert themselves into a connection between a user and a legitimate website, relaying traffic between the two parties while eavesdropping on the connection. Although similarly named, the meet-in-the-middle attack is a cryptographic attack that does not necessarily involve connection tampering. Fraggle is a network-based denial-of-service attack using UDP packets. Wardriving is a reconnaissance technique for discovering open or weakly secured wireless networks.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      718,
      719,
      730,
      729,
      527
    ],
    "source": ""
  },
  {
    "id": 834,
    "question": "What type of key does WEP use to encrypt wireless communications?",
    "choice_a": "An asymmetric key",
    "choice_b": "Unique key sets for each host",
    "choice_c": "A predefined shared static key",
    "choice_d": "Unique asymmetric keys for each host",
    "correct_answer": "C",
    "explanation": "WEP has a weak security model that relies on a single, predefined, shared static key. This means that modern attacks can break WEP encryption in less than a minute.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      525,
      527,
      526,
      528,
      179
    ],
    "source": ""
  },
  {
    "id": 835,
    "question": "What does a bluesnarfing attack target?",
    "choice_a": "Data on IBM systems",
    "choice_b": "An outbound phone call via Bluetooth",
    "choice_c": "802.11b networks",
    "choice_d": "Data from a Bluetooth-enabled device",
    "correct_answer": "D",
    "explanation": "Bluesnarfing targets the data or information on Bluetooth-enabled devices. Bluejacking occurs when attackers send unsolicited messages via Bluetooth.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 836,
    "question": "Susan is writing a best practices statement for her organizational users who need to use Bluetooth. She knows that there are many potential security issues with Bluetooth and wants to provide the best advice she can. Which of the following sets of guidance should Susan include?",
    "choice_a": "Use Bluetooth's built-in strong encryption, change the default PIN on your device, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "choice_b": "Use Bluetooth only for those activities that are not confidential, change the default PIN on your device, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "choice_c": "Use Bluetooth's built-in strong encryption, use extended (eight digits or longer) Bluetooth PINs, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "choice_d": "Use Bluetooth only for those activities that are not confidential, use extended (eight digits or longer) Bluetooth PINs, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "correct_answer": "B",
    "explanation": "Since Bluetooth doesn't provide strong encryption, it should only be used for activities that are not confidential. Bluetooth PINs are four-digit codes that often default to 0000. Turning it off and ensuring that your devices are not in discovery mode can help prevent Bluetooth attacks.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 837,
    "question": "Lauren uses the ping utility to check whether a remote system is up as part of a penetration testing exercise. If she does not want to see her own ping packets, what protocol should she filter out from her packet sniffer's logs?",
    "choice_a": "UDP",
    "choice_b": "TCP",
    "choice_c": "IP",
    "choice_d": "ICMP",
    "correct_answer": "D",
    "explanation": "Ping uses ICMP, the Internet Control Message Protocol, to determine whether a system responds and how many hops there are between the originating system and the remote system. Lauren simply needs to filter out ICMP to not see her pings.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      729,
      504,
      178,
      179,
      505
    ],
    "source": ""
  },
  {
    "id": 838,
    "question": "During a port scan using nmap, Joseph discovers that a system shows two ports open that cause him immediate worry: <br>21/open <br>23/open <br>What services are likely running on those ports?",
    "choice_a": "SSH and FTP",
    "choice_b": "FTP and Telnet",
    "choice_c": "SMTP and Telnet",
    "choice_d": "POP3 and SMTP",
    "correct_answer": "B",
    "explanation": "Joseph may be surprised to discover FTP (TCP port 21) and Telnet (TCP port 23) open on his network since both services are unencrypted and have been largely replaced by SSH, and SCP or SFTP. SSH uses port 22, SMTP uses port 25, and POP3 uses port 110.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      453,
      455,
      454,
      509,
      182
    ],
    "source": ""
  },
  {
    "id": 839,
    "question": "One of the findings that Jim made when performing a security audit was the use of non-IP protocols in a private network. What issue should Jim point out that may result from the use of these non-IP protocols?",
    "choice_a": "They are outdated and cannot be used on modern PCs.",
    "choice_b": "They may not be able to be filtered by firewall devices.",
    "choice_c": "They may allow Christmas tree attacks.",
    "choice_d": "IPX extends on the IP protocol and may not be supported by all TCP stacks.",
    "correct_answer": "B",
    "explanation": "While non-IP protocols like IPX/SPX, NetBEUI, and AppleTalk are rare in modern networks, they can present a challenge because many firewalls are not capable of filtering them. This can create risks when they are necessary for an application or system's function because they may have to be passed without any inspection. Christmas tree attacks set all of the possible flags on a TCP packet (and are thus, related to an IP protocol), IPX is not an IP-based protocol, and while these protocols are outdated, there are ways to make even modern PCs understand them.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      684,
      730,
      200,
      178,
      501
    ],
    "source": ""
  },
  {
    "id": 840,
    "question": "What type of attack is most likely to occur after a successful ARP spoofing attempt?",
    "choice_a": "A DoS attack",
    "choice_b": "A Trojan",
    "choice_c": "A replay attack",
    "choice_d": "A man-in-the-middle attack",
    "correct_answer": "D",
    "explanation": "ARP spoofing is often done to replace a target's cache entry for a destination IP, allowing the attacker to conduct a man-in-the-middle attack. A denial-of-service attack would be aimed at disrupting services rather than spoofing an ARP response, a replay attack will involve existing sessions, and a Trojan is malware that is disguised in a way that makes it look harmless.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      178,
      718,
      729,
      162
    ],
    "source": ""
  },
  {
    "id": 841,
    "question": "Arnold is receiving reports from end users that their Internet connections are extremely slow. He looks at the firewall and determines that there are thousands of unexpected inbound connections per second arriving from all over the world. What type of attack is most likely occurring?",
    "choice_a": "A worm",
    "choice_b": "A denial-of-service attack",
    "choice_c": "A virus",
    "choice_d": "A smurf attack",
    "correct_answer": "B",
    "explanation": "A denial-of-service attack is an attack that causes a service to fail or to be unavailable. Exhausting a system's resources to cause a service to fail is a common form of denial-of-service attack. A worm is a self-replicating form of malware that propagates via a network, a virus is a type of malware that can copy itself to spread, and a smurf attack is a distributed denial-of-service (DDoS) that spoofs a victim's IP address to systems using an IP broadcast, resulting in traffic from all of those systems to the target.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      729,
      718,
      200,
      178,
      181
    ],
    "source": ""
  },
  {
    "id": 842,
    "question": "Jim is building a research computing system that benefits from being part of a full mesh topology between systems. In a five-node full mesh topology design, how many connections will an individual node have?",
    "choice_a": "Two",
    "choice_b": "Three",
    "choice_c": "Four",
    "choice_d": "Five",
    "correct_answer": "C",
    "explanation": "A full mesh topology directly connects each machine to every other machine on the network. For five systems, this means four connections per system.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      465,
      467,
      179,
      504,
      178
    ],
    "source": ""
  },
  {
    "id": 843,
    "question": "During a security assessment of a wireless network, Jim discovers that LEAP is in use on a network using WPA. What recommendation should Jim make?",
    "choice_a": "Continue to use LEAP. It provides better security than TKIP for WPA networks.",
    "choice_b": "Use an alternate protocol like PEAP or EAP-TLS and implement WPA2 if supported.",
    "choice_c": "Continue to use LEAP to avoid authentication issues, but move to WPA2.",
    "choice_d": "Use an alternate protocol like PEAP or EAP-TLS, and implement Wired Equivalent Privacy to avoid wireless security issues.",
    "correct_answer": "B",
    "explanation": "LEAP, the Lightweight Extensible Authentication Protocol, is a Cisco proprietary protocol designed to handle problems with TKIP. Unfortunately, LEAP has significant security issues as well and should not be used. Any modern hardware should support WPA2 and technologies like PEAP or EAP-TLS. Using WEP, the predecessor to WPA and WPA2, would be a major step back in security for any network.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      180,
      189,
      188,
      167,
      183
    ],
    "source": ""
  },
  {
    "id": 844,
    "question": "Which one of the following security tools is not capable of generating an active response to a security event?",
    "choice_a": "IPS",
    "choice_b": "Firewall",
    "choice_c": "IDS",
    "choice_d": "Antivirus software",
    "correct_answer": "C",
    "explanation": "Intrusion detection systems (IDSs) provide only passive responses, such as alerting administrators to a suspected attack. Intrusion prevention systems and firewalls, on the other hand, may take action to block an attack attempt. Antivirus software also may engage in active response by quarantining suspect files.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      718,
      730,
      181,
      200,
      197
    ],
    "source": ""
  },
  {
    "id": 845,
    "question": "Please refer to a stateful inspection firewall running the rulebase shown here. The source ports have been omitted from the figure, but you may assume that they are specified correctly for the purposes of answering the question. <br><img src=\"/question_assets/SSCP/c06uf006.png\"/>Which one of the following rules is not shown in the rulebase but will be enforced by the firewall?",
    "choice_a": "Stealth",
    "choice_b": "Implicit deny",
    "choice_c": "Connection proxy",
    "choice_d": "Egress filter",
    "correct_answer": "B",
    "explanation": "All stateful inspection firewalls enforce an implicit deny rule as the final rule of the rulebase. It is designed to drop all inbound traffic that was not accepted by an earlier rule. Stealth rules hide the firewall from external networks, but they are not included by default. This firewall does not contain any egress filtering rules, and egress filtering is not enforced by default. Connection proxying is an optional feature of stateful inspection firewalls and would not be enforced without a rule explicitly implementing it.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      684,
      686,
      685,
      687,
      688
    ],
    "source": ""
  },
  {
    "id": 846,
    "question": "Please refer to a stateful inspection firewall running the rulebase shown here. The source ports have been omitted from the figure, but you may assume that they are specified correctly for the purposes of answering the question. <br><img src=\"/question_assets/SSCP/c06uf006.png\"/>What type of server is running at IP address 10.1.0.26?",
    "choice_a": "Email",
    "choice_b": "Web",
    "choice_c": "FTP",
    "choice_d": "Database",
    "correct_answer": "A",
    "explanation": "SMTP uses ports 25 and 465. The presence of an inbound rule allowing SMTP traffic indicates that this is an email server.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      453,
      455,
      684,
      685,
      686
    ],
    "source": ""
  },
  {
    "id": 847,
    "question": "Please refer to a stateful inspection firewall running the rulebase shown here. The source ports have been omitted from the figure, but you may assume that they are specified correctly for the purposes of answering the question. <br><img src=\"/question_assets/SSCP/c06uf006.png\"/>The system at 15.246.10.1 attempts HTTP and HTTPS connections to the web server running at 10.1.0.50. Which one of the following statements is true about that connection?",
    "choice_a": "Both connections will be allowed.",
    "choice_b": "Both connections will be blocked.",
    "choice_c": "The HTTP connection will be allowed, and the HTTPS connection will be blocked.",
    "choice_d": "The HTTP connection will be blocked, and the HTTPS connection will be allowed.",
    "correct_answer": "C",
    "explanation": "The HTTP connection will be allowed, despite the presence of rule 2, because it matches rule 1. The HTTPS connection will be blocked because there is no rule allowing HTTPS connections to this server.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      685,
      684,
      686,
      178,
      689
    ],
    "source": ""
  },
  {
    "id": 848,
    "question": "Please refer to a stateful inspection firewall running the rulebase shown here. The source ports have been omitted from the figure, but you may assume that they are specified correctly for the purposes of answering the question. <br><img src=\"/question_assets/SSCP/c06uf006.png\"/>What value should be used to fill in the source port for rule 3?",
    "choice_a": "25",
    "choice_b": "465",
    "choice_c": "80",
    "choice_d": "Any",
    "correct_answer": "D",
    "explanation": "The firewall should be configured to accept inbound connections from any port selected by the source system. The vast majority of inbound firewall rules allow access from any source port.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      684,
      686,
      685,
      688,
      689
    ],
    "source": ""
  },
  {
    "id": 849,
    "question": "What type of firewall design is shown in the following image? <br><img src=\"/question_assets/SSCP/c06uf007.png\"/>",
    "choice_a": "Single-tier",
    "choice_b": "Two-tier",
    "choice_c": "Three-tier",
    "choice_d": "Next generation",
    "correct_answer": "A",
    "explanation": "A single-tier firewall deployment is simple and does not offer useful design options like a DMZ or separate transaction subnets.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      687,
      688,
      689,
      685,
      686
    ],
    "source": ""
  },
  {
    "id": 850,
    "question": "Ben has configured his network to not broadcast an SSID. Why might Ben disable SSID broadcast, and how could his SSID be discovered?",
    "choice_a": "Disabling SSID broadcast prevents attackers from discovering the encryption key. The SSID can be recovered from decrypted packets.",
    "choice_b": "Disabling SSID broadcast hides networks from unauthorized personnel. The SSID can be discovered using a wireless sniffer.",
    "choice_c": "Disabling SSID broadcast prevents issues with beacon frames. The SSID can be recovered by reconstructing the BSSID.",
    "choice_d": "Disabling SSID broadcast helps avoid SSID conflicts. The SSID can be discovered by attempting to connect to the network.",
    "correct_answer": "B",
    "explanation": "Disabling SSID broadcast can help prevent unauthorized personnel from attempting to connect to the network. Since the SSID is still active, it can be discovered by using a wireless sniffer. Encryption keys are not related to SSID broadcast, beacon frames are used to broadcast the SSID, and it is possible to have multiple networks with the same SSID.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      504,
      505,
      200,
      178
    ],
    "source": ""
  },
  {
    "id": 851,
    "question": "The DARPA TCP/IP model's Application layer matches up to what three OSI model layers?",
    "choice_a": "Application, Presentation, and Transport",
    "choice_b": "Presentation, Session, and Transport",
    "choice_c": "Application, Presentation, and Session",
    "choice_d": "There is not a direct match. The TCP model was created before the OSI model.",
    "correct_answer": "C",
    "explanation": "The DARPA TCP/IP model was used to create the OSI model, and the designers of the OSI model made sure to map the OSI model layers to it. The Application layer of the TCP model maps to the Application, Presentation, and Session layers, while the TCP and OSI models both have a distinct Transport layer.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      717,
      454,
      179,
      195
    ],
    "source": ""
  },
  {
    "id": 852,
    "question": "When a host on an Ethernet network detects a collision and transmits a jam signal, what happens next?",
    "choice_a": "The host that transmitted the jam signal is allowed to retransmit while all other hosts pause until that transmission is received successfully.",
    "choice_b": "All hosts stop transmitting, and each host waits a random period of time before attempting to transmit again.",
    "choice_c": "All hosts stop transmitting, and each host waits a period of time based on how recently it successfully transmitted.",
    "choice_d": "Hosts wait for the token to be passed and then resume transmitting data as they pass the token.",
    "correct_answer": "B",
    "explanation": "Ethernet networks use Carrier-Sense Multiple Access/Collision Detection (CSMA/CD) technology. When a collision is detected and a jam signal is sent, hosts wait a random period of time before attempting retransmission.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      675,
      676,
      718,
      681
    ],
    "source": ""
  },
  {
    "id": 853,
    "question": "Which of the following options includes standards or protocols that exist in layer 6 of the OSI model?",
    "choice_a": "NFS, SQL, and RPC",
    "choice_b": "TCP, UDP, and TLS",
    "choice_c": "JPEG, ASCII, and MIDI",
    "choice_d": "HTTP, FTP, and SMTP",
    "correct_answer": "C",
    "explanation": "Layer 6, the Presentation layer, transforms data from the Application layer into formats that other systems can understand by formatting and standardizing the data. That means that standards like JPEG, ASCII, and MIDI are used at the Presentation layer for data. TCP, UDP, and TLS are used at the Transport layer; NFS, SQL, and RPC operate at the Session layer; and HTTP, FTP, and SMTP are Application layer protocols.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      179,
      681,
      676,
      454
    ],
    "source": ""
  },
  {
    "id": 854,
    "question": "WPA2's Counter Mode Cipher Block Chaining Message Authentication Mode Protocol (CCMP) is based on which common encryption scheme?",
    "choice_a": "DES",
    "choice_b": "3DES",
    "choice_c": "AES",
    "choice_d": "TLS",
    "correct_answer": "C",
    "explanation": "WPA2's CCMP encryption scheme is based on AES. As of the writing of this book, there have not been any practical real-world attacks against WPA2. DES has been successfully broken, and neither 3DES nor TLS is used for WPA2.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      527,
      525,
      530,
      179,
      180
    ],
    "source": ""
  },
  {
    "id": 855,
    "question": "What type of firewall design does the following image show? <br><img src=\"/question_assets/SSCP/c06uf008.png\"/>",
    "choice_a": "A single-tier firewall",
    "choice_b": "A two-tier firewall",
    "choice_c": "A three-tier firewall",
    "choice_d": "A fully protected DMZ firewall",
    "correct_answer": "B",
    "explanation": "A two-tier firewall uses a firewall with multiple interfaces or multiple firewalls in series. This image shows a firewall with two protected interfaces, with one used for a DMZ and one used for a protected network. This allows traffic to be filtered between each of the zones (Internet, DMZ, and private network).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      687,
      688,
      689,
      685,
      686
    ],
    "source": ""
  },
  {
    "id": 856,
    "question": "During troubleshooting, Chris uses the <code>nslookup</code> command to check the IP address of a host he is attempting to connect to. The IP he sees in the response is not the IP that should resolve when the lookup is done. What type of attack has likely been conducted?",
    "choice_a": "DNS spoofing",
    "choice_b": "DNS poisoning",
    "choice_c": "ARP spoofing",
    "choice_d": "A Cain attack",
    "correct_answer": "B",
    "explanation": "DNS poisoning occurs when an attacker changes the domain name to IP address mappings of a system to redirect traffic to alternate systems. DNS spoofing occurs when an attacker sends false replies to a requesting system, beating valid replies from the actual DNS server. ARP spoofing provides a false hardware address in response to queries about an IP, and Cain & Abel is a powerful Windows hacking tool, but a Cain attack is not a specific type of attack.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      505,
      506,
      507,
      468,
      451
    ],
    "source": ""
  },
  {
    "id": 857,
    "question": "Which of the following does not describe data in motion?",
    "choice_a": "Data on a backup tape that is being shipped to a storage facility",
    "choice_b": "Data in a TCP packet",
    "choice_c": "Data in an e-commerce transaction",
    "choice_d": "Data in files being copied between locations",
    "correct_answer": "A",
    "explanation": "The correct answer is the tape that is being shipped to a storage facility. You might think that the tape in shipment is \u201cin motion,\u201d but the key concept is that the data is not being accessed and is instead in storage. Data in a TCP packet, in an e-commerce transaction, or in local RAM is in motion and is actively being used.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      171,
      160,
      170,
      161,
      167
    ],
    "source": ""
  },
  {
    "id": 858,
    "question": "Kim is troubleshooting an application firewall that serves as a supplement to the organization's network and host firewalls and intrusion prevention system, providing added protection against web-based attacks. The issue the organization is experiencing is that the\u00a0firewall technology suffers somewhat frequent restarts that render it unavailable for 10 minutes at a time. What configuration might Kim consider to maintain availability during that period at the lowest cost to the company?",
    "choice_a": "High availability cluster",
    "choice_b": "Failover device",
    "choice_c": "Fail open",
    "choice_d": "Redundant disks",
    "correct_answer": "C",
    "explanation": "A fail open configuration may be appropriate in this case. In this configuration, the firewall would continue to pass traffic without inspection while it is restarting. This would minimize downtime, and the traffic would still be protected by the other security controls described in the scenario. Failover devices and high availability clusters would indeed increase availability, but at potentially significant expense. Redundant disks would not help in this scenario because no disk failure is described.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      689,
      687,
      686,
      685,
      688
    ],
    "source": ""
  },
  {
    "id": 859,
    "question": "Chris uses a cellular hot spot (modem) to provide Internet access when he is traveling. If he leaves the hot spot connected to his PC while his PC is on his organization's corporate network, what security issue might he cause?",
    "choice_a": "Traffic may not be routed properly, exposing sensitive data.",
    "choice_b": "His system may act as a bridge from the Internet to the local network.",
    "choice_c": "His system may be a portal for a reflected DDoS attack.",
    "choice_d": "Security administrators may not be able to determine his IP address if a security issue occurs.",
    "correct_answer": "B",
    "explanation": "When a workstation or other device is connected simultaneously to both a secure and a nonsecure network like the Internet, it may act as a bridge, bypassing the security protections located at the edge of a corporate network. It is unlikely that traffic will be routed improperly leading to the exposure of sensitive data, as traffic headed to internal systems and networks is unlikely to be routed to the external network. Reflected DDoS attacks are used to hide identities rather than to connect through to an internal network, and security administrators of managed systems should be able to determine both the local and wireless IP addresses his system uses.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      178,
      181,
      175,
      162
    ],
    "source": ""
  },
  {
    "id": 860,
    "question": "Ben has deployed a 1000BaseT 1 gigabit network and needs to run a cable to another building. If Ben is running his link directly from a switch to another switch in that building, what is the maximum distance Ben can cover according to the 1000BaseT specification?",
    "choice_a": "2 kilometers",
    "choice_b": "500 meters",
    "choice_c": "185 meters",
    "choice_d": "100 meters",
    "correct_answer": "D",
    "explanation": "1000BaseT is capable of a 100-meter run according to its specifications. For longer distances, a fiber-optic cable is typically used in modern networks.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      675,
      676,
      179,
      504,
      681
    ],
    "source": ""
  },
  {
    "id": 861,
    "question": "Lisa is attempting to prevent her network from being targeted by IP spoofing attacks as well as preventing her network from being the source of those attacks. Which one of the following rules is <italic>not</italic> a best practice that Lisa can configure at her network border?",
    "choice_a": "Block packets with internal source addresses from entering the network.",
    "choice_b": "Block packets with external source addresses from leaving the network.",
    "choice_c": "Block packets with private IP addresses from exiting the network.",
    "choice_d": "Block packets with public IP addresses from entering the network.",
    "correct_answer": "D",
    "explanation": "This question is asking you to identify the blocking rule that should <italic>not</italic> be set on the firewall. Packets with public IP addresses will routinely be allowed to enter the network, so you should not create a rule to block them, making this the correct answer. Packets with internal source addresses should never originate from outside the network, so they should be blocked from entering the network. Packets with external source addresses should never be found on the internal network, so they should be blocked from leaving the network. Finally, private IP addresses should never be used on the Internet, so packets containing private IP addresses should be blocked from leaving the network.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      470,
      507,
      685,
      684,
      178
    ],
    "source": ""
  },
  {
    "id": 862,
    "question": "Lauren's and Nick's PCs simultaneously send traffic by transmitting at the same time. What network term describes the range of systems on a network that could be affected by this same issue?",
    "choice_a": "The subnet",
    "choice_b": "The supernet",
    "choice_c": "A collision domain",
    "choice_d": "A broadcast domain",
    "correct_answer": "C",
    "explanation": "A collision domain is the set of systems that could cause a collision if they transmitted at the same time. Systems outside a collision domain cannot cause a collision if they send at the same time. This is important, as the number of systems in a collision domain increases the likelihood of network congestion due to an increase in collisions. A broadcast domain is the set of systems that can receive a broadcast from each other. A subnet is a logical division of a network, while a supernet is made up of two or more networks.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      178,
      179,
      200,
      195,
      730
    ],
    "source": ""
  },
  {
    "id": 863,
    "question": "What type of firewall is capable of inspecting traffic at layer 7 and performing protocol-specific analysis for malicious traffic?",
    "choice_a": "Application firewall",
    "choice_b": "Stateful inspection firewall",
    "choice_c": "Packet filtering firewall",
    "choice_d": "Bastion host",
    "correct_answer": "A",
    "explanation": "Application firewalls add layer 7 functionality to other firewall solutions. This includes the ability to inspect Application-layer details such as analyzing HTTP, DNS, FTP, and other application protocols.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      770,
      769,
      684,
      689
    ],
    "source": ""
  },
  {
    "id": 864,
    "question": "Which of the following sequences properly describes the TCP three-way handshake?",
    "choice_a": "SYN, ACK, SYN/ACK",
    "choice_b": "PSH, RST, ACK",
    "choice_c": "SYN, SYN/ACK, ACK",
    "choice_d": "SYN, RST, FIN",
    "correct_answer": "C",
    "explanation": "The TCP three-way handshake consists of initial contact via a SYN, or synchronize flagged packet; which receives a response with a SYN/ACK, or synchronize and acknowledge flagged packet; which is acknowledged by the original sender with an ACK, or acknowledge packet. RST is used in TCP to reset a connection, PSH is used to send data immediately, and FIN is used to end a connection.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      717,
      718,
      719,
      179,
      178
    ],
    "source": ""
  },
  {
    "id": 865,
    "question": "SMTP, HTTP, and SNMP all occur at what layer of the OSI model?",
    "choice_a": "Layer 4",
    "choice_b": "Layer 5",
    "choice_c": "Layer 6",
    "choice_d": "Layer 7",
    "correct_answer": "D",
    "explanation": "Application-specific protocols are handled at layer 7, the Application layer of the OSI model.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      179,
      454,
      505,
      682
    ],
    "source": ""
  },
  {
    "id": 866,
    "question": "During a forensic investigation, Charles is able to determine the Media Access Control address of a system that was connected to a compromised network. Charles knows that MAC addresses are tied back to a manufacturer or vendor and are part of the fingerprint of the system. To which OSI layer does a MAC address belong?",
    "choice_a": "The Application layer",
    "choice_b": "The Session layer",
    "choice_c": "The Physical layer",
    "choice_d": "The Data Link layer",
    "correct_answer": "D",
    "explanation": "MAC addresses and their organizationally unique identifiers are used at the Data Link layer to identify systems on a network. The Application and Session layers don't care about physical addresses, while the Physical layer involves electrical connectivity and handling physical interfaces rather than addressing.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      504,
      505,
      682,
      676,
      675
    ],
    "source": ""
  },
  {
    "id": 867,
    "question": "What technology could Lauren's employer implement to help prevent confidential data from being emailed out of the organization?",
    "choice_a": "DLP",
    "choice_b": "IDS",
    "choice_c": "A firewall",
    "choice_d": "UDP",
    "correct_answer": "A",
    "explanation": "A data loss prevention (DLP) system or software is designed to identify labeled data or data that fits specific patterns and descriptions to help prevent it from leaving the organization. An IDS is designed to identify intrusions. Although some IDS systems can detect specific types of sensitive data using pattern matching, they have no ability to stop traffic. A firewall uses rules to control traffic routing, while UDP is a network protocol.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      770,
      185,
      175,
      187,
      200
    ],
    "source": ""
  },
  {
    "id": 868,
    "question": "Lauren's multinational company is planning a new cloud deployment and wants to ensure compliance with the EU GDPR. Which principle states that the individual should have the right to receive personal information concerning himself or herself and share it with another data controller?",
    "choice_a": "Onward transfer",
    "choice_b": "Data integrity",
    "choice_c": "Enforcement",
    "choice_d": "Data portability",
    "correct_answer": "B",
    "explanation": "The principle of data integrity states that data should be reliable and that information should not be used for purposes other than those that users are made aware of by notice and that they have accepted through choice. Enforcement is aimed at ensuring that compliance with principles is assured. Access allows individuals to correct, change, or delete their information, while onward transfer limits transfers to other organizations that comply with the principles of notice and choice.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      233,
      217,
      268,
      746,
      201
    ],
    "source": ""
  },
  {
    "id": 869,
    "question": "Tiffany needs to assess the patch level of a Windows 2012 server and wants to use a freely available tool to check the system for security issues. Which of the following tools will provide the most detail about specific patches installed or missing from her machine?",
    "choice_a": "Nmap",
    "choice_b": "Nessus",
    "choice_c": "MBSA",
    "choice_d": "Metasploit",
    "correct_answer": "C",
    "explanation": "The Microsoft Baseline Security Analyzer, or MBSA, is a tool provided by Microsoft that can identify installed or missing patches as well as common security misconfigurations. Since it is run with administrative rights, it will provide a better view than normal nmap and Nessus scans. MBSA provides more detailed information about specific patches that are installed. Metasploit provides some limited scanning capabilities but is not the best tool for the situation.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 870,
    "question": "Maria wants to deploy an anti-malware tool to detect zero-day malware. What type of detection method should she look for in her selected tool?",
    "choice_a": "Signature-based",
    "choice_b": "Heuristic-based",
    "choice_c": "Trend-based",
    "choice_d": "Availability-based",
    "correct_answer": "B",
    "explanation": "Heuristic detection methods run the potential malware application and track what occurs. This can allow the anti-malware tool to determine whether the behaviors and actions of the program match those common to malware, even if the file does not match the fingerprint of known malware packages.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      701,
      692,
      700,
      699
    ],
    "source": ""
  },
  {
    "id": 871,
    "question": "Cameron is configuring his organization's Internet router and would like to enable anti-spoofing technology.  Which one of the following source IP addresses on an inbound packet should trigger anti-spoofing controls?",
    "choice_a": "192.168.163.109",
    "choice_b": "13.5.102.5",
    "choice_c": "124.70.14.100",
    "choice_d": "222.222.222.222",
    "correct_answer": "A",
    "explanation": "The 192.168.0.0/16 address range, which includes 192.168.163.109 is one of the address ranges reserved for use as private IP addresses.  These addresses should not appear on packets inbound to a network from the Internet.  The other addresses mentioned here are all normal public IP addresses.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      254,
      245,
      237,
      246,
      268
    ],
    "source": ""
  },
  {
    "id": 872,
    "question": "As part of her malware analysis process, Caitlyn diagrams the high-level functions and processes that the malware uses to accomplish its goals. What is this process known as?",
    "choice_a": "Static analysis",
    "choice_b": "Composition",
    "choice_c": "Dynamic analysis",
    "choice_d": "Decomposition",
    "correct_answer": "D",
    "explanation": "Caitlyn is preparing a decomposition diagram that maps the high-level functions to lower-level components. This will allow her to better understand how the malware package works and may help her identify areas she should focus on.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      692,
      704,
      733,
      702
    ],
    "source": ""
  },
  {
    "id": 873,
    "question": "The company that Lauren works for is making significant investments in infrastructure as a service hosting to replace its traditional data center. Members of her organization's management have expressed concerns about data remanence when Lauren's team moves from one virtual host to another in their cloud service provider's environment. What should she instruct her team to do to avoid this concern?",
    "choice_a": "Zero-wipe drives before moving systems.",
    "choice_b": "Use full disk encryption.",
    "choice_c": "Use data masking.",
    "choice_d": "Span multiple virtual disks to fragment data.",
    "correct_answer": "B",
    "explanation": "Lauren's team should use full disk encryption or volume encryption and should secure the encryption keys properly. This will ensure that any data that remains cannot be exposed to future users of the virtual infrastructure. While many cloud providers have implemented technology to ensure that this won't happen, Lauren can avoid any potential issues by ensuring that she has taken proactive action to prevent data exposure. Using a zero wipe is often impossible because virtual environments may move without her team's intervention, data masking will not prevent unmasked data or temporary data stored on the virtual disks from being exposed, and spanning multiple virtual disks will still leave data accessible, albeit possibly in fragmented form.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      227,
      252,
      535,
      233,
      237
    ],
    "source": ""
  },
  {
    "id": 874,
    "question": "Lucca wants to prevent workstations on his network from attacking each other. If Lucca's corporate network looks like the network shown here, what technology should he select to prevent laptop A from being able to attack workstation B? <br><img src=\"/question_assets/SSCP/c07uf002.png\"/>",
    "choice_a": "IPS",
    "choice_b": "IDS",
    "choice_c": "HIPS",
    "choice_d": "HIDS",
    "correct_answer": "C",
    "explanation": "When endpoints are connected without a network control point between them, a host-based solution is required. In this case, Lucca's specific requirement is to prevent attacks, rather than simply detect them, meaning that a HIPS is required to meet his needs. Many modern products combine HIPS capabilities with other features such as data loss prevention and system compliance profiling, so Lucca may end up with additional useful capabilities if he selects a product with those features.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 875,
    "question": "The company that Dan works for has recently migrated to a Service as a Service provider for its enterprise resource planning (ERP) software. In its traditional on-site ERP environment, Dan conducted regular port scans to help with security validation for the systems. What will Dan most likely have to do in this new environment?",
    "choice_a": "Use a different scanning tool.",
    "choice_b": "Rely on vendor testing and audits.",
    "choice_c": "Engage a third-party tester.",
    "choice_d": "Use a VPN to scan inside the vendor's security perimeter.",
    "correct_answer": "B",
    "explanation": "Most SaaS providers do not want their customers conducting port scans of their service, and many are glad to provide security assertions and attestations including audits, testing information, or contractual language that addresses potential security issues. Using a different scanning tool, engaging a third-party tester, and even using a VPN are not typically valid answers in a scenario like this.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      744,
      746,
      535,
      254,
      215
    ],
    "source": ""
  },
  {
    "id": 876,
    "question": "While investigating a malware infection, Lauren discovers that the hosts file for the system she is reviewing contains multiple entries as shown here:<br><code>0.0.0.0        symantec.com</code><br><code>0.0.0.0        mcafee.com</code><br><code>0.0.0.0        microsoft.com</code><br><code>0.0.0.0        kapersky.com</code><br>Why would the malware make this change?",
    "choice_a": "To redirect 0.0.0.0 to known sites",
    "choice_b": "To prevent antivirus updates",
    "choice_c": "To prevent other attackers from compromising the system",
    "choice_d": "To enable remote access to the system",
    "correct_answer": "B",
    "explanation": "Changing the hosts file has been used by various malware packages to prevent updates by stopping DNS resolution of the antivirus update server. Lauren should check to see whether the antivirus software on the system is up-to-date, but she will probably need to recommend a rebuild or reinstallation of the system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      702,
      691,
      733,
      692
    ],
    "source": ""
  },
  {
    "id": 877,
    "question": "Geoff is responsible for hardening systems on his network and discovers that a number of network appliances have exposed services including telnet, FTP, and web servers. What is his best option to secure these systems?",
    "choice_a": "Enable host firewalls.",
    "choice_b": "Install patches for those services.",
    "choice_c": "Turn off the services for each appliance.",
    "choice_d": "Place a network firewall between the devices and the rest of the network.",
    "correct_answer": "D",
    "explanation": "Geoff's only sure bet to prevent these services from being accessed is to put a network firewall in front of them. Many appliances enable services by default, but since they are appliances, they may not have host firewalls available to enable. They also often don't have patches available, and many appliances do not allow the services they provide to be disabled or modified.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      732,
      245,
      246,
      243,
      201
    ],
    "source": ""
  },
  {
    "id": 878,
    "question": "Tim needs to lock down a Windows workstation that has recently been scanned using nmap with the results shown here. He knows that the workstation needs to access websites and that the system is part of a Windows domain. What ports should he allow through the system's firewall for externally initiated connections? <br><img src=\"/question_assets/SSCP/c07uf003.png\"/>",
    "choice_a": "He should allow ports 80, 135, 139, and 445.",
    "choice_b": "He should allow ports 80, 445, and 3389.",
    "choice_c": "He should allow ports 135, 139, and 445.",
    "choice_d": "No ports should be open.",
    "correct_answer": "D",
    "explanation": "The uses described for the workstation that Tim is securing do not require inbound access to the system on any of these ports. Web browsing and Active Directory domain membership traffic can be handled by traffic initiated by the system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      254,
      243,
      231,
      201,
      263
    ],
    "source": ""
  },
  {
    "id": 879,
    "question": "What major issue would Charles face if he relied on hashing malware packages to identify malware packages?",
    "choice_a": "Hashing can be spoofed.",
    "choice_b": "Collisions can result in false positives.",
    "choice_c": "Hashing cannot identify unknown malware.",
    "choice_d": "Hashing relies on unencrypted malware samples.",
    "correct_answer": "C",
    "explanation": "Relying on hashing means that Charles will only be able to identify the specific versions of malware packages that have already been identified. This is a consistent problem with signature-based detections and malware. Packages commonly implement polymorphic capabilities, meaning that two instances of the same package will not have identical hashes because of changes meant to avoid signature-based detection systems.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      212,
      733,
      692,
      699
    ],
    "source": ""
  },
  {
    "id": 880,
    "question": "As part of her system hardening process for a Windows 10 workstation, Lauren runs the Microsoft Baseline System Analyzer. She sees the following result after MBSA runs. What can she determine from this scan? <br><img src=\"/question_assets/SSCP/c07uf004.png\"/>",
    "choice_a": "The system has been compromised, and shares allow all users to read and execute administrative files.",
    "choice_b": "The system has default administrative shares enabled.",
    "choice_c": "The system is part of a domain that uses administrative shares to manage systems.",
    "choice_d": "The shares are properly secured and pose no threat to the system.",
    "correct_answer": "B",
    "explanation": "Lauren can determine only that the default administrative shares are enabled. While administrative shares are useful for remote administration, they can pose a threat for systems that do not require them, and some security baselines suggest disabling them in the registry if they are not used.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 881,
    "question": "Susan is reviewing files on a Windows workstation and believes that <code>cmd.exe</code> has been replaced with a malware package. Which of the following is the best way to validate her theory?",
    "choice_a": "Submit <code>cmd.exe</code> to VirusTotal.",
    "choice_b": "Compare the hash of <code>cmd.exe</code> to a known good version.",
    "choice_c": "Check the file using the National Software Reference Library.",
    "choice_d": "Run <code>cmd.exe</code> to make sure its behavior is normal.",
    "correct_answer": "A",
    "explanation": "Susan's best option is to submit the file to a tool like VirusTotal, which will scan it for virus-like behaviors and known malware tools. Checking the hash using either a manual check or by using the National Software Reference Library can tell her whether the file matches a known good version but won't tell her if it includes malware. Running a suspect file is the worst option on the list!",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      692,
      691,
      704,
      259,
      229
    ],
    "source": ""
  },
  {
    "id": 882,
    "question": "Chris wants to prevent users from running a popular game on Windows workstations he is responsible for. How can Chris accomplish this for Windows 10 Pro workstations?",
    "choice_a": "Using application whitelisting to prevent all unallowed programs from running",
    "choice_b": "Using Windows Defender and adding the game to the blacklist file",
    "choice_c": "By listing in the Blocked Programs list via <code>secpol.msc</code>",
    "choice_d": "You cannot blacklist applications in Windows 10 without a third-party application.",
    "correct_answer": "A",
    "explanation": "Windows 10 Pro and Enterprise support application whitelisting. Chris can whitelist his allowed programs and then set the default mode to disallowed, preventing all other applications from running and thus, blacklisting the application. This can be a bit of a maintenance hassle but can be useful for high security environments or those in which limiting what programs can run is critical.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      694,
      693,
      703,
      259,
      266
    ],
    "source": ""
  },
  {
    "id": 883,
    "question": "Ian's company has an internal policy requiring that it perform regular port scans of all of its servers. Ian has been part of a recent effort to move his organization's servers to an infrastructure as a service provider. What change will Ian most likely need to make to his scanning efforts?",
    "choice_a": "Change scanning software.",
    "choice_b": "Follow the service provider's scan policies.",
    "choice_c": "Sign a security contract with the provider.",
    "choice_d": "Discontinue port scanning.",
    "correct_answer": "B",
    "explanation": "Most infrastructure as a service providers will allow their customers to perform security scans as long as they follow the rules and policies around such scans. Ian should review his vendor's security documentation and contact them for details if he has questions.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      745,
      217,
      246,
      245,
      231
    ],
    "source": ""
  },
  {
    "id": 884,
    "question": "Isaac wants to prevent hosts from connecting to known malware distribution domains. What type of solution can he use to do this without deploying endpoint protection software or an IPS?",
    "choice_a": "Route poisoning",
    "choice_b": "Anti-malware router filters",
    "choice_c": "Subdomain whitelisting",
    "choice_d": "DNS blackholing",
    "correct_answer": "D",
    "explanation": "DNS blackholing uses a list of known malicious domains or IP addresses and relies on listing the domains on an internal DNS server that provides a fake reply. Route poisoning prevents networks from sending data to a destination that is invalid. Routers do not typically have an anti-malware filter feature, and subdomain whitelisting was made up for this question.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 885,
    "question": "Senior management in Adam's company recently read a number of articles about massive ransomware attacks that successfully targeted organizations like the one that Adam is part of. Adam's organization already uses layered security solutions including a border IPS, firewalls between network zones, local host firewalls, antivirus software, and a configuration management system that applies recommended operating system best practice settings to their workstations. What should Adam recommend to minimize the impact of a similar ransomware outbreak at his organization?",
    "choice_a": "Honeypots",
    "choice_b": "Backups",
    "choice_c": "Anti-malware software",
    "choice_d": "A next-generation firewall appliance",
    "correct_answer": "B",
    "explanation": "In many cases, backups are the best method to minimize the impact of a ransomware outbreak. While preventative measures can help, malware packages continue to change more quickly than detective controls like anti-malware software and NGFW device manufacturers can react. A honeypot won't help Adam prevent ransomware, so it can be easily dismissed when answering this question.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      231,
      265
    ],
    "source": ""
  },
  {
    "id": 886,
    "question": "Lauren'ts screenshot shows behavioral analysis of the executed code.  From this, we can determine that the tool she used is a dyanamic analysis sandbox that runs the malware sample to determine what it does while also analyzing the file. <br><img src=\"/question_assets/SSCP/c07uf005.png\"/>",
    "choice_a": "A reverse engineering tool",
    "choice_b": "A static analysis sandbox",
    "choice_c": "A dynamic analysis sandbox",
    "choice_d": "A decompiler sandbox",
    "correct_answer": "C",
    "explanation": "Lauren's screenshot shows behavioral analysis of the executed code. From this, we can determine that malwr is a dynamic analysis sandbox that runs the malware sample to determine what it does while also analyzing the file.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      691,
      692,
      690,
      700,
      701
    ],
    "source": ""
  },
  {
    "id": 887,
    "question": "<br><img src=\"/question_assets/SSCP/c07uf006.png\"/>What component is identified by A in the image?",
    "choice_a": "Hypervisor",
    "choice_b": "Host operating system",
    "choice_c": "Guest operating system",
    "choice_d": "Physical hardware",
    "correct_answer": "C",
    "explanation": "The label A designates the guest operating systems in this environment. Each virtualization platform may run multiple guest operating systems, all of which share physical resources.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      696,
      534,
      697,
      698,
      695
    ],
    "source": ""
  },
  {
    "id": 888,
    "question": "<br><img src=\"/question_assets/SSCP/c07uf006.png\"/>What component is identified by B in the image?",
    "choice_a": "Hypervisor",
    "choice_b": "Host operating system",
    "choice_c": "Guest operating system",
    "choice_d": "Physical hardware",
    "correct_answer": "A",
    "explanation": "The label B designates the hypervisor in this environment. In a bare-metal virtualization environment, the hypervisor sits beneath the guest operating systems and controls access to memory, disk, CPU, and other system resources.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      535,
      536,
      697
    ],
    "source": ""
  },
  {
    "id": 889,
    "question": "<br><img src=\"/question_assets/SSCP/c07uf006.png\"/>What component is identified by C in the image?",
    "choice_a": "Hypervisor",
    "choice_b": "Host operating system",
    "choice_c": "Guest operating system",
    "choice_d": "Physical hardware",
    "correct_answer": "D",
    "explanation": "The label C designates the physical hardware in this environment. In a bare-metal virtualization environment, the physical hardware sits beneath the hypervisor, which moderates access by guest operating systems. There is no host operating system in a bare-metal virtualization approach.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      697,
      698,
      204
    ],
    "source": ""
  },
  {
    "id": 890,
    "question": "Frank discovers a missing Windows security patch during a vulnerability scan of a server in his organization's data center. Upon further investigation, he discovers that the system is virtualized. Where should he apply the patch?",
    "choice_a": "To the virtualized system",
    "choice_b": "The patch is not necessary",
    "choice_c": "To the domain controller",
    "choice_d": "To the virtualization platform",
    "correct_answer": "A",
    "explanation": "Virtualized systems run full versions of operating systems. If Frank's scan revealed a missing operating system patch when he scanned a virtualized server, the patch should be applied directly to that guest operating system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      696,
      697,
      698,
      695,
      734
    ],
    "source": ""
  },
  {
    "id": 891,
    "question": "Mike runs a vulnerability scan against his company's virtualization environment and finds the vulnerability shown here in several of the virtual hosts. What action should Mike take? <br><img src=\"/question_assets/SSCP/c07uf007.png\"/>",
    "choice_a": "No action is necessary because this is an informational report.",
    "choice_b": "Mike should disable HTTP on the affected devices.",
    "choice_c": "Mike should upgrade the version of OpenSSL on the affected devices.",
    "choice_d": "Mike should immediately upgrade the hypervisor.",
    "correct_answer": "A",
    "explanation": "This is an informational-level report that will be discovered on any server that supports the OPTIONS method. This is not a serious issue and is listed as an informational item, so Mike does not need to take any action to address it.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      695,
      734,
      208
    ],
    "source": ""
  },
  {
    "id": 892,
    "question": "During a recent vulnerability scan, Ed discovered that a web server running on his network has access to a database server that should be restricted. Both servers are running on his organization's VMware virtualization platform. Where should Ed look first to configure a security control to restrict this access?",
    "choice_a": "VMware",
    "choice_b": "Data center firewall",
    "choice_c": "Perimeter (Internet) firewall",
    "choice_d": "Intrusion prevention system",
    "correct_answer": "A",
    "explanation": "Because both of these hosts are located on the same virtualization platform, it is likely that the network traffic never leaves that environment and would not be controlled by an external network firewall or intrusion prevention system. Ed should first look at the internal configuration of the virtual network to determine whether he can apply the restriction there.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      245,
      254,
      732
    ],
    "source": ""
  },
  {
    "id": 893,
    "question": "Which one of the following protocols might be used within a virtualization platform for monitoring and managing the network?",
    "choice_a": "SNMP",
    "choice_b": "SMTP",
    "choice_c": "BGP",
    "choice_d": "EIGRP",
    "correct_answer": "A",
    "explanation": "The Simple Network Management Protocol (SNMP) uses traps and polling requests to monitor and manage both physical and virtual networks. The Simple Mail Transfer Protocol (SMTP) is an email transfer protocol. The Border Gateway Protocol (BGP) and Enhanced Interior Gateway Routing Protocol (EIGRP) are used to make routing decisions.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      254,
      246,
      245
    ],
    "source": ""
  },
  {
    "id": 894,
    "question": "Don completed a vulnerability scan of his organization's virtualization platform from an external host and discovered the vulnerability shown here. How should Don react? <br><img src=\"/question_assets/SSCP/c07uf008.png\"/>",
    "choice_a": "This is a critical issue that requires immediate adjustment of firewall rules.",
    "choice_b": "This issue has a very low severity and does not require remediation.",
    "choice_c": "This issue should be corrected as time permits.",
    "choice_d": "This is a critical issue, and Don should shut down the platform until it is corrected.",
    "correct_answer": "A",
    "explanation": "Although the vulnerability scan report does indicate that this is a low-severity vulnerability, Don must take this information in context. The management interface of a virtualization platform should never be exposed to external hosts, and it also should not use unencrypted credentials. In that context, this is a critical vulnerability that could allow an attacker to take control of a large portion of the computing environment. Don should work with security and network engineers to block this activity at the firewall as soon as possible. Shutting down the virtualization platform is not a good alternative because it would be extremely disruptive, and the firewall adjustment is equally effective from a security point of view.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      245,
      227,
      695
    ],
    "source": ""
  },
  {
    "id": 895,
    "question": "While conducting a vulnerability scan of his organization's data center, Renee discovers that the management interface for the organization's virtualization platform is exposed to the scanner. In typical operating circumstances, what is the proper exposure for this interface?",
    "choice_a": "Internet",
    "choice_b": "Internal networks",
    "choice_c": "No exposure",
    "choice_d": "Management network",
    "correct_answer": "D",
    "explanation": "The best practice for securing virtualization platforms is to expose the management interface only to a dedicated management network, accessible only to authorized engineers. This greatly reduces the likelihood of an attack against the virtualization platform.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      265,
      217,
      218
    ],
    "source": ""
  },
  {
    "id": 896,
    "question": "Angela wants to understand what a malware package does and executes it in a virtual machine that is instrumented using tools that will track what the program does, what changes it makes, and what network traffic it sends while allowing her to make changes on the system or to click on files as needed. What type of analysis has Angela performed?",
    "choice_a": "Manual code reversing",
    "choice_b": "Interactive behavior analysis",
    "choice_c": "Static property analysis",
    "choice_d": "Dynamic code analysis",
    "correct_answer": "B",
    "explanation": "Angela has performed interactive behavior analysis. This process involves executing a file in a fully instrumented environment and then tracking what occurs. Angela's ability to interact with the file is part of the interactive element and allows her to simulate normal user interactions as needed or to provide the malware with an environment where it can interact like it would in the wild.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      692,
      704,
      263,
      227,
      272
    ],
    "source": ""
  },
  {
    "id": 897,
    "question": "Derek sets up a series of virtual machines that are automatically created in a completely isolated environment. Once created, the systems are used to run potentially malicious software and files. The actions taken by those files and programs are recorded and then reported. What technique is Derek using?",
    "choice_a": "Sandboxing",
    "choice_b": "Reverse engineering",
    "choice_c": "Malware disassembly",
    "choice_d": "Darknet analysis",
    "correct_answer": "A",
    "explanation": "Derek has created a malware analysis sandbox and may opt to use tools like Cuckoo, Truman, Minibis, or a commercial analysis tool. If he pulls apart the files to analyze how they work, he would be engaging in reverse engineering, and doing code-level analysis of executable malware would require disassembly. Darknets are used to identify malicious traffic and aren't used in this way.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      692,
      534,
      261,
      267
    ],
    "source": ""
  },
  {
    "id": 898,
    "question": "Ian is reviewing the security architecture shown here. This architecture is designed to connect his local data center with an IaaS service provider that his company is using to provide overflow services. What component can be used at the points marked by question marks to provide a secure encrypted network connection? <br><img src=\"/question_assets/SSCP/c07uf009.png\"/>",
    "choice_a": "Firewall",
    "choice_b": "VPN",
    "choice_c": "IPS",
    "choice_d": "DLP",
    "correct_answer": "B",
    "explanation": "The diagram already shows a firewall in place on both sides of the network connection. Ian should place a VPN at the point marked by question marks to ensure that communications over the Internet are encrypted. IPS and DLP systems do provide added security controls, but they do not provide encrypted network connections.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      245,
      246,
      243,
      201,
      221
    ],
    "source": ""
  },
  {
    "id": 899,
    "question": "Which one of the following statements is true about virtualized operating systems?",
    "choice_a": "In bare-metal virtualization, all guest operating systems must be the same version.",
    "choice_b": "In bare-metal virtualization, all guest operating systems must be the same platform (e.g., Windows, RedHat, CentOS).",
    "choice_c": "In bare-metal virtualization, the host operating system and guest operating system platforms must be consistent.",
    "choice_d": "None of these statements is correct.",
    "correct_answer": "D",
    "explanation": "Bare-metal virtualization does not impose any requirements on the diversity of guest operating systems. It is common to find Linux and Windows systems running on the same platform. Bare-metal virtualization does not use a host operating system. Instead, it runs the hypervisor directly on top of the physical hardware.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      696,
      534,
      697,
      698,
      269
    ],
    "source": ""
  },
  {
    "id": 900,
    "question": "While reviewing output from netstat, John sees the following output. What should his next action be? <br><img src=\"/question_assets/SSCP/7_image1.png\"/>",
    "choice_a": "To capture traffic to 151.101.2.69 using Wireshark",
    "choice_b": "To initiate the organization's incident response plan",
    "choice_c": "To check to see whether 151.101.2.69 is a valid Microsoft address",
    "choice_d": "To ignore it; this is a false positive.",
    "correct_answer": "B",
    "explanation": "John has discovered a program that is both accepting connections and has an open connection, neither of which are typical for the Minesweeper game. Attackers often disguise trojans as innocuous applications, so John should follow his organization's incident response plan.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      701,
      699,
      700,
      734,
      267
    ],
    "source": ""
  },
  {
    "id": 901,
    "question": "As Lauren prepares her organization's security practices and policies, she wants to address as many threat vectors as she can using an awareness program. Which of the following threats can be most effectively dealt with via awareness?",
    "choice_a": "Attrition",
    "choice_b": "Impersonation",
    "choice_c": "Improper usage",
    "choice_d": "Web",
    "correct_answer": "B",
    "explanation": "Improper usage, which results from violations of an organization's acceptable use policies by authorized users can be reduced by implementing a strong awareness program. This will help ensure users know what they are permitted to do and what is prohibited. Attrition attacks focus on brute-force methods of attacking services, impersonation attacks include spoofing, man-in-the-middle attacks, and similar threats. Finally, web-based attacks focus on websites or web applications. Awareness may help with some specific web-based attacks like fake login sites, but many others would not be limited by Lauren's awareness efforts.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      259,
      266,
      256,
      214,
      263
    ],
    "source": ""
  },
  {
    "id": 902,
    "question": "Which one of the following mobile device strategies is most likely to result in the introduction of vulnerable devices to a network?",
    "choice_a": "COPE",
    "choice_b": "TLS",
    "choice_c": "BYOD",
    "choice_d": "MDM",
    "correct_answer": "C",
    "explanation": "Bring your own device (BYOD) strategies allow users to operate personally owned devices on corporate networks. These devices are more likely to contain vulnerabilities than those managed under a mobile device management (MDM) system or a corporate-owned, personally enabled (COPE) strategy. Transport Layer Security (TLS) is a network encryption protocol, not a mobile device strategy.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      705,
      707,
      706,
      732,
      264
    ],
    "source": ""
  },
  {
    "id": 903,
    "question": "Jarett needs to protect an application server against resource exhaustion attacks. Which of the following techniques is best suited to surviving a large-scale DDoS attack?",
    "choice_a": "Enable application sharding.",
    "choice_b": "Review each query and implement query optimization.",
    "choice_c": "Implement aggressive aging at the organization's firewall.",
    "choice_d": "Employ a CDN.",
    "correct_answer": "D",
    "explanation": "While application sharding and query optimization can help services respond under heavy loads, Jarett's best bet is to work with a content distribution network, or CDN, that has built-in DDoS mitigation technologies. This will allow his content to be accessible even if his primary service is taken offline and will spread the load to other servers during attacks, even if the CDN's anti-DDoS capabilities can't entirely mitigate the attack. Aggressive aging can help when implemented on a firewall and may help somewhat with survivability but is less useful for large scale DDoS attacks.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      252,
      231,
      695,
      693,
      265
    ],
    "source": ""
  },
  {
    "id": 904,
    "question": "Jennifer is an Active Directory domain administrator for her company and knows that a quickly spreading botnet relies on a series of domain names for command and control and that preventing access to those domain names will cause the malware infection that connects to the botnet to fail to take further action. Which of the following actions is her best option if she wants to prevent off-site Windows users from connecting to botnet command-and-control systems?",
    "choice_a": "Force a BGP update.",
    "choice_b": "Set up a DNS sinkhole.",
    "choice_c": "Modify the hosts file.",
    "choice_d": "Install an anti-malware application.",
    "correct_answer": "C",
    "explanation": "Jennifer can push an updated hosts file to her domain-connected systems that will direct traffic intended for known bad domains to the localhost or a safe system. She might want to work with a security analyst or other IT staff member to capture queries sent to that system to track any potentially infected workstations. A DNS sinkhole would work only if all the systems were using local DNS, and off-site users are likely to have DNS settings set by the local networks they connect to. Anti-malware applications may not have an update yet or may fail to detect the malware, and forcing a BGP update for third-party networks is likely a bad idea!",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      263,
      264,
      253,
      231,
      243
    ],
    "source": ""
  },
  {
    "id": 905,
    "question": "Several employees will need to travel with sensitive information on their laptops. Martin is concerned that one of those laptops may be lost or stolen. Which one of the following controls would best protect the data on stolen devices?",
    "choice_a": "FDE",
    "choice_b": "Strong passwords",
    "choice_c": "Cable lock",
    "choice_d": "IPS",
    "correct_answer": "A",
    "explanation": "Full disk encryption prevents anyone who gains possession of a device from accessing the data it contains, making it an ideal control to meet Martin's goal. Strong passwords may be bypassed by directly accessing the disk. Cable locks are not effective for devices used by travelers. Intrusion prevention systems are technical controls that would not affect someone who gained physical access to a device.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      227,
      244,
      252,
      265,
      231
    ],
    "source": ""
  },
  {
    "id": 906,
    "question": "Ben is an information security professional at an organization that is replacing its physical servers with virtual machines. As the organization builds its virtual environment, it is decreasing the number of physical servers it uses while purchasing more powerful servers to act as the virtualization platforms. <br>The IDS Ben is responsible for is used to monitor communications in the data center using a mirrored port on the data center switch. What traffic will Ben see once the majority of servers in the data center have been virtualized?",
    "choice_a": "The same traffic he currently sees",
    "choice_b": "All inter-VM traffic",
    "choice_c": "Only traffic sent outside the VM environment",
    "choice_d": "All inter-hypervisor traffic",
    "correct_answer": "C",
    "explanation": "One of the visibility risks of virtualization is that communication between servers and systems using virtual interfaces can occur \u201cinside\u201d the virtual environment. This means that visibility into traffic in the virtualization environment has to be purpose-built as part of its design. <br>Option D is correct but incomplete because inter-hypervisor traffic isn't the only traffic the IDS will see.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      696,
      534,
      263,
      272,
      261
    ],
    "source": ""
  },
  {
    "id": 907,
    "question": "Ben is an information security professional at an organization that is replacing its physical servers with virtual machines. As the organization builds its virtual environment, it is decreasing the number of physical servers it uses while purchasing more powerful servers to act as the virtualization platforms. <br>The VM administrators recommend enabling cut and paste between virtual machines. What security concern should Ben raise about this practice?",
    "choice_a": "It can cause a denial-of-service condition.",
    "choice_b": "It can serve as a covert channel.",
    "choice_c": "It can allow viruses to spread.",
    "choice_d": "It can bypass authentication controls.",
    "correct_answer": "B",
    "explanation": "Cut and paste between virtual machines can bypass normal network-based data loss prevention tools and monitoring tools like an IDS or IPS. Thus, it can act as a covert channel, allowing the transport of data between security zones. So far, cut and paste has not been used as a method for malware spread in virtual environments and has not been associated with denial-of-service attacks. Cut and paste requires users to be logged in and does not bypass authentication requirements.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      245,
      231,
      227,
      269,
      217
    ],
    "source": ""
  },
  {
    "id": 908,
    "question": "Ben is an information security professional at an organization that is replacing its physical servers with virtual machines. As the organization builds its virtual environment, it is decreasing the number of physical servers it uses while purchasing more powerful servers to act as the virtualization platforms. <br>Ben is concerned about exploits that allow VM escape. What option should Ben suggest to help limit the impact of VM escape exploits?",
    "choice_a": "Separate virtual machines onto separate physical hardware based on task or data types.",
    "choice_b": "Use VM escape detection tools on the underlying hypervisor.",
    "choice_c": "Restore machines to their original snapshots on a regular basis.",
    "choice_d": "Use a utility like Tripwire to look for changes in the virtual machines.",
    "correct_answer": "A",
    "explanation": "While virtual machine escape has been demonstrated only in laboratory environments, the threat is best dealt with by limiting what access to the underlying hypervisor can prove to a successful tracker. Segmenting by data types or access levels can limit the potential impact of a hypervisor compromise. If attackers can access the underlying system, restricting the breach to only similar data types or systems will limit the impact. Escape detection tools are not available on the market, restoring machines to their original snapshots will not prevent the exploit from occurring again, and Tripwire detects file changes and is unlikely to catch exploits that escape the virtual machines themselves.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      536,
      534,
      696,
      231,
      227
    ],
    "source": ""
  },
  {
    "id": 909,
    "question": "Michael is responsible for forensic investigations and is investigating a medium-severity security incident that involved the defacement of a corporate website. The web server in question ran on a virtualization platform, and the marketing team would like to get the website up and running as quickly as possible. What would be the most reasonable next step for Michael to take?",
    "choice_a": "Keep the website offline until the investigation is complete.",
    "choice_b": "Take the virtualization platform offline as evidence.",
    "choice_c": "Take a snapshot of the compromised system and use that for the investigation.",
    "choice_d": "Ignore the incident and focus on quickly restoring the website.",
    "correct_answer": "C",
    "explanation": "Michael should conduct his investigation, but there is a pressing business need to bring the website back online. The most reasonable course of action would be to take a snapshot of the compromised system and use the snapshot for the investigation, restoring the website to operation as quickly as possible while using the results of the investigation to improve the security of the site.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 910,
    "question": "Sonia recently removed an encrypted hard drive from a laptop and moved it to a new device because of a hardware failure. She is having difficulty accessing encrypted content on the drive despite that she knows the user's password. What hardware security feature is likely causing this problem?",
    "choice_a": "TCB",
    "choice_b": "TPM",
    "choice_c": "NIACAP",
    "choice_d": "RSA",
    "correct_answer": "B",
    "explanation": "The Trusted Platform Module (TPM) is a hardware security technique that stores an encryption key on a chip on the motherboard and prevents someone from accessing an encrypted drive by installing it in another computer.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      218,
      217,
      233,
      264,
      706
    ],
    "source": ""
  },
  {
    "id": 911,
    "question": "In an infrastructure as a service (IaaS) environment where a vendor supplies a customer with access to storage services, who is normally responsible for removing sensitive data from drives that are taken out of service?",
    "choice_a": "Customer's security team",
    "choice_b": "Customer's storage team",
    "choice_c": "Customer's vendor management team",
    "choice_d": "Vendor",
    "correct_answer": "D",
    "explanation": "In an infrastructure as a service environment, security duties follow a shared responsibility model. Since the vendor is responsible for managing the storage hardware, the vendor would retain responsibility for destroying or wiping drives as they are taken out of service. However, it is still the customer's responsibility to validate that the vendor's sanitization procedures meet their requirements prior to utilizing the vendor's storage services.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      697,
      535,
      536,
      227,
      233
    ],
    "source": ""
  },
  {
    "id": 912,
    "question": "Gary is concerned about applying consistent security settings to the many mobile devices used throughout his organization. What technology would best assist with this challenge?",
    "choice_a": "MDM",
    "choice_b": "IPS",
    "choice_c": "IDS",
    "choice_d": "SIEM",
    "correct_answer": "A",
    "explanation": "Mobile device management (MDM) products provide a consistent, centralized interface for applying security configuration settings to mobile devices.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      705,
      707,
      706,
      695,
      265
    ],
    "source": ""
  },
  {
    "id": 913,
    "question": "In a software as a service cloud computing environment, who is normally responsible for ensuring that appropriate firewall controls are in place to protect the application?",
    "choice_a": "Customer's security team",
    "choice_b": "Vendor",
    "choice_c": "Customer's networking team",
    "choice_d": "Customer's infrastructure management team",
    "correct_answer": "B",
    "explanation": "In a software as a service environment, the customer has no access to any underlying infrastructure, so firewall management is a vendor responsibility under the cloud computing shared responsibility model.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      536,
      697,
      744,
      746
    ],
    "source": ""
  },
  {
    "id": 914,
    "question": "Grace would like to implement application control technology in her organization. Users often need to install new applications for research and testing purposes, and she does not want to interfere with that process. At the same time, she would like to block the use of known malicious software. What type of application control would be appropriate in this situation?",
    "choice_a": "Blacklisting",
    "choice_b": "Graylisting",
    "choice_c": "Whitelisting",
    "choice_d": "Bluelisting",
    "correct_answer": "A",
    "explanation": "The blacklisting approach to application control allows users to install any software they want except for packages specifically identified by the administrator as prohibited. This would be an appropriate approach in a scenario where users should be able to install any nonmalicious software they want to use.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      694,
      693,
      695,
      703,
      706
    ],
    "source": ""
  },
  {
    "id": 915,
    "question": "In a virtualized computing environment, what component is responsible for enforcing separation between guest machines?",
    "choice_a": "Guest operating system",
    "choice_b": "Hypervisor",
    "choice_c": "Kernel",
    "choice_d": "Protection manager",
    "correct_answer": "B",
    "explanation": "The hypervisor is responsible for coordinating access to physical hardware and enforcing isolation between different virtual machines running on the same physical platform.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      535,
      536,
      697
    ],
    "source": ""
  },
  {
    "id": 916,
    "question": "During a third-party vulnerability scan and security test, Danielle's employer recently discovered that the embedded systems that were installed to manage her company's new buildings have a severe remote access vulnerability. The manufacturer has gone out of business, and there is no patch or update for the devices. What should Danielle recommend that her employer do about the hundreds of devices that are vulnerable?",
    "choice_a": "Identify a replacement device model and replace every device",
    "choice_b": "Turn off all the devices",
    "choice_c": "Move the devices to a secured network segment",
    "choice_d": "Reverse engineer the devices and build an in-house patch",
    "correct_answer": "C",
    "explanation": "The most reasonable choice presented is to move the devices to a secure and isolated network segment. This will allow the devices to continue to serve their intended function while preventing them from being compromised. All of the other scenarios either create major new costs or deprive her organization of the functionality that the devices were purchased to provide.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      231,
      201,
      266,
      237,
      246
    ],
    "source": ""
  },
  {
    "id": 917,
    "question": "Lauren's networking team has been asked to identify a technology that will allow them to dynamically change the organization's network by treating the network like code. What type of architecture should she recommend?",
    "choice_a": "A network that follows the 5-4-3 rule",
    "choice_b": "A converged network",
    "choice_c": "A software-defined network",
    "choice_d": "A hypervisor-based network",
    "correct_answer": "C",
    "explanation": "Software-defined networking provides a network architecture that can be defined and configured as code or software. This will allow Lauren's team to quickly change the network based on organizational requirements. The 5-4-3 rule is an old design rule for networks that relied on repeaters or hubs. A converged network carries multiple types of traffic such as voice, video, and data. A hypervisor-based network may be software defined, but it could also use traditional network devices running as virtual machines.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      696,
      535,
      534
    ],
    "source": ""
  },
  {
    "id": 918,
    "question": "Ben's organization has had an issue with unauthorized access to applications and workstations during the lunch hour when employees aren't at their desk. What are the best types of session management solutions for Ben to recommend to help prevent this type of access?",
    "choice_a": "Use session IDs for all access and verify system IP addresses of all workstations.",
    "choice_b": "Set session timeouts for applications and use password-protected screensavers with inactivity time-outs on workstations.",
    "choice_c": "Use session IDs for all applications and use password protected screensavers with inactivity timeouts on workstations.",
    "choice_d": "Set session timeouts for applications and verify system IP addresses of all workstations.",
    "correct_answer": "B",
    "explanation": "Since physical access to the workstations is part of the problem, setting application timeouts and password-protected screensavers with relatively short inactivity timeouts can help prevent unauthorized access. Using session IDs for all applications and verifying system IP addresses would be helpful for online attacks against applications.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      254,
      231,
      265,
      259,
      218
    ],
    "source": ""
  },
  {
    "id": 919,
    "question": "Harold recently added an input validation routine to a web application that is designed to remove any instances of the &lt;SCRIPT&gt; tag in user input.  What type of attack is Harold attempting to mitigate?",
    "choice_a": "SQL injection",
    "choice_b": "CSRF",
    "choice_c": "XSS",
    "choice_d": "Man-in-the-middle",
    "correct_answer": "C",
    "explanation": "Cross-site scripting (XSS) attacks seek to inject script code into a web application through unvalidated input.  By removing the &lt;SCRIPT&gt; tag from that input, Harold is seeking to prevent this type of attack from succeeding.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      266,
      243,
      695,
      694,
      701
    ],
    "source": ""
  },
  {
    "id": 920,
    "question": "Under what virtualization model does the virtualization platform separate the network control plane from the data plane and replace complex network devices with simpler devices that simply receive instructions from the controller?",
    "choice_a": "Virtual machines",
    "choice_b": "VSAN",
    "choice_c": "VLAN",
    "choice_d": "SDN",
    "correct_answer": "D",
    "explanation": "Software-defined networking separates the control plane from the data plane. Network devices then do not contain complex logic themselves but receive instructions from the SDN.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      696,
      245,
      254,
      237
    ],
    "source": ""
  },
  {
    "id": 921,
    "question": "Which one of the following terms is often used to describe a collection of unrelated patches released in a large collection?",
    "choice_a": "Hotfix",
    "choice_b": "Update",
    "choice_c": "Security fix",
    "choice_d": "Service pack",
    "correct_answer": "D",
    "explanation": "Hotfixes, updates, and security fixes are all synonyms for single patches designed to correct a single problem. Service packs are collections of many different updates that serve as a major update to an operating system or application.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      201,
      272,
      696,
      697
    ],
    "source": ""
  },
  {
    "id": 922,
    "question": "Brian recently joined an organization that runs the majority of its services on a virtualization platform located in its own data center but also leverages an IaaS provider for hosting its web services and an SaaS email system. What term best describes the type of cloud environment this organization uses?",
    "choice_a": "Public cloud",
    "choice_b": "Dedicated cloud",
    "choice_c": "Private cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "D",
    "explanation": "The scenario describes a mix of public cloud and private cloud services. This is an example of a hybrid cloud environment.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      536,
      534,
      696,
      745
    ],
    "source": ""
  },
  {
    "id": 923,
    "question": "Mark is considering replacing his organization's customer relationship management (CRM) solution with a new product that is available in the cloud. This new solution is completely managed by the vendor, and Mark's company will not have to write any code or manage any physical resources. What type of cloud solution is Mark considering?",
    "choice_a": "IaaS",
    "choice_b": "CaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "D",
    "explanation": "In a software as a service solution, the vendor manages both the physical infrastructure and the complete application stack, providing the customer with access to a fully managed application.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      697,
      696,
      744,
      746
    ],
    "source": ""
  },
  {
    "id": 924,
    "question": "Which one of the following statements best describes a zero-day vulnerability?",
    "choice_a": "An attacker who is new to the world of hacking",
    "choice_b": "A database attack that places the date 00/00/0000 in data tables in an attempt to exploit flaws in business logic",
    "choice_c": "An attack previously unknown to the security community",
    "choice_d": "An attack that sets the operating system date and time to 00/00/0000 and 00:00:00",
    "correct_answer": "C",
    "explanation": "Zero-day attacks are those that are previously unknown to the security community and, therefore, have no available patch. These are especially dangerous attacks because they may be highly effective until a solution becomes available.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      259,
      261,
      264,
      263,
      201
    ],
    "source": ""
  },
  {
    "id": 925,
    "question": "Melanie suspects that someone is using malicious software to steal computing cycles from her company. Which one of the following security tools would be in the best position to detect this type of incident?",
    "choice_a": "NIDS",
    "choice_b": "Firewall",
    "choice_c": "HIDS",
    "choice_d": "DLP",
    "correct_answer": "C",
    "explanation": "A host-based intrusion detection system (HIDS) may be able to detect unauthorized processes running on a system. The other controls mentioned, network intrusion detection systems (NIDSs), firewalls, and DLP systems, are network-based and may not notice rogue processes.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      701,
      700,
      690,
      699,
      703
    ],
    "source": ""
  },
  {
    "id": 926,
    "question": "Brandon observes that an authorized user of a system on his network recently misused his account to exploit a system vulnerability against a shared server that allowed him to gain root access to that server. What type of attack took place?",
    "choice_a": "Denial-of-service",
    "choice_b": "Privilege escalation",
    "choice_c": "Reconnaissance",
    "choice_d": "Brute force",
    "correct_answer": "B",
    "explanation": "The scenario describes a privilege escalation attack where a malicious insider with authorized access to a system misused that access to gain privileged credentials.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      254,
      259,
      260,
      262,
      267
    ],
    "source": ""
  },
  {
    "id": 927,
    "question": "Roger recently accepted a new position as a security professional at a company that runs its entire IT infrastructure within an IaaS environment. Which one of the following would most likely be the responsibility of Roger's firm?",
    "choice_a": "Configuring the network firewall",
    "choice_b": "Applying hypervisor updates",
    "choice_c": "Patching operating systems",
    "choice_d": "Wiping drives prior to disposal",
    "correct_answer": "C",
    "explanation": "In an infrastructure as a service environment, the vendor is responsible for hardware- and network-related responsibilities. These include configuring network firewalls, maintaining the hypervisor, and managing physical equipment. The customer retains responsibility for patching operating systems on its virtual machine instances.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      536,
      534,
      697,
      744
    ],
    "source": ""
  },
  {
    "id": 928,
    "question": "Renee is a software developer who writes code in Node.js for her organization. The company is considering moving from a self-hosted Node.js environment to one where Renee will run her code on application servers managed by a cloud vendor. What type of cloud solution is Renee's company considering?",
    "choice_a": "IaaS",
    "choice_b": "CaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "C",
    "explanation": "In a platform as a service solution, the customer supplies application code that the vendor then executes on its own infrastructure.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      536,
      697,
      698,
      744
    ],
    "source": ""
  },
  {
    "id": 929,
    "question": "Lauren wants to ensure that her users run only the software that her organization has approved. What technology should she deploy?",
    "choice_a": "Blacklisting",
    "choice_b": "Configuration management",
    "choice_c": "Whitelisting",
    "choice_d": "Graylisting",
    "correct_answer": "C",
    "explanation": "A whitelist of allowed applications will ensure that Lauren's users can run only the applications that she preapproves. Blacklists would require her to maintain a list of every application that she doesn't want to allow, which is an almost impossible task. Graylisting is not a technology option, and configuration management can be useful for making sure the right applications are on a PC but typically can't directly prevent users from running undesired applications or programs.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      265,
      695,
      266,
      259,
      201
    ],
    "source": ""
  },
  {
    "id": 930,
    "question": "Which one of the following files is most likely to contain a macro virus?",
    "choice_a": "<code>projections.doc</code>",
    "choice_b": "<code>command.com</code>",
    "choice_c": "<code>command.exe</code>",
    "choice_d": "<code>loopmaster.exe</code>",
    "correct_answer": "A",
    "explanation": "Macro viruses are most commonly found in office productivity documents, such as Microsoft Word documents that end in the <code>.doc</code> or <code>.docx</code> extension. They are not commonly found in executable files with the <code>.com</code> or <code>.exe</code> extensions.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      702,
      703,
      699,
      207,
      201
    ],
    "source": ""
  },
  {
    "id": 931,
    "question": "What type of malware is characterized by spreading from system to system under its own power by exploiting vulnerabilities that do not require user intervention?",
    "choice_a": "Trojan horse",
    "choice_b": "Virus",
    "choice_c": "Logic bomb",
    "choice_d": "Worm",
    "correct_answer": "D",
    "explanation": "Worms have built-in propagation mechanisms that do not require user interaction, such as scanning for systems containing known vulnerabilities and then exploiting those vulnerabilities to gain access. Viruses and Trojan horses typically require user interaction to spread. Logic bombs do not spread from system to system but lie in wait until certain conditions are met, triggering the delivery of their payload.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      732,
      733,
      701,
      702,
      264
    ],
    "source": ""
  },
  {
    "id": 932,
    "question": "Martin is inspecting a system where the user reported unusual activity, including disk activity when the system is idle, and abnormal CPU and network usage. He suspects that the machine is infected by a virus but scans come up clean. What malware technique might be in use here that would explain the clean scan results?",
    "choice_a": "File infector virus",
    "choice_b": "MBR virus",
    "choice_c": "Service injection virus",
    "choice_d": "Stealth virus",
    "correct_answer": "D",
    "explanation": "One possibility for the clean scan results is that the virus is using stealth techniques, such as intercepting read requests from the antivirus software and returning a correct-looking version of the infected file. The system may also be the victim of a zero-day attack, using a virus that is not yet included in the signature definition files provided by the antivirus vendor.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      732,
      733,
      703,
      210
    ],
    "source": ""
  },
  {
    "id": 933,
    "question": "TJ is inspecting a system where the user reported a strange error message and the inability to access files. He sees the window shown here. What type of malware should TJ suspect? <br><img src=\"/question_assets/SSCP/c07uf010.png\"/>",
    "choice_a": "Service injection",
    "choice_b": "Encrypted virus",
    "choice_c": "SQL injection",
    "choice_d": "Ransomware",
    "correct_answer": "D",
    "explanation": "Messages similar to the one shown in the figure are indicative of a ransomware attack. The attacker encrypts files on a user's hard drive and then demands a ransom, normally paid in Bitcoin, for the decryption key required to restore access to the original content. Encrypted viruses, on the other hand, use encryption to hide themselves from antivirus mechanisms and do not alter other contents on the system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      201,
      227,
      233,
      202,
      207
    ],
    "source": ""
  },
  {
    "id": 934,
    "question": "Which of the following is not a type of attack used against access controls?",
    "choice_a": "Dictionary attack",
    "choice_b": "Brute-force attack",
    "choice_c": "Teardrop",
    "choice_d": "Man-in-the-middle attack",
    "correct_answer": "C",
    "explanation": "Dictionary, brute-force, and man-in-the-middle attacks are all types of attacks that are frequently aimed at access controls. Teardrop attacks are a type of denial-of-service attack.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      62,
      60,
      61,
      50,
      55
    ],
    "source": ""
  },
  {
    "id": 935,
    "question": "George is assisting a prosecutor with a case against a hacker who attempted to break into the computer systems at George's company. He provides system logs to the prosecutor for use as evidence, but the prosecutor insists that George testify in court about how he gathered the logs. What rule of evidence requires George's testimony?",
    "choice_a": "Testimonial evidence rule",
    "choice_b": "Parol evidence rule",
    "choice_c": "Best evidence rule",
    "choice_d": "Hearsay rule",
    "correct_answer": "D",
    "explanation": "The hearsay rule says that a witness cannot testify about what someone else told them, except under specific exceptions. The courts have applied the hearsay rule to include the concept that attorneys may not introduce logs into evidence unless they are authenticated by the system administrator. The best evidence rule states that copies of documents may not be submitted into evidence if the originals are available. The parol evidence rule states that if two parties enter into a written agreement, that written document is assumed to contain all the terms of the agreement. Testimonial evidence is a type of evidence, not a rule of evidence.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      659,
      658,
      657,
      711,
      640
    ],
    "source": ""
  },
  {
    "id": 936,
    "question": "Jim has been asked to individually identify devices that users are bringing to work as part of a new BYOD policy. The devices will not be joined to a central management system like\u00a0Active Directory, but he still needs to uniquely identify the systems. Which of the following options will provide Jim with the best means of reliably identifying each unique device?",
    "choice_a": "Record the MAC address of each system.",
    "choice_b": "Require users to fill out a form to register each system.",
    "choice_c": "Scan each system using a port scanner.",
    "choice_d": "Use device fingerprinting via a web-based registration system.",
    "correct_answer": "D",
    "explanation": "Device fingerprinting via a web portal can require user authentication and can gather data like operating systems, versions, software information, and many other factors that can uniquely identify systems. Using an automated fingerprinting system is preferable to handling manual registration, and pairing user authentication with data gathering provides more detail than a port scan. MAC addresses can be spoofed, and systems may have more than one depending on how many network interfaces they have, which can make unique identification challenging.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      705,
      706,
      707,
      268,
      243
    ],
    "source": ""
  },
  {
    "id": 937,
    "question": "Greg would like to implement application control technology in his organization. He would like to limit users to installing only approved software on their systems. What type of application control would be appropriate in this situation?",
    "choice_a": "Blacklisting",
    "choice_b": "Graylisting",
    "choice_c": "Whitelisting",
    "choice_d": "Bluelisting",
    "correct_answer": "C",
    "explanation": "The whitelisting approach to application control allows users to install only those software packages specifically approved by administrators. This would be an appropriate approach in a scenario where application installation needs to be tightly controlled.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      693,
      694,
      695,
      703,
      701
    ],
    "source": ""
  },
  {
    "id": 938,
    "question": "Which pair of the following factors is key for user acceptance of biometric identification systems?",
    "choice_a": "The FAR and FRR",
    "choice_b": "The throughput rate and the time required to enroll",
    "choice_c": "The CER and the ERR",
    "choice_d": "How often users must reenroll and the reference profile requirements",
    "correct_answer": "B",
    "explanation": "Biometric systems can face major usability challenges if the time to enroll is long (more than a couple of minutes) and if the speed at which the biometric system is able to scan and accept or reject the user is too slow. FAR and FRR may be important in the design decisions made by administrators or designers, but they aren't typically visible to users. CER and ERR are the same and are the point where FAR and FRR meet. Reference profile requirements are a system requirement, not a user requirement.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      484,
      286,
      275,
      320,
      7
    ],
    "source": ""
  },
  {
    "id": 939,
    "question": "Sally is wiring a gigabit Ethernet network. What cabling choices should she make to ensure she can use her network at the full 1000 Mbps she wants to provide to her users?",
    "choice_a": "Cat 5 and Cat 6",
    "choice_b": "Cat 5e and Cat 6",
    "choice_c": "Cat 4e and Cat 5e",
    "choice_d": "Cat 6 and Cat 7",
    "correct_answer": "B",
    "explanation": "Category 5e and Category 6 UTP cable are both rated to 1000 Mbps. Cat 5 (not Cat 5e) is rated only to 100 Mbps, whereas Cat 7 is rated to 10 Gbps. There is no Cat 4e.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      681,
      682,
      675,
      683,
      504
    ],
    "source": ""
  },
  {
    "id": 940,
    "question": "Alex has been with the university he works at for more than 10 years. During that time, he has been a system administrator and a database administrator, and he has worked in the university's help desk. He is now a manager for the team that runs the university's web applications. Using the provisioning diagram shown here, answer the following question. <br><img src=\"/question_assets/SSCP/c08uf001.png\"/>If Alex hires a new employee and the employee's account is provisioned after HR manually inputs information into the provisioning system based on data Alex provides via a series of forms, what type of provisioning has occurred?",
    "choice_a": "Discretionary account provisioning",
    "choice_b": "Workflow-based account provisioning",
    "choice_c": "Automated account provisioning",
    "choice_d": "Self-service account provisioning",
    "correct_answer": "B",
    "explanation": "Provisioning that occurs through an established workflow, such as through an HR process, is workflow-based account provisioning. If Alex had set up accounts for his new hire on the systems he manages, he would have been using discretionary account provisioning. If the provisioning system allowed the new hire to sign up for an account on their own, they would have used self-service account provisioning, and if there was a central, software-driven process, rather than HR forms, it would have been automated account provisioning.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      709,
      708,
      710,
      542,
      549
    ],
    "source": ""
  },
  {
    "id": 941,
    "question": "Alex has been with the university he works at for more than 10 years. During that time, he has been a system administrator and a database administrator, and he has worked in the university's help desk. He is now a manager for the team that runs the university's web applications. Using the provisioning diagram shown here, answer the following question. <br><img src=\"/question_assets/SSCP/c08uf001.png\"/>Alex has access to B, C, and D. What concern should he raise to the university's identity management team?",
    "choice_a": "The provisioning process did not give him the rights he needs.",
    "choice_b": "He has excessive privileges.",
    "choice_c": "Privilege creep may be taking place.",
    "choice_d": "Logging is not properly enabled.",
    "correct_answer": "C",
    "explanation": "As Alex has changed roles, he retained access to systems that he no longer administers. The provisioning system has provided rights to workstations and the application servers he manages, but he should not have access to the databases he no longer administers. Privilege levels are not specified, so we can't determine whether he has excessive rights. Logging may or may not be enabled, but it isn't possible to tell from the diagram or problem.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      542,
      557,
      420,
      273,
      321
    ],
    "source": ""
  },
  {
    "id": 942,
    "question": "Alex has been with the university he works at for more than 10 years. During that time, he has been a system administrator and a database administrator, and he has worked in the university's help desk. He is now a manager for the team that runs the university's web applications. Using the provisioning diagram shown here, answer the following question. <br><img src=\"/question_assets/SSCP/c08uf001.png\"/>When Alex changes roles, what should occur?",
    "choice_a": "He should be deprovisioned, and a new account should be created.",
    "choice_b": "He should have his new rights added to his existing account.",
    "choice_c": "He should be provisioned for only the rights that match his role.",
    "choice_d": "He should have his rights set to match those of the person he is replacing.",
    "correct_answer": "C",
    "explanation": "When a user's role changes, they should be provisioned based on their role and other access entitlements. Deprovisioning and reprovisioning is time-consuming and can lead to problems with changed IDs and how existing credentials work. Simply adding new rights leads to privilege creep, and matching another user's rights can lead to excessive privileges because of privilege creep for that other user.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      542,
      549,
      420,
      330,
      19
    ],
    "source": ""
  },
  {
    "id": 943,
    "question": "Vivian works for a chain of retail stores and would like to use a software product that restricts the software used on point-of-sale terminals to those packages on a preapproved list. What approach should Vivian use?",
    "choice_a": "Antivirus",
    "choice_b": "Heuristic",
    "choice_c": "Whitelist",
    "choice_d": "Blacklist",
    "correct_answer": "C",
    "explanation": "The blacklist approach to application control blocks certain prohibited packages but allows the installation of other software on systems. The whitelist approach uses the reverse philosophy and allows only approved software. Antivirus software would only detect the installation of malicious software after the fact. Heuristic detection is a variant of antivirus software.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      690,
      254,
      264,
      267,
      201
    ],
    "source": ""
  },
  {
    "id": 944,
    "question": "What type of motion detector senses changes in the electromagnetic fields in monitored areas?",
    "choice_a": "Infrared",
    "choice_b": "Wave pattern",
    "choice_c": "Capacitance",
    "choice_d": "Photoelectric",
    "correct_answer": "C",
    "explanation": "Capacitance motion detectors monitor the electromagnetic field in a monitored area, sensing disturbances that correspond to motion.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      724,
      588,
      590,
      721,
      583
    ],
    "source": ""
  },
  {
    "id": 945,
    "question": "Don's company is considering the use of an object-based storage system where data is placed in a vendor-managed storage environment through the use of API calls. What type of cloud computing service is in use?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "CaaS",
    "choice_d": "SaaS",
    "correct_answer": "A",
    "explanation": "In this scenario, the vendor is providing object-based storage, a core infrastructure service. Therefore, this is an example of infrastructure as a service (IaaS).",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      535,
      534,
      746,
      697,
      696
    ],
    "source": ""
  },
  {
    "id": 946,
    "question": "What is the minimum interval at which an organization should conduct business continuity plan refresher training for those with specific business continuity roles?",
    "choice_a": "Weekly",
    "choice_b": "Monthly",
    "choice_c": "Semiannually",
    "choice_d": "Annually",
    "correct_answer": "D",
    "explanation": "Individuals with specific business continuity roles should receive training on at least an annual basis.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      648,
      650,
      649,
      79,
      86
    ],
    "source": ""
  },
  {
    "id": 947,
    "question": "What type of log file is shown in this figure? <br><img src=\"/question_assets/SSCP/c08uf002.png\"/>",
    "choice_a": "Application",
    "choice_b": "Web server",
    "choice_c": "System",
    "choice_d": "Firewall",
    "correct_answer": "D",
    "explanation": "The log entries contained in this example show the allow/deny status for inbound and outbound TCP and UDP sessions. This is, therefore, an example of a firewall log.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      712,
      713,
      711,
      96,
      75
    ],
    "source": ""
  },
  {
    "id": 948,
    "question": "Which one of the following technologies is not normally a capability of mobile device management (MDM) solutions?",
    "choice_a": "Remotely wiping the contents of a mobile device",
    "choice_b": "Assuming control of a nonregistered BYOD mobile device",
    "choice_c": "Enforcing the use of device encryption",
    "choice_d": "Managing device backups",
    "correct_answer": "B",
    "explanation": "MDM products do not have the capability of assuming control of a device not currently managed by the organization. This would be equivalent to hacking into a device owned by someone else and might constitute a crime.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      705,
      707,
      706,
      701,
      702
    ],
    "source": ""
  },
  {
    "id": 949,
    "question": "Alex is preparing to solicit bids for a penetration test of his company's network and systems. He wants to maximize the effectiveness of the testing rather than the realism of the test. What type of penetration test should he require in his bidding process?",
    "choice_a": "Black box",
    "choice_b": "Crystal box",
    "choice_c": "Gray box",
    "choice_d": "Zero box",
    "correct_answer": "B",
    "explanation": "Crystal-box penetration testing, which is also sometimes called white-box penetration testing, provides the tester with information about networks, systems, and configurations, allowing highly effective testing. It doesn't simulate an actual attack like black-and gray-box testing can and thus, does not have the same realism, and it can lead to attacks succeeding that would fail in a zero- or limited-knowledge attack.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      629,
      602,
      617,
      628,
      59
    ],
    "source": ""
  },
  {
    "id": 950,
    "question": "What RADIUS alternative is commonly used for Cisco network gear and supports two-factor authentication?",
    "choice_a": "RADIUS+",
    "choice_b": "TACACS+",
    "choice_c": "XTACACS",
    "choice_d": "Kerberos",
    "correct_answer": "B",
    "explanation": "TACACS+ is the most modern version of TACACS, the Terminal Access Controller Access-Control System. It is a Cisco proprietary protocol with added features beyond what RADIUS provides, meaning it is commonly used on Cisco networks. XTACACS is an earlier version, Kerberos is a network authentication protocol rather than a remote user authentication protocol, and RADIUS+ is a made-up term.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      183,
      189,
      182,
      188,
      186
    ],
    "source": ""
  },
  {
    "id": 951,
    "question": "What type of fire extinguisher is useful against liquid-based fires?",
    "choice_a": "Class A",
    "choice_b": "Class B",
    "choice_c": "Class C",
    "choice_d": "Class D",
    "correct_answer": "B",
    "explanation": "Class B fire extinguishers use carbon dioxide, halon, or soda acid as their suppression material and are useful against liquid-based fires. Water may not be used against liquid-based fires because it may cause the burning liquid to splash, and many burning liquids, such as oil, will float on water.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      715,
      714,
      716,
      584,
      582
    ],
    "source": ""
  },
  {
    "id": 952,
    "question": "Which one of the following components should be included in an organization's emergency response guidelines?",
    "choice_a": "Immediate response procedures",
    "choice_b": "Long-term business continuity protocols",
    "choice_c": "Activation procedures for the organization's cold sites",
    "choice_d": "Contact information for ordering equipment",
    "correct_answer": "A",
    "explanation": "The emergency response guidelines should include the immediate steps an organization should follow in response to an emergency situation. These include immediate response procedures, a list of individuals who should be notified of the emergency, and secondary response procedures for first responders. They do not include long-term actions such as activating business continuity protocols, ordering equipment, or activating DR sites.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      99,
      71,
      69,
      101,
      648
    ],
    "source": ""
  },
  {
    "id": 953,
    "question": "Which one of the following disaster recovery test types involves the actual activation of the disaster recovery facility?",
    "choice_a": "Simulation test",
    "choice_b": "Tabletop exercise",
    "choice_c": "Parallel test",
    "choice_d": "Checklist review",
    "correct_answer": "C",
    "explanation": "During a parallel test, the team activates the disaster recovery site for testing, but the primary site remains operational. A simulation test involves a roleplay of a prepared scenario overseen by a moderator. Responses are assessed to help improve the organization's response process. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      656,
      654,
      655,
      495,
      651
    ],
    "source": ""
  },
  {
    "id": 954,
    "question": "Susan is configuring her network devices to use syslog. What should she set to ensure that she is notified about issues but does not receive normal operational issue messages?",
    "choice_a": "The facility code",
    "choice_b": "The log priority",
    "choice_c": "The security level",
    "choice_d": "The severity level",
    "correct_answer": "D",
    "explanation": "Implementations of syslog vary, but most provide a setting for severity level, allowing configuration of a value that determines what messages are sent. Typical severity levels include debug, informational, notice, warning, error, critical, alert, and emergency. The facility code is also supported by syslog but is associated with which services are being logged. Security level and log priority are not typical syslog settings.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      609,
      610,
      611,
      604,
      605
    ],
    "source": ""
  },
  {
    "id": 955,
    "question": "While Lauren is monitoring traffic on two ends of a network connection, she sees traffic that is inbound to a public IP address show up inside the production network bound for an internal host that uses an RFC 1918 reserved address. What technology should she expect is in use at the network border?",
    "choice_a": "NAT",
    "choice_b": "VLANs",
    "choice_c": "S/NAT",
    "choice_d": "BGP",
    "correct_answer": "A",
    "explanation": "Network address translation (NAT) translates an internal address to an external address. VLANs are used to logically divide networks, BGP is a routing protocol, and S/NAT is a made-up term.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      245,
      237,
      236,
      263,
      201
    ],
    "source": ""
  },
  {
    "id": 956,
    "question": "Michelle is in charge of her organization's mobile device management efforts and handles lost and stolen devices. Which of the following recommendations will provide the most assurance to her organization that data will not be lost if a device is stolen?",
    "choice_a": "Mandatory passcodes and application management",
    "choice_b": "Full device encryption and mandatory passcodes",
    "choice_c": "Remote wipe and GPS tracking",
    "choice_d": "Enabling GPS tracking and full device encryption",
    "correct_answer": "B",
    "explanation": "While full device encryption doesn't guarantee that data cannot be accessed, it provides Michelle's best option for preventing data from being lost with a stolen device when paired with a passcode. Mandatory passcodes and application management can help prevent application-based attacks and unwanted access to devices but won't keep the data secure if the device is lost. Remote wipe and GPS location is useful if the thief allows the device to connect to a cellular or Wi-Fi network. Unfortunately, many modern thieves immediately take steps to ensure that the device will not be trackable or allowed to connect to a network before they capture data or wipe the device for resale.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      227,
      244,
      252,
      256,
      233
    ],
    "source": ""
  },
  {
    "id": 957,
    "question": "Dogs, guards, and fences are all common examples of what type of control?",
    "choice_a": "Detective",
    "choice_b": "Recovery",
    "choice_c": "Administrative",
    "choice_d": "Physical",
    "correct_answer": "D",
    "explanation": "Dogs, guards, and fences are all examples of physical controls. While dogs and guards might detect a problem, fences cannot, so they are not all examples of detective controls. None of these controls would help repair or restore functionality after an issue, and thus, they are not recovery controls, nor are they administrative controls that involve policy or procedures, although the guards might refer to them when performing their duties.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      588,
      26,
      574,
      573,
      575
    ],
    "source": ""
  },
  {
    "id": 958,
    "question": "In this diagram of the TCP three-way handshake, what should system A send to system B in step 3? <br><img src=\"/question_assets/SSCP/c08uf003.png\"/>",
    "choice_a": "ACK",
    "choice_b": "SYN",
    "choice_c": "FIN",
    "choice_d": "RST",
    "correct_answer": "A",
    "explanation": "System A should send an ACK to end the three-way handshake. The TCP three-way handshake is SYN, SYN/ACK, ACK.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      717,
      718,
      719,
      179,
      504
    ],
    "source": ""
  },
  {
    "id": 959,
    "question": "In which cloud computing model does a customer share computing infrastructure with other customers of the cloud vendor where one customer may not know the other's identity?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Community cloud",
    "choice_d": "Shared cloud",
    "correct_answer": "A",
    "explanation": "In the public cloud computing model, the vendor builds a single platform that is shared among many different customers. This is also known as the shared tenancy model.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      535,
      534,
      696,
      697,
      536
    ],
    "source": ""
  },
  {
    "id": 960,
    "question": "The large business that Jack works for has been using noncentralized logging for years. They have recently started to implement centralized logging, however, and as they reviewed logs, they discovered a breach that appeared to have involved a malicious insider. <br>When the breach was discovered and the logs were reviewed, it was discovered that the attacker had purged the logs on the system that they compromised. How can this be prevented in the future?",
    "choice_a": "Encrypt local logs.",
    "choice_b": "Require administrative access to change logs.",
    "choice_c": "Enable log rotation.",
    "choice_d": "Send logs to a bastion host.",
    "correct_answer": "D",
    "explanation": "Sending logs to a secure log server, sometimes called a bastion host, is the most effective way to ensure that logs survive a breach. Encrypting local logs won't stop an attacker from deleting them, and requiring administrative access won't stop attackers who have breached a machine and acquired escalated privileges. Log rotation archives logs based on time or file size and can also purge logs after a threshold is hit. Rotation won't prevent an attacker from purging logs.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      61,
      59,
      62,
      741,
      609
    ],
    "source": ""
  },
  {
    "id": 961,
    "question": "The large business that Jack works for has been using noncentralized logging for years. They have recently started to implement centralized logging, however, and as they reviewed logs, they discovered a breach that appeared to have involved a malicious insider. <br>How can Jack detect issues like this using his organization's new centralized logging?",
    "choice_a": "Deploy and use an IDS.",
    "choice_b": "Send logs to a central logging server.",
    "choice_c": "Deploy and use a SIEM.",
    "choice_d": "Use syslog.",
    "correct_answer": "C",
    "explanation": "A security information and event management (SIEM) tool is designed to provide automated analysis and monitoring of logs and security events. A SIEM tool that receives access to logs can help detect and alert on events like logs being purged or other breach indicators. An IDS can help detect intrusions, but IDSs are not typically designed to handle central logs. A central logging server can receive and store logs but won't help with analysis without taking additional actions. Syslog is simply a log format.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      40,
      61,
      609,
      625,
      53
    ],
    "source": ""
  },
  {
    "id": 962,
    "question": "The large business that Jack works for has been using noncentralized logging for years. They have recently started to implement centralized logging, however, and as they reviewed logs, they discovered a breach that appeared to have involved a malicious insider. <br>How can Jack best ensure accountability for actions taken on systems in his environment?",
    "choice_a": "Log review and require digital signatures for each log.",
    "choice_b": "Require authentication for all actions taken and capture logs centrally.",
    "choice_c": "Log the use of administrative credentials and encrypt log data in transit.",
    "choice_d": "Require authorization and capture logs centrally.",
    "correct_answer": "B",
    "explanation": "Requiring authentication can help provide accountability by ensuring that any action taken can be tracked back to a specific user. Storing logs centrally ensures that users can't erase the evidence of actions that they have taken. Log review can be useful when identifying issues, but digital signatures are not a typical part of a logging environment. Logging the use of administrative credentials helps for those users but won't cover all users, and encrypting the logs doesn't help with accountability. Authorization helps, but being able to specifically identify users through authentication is more important.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      609,
      610,
      622,
      40,
      53
    ],
    "source": ""
  },
  {
    "id": 963,
    "question": "What type of firewall uses multiple proxy servers that filter traffic based on analysis of the protocols used for each service?",
    "choice_a": "A static packet filtering firewall",
    "choice_b": "An application-level gateway firewall",
    "choice_c": "A circuit-level gateway firewall",
    "choice_d": "A stateful inspection firewall",
    "correct_answer": "B",
    "explanation": "An application-level gateway firewall uses proxies for each service it filters. Each proxy is designed to analyze traffic for its specific traffic type, allowing it to better understand valid traffic and to prevent attacks. Static packet filters and circuit-level gateways simply look at the source, destination, and ports in use, whereas a stateful packet inspection firewall can track the status of communication and allow or deny traffic based on that understanding.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      689,
      684,
      685,
      686,
      687
    ],
    "source": ""
  },
  {
    "id": 964,
    "question": "James is building a disaster recovery plan for his organization and would like to determine the amount of acceptable data loss after an outage. What variable is James determining?",
    "choice_a": "SLA",
    "choice_b": "RTO",
    "choice_c": "MTD",
    "choice_d": "RPO",
    "correct_answer": "D",
    "explanation": "The recovery point objective (RPO) identifies the maximum amount of data, measured in time, that may be lost during a recovery effort. The recovery time objective (RTO) is the amount of time expected to return an IT service or component to operation after a failure. The maximum tolerable downtime (MTD) is the longest amount of time that an IT service or component may be unavailable without causing serious damage to the organization. Service-level agreements (SLAs) are written contracts that document service expectations.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      495,
      496,
      654,
      653,
      497
    ],
    "source": ""
  },
  {
    "id": 965,
    "question": "Which one of the following is not one of the canons of the ISC2 Code of Ethics?",
    "choice_a": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "choice_b": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_c": "Provide diligent and competent service to principals.",
    "choice_d": "Maintain competent records of all investigations and assessments.",
    "correct_answer": "D",
    "explanation": "The four canons of the ISC2 code of ethics are to protect society, the common good, necessary public trust and confidence, and the infrastructure; act honorably, honestly, justly, responsibly, and legally; provide diligent and competent service to principals; and advance and protect the profession.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      31,
      30,
      32,
      33,
      29
    ],
    "source": ""
  },
  {
    "id": 966,
    "question": "Dave is responsible for password security in his organization and would like to strengthen the security of password files. He would like to defend his organization against the use of rainbow tables. Which one of the following techniques is specifically designed to frustrate the use of rainbow tables?",
    "choice_a": "Password expiration policies",
    "choice_b": "Salting",
    "choice_c": "User education",
    "choice_d": "Password complexity policies",
    "correct_answer": "B",
    "explanation": "Rainbow tables use precomputed password hashes to conduct cracking attacks against password files. They may be frustrated by the use of salting, which adds a specified value to the password prior to hashing, making it much more difficult to perform precomputation. Password expiration policies, password complexity policies, and user education may all contribute to password security, but they are not direct defenses against the use of rainbow tables.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      751,
      750,
      752,
      664,
      104
    ],
    "source": ""
  },
  {
    "id": 967,
    "question": "What is the process that occurs when the Session layer removes the header from data sent by the Transport layer?",
    "choice_a": "Encapsulation",
    "choice_b": "Packet unwrapping",
    "choice_c": "De-encapsulation",
    "choice_d": "Payloading",
    "correct_answer": "C",
    "explanation": "The process of removing a header (and possibly a footer) from the data received from a previous layer in the OSI model is known as de-encapsulation. Encapsulation occurs when the header and/or footer are added. Payloads are part of a virus or malware package that are delivered to a target, and packet unwrapping is a made-up term.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      504,
      505,
      717,
      501,
      179
    ],
    "source": ""
  },
  {
    "id": 968,
    "question": "Which one of the following types of firewalls does not have the ability to track connection status between different packets?",
    "choice_a": "Stateful inspection",
    "choice_b": "Application proxy",
    "choice_c": "Packet filter",
    "choice_d": "Next generation",
    "correct_answer": "C",
    "explanation": "Static packet filtering firewalls are known as first-generation firewalls and do not track connection state. Stateful inspection, application proxying, and next-generation firewalls all add connection state tracking capability.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      684,
      718,
      508,
      719,
      717
    ],
    "source": ""
  },
  {
    "id": 969,
    "question": "Alice wants to send Bob a message with the confidence that Bob will know the message was not altered while in transit. What goal of cryptography is Alice trying to achieve?",
    "choice_a": "Confidentiality",
    "choice_b": "Nonrepudiation",
    "choice_c": "Authentication",
    "choice_d": "Integrity",
    "correct_answer": "D",
    "explanation": "Integrity ensures that unauthorized changes are not made to data while stored or in transit.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      664,
      663,
      104,
      107,
      666
    ],
    "source": ""
  },
  {
    "id": 970,
    "question": "Chris is troubleshooting an issue with his organization's SIEM reporting. After analyzing the issue, he believes that the timestamps on log entries from different systems are inconsistent. What protocol can he use to resolve this issue?",
    "choice_a": "SSH",
    "choice_b": "FTP",
    "choice_c": "TLS",
    "choice_d": "NTP",
    "correct_answer": "D",
    "explanation": "The Network Time Protocol (NTP) allows the synchronization of system clocks with a standardized time source. The Secure Shell (SSH) protocol provides encrypted administrative connections to servers. The File Transfer Protocol (FTP) is used for data exchange. Transport Layer Security (TLS) is an encryption process used to protect information in transit over a network.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      504,
      179,
      525,
      189,
      719
    ],
    "source": ""
  },
  {
    "id": 971,
    "question": "Alan is installing a fire suppression system that will kick in after a fire breaks out and protect the equipment in the data center from extensive damage. What metric is Alan attempting to lower?",
    "choice_a": "Likelihood",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "Impact",
    "correct_answer": "D",
    "explanation": "Fire suppression systems do not stop a fire from occurring but do reduce the damage that fires cause. This is an example of reducing risk by lowering the impact of an event.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      716,
      714,
      584,
      25,
      518
    ],
    "source": ""
  },
  {
    "id": 972,
    "question": "Which one of the following technologies is designed to prevent a web server going offline from becoming a single point of failure in a web application architecture?",
    "choice_a": "Load balancing",
    "choice_b": "Dual-power supplies",
    "choice_c": "IPS",
    "choice_d": "RAID",
    "correct_answer": "A",
    "explanation": "Load balancing helps to ensure that a failed server will not take a website or service offline. Dual power supplies only work to prevent failure of a power supply or power source. IPS can help to prevent attacks, and RAID can help prevent a disk failure from taking a system offline.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      24,
      25,
      515,
      487,
      488
    ],
    "source": ""
  },
  {
    "id": 973,
    "question": "Alan is considering the use of new identification cards in his organization that will be used for physical access control. He comes across a sample card and is unsure of the technology. He breaks it open and sees the following internal construction. What type of card is this? <br><img src=\"/question_assets/SSCP/c08uf004.png\"/>",
    "choice_a": "Smart card",
    "choice_b": "Proximity card",
    "choice_c": "Magnetic stripe",
    "choice_d": "Phase-two card",
    "correct_answer": "B",
    "explanation": "The use of an electromagnetic coil inside the card indicates that this is a proximity card.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      721,
      720,
      591,
      588,
      590
    ],
    "source": ""
  },
  {
    "id": 974,
    "question": "When an application or system allows a logged-in user to perform specific actions, it is an example of what?",
    "choice_a": "Roles",
    "choice_b": "Group management",
    "choice_c": "Logins",
    "choice_d": "Authorization",
    "correct_answer": "D",
    "explanation": "Authorization provides a user with capabilities or rights. Roles and group management are both methods that could be used to match users with rights. Logins are used to validate a user.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      708,
      322,
      330,
      273,
      446
    ],
    "source": ""
  },
  {
    "id": 975,
    "question": "What is the minimum number of cryptographic keys necessary to achieve strong security when using the 3DES algorithm?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "Triple DES functions by using either two or three encryption keys. When used with only one key, 3DES produces weakly encrypted ciphertext that is the insecure equivalent of DES.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      498,
      499,
      668,
      663,
      750
    ],
    "source": ""
  },
  {
    "id": 976,
    "question": "Gina recently took the SSCP certification exam and then wrote a blog post that included the text of many of the exam questions that she experienced. What aspect of the ISC2 code of ethics is most directly violated in this situation?",
    "choice_a": "Advance and protect the profession.",
    "choice_b": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_c": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "choice_d": "Provide diligent and competent service to principals.",
    "correct_answer": "A",
    "explanation": "Gina's actions harm the certification and information security community by undermining the integrity of the examination process. While Gina also is acting dishonestly, the harm to the profession is more of a direct violation of the code of ethics.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      31,
      30,
      32,
      29,
      33
    ],
    "source": ""
  },
  {
    "id": 977,
    "question": "What type of access controls allow the owner of a file to grant other users access to it using an access control list?",
    "choice_a": "Role-based",
    "choice_b": "Nondiscretionary",
    "choice_c": "Rule-based",
    "choice_d": "Discretionary",
    "correct_answer": "D",
    "explanation": "When the owner of a file makes the decisions about who has rights or access privileges to it, they are using discretionary access control. Role-based access controls would grant access based on a subject's role, while rule-based controls would base the decision on a set of rules or requirements. Nondiscretionary access controls apply a fixed set of rules to an environment to manage access. Nondiscretionary access controls include rule-, role-, and lattice-based access controls.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      539,
      537,
      710,
      555,
      540
    ],
    "source": ""
  },
  {
    "id": 978,
    "question": "Which one of the following components is used to assign classifications to objects in a mandatory access control system?",
    "choice_a": "Security label",
    "choice_b": "Security token",
    "choice_c": "Security descriptor",
    "choice_d": "Security capability",
    "correct_answer": "A",
    "explanation": "Administrators and processes may attach security labels to objects that provide information on an object's attributes. Labels are commonly used to apply classifications in a mandatory access control system.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      286,
      537,
      541,
      555,
      540
    ],
    "source": ""
  },
  {
    "id": 979,
    "question": "Tommy handles access control requests for his organization. A user approaches him and explains that he needs access to the human resources database to complete a headcount analysis requested by the CFO. What has the user demonstrated successfully to Tommy?",
    "choice_a": "Clearance",
    "choice_b": "Separation of duties",
    "choice_c": "Need to know",
    "choice_d": "Isolation",
    "correct_answer": "C",
    "explanation": "The user has successfully explained a valid need to know the data\u2014completing the report requested by the CFO requires this access. However, the user has not yet demonstrated that he or she has appropriate clearance to access the information. A note from the CFO would meet this requirement.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      542,
      555,
      273,
      286,
      19
    ],
    "source": ""
  },
  {
    "id": 980,
    "question": "Which one of the following is not a mode of operation for the Data Encryption Standard?",
    "choice_a": "CBC",
    "choice_b": "CFB",
    "choice_c": "OFB",
    "choice_d": "AES",
    "correct_answer": "D",
    "explanation": "The DES modes of operation are Electronic Codebook (ECB), Cipher Block Chaining (CBC), Cipher Feedback (CFB), Output Feedback (OFB), and Counter (CTR). The Advanced Encryption Standard (AES) is a separate encryption algorithm.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      668
    ],
    "source": ""
  },
  {
    "id": 981,
    "question": "Voice pattern recognition is what type of authentication factor?",
    "choice_a": "Something you know",
    "choice_b": "Something you have",
    "choice_c": "Something you are",
    "choice_d": "Somewhere you are",
    "correct_answer": "C",
    "explanation": "Voice pattern recognition is \u201csomething you are,\u201d a biometric authentication factor, because it measures a physical characteristic of the individual authenticating.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      726,
      564,
      565,
      485,
      484
    ],
    "source": ""
  },
  {
    "id": 982,
    "question": "Which of the following is not a single sign-on implementation?",
    "choice_a": "Kerberos",
    "choice_b": "ADFS",
    "choice_c": "CAS",
    "choice_d": "RADIUS",
    "correct_answer": "D",
    "explanation": "Kerberos, Active Directory Federation Services (ADFS), and Central Authentication Services (CAS) are all SSO implementations. RADIUS is not a single sign-on implementation, although some vendors use it behind the scenes to provide authentication for proprietary SSO.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      543,
      562,
      544,
      545,
      726
    ],
    "source": ""
  },
  {
    "id": 983,
    "question": "Chris is conducting a risk assessment for his organization and has determined the amount of damage that a single flood could be expected to cause to his facilities. What metric has Chris identified?",
    "choice_a": "ALE",
    "choice_b": "SLE",
    "choice_c": "ARO",
    "choice_d": "AV",
    "correct_answer": "B",
    "explanation": "The single loss expectancy (SLE) is the amount of damage that a risk is expected to cause each time that it occurs.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      597,
      598,
      596,
      594,
      613
    ],
    "source": ""
  },
  {
    "id": 984,
    "question": "Concho Controls is a midsize business focusing on building automation systems. They host a set of local file servers in their on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>What backup should Tara apply to the server first?",
    "choice_a": "Sunday's full backup",
    "choice_b": "Monday's differential backup",
    "choice_c": "Tuesday's differential backup",
    "choice_d": "Wednesday's differential backup",
    "correct_answer": "A",
    "explanation": "Tara first must achieve a system baseline. She does this by applying the most recent full backup to the new system. This is Sunday's full backup. Once Tara establishes this baseline, she may then proceed to apply differential backups to bring the system back to a more recent state.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      653,
      497,
      87,
      79,
      88
    ],
    "source": ""
  },
  {
    "id": 985,
    "question": "Concho Controls is a midsize business focusing on building automation systems. They host a set of local file servers in their on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>How many backups in total must Tara apply to the system to make the data it contains as current as possible?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "To restore the system to as current a state as possible, Tara must first apply Sunday's full backup. She may then apply the most recent differential backup, from Wednesday at noon. Differential backups include all files that have changed since the most recent full backup, so the contents of Wednesday's backup contain all of the data that would be contained in Monday and Tuesday's backups, making the Monday and Tuesday backups irrelevant for this scenario.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      653,
      521,
      88,
      79,
      84
    ],
    "source": ""
  },
  {
    "id": 986,
    "question": "Concho Controls is a midsize business focusing on building automation systems. They host a set of local file servers in their on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>In this backup approach, some data may be irretrievably lost. How long is the time period where any changes made will have been lost?",
    "choice_a": "3 hours",
    "choice_b": "5 hours",
    "choice_c": "8 hours",
    "choice_d": "No data will be lost.",
    "correct_answer": "A",
    "explanation": "In this scenario, the differential backup was made at noon, and the server failed at 3 p.m. Therefore, any data modified or created between noon and 3 p.m. will not be contained on any backup and will be irretrievably lost.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      653,
      497,
      521,
      79,
      87
    ],
    "source": ""
  },
  {
    "id": 987,
    "question": "Concho Controls is a midsize business focusing on building automation systems. They host a set of local file servers in their on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>If Tara followed the same schedule but switched the differential backups to incremental backups, how many backups in total would she need to apply to the system to make the data it contains as current as possible?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "D",
    "explanation": "By switching from differential to incremental backups, Tara's weekday backups will contain only the information changed since the previous day. Therefore, she must apply all the available incremental backups. She would begin by restoring the Sunday full backup and then apply the Monday, Tuesday, and Wednesday incremental backups.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      653,
      632,
      88,
      87,
      79
    ],
    "source": ""
  },
  {
    "id": 988,
    "question": "Concho Controls is a midsize business focusing on building automation systems. They host a set of local file servers in their on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>If Tara made the change from differential to incremental backups and we assume that the same amount of information changes each day, which one of the following files would be the largest?",
    "choice_a": "Monday's incremental backup",
    "choice_b": "Tuesday's incremental backup",
    "choice_c": "Wednesday's incremental backup",
    "choice_d": "All three will be the same size.",
    "correct_answer": "D",
    "explanation": "Each incremental backup contains only the information changed since the most recent full or incremental backup. If we assume that the same amount of information changes every day, each of the incremental backups would be roughly the same size.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      88,
      87,
      79,
      84,
      72
    ],
    "source": ""
  },
  {
    "id": 989,
    "question": "Susan has discovered that the smart card\u2013based locks used to keep the facility she works at secure are not effective because staff members are propping the doors open. She places signs on the doors reminding staff that leaving the door open creates a security issue, and she adds alarms that will sound if the doors are left open for more than five minutes. What type of controls has she put into place?",
    "choice_a": "Physical",
    "choice_b": "Administrative",
    "choice_c": "Compensation",
    "choice_d": "Recovery",
    "correct_answer": "C",
    "explanation": "She has placed compensation controls in place. Compensation controls are used when controls like the locks in this example are not sufficient. While the alarm is a physical control, the signs she posted are not. Similarly, the alarms are not administrative controls. These controls do not help to recover from an issue and are thus, not recovery controls.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      574,
      573,
      591,
      588,
      517
    ],
    "source": ""
  },
  {
    "id": 990,
    "question": "During what phase of the electronic discovery reference model does an organization ensure that potentially discoverable information is protected against alteration or deletion?",
    "choice_a": "Identification",
    "choice_b": "Preservation",
    "choice_c": "Collection",
    "choice_d": "Production",
    "correct_answer": "B",
    "explanation": "During the preservation phase, the organization ensures that information related to the matter at hand is protected against intentional or unintentional alteration or deletion. The identification phase locates relevant information but does not preserve it. The collection phase occurs after preservation and gathers responsive information. The processing phase performs a rough cut of the collected information for relevance.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      632,
      639,
      658,
      84,
      72
    ],
    "source": ""
  },
  {
    "id": 991,
    "question": "Marty discovers that the access restrictions in his organization allow any user to log into the workstation assigned to any other user, even if they are from completely different departments. This type of access most directly violates which information security principle?",
    "choice_a": "Separation of duties",
    "choice_b": "Two-person control",
    "choice_c": "Need to know",
    "choice_d": "Least privilege",
    "correct_answer": "D",
    "explanation": "This broad access may indirectly violate all of the listed security principles, but it is most directly a violation of least privilege because it grants users privileges that they do not need for their job functions.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      25,
      22,
      24,
      29,
      31
    ],
    "source": ""
  },
  {
    "id": 992,
    "question": "Which of the following tools is best suited to testing known exploits against a system?",
    "choice_a": "Nikto",
    "choice_b": "Ettercap",
    "choice_c": "Metasploit",
    "choice_d": "THC Hydra",
    "correct_answer": "C",
    "explanation": "Metasploit is a tool used to exploit known vulnerabilities. Nikto is a web application and server vulnerability scanning tool, Ettercap is a man-in-the-middle attack tool, and THC Hydra is a password brute-force tool.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      602,
      600,
      601,
      617,
      620
    ],
    "source": ""
  },
  {
    "id": 993,
    "question": "Denise is preparing for a trial relating to a contract dispute between her company and a software vendor. The vendor is claiming that Denise made a verbal agreement that amended their written contract. What rule of evidence should Denise raise in her defense?",
    "choice_a": "Real evidence rule",
    "choice_b": "Best evidence rule",
    "choice_c": "Parol evidence rule",
    "choice_d": "Testimonial evidence rule",
    "correct_answer": "C",
    "explanation": "The parol evidence rule states that when an agreement between two parties is put into written form, it is assumed to be the entire agreement unless amended in writing. The best evidence rule says that a copy of a document is not admissible if the original document is available. Real evidence and testimonial evidence are evidence types, not rules of evidence.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      657,
      658,
      659,
      662,
      640
    ],
    "source": ""
  },
  {
    "id": 994,
    "question": "During which phase of the incident response process would an organization determine whether it is required to notify law enforcement officials or other regulators of the incident?",
    "choice_a": "Detection",
    "choice_b": "Recovery",
    "choice_c": "Remediation",
    "choice_d": "Reporting",
    "correct_answer": "D",
    "explanation": "During the Reporting phase, incident responders assess their obligations under laws and regulations to report the incident to government agencies and other regulators.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      101,
      99,
      660,
      735,
      97
    ],
    "source": ""
  },
  {
    "id": 995,
    "question": "Gordon is conducting a risk assessment for his organization and determined the amount of damage that flooding is expected to cause to his facilities each year. What metric has Gordon identified?",
    "choice_a": "ALE",
    "choice_b": "ARO",
    "choice_c": "SLE",
    "choice_d": "EF",
    "correct_answer": "A",
    "explanation": "The annualized loss expectancy is the amount of damage that the organization expects to occur each year as the result of a given risk.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      597,
      458,
      596,
      612,
      614
    ],
    "source": ""
  },
  {
    "id": 996,
    "question": "Data is sent as bits at what layer of the OSI model?",
    "choice_a": "Transport",
    "choice_b": "Network",
    "choice_c": "Data Link",
    "choice_d": "Physical",
    "correct_answer": "D",
    "explanation": "The Physical layer deals with the electrical impulses or optical pulses that are sent as bits to convey data.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      504,
      682,
      675,
      179,
      676
    ],
    "source": ""
  },
  {
    "id": 997,
    "question": "Angie is configuring egress monitoring on her network to provide added security. Which one of the following packet types should Angie allow to leave the network headed for the Internet?",
    "choice_a": "Packets with a source address from Angie's public IP address block",
    "choice_b": "Packets with a destination address from Angie's public IP address block",
    "choice_c": "Packets with a source address outside Angie's address block",
    "choice_d": "Packets with a source address from Angie's private address block",
    "correct_answer": "A",
    "explanation": "All packets leaving Angie's network should have a source address from her public IP address block. Packets with a destination address from Angie's network should not be leaving the network. Packets with source addresses from other networks are likely spoofed and should be blocked by egress filters. Packets with private IP addresses as sources or destinations should never be routed onto the Internet.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      470,
      507,
      452,
      505,
      178
    ],
    "source": ""
  },
  {
    "id": 998,
    "question": "Harry would like to access a document owned by Sally stored on a file server. Applying the subject/object model to this scenario, who or what is the object of the resource request?",
    "choice_a": "Harry",
    "choice_b": "Sally",
    "choice_c": "File server",
    "choice_d": "Document",
    "correct_answer": "D",
    "explanation": "In the subject/object model, the object is the resource being requested by a subject. In this example, Harry would like access to the document, making the document the object of the request.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      555,
      556,
      273,
      286,
      330
    ],
    "source": ""
  },
  {
    "id": 999,
    "question": "Information about an individual like their name, Social Security number, date and place of birth, or their mother's maiden name is an example of what type of protected information?",
    "choice_a": "PHI",
    "choice_b": "Proprietary data",
    "choice_c": "PII",
    "choice_d": "EDI",
    "correct_answer": "C",
    "explanation": "Personally identifiable information (PII) includes data that can be used to distinguish or trace that person's identity and also includes information such as their medical, educational, financial, and employment information. PHI is personal health information, EDI is Electronic Data Interchange, and proprietary data is used to maintain an organization's competitive advantage.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      669,
      670,
      671,
      668,
      106
    ],
    "source": ""
  },
  {
    "id": 1000,
    "question": "Greg is building a disaster recovery plan for his organization and would like to determine the amount of time that it should take to restore a particular IT service after an outage. What variable is Greg calculating?",
    "choice_a": "MTD",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "SLA",
    "correct_answer": "B",
    "explanation": "The recovery time objective (RTO) is the amount of time expected to return an IT service or component to operation after a failure. The maximum tolerable downtime (MTD) is the longest amount of time that an IT service or component may be unavailable without causing serious damage to the organization. The recovery point objective (RPO) identifies the maximum amount of data, measured in time, that may be lost during a recovery effort. Service-level agreements (SLAs) are written contracts that document service expectations.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      496,
      495,
      653,
      656,
      72
    ],
    "source": ""
  },
  {
    "id": 1001,
    "question": "What type of access control is intended to discover unwanted or unauthorized activity by providing information after the event has occurred?",
    "choice_a": "Preventive",
    "choice_b": "Corrective",
    "choice_c": "Detective",
    "choice_d": "Directive",
    "correct_answer": "C",
    "explanation": "Detective access controls operate after the fact and are intended to detect or discover unwanted access or activity. Preventive access controls are designed to prevent the activity from occurring, whereas corrective controls return an environment to its original status after an issue occurs. Directive access controls limit or direct the actions of subjects to ensure compliance with policies.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      574,
      573,
      517,
      518,
      725
    ],
    "source": ""
  },
  {
    "id": 1002,
    "question": "What business process typically requires sign-off from a manager before modifications are made to a system?",
    "choice_a": "SDN",
    "choice_b": "Release management",
    "choice_c": "Change management",
    "choice_d": "Versioning",
    "correct_answer": "C",
    "explanation": "Change management typically requires sign-off from a manager or supervisor before changes are made. This helps to ensure proper awareness and communication. SDN stands for software-defined networking, release management is the process that new software releases go through to be accepted, and versioning is used to differentiate versions of software, code, or other objects.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      581,
      487,
      486,
      579,
      580
    ],
    "source": ""
  },
  {
    "id": 1003,
    "question": "Gordon is developing a business continuity plan for a manufacturing company's IT operations. The company is located in North Dakota and currently evaluating the risk of earthquake. They choose to pursue a risk acceptance strategy. Which one of the following actions is consistent with that strategy?",
    "choice_a": "Purchasing earthquake insurance",
    "choice_b": "Relocating the data center to a safer area",
    "choice_c": "Documenting the decision-making process",
    "choice_d": "Reengineering the facility to withstand the shock of an earthquake",
    "correct_answer": "C",
    "explanation": "In a risk acceptance strategy, the organization chooses to take no action other than documenting the risk. Purchasing insurance would be an example of risk transference. Relocating the data center would be risk avoidance. Reengineering the facility is an example of a risk mitigation strategy.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      64,
      59,
      63,
      62,
      56
    ],
    "source": ""
  },
  {
    "id": 1004,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>When Matthew sends Richard a message, what key should he use to encrypt the message?",
    "choice_a": "Matthew's public key",
    "choice_b": "Matthew's private key",
    "choice_c": "Richard's public key",
    "choice_d": "Richard's private key",
    "correct_answer": "C",
    "explanation": "The sender of a message encrypts the message using the public key of the message recipient.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      672,
      500,
      498,
      104,
      663
    ],
    "source": ""
  },
  {
    "id": 1005,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>When Richard receives the message from Matthew, what key should he use to decrypt the message?",
    "choice_a": "Matthew's public key",
    "choice_b": "Matthew's private key",
    "choice_c": "Richard's public key",
    "choice_d": "Richard's private key",
    "correct_answer": "D",
    "explanation": "The recipient of a message uses his or her own private key to decrypt messages that were encrypted with the recipient's public key. This ensures that nobody other than the intended recipient can decrypt the message.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      672,
      500,
      498,
      664,
      524
    ],
    "source": ""
  },
  {
    "id": 1006,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>Matthew would like to enhance the security of his communication by adding a digital signature to the message. What goal of cryptography are digital signatures intended to enforce?",
    "choice_a": "Secrecy",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Nonrepudiation",
    "correct_answer": "D",
    "explanation": "Digital signatures enforce nonrepudiation. They prevent an individual from denying that he or she was the actual originator of the message.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      104,
      672,
      524,
      103,
      106
    ],
    "source": ""
  },
  {
    "id": 1007,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>When Matthew goes to add the digital signature to the message, what encryption key does he use to create the digital signature?",
    "choice_a": "Matthew's public key",
    "choice_b": "Matthew's private key",
    "choice_c": "Richard's public key",
    "choice_d": "Richard's private key",
    "correct_answer": "B",
    "explanation": "An individual creates a digital signature by encrypting the message digest with his or her own private key.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      672,
      663,
      104,
      524,
      668
    ],
    "source": ""
  },
  {
    "id": 1008,
    "question": "What type of motion detector uses high microwave frequency signal transmissions to identify potential intruders?",
    "choice_a": "Infrared",
    "choice_b": "Heat-based",
    "choice_c": "Wave pattern",
    "choice_d": "Capacitance",
    "correct_answer": "C",
    "explanation": "Wave pattern motion detectors transmit ultrasonic or microwave signals into the monitor area, watching for changes in the returned signals bouncing off objects.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      20,
      33,
      583,
      588,
      588
    ],
    "source": ""
  },
  {
    "id": 1009,
    "question": "Bert is considering the use of an infrastructure as a service cloud computing partner to provide virtual servers. Which one of the following would be a vendor responsibility in this scenario?",
    "choice_a": "Maintaining the hypervisor",
    "choice_b": "Managing operating system security settings",
    "choice_c": "Maintaining the host firewall",
    "choice_d": "Configuring server access control",
    "correct_answer": "A",
    "explanation": "In an IaaS server environment, the customer retains responsibility for most server security operations under the shared responsibility model. This includes managing OS security settings, maintaining host firewalls, and configuring server access control. The\u00a0vendor would be responsible for all security mechanisms at the hypervisor layer and\u00a0below.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      535,
      536,
      534,
      696,
      697
    ],
    "source": ""
  },
  {
    "id": 1010,
    "question": "Callback to a landline phone number is an example of what type of factor?",
    "choice_a": "Something you know",
    "choice_b": "Somewhere you are",
    "choice_c": "Something you have",
    "choice_d": "Something you are",
    "correct_answer": "B",
    "explanation": "A callback to a landline phone number is an example of a \u201csomewhere you are\u201d factor because of the fixed physical location of a wired phone. A callback to a mobile phone would be a \u201csomething you have\u201d factor.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      727,
      726,
      281,
      420,
      273
    ],
    "source": ""
  },
  {
    "id": 1011,
    "question": "Renee is using encryption to safeguard sensitive business secrets when in transit over the Internet. What risk metric is she attempting to lower?",
    "choice_a": "Likelihood",
    "choice_b": "RTO",
    "choice_c": "MTO",
    "choice_d": "Impact",
    "correct_answer": "A",
    "explanation": "Using encryption reduces risk by lowering the likelihood that an eavesdropper will be able to gain access to sensitive information.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      668,
      666,
      104,
      106,
      128
    ],
    "source": ""
  },
  {
    "id": 1012,
    "question": "Kim is the system administrator for a small business network that is experiencing security problems. She is in the office in the evening working on the problem, and nobody else is there. As she is watching, she can see that systems on the other side of the office that were previously behaving normally are now exhibiting signs of infection. What type of malware is Kim likely dealing with?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Trojan horse",
    "choice_d": "Logic bomb",
    "correct_answer": "B",
    "explanation": "Worms have built-in propagation mechanisms that do not require user interaction, such as scanning for systems containing known vulnerabilities and then exploiting those vulnerabilities to gain access. Viruses and Trojan horses typically require user interaction to spread. Logic bombs do not spread from system to system but lie in wait until certain conditions are met, triggering the delivery of their payload.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      732,
      702,
      264,
      259,
      261
    ],
    "source": ""
  },
  {
    "id": 1013,
    "question": "What two logical network topologies can be physically implemented as a star topology?",
    "choice_a": "A bus and a mesh",
    "choice_b": "A ring and a mesh",
    "choice_c": "A bus and a ring",
    "choice_d": "It is not possible to implement other topologies as a star.",
    "correct_answer": "C",
    "explanation": "Both a logical bus and a logical ring can be implemented as a physical star. Ethernet is commonly deployed as a physical star by placing a switch as the center of a star, but Ethernet still operates as a bus. Similarly, Token Ring deployments using a multistation access unit (MAU) were deployed as physical stars but operated as rings.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      504,
      682,
      676,
      179,
      675
    ],
    "source": ""
  },
  {
    "id": 1014,
    "question": "Jim has worked in human relations, payroll, and customer service roles in his company over the past few years. What type of process should his company perform to ensure that he has appropriate rights?",
    "choice_a": "Re-provisioning",
    "choice_b": "Account review",
    "choice_c": "Privilege creep",
    "choice_d": "Account revocation",
    "correct_answer": "B",
    "explanation": "As an employee's role changes, they often experience privilege creep, which is the accumulation of old rights and roles. Account review is the process of reviewing accounts and ensuring that their rights match their owners' role and job requirements. Account revocation removes accounts, while reprovisioning might occur if an employee was terminated and returned or took a leave of absence and returned.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      549,
      550,
      542,
      557,
      13
    ],
    "source": ""
  },
  {
    "id": 1015,
    "question": "What type of inbound packet is characteristic of a ping flood attack?",
    "choice_a": "ICMP echo request",
    "choice_b": "ICMP echo reply",
    "choice_c": "ICMP destination unreachable",
    "choice_d": "ICMP route changed",
    "correct_answer": "A",
    "explanation": "The ping flood attack sends echo requests at a targeted system. These pings use inbound ICMP echo request packets, causing the system to respond with an outbound ICMP echo reply.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      729,
      730,
      718,
      717,
      684
    ],
    "source": ""
  },
  {
    "id": 1016,
    "question": "What penetration testing technique can best help assess training and awareness issues?",
    "choice_a": "Port scanning",
    "choice_b": "Discovery",
    "choice_c": "Social engineering",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "C",
    "explanation": "Social engineering is the best answer, as it can be useful to penetration testers who are asked to assess whether staff members are applying security training and have absorbed the awareness messages the organization uses. Port scanning and vulnerability scanning find technical issues that may be related to awareness or training issues but that are less likely to be directly related. Discovery can involve port scanning or other data-gathering efforts but is also less likely to be directly related to training and awareness.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      52,
      39,
      60,
      62,
      55
    ],
    "source": ""
  },
  {
    "id": 1017,
    "question": "GAD Systems is concerned about the risk of hackers stealing sensitive information stored on a file server. They choose to pursue a risk mitigation strategy. Which one of the following actions would support that strategy?",
    "choice_a": "Encrypting the files",
    "choice_b": "Deleting the files",
    "choice_c": "Purchasing cyber-liability insurance",
    "choice_d": "Taking no action",
    "correct_answer": "A",
    "explanation": "Encrypting the files reduces the probability that the data will be successfully stolen, so it is an example of risk mitigation. Deleting the files would be risk avoidance. Purchasing insurance would be risk transference. Taking no action would be risk acceptance.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      42,
      59,
      63,
      64,
      56
    ],
    "source": ""
  },
  {
    "id": 1018,
    "question": "Sally's organization needs to be able to prove that certain staff members sent emails, and she wants to adopt a technology that will provide that capability without changing their existing email system. What is the technical term for the capability Sally needs to implement as the owner of the email system, and what tool could she use to do it?",
    "choice_a": "Integrity; IMAP",
    "choice_b": "Repudiation; encryption",
    "choice_c": "Nonrepudiation; digital signatures",
    "choice_d": "Authentication; DKIM",
    "correct_answer": "C",
    "explanation": "Sally needs to provide nonrepudiation, the ability to provably associate a given email with a sender. Digital signatures can provide nonrepudiation and are her best option. IMAP is a mail protocol, encryption can provide confidentiality, and DKIM is a tool for identifying domains that send email.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      104,
      124,
      106,
      108,
      103
    ],
    "source": ""
  },
  {
    "id": 1019,
    "question": "What type of virus is characterized by the use of two or more different propagation mechanisms to improve its likelihood of spreading between systems?",
    "choice_a": "Stealth virus",
    "choice_b": "Polymorphic virus",
    "choice_c": "Multipartite virus",
    "choice_d": "Encrypted virus",
    "correct_answer": "C",
    "explanation": "Multipartite viruses use multiple propagation mechanisms to spread between systems. This improves their likelihood of successfully infecting a system because it provides alternative infection mechanisms that may be successful against systems that are not vulnerable to the primary infection mechanism.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      733,
      732,
      734,
      210,
      235
    ],
    "source": ""
  },
  {
    "id": 1020,
    "question": "Which one of the following provides an authentication mechanism that would be appropriate for pairing with a password to achieve multifactor authentication?",
    "choice_a": "Username",
    "choice_b": "Personal identification number (PIN)",
    "choice_c": "Security question",
    "choice_d": "Fingerprint scan",
    "correct_answer": "D",
    "explanation": "A fingerprint scan is an example of a \u201csomething you are\u201d factor, which would be appropriate for pairing with a \u201csomething you know\u201d password to achieve multifactor authentication. A username is not an authentication factor. PINs and security questions are both \u201csomething you know,\u201d which would not achieve multifactor authentication when paired with a password because both methods would come from the same category, failing the requirement for multifactor authentication.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      726,
      727,
      553,
      562,
      749
    ],
    "source": ""
  },
  {
    "id": 1021,
    "question": "Colleen is conducting a business impact assessment for her organization. What metric provides important information about the amount of time that the organization may be without a service before causing irreparable harm?",
    "choice_a": "MTD",
    "choice_b": "ALE",
    "choice_c": "RPO",
    "choice_d": "RTO",
    "correct_answer": "A",
    "explanation": "The maximum tolerable downtime (MTD) is the amount of time that a business may be without a service before irreparable harm occurs. This measure is sometimes also called maximum tolerable outage (MTO).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      68,
      72,
      77,
      651,
      648
    ],
    "source": ""
  },
  {
    "id": 1022,
    "question": "The separation of network infrastructure from the control layer, combined with the ability to centrally program a network design in a vendor-neutral, standards-based implementation, is an example of what important concept?",
    "choice_a": "MPLS, a way to replace long network addresses with shorter labels and support a wide range of protocols",
    "choice_b": "FCoE, a converged protocol that allows common applications over Ethernet",
    "choice_c": "SDN, a converged protocol that allows network virtualization",
    "choice_d": "CDN, a converged protocol that makes common network designs accessible",
    "correct_answer": "C",
    "explanation": "Software-defined networking (SDN) is a converged protocol that allows virtualization concepts and practices to be applied to networks. MPLS handles a wide range of protocols like ATM, DSL, and others, but isn't intended to provide the centralization capabilities that SDN does. Content distribution network (CDN) is not a converged protocol, and FCoE is Fibre Channel over Ethernet, a converged protocol for storage.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1023,
    "question": "Ben is selecting an encryption algorithm for use in an organization with 10,000 employees. He must facilitate communication between any two employees within the organization. Which one of the following algorithms would allow him to meet this goal with the least time dedicated to key management?",
    "choice_a": "RSA",
    "choice_b": "IDEA",
    "choice_c": "3DES",
    "choice_d": "Skipjack",
    "correct_answer": "A",
    "explanation": "RSA is an asymmetric encryption algorithm that requires only two keys for each user. IDEA, 3DES, and Skipjack are all symmetric encryption algorithms and would require a key for every unique pair of users in the system.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      498,
      500,
      499,
      672,
      106
    ],
    "source": ""
  },
  {
    "id": 1024,
    "question": "Which of the following is used only to encrypt data in transit over a network and cannot be used to encrypt data at rest?",
    "choice_a": "TKIP",
    "choice_b": "AES",
    "choice_c": "3DES",
    "choice_d": "RSA",
    "correct_answer": "A",
    "explanation": "TKIP is used only as a means to encrypt transmissions and is not used for data at rest. RSA, AES, and 3DES are all used on data at rest as well as data in transit.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      130,
      666,
      668,
      107,
      124
    ],
    "source": ""
  },
  {
    "id": 1025,
    "question": "Which one of the following tools may be used to achieve the goal of nonrepudiation?",
    "choice_a": "Digital signature",
    "choice_b": "Symmetric encryption",
    "choice_c": "Firewall",
    "choice_d": "IDS",
    "correct_answer": "A",
    "explanation": "Applying a digital signature to a message allows the sender to achieve the goal of nonrepudiation. This allows the recipient of a message to prove to a third party that the message came from the purported sender. Symmetric encryption does not support nonrepudiation. Firewalls and IDS are network security tools that are not used to provide nonrepudiation.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      104,
      524,
      663,
      664,
      106
    ],
    "source": ""
  },
  {
    "id": 1026,
    "question": "When should an organization conduct a review of the privileged access that a user has to sensitive systems?",
    "choice_a": "On a periodic basis",
    "choice_b": "When a user leaves the organization",
    "choice_c": "When a user changes roles",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Privileged access reviews are one of the most critical components of an organization's security program because they ensure that only authorized users have access to perform the most sensitive operations. They should take place whenever a user with privileged access leaves the organization or changes roles as well as on a regular, recurring basis.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      581,
      570,
      575,
      492,
      516
    ],
    "source": ""
  },
  {
    "id": 1027,
    "question": "Nessus, OpenVAS, and SAINT are all examples of what type of tool?",
    "choice_a": "Port scanners",
    "choice_b": "Patch management suites",
    "choice_c": "Port mappers",
    "choice_d": "Vulnerability scanners",
    "correct_answer": "D",
    "explanation": "Nessus, OpenVAS and SAINT are all vulnerability scanning tools. All provide port scanning capabilities as well but are more than simple port scanning tools.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      600,
      602,
      617,
      620,
      628
    ],
    "source": ""
  },
  {
    "id": 1028,
    "question": "Kolin is searching for a network security solution that will allow him to help reduce zero-day attacks while using identities to enforce a security policy on systems before they connect to the network. What type of solution should Kolin implement?",
    "choice_a": "A firewall",
    "choice_b": "A NAC system",
    "choice_c": "An intrusion detection system",
    "choice_d": "Port security",
    "correct_answer": "B",
    "explanation": "Network access control (NAC) systems can be used to authenticate users and then validate their system's compliance with a security standard before they are allowed to connect to the network. Enforcing security profiles can help reduce zero-day attacks, making NAC a useful solution. A firewall can't enforce system security policies, whereas an IDS can only monitor for attacks and alarm when they happen. Thus, neither a firewall nor an IDS meets Kolin's needs. Finally, port security is a MAC address\u2013based security feature that can restrict only which systems or devices can connect to a given port.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      178,
      181,
      163,
      160,
      175
    ],
    "source": ""
  },
  {
    "id": 1029,
    "question": "How many possible keys exist when using a cryptographic algorithm that has an 8-bit binary encryption key?",
    "choice_a": "16",
    "choice_b": "128",
    "choice_c": "256",
    "choice_d": "512",
    "correct_answer": "C",
    "explanation": "Binary keyspaces contain a number of keys equal to 2 raised to the power of the number of bits. Two to the eighth power is 256, so an 8-bit keyspace contains 256 possible keys.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      499,
      130,
      124,
      106,
      102
    ],
    "source": ""
  },
  {
    "id": 1030,
    "question": "In what cloud computing model does the customer build a cloud computing environment in his or her own data center or build an environment in another data center that is for the customer's exclusive use?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Shared cloud",
    "correct_answer": "B",
    "explanation": "In the private cloud computing model, the cloud computing environment is dedicated to a single organization and does not follow the shared tenancy model. The environment may be built by the company in its own data center or built by a vendor at a co-location site.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      535,
      534,
      696,
      697,
      746
    ],
    "source": ""
  },
  {
    "id": 1031,
    "question": "What major issue often results from decentralized access control?",
    "choice_a": "Access outages may occur.",
    "choice_b": "Control is not consistent.",
    "choice_c": "Control is too granular.",
    "choice_d": "Training costs are high.",
    "correct_answer": "B",
    "explanation": "Decentralized access control can result in less consistency because the individuals tasked with control may interpret policies and requirements differently and may perform their roles in different ways. Access outages, overly granular control, and training costs may occur, depending on specific implementations, but they are not commonly identified issues with decentralized access control.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      551,
      537,
      538,
      550,
      547
    ],
    "source": ""
  },
  {
    "id": 1032,
    "question": "In what model of cloud computing do two or more organizations collaborate to build a shared cloud computing environment that is for their own use?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Community cloud",
    "choice_d": "Shared cloud",
    "correct_answer": "C",
    "explanation": "In the community cloud computing model, two or more organizations pool their resources to create a cloud environment that they then share.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      204,
      271,
      534,
      536,
      696
    ],
    "source": ""
  },
  {
    "id": 1033,
    "question": "Susan's organization is updating its password policy and wants to use the strongest possible passwords. What password requirement will have the highest impact in preventing brute-force attacks?",
    "choice_a": "Change maximum age from 1 year to 180 days.",
    "choice_b": "Increase the minimum password length from 8 characters to 16 characters.",
    "choice_c": "Increase the password complexity so that at least three character classes (such as uppercase, lowercase, numbers, and symbols) are required.",
    "choice_d": "Retain a password history of at least four passwords to prevent reuse.",
    "correct_answer": "B",
    "explanation": "Password complexity is driven by length, and a longer password will be more effective against brute-force attacks than a shorter password. Each character of additional length increases the difficulty by the size of the potential character set (for example, a single lowercase character makes the passwords 26 times more difficult to crack). While each of the other settings is useful for a strong password policy, they won't have the same impact on brute-force attacks.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      747,
      748,
      749,
      552,
      554
    ],
    "source": ""
  },
  {
    "id": 1034,
    "question": "Which of the following statements is true about heuristic-based antimalware software?",
    "choice_a": "It has a lower false positive rate than signature detection.",
    "choice_b": "It requires frequent definition updates to detect new malware.",
    "choice_c": "It has a higher likelihood of detecting zero-day exploits than signature detection.",
    "choice_d": "It monitors systems for files with content known to be viruses.",
    "correct_answer": "C",
    "explanation": "Heuristic-based antimalware software has a higher likelihood of detecting a zero-day exploit than signature-based methods. Heuristic-based software does not require frequent signature updates because it does not rely upon monitoring systems for the presence of known malware. The trade-off with this approach is that it has a higher false positive rate than signature detection methods.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      690,
      699,
      703,
      210,
      265
    ],
    "source": ""
  },
  {
    "id": 1035,
    "question": "Which one of the following malware types uses built-in propagation mechanisms that exploit system vulnerabilities to spread?",
    "choice_a": "Trojan horse",
    "choice_b": "Worm",
    "choice_c": "Logic bomb",
    "choice_d": "Virus",
    "correct_answer": "B",
    "explanation": "Worms have built-in propagation mechanisms that do not require user interaction, such as scanning for systems containing known vulnerabilities and then exploiting those vulnerabilities.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      732,
      733,
      702,
      703,
      704
    ],
    "source": ""
  },
  {
    "id": 1036,
    "question": "When Chris verifies an individual's identity and adds a unique identifier like a user ID to an identity system, what process has occurred?",
    "choice_a": "Identity proofing",
    "choice_b": "Registration",
    "choice_c": "Directory management",
    "choice_d": "Session management",
    "correct_answer": "B",
    "explanation": "Registration is the process of adding a user to an identity management system. This includes creating their unique identifier and adding any attribute information that is associated with their identity. Proofing occurs when the user provides information to prove who they are. Directories are managed to maintain lists of users, services, and other items. Session management tracks application and user sessions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      542,
      708,
      281,
      559,
      273
    ],
    "source": ""
  },
  {
    "id": 1037,
    "question": "Fred needs to deploy a network device that can connect his network to other networks while controlling traffic on his network. What type of device is Fred's best choice?",
    "choice_a": "A switch",
    "choice_b": "A bridge",
    "choice_c": "A gateway",
    "choice_d": "A router",
    "correct_answer": "D",
    "explanation": "Fred should choose a router. Routers are designed to control traffic on a network while connecting to other similar networks. If the networks are very different, a bridge can help connect them. Gateways are used to connect to networks that use other protocols by transforming traffic to the appropriate protocol or format as it passes through them. Switches are often used to create broadcast domains and to connect endpoint systems or other devices.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      504,
      505,
      677,
      179,
      178
    ],
    "source": ""
  },
  {
    "id": 1038,
    "question": "Bill implemented RAID level 5 on a server that he operates using a total of three disks. How many disks may fail without the loss of data?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "3",
    "correct_answer": "B",
    "explanation": "RAID level 5 is also known as disk striping with parity. It uses three or more disks, with one disk containing parity information used to restore data to another disk in the event of failure. When used with three disks, RAID 5 is able to withstand the loss of a single disk.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1039,
    "question": "What network topology is shown here? <br><img src=\"/question_assets/SSCP/c08uf005.png\"/>",
    "choice_a": "A ring",
    "choice_b": "A bus",
    "choice_c": "A star",
    "choice_d": "A mesh",
    "correct_answer": "C",
    "explanation": "A star topology uses a central connection device. Ethernet networks may look like a star, but they are actually a logical bus topology that is sometimes deployed in a physical star.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      467,
      465,
      504,
      676,
      682
    ],
    "source": ""
  },
  {
    "id": 1040,
    "question": "Which one of the following is normally used as an authorization tool?",
    "choice_a": "ACL",
    "choice_b": "Token",
    "choice_c": "Username",
    "choice_d": "Password",
    "correct_answer": "A",
    "explanation": "Access control lists (ACLs) are used for determining a user's authorization level. Usernames are identification tools. Passwords and tokens are authentication tools.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      537,
      539,
      562,
      538,
      557
    ],
    "source": ""
  },
  {
    "id": 1041,
    "question": "Ben is concerned about password cracking attacks against his system. He would like to implement controls that prevent an attacker who has obtained those hashes from easily cracking them. What two controls would best meet this objective?",
    "choice_a": "Longer passwords and salting",
    "choice_b": "Over-the-wire encryption and use of SHA1 instead of MD5",
    "choice_c": "Salting and use of MD5",
    "choice_d": "Using shadow passwords and salting",
    "correct_answer": "A",
    "explanation": "Rainbow tables rely on being able to use databases of precomputed hashes to quickly search for matches to known hashes acquired by an attacker. Making passwords longer can greatly increase the size of the rainbow table required to find the matching hash, and adding a salt to the password will make it nearly impossible for the attacker to generate a table that will match unless they can acquire the salt value. MD5 and SHA1 are both poor choices for password hashing compared to modern password hashes, which are designed to make hashing easy and recovery difficult. Rainbow tables are often used against lists of hashes acquired by attacks rather than over-the-wire attacks, so over-the-wire encryption is not particularly useful here. Shadow passwords simply make the traditionally world-readable list of password hashes on Unix and Linux systems available in a location readable only by root. This doesn't prevent a rainbow table attack once the hashes are obtained.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      750,
      751,
      752,
      668,
      664
    ],
    "source": ""
  },
  {
    "id": 1042,
    "question": "Mark is planning a disaster recovery test for his organization. He would like to perform a live test of the disaster recovery facility but does not want to disrupt operations at the primary facility. What type of test should Mark choose?",
    "choice_a": "Full interruption test",
    "choice_b": "Checklist review",
    "choice_c": "Parallel test",
    "choice_d": "Tabletop exercise",
    "correct_answer": "C",
    "explanation": "During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      656,
      654,
      655,
      495,
      649
    ],
    "source": ""
  },
  {
    "id": 1043,
    "question": "Alice sends a message to Bob and wants to ensure that Mal, a third party, does not read the contents of the message while in transit. What goal of cryptography is Alice attempting to achieve?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Authentication",
    "choice_d": "Nonrepudiation",
    "correct_answer": "A",
    "explanation": "Confidentiality ensures that data cannot be read by unauthorized individuals while stored or in transit.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      107,
      105,
      106,
      664,
      666
    ],
    "source": ""
  },
  {
    "id": 1044,
    "question": "The company Chris works for has notifications posted at each door reminding employees to be careful to not allow people to enter when they do. Which type of controls best describes this?",
    "choice_a": "Detective",
    "choice_b": "Physical",
    "choice_c": "Preventive",
    "choice_d": "Directive",
    "correct_answer": "D",
    "explanation": "Notifications and procedures like the signs posted at the company Chris works for are examples of directive access controls. Detective controls are designed to operate after the fact. The doors and the locks on them are examples of physical controls. Preventive controls are designed to stop an event and could also include the locks that are present on the doors.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      574,
      573,
      588,
      590,
      589
    ],
    "source": ""
  },
  {
    "id": 1045,
    "question": "Jim is implementing an IDaaS solution for his organization. What type of technology is he putting in place?",
    "choice_a": "Identity as a service",
    "choice_b": "Employee ID as a service",
    "choice_c": "Intrusion detection as a service",
    "choice_d": "OAuth",
    "correct_answer": "A",
    "explanation": "Identity as a service (IDaaS) provides an identity platform as a third-party service. This can provide benefits, including integration with cloud services and removing overhead for maintenance of traditional on-premise identity systems but can also create risk because of third-party control of identity services and reliance on an offsite identity infrastructure.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      349,
      279,
      542,
      543,
      563
    ],
    "source": ""
  },
  {
    "id": 1046,
    "question": "How many possible keys exist in a cryptographic algorithm that uses 6-bit encryption keys?",
    "choice_a": "12",
    "choice_b": "16",
    "choice_c": "32",
    "choice_d": "64",
    "correct_answer": "D",
    "explanation": "Binary keyspaces contain a number of keys equal to 2 raised to the power of the number of bits. Two to the sixth power is 64, so a 6-bit keyspace contains 64 possible keys. The number of viable keys is usually smaller in most algorithms because of the presence of parity bits and other algorithmic overhead or security issues that restrict the use of some key values.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      499,
      498,
      124,
      130,
      143
    ],
    "source": ""
  },
  {
    "id": 1047,
    "question": "When an attacker calls an organization's help desk and persuades them to reset a password for them because of the help desk employee's trust and willingness to help, what type of attack succeeded?",
    "choice_a": "A human Trojan",
    "choice_b": "Social engineering",
    "choice_c": "Phishing",
    "choice_d": "Whaling",
    "correct_answer": "B",
    "explanation": "Social engineering exploits humans to allow attacks to succeed. Since help desk employees are specifically tasked with being helpful, they may be targeted by attackers posing as legitimate employees. Trojans are a type of malware, whereas phishing is a targeted attack via electronic communication methods intended to capture passwords or other sensitive data. Whaling is a type of phishing aimed at high-profile or important targets.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      259,
      263,
      267,
      201,
      266
    ],
    "source": ""
  },
  {
    "id": 1048,
    "question": "Which one of the following is typically considered a business continuity task?",
    "choice_a": "Business impact assessment",
    "choice_b": "Alternate facility selection",
    "choice_c": "Activation of cold sites",
    "choice_d": "Restoration of data from backup",
    "correct_answer": "A",
    "explanation": "Developing a business impact assessment is an integral part of the business continuity planning effort. The selection of alternate facilities, activation of those facilities, and restoration of data from backup are all disaster recovery tasks.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      648,
      649,
      68,
      77,
      654
    ],
    "source": ""
  },
  {
    "id": 1049,
    "question": "What type of log is shown here? <br><img src=\"/question_assets/SSCP/c08uf006.png\"/>",
    "choice_a": "Firewall log",
    "choice_b": "Change log",
    "choice_c": "Application log",
    "choice_d": "System log",
    "correct_answer": "C",
    "explanation": "The file clearly shows HTTP requests, as evidenced by the many GET commands. Therefore, this is an example of an application log from an HTTP server.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      609,
      610,
      40,
      622,
      741
    ],
    "source": ""
  },
  {
    "id": 1050,
    "question": "Kathleen needs to set up an Active Directory trust to allow authentication with an existing Kerberos K5 domain. What type of trust does she need to create?",
    "choice_a": "A shortcut trust",
    "choice_b": "A forest trust",
    "choice_c": "An external trust",
    "choice_d": "A realm trust",
    "correct_answer": "D",
    "explanation": "Kerberos uses realms, and the proper type of trust to set up for an Active Directory environment that needs to connect to a K5 domain is a realm trust. A shortcut trust is a transitive trust between parts of a domain tree or forest that shortens the trust path, a forest trust is a transitive trust between two forest root domains, and an external trust is a nontransitive trust between AD domains in separate forests.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      562
    ],
    "source": ""
  },
  {
    "id": 1051,
    "question": "Ben owns a coffeehouse and wants to provide wireless Internet service for his customers. Ben's network is simple and uses a single consumer-grade wireless router and a cable modem connected via a commercial cable data contract. <br>How can Ben provide access control for his customers without having to provision user IDs before they connect while also gathering useful contact information for his business purposes?",
    "choice_a": "WPA2 PSK",
    "choice_b": "A captive portal",
    "choice_c": "Require customers to use a publicly posted password like \u201cBensCoffee\u201d",
    "choice_d": "Port security",
    "correct_answer": "B",
    "explanation": "A captive portal can require those who want to connect to and use Wi-Fi to provide an email address to connect. This allows Ben to provide easy-to-use wireless while meeting his business purposes. WPA2 PSK is the preshared key mode of WPA and won't provide information about users who are given a key. Sharing a password doesn't allow for data gathering either. Port security is designed to protect wired network ports based on MAC addresses.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      181,
      178,
      180,
      182,
      187
    ],
    "source": ""
  },
  {
    "id": 1052,
    "question": "Ben owns a coffeehouse and wants to provide wireless Internet service for his customers. Ben's network is simple and uses a single consumer-grade wireless router and a cable modem connected via a commercial cable data contract. <br>Ben intends to run an open (unencrypted) wireless network. How should he connect his business devices?",
    "choice_a": "Run WPA2 on the same SSID",
    "choice_b": "Set up a separate SSID using WPA2.",
    "choice_c": "Run the open network in Enterprise mod.",
    "choice_d": "Set up a separate wireless network using WEP.",
    "correct_answer": "B",
    "explanation": "Many modern wireless routers can provide multiple SSIDs. Ben can create a private, secure network for his business operations, but he will need to make sure that the customer and business networks are firewalled or otherwise logically separated from each other. Running WPA2 on the same SSID isn't possible without creating another wireless network and would cause confusion for customers (SSIDs aren't required to be unique). Running a network in Enterprise mode isn't used for open networks, and WEP is outdated and incredibly vulnerable.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      178,
      180,
      181,
      171,
      185
    ],
    "source": ""
  },
  {
    "id": 1053,
    "question": "Ben owns a coffeehouse and wants to provide wireless Internet service for his customers. Ben's network is simple and uses a single consumer-grade wireless router and a cable modem connected via a commercial cable data contract. <br>After implementing the solution from the first question, Ben receives a complaint about users in his cafe hijacking other customers' web traffic, including using their usernames and passwords. How is this possible?",
    "choice_a": "The password is shared by all users, making traffic vulnerable.",
    "choice_b": "A malicious user has installed a Trojan on the router.",
    "choice_c": "A user has ARP spoofed the router, making all traffic broadcast to all users.",
    "choice_d": "Open networks are unencrypted, making traffic easily sniffable.",
    "correct_answer": "D",
    "explanation": "Unencrypted open networks broadcast traffic in the clear. This means that unencrypted sessions to websites can be easily captured with a packet sniffer. Some tools like FireSheep have been specifically designed to capture sessions from popular websites. Fortunately, many now use TLS by default, but other sites still send user session information in the clear. Shared passwords are not the cause of the vulnerability, ARP spoofing isn't an issue with wireless networks, and a Trojan is designed to look like safe software, not to compromise a router.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      179,
      178,
      200,
      162,
      181
    ],
    "source": ""
  },
  {
    "id": 1054,
    "question": "Frank is the security administrator for a web server that provides news and information to people located around the world. His server received an unusually high volume of traffic that it could not handle and was forced to reject requests. Frank traced the source of the traffic back to a botnet. What type of attack took place?",
    "choice_a": "Denial-of-service",
    "choice_b": "Reconnaissance",
    "choice_c": "Compromise",
    "choice_d": "Malicious insider",
    "correct_answer": "A",
    "explanation": "This is a clear example of a denial-of-service attack\u2014denying legitimate users authorized access to the system through the use of overwhelming traffic. It goes beyond a reconnaissance attack because the attacker is affecting the system, but it is not a compromise because the attacker did not attempt to gain access to the system. There is no reason to believe that a malicious insider was involved.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      231,
      263,
      267,
      245,
      243
    ],
    "source": ""
  },
  {
    "id": 1055,
    "question": "SYN floods rely on implementations of what protocol to cause denial-of-service conditions?",
    "choice_a": "IGMP",
    "choice_b": "UDP",
    "choice_c": "TCP",
    "choice_d": "ICMP",
    "correct_answer": "C",
    "explanation": "SYN floods rely on the TCP implementation on machines and network devices to cause denial-of-service conditions.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      718,
      717,
      730,
      729,
      199
    ],
    "source": ""
  },
  {
    "id": 1056,
    "question": "What is the longest encryption key supported by the Advanced Encryption Standard (AES) algorithm?",
    "choice_a": "256 bits",
    "choice_b": "512 bits",
    "choice_c": "1,024 bits",
    "choice_d": "2,048 bits",
    "correct_answer": "A",
    "explanation": "The Advanced Encryption Standard (AES) supports the use of encryption keys that are 128 bits, 192 bits, or 256 bits in length.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      499,
      500,
      498,
      672,
      128
    ],
    "source": ""
  },
  {
    "id": 1057,
    "question": "During a system audit, Casey notices that the private key for her organization's web server has been stored in a public Amazon S3 storage bucket for more than a year. What should she do?",
    "choice_a": "Remove the key from the bucket.",
    "choice_b": "Notify all customers that their data may have been exposed.",
    "choice_c": "Request a new certificate using a new key.",
    "choice_d": "Nothing, because the private key should be accessible for validation",
    "correct_answer": "C",
    "explanation": "The first thing Casey should do is notify her management, but after that, replacing the certificate and using proper key management practices with the new certificate's key should be at the top of her list.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      500,
      498,
      672,
      666,
      522
    ],
    "source": ""
  },
  {
    "id": 1058,
    "question": "Which of the following is not a common threat to access control mechanisms?",
    "choice_a": "Fake login pages",
    "choice_b": "Phishing",
    "choice_c": "Dictionary attacks",
    "choice_d": "Man-in-the-middle attacks",
    "correct_answer": "B",
    "explanation": "Phishing is not an attack against an access control mechanism. While phishing can result in stolen credentials, the attack itself is not against the control system and is instead against the person being phished. Dictionary attacks and man-in-the-middle attacks both target access control systems.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      260,
      261,
      262,
      259,
      254
    ],
    "source": ""
  },
  {
    "id": 1059,
    "question": "Which one of the following would be considered an example of infrastructure as a service cloud computing?",
    "choice_a": "Payroll system managed by a vendor and delivered over the web",
    "choice_b": "Application platform managed by a vendor that runs customer code",
    "choice_c": "Servers provisioned by customers on a vendor-managed virtualization platform",
    "choice_d": "Web-based email service provided by a vendor",
    "correct_answer": "C",
    "explanation": "One of the core capabilities of infrastructure as a service is providing servers on a vendor-managed virtualization platform. Web-based payroll and email systems are examples of software as a service. An application platform managed by a vendor that runs customer code is an example of platform as a service.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      534,
      535,
      697,
      744,
      746
    ],
    "source": ""
  },
  {
    "id": 1060,
    "question": "Referring to the fire triangle shown here, which one of the following suppression materials attacks a fire by removing the fuel source? <br><img src=\"/question_assets/SSCP/c09uf001.png\"/>Image reprinted from CISSP ISC2 Certified Information Systems Security Professional Official Study Guide, 7th Edition \u00a9 John Wiley & Sons 2015. Reprinted with permission.",
    "choice_a": "Water",
    "choice_b": "Soda acid",
    "choice_c": "Carbon dioxide",
    "choice_d": "Halon",
    "correct_answer": "B",
    "explanation": "Soda acid and other dry powder extinguishers work to remove the fuel supply. Water suppresses temperature, while halon and carbon dioxide remove the oxygen supply from a fire.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      716,
      714,
      715,
      582,
      584
    ],
    "source": ""
  },
  {
    "id": 1061,
    "question": "What type of alternate processing facility contains the hardware necessary to restore operations but does not have a current copy of data?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Mobile site",
    "correct_answer": "B",
    "explanation": "Warm sites contain the hardware necessary to restore operations but do not have a current copy of data.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      496,
      495,
      497,
      653,
      77
    ],
    "source": ""
  },
  {
    "id": 1062,
    "question": "The IP address 201.19.7.45 is what type of address?",
    "choice_a": "A public IP address",
    "choice_b": "An RFC 1918 address",
    "choice_c": "An APIPA address",
    "choice_d": "A loopback address",
    "correct_answer": "A",
    "explanation": "201.19.7.45 is a public IP address. RFC 1918 addresses are in the ranges 10.0.0.0 to 0.255.255.255, 172.16.0.0 to 172.31.255.255, and 192.168.0.0 to 192.168.255.255. APIPA addresses are assigned between 169.254.0.0 to 169.254.255.254, and 127.0.0.1 is a loopback address (although technically the entire 127.x.x.x network is reserved for loopback).",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      470,
      468,
      505,
      506,
      450
    ],
    "source": ""
  },
  {
    "id": 1063,
    "question": "James has opted to implement a NAC solution that uses a post-admission philosophy for its control of network connectivity. What type of issues can't a strictly post-admission policy handle?",
    "choice_a": "Out-of-band monitoring",
    "choice_b": "Preventing an unpatched laptop from being exploited immediately after connecting to the network",
    "choice_c": "Denying access when user behavior doesn't match an authorization matrix",
    "choice_d": "Allowing user access when user behavior is allowed based on an authorization matrix",
    "correct_answer": "B",
    "explanation": "A post-admission philosophy allows or denies access based on user activity after connection. Since this doesn't check the status of a machine before it connects, it can't prevent the exploit of the system immediately after connection. This doesn't preclude out-of-band or in-band monitoring, but it does mean that a strictly post-admission policy won't handle system checks before the systems are admitted to the network.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      707,
      254,
      217,
      231,
      245
    ],
    "source": ""
  },
  {
    "id": 1064,
    "question": "What process adds a header and a footer to data received at each layer of the OSI model?",
    "choice_a": "Attribution",
    "choice_b": "Encapsulation",
    "choice_c": "TCP wrapping",
    "choice_d": "Data hiding",
    "correct_answer": "B",
    "explanation": "Encapsulation is a process that adds a header and possibly a footer to data received at each layer before handoff to the next layer. TCP wrappers are a host-based network access control system, attribution is determining who or what performed an action or sent data, and data hiding is a term from object-oriented programming that is not relevant here.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      504,
      505,
      179,
      717,
      508
    ],
    "source": ""
  },
  {
    "id": 1065,
    "question": "Which of the following is not one of the four canons of the ISC2 code of ethics?",
    "choice_a": "Avoid conflicts of interest that may jeopardize impartiality.",
    "choice_b": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "choice_c": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_d": "Provide diligent and competent service to principals.",
    "correct_answer": "A",
    "explanation": "The four canons of the ISC2 code of ethics are to protect society, the common good, necessary public trust and confidence, and the infrastructure; act honorably, honestly, justly, responsibly, and legally; provide diligent and competent service to principals; and advance and protect the profession.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      31,
      30,
      32,
      33,
      29
    ],
    "source": ""
  },
  {
    "id": 1066,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When the certificate authority (CA) created Renee's digital certificate, what key was contained within the body of the certificate?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "A",
    "explanation": "The purpose of a digital certificate is to provide the general public with an authenticated copy of the certificate subject's public key.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      672,
      674,
      522,
      671,
      499
    ],
    "source": ""
  },
  {
    "id": 1067,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When the certificate authority created Renee's digital certificate, what key did it use to digitally sign the completed certificate?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "D",
    "explanation": "The last step of the certificate creation process is the digital signature. During this step, the certificate authority signs the certificate using its own private key.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      672,
      674,
      522,
      524,
      104
    ],
    "source": ""
  },
  {
    "id": 1068,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When Mike receives Renee's digital certificate, what key does he use to verify the authenticity of the certificate?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "C",
    "explanation": "When an individual receives a copy of a digital certificate, he or she verifies the authenticity of that certificate by using the CA's public key to validate the digital signature contained on the certificate.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      672,
      522,
      524,
      500,
      674
    ],
    "source": ""
  },
  {
    "id": 1069,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>Mike would like to send Renee a private message using the information gained during this exchange. What key should he use to encrypt the message?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "A",
    "explanation": "Mike uses the public key that he extracted from Renee's digital certificate to encrypt the message that he would like to send to Renee.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      672,
      522,
      674,
      104,
      664
    ],
    "source": ""
  },
  {
    "id": 1070,
    "question": "Jim starts a new job as a system engineer, and his boss provides him with a document entitled \u201cForensic Response Guidelines.\u201d Which one of the following statements is not true?",
    "choice_a": "Jim must comply with the information in this document.",
    "choice_b": "The document contains information about forensic examinations.",
    "choice_c": "Jim should read the document thoroughly.",
    "choice_d": "The document is likely based on industry best practices.",
    "correct_answer": "A",
    "explanation": "Guidelines provide advice based on best practices developed throughout industry and organizations, but they are not compulsory. Compliance with guidelines is optional.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      735,
      736,
      737,
      71,
      72
    ],
    "source": ""
  },
  {
    "id": 1071,
    "question": "Alex has been employed by his company for more than a decade and has held a number of positions in the company. During an audit, it is discovered that he has access to shared folders and applications because of his former roles. What issue has Alex's company encountered?",
    "choice_a": "Excessive provisioning",
    "choice_b": "Unauthorized access",
    "choice_c": "Privilege creep",
    "choice_d": "Account review",
    "correct_answer": "C",
    "explanation": "Privilege creep occurs when users retain from roles they held previously rights they do not need to accomplish their current job. Unauthorized access occurs when an unauthorized user accesses files. Excessive provisioning is not a term used to describe permissions issues, and account review would help find issues like this.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      549,
      542,
      537,
      539,
      273
    ],
    "source": ""
  },
  {
    "id": 1072,
    "question": "RIP, OSPF, and BGP are all examples of protocols associated with what type of network device?",
    "choice_a": "Switches",
    "choice_b": "Bridges",
    "choice_c": "Routers",
    "choice_d": "Gateways",
    "correct_answer": "C",
    "explanation": "Routing Information Protocol (RIP), Open Shortest Path First (OSPF), and Border Gateway Protocol (BGP) are all routing protocols and are associated with routers.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      179,
      178,
      180,
      677,
      676
    ],
    "source": ""
  },
  {
    "id": 1073,
    "question": "If Susan's organization requires her to log in with her username, a PIN, a password, and a retina scan, how many distinct authentication factor types has she used?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "B",
    "explanation": "Susan has used two distinct types of factors: the PIN and password are both Type 1 factors, and the retina scan is a Type 3 factor. Her username is not a factor.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      564,
      565,
      483,
      708,
      273
    ],
    "source": ""
  },
  {
    "id": 1074,
    "question": "What process makes TCP a connection-oriented protocol?",
    "choice_a": "It works via network connections.",
    "choice_b": "It uses a handshake.",
    "choice_c": "It monitors for dropped connections.",
    "choice_d": "It uses a complex header.",
    "correct_answer": "B",
    "explanation": "TCP's use of a handshake process to establish communications makes it a connection-oriented protocol. TCP does not monitor for dropped connections, nor does the fact that it works via network connections make it connection-oriented.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      717,
      718,
      719,
      179,
      508
    ],
    "source": ""
  },
  {
    "id": 1075,
    "question": "What is the goal of the BCP process?",
    "choice_a": "RTO < MTD",
    "choice_b": "MTD < RTO",
    "choice_c": "RPO < MTD",
    "choice_d": "MTD < RPO",
    "correct_answer": "A",
    "explanation": "The goal of the business continuity planning process is to ensure that your recovery time objectives are all less than your maximum tolerable downtimes.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      495,
      496,
      654,
      648,
      649
    ],
    "source": ""
  },
  {
    "id": 1076,
    "question": "Which one of the following is an example of an administrative control?",
    "choice_a": "Intrusion detection system",
    "choice_b": "Security awareness training",
    "choice_c": "Firewalls",
    "choice_d": "Security guards",
    "correct_answer": "B",
    "explanation": "Awareness training is an example of an administrative control. Firewalls and intrusion detection systems are technical controls. Security guards are physical controls.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      29,
      31,
      30,
      572,
      490
    ],
    "source": ""
  },
  {
    "id": 1077,
    "question": "What level of RAID is also known as disk mirroring?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "B",
    "explanation": "RAID level 1 is also known as disk mirroring. RAID 0 is called disk striping. RAID 5 is called disk striping with parity. RAID 10 is known as a stripe of mirrors.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      24
    ],
    "source": ""
  },
  {
    "id": 1078,
    "question": "Lauren needs to send information about services she is provisioning to a third-party organization. What standards-based markup language should she choose to build the interface?",
    "choice_a": "SAML",
    "choice_b": "SOAP",
    "choice_c": "SPML",
    "choice_d": "XACML",
    "correct_answer": "C",
    "explanation": "Service Provisioning Markup Language, or SPML, is an XML-based language designed to allow platforms to generate and respond to provisioning requests. SAML is used to make authorization and authentication data, while XACML is used to describe access controls. SOAP, or Simple Object Access Protocol, is a messaging protocol and could be used for any XML messaging but is not a markup language itself.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      738,
      739,
      708,
      709,
      710
    ],
    "source": ""
  },
  {
    "id": 1079,
    "question": "TCP and UDP both operate at what layer of the OSI model?",
    "choice_a": "Layer 2",
    "choice_b": "Layer 3",
    "choice_c": "Layer 4",
    "choice_d": "Layer 5",
    "correct_answer": "C",
    "explanation": "TCP, UDP, and other transport layer protocols like SSL and TLS operate at the Transport layer.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      504,
      179,
      454,
      719,
      717
    ],
    "source": ""
  },
  {
    "id": 1080,
    "question": "Linda is selecting a disaster recovery facility for her organization, and she wants to retain independence from other organizations as much as possible. She would like to choose a facility that balances cost and recovery time, allowing activation in about one week after a disaster is declared. What type of facility should she choose?",
    "choice_a": "Cold site",
    "choice_b": "Warm site",
    "choice_c": "Mutual assistance agreement",
    "choice_d": "Hot site",
    "correct_answer": "B",
    "explanation": "Linda should choose a warm site. This approach balances cost and recovery time. Cold sites take a long time to activate, measured in weeks or months. Hot sites activate immediately but are quite expensive. Mutual assistance agreements depend on the support of another organization.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      495,
      496,
      497,
      654,
      656
    ],
    "source": ""
  },
  {
    "id": 1081,
    "question": "Which one of the following backup types does not alter the status of the archive bit on a file?",
    "choice_a": "Full backup",
    "choice_b": "Incremental backup",
    "choice_c": "Partial backup",
    "choice_d": "Differential backup",
    "correct_answer": "D",
    "explanation": "Differential backups do not alter the archive bit on a file, whereas incremental and full backups reset the archive bit to 0 after the backup completes. Partial backups are not a backup type.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      653,
      521,
      497,
      656,
      654
    ],
    "source": ""
  },
  {
    "id": 1082,
    "question": "During which phase of the incident response process would administrators design new security controls intended to prevent a recurrence of the incident?",
    "choice_a": "Reporting",
    "choice_b": "Recovery",
    "choice_c": "Remediation",
    "choice_d": "Lessons Learned",
    "correct_answer": "C",
    "explanation": "The Remediation phase of incident handling focuses on conducting a root-cause analysis to identify the factors contributing to an incident and implementing new security controls, as needed.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      72,
      79,
      77,
      78,
      71
    ],
    "source": ""
  },
  {
    "id": 1083,
    "question": "What type of Windows audit record describes events like an OS shutdown or a service being stopped?",
    "choice_a": "An application log",
    "choice_b": "A security log",
    "choice_c": "A system log",
    "choice_d": "A setup log",
    "correct_answer": "C",
    "explanation": "service state changes. Application logs record events generated by programs, security logs track events like logins and uses of rights, and setup logs track application setup.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      609,
      610,
      607,
      743,
      625
    ],
    "source": ""
  },
  {
    "id": 1084,
    "question": "During a log review, Karen discovers that the system she needs to gather logs from has the log setting shown here. What problem is Karen likely to encounter? <br><img src=\"/question_assets/SSCP/c09uf002.png\"/>",
    "choice_a": "Too much log data will be stored on the system.",
    "choice_b": "The system is automatically purging archived logs.",
    "choice_c": "The logs will not contain the information needed.",
    "choice_d": "The logs will contain only the most recent 20 MB of log data.",
    "correct_answer": "D",
    "explanation": "The system is set to overwrite the logs and will replace the oldest log entries with new log entries when the file reaches 20 MB. The system is not purging archived logs because it is not archiving logs. Since there can only be 20 MB of logs, this system will not have stored too much log data, and the question does not provide enough information to know whether there will be an issue with not having the information needed.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      742,
      741,
      743,
      603,
      604
    ],
    "source": ""
  },
  {
    "id": 1085,
    "question": "Microsoft's STRIDE threat assessment framework uses six categories for threats: Spoofing, Tampering, Repudiation, Information Disclosure, Denial of Service, and Elevation of Privilege. If a penetration tester is able to modify audit logs, what STRIDE categories best describe this issue?",
    "choice_a": "Tampering and information disclosure",
    "choice_b": "Elevation of privilege and tampering",
    "choice_c": "Repudiation and denial of service",
    "choice_d": "Repudiation and tampering",
    "correct_answer": "D",
    "explanation": "Modification of audit logs will prevent repudiation because the data cannot be trusted, and thus, actions cannot be provably denied. The modification of the logs is also a direct example of tampering. It might initially be tempting to answer elevation of privileges and tampering, as the attacker made changes to files that should be protected, but this is an unknown without more information. Similarly, the attacker may have accessed the files, resulting in information disclosure in addition to tampering, but again, this is not specified in the question. Finally, this did not cause a denial of service, and thus, that answer can be ignored.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      38,
      42,
      46,
      50,
      55
    ],
    "source": ""
  },
  {
    "id": 1086,
    "question": "What type of access control is being used in the following permission listing? <br>Storage Device X <br>User1: Can read, write, list <br>User2: Can read, list <br>User3: Can read, write, list, delete <br>User4: Can list",
    "choice_a": "Resource-based access controls",
    "choice_b": "Role-based access controls",
    "choice_c": "Mandatory access controls",
    "choice_d": "Rule-based access controls",
    "correct_answer": "A",
    "explanation": "Resource-based access controls match permissions to resources like a storage volume. Resource-based access controls are becoming increasingly common in cloud-based infrastructure as a service environments. The lack of roles, rules, or a classification system indicate that role-based, rule-based, and mandatory access controls are not in use here.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      537,
      539,
      540,
      555,
      541
    ],
    "source": ""
  },
  {
    "id": 1087,
    "question": "Fred's company wants to ensure the integrity of email messages sent via its central email servers. If the confidentiality of the messages is not critical, what solution should Fred suggest?",
    "choice_a": "Digitally sign and encrypt all messages to ensure integrity.",
    "choice_b": "Digitally sign but don't encrypt all messages.",
    "choice_c": "Use TLS to protect messages, ensuring their integrity.",
    "choice_d": "Use a hashing algorithm to provide a hash in each message to prove that it hasn't changed.",
    "correct_answer": "B",
    "explanation": "Fred's company needs to protect integrity, which can be accomplished by digitally signing messages. Any change will cause the signature to be invalid. Encrypting isn't necessary because the company does not want to protect confidentiality. TLS can provide in-transit protection but won't protect integrity of the messages, and of course a hash used without a way to verify that the hash wasn't changed won't ensure integrity either.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      664,
      663,
      124,
      103,
      116
    ],
    "source": ""
  },
  {
    "id": 1088,
    "question": "Which one of the following goals of physical security environments occurs first in the functional order of controls?",
    "choice_a": "Delay",
    "choice_b": "Detection",
    "choice_c": "Deterrence",
    "choice_d": "Denial",
    "correct_answer": "C",
    "explanation": "Deterrence is the first functional goal of physical security mechanisms. If a physical security control presents a formidable challenge to a potential attacker, they may not attempt the attack in the first place.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      722,
      588,
      720,
      591,
      515
    ],
    "source": ""
  },
  {
    "id": 1089,
    "question": "Cameron is responsible for backing up his company's primary file server. He configured a backup schedule that performs full backups every Monday evening at 9 p.m. and incremental backups on other days of the week at that same time. How many files will be copied in Wednesday's backup? <br><img src=\"/question_assets/SSCP/c09uf003.png\"/>",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "5",
    "choice_d": "6",
    "correct_answer": "B",
    "explanation": "In this scenario, all the files on the server will be backed up on Monday evening during the full backup. Tuesday's incremental backup will include all files changed since Monday's full backup: files 1, 2, and 5. Wednesday's incremental backup will then include all files modified since Tuesday's incremental backup: files 3 and 6.<br><img src=\"/question_assets/SSCP/c09uf009.png\"/>",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      653,
      521,
      497,
      656,
      632
    ],
    "source": ""
  },
  {
    "id": 1090,
    "question": "Lauren is responsible for building a banking website. She needs proof of the identity of the users who register for the site. How should she validate user identities?",
    "choice_a": "Require users to create unique questions that only they will know.",
    "choice_b": "Require new users to bring their driver's license or passport in person to the bank.",
    "choice_c": "Use information that both the bank and the user have such as questions pulled from their credit report.",
    "choice_d": "Call the user on their registered phone number to verify that they are who they claim to be.",
    "correct_answer": "C",
    "explanation": "Identity proofing can be done by comparing user information that the organization already has, such as account numbers or personal information. Requiring users to create unique questions can help with future support by providing a way for them to do password resets. Using a phone call only verifies that the individual who created the account has the phone that they registered and won't prove their identity. In-person verification would not fit the business needs of most websites.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      708,
      726,
      338,
      420,
      14
    ],
    "source": ""
  },
  {
    "id": 1091,
    "question": "Surveys, interviews, and audits are all examples of ways to measure what important part of an organization's security posture?",
    "choice_a": "Code quality",
    "choice_b": "Service vulnerabilities",
    "choice_c": "Awareness",
    "choice_d": "Attack surface",
    "correct_answer": "C",
    "explanation": "Interviews, surveys, and audits are all useful for assessing awareness. Code quality is best judged by code review, service vulnerabilities are tested using vulnerability scanners and related tools, and the attack surface of an organization requires both technical and administrative review.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      29,
      490,
      489,
      491,
      32
    ],
    "source": ""
  },
  {
    "id": 1092,
    "question": "In the image shown here, what does system B send to system A at step 2 of the three-way TCP handshake? <br><img src=\"/question_assets/SSCP/c09uf004.png\"/>",
    "choice_a": "SYN",
    "choice_b": "ACK",
    "choice_c": "FIN/ACK",
    "choice_d": "SYN/ACK",
    "correct_answer": "D",
    "explanation": "The three-way handshake is SYN, SYN/ACK, ACK. System B should respond with \u201cSynchronize and Acknowledge\u201d to System A after it receives a SYN.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      717,
      718,
      719,
      179,
      526
    ],
    "source": ""
  },
  {
    "id": 1093,
    "question": "Which one of the following is not a valid key length for the Advanced Encryption Standard?",
    "choice_a": "128 bits",
    "choice_b": "192 bits",
    "choice_c": "256 bits",
    "choice_d": "384 bits",
    "correct_answer": "D",
    "explanation": "The Advanced Encryption Standard supports encryption with 128-bit keys, 192-bit keys, and 256-bit keys.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      499,
      500,
      498,
      668,
      130
    ],
    "source": ""
  },
  {
    "id": 1094,
    "question": "Which one of the following is not a technique used by virus authors to hide the existence of their virus from anti-malware software?",
    "choice_a": "Stealth",
    "choice_b": "Multipartitism",
    "choice_c": "Polymorphism",
    "choice_d": "Encryption",
    "correct_answer": "B",
    "explanation": "Multipartite viruses use multiple propagation mechanisms to defeat system security controls but do not necessarily include techniques designed to hide the malware from antivirus software. Stealth viruses tamper with the operating system to hide their existence. Polymorphic viruses alter their code on each system they infect to defeat signature detection. Encrypted viruses use a similar technique, employing encryption to alter their appearance and avoid signature detection mechanisms.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      733,
      690,
      701,
      732,
      703
    ],
    "source": ""
  },
  {
    "id": 1095,
    "question": "The company that Fred works for is reviewing the security of its company-issued cell phones. They issue 4G-capable smartphones running Android and iOS and use a mobile device management solution to deploy company software to the phones. The mobile device management software also allows the company to remotely wipe the phones if they are lost. <br>What security considerations should Fred's company require for sending sensitive data over the cellular network?",
    "choice_a": "They should use the same requirements as data over any public network.",
    "choice_b": "Cellular provider networks are private networks and should not require special consideration.",
    "choice_c": "Encrypt all traffic to ensure confidentiality.",
    "choice_d": "Require the use of WAP for all data sent from the phone.",
    "correct_answer": "A",
    "explanation": "network does. Encryption requirements should match those that the organization selects for other public networks such as hotels, conference Wi-Fi, and similar scenarios. Encrypting all data is difficult and adds overhead, so it should not be the default answer unless the company specifically requires it. WAP is a dated wireless application protocol and is not in broad use; requiring it would be difficult. WAP does provide TLS, which would help when in use.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      200,
      178,
      502,
      180,
      182
    ],
    "source": ""
  },
  {
    "id": 1096,
    "question": "The company that Fred works for is reviewing the security of its company-issued cell phones. They issue 4G-capable smartphones running Android and iOS and use a mobile device management solution to deploy company software to the phones. The mobile device management software also allows the company to remotely wipe the phones if they are lost. <br>Fred intends to attend a major hacker conference this year. What should he do when connecting to his cellular provider's 4G network while at the conference?",
    "choice_a": "Continue normal usage.",
    "choice_b": "Discontinue all usage; towers can be spoofed.",
    "choice_c": "Only use trusted Wi-Fi networks.",
    "choice_d": "Connect to his company's encrypted VPN service.",
    "correct_answer": "D",
    "explanation": "Fred's best option is to use an encrypted, trusted VPN service to tunnel all of his data usage. Trusted Wi-Fi networks are unlikely to exist at a hacker conference, normal usage is dangerous due to the proliferation of technology that allows fake towers to be set up, and discontinuing all usage won't support Fred's business needs.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      179,
      200,
      178,
      162,
      197
    ],
    "source": ""
  },
  {
    "id": 1097,
    "question": "The company that Fred works for is reviewing the security of its company-issued cell phones. They issue 4G-capable smartphones running Android and iOS and use a mobile device management solution to deploy company software to the phones. The mobile device management software also allows the company to remotely wipe the phones if they are lost. <br> What are the most likely circumstances that would cause a remote wipe of a mobile phone to fail?",
    "choice_a": "The phone has a passcode on it.",
    "choice_b": "The phone cannot contact a network.",
    "choice_c": "The provider has not unlocked the phone.",
    "choice_d": "The phone is in use.",
    "correct_answer": "B",
    "explanation": "Remote wipe tools are a useful solution, but they work only if the phone can access either a cellular or Wi-Fi network. Remote wipe solutions are designed to wipe data from the phone regardless of whether it is in use or has a passcode. Providers unlock phones for use on other cellular networks rather than for wiping or other feature support.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      179,
      178,
      181,
      200,
      164
    ],
    "source": ""
  },
  {
    "id": 1098,
    "question": "Which one of the following is an example of risk transference?",
    "choice_a": "Building a guard shack",
    "choice_b": "Purchasing insurance",
    "choice_c": "Erecting fences",
    "choice_d": "Relocating facilities",
    "correct_answer": "B",
    "explanation": "Risk transference involves actions that shift risk from one party to another. Purchasing insurance is an example of risk transference because it moves risk from the insured to the insurance company.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      59,
      56,
      47,
      64,
      36
    ],
    "source": ""
  },
  {
    "id": 1099,
    "question": "Kyle is being granted access to a military computer system that uses System High mode. What is not true about Kyle's security clearance requirements?",
    "choice_a": "Kyle must have a clearance for the highest level of classification processed by the system, regardless of his access.",
    "choice_b": "Kyle must have access approval for all information processed by the system.",
    "choice_c": "Kyle must have a valid need to know for all information processed by the system.",
    "choice_d": "Kyle must have a valid security clearance.",
    "correct_answer": "C",
    "explanation": "For systems running in System High mode, the user must have a valid security clearance for all information processed by the system, access approval for all information processed by the system, and a valid need to know for some, but not necessarily all, information processed by the system.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      286,
      305,
      306,
      420,
      446
    ],
    "source": ""
  },
  {
    "id": 1100,
    "question": "Tom is conducting a business continuity planning effort for Orange Blossoms, a fruit orchard located in Central Florida. During the assessment process, the committee determined that there is a small risk of snow in the region but that the cost of implementing controls to reduce the impact of that risk is not warranted. They elect to not take any specific action in response to the risk. What risk management strategy is Orange Blossoms pursuing?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk transference",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk acceptance",
    "correct_answer": "D",
    "explanation": "Risk acceptance occurs when an organization determines that the costs involved in pursuing other risk management strategies are not justified and they choose not to pursue any action.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      64,
      59,
      63,
      62,
      61
    ],
    "source": ""
  },
  {
    "id": 1101,
    "question": "Carla has worked for her company for 15 years and has held a variety of different positions. Each time she changed positions, she gained new privileges associated with that position, but no privileges were ever taken away. What concept describes the sets of privileges she has accumulated?",
    "choice_a": "Entitlement",
    "choice_b": "Aggregation",
    "choice_c": "Transitivity",
    "choice_d": "Isolation",
    "correct_answer": "B",
    "explanation": "Carla's account has experienced aggregation, where privileges accumulated over time. This condition is also known as privilege creep and likely constitutes a violation of the least privilege principle.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      549,
      542,
      537,
      295,
      420
    ],
    "source": ""
  },
  {
    "id": 1102,
    "question": "Which one of the following types of agreements is the most formal document that contains expectations about availability and other performance parameters between a service provider and a customer?",
    "choice_a": "Service-level agreement (SLA)",
    "choice_b": "Operational-level agreement (OLA)",
    "choice_c": "Memorandum of understanding (MOU)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "A",
    "explanation": "The service-level agreement (SLA) is between a service provider and a customer and documents in a formal manner expectations around availability, performance, and other parameters. An MOU may cover the same items but is not as formal a document. An OLA is between internal service organizations and does not involve customers. An SOW is an addendum to a contract describing work to be performed.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      745,
      744,
      746,
      201,
      227
    ],
    "source": ""
  },
  {
    "id": 1103,
    "question": "Chris has been assigned to scan a system on all of its possible TCP and UDP ports. How many ports of each type must he scan to complete his assignment?",
    "choice_a": "65,536 TCP ports and 32,768 UDP ports",
    "choice_b": "1,024 common TCP ports and 32,768 ephemeral UDP ports",
    "choice_c": "65,536 TCP and 65,536 UDP ports",
    "choice_d": "16,384 TCP ports and 16,384 UDP ports",
    "correct_answer": "C",
    "explanation": "Both TCP and UDP port numbers are a 16-digit binary number, which means there can be 216 ports, or 65,536 ports, numbered from 0 to 65,535.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      618,
      616,
      35,
      39,
      52
    ],
    "source": ""
  },
  {
    "id": 1104,
    "question": "Lauren starts at her new job and finds that she has access to a variety of systems that she does not need to accomplish her job. What problem has she encountered?",
    "choice_a": "Privilege creep",
    "choice_b": "Rights collision",
    "choice_c": "Least privilege",
    "choice_d": "Excessive privileges",
    "correct_answer": "D",
    "explanation": "When users have more rights than they need to accomplish their job, they have excessive privileges. This is a violation of the concept of least privilege. Unlike creeping privileges, this is a provisioning or rights management issue rather than a problem of retention of rights the user needed but no longer requires. Rights collision is a made-up term and thus, is not an issue here.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      273,
      420,
      357,
      446,
      321
    ],
    "source": ""
  },
  {
    "id": 1105,
    "question": "Jim has been contracted to perform a penetration test of a bank's primary branch. To make the test as real as possible, he has not been given any information about the bank other than its name and address. What type of penetration test has Jim agreed to perform?",
    "choice_a": "A crystal-box penetration test",
    "choice_b": "A gray-box penetration test",
    "choice_c": "A black-box penetration test",
    "choice_d": "A white-box penetration test",
    "correct_answer": "C",
    "explanation": "Jim has agreed to a black-box penetration test, which provides no information about the organization, its systems, or its defenses. A crystal- or white-box penetration test provides all of the information an attacker needs, whereas a gray-box penetration test provides some, but not all, information.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      628,
      36,
      56,
      52,
      39
    ],
    "source": ""
  },
  {
    "id": 1106,
    "question": "Lauren builds a table that includes assigned privileges, objects, and subjects to manage access control for the systems she is responsible for. Each time a subject attempts to access an object, the systems check the table to ensure that the subject has the appropriate rights to the objects. What type of access control system is Lauren using?",
    "choice_a": "A capability table",
    "choice_b": "An access control list",
    "choice_c": "An access control matrix",
    "choice_d": "A subject/object rights management system",
    "correct_answer": "C",
    "explanation": "An access control matrix is a table that lists objects, subjects, and their privileges. Access control lists focus on objects and which subjects can access them. Capability tables list subjects and what objects they can access. Subject/object rights management systems are not based on an access control model.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      537,
      539,
      541,
      540,
      555
    ],
    "source": ""
  },
  {
    "id": 1107,
    "question": "A cloud-based service that provides account provisioning, management, authentication, authorization, reporting, and monitoring capabilities is known as what type of service?",
    "choice_a": "PaaS",
    "choice_b": "IDaaS",
    "choice_c": "IaaS",
    "choice_d": "SaaS",
    "correct_answer": "B",
    "explanation": "Identity as a service (IDaaS) provides capabilities such as account provisioning, management, authentication, authorization, reporting, and monitoring. Platform as a service (PaaS), infrastructure as a service (IaaS), and software as a service (SaaS) are other types of cloud computing capabilities that are not specialized identity management services.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      535,
      536,
      746,
      744,
      228
    ],
    "source": ""
  },
  {
    "id": 1108,
    "question": "What is the maximum penalty that may be imposed by an ISC2 peer review board when considering a potential ethics violation?",
    "choice_a": "Revocation of certification",
    "choice_b": "Termination of employment",
    "choice_c": "Financial penalty",
    "choice_d": "Suspension of certification",
    "correct_answer": "A",
    "explanation": "If the ISC2 peer review board finds that a certified individual has violated the ISC2 code of ethics, the board may revoke their certification. The board is not able to terminate an individual's employment or assess financial penalties.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      30,
      31,
      32,
      570,
      572
    ],
    "source": ""
  },
  {
    "id": 1109,
    "question": "Matthew, Richard, and Christopher would like to exchange messages with each other using symmetric cryptography. They want to ensure that each individual can privately send a message to another individual without the third person being able to read the message. How many keys do they need?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "6",
    "correct_answer": "C",
    "explanation": "They need a key for every possible pair of users in the cryptosystem. The first key would allow communication between Matthew and Richard. The second key would allow communication between Richard and Christopher. The third key would allow communication between Christopher and Matthew.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      498,
      500,
      104,
      103,
      106
    ],
    "source": ""
  },
  {
    "id": 1110,
    "question": "What UDP port is typically used by the syslog service?",
    "choice_a": "443",
    "choice_b": "514",
    "choice_c": "515",
    "choice_d": "445",
    "correct_answer": "B",
    "explanation": "Syslog uses UDP port 514. TCP-based implementations of syslog typically use port 6514. The other ports may look familiar because they are commonly used TCP ports: 443 is HTTPS, 515 is the LPD print service, and 445 is used for Windows SMB.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      453,
      455,
      189,
      507,
      509
    ],
    "source": ""
  },
  {
    "id": 1111,
    "question": "During which of the following disaster recovery tests does the team sit together and discuss the response to a scenario but not actually activate any disaster recovery controls?",
    "choice_a": "Checklist review",
    "choice_b": "Full interruption test",
    "choice_c": "Parallel test",
    "choice_d": "Tabletop exercise",
    "correct_answer": "D",
    "explanation": "During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      655,
      654,
      656,
      648,
      650
    ],
    "source": ""
  },
  {
    "id": 1112,
    "question": "Which one of the following is a detailed, step-by-step document that describes the exact actions that individuals must complete?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "D",
    "explanation": "Procedures are formal, mandatory documents that provide detailed, step-by-step actions required from individuals performing a task.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      735,
      736,
      72,
      88,
      84
    ],
    "source": ""
  },
  {
    "id": 1113,
    "question": "Tammy is selecting a disaster recovery facility for her organization. She would like to choose a facility that balances the time required to recover operations with the cost involved. What type of facility should she choose?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Red site",
    "correct_answer": "B",
    "explanation": "Tammy should choose a warm site. This type of facility meets her requirements for a good balance between cost and recovery time. It is less expensive than a hot site but facilitates faster recovery than a cold site. A red site is not a type of disaster recovery facility.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      496,
      495,
      497,
      651,
      72
    ],
    "source": ""
  },
  {
    "id": 1114,
    "question": "Which one of the following statements about malware is correct?",
    "choice_a": "Malware authors do not target Macintosh or Linux systems.",
    "choice_b": "The most reliable way to detect known malware is watching for unusual system activity.",
    "choice_c": "Signature detection is the most effective technique to combat known malware.",
    "choice_d": "APT attackers typically use malware designed to exploit vulnerabilities identified in security bulletins.",
    "correct_answer": "C",
    "explanation": "Signature detection is extremely effective against known strains of malware because it uses a reliable pattern matching technique to identify known malware. Signature detection is, therefore, the most reliable way to detect known malware. This technique is not, however, effective against the zero-day malware typically used by advanced persistent threats (APTs) that does not exploit vulnerabilities identified in security bulletins. While malware authors once almost exclusively targeted Windows systems, malware now exists for all major platforms.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      690,
      701,
      699,
      692,
      734
    ],
    "source": ""
  },
  {
    "id": 1115,
    "question": "Ben needs to verify that the most recent patch for his organization's critical application did not introduce issues elsewhere. What type of testing does Ben need to conduct to ensure this?",
    "choice_a": "Unit testing",
    "choice_b": "White box",
    "choice_c": "Regression testing",
    "choice_d": "Black box",
    "correct_answer": "C",
    "explanation": "Regression testing ensures proper functionality of an application or system after it has been changed. Unit testing focuses on testing each module of a program instead of against its previous functional state. White- and black-box testing both describe the amount of knowledge about a system or application, rather than a specific type or intent for testing.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      487,
      579,
      581,
      488,
      516
    ],
    "source": ""
  },
  {
    "id": 1116,
    "question": "Warren is designing a physical intrusion detection system for his data center and wants to include technology that issues an alert if the communications lines for the alarm system are unexpectedly cut. What technology would meet this requirement?",
    "choice_a": "Heartbeat sensor",
    "choice_b": "Emanation security",
    "choice_c": "Motion detector",
    "choice_d": "Faraday cage",
    "correct_answer": "A",
    "explanation": "Heartbeat sensors send periodic status messages from the alarm system to the monitoring center. The monitoring center triggers an alarm if it does not receive a status message for a prolonged period of time, indicating that communications were disrupted.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      40,
      61,
      55,
      50,
      53
    ],
    "source": ""
  },
  {
    "id": 1117,
    "question": "Greg is battling a malware outbreak in his organization. He used specialized malware analysis tools to capture samples of the malware from three different systems and noticed that the code is changing slightly from infection to infection. Greg believes that this is the reason that antivirus software is having a tough time defeating the outbreak. What type of malware should Greg suspect is responsible for this security incident?",
    "choice_a": "Stealth virus",
    "choice_b": "Polymorphic virus",
    "choice_c": "Multipartite virus",
    "choice_d": "Encrypted virus",
    "correct_answer": "B",
    "explanation": "Polymorphic viruses mutate each time they infect a system by making adjustments to their code that assists them in evading signature detection mechanisms. Encrypted viruses also mutate from infection to infection but do so by encrypting themselves with different keys on each device.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      690,
      701,
      733,
      692,
      704
    ],
    "source": ""
  },
  {
    "id": 1118,
    "question": "Which group is best suited to evaluate and report on the effectiveness of administrative controls an organization has put in place to a third party?",
    "choice_a": "Internal auditors",
    "choice_b": "Penetration testers",
    "choice_c": "External auditors",
    "choice_d": "Employees who design, implement, and monitor the controls",
    "correct_answer": "C",
    "explanation": "External auditors can provide an unbiased and impartial view of an organization's controls to third parties. Internal auditors are useful when reporting to senior management of the organization but are typically not asked to report to third parties. Penetration tests test technical controls but are not as well suited to testing many administrative controls. The employees who build and maintain controls are more likely to bring a bias to the testing of those controls and should not be asked to report on them to third parties.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      491,
      489,
      492,
      518,
      493
    ],
    "source": ""
  },
  {
    "id": 1119,
    "question": "In virtualization platforms, what name is given to the module that is responsible for controlling access to physical resources by virtual resources?",
    "choice_a": "Guest machine",
    "choice_b": "SDN",
    "choice_c": "Kernel",
    "choice_d": "Hypervisor",
    "correct_answer": "D",
    "explanation": "The hypervisor runs within the virtualization platform and serves as the moderator between virtual resources and physical resources.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      696,
      534,
      265,
      215,
      222
    ],
    "source": ""
  },
  {
    "id": 1120,
    "question": "Google's identity integration with a variety of organizations and applications across domains is an example of which of the following?",
    "choice_a": "PKI",
    "choice_b": "Federation",
    "choice_c": "Single sign-on",
    "choice_d": "Provisioning",
    "correct_answer": "B",
    "explanation": "Google's federation with other applications and organizations allows single sign-on as well as management of their electronic identity and its related attributes. While this is an example of SSO, it goes beyond simple single sign-on. Provisioning provides accounts and rights, and a public key infrastructure is used for certificate management.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      543,
      545,
      542,
      349,
      281
    ],
    "source": ""
  },
  {
    "id": 1121,
    "question": "Joe wants to test a program he suspects may contain malware. What technology can he use to isolate the program while it runs?",
    "choice_a": "ASLR",
    "choice_b": "Sandboxing",
    "choice_c": "Clipping",
    "choice_d": "Process isolation",
    "correct_answer": "B",
    "explanation": "Running the program in a sandbox provides secure isolation that can prevent the malware from impacting other applications or systems. If Joe uses appropriate instrumentation, he can observe what the program does, what changes it makes, and any communications it may attempt. ASLR is a memory location randomization technology, process isolation keeps processes from impacting each other, but a sandbox typically provides greater utility in a scenario like this since it can be instrumented and managed in a way that better supports investigations, and clipping is a term often used in signal processing.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      535,
      697,
      245,
      266,
      227
    ],
    "source": ""
  },
  {
    "id": 1122,
    "question": "What type of attack would the following precautions help prevent? <br>Requesting proof of identity <br>Requiring callback authorizations on voice-only requests <br>Not changing passwords via voice communications",
    "choice_a": "DoS attacks",
    "choice_b": "Worms",
    "choice_c": "Social engineering",
    "choice_d": "Shoulder surfing",
    "correct_answer": "C",
    "explanation": "Each of the precautions listed helps to prevent social engineering by helping prevent exploitation of trust. Avoiding voice-only communications is particularly important since establishing identity over the phone is difficult. The other listed attacks would not be prevented by these techniques.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      259,
      214,
      230,
      239,
      256
    ],
    "source": ""
  },
  {
    "id": 1123,
    "question": "Mike has been tasked with preventing an outbreak of malware like Mirai. What type of systems should be protected in his organization?",
    "choice_a": "Servers",
    "choice_b": "SCADA",
    "choice_c": "Mobile devices",
    "choice_d": "Internet of Things (IoT) devices",
    "correct_answer": "D",
    "explanation": "Mirai targeted Internet of Things devices, including routers, cameras, and DVRs. As organizations bring an increasing number of devices like these into their corporate networks, protecting both internal and external targets from insecure, infrequently updated, and often vulnerable IoT devices is increasingly important.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      234,
      245,
      265,
      220,
      227
    ],
    "source": ""
  },
  {
    "id": 1124,
    "question": "What type of risk assessment uses tools such as the one shown here? <br><img src=\"/question_assets/SSCP/c09uf005.png\"/>",
    "choice_a": "Quantitative",
    "choice_b": "Loss expectancy",
    "choice_c": "Financial",
    "choice_d": "Qualitative",
    "correct_answer": "D",
    "explanation": "The use of a probability/impact matrix is the hallmark of a qualitative risk assessment. It uses subjective measures of probability and impact, such as \u201chigh\u201d and \u201clow,\u201d in place of quantitative measures.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      456,
      597,
      596,
      594,
      612
    ],
    "source": ""
  },
  {
    "id": 1125,
    "question": "Ben has written the password hashing system for the web application he is building. His hashing code function for passwords results in the following process for a series of passwords: <br><img src=\"/question_assets/SSCP/pe2_image1.png\"/> What flaw has Ben introduced with his hashing implementation?",
    "choice_a": "Plaintext salting",
    "choice_b": "Salt reuse",
    "choice_c": "Use of a short salt",
    "choice_d": "Poor salt algorithm selection",
    "correct_answer": "B",
    "explanation": "Ben is reusing his salt. When the same salt is used for each hash, all users with the same password will have the same hash, and the attack can either attempt to steal the salt or may attempt to guess the salt by targeting the most frequent hash occurrences based on commonly used passwords. Short salts are an issue, but the salts used here are 32 bytes (256 bits) long. There is no salting algorithm used or mentioned here; salt is an added value for a hash, and plaintext salting is a made-up term.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      752,
      751,
      750,
      663,
      665
    ],
    "source": ""
  },
  {
    "id": 1126,
    "question": "Which one of the following tools is most often used for identification purposes and is not suitable for use as an authenticator?",
    "choice_a": "Password",
    "choice_b": "Retinal scan",
    "choice_c": "Username",
    "choice_d": "Token",
    "correct_answer": "C",
    "explanation": "Usernames are an identification tool. They are not secret, so they are not suitable for use as a password.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      726,
      322,
      357,
      327,
      5
    ],
    "source": ""
  },
  {
    "id": 1127,
    "question": "Theresa is implementing a new access control system and wants to ensure that developers do not have the ability to move code from development systems into the production environment. What information security principle is she most directly enforcing?",
    "choice_a": "Separation of duties",
    "choice_b": "Two-person control",
    "choice_c": "Least privilege",
    "choice_d": "Job rotation",
    "correct_answer": "A",
    "explanation": "While developers may feel like they have a business need to be able to move code into production, the principle of separation of duties dictates that they should not have the ability to both write code and place it on a production server. The deployment of code is often performed by change management staff.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      420,
      321,
      317,
      427,
      330
    ],
    "source": ""
  },
  {
    "id": 1128,
    "question": "NIST Special Publication 800-92, the Guide to Computer Security Log Management, describes four types of common challenges to log management: <br><li>Many log sources</li><li>Inconsistent log content</li><li>Inconsistent timestamps</li><li>Inconsistent log formats</li> <br>Which of the following solutions is best suited to solving these issues?<br>",
    "choice_a": "Implement SNMP for all logging devices.",
    "choice_b": "Implement a SIEM.",
    "choice_c": "Standardize on the Windows event log format for all devices and use NTP.",
    "choice_d": "Ensure that logging is enabled on all endpoints using their native logging formats and set their local time correctly.",
    "correct_answer": "B",
    "explanation": "A security information and event management (SIEM) tool is designed to centralize logs from many locations in many formats and to ensure that logs are read and analyzed despite differences between different systems and devices. The Simple Network Management Protocol (SNMP) is used for some log messaging but is not a solution that solves all of these problems. Most non-Windows devices, including network devices among others, are not designed to use the Windows event log format, although using NTP for time synchronization is a good idea. Finally, local logging is useful, but setting clocks individually will result in drift over time and won't solve the issue with many log sources.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      622,
      609,
      40,
      471,
      611
    ],
    "source": ""
  },
  {
    "id": 1129,
    "question": "Which one of the following components should be included in an organization's emergency response guidelines?",
    "choice_a": "Secondary response procedures for first responders",
    "choice_b": "Long-term business continuity protocols",
    "choice_c": "Activation procedures for the organization's cold sites",
    "choice_d": "Contact information for ordering equipment",
    "correct_answer": "A",
    "explanation": "The emergency response guidelines should include the immediate steps an organization should follow in response to an emergency situation. These include immediate response procedures, a list of individuals who should be notified of the emergency, and secondary response procedures for first responders. They do not include long-term actions such as activating business continuity protocols, ordering equipment, or activating disaster recovery sites.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      99,
      71,
      69,
      101,
      648
    ],
    "source": ""
  },
  {
    "id": 1130,
    "question": "Grace is considering the use of new identification cards in her organization that will be used for physical access control. She comes across the sample card shown here and is unsure of the technology it uses. What type of card is this? <br><img src=\"/question_assets/SSCP/c09uf006.png\"/>",
    "choice_a": "Smart card",
    "choice_b": "Phase-two card",
    "choice_c": "Proximity card",
    "choice_d": "Magnetic stripe card",
    "correct_answer": "D",
    "explanation": "The image clearly shows a black magnetic stripe running across the card, making this an example of a magnetic stripe card.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      280,
      308,
      283,
      312,
      4
    ],
    "source": ""
  },
  {
    "id": 1131,
    "question": "Gary is analyzing a security incident and, during his investigation, encounters a user who denies having performed an action that Gary believes he did perform. What type of threat has taken place under the STRIDE model?",
    "choice_a": "Repudiation",
    "choice_b": "Information disclosure",
    "choice_c": "Tampering",
    "choice_d": "Elevation of privilege",
    "correct_answer": "A",
    "explanation": "Repudiation threats allow an attacker to deny having performed an action or activity without the other party being able to prove differently.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      34,
      46,
      55,
      59,
      41
    ],
    "source": ""
  },
  {
    "id": 1132,
    "question": "After scanning all the systems on his wireless network, Mike notices that one system is identified as an iOS device running a massively out-of-date version of Apple's mobile operating system. When he investigates further, he discovers that the device is an original iPad and that it cannot be updated to a current secure version of the operating system. What should Mike recommend?",
    "choice_a": "Retire or replace the device.",
    "choice_b": "Isolate the device on a dedicated wireless network.",
    "choice_c": "Install a firewall on the tablet.",
    "choice_d": "Reinstall the OS.",
    "correct_answer": "A",
    "explanation": "When operating system patches are no longer available for mobile devices, the best option is typically to retire or replace the device. Building isolated networks will not stop the device from being used for browsing or other purposes, which means it is likely to continue to be exposed to threats. Installing a firewall will not remediate the security flaws in the OS, although it may help somewhat. Finally, reinstalling the OS will not allow new updates or fix the root issue.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      181,
      178,
      164,
      185,
      200
    ],
    "source": ""
  },
  {
    "id": 1133,
    "question": "What type of access control scheme is shown in the following table? <br><img src=\"/question_assets/SSCP/pe2_image7.png\"/>",
    "choice_a": "RBAC",
    "choice_b": "DAC",
    "choice_c": "MAC",
    "choice_d": "TBAC",
    "correct_answer": "C",
    "explanation": "Mandatory access controls use a lattice to describe how classification labels relate to each other. In this image, classification levels are set for each of the labels shown. A discretionary access control (DAC) system would show how the owner of the objects allows access. RBAC could be either rule- or role-based access control and would use either system-wide rules or roles. Task-based access control (TBAC) would list tasks for users.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      537,
      539,
      710,
      345,
      551
    ],
    "source": ""
  },
  {
    "id": 1134,
    "question": "Rick is an application developer who works primarily in Python. He recently decided to evaluate a new service where he provides his Python code to a vendor who then executes it on their server environment. What type of cloud computing environment is this service?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "IaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "Cloud computing systems where the customer only provides application code for execution on a vendor-supplied computing platform are examples of platform as a service (PaaS) computing.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      535,
      697,
      698,
      744,
      746
    ],
    "source": ""
  },
  {
    "id": 1135,
    "question": "During a penetration test, Chris recovers a file containing hashed passwords for the system he is attempting to access. What type of attack is most likely to succeed against the hashed passwords?",
    "choice_a": "A brute-force attack",
    "choice_b": "A pass-the-hash attack",
    "choice_c": "A rainbow table attack",
    "choice_d": "A salt recovery attack",
    "correct_answer": "C",
    "explanation": "Rainbow tables are databases of prehashed passwords paired with high-speed lookup functions. Since they can quickly compare known hashes against those in a file, using rainbow tables is the fastest way to quickly determine passwords from hashes. A brute-force attack may eventually succeed but will be very slow against most hashes. Pass-the-hash attacks rely on sniffed or otherwise acquired NTLM or LanMan hashes being sent to a system to avoid the need to know a user's password. Salts are data added to a hash to avoid the use of tools like rainbow tables. A salt added to a password means the hash won't match a rainbow table generated without the same salt.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      35,
      46,
      62,
      59,
      65
    ],
    "source": ""
  },
  {
    "id": 1136,
    "question": "Kay is selecting an application management approach for her organization. Employees need the flexibility to install software on their systems, but Kay wants to prevent them from installing certain prohibited packages. What type of approach should she use?",
    "choice_a": "Antivirus",
    "choice_b": "Whitelist",
    "choice_c": "Blacklist",
    "choice_d": "Heuristic",
    "correct_answer": "C",
    "explanation": "The blacklist approach to application control blocks certain prohibited packages but allows the installation of other software on systems. The whitelist approach uses the reverse philosophy and allows only approved software. Antivirus software would detect the installation of malicious software only after the fact. Heuristic detection is a variant of antivirus software.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      694,
      693,
      695,
      690,
      703
    ],
    "source": ""
  },
  {
    "id": 1137,
    "question": "Owen recently designed a security access control structure that prevents a single user from simultaneously holding the role required to create a new vendor and the role required to issue a check. What principle is Owen enforcing?",
    "choice_a": "Two-person control",
    "choice_b": "Least privilege",
    "choice_c": "Separation of duties",
    "choice_d": "Job rotation",
    "correct_answer": "C",
    "explanation": "This scenario describes separation of duties\u2014not allowing the same person to hold two roles that, when combined, are sensitive. While two-person control is a similar concept, it does not apply in this case because the scenario does not say that either action requires the concurrence of two users.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      420,
      557,
      330,
      273,
      15
    ],
    "source": ""
  },
  {
    "id": 1138,
    "question": "IP addresses like 10.10.10.10 and 172.19.24.21 are both examples of what type of IP address?",
    "choice_a": "Public IP addresses",
    "choice_b": "Prohibited IP addresses",
    "choice_c": "Private IP addresses",
    "choice_d": "Class B IP ranges",
    "correct_answer": "C",
    "explanation": "These are examples of private IP addresses. RFC1918 defines a set of private IP addresses for use in internal networks. These private addresses including 10.0.0.0 to 10.255.255.255, 172.16.0.0 to 172.31.255.255, and 192.168.0.0 to 196.168.255.255 should never be routable on the public Internet.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      470,
      507,
      468,
      506,
      505
    ],
    "source": ""
  },
  {
    "id": 1139,
    "question": "Fran's company is considering purchasing a web-based email service from a vendor and eliminating its own email server environment as a cost-saving measure. What type of cloud computing environment is Fran's company considering?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "CaaS",
    "choice_d": "PaaS",
    "correct_answer": "A",
    "explanation": "This is an example of a vendor offering a fully functional application as a web-based service. Therefore, it fits under the definition of software as a service (SaaS). In infrastructure as a service (IaaS), compute as a service (CaaS), and platform as a service (PaaS) approaches, the customer provides their own software. In this example, the vendor is providing the email software, so none of those choices is appropriate.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      535,
      746,
      744,
      745,
      201
    ],
    "source": ""
  },
  {
    "id": 1140,
    "question": "Which component of IPsec provides authentication, integrity, and nonrepudiation?",
    "choice_a": "L2TP",
    "choice_b": "Encapsulating Security Payload",
    "choice_c": "Encryption Security Header",
    "choice_d": "Authentication Header",
    "correct_answer": "D",
    "explanation": "The Authentication Header provides authentication, integrity, and nonrepudiation for IPsec connections. The Encapsulating Security Payload provides encryption and thus, provides confidentiality. It can also provide limited authentication. L2TP is an independent VPN protocol, and Encryption Security Header is a made-up term.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      124,
      104,
      128,
      146,
      116
    ],
    "source": ""
  },
  {
    "id": 1141,
    "question": "Alex's job requires him to see protected health information (PHI) to ensure proper treatment of patients. His access to their medical records does not provide access to patient addresses or billing information. What access control concept best describes this control?",
    "choice_a": "Separation of duties",
    "choice_b": "Constrained interfaces",
    "choice_c": "Context-dependent control",
    "choice_d": "Need to know",
    "correct_answer": "D",
    "explanation": "Need to know is applied when subjects like Alex have access to only the data they need to accomplish their job. Separation of duties is used to limit fraud and abuse by having multiple employees perform parts of a task. Constrained interfaces restrict what a user can see or do and would be a reasonable answer if need to know did not describe his access more completely in this scenario. Context-dependent control relies on the activity being performed to apply controls, and this question does not specify a workflow or process.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      555,
      556,
      540,
      413,
      330
    ],
    "source": ""
  },
  {
    "id": 1142,
    "question": "Which one of the following investigation types has the loosest standards for collecting and preserving information?",
    "choice_a": "Civil investigation",
    "choice_b": "Operational investigation",
    "choice_c": "Criminal investigation",
    "choice_d": "Regulatory investigation",
    "correct_answer": "B",
    "explanation": "Operational investigations are performed by internal teams to troubleshoot performance or other technical issues. They are not intended to produce evidence for use in court and, therefore, do not have the rigid collection standards of criminal, civil, or regulatory investigations.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      658,
      659,
      644,
      643,
      711
    ],
    "source": ""
  },
  {
    "id": 1143,
    "question": "Susan is working to improve the strength of her organization's passwords by changing the password policy. The password system that she is using allows uppercase and lowercase letters as well as numbers but no other characters. How much additional complexity does adding a single character to the minimum length of passwords for her organization create?",
    "choice_a": "26 times more complex",
    "choice_b": "62 times more complex",
    "choice_c": "36 times more complex",
    "choice_d": "2^62 times more complex",
    "correct_answer": "B",
    "explanation": "The complexity of brute-forcing a password increases based on both the number of potential characters and the number of letters added. In this case, there are 26 lowercase letters, 26 uppercase letters, and 10 possible digits. That creates 62 possibilities. Since we added only a single letter of length, we get 62^1, or 62 possibilities, and thus, the new passwords would be 62 times harder to brute-force on average.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      748,
      747,
      749,
      1,
      7
    ],
    "source": ""
  },
  {
    "id": 1144,
    "question": "Purchasing insurance is a form of what type of risk response?",
    "choice_a": "Transfer",
    "choice_b": "Avoid",
    "choice_c": "Mitigate",
    "choice_d": "Accept",
    "correct_answer": "A",
    "explanation": "Purchasing insurance is a way to transfer risk to another entity.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      59,
      56,
      47,
      42,
      62
    ],
    "source": ""
  },
  {
    "id": 1145,
    "question": "Which one of the following metrics specifies the amount of time that business continuity planners find acceptable for the restoration of service after a disaster?",
    "choice_a": "MTD",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "MTO",
    "correct_answer": "B",
    "explanation": "The recovery time objective (RTO) is the amount of time that it may take to restore a service after a disaster without unacceptable impact on the business. The RTO for each service is identified during a business impact assessment.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      495,
      496,
      648,
      654,
      72
    ],
    "source": ""
  },
  {
    "id": 1146,
    "question": "Jacob is planning his organization's biometric authentication system and is considering retina scans. What concern may be raised about retina scans by others in his organization?",
    "choice_a": "Retina scans can reveal information about medical conditions.",
    "choice_b": "Retina scans are painful because they require a puff of air in the user's eye.",
    "choice_c": "Retina scanners are the most expensive type of biometric device.",
    "choice_d": "Retina scanners have a high false positive rate and will cause support issues.",
    "correct_answer": "A",
    "explanation": "Retina scans can reveal additional information, including high blood pressure and pregnancy, causing privacy concerns. Newer retina scans don't require a puff of air, and retina scanners are not the most expensive biometric factor. Their false positive rate can typically be adjusted in software, allowing administrators to adjust their acceptance rate as needed to balance usability and security.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      565,
      484,
      483,
      485,
      305
    ],
    "source": ""
  },
  {
    "id": 1147,
    "question": "What is the best way to ensure email confidentiality in motion?",
    "choice_a": "Use TLS between the client and server.",
    "choice_b": "Use SSL between the client and server.",
    "choice_c": "Encrypt the email content.",
    "choice_d": "Use a digital signature.",
    "correct_answer": "C",
    "explanation": "The SMTP protocol does not guarantee confidentiality between servers, making TLS or SSL between the client and server only a partial measure. Encrypting the email content can provide confidentiality; digital signatures can provide nonrepudiation.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      107,
      124,
      128,
      103,
      147
    ],
    "source": ""
  },
  {
    "id": 1148,
    "question": "What layer of the OSI model is associated with datagrams?",
    "choice_a": "Session",
    "choice_b": "Transport",
    "choice_c": "Network",
    "choice_d": "Data Link",
    "correct_answer": "B",
    "explanation": "When data reaches the Transport layer, it is sent as segments (TCP) or datagrams (UDP). Above the Transport layer, data becomes a data stream, while below the Transport layer they are converted to packets at the Network layer, frames at the Data Link layer, and bits at the Physical layer.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      504,
      454,
      179,
      675,
      676
    ],
    "source": ""
  },
  {
    "id": 1149,
    "question": "What type of vulnerability scan accesses configuration information from the systems it is run against as well as information that can be accessed via services available via the network?",
    "choice_a": "Authenticated scans",
    "choice_b": "Web application scans",
    "choice_c": "Unauthenticated scans",
    "choice_d": "Port scans",
    "correct_answer": "A",
    "explanation": "Authenticated scans use a read-only account to access configuration files, allowing more accurate testing of vulnerabilities. Web application, unauthenticated scans, and port scans don't have access to configuration files unless they are inadvertently exposed.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      620,
      617,
      602,
      606,
      601
    ],
    "source": ""
  },
  {
    "id": 1150,
    "question": "What term is used to describe a starting point for a minimum security standard?",
    "choice_a": "Outline",
    "choice_b": "Baseline",
    "choice_c": "Policy",
    "choice_d": "Configuration guide",
    "correct_answer": "B",
    "explanation": "A baseline is used to ensure a minimum security standard. A policy is the foundation that a standard may point to for authority, and a configuration guide may be built from a baseline to help staff who need to implement it to accomplish their task. An outline is helpful, but outline isn't the term you're looking for here.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      265,
      701,
      257,
      221,
      244
    ],
    "source": ""
  },
  {
    "id": 1151,
    "question": "Full disk encryption like Microsoft's BitLocker is used to protect data in what state?",
    "choice_a": "Data in transit",
    "choice_b": "Data at rest",
    "choice_c": "Unlabeled data",
    "choice_d": "Labeled data",
    "correct_answer": "B",
    "explanation": "Full disk encryption only protects data at rest. Since it encrypts the full disk, it does not distinguish between labeled and unlabeled data.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      666,
      668,
      107,
      667,
      663
    ],
    "source": ""
  },
  {
    "id": 1152,
    "question": "Gwen comes across an application that is running under a service account on a web server. The service account has full administrative rights to the server. What principle of information security does this violate?",
    "choice_a": "Need to know",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Job rotation",
    "correct_answer": "C",
    "explanation": "This scenario violates the least privilege principle because an application should never require full administrative rights to run. Gwen should update the service account to have only the privileges necessary to support the application.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      549,
      550,
      330,
      315,
      420
    ],
    "source": ""
  },
  {
    "id": 1153,
    "question": "Using the OSI model, what format does the Data Link layer use to format messages received from higher up the stack?",
    "choice_a": "A data stream",
    "choice_b": "A frame",
    "choice_c": "A segment",
    "choice_d": "A datagram",
    "correct_answer": "B",
    "explanation": "When a message reaches the Data Link layer, it is called a frame. Data streams exist at the Application, Presentation, and Session layers, whereas segments and datagrams exist at the Transport layer (for TCP and UDP, respectively).",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      504,
      505,
      179,
      682,
      719
    ],
    "source": ""
  },
  {
    "id": 1154,
    "question": "What type of forensic investigation typically has the highest evidentiary standards?",
    "choice_a": "Administrative",
    "choice_b": "Criminal",
    "choice_c": "Civil",
    "choice_d": "Industry",
    "correct_answer": "B",
    "explanation": "Criminal forensic investigations typically have the highest standards for evidence, as they must be able to help prove the case beyond a reasonable doubt. Administrative investigations merely need to meet the standards of the organization and to be able to be defended in court, while civil investigations operate on a preponderance of evidence. There is not a category of forensic investigation referred to as \u201cindustry\u201d in the exam's breakdown of forensic types.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      658,
      640,
      644,
      632,
      711
    ],
    "source": ""
  },
  {
    "id": 1155,
    "question": "Lauren's healthcare provider maintains such data as details about her health, treatments, and medical billing. What type of data is this?",
    "choice_a": "Protected health information",
    "choice_b": "Personally identifiable information",
    "choice_c": "Protected health insurance",
    "choice_d": "Individual protected data",
    "correct_answer": "A",
    "explanation": "Protected health information (PHI) is defined by HIPAA to include health information used by healthcare providers, such as medical treatment, history, and billing. Personally identifiable information is information that can be used to identify an individual, which may be included in the PHI but isn't specifically this type of data. Protected health insurance and individual protected data are both made-up terms.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      669,
      668,
      666,
      667,
      670
    ],
    "source": ""
  },
  {
    "id": 1156,
    "question": "In Jen's job as the network administrator for an industrial production facility, she is tasked with ensuring that the network is not susceptible to electromagnetic interference due to the large motors and other devices running on the production floor. What type of network cabling should she choose if this concern is more important than cost and difficulty of installation?",
    "choice_a": "10Base2",
    "choice_b": "100BaseT",
    "choice_c": "1000BaseT",
    "choice_d": "Fiber-optic",
    "correct_answer": "D",
    "explanation": "Fiber-optic cable is more expensive and can be much harder to install than stranded copper cable or coaxial cable, but it isn't susceptible to electromagnetic interference (EMI). That makes it a great solution for Jen's problem, especially if she is deploying EMI-hardened systems to go with her EMI-resistant network cables.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      681,
      683,
      179,
      504,
      505
    ],
    "source": ""
  },
  {
    "id": 1157,
    "question": "What type of penetration testing provides detail on the scope of a penetration test\u2014including items like what systems would be targeted\u2014but does not provide full visibility into the configuration or other details of the systems or networks the penetration tester must test?",
    "choice_a": "Crystal box",
    "choice_b": "White box",
    "choice_c": "Black box",
    "choice_d": "Gray box",
    "correct_answer": "D",
    "explanation": "Gray-box testing is a blend of crystal-box (or white-box) testing, which provides full information about a target, and black-box testing, which provides little or no knowledge about the target.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      629,
      628,
      602,
      608,
      606
    ],
    "source": ""
  },
  {
    "id": 1158,
    "question": "You are the CISO for a major hospital system and are preparing to sign a contract with a software as a service (SaaS) email vendor and want to ensure that its business continuity planning measures are reasonable. What type of audit might you request to meet this goal?",
    "choice_a": "SOC 1",
    "choice_b": "FISMA",
    "choice_c": "PCI DSS",
    "choice_d": "SOC 2",
    "correct_answer": "D",
    "explanation": "The Service Organizations Control audit program includes business continuity controls in a SOC 2, but not SOC 1, audit. Although FISMA and PCI DSS may audit business continuity, they would not apply to an email service used by a hospital.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      595,
      477,
      479,
      52,
      53
    ],
    "source": ""
  },
  {
    "id": 1159,
    "question": "Which of the following types of controls does not describe a mantrap?",
    "choice_a": "Deterrent",
    "choice_b": "Preventive",
    "choice_c": "Compensating",
    "choice_d": "Physical",
    "correct_answer": "C",
    "explanation": "A mantrap, which is composed of a pair of doors with an access mechanism that allows only one door to open at a time, is an example of a preventive access control because it can stop unwanted access by keeping intruders from accessing a facility because of an opened door or following legitimate staff in. It can serve as a deterrent by discouraging intruders who would be trapped in it without proper access, and of course, doors with locks are an example of a physical control. A compensating control attempts to make up for problems with an existing control or to add additional controls to improve a primary control.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      722,
      588,
      574,
      590,
      720
    ],
    "source": ""
  },
  {
    "id": 1160,
    "question": "What should be true for salts used in password hashes?",
    "choice_a": "A single salt should be set so passwords can be de-hashed as needed.",
    "choice_b": "A single salt should be used so the original salt can be used to check passwords against their hash.",
    "choice_c": "Unique salts should be stored for each user.",
    "choice_d": "Unique salts should be created every time a user logs in.",
    "correct_answer": "C",
    "explanation": "A unique salt should be created for each user using a secure generation method and stored in that user's record. Since attacks against hashes rely on building tables to compare the hashes against, unique salts for each user make building tables for an entire database essentially impossible\u2014the work to recover a single user account may be feasible, but large-scale recovery requires complete regeneration of the table each time. A single salt allows rainbow tables to be generated if the salt is stolen or can be guessed based on frequently used passwords. Creating a unique salt each time a user logs in does not allow a match against a known salted hashed password.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      751,
      750,
      752,
      664,
      665
    ],
    "source": ""
  },
  {
    "id": 1161,
    "question": "STRIDE, which stands for Spoofing, Tampering, Repudiation, Information Disclosure, Denial of Service, Elevation of Privilege, is useful in what part of application threat modeling?",
    "choice_a": "Vulnerability assessment",
    "choice_b": "Misuse case testing",
    "choice_c": "Threat categorization",
    "choice_d": "Penetration test planning",
    "correct_answer": "C",
    "explanation": "An important part of application threat modeling is threat categorization. It helps to assess attacker goals that influence the controls that should be put in place. The other answers all involve topics that are not directly part of application threat modeling.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      36,
      56,
      42,
      48,
      46
    ],
    "source": ""
  },
  {
    "id": 1162,
    "question": "Which one of the following is not a basic preventative measure that you can take to protect your systems and applications against attack?",
    "choice_a": "Implement intrusion detection and prevention systems.",
    "choice_b": "Maintain current patch levels on all operating systems and applications.",
    "choice_c": "Remove unnecessary accounts and services.",
    "choice_d": "Conduct forensic imaging of all systems.",
    "correct_answer": "D",
    "explanation": "There is no need to conduct forensic imaging as a preventative measure. Rather, forensic imaging should be used during the incident response process. Maintaining patch levels, implementing intrusion detection/prevention, and removing unnecessary services and accounts are all basic preventative measures.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      587,
      585,
      725,
      723,
      581
    ],
    "source": ""
  },
  {
    "id": 1163,
    "question": "You are conducting a qualitative risk assessment for your organization. The two important risk elements that should weigh most heavily in your analysis of risk are probability and ________________ .",
    "choice_a": "Likelihood",
    "choice_b": "History",
    "choice_c": "Impact",
    "choice_d": "Cost",
    "correct_answer": "C",
    "explanation": "The two most important elements of a qualitative risk assessment are determining the probability and impact of each risk upon the organization. Likelihood is another word for probability. Cost should be taken into account but is only one element of impact, which also includes reputational damage, operational disruption, and other ill effects.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      42,
      34,
      56,
      48,
      43
    ],
    "source": ""
  },
  {
    "id": 1164,
    "question": "Fred needs to transfer files between two servers on an untrusted network. Since he knows the network isn't trusted, he needs to select an encrypted protocol that can ensure that his data remains secure. What protocol should he choose?",
    "choice_a": "SSH",
    "choice_b": "TCP",
    "choice_c": "SFTP",
    "choice_d": "IPsec",
    "correct_answer": "C",
    "explanation": "The Secure File Transfer Protocol (SFTP) is specifically designed for encrypted file transfer. SSH is used for secure command-line access, whereas TCP is one of the bundles of Internet protocols commonly used to transmit data across a network. IPsec could be used to create a tunnel to transfer the data but is not specifically designed for file transfer.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      107,
      124,
      128,
      116,
      104
    ],
    "source": ""
  },
  {
    "id": 1165,
    "question": "Which one of the following investigation types always uses the beyond-a-reasonable-doubt standard of proof?",
    "choice_a": "Civil investigation",
    "choice_b": "Criminal investigation",
    "choice_c": "Operational investigation",
    "choice_d": "Regulatory investigation",
    "correct_answer": "B",
    "explanation": "Criminal investigations have high stakes with severe punishment for the offender that may include incarceration. Therefore, they use the strictest standard of evidence of all investigations: beyond a reasonable doubt. Civil investigations use a preponderance-of-the-evidence standard. Regulatory investigations may use whatever standard is appropriate for the venue where the evidence will be heard. This may include the beyond-a-reasonable-doubt standard, but it is not always used in regulatory investigations. Operational investigations do not use a standard of evidence.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      657,
      659,
      100,
      69,
      101
    ],
    "source": ""
  },
  {
    "id": 1166,
    "question": "Norm would like to conduct a disaster recovery test for his organization and wants to choose the most thorough type of test, recognizing that it may be quite disruptive. What type of test should Norm choose?",
    "choice_a": "Full interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Tabletop exercise",
    "choice_d": "Checklist review",
    "correct_answer": "A",
    "explanation": "During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive. During a parallel test, the team actually activates the disaster recovery site for testing but the primary site remains operational. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      656,
      654,
      655,
      495,
      653
    ],
    "source": ""
  },
  {
    "id": 1167,
    "question": "Ed is tasked with protecting information about his organization's customers, including their name, Social Security number, birthdate, and place of birth, as well as a variety of other information. What is this information known as?",
    "choice_a": "PHI",
    "choice_b": "PII",
    "choice_c": "Personal protected data",
    "choice_d": "PID",
    "correct_answer": "B",
    "explanation": "Personally identifiable information (PII) can be used to distinguish a person's identity. Protected health information (PHI) includes data such as medical history, lab results, insurance information, and other details about a patient. Personal protected data is a made-up term, and PID is an acronym for process ID, the number associated with a running program or process.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      669,
      670,
      668,
      104,
      107
    ],
    "source": ""
  },
  {
    "id": 1168,
    "question": "Susan is conducting a STRIDE threat assessment by placing threats into one or more of the following categories: Spoofing, Tampering, Repudiation, Information Disclosure, Denial of Service, and Elevation of Privilege. As part of her assessment, she has discovered an issue that allows transactions to be modified between a web browser and the application server that it accesses. What STRIDE categorization(s) best fit this issue?",
    "choice_a": "Tampering and Information Disclosure",
    "choice_b": "Spoofing and Tampering",
    "choice_c": "Tampering and Repudiatio",
    "choice_d": "Information Disclosure and Elevation of Privilege",
    "correct_answer": "A",
    "explanation": "Information that is modifiable between a client and a server also means that it is accessible, pointing to both tampering and information disclosure. Spoofing in STRIDE is aimed at credentials and authentication, and there is no mention of this in the question. Repudiation would require that proving who performed an action was important, and elevation of privilege would come into play if privilege levels were involved.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      42,
      46,
      50,
      36,
      56
    ],
    "source": ""
  },
  {
    "id": 1169,
    "question": "Tamara recently decided to purchase cyber-liability insurance to cover her company's costs in the event of a data breach. What risk management strategy is she pursuing?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk transference",
    "choice_d": "Risk avoidance",
    "correct_answer": "C",
    "explanation": "Risk transference involves shifting the impact of a potential risk from the organization incurring the risk to another organization. Insurance is a common example of risk transference.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      59,
      63,
      62,
      60,
      56
    ],
    "source": ""
  },
  {
    "id": 1170,
    "question": "Referring to the figure shown here, what is the name of the security control indicated by the arrow? <br><img src=\"/question_assets/SSCP/c09uf007.png\"/>",
    "choice_a": "Mantrap",
    "choice_b": "Intrusion prevention system",
    "choice_c": "Turnstile",
    "choice_d": "Portal",
    "correct_answer": "C",
    "explanation": "Turnstiles are unidirectional gates that prevent more than a single person from entering a facility at a time.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      722,
      588,
      590,
      589,
      26
    ],
    "source": ""
  },
  {
    "id": 1171,
    "question": "Elaine is developing a business continuity plan for her organization. What value should she seek to minimize?",
    "choice_a": "AV",
    "choice_b": "SSL",
    "choice_c": "RTO",
    "choice_d": "MTO",
    "correct_answer": "C",
    "explanation": "The goal of business continuity planning exercises is to reduce the amount of time required to restore operations. This is done by minimizing the recovery time objective (RTO).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      496,
      495,
      648,
      655,
      653
    ],
    "source": ""
  },
  {
    "id": 1172,
    "question": "Chris is deploying a gigabit Ethernet network using Category 6 cable between two buildings. What is the maximum distance he can run the cable according to the Category 6 standard?",
    "choice_a": "50 meters",
    "choice_b": "100 meters",
    "choice_c": "200 meters",
    "choice_d": "300 meters",
    "correct_answer": "B",
    "explanation": "The maximum allowed length of a Cat 6 cable is 100 meters, or 328 feet. Long distances are typically handled by a fiber run or by using network devices like switches or repeaters.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      675,
      681,
      676,
      179,
      504
    ],
    "source": ""
  },
  {
    "id": 1173,
    "question": "What type of alternate processing facility includes all of the hardware and data necessary to restore operations in a matter of minutes or seconds?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Mobile site",
    "correct_answer": "A",
    "explanation": "Hot sites contain all of the hardware and data necessary to restore operations and may be activated very quickly.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      496,
      495,
      497,
      653,
      79
    ],
    "source": ""
  },
  {
    "id": 1174,
    "question": "The organization that Ben works for has a traditional on-site Active Directory environment that uses a manual provisioning process for each addition to their 350-employee company. As the company adopts new technologies, they are increasingly using software as a service applications to replace their internally developed software stack. <br>Ben has been tasked with designing an identity management implementation that will allow his company to use cloud services while supporting their existing systems. Using the logical diagram shown here, answer the following question about the identity recommendations Ben should make. <br><img src=\"/question_assets/SSCP/c09uf008.png\"/>If availability of authentication services is the organization's biggest priority, what type of identity platform should Ben recommend?",
    "choice_a": "On-site",
    "choice_b": "Cloud-based",
    "choice_c": "Hybrid",
    "choice_d": "Outsourced",
    "correct_answer": "C",
    "explanation": "A hybrid authentication service can provide authentication services in both the cloud and on-premise, ensuring that service outages due to interrupted links are minimized. An on-site service would continue to work during an Internet outage, but would not allow the e-commerce website to authenticate, while a cloud service would leave the corporate location offline. Outsourcing authentication does not indicate whether the solution is on or off premise, and thus isn't a useful answer.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      348,
      542,
      562,
      282,
      353
    ],
    "source": ""
  },
  {
    "id": 1175,
    "question": "The organization that Ben works for has a traditional on-site Active Directory environment that uses a manual provisioning process for each addition to their 350-employee company. As the company adopts new technologies, they are increasingly using software as a service applications to replace their internally developed software stack. <br>Ben has been tasked with designing an identity management implementation that will allow his company to use cloud services while supporting their existing systems. Using the logical diagram shown here, answer the following question about the identity recommendations Ben should make. <br><img src=\"/question_assets/SSCP/c09uf008.png\"/> If Ben needs to share identity information with the business partner shown, what should he investigate?",
    "choice_a": "Single sign-on",
    "choice_b": "Multifactor authentication",
    "choice_c": "Federation",
    "choice_d": "IDaaS",
    "correct_answer": "C",
    "explanation": "Federation links identity information between multiple organizations. Federating with a business partner can allow identification and authorization to occur between them, making integration much easier. Single sign-on would reduce the number of times a user has to log in, but will not facilitate the sharing of identity information. Multifactor can help secure authentication, but again, doesn\u2019t help integrate with a third party. Finally an Identity as a Service provider might provider federation, but doesn't guarantee it.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      543,
      349,
      563,
      708,
      542
    ],
    "source": ""
  },
  {
    "id": 1176,
    "question": "The organization that Ben works for has a traditional on-site Active Directory environment that uses a manual provisioning process for each addition to their 350-employee company. As the company adopts new technologies, they are increasingly using software as a service applications to replace their internally developed software stack. <br>Ben has been tasked with designing an identity management implementation that will allow his company to use cloud services while supporting their existing systems. Using the logical diagram shown here, answer the following question about the identity recommendations Ben should make. <br><img src=\"/question_assets/SSCP/c09uf008.png\"/>What technology is likely to be involved when Ben's organization needs to provide authentication and authorization assertions to their cloud e-commerce application?",
    "choice_a": "Active Directory",
    "choice_b": "SAML",
    "choice_c": "RADIUS",
    "choice_d": "SPML",
    "correct_answer": "B",
    "explanation": "SAML, the Security Assertion Markup Language is frequently used to integrate cloud services, and provides the ability to make authentication and authorization assertions. Active Directory integrations are possible, but are less common for cloud service providers, and RADIUS is not typically used for integrations like this. SPML, the Service Provisioning Markup Language is used to provision users, resources, and services.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      562,
      561,
      563,
      542,
      349
    ],
    "source": ""
  },
  {
    "id": 1177,
    "question": "Norm is configuring an RSA cryptosystem for use within his organization and is selecting the key lengths that he will support. Which one of the following key lengths is not both supported by the RSA algorithm and generally considered secure?",
    "choice_a": "512 bits",
    "choice_b": "1,024 bits",
    "choice_c": "2,048 bits",
    "choice_d": "4,096 bits",
    "correct_answer": "A",
    "explanation": "The RSA algorithm supports key lengths between 1,024 and 4,096 bits. All of these key lengths are currently considered secure. Some cryptographers believe that attacks will surface that render 1,024 bit keys insecure in the future, but no such attacks are yet public. RSA does not support 512 bit keys.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      499,
      500,
      498,
      672,
      105
    ],
    "source": ""
  },
  {
    "id": 1178,
    "question": "Public health measures often require that immunization or treatment records would be made available to travel operators to use in determining if each passenger or crew member was safe to be allowed on board. Which of the following would be the best description of this process?",
    "choice_a": "Data processing",
    "choice_b": "Information management",
    "choice_c": "Knowledge management",
    "choice_d": "Information processing",
    "correct_answer": "D",
    "explanation": "Each person's immunization or test records represent a set of data; gathering a lot of data together to determine a higher-level, more abstract finding (is that person safe to board, or should boarding be denied?) is creating new information. <br>Option A might take each individual's records and extract the fields that contain specific data that the operator needs to use (such as name, vaccination type and date, and so on). <br>Option C might be appropriate for the way that the operator determines if a particular voyage's total crew and passenger manifest is safe. <br>Option B refers to a general process of organizing, directing, and controlling the ways that information is gathered, used, stored, and disposed of.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      7,
      323,
      337,
      16
    ],
    "source": "",
    "choice_e": "None of the above"
  },
  {
    "id": 1179,
    "question": "Public health measures often require that a travel operator gather and maintain current government-issued criteria or guidelines for making a board/no-board decision about each passenger. These change frequently and often contradict each other. At one airline, managers relied on informal, verbal means of directing their passenger agents as to how to make sense of these instructions. This is a process that relied on:",
    "choice_a": "Explicit knowledge",
    "choice_b": "Data smoothing",
    "choice_c": "Tacit knowledge",
    "choice_d": "Business logic",
    "correct_answer": "C",
    "explanation": "Collecting all of the current versions of government guidance and turning it into useful, meaningful direction to a team of workers is generating knowledge. If that knowledge is written down, it is made explicit. If it's left to human memory of a conversation or an experience, that knowledge is tacit\u2014skills and experience possessed but not codified. Thus, option A is incorrect. <br>Option B is incorrect, as this refers to taking many samples of the same kind of measurement (such as a person's skin temperature) and using a mathematical process to eliminate false readings and find the reading with the greatest likelihood of being correct. <br>Option D is incorrect, as this is a general name for the set of steps used in completing a set of tasks, including the criteria used by workers at each step if necessary to make decisions required as part of that task.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      2,
      1,
      6,
      19
    ],
    "source": ""
  },
  {
    "id": 1180,
    "question": "During public health emergencies such as pandemics, government-issued guidance to travel operators such as airlines and cruise ships can change frequently. Suppose one cruise ship operator has well-defined, written guidance to its passenger agents, which they update as quickly as possible when circumstances change. Which ethical or legal duty or duties would this be fulfilling? <ol type=\"A\"><li>Due process</li><li>Due care</li><li>Due diligence</li><li>Accountability</li></ol>",
    "choice_a": "A and B",
    "choice_b": "A and C",
    "choice_c": "B and C",
    "choice_d": "C and D",
    "correct_answer": "A",
    "explanation": "They have clearly defined a process for making each board/no-board decision, and they control that process with detailed, written instructions and guidance. Their attention to detail in this suggests taking due care. <br>As described, however, nothing indicates that they monitor the execution of that process to make sure instructions are being used correctly and that this produces correct results; thus, option C is incorrect. <br>No mention is made of holding individual passenger agents, their supervisors, or the company itself responsible for incorrect decisions; thus, option D is incorrect (has not been addressed in the scenario thus far).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      759,
      760,
      14,
      447
    ],
    "source": ""
  },
  {
    "id": 1181,
    "question": "Government regulations may require that travel operators verify that each passenger have full and current immunizations in order to travel. Suppose that one airline fails to put in place controls or processes to validate that immunization or test results sent to them by a prospective passenger are not, in fact, counterfeit or forgeries. This would mean their information security approach is failing to achieve which of the following?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Nonrepudiation",
    "correct_answer": "E",
    "explanation": "Ascertaining that a set of input data comes from a trustworthy source and is true and correct is part of establishing the authenticity of that data. The other attributes (options A, B, C, and D) are important, but do not directly bear on whether the source of the data is recognized as being the \u201cauthoritative\u201d voice to provide that data in the first place.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      323,
      7,
      344,
      330,
      276
    ],
    "source": "",
    "choice_e": "Authenticity"
  },
  {
    "id": 1182,
    "question": "During the Covid-19 pandemic, one airline realized that they need to make changes to improve the reliability of their decisions about boarding or declining passengers, by ensuring the authenticity of the immunization data they submitted. What type of planning process might they use to come to this realization?",
    "choice_a": "Business case",
    "choice_b": "Business logic",
    "choice_c": "Business plan",
    "choice_d": "GAAP analysis",
    "correct_answer": "A",
    "explanation": "In this situation, a business case might show the risks of being shut down by government regulators (for making unsafe decisions about passengers) versus the immediate costs and impacts of making changes to implement an authentication process. Their business logic (option B) would need to be updated by these changes. <br>Option C is incorrect, as this type of change would (presumably) be more immediate than long-term or strategic in nature, which is the normal scale of change covered by a business plan. <br>Option D confuses Generally Accepted Accounting Principles (GAAP) with a comparative analysis of requirements or standards versus an in-use design to identify what's missing (or \u201cin the gap\u201d).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      13,
      323,
      338,
      337
    ],
    "source": ""
  },
  {
    "id": 1183,
    "question": "Which statement best describes information systems?",
    "choice_a": "The computers, networks, and communications elements that are used to gather, process, store, and distribute information",
    "choice_b": "The operating systems, applications, and databases used to gather, store, process, and distribute information",
    "choice_c": "The set of tools and processes used to transform data into information",
    "choice_d": "The set of information, processes, and technologies, and interfaces that work together to suit the needs of the system's owners and users",
    "correct_answer": "D",
    "explanation": "Information systems do not depend upon any one technology for their implementation or use. <br>Options A and B address information technology systems and thus are incomplete. <br>Option C is incorrect, as it addresses only one possible use of an information system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      5,
      6,
      1,
      7
    ],
    "source": ""
  },
  {
    "id": 1184,
    "question": "Many investment brokerages allow their customers to make online purchase and sales orders for stocks, options, commodities, or other investments. The brokerage makes that transaction immediately after the customer clicks the Submit button. Which information security attribute or characteristic protects the brokerage from the customer claiming that they never sent in a particular order?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Nonrepudiation",
    "correct_answer": "D",
    "explanation": "The customer's attempt to repudiate the order (i.e., claim they did not submit such an order) must somehow be protected against. <br>Option E, authenticity, is necessary to first establish that the person logging in to attempt the order is in fact who they claim to be. Other options address protecting the data and the transaction, but in themselves do not protect the brokerage from customers falsely claiming to have never sent in such an order.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      339,
      14,
      330,
      375,
      387
    ],
    "source": "",
    "choice_e": "Authenticity"
  },
  {
    "id": 1185,
    "question": "Which statement best characterizes the difference between a business case and a business plan for an information security project?",
    "choice_a": "The business case looks at law and regulations as the source of detailed requirements, while the business plan uses broad, general statements about goals and objectives as the basis of its plan.",
    "choice_b": "The business case looks at longer-term, strategic ways to accomplish objectives; the business plan specifies the details about each element in achieving that plan.",
    "choice_c": "The business case provides a compelling argument, in cost-benefits or risks-versus-rewards terms, for making an immediate or near-term change in security practices; the business plan looks at longer-term objectives, prioritizes them, and lays out a strategy to achieve them with.",
    "choice_d": "None of the above.",
    "correct_answer": "C",
    "explanation": "Option A may or may not be correct\u2014a new law or regulation may dictate the need for an immediate change in security processes\u2014but it says nothing about justifying the proposed change. <br>Option B is incorrect, as it reverses part of the nature of a business plan and a business case.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      12,
      17,
      444,
      335
    ],
    "source": ""
  },
  {
    "id": 1186,
    "question": "What might be the best reason for a business case be able to use a short payback period, rather than a longer one, as part of its argument?",
    "choice_a": "The threat landscape changes very quickly.",
    "choice_b": "Operational or business needs may change rapidly and unpredictably.",
    "choice_c": "Most people, managers and leaders included, cannot make meaningful predictions too far into the future; the shorter the payback period, the more they will perceive the proposed change as being valuable.",
    "choice_d": "None of the above.",
    "correct_answer": "C",
    "explanation": "Options A and B certainly raise aspects that security professionals, managers, and leaders of organizations must consider, and they contribute to a \u201csooner is better\u201d attitude.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      14,
      320,
      446,
      17
    ],
    "source": ""
  },
  {
    "id": 1187,
    "question": "How do ethical concepts of accountability relate to information security?",
    "choice_a": "Ethical concepts of accountability directly relate to concepts of trust and reliability, which directly relate to information security concepts.",
    "choice_b": "They don't relate very well, since most ethical concepts are up to the individual to decide.",
    "choice_c": "They don't relate very well, as information security concepts are derived from legal ideas about accountability, and attempting to legislate ethics does not work.",
    "choice_d": "Indirectly, as these ethics concepts get expressed into laws and regulations, and these are what dictate information security concepts and practices.",
    "correct_answer": "A",
    "explanation": "Option A focuses on the core concepts of trust and reliability, which directly relate to information security concepts of confidentiality, integrity, availability, nonrepudiation, and authentication. <br>Options B and C incorrectly refute this, but the root meaning of <italic>integrity</italic> as a security concept shows this refutation to be false. <br>Option D is incorrect, as a simple desire for efficient and correct operation of a system leads directly to the information security concepts mentioned; laws are not needed to recognize their value.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      13,
      7,
      15,
      420
    ],
    "source": ""
  },
  {
    "id": 1188,
    "question": "As a security operations analyst, you've come across indications that some employees seem to be facilitating a fake invoicing scheme, which is potentially defrauding the company. This is an example of what kind of information security need?",
    "choice_a": "Privacy",
    "choice_b": "Confidentiality",
    "choice_c": "Nonrepudiation",
    "choice_d": "Authenticity",
    "correct_answer": "D",
    "explanation": "Payment of an invoice should involve some form of control, limiting it to just specifically authorized individuals. The ones suspected of being involved with this fraud may be exceeding their authorizations or abusing the authority they are already granted. <br>Option D would address the need to have effective recordkeeping in place, recording who authorized such payments, when, and how; its presence or absence does not enable the fraud. <br>Privacy and confidentiality (options A and B) are not involved directly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      273,
      330,
      354,
      433,
      447
    ],
    "source": ""
  },
  {
    "id": 1189,
    "question": "When you compare safety requirements and security requirements for information systems, which of the following statement is incorrect?",
    "choice_a": "When information security measures fail to keep critical data available and correct, the resulting system malfunctions could lead to loss of revenue, property damage, injury, or death.",
    "choice_b": "Operating a system in an unsafe manner could introduce information that further corrupts the system, violates its integrity, or leads to it crashing, which violates availability needs.",
    "choice_c": "Keeping a system safe also means \u201csafe from harm\u201d and thus means much the same as keeping it secure.",
    "choice_d": "Safe system operation is the responsibility of its designers, builders, and operators; the information security people have no role in that, and thus safety and security are unrelated concepts.",
    "correct_answer": "D",
    "explanation": "\u201cSafety\u201d for information systems can mean keeping the system from suffering damage, keeping the system from failing in ways that cause damage, or both. Thus, options A and C are correct, though they are different aspects of safety. <br>Option B might be true in some cases, but in most circumstances, the safety issues would take precedence. <br>Option D is incorrect because it tries to separate safety and security when they are in fact related to each other.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      275,
      324,
      5,
      446,
      317
    ],
    "source": ""
  },
  {
    "id": 1190,
    "question": "Suppose that you are employed by a business or that as a consultant you have a business as one of your clients. As an SSCP, which of the following groups do you have responsibilities to?",
    "choice_a": "Co-workers, managers, and owners of the business that employs you (or is your client)",
    "choice_b": "Competitors of the business that employs you or is your client",
    "choice_c": "Customers, suppliers, or other companies that work with this business",
    "choice_d": "People and groups that have nothing to do with this business",
    "correct_answer": "C",
    "explanation": "Options A and B are both examples of due care; due diligence is the verification that all is being done well and that nothing is not done properly. <br>Option D can be an important part of due diligence but is missing the potential for follow-up action.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      759,
      761,
      307,
      14
    ],
    "source": ""
  },
  {
    "id": 1191,
    "question": "You're working as a security analyst for an American online retailer and have discovered what you think might be an ongoing data breach involving data pertaining to your overseas customers and vendors. You talk with your supervisor about this and ask if this should be reported to the authorities or somehow publicly disclosed. Your supervisor says that since none of the customers or vendors are U.S. citizens or residents, that no disclosure or reporting would be required or effective. Which statement might be your best response?",
    "choice_a": "You agree with your supervisor, as this makes sense.",
    "choice_b": "You disagree, since you think that even U.S. law may require some form of prompt notification to customers and to the authorities.",
    "choice_c": "You disagree, since you think that the countries where those customers are citizens or residents may have laws that require even an American firm to do prompt notification or disclosure.",
    "choice_d": "You suggest that perhaps the company's general counsel be asked, quickly, just in case the United States or other nations' data localization or data residency laws do in fact require prompt notification or disclosure.",
    "correct_answer": "D",
    "explanation": "Options B and C are partly correct, but even if both of you are conversant with all of those laws about data residency and data localization, your senior managers do need to get the lawyers' advice. Quickly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      392,
      445,
      387,
      276,
      337
    ],
    "source": ""
  },
  {
    "id": 1192,
    "question": "Yoshi works as a security analyst for an online merchant. Their systems are reporting a dramatic increase in customer complaints about charges the merchant has made to their accounts for orders that the customers say they have never made. Which information security functions or systems elements should Yoshi investigate first?",
    "choice_a": "Integrity",
    "choice_b": "Privacy",
    "choice_c": "Nonrepudiation",
    "choice_d": "Authenticity",
    "correct_answer": "C",
    "explanation": "Start with the specifics of the complaints by confirming whether these customers are mistakenly or fraudulently trying to claim they never made the orders in question or whether some other system error may be responsible. After that's been eliminated, it's time to investigate whether the security of these customers' accounts was compromised (option D). If so, that may indicate a failure of the privacy protections (option B). While it's easy to think this is a data integrity problem (option A), that is a result; Yoshi needs to investigate to find what systems function(s) failed to operate correctly to make that result happen.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      364,
      376,
      374,
      330,
      353
    ],
    "source": ""
  },
  {
    "id": 1193,
    "question": "Pedro works at a city water reclamation and treatment plant, where he monitors the systems that control the addition of chemicals to the water to sanitize it before releasing it into the city's drinking water supply. He notices that his supervisor (who is on holiday leave) has apparently logged on remotely, used remote desktop features to take control of Pedro's system, and is trying to dump huge amounts of chemicals into the water being treated. Pedro takes immediate action to override this, preventing contamination of the city's drinking water. This scenario illustrates what type of information security concern?",
    "choice_a": "Safety",
    "choice_b": "Integrity",
    "choice_c": "Authentication",
    "choice_d": "Nonrepudiation",
    "correct_answer": "A",
    "explanation": "From the information provided, this seems to be an unauthorized attempt to interfere with the safe operation of the chemical treatment system. <br>Option C may be a factor in this, if the supervisor's login credentials were compromised, but this is minor compared to the potential safety issues involved. <br>Systems integrity (option B) is in doubt because of this attack, but as with authentication, it's not the driver. <br>Option D, nonrepudiation, does not apply to this case.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      275,
      431,
      308,
      330,
      378
    ],
    "source": ""
  },
  {
    "id": 1194,
    "question": "Which GDPR role best applies to the merchant regarding the data about you, as an employee of the merchant?",
    "choice_a": "No roles apply",
    "choice_b": "Owner",
    "choice_c": "Processor",
    "choice_d": "Subject",
    "correct_answer": "C",
    "explanation": "The merchant has to organize, use, and update their records about you as an employee, regardless of where you live or how you do work for them. <br>Option A is incorrect, as it seems to assume that GDPR doesn't apply to you somehow. <br>Option B is not a defined GDPR role with respect to data protection. <br>Option D is incorrect, as you (in this case) are the subject of the data in question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      16,
      337,
      338,
      309
    ],
    "source": ""
  },
  {
    "id": 1195,
    "question": "Which GDPR role best describes your role with respect to your employment with the merchant?",
    "choice_a": "Custodian",
    "choice_b": "Controller",
    "choice_c": "Processor",
    "choice_d": "Subject",
    "correct_answer": "D",
    "explanation": "You are the person described or identifiable by the data. <br>Options A, B, and C refer to different functional roles that the merchant has responsibility for and therefore has the data protection responsibilities associated with these roles.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      16,
      338,
      334,
      339
    ],
    "source": ""
  },
  {
    "id": 1196,
    "question": "The merchant in Berlin uses a third-party firm to handle all of its personnel files. With respect to your data in those files, which GDPR role best describes the merchant?",
    "choice_a": "Custodian",
    "choice_b": "Controller",
    "choice_c": "Processor",
    "choice_d": "Subject",
    "correct_answer": "B",
    "explanation": "The controller has ultimate responsibility for protecting the data, even when it is in the hands of another who performs processing tasks on it. <br>Option A refers to one who stores the data, but does nothing with it. <br>Option D refers to you, as the data is about you.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      353,
      333,
      338,
      4,
      309
    ],
    "source": ""
  },
  {
    "id": 1197,
    "question": "As a security and legal concept, which statement best describes what confidentiality means?",
    "choice_a": "Information defined in laws pertaining to banking, healthcare, education, or official secrets must be protected from unauthorized access or disclosure.",
    "choice_b": "Declaring certain information confidential can shield the holders or users of that information from scrutiny or accountability.",
    "choice_c": "Any information shared between two or more people is kept from further disclosure or dissemination unless all parties agree to it.",
    "choice_d": "A secret shared between two or more people is kept from further disclosure or dissemination unless all parties agree to it.",
    "correct_answer": "D",
    "explanation": "Note the difference between options C and D; the burden to protect confidentiality applies only to \u201csecrets,\u201d that is, to specifically declared types of communications. Saying \u201chello\u201d to one's doctor or lawyer, while encountering them in a public place, is not a privileged communication; what you speak about with them in consultation is. <br>Option A refers to required protection and treatment of some data that must be held in confidence (kept from disclosure), but these laws do not define what \u201cconfidentiality\u201d means as a security concept. <br>Option B misstates the purpose and intent of protecting privileged communications, that is, the sharing of secrets. It may be a side effect of invoking such protections, which in many cases may be unethical, illegal, or both.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      323,
      15,
      345,
      6,
      327
    ],
    "source": ""
  },
  {
    "id": 1198,
    "question": "You discuss with your boss that on the surface, that decision by the company seems unethical and may be in violation of the law. Your boss tells you to trust in the management team and not make a further issue of this. You do not agree with this, and you feel your boss is deflecting you from the issue. As an SSCP, what would your professional ethics require you to do?",
    "choice_a": "Agree and support your boss and the company, for they have followed due process and taken due care in coming to this conclusion.",
    "choice_b": "Discuss it with the company's data protection officer or similar official.",
    "choice_c": "Agree and support your boss and the company, but urgently start seeking employment elsewhere.",
    "choice_d": "Attempt to make your own report of this to law enforcement or government regulators.",
    "correct_answer": "B",
    "explanation": "Although nothing is said here whether this company is subject to GDPR or not, your company may have some designated official who acts as the focal point for such concerns. Ethically, you have a duty to the employer to attempt to use all means they make available to you to raise such an issue, even if this puts you at risk of losing your job. <br>Option A suggests that perhaps you doubt your own conclusions; assuming you do not, this choice risk putting you in tacit (unspoken) agreement with their decision, which you just told your boss you believed to be unethical if not illegal. <br>Option C suggests you're willing to stay silent about the situation and protect your own interests first; this does not fulfill your professional obligations to your company, your profession, or to society as a whole. <br>Option D would be your last resort, if attempting to raise the issue through company channels fails to satisfy you.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      762,
      14,
      19,
      335,
      447
    ],
    "source": ""
  },
  {
    "id": 1199,
    "question": "Which security characteristic do you think might be put at most risk in this scenario?",
    "choice_a": "Safety",
    "choice_b": "Privacy",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "B",
    "explanation": "Clearly the scenario involves the risks of compromise of private data. Since insurance billing tends to be after medical treatment has been rendered, safety of the patient (in medical terms) isn't at risk. <br>Option A, given the information in the scenario, does not seem to apply. Arguably, data in compromised accounts could be further exploited by attackers in ways that might put people or property at risk, but this is part of the argument of why private data needs to be protected. <br>Options C and D do not seem to apply to this scenario.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      345,
      355,
      356,
      412
    ],
    "source": ""
  },
  {
    "id": 1200,
    "question": "Which of the following statements best describes security classification?",
    "choice_a": "A security classification is a label attached to a storage device that contains sensitive information, and indicates the required protection and handling methods.",
    "choice_b": "Security classification is a process that determines possible loss or impact if information of a given type suffers any kind of security compromise.",
    "choice_c": "Security classification is a process that determines possible loss or impact if information of a given type is disclosed to an unauthorized person or entity.",
    "choice_d": "Security classification groups together information types that have comparable loss or impacts if compromised to help optimize the choice of protection techniques.",
    "correct_answer": "B",
    "explanation": "Option A confuses the results of establishing a security baseline (and thus a labeling and handling procedure) with the classification determination itself. <br>Option C is partly correct, but compromise must consider impacts to more than just confidentiality (i.e., to all of the CIANA+PS characteristics). <br>Option D confuses classification with categorization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      38,
      42,
      34,
      46,
      37
    ],
    "source": ""
  },
  {
    "id": 1201,
    "question": "Which of the following statements best describes security categorization?",
    "choice_a": "A security categorization is a label attached to a storage device that contains sensitive information, and indicates the required protection and handling methods.",
    "choice_b": "Security categorization groups together information types that have comparable loss or impacts if compromised, along with any compliance-required security protection requirements for that type of data.",
    "choice_c": "Security categorization is a process that determines possible loss or impact if information of a given type is disclosed to an unauthorized person or entity.",
    "choice_d": "Security categorization groups together information types that have comparable loss or impacts if compromised, to help optimize the choice of protection techniques.",
    "correct_answer": "B",
    "explanation": "Option A confuses the results of establishing a security baseline (and thus a labeling and handling procedure) with the classification determination itself. <br>Option C confuses classification with categorization. <br>Option D confuses categorization with security baselining.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      42,
      606,
      474,
      57
    ],
    "source": ""
  },
  {
    "id": 1202,
    "question": "Which of the following events are threats?",
    "choice_a": "A thunderstorm that interrupts commercial electrical power",
    "choice_b": "A user who copies data that they do not need for work-related tasks onto a removable storage device",
    "choice_c": "A systems administrator who leaves their workstation logged in to their privileged account, while they take a coffee break",
    "choice_d": "A network firewall that malfunctions, sporadically blocking some but not all traffic, due to its power supply overheating",
    "correct_answer": "B",
    "explanation": "This is an intentional act caused by a human being, which may lead to loss or impact to the organization. <br>Options A and D represent hazards. <br>Option C, which is an intentional act, is not in and of itself a potential risk event (if, for example, the workstation is in a secured work area that only systems administrators can access); however, it may represent one or more exploitable vulnerabilities in the overall security posture of the organization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      46,
      55,
      42,
      48
    ],
    "source": ""
  },
  {
    "id": 1203,
    "question": "Which control functions are performed by exterior floodlights controlled by motion detectors around a residential or commercial building? <ol type=\"A\"><li>Directive</li><li>Deterrent</li><li>Preventative</li><li>Detective</li><li>Reactive</li><li>Corrective</li><li>Recovery</li></ol>",
    "choice_a": "A, D, F",
    "choice_b": "B, D, E",
    "choice_c": "C, F, G",
    "choice_d": "B, E, F",
    "correct_answer": "B",
    "explanation": "Triggering the lights, the intruder may pause and reconsider continuing with their attack. They may, of course, decide to continue, so the lights by themselves do not prevent intrusion. The lights can be part of an integrated alarm system (option B). The motion detectors (as their name implies) detect a potential intrusion (option D), but it is the reactive element of turning the floodlights on (option E) that delivers the message to the intruder that they have been noticed by the system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      59,
      61,
      55,
      62
    ],
    "source": ""
  },
  {
    "id": 1204,
    "question": "Your bank's online services portal requires you to log in with username, password, additional security code, and a separate security app on your mobile phone. In addition, any attempts to submit a transaction will require you to answer additional security challenges, which might also require use of the mobile phone app. Which control functions are not performed by these features? <ol type=\"A\"><li>Directive</li><li>Deterrent</li><li>Preventative</li><li>Detective</li><li>Reactive</li><li>Corrective</li><li>Recovery</li></ol>",
    "choice_a": "A, B",
    "choice_b": "D, E",
    "choice_c": "F, G",
    "choice_d": "C, G",
    "correct_answer": "C",
    "explanation": "The combination of these features sends the message to users and intruders that the bank takes the security of your account seriously. It has put all of these measures in place to make it difficult for anyone to impersonate you and gain access to your accounts. Banners at login, instructions, and reminders do part of the direct messaging (option A, directive, is performed). <br>Options B and C (deterrent and preventative controls) are achieved by denying access if the user does not successfully engage with the controls. Corrective and recovery (options F and G) are functions not performed during login or normal use of the system but would apply after an incident of some kind has occurred.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      62,
      60,
      61,
      65
    ],
    "source": ""
  },
  {
    "id": 1205,
    "question": "You're working as a one-person security operations team at a startup biotech firm. Your group has recently completed a vulnerability assessment of the systems and assets in the existing IT asset inventory, which included identifying any current CVE issues listed for the asset types listed on the inventory. A number of urgent issues were surfaced by this assessment. The chief operating officer (COO) for the company believes that vulnerability assessment must now be complete and wants to get back to \u201cnormal\u201d business. Which statement or statements might be your best response?<ol type=\"A\"><li>Suggest to the COO that there are many OT systems, such as building management and laboratory systems, which are not on the IT inventory, and that these should be assessed for vulnerabilities too.</li><li>Suggest to the COO that there are many OT systems, such as building management and laboratory systems, which are not on the IT inventory, but those systems are safe from intrusion or attack.</li><li>Suggest to the COO that some of the vulnerabilities that have been discovered may need immediate policy direction to all employees.</li><li>Agree, and ask for direction to proceed with planning and estimating the costs of the most urgently needed risk mitigations.</li></ol>",
    "choice_a": "A, B",
    "choice_b": "A, C",
    "choice_c": "B, C",
    "choice_d": "C, D",
    "correct_answer": "B",
    "explanation": "Whether it's the building's heating, ventilation, and air conditioning (HVAC), its internal fire suppression and security alarm systems, or the systems in the labs, these OT systems may be vulnerable to an over-the-Internet intrusion and attack (option A is correct). <br>Option C is correct; this tends to be the first step in responding to the discoveries made during risk and vulnerability assessment, and it shapes the planning for more physical and technical mitigation strategies. <br>Option B is incorrect; even if those systems are fully isolated from any external network, until you've done a vulnerability assessment, you don't know what you don't know. <br>Option D is incorrect; it gives the COO false comfort and, if nothing else, seems self-serving (my budget is all I care for, it seems to say).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      52,
      46,
      45,
      56,
      58
    ],
    "source": ""
  },
  {
    "id": 1206,
    "question": "Which of the following statements about the use of workflows and playbooks for information security is most correct?",
    "choice_a": "Workflows and playbooks can be part of major applications platforms and may support security functions in those platforms, but provide no useful capability for network or systems security.",
    "choice_b": "Workflows and playbooks can help security teams define and manage routine tasks and activities, but they cannot cope well with the ad hoc, dynamic circumstances of incident response and recovery.",
    "choice_c": "Workflows and playbooks can support incident response by building in decision points, suggestions on conditions to investigate, and reminders or prompts for notifying or reporting to managers and users.",
    "choice_d": "Workflow management systems, and their playbooks, make sense only for organizations with established, well-practiced procedures.",
    "correct_answer": "C",
    "explanation": "Incident response and recovery needs to combine thoughtful, well-considered, pre-planned procedural responses with informed, real-time decision making. Workflows for each (relatively small) procedure, organized into playbooks, can and should include decision call-outs or breakpoints. <br>Option A is true as written, but it confuses application-specific workflows and playbooks with ones used for other purposes, such as security. <br>Option B is false; nearly all workflow and playbook systems (for security or other uses) support a mix of routine and ad hoc activities. <br>Option D is false; it's actually recommended to start small and simple and improve both the organization's procedures and its use of workflows and playbooks as its understanding and experience grow.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      69,
      71,
      99,
      96,
      87
    ],
    "source": ""
  },
  {
    "id": 1207,
    "question": "Which of the following statements about security orchestration and automation is most correct?",
    "choice_a": "Orchestration brings together all sources of security and event information; automation provides for workflows and playbooks to define, manage, and perform security tasks with direct interfaces to various security systems, data sources, or agents.",
    "choice_b": "Automation brings together all sources of security and event information; orchestration provides for workflows and playbooks to define, manage, and perform security tasks with direct interfaces to various security systems, data sources, or agents.",
    "choice_c": "These terms both refer to the integration of information and control flows between security devices, data sources or agents, and security operations and management consoles; vendors use them interchangeably.",
    "choice_d": "Automation refers to the use of workflows to control the integration, analysis, and use of security information to perform security activities; orchestration refers to arranging these workflows into higher-level plans and processes, by the use of playbooks.",
    "correct_answer": "A",
    "explanation": "Automation is the use of scripts and similar techniques to predefine and then perform sequences of activities, which can be grouped in workflows and playbooks (of workflows); orchestration refers to organizing and managing the data flows from various security information sensors, agents, and devices. <br>Option B is false, it reverses these terms. <br>Option C is incorrect, although it is a useful caution as security vendors try to turn existing SIEMs or NGFW products and services into SOAR-like offerings. <br>Option D incorrectly describes both automation (which is workbooks and playbooks together to plan, manage, and perform tasks) and orchestration (of input data).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      49,
      50,
      59,
      65
    ],
    "source": ""
  },
  {
    "id": 1208,
    "question": "Various security devices, technologies, and systems seem to have evolved from each other, with each step on that pathway added new, more powerful capabilities to that which was already available. <br>Choose the option which places these systems or technologies in the correct sequence, from most capable to least capable.",
    "choice_a": "SOAR, SIEM, SDN, SDS",
    "choice_b": "SIEM, SDS, SDN, SOAR",
    "choice_c": "SIEM, SDN, SOAR, SDS",
    "choice_d": "SIEM, SDN, SDS, SOAR",
    "correct_answer": "D",
    "explanation": "The correct sequence is SIEM, SDN, SDS, and then SOAR.<br>SOAR depends upon centralized, virtualized control of security (SDS), which is built on top of network virtualization (SDN). SIEM systems do not in general require network virtualization.<br>This reflects integration of data from physical network and systems security devices, virtualized networks providing for scripted configuration (and reconfiguration) of network VMs, including their security characteristics; specialized applications that integrate security monitoring and configuration for virtual and physical systems; and process and activity workflow management and execution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      51,
      59,
      65,
      36
    ],
    "source": ""
  },
  {
    "id": 1209,
    "question": "The terms <italic>continuous assessment</italic> and <italic>continuous compliance</italic> are in frequent use. What does <italic>continuous</italic> actually mean in these contexts, with respect to how often these test, assessment, audit, and analysis activities are performed?",
    "choice_a": "These are conducted multiple times per business day, but only on a very small basis, such as with a single simulated transaction.",
    "choice_b": "Some may be regularly scheduled for multiple times per day, others less frequently.",
    "choice_c": "The full sequence of activities defined for a major end-to-end assessment or audit is executed task by task across the hours, days, or weeks, until all have been completed by the end of the audit period.",
    "choice_d": "Some may be performed multiple times per day, others less frequently, either periodically or on a scheduled basis, to balance the needs of assessment, compliance monitoring, and business operations.",
    "correct_answer": "D",
    "explanation": "Option A is incorrect, as there is no real restriction (such as single simulated transaction at a time) on how organizations plan and conduct such assessment and compliance monitoring. <br>Option B is correct as far as it goes, but not as complete as answer D. <br>Option C is unnecessarily restrictive; this may be one such strategy that an organization may consider and use for this, but it is not the only such strategy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      433,
      373,
      357,
      310,
      293
    ],
    "source": ""
  },
  {
    "id": 1210,
    "question": "Which statement about continuous security assessment and continuous compliance is most correct, when comparing it against more traditional integrated or end-to-end assessment or audit events?",
    "choice_a": "Performing assessment and compliance monitoring continuously should improve speed at which problems are identified, while providing ongoing assurance of effectiveness and compliance satisfaction.",
    "choice_b": "Planning and conducting single, integrated assessments or audits is probably more cost-effective, and easier to justify to regulators and compliance authorities, even if continuous assessment might provide better visibility into security controls and their performance.",
    "choice_c": "Both approaches provide about the same overall security and compliance results, but one may be better suited to the organization's management culture and processes.",
    "choice_d": "Performing these tasks continuously will probably cost more in the long run, while providing only a narrow, incremental view as to whether security controls are working properly.",
    "correct_answer": "A",
    "explanation": "Option A accurately expresses the goals and the benefits of doing these on a continuous basis. <br>Option B may or may not accurately state the cost comparison, but it ignores the growing need for faster intrusion detection (which means faster, or continuous, verification that security controls are working against each new day's threat landscape). <br>Option C may be true with respect to culture, but like option B misstates the need to have much faster intrusion detection. <br>Option D seems to describe a continuous assessment and compliance approach that is in need of rebalancing; this is not the general case.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      424,
      375,
      374,
      761,
      417
    ],
    "source": ""
  },
  {
    "id": 1211,
    "question": "The COVID-19 pandemic caused many organizations to substantially increase the percentage of their employees that worked remotely (from home or other locations). What physical information security issues should these organizations have addressed? <ol type=\"A\"><li>Ergometrics and other physiological safety and security aspects of each employee's remote work locations and arrangements. </li><li>Physical protection of network infrastructure and endpoint devices, at each employee's remote location, from loss or compromise. </li><li>More thorough enforcement of appropriate use policies and restrictions for endpoints and network access used by these employees.</li><li>Ensure that each remote work location had suitable backup power and connectivity.</li></ol>",
    "choice_a": "A, B",
    "choice_b": "B, C",
    "choice_c": "B, D",
    "choice_d": "A,C",
    "correct_answer": "C",
    "explanation": "Option A addresses a worker health and safety issue that is legitimate, but not normally in the scope of an information systems security plan or activity. <br>Option C is primarily implemented by technical, not physical, security controls. <br>Option D does address physical availability and might be necessary on a case-by-case basis for individual workers or workgroups requiring high availability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      280,
      282,
      346,
      293,
      281
    ],
    "source": ""
  },
  {
    "id": 1212,
    "question": "Your client manages a chain of fast-food restaurants that use a variety of digitally controlled cooking systems in the on-site preparation of their products. Up till now, these have only been connected at the local (in-restaurant) control system, which would produce printed reports on their utilization, temperatures, energy use, and so on. The client wants to upgrade these to controllers that can be remotely monitored by apps run by his corporate operations managers and business analysts. The client believes this can be done at minimal risk. As your client's security advisor, which of the following would be your best response?",
    "choice_a": "Concur; there is minimal additional risk, since the new interface is a one-way flow of reports from the controllers to headquarters.",
    "choice_b": "Suggest that the controllers' vendor(s) be asked to provide a security assessment, showing what threats they considered and have taken steps to mitigate; review this and resolve any issues before committing to their proposed upgrade.",
    "choice_c": "Warn the client that without doing extensive threat analysis and redoing the organization's risk assessment, you cannot support the idea of going ahead with this proposal.",
    "choice_d": "Suggest that the client ask the vendor(s) for referrals to other customers who've made this type of upgrade who are willing to talk about their experiences, including any security issues, with us.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; clearly the interface is two-way and could allow entities that can access the controller to have access to the IT systems at headquarters. <br>Option B is correct; if the vendor refuses to share, or has only minimal data and insights to share, that should be a strong warning that the vendor has not done their own risk assessment properly. <br>Option C is incorrect only in that it is relieving the vendors of responsibility right away, which is not advisable. <br>Option D is incorrect, as such referrals may be hand-picked by the vendor to offer slanted or biased observations to you.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      52,
      39,
      56,
      53,
      46
    ],
    "source": ""
  },
  {
    "id": 1213,
    "question": "Which of the following IT system security features are often included in many OT systems?",
    "choice_a": "Centralized control of usernames, passwords, and credentials, especially for root or admin identities",
    "choice_b": "Secure management of remote push of software, firmware, and control parameter updates",
    "choice_c": "Host intrusion prevention and detection",
    "choice_d": "All of the above",
    "correct_answer": "E",
    "explanation": "Most OT systems in use today use very small onboard controllers with minimal RAM or other storage capacity; as a result, many are difficult to update or make changes to, especially via remote push. Few have any kind of host-based intrusion detection or prevention capabilities, either built-in or available as after-market add-ons. As such, options A, B, C, D are incorrect.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      718,
      730,
      178,
      680,
      200
    ],
    "source": "",
    "choice_e": "None of the above"
  },
  {
    "id": 1214,
    "question": "Dejah is a student at the local community college. Using the on-campus library's student-accessible Wi-Fi connections, she uses a port mapping tool on her laptop to identify a number of systems on the campus network, including some of its firewalls. Curious, she browses to some of those IP addresses and is presented with device and server login screens; in one case, an address presents her with what looks to be a command-line interface login prompt. Whether intentional or not, which types of information security attack technique is she demonstrating?",
    "choice_a": "Privilege escalation",
    "choice_b": "Lateral movement",
    "choice_c": "Cross-site scripting",
    "choice_d": "Falsified credentials",
    "correct_answer": "B",
    "explanation": "Option B highlights how easy it can be in many environments to gather information and use it to attempt to access services that should be restricted. <br>Option A is incorrect, as no attempts were made to elevate to administrative or other privileged user modes. <br>Nor is option D correct, as the student was using either her own credentials or a publicly accessible (unsecured) Wi-Fi access point. <br>Option C is not correct; no attempts were made to alter web page contents to attack other users or sites.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      259,
      267,
      231,
      254,
      228
    ],
    "source": ""
  },
  {
    "id": 1215,
    "question": "One of the new members on your security team has heard about new ideas in digital identity creation, management, authentication, and use, but is a bit confused by it all. Which statement best explains to them, for example, what the important difference or differences are between an identity and an entity?",
    "choice_a": "An entity is a thing, such as a software task or process thread, or a device such as a phone or removable storage device; an identity refers only to a human being.",
    "choice_b": "Each individual person, device, or instance of a piece of software or a virtual machine has a unique identity; it may be represented as different entities, such as with different accounts on different systems.",
    "choice_c": "Different systems and organizations use these terms interchangeably to mean the same thing. No matter what it's called, it has to be authenticated and authorized before it should be allowed to access any systems resources.",
    "choice_d": "Each individual person, device, or instance of a piece of software or a virtual machine is a unique entity; it may be represented as different identities, such as with different accounts on different systems.",
    "correct_answer": "D",
    "explanation": "Option D correctly states this definition; a specific human, disk drive, laptop computer, or instance of a software process being executed is a specific, unique entity, even if it has been reproduced by copying it. Each entity must have an identity to access a system; the identity is what is authenticated for access and then for authorization. <br>Option A is correct as far as it goes, but does not connect these concepts to access control or identity management. <br>Option B swaps the label (identity or entity) and definition. <br>Option C is incorrect, and also does not represent current use of the terms in industry.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      228,
      254,
      231,
      233,
      248
    ],
    "source": ""
  },
  {
    "id": 1216,
    "question": "You work with a small startup company that is building dynamic mashups that combine the search results of user's web queries, map data, and results from analytics run in real time in order to create unique software to meet the user's needs. This software may be a game, an applet or widget, or some other small software appliance, for use with the user's IoT devices. The mashups can also include code from web-hosted code libraries and repositories, most of which are open source and unrestricted for reuse. <br>Which statement best captures the supply chain risks that are unique to this business process that the organization should consider?<ol type=\"A\"><li>Inbound supply chain risks </li><li>Outbound supply chain risks </li><li>Development risks </li><li>Data integrity risks</li></ol>",
    "choice_a": "A, B",
    "choice_b": "A, C",
    "choice_c": "B, C",
    "choice_d": "A, D",
    "correct_answer": "A",
    "explanation": "In effect, this organization is creating new things (the mashups) from the inputs selected in response to user inputs. <br>Option A addresses how many different threats can cause search results to be tainted (misdirected or contaminated with malformed data) or that code libraries selected for reuse are infected with malware of many types. <br>Option B addresses the passing on of these risks to customers, who then use those mashups for business or leisure use. <br>Options C and D are not unique to this business model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      46,
      56,
      52,
      59
    ],
    "source": ""
  },
  {
    "id": 1217,
    "question": "A new employee is familiarizing themselves with the company's parts catalog system. They discover that they can enter an SQL query such as a SELECT statement into a part number field, and sometimes the application responds by displaying selected data followed with a database command prompt. Which statement best identifies what kind of attack technique this might be?",
    "choice_a": "Cross-site scripting",
    "choice_b": "Buffer overflow",
    "choice_c": "SQL injection",
    "choice_d": "Arbitrary code execution",
    "correct_answer": "C",
    "explanation": "Option C best describes the improper entry of a query instead of data values, and having the application process that query as a query, rather than as data field values. <br>Options B and D might describe parts of the problem in this situation, but they are too broad to focus attention on the specific problem. <br>Option A is false, as this incident does not involve the attacker placing bogus scripts into web pages for other users to execute.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      222,
      201,
      261,
      262,
      267
    ],
    "source": ""
  },
  {
    "id": 1218,
    "question": "Which of the following might be the most effective means of detecting malformed data attacks?",
    "choice_a": "User and entity behavior analytics, applied to ongoing activities",
    "choice_b": "Ethical penetration testing to detect vulnerabilities with data typing, validation, and reasonableness checks in software and procedure designs",
    "choice_c": "Periodic audit of processed transactions, accounts, and related records",
    "choice_d": "Trending analysis of errors encountered during user entry and use of forms, workflows, or other data input processes",
    "correct_answer": "A",
    "explanation": "Each of these answers is a valid technique to reduce the risk that malformed data attacks can occur; only option A provides a real-time opportunity to check user and entity actions, across the organization's systems and infrastructures, for behaviors that are suspicious and might be exploiting a malformed data vulnerability. <br>Option B simulates such attacks and is valuable in finding such vulnerabilities or stress-testing the controls put in place to mitigate them. <br>Option C can identify attacks that have happened during the audit period, but not usually in real time. It may still be the only way to detect that your systems were successfully invaded weeks or months ago and might reveal where they are currently abusing your resources and assets. <br>Option D, trending, will highlight types of errors, if the systems and applications generate log entries or other telemetry when these events happen; this may be useful in highlighting vulnerabilities, but not in identifying that a specific attack has been made.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      53,
      59,
      55,
      40
    ],
    "source": ""
  },
  {
    "id": 1219,
    "question": "Arbitrary code execution is a form of:",
    "choice_a": "Firewall configuration errors",
    "choice_b": "Security kernel being disabled by superuser",
    "choice_c": "Buffer overflows",
    "choice_d": "Phishing",
    "correct_answer": "C",
    "explanation": "Buffer overflows can cause improperly structured software to have portions of their instruction space overwritten by data input that has more characters in it than space reserved for it by the program. In such cases, the bytes beyond the declared length of the buffer may be executed as machine instructions; this is option C. <br>Option A is false; firewalls do not play a part in preventing this form of malformed data attacks. <br>Option B is false; the security kernel is not disabled by entering privileged mode, and in most systems it cannot be disabled at all. <br>Option D is false; phishing attempts may provide an attacker with access to a system, but this is not a case of malformed data attack.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      62,
      55,
      49,
      46
    ],
    "source": ""
  },
  {
    "id": 1220,
    "question": "You work as the one-person information security team at a small business. One of the senior managers has just watched some cybercrime webinars and as a result has asked you to look into implementing a full set of DNSSEC measures. Which statement best summarizes your response?",
    "choice_a": "You'll develop a plan and proposal to implement these in the organization's web servers and internal network management systems.",
    "choice_b": "Since most of what the company uses is all cloud-hosted applications platforms, you'll check with the CSP to see what they provide and what it might take to enable or use DNSSEC on your company's cloud activities.",
    "choice_c": "Since DNSSEC is for the Internet organizations that run the network and DNS infrastructures, there's really nothing in it that applies to our company.",
    "choice_d": "DNSSEC is not really an end user organization's set of remedies to apply, but there are other things that the company can and should be doing.",
    "correct_answer": "D",
    "explanation": "Option A is incorrect, as DNSSEC is not something that is implemented by end user organizations. <br>Option B is also incorrect, as CSPs are end user organizations from the perspective of the DNS infrastructure. <br>Option C, while true as far as it goes, does not actually address the underlying concern. <br>Option D corrects the misunderstanding of DNSSEC and offers a way forward.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      192,
      160,
      163,
      178,
      200
    ],
    "source": ""
  },
  {
    "id": 1221,
    "question": "Which statement best describes the two forms of analytics commonly used?",
    "choice_a": "Machine learning and Bayesian analysis",
    "choice_b": "Predictive and descriptive",
    "choice_c": "Glass box and hidden methods",
    "choice_d": "Pattern matching and behavioral analysis",
    "correct_answer": "B",
    "explanation": "Option B correctly identifies analytics (or large-scale data analysis) being used in two ways to predict future outcomes or to describe current and past events and systems behaviors. <br>Options A and D are incorrect; these are techniques that can be used in either prescriptive or descriptive analytics. <br>Option C is also incorrect, although this does succinctly express one of the major barriers to human managers placing trust in automation driven by analytics.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      272,
      263,
      210,
      201,
      221
    ],
    "source": ""
  },
  {
    "id": 1222,
    "question": "Machine learning, analytics, and other artificial intelligence techniques are often not trusted very much by business and organizational managers and leaders. Which of the following might be the biggest barrier to gaining their trust and confidence so that these tools can be put to more automated, real-time use as part of information security?",
    "choice_a": "Ensure that managers and leaders understand the mathematics and logical processes used by these tools.",
    "choice_b": "Conduct sufficient parallel assessment testing to demonstrate that these tools have \u201cpassed\u201d their training and work as effectively as humans do.",
    "choice_c": "Use these technologies in ways that can display or summarize their logic and reasoning, allowing users to understand it (at a summary level), question it, or accept it.",
    "choice_d": "Always use them in a dual control process requiring trained human approval before action is taken.",
    "correct_answer": "C",
    "explanation": "Option C correctly states the essence of the trust and confidence problem. Without explicability, these tools are often seen as little more than magic; either their users trust in them blindly or they don't. <br>Options A and B don't address this, but these techniques can play a role in initial systems and tools selection, initial training and calibration, and ongoing operational evaluation of them. <br>Option D is incorrect and is somewhat self-defeating.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      272,
      700,
      223,
      201,
      204
    ],
    "source": ""
  },
  {
    "id": 1223,
    "question": "The customer satisfaction manager at your organization shares with you their concern that security measures are introducing too much friction into customer-facing processes. Which statement best describes what this means?",
    "choice_a": "As the sensitivity of security and counterfraud measures are increased, this requires users (such as customers) to respond correctly to more security challenges, more frequently, or for more user activities to require a human manager approval to proceed. These all add time to fulfilling customer service needs.",
    "choice_b": "Security measures have made customer-facing applications and web pages difficult to understand and harder to use; internal users, too, find them hard to follow and use correctly.",
    "choice_c": "Security measures are requiring management analysts to generate additional reports and analytics, which must then be audited, and this is reducing the cost effectiveness of customer-oriented business processes.",
    "choice_d": "Customers are complaining that they don't like the new multifactor authentication and security challenge processes, and dealing with these complaints is taking up too much staff time.",
    "correct_answer": "A",
    "explanation": "Option A correctly identifies that adding additional work steps, checks and balances, or validation activities to a work process can require additional processing time, resources, or the involvement of additional human review and authorization to complete. Too much friction can cause customers (internal and external) to go elsewhere, or attempt to circumvent the controls. <br>Option B is incomplete and doesn't address well-designed controls that still add steps (and friction). <br>Option C is incorrect, as it refers to activities that happen after a customer process has completed (presumably). <br>Option D is incorrect; staff time to resolve complaints is presumably spent after the process has been completed (or abandoned) and does not relate to its real-time performance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      447,
      273,
      330,
      394,
      13
    ],
    "source": ""
  },
  {
    "id": 1224,
    "question": "Most organizations have to demonstrate that their users (at all levels) have completed specific security education, training, and awareness activities to satisfy compliance audits and keep their systems and information secure. Which is the best approach to achieve this?",
    "choice_a": "Use a formal classroom setting and instructional methods to deliver lessons that identify security requirements, the compliance requirements that relate to them, organizational security policies, employee responsibilities, and sanctions for violations of security policies.",
    "choice_b": "Combine initial classroom training on security requirements, policies, and employee responsibilities with shorter, self-paced refresher lessons that users must periodically complete.",
    "choice_c": "Combine initial on-the-job orientation education, with task-specific training to identify security policy requirements and link them to employee actions.",
    "choice_d": "Combine microtraining and other just-in-time learning methods and security services delivery, along with a mix of initial education and training and other methods.",
    "correct_answer": "D",
    "explanation": "Option D in effect implements a \u201cneed to know\u201d approach but in a different way by providing the new (or refresher) security insights right at the point of work where the user can make best use of them. This enables the worker to take more positive, security-correct action. <br>Option A is a traditional approach, which tends to consider users as the weakest link in the overall chain of security controls. <br>Option B is an improvement on A, but still often results in tick-the-box training compliance rather than a more well-informed workforce. <br>Option C is a just-in-time learning and security delivery model, but is lacking a more complete, full-spectrum teaching, learning, skills-building, and assessment set of methods.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      428,
      447,
      420,
      275,
      273
    ],
    "source": ""
  },
  {
    "id": 1225,
    "question": "Which statement best describes the relationship between continuous assessment and vulnerability management?",
    "choice_a": "Vulnerability management should drive continuous assessment, setting the priority or urgency for assessment activities based on the risks associated with that vulnerability.",
    "choice_b": "Vulnerability management informs the planning and conduct of continuous assessment, the results of which are used as updates to vulnerability management.",
    "choice_c": "There is no direct link between these two sets of processes; rather, they come together via continuous monitoring.",
    "choice_d": "Vulnerability management helps inform and prioritize continuous assessment planning, but it is the results of continuous compliance that closes the loop back to vulnerability management.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect, in that other operational, compliance, and the current risk and threat context may be better sources of priority and urgency to use for assessment activity planning and conduct. <br>Option B correctly refers to the one process informing, but not driving, the other. <br>Option C is incorrect and misstates the relationship of monitoring with assessment and compliance. <br>Option D is incorrect, as the successful validation of an assessment activity actually drives both the close-out of the vulnerability and the completion of a compliance check.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      58,
      35,
      54,
      46
    ],
    "source": ""
  },
  {
    "id": 1226,
    "question": "Your company recently replaced its security log management approach to monitoring with a SIEM system and is starting to adapt its procedures over to making better use of this investment. The SIEM product you're using does not provide for workflow management and use. Which approach might be a good step for the company to continue to mature its security program?",
    "choice_a": "SDN",
    "choice_b": "SDS",
    "choice_c": "SOAR",
    "choice_d": "Managed security services",
    "correct_answer": "C",
    "explanation": "Security orchestration, automation, and response (SOAR) systems, option C, provide for workflows and playbooks with which security teams can create, manage, use, and mature their procedural activities. <br>Option B, software-defined security, does provide for more script-driven, centralized control of security systems, but generally does not include hierarchical structures of procedures like playbooks and workflows, nor the automation capabilities for event-triggered activation and use of them to meet predefined events or conditions. <br>Option D hands most of the security processes and their responsibilities to an outside services provider, which does not develop in-house skills or knowledge. <br>Option A, software-defined network, is pretty much a prerequisite for SDS and SOAR.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      197,
      198,
      176,
      200,
      195
    ],
    "source": ""
  },
  {
    "id": 1227,
    "question": "Your organization's security monitoring and analysis activities currently use a variety of scripts running on each data source, such as application servers, to save logs and send them to a central logging server. Currently, only one month of data is kept on the logging server; once past that point, date is overwritten. Which statement best describes the potential impacts of this approach?",
    "choice_a": "This forces the organization to do compliance audits on a rolling or continuous basis, so as not to lose sight of the security condition of the system on any given day.",
    "choice_b": "There is no data available to determine if a security incident such as a data breach began and ended more than a month ago.",
    "choice_c": "No impact, as the organization needs to focus on intrusion attempts that are happening in real time, rather than spending analyst time looking into the distant past.",
    "choice_d": "These log files are important during systems recovery and restoration operations, and thus you're unable to fall back to a system configuration more than one month old.",
    "correct_answer": "B",
    "explanation": "Option B correctly identifies the primary risk: with most intrusions going undetected for up to six months or more, once those log files and data are gone, you have no idea how much of your organization's sensitive data (or your customer's data) has been compromised over time. <br>Option A may be a valid concern, but it doesn't directly address the risk of an undetected (and potentially undetectable) compromise. <br>Option C is incorrect on its face: forensic, compliance, and intrusion detection may very well need to reach further back than one month to determine if something has happened, and what its repercussions were and are. <br>Option D is false; log files play no direct role in systems recovery and restoration.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      605,
      61,
      51,
      53,
      40
    ],
    "source": ""
  },
  {
    "id": 1228,
    "question": "As a security analyst, you're asked to help determine if there are insider threats that the organization may not have adequate measures in place to prevent, detect, identify, contain, or respond to. One of your teammates suggests that everything you'd need to look at should be in the identity management and access control system's accounting records. Which phase or phases of incident response would such data be least applicable to?",
    "choice_a": "Prevent",
    "choice_b": "Detect",
    "choice_c": "Contain",
    "choice_d": "Identify",
    "correct_answer": "D",
    "explanation": "The IAAA records themselves are, of course, a history of events. They would be helpful in identifying (option D) privilege creep or abuse, lateral movement, and similar activities that potentially indicate an insider becoming a threat. By themselves, the accounting records do not detect (option B), prevent (option A), nor contain (option C) an unauthorized behavior.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      99,
      94,
      96,
      80,
      81
    ],
    "source": ""
  },
  {
    "id": 1229,
    "question": "One of the on-premises application servers your organization depends upon crashes on an irregular basis. The crashes are triggered by the server's security kernel. Analysis shows that this happens most frequently when a certain set of applications programs are running, as part of a larger transaction processing system. Which of the following types of attacks would you look to first, as the possible cause of these crashes?",
    "choice_a": "Malformed data attack",
    "choice_b": "Cross-site scripting attack",
    "choice_c": "Distributed denial-of-service attack",
    "choice_d": "DNS cache poisoning attacks",
    "correct_answer": "A",
    "explanation": "Option A is correct; input data to one or more of these applications may all be within range and format validation checks, but taken together are inconsistent and contradictory, which may cause a software vulnerability to trigger that leads to the crash. <br>Options B, C, and D are unlikely to be the direct cause of an application program operating in ways that cause the security kernel to shut the system down. A larger attack process may be using one or more of these to cause the malformed data to be input to the application in question, but malformed input should still be the place to check first.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      46,
      42,
      44,
      35,
      39
    ],
    "source": ""
  },
  {
    "id": 1230,
    "question": "Microtraining is security training that:",
    "choice_a": "Provides immediate, in-context security tips and advice to help users complete specific tasks more securely",
    "choice_b": "Engages users with task-oriented security learning activities that typically need a minute or so of time to complete",
    "choice_c": "Single-issue awareness learning activities, easily taken in by a user in less than a minute",
    "choice_d": "Any security education, training, and awareness activity where effectiveness of learning is best measured with small, focused tasks.",
    "correct_answer": "B",
    "explanation": "Option B correctly identifies engaging users with tasks that reinforce proper security-conscious behavior, such as not opening suspicious emails or their attachments. <br>Option A is incorrect; it describes just-in-time security. <br>Option C is incorrect; a poster may take 15 seconds to read, but there is no effective way to assess how that 15 seconds affects behavior. <br>Option D is incorrect; the concept of microtraining refers to the total time spent by the learner on the activity, and not just the assessment aspects of it.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      428,
      447,
      420,
      275,
      327
    ],
    "source": ""
  },
  {
    "id": 1231,
    "question": "Which of the following areas of a manufacturing company's operations and systems should be covered by an up-to-date disaster recovery plan?",
    "choice_a": "IT and communications systems and services",
    "choice_b": "OT, process control, and related safety systems",
    "choice_c": "Internal and external information, coordination, reporting, and disclosure processes",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Option A is incomplete, but it does represent the traditional viewpoint in the IT community that \u201csomeone else\u201d worried about restoring the functions of the business, once the IT and communications were brought back to useful service. <br>Options B and C identify critical functions to any manufacturing entity; these can be disrupted or damaged by cyberattacks, and without their effective restoration and recovery, the business cannot function. <br>Option D is correct and represents the growing consensus of what a \u201cdisaster\u201d truly entails for a modern organization.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      82,
      72,
      88,
      92,
      79
    ],
    "source": ""
  },
  {
    "id": 1232,
    "question": "Which of the following components must be included in a trusted computing base?",
    "choice_a": "Reference monitor",
    "choice_b": "Firewall",
    "choice_c": "Trusted platform module",
    "choice_d": "Hardware security module",
    "correct_answer": "A",
    "explanation": "Option A is correct; a trusted computing base consists of the security kernel and the reference monitor, inclusive of the hardware, firmware, and software that host or support them directly. <br>Options B is an external application or device, not part of the kernel. <br>Option C is a tamper-resistant hardware device that provides core cryptographic services to a system. <br>Option D is a device, typically on a network, for securely storing and managing cryptographic assets.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      218,
      217,
      223,
      201,
      205
    ],
    "source": ""
  },
  {
    "id": 1233,
    "question": "You've been asked to review your organization's business continuity plans, which lay out a variety of options for alternate and backup work locations and facilities. You notice that these plans make no mention of physical security controls. What would this mean to you, as a security team specialist, if a major disruption happens today and these plans were put into action immediately?",
    "choice_a": "I would assume that someone else would be enforcing all normal workplace physical security procedures, such as badging, visitor control, and use of personal devices, at each alternate location as it is put into use.",
    "choice_b": "I would assume that the security team would be enforcing all normal workplace physical security procedures, such as badging, visitor control, and use of personal devices, at each alternate location as it is put into use.",
    "choice_c": "I would assume that the security team would have to work this out during the activation of each location, as each location and the circumstances of its use may dictate specific physical security needs.",
    "choice_d": "I would assume that the employees and managers that are sent to each alternate location will know the right physical security steps to take when they first start operations at that location.",
    "correct_answer": "C",
    "explanation": "Option C is most correct: it keeps the burden (or responsibility) of due care and due diligence for security, including physical security, on those with the primary responsibility for it (the security team). <br>Option B is partially correct: the requirements that drove those policies haven't changed, but the details of carrying them out (procedurally) will no doubt have to be tailored to location and circumstances. <br>Options A and D are incorrect; both of these abdicate the responsibilities the security team is assigned, and hope that someone else will pick them up and carry them out.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      84,
      83,
      92,
      101,
      72
    ],
    "source": ""
  },
  {
    "id": 1234,
    "question": "Which statement best describes the security implications of the shared responsibility model?",
    "choice_a": "The primary party always has ultimate responsibility for security, but use contracts to share certain parts of those responsibilities with third-party service providers.",
    "choice_b": "Cloud services providers (CSPs) use their service level agreements and standards to specify which security responsibilities they will provide, and which must be left to their customers to choose how to implement (if at all).",
    "choice_c": "Trusted systems use depends upon allocating different aspects of a security requirements, such as preserving systems integrity, across different elements which must use specified, trusted channels to achieve this.",
    "choice_d": "As part of an acceptable use policy, this places some of the responsibility for systems security (and therefore the security and safety of the organization) on each user or employee. It provides the basis for granting access privileges, for example.",
    "correct_answer": "A",
    "explanation": "Option A best states the shared responsibility model. <br>Option B is correct for CSPs but ignores that this model applies to any service provider agreement. <br>Options C is incorrect; it confuses a legal and administrative concept with systems architecture ones, such as dual control. <br>Option D is incorrect, although it demonstrates that the fundamental concept can be seen (by way of analogy) in many security practices.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      697,
      535,
      536,
      746,
      744
    ],
    "source": ""
  },
  {
    "id": 1235,
    "question": "You've recently joined the security team at a nonprofit corporation's regional headquarters. Recently, it came to light that local employees have been using a collection of software, including scripts and macros, that different staff members have developed over time; these include a database system for client and donor information. Your boss asks you to perform a security assessment of this situation. Where would you start?",
    "choice_a": "Vulnerability assessment and inventory",
    "choice_b": "System enumeration and inventory",
    "choice_c": "User and manager interviews, to identify and characterize the elements of this collection, and use this to prioritize further security analysis and assessment",
    "choice_d": "Review user complaints, help requests, or security logs to determine what security issues (if any) may need further investigation",
    "correct_answer": "B",
    "explanation": "Option B correctly starts with the first rule of systems management: know what it is that you're going to manage. With that inventory in hand, option A has a known place to start from. <br>Option C can also be done, once the inventory is in hand, to gain guidance as to how detailed or how urgent any one line of investigation should be. <br>Option D is also best performed after an inventory is in hand. Note that even if the first enumeration and inventory is complete, it still is better than starting any of these tasks without one.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      706,
      266,
      257,
      231,
      220
    ],
    "source": ""
  },
  {
    "id": 1236,
    "question": "An unscrupulous employee wants to exfiltrate copies of the development plans for a new product and its marketing strategy so that when they no longer work for that company, they can use them as part of starting their own business. Physical and other administrative security policies prevent just copying them and walking out with the copies, so they find and use tools that fragment the data, encrypt the fragments, and stuff the data into JPEG and MP4 files (as tagged fields that image and video viewer apps will ignore) that are routinely made available to customers. This would be an example of using:",
    "choice_a": "A side channel",
    "choice_b": "An out-of-band channel",
    "choice_c": "A covert path",
    "choice_d": "A hijack",
    "correct_answer": "C",
    "explanation": "Option C correctly identifies this as an unauthorized communications channel or pathway between two processes. <br>Option A is incorrect; side channel attacks try to inject spurious noise, environmental or power transients, etc., to disturb the operation of a system or element, rather than manipulating or interfering directly with data and commands flowing into the system. <br>Option B is incorrect; this is using an alternative means to communicate information, such as to distribute encryption keys and related cryptovariables. <br>Option D is incorrect, as a hijack involves taking over or somehow inserting an attacker's processes into a protocol or communications path between two other systems or parties.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      261,
      265,
      227,
      201,
      237
    ],
    "source": ""
  },
  {
    "id": 1237,
    "question": "How does authentication differ from authorization, in identity management and access control terms?",
    "choice_a": "Authentication enforces the permissions granted to an identity, while authorization establishes that the identity is known to the system and is not being falsely claimed by the submitting system or user.",
    "choice_b": "AuthAuthorization enforces the permissions granted to an entity, while authentication establishes that the entity is known to the system and is not being falsely claimed by the submitting system or user.",
    "choice_c": "Authentication enforces the permissions granted to an entity, while authorization establishes that the entity is known to the system and is not being falsely claimed by the submitting system or user.",
    "choice_d": "Authorization enforces the permissions granted to an identity, while authentication establishes that the identity is known to the system and is not being falsely claimed by the submitting system or user.",
    "correct_answer": "D",
    "explanation": "Option A is incorrect, as it explains authorization as if it were authentication, and vice versa. <br>Option B is incorrect in that both processes relate to identities, not entities. <br>Option C is incorrect, in that it applies these concepts to entities, rather than to identities. <br>Option D correctly relates both concepts to identities (which are issued by the system in question, or another identity service, for the use of the entity that wishes to access that system's resources), and correctly states that authentication verifies that the identity is known and that the claim by the presenting entity is valid, so that subsequent access request can be authorized (allowed to proceed) based on checking predefined permissions.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      228,
      254,
      231,
      230,
      248
    ],
    "source": ""
  },
  {
    "id": 1238,
    "question": "Lateral movement refers to a security risk in which a user or process:",
    "choice_a": "Uses their authorized privileges to access resources on other elements of the system, such as on other application servers or databases",
    "choice_b": "Escalates their privileges to access resources on other elements of the system, such as on other application servers or databases",
    "choice_c": "Attempts to log onto or connect with servers or services that they do not require access to for job-related functions",
    "choice_d": "Attempts to circumvent database view restrictions to access data elements, fields, or records",
    "correct_answer": "A",
    "explanation": "Option A correctly expresses lateral movement; it represents a failure by systems administrators to effectively implement authentication and authorization across an architecture and is a common failure in implementing single sign-on or other federated access architectures. <br>Option B is incorrect, as lateral movement does not require an escalation or change of privileges. <br>Option C is partly correct; this is one technique that might be used in lateral movement, but is not what defines it. <br>Option D is incorrect, as lateral movement refers to exploiting access to other systems and services, and not to features (such as data or commands) within a system the user already has access to.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      195,
      191,
      200,
      196,
      175
    ],
    "source": ""
  },
  {
    "id": 1239,
    "question": "Which of the following security processes relates potential impacts to the organization, to its stakeholders, or to other parties, with any compromise of an information asset's security?",
    "choice_a": "Establishing a security baseline",
    "choice_b": "Categorization",
    "choice_c": "Classification",
    "choice_d": "Compliance assessment",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; the baseline is built by combining classification, categorization, and controls information. <br>Option B is incorrect, as this process groups assets of comparable classification and compliance-dictated security protection requirements. <br>Option C is correct; note this includes all aspects of security, and not just confidentiality or privacy. <br>Option D is incorrect, as this is performed to determine how well (or badly) a system meets these requirements, which should be captured in the system's security baseline if the system and its security is properly managed.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      45,
      42,
      48,
      38,
      52
    ],
    "source": ""
  },
  {
    "id": 1240,
    "question": "Risk management and mitigation involve making choices, which are often expressed as the choices of accepting, avoiding, treating, transferring, or recasting a risk. Which statement best captures the way these decisions are used in an effective risk management program?",
    "choice_a": "These decisions are made during strategic risk management considerations, which then drive, constrain, or guide the planning of specific treatment plans for each risk.",
    "choice_b": "These decisions are made iteratively, and at strategic, tactical, and operational levels, as the organization's understanding of a risk broadens and deepens.",
    "choice_c": "Treating (or mitigating) a risk involves the use of security controls; all other decisions involve purely administrative or policy actions to carry out.",
    "choice_d": "Decisions to accept, avoid, or transfer are best made first at the strategic level first; treatment (or mitigation) then applies controls. Recasting of a risk is largely an administrative exercise to show to compliance auditors that all identified risks have been dealt with somehow.",
    "correct_answer": "B",
    "explanation": "Option B correctly shows that large, strategic risks are often broken down into finer and finer granularity, and along the way, different pieces of that larger risk may require different choices (i.e., accept, treat, etc.) Option A incorrectly reduces risk mitigation's span of decision to treatment only. <br>Option C incorrectly disregards administrative actions as forms of security controls, as well as disregarding the use of technical or physical controls as part of carrying out decisions to accept, avoid, etc. <br>Option D is partly correct (to recast is to restate the residual risk in its own terms), but this is not a mere compliance sleight of hand.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      65,
      59,
      63,
      62,
      56
    ],
    "source": ""
  },
  {
    "id": 1241,
    "question": "Which statement best describes how security orchestration is different than security automation?",
    "choice_a": "Orchestration involves bringing together the command and control of security devices, appliances, or agents in an architecture, while automation provides scripted control over security monitoring and data gathering activities.",
    "choice_b": "Automation involves bringing together the command and control of security devices, appliances, or agents in an architecture, while orchestration provides scripted control over security monitoring and data gathering activities.",
    "choice_c": "Automation involves bringing together data sources and streams from security devices, appliances, or agents in an architecture, while orchestration provides scripted control via workflows and playbooks over security activities such as incident responses or monitoring and analysis tasks.",
    "choice_d": "Orchestration involves bringing together data sources and streams from security devices, appliances, or agents in an architecture, while automation provides scripted control via workflows and playbooks over security activities such as incident responses or monitoring and analysis tasks.",
    "correct_answer": "D",
    "explanation": "Option D correctly describes automation and orchestration in security systems. <br>Option C has the terms reversed. <br>Option A is incorrect: gathering various data streams (and the devices that produce that data) requires management, but this is not the command and control of devices, such as intrusion prevention systems, that automation applies to as a concept; similarly, automation may use scripts, but the real power it brings is in the management and execution of these scripts in playbooks and workflows. <br>Option B has this same garbled meanings but connected to the wrong term.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      40,
      51,
      49,
      59,
      65
    ],
    "source": ""
  },
  {
    "id": 1242,
    "question": "Which of the following statements is correct in regard to source code escrow? <ol type=\"A\"><li>Allows organizations to meet contractual obligations in regard to software licensing </li><li>Protects against software vendor bankruptcy </li><li>Allows detection of vulnerabilities in software </li><li>Allows backing up of critical software </li></ol>",
    "choice_a": "A, B",
    "choice_b": "B, C",
    "choice_c": "A, D",
    "choice_d": "B, D",
    "correct_answer": "A",
    "explanation": "Source code escrow can also be applied to reduce the risk of technology obsolescence, such as for device drivers, by paying a licensing (escrow) fee to the vendor. It has no role to play, however, in vulnerability detection or backing up of software, which involves secure copies of executable systems and applications.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      510,
      511,
      512,
      461,
      487
    ],
    "source": ""
  },
  {
    "id": 1243,
    "question": "Your security managers are considering moving to a security orchestration, automation, and response (SOAR) approach, as a way of improving their overall security posture. Your main responsibilities are with end user and manager security education, training, and awareness activities. Which statement best describes the differences this would make to your functions and activities?",
    "choice_a": "Some benefit, both for deployment and use of training products and services, and for analytics support to assess training effectiveness or identify areas (or people) requiring greater attention.",
    "choice_b": "Major benefit, as over time the playbooks and workflows that will be built using SOAR can also grow, capture, and manage institutional and personal knowledge.",
    "choice_c": "Minimal benefit, as some event-driven training and skills-building might benefit from using SOAR as part of its deployment and management.",
    "choice_d": "No real change is anticipated.",
    "correct_answer": "A",
    "explanation": "Option A is correct; with SOAR in place, your ability to analytically link delivery of training to users with effective use of security measures and controls is improved. <br>Option B is not correct with respect to your duties as education, training, and awareness coordinator, although SOAR may be able to help the security teams overall make significant improvements in the organization's security posture. <br>Option C is only partially correct; it ignores the potential for improved analytics to better focus and direct education and training. <br>Option D is incorrect, as this ignores all potential changes, including the possibility that new SOAR-related security procedures that effect end users will require new or revised training.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      40,
      57,
      59,
      52,
      56
    ],
    "source": ""
  },
  {
    "id": 1244,
    "question": "Which sources of information would be helpful in identifying a possible insider threat situation that might arise from employees who believe themselves to be wrongly treated by their managers?",
    "choice_a": "Threat intelligence services",
    "choice_b": "Social network activities and postings",
    "choice_c": "Integrated identity and access management (IAM) systems data.",
    "choice_d": "Periodic personnel evaluation, counseling, and feedback sessions",
    "correct_answer": "B",
    "explanation": "Option B correctly focuses attention on the channels in which frustrated employees, who might potentially become disruptive or cause security incidents, may be expressing their emotions more openly. <br>Option A is incorrect, as these services tend to be more useful at identifying and characterizing external threats. <br>Option C is incorrect, as this will show employee actions in the information systems architectures, but not necessarily reveal anything about motivations. <br>Option D is incorrect; generalizations made about such evaluations and feedback tend to be unreliable at detecting such potential for insider threats.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1245,
    "question": "As a security advisor, one of your clients is a small company developing custom software systems for other small businesses. Their development process and all business support systems are cloud-hosted; their rented office spaces in an office park provide their developers, sales team, and managers with workstations, Internet access, and meeting spaces. You believe they may be overlooking a variety of IoT-related security issues. Which of the following would you consider the most important to assess first?",
    "choice_a": "Use of drones or other autonomous devices as part of a data breach to steal intellectual property and customer data",
    "choice_b": "Surreptitious use of Wi-Fi interception to eavesdrop on conversations",
    "choice_c": "Exploits against consumer devices used in the office, such as entertainment systems, mobile phones, or other similar devices",
    "choice_d": "Attacks against the building's utilities, heating and air conditioning, and physical security systems",
    "correct_answer": "C",
    "explanation": "Option C is correct; many modern consumer products include voice-activated control systems that use cloud-hosted speech processing systems as part of their processing, which may or may not be as secure as the company or its clients may need. <br>Option A can and does occur in the wild, but generally is not a persistent risk (the drone is not outside your window every day, all day, for example). <br>Option B is incorrect; using a mobile device to surreptitiously monitor conversation would probably use the device's mobile phone system services, rather than the target's Wi-Fi, as its communications path. <br>Option D is possible, of course, but given the nature of the organization and its business, only the potential for an undetected physical intrusion into the workspace is there an immediate concern.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      227,
      265,
      201,
      208,
      266
    ],
    "source": ""
  },
  {
    "id": 1246,
    "question": "An update to your email system now allows it to scan emails as they are being first created by users, offer advice about possible security concerns, and dynamically impose certain processing steps required by security policies to an email and its attachments before it can be completed, saved, and sent. This is an example of which security concept in action?",
    "choice_a": "User and entity behavioral analytics",
    "choice_b": "Data loss prevention",
    "choice_c": "Microtraining",
    "choice_d": "Just-in-time security",
    "correct_answer": "D",
    "explanation": "Option D is correct; this is delivering security help in the form of tools, techniques, and information right in the moment that the user needs it. <br>Option C is incorrect; this is generally done with simulated data, not data such as emails that the user is preparing or documents they are working with. <br>Option B is incorrect, although just in time security can play a vital role in an overall DLP strategy. <br>Option A is incorrect, although UEBA or similar capabilities may help inform the just in time security system's models and the advice or choices it offers to users at the time and point of need.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      447,
      19,
      357,
      315,
      338
    ],
    "source": ""
  },
  {
    "id": 1247,
    "question": "The recent publication of NIST's Cyber Security Framework (CSF) places greater emphasizes on which of the incident response lifecycle phases more, than did previous guidance and publications?",
    "choice_a": "Preparation",
    "choice_b": "Prevention",
    "choice_c": "Detection",
    "choice_d": "Response",
    "correct_answer": "C",
    "explanation": "Option C is correct. NIST (and others) believe that while many organizations have made great progress with improvements to intrusion (and incident) prevention, greater attention is needed on real time and near real time detection. The other options are important and vital to overall security; but with intrusions going undetected for six months or more, greater emphasis on detection is overdue.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      99,
      96,
      69,
      94,
      71
    ],
    "source": ""
  },
  {
    "id": 1248,
    "question": "Which of the following technologies would be used to manage and protect an organization's digital certificates?",
    "choice_a": "Reference monitor",
    "choice_b": "Trusted platform module",
    "choice_c": "Hardware security module",
    "choice_d": "Key escrow.",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; this is part of the trusted computing base of every processor. <br>Option B is incorrect; TPMs might be used in a single server or endpoint to manage and store certificates used with it, but not for the organization as a whole. <br>Option D is a process for storing keys with a trusted party for later on-demand retrieval, such as by law enforcement. <br>Option C is correct; an HSM provides secure and safe storage and management of sensitive assets such as certificates or the keys used to encrypt archival and backup data.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      218,
      268,
      248,
      240,
      265
    ],
    "source": ""
  },
  {
    "id": 1249,
    "question": "One of the farmers in your area is using a variety of smart systems to guide and control the operation of farm machinery in their fields. They've asked you to look at their operation and assess its security. Which of the following areas of their farm's IT and OT architecture would be your starting point for your security assessment?",
    "choice_a": "Self-driving tractors, guided by GPS or precision location services, for more accurate care and treatment of fields",
    "choice_b": "Precision drip irrigation and feeding systems, which can be run with a smartphone app",
    "choice_c": "Security alarm systems for their barns, sheds, other outbuildings, and their home",
    "choice_d": "Their use of a cloud-hosted \u201csmartfarm\u201d applications platform to provide integrated control and comprehensive analytics.",
    "correct_answer": "D",
    "explanation": "Threats in this situation could originate elsewhere in the cloud and move inwards to the IoT devices themselves; or they can originate in the field via MITM, link or session hijack attacks, or other means, and work upward to the farmer's private data\u2014or even to other clients of the smartfarm app itself. So where do you start? Options A, B, and C all are areas of concern; they all involve systems that have on-site control, communications, and data gathering elements, which are subject to interference, sabotage, eavesdropping, or other attacks. They all can be subverted by an attacker to be used as an entry point into other areas of the farm's systems. <br>Option D, the cloud application, is a single point where everything comes together. Start with the service level agreements, contracts, and user guides from this platform provider, and having examined that fully, then break out your muddy boots and head out into the farm and its fields.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      535,
      234,
      217,
      227,
      231
    ],
    "source": ""
  },
  {
    "id": 1250,
    "question": "Your company has just suffered a massive cyberattack that left most of your servers and your factory automation systems inoperable. Some had their hard drives encrypted or critical systems parameters changed. Others, including OT systems elements, seem to have had their firmware or control software changed as part of the attack. Many different forms of malware are suspected to have been used, but so far, the attack hasn't been analyzed in depth. From an IT or OT supply chain perspective, which of the following strategies seems to be the least secure way of restoring these systems to operational use?",
    "choice_a": "Start by reloading the highest-level servers and administrative control systems from the most recent backups; then work down through corporate data center systems and finally to individual workstations or mobile endpoints.",
    "choice_b": "Buy a limited set of new endpoint devices for administrator and control functions, load these from backups, and scan them with the latest anti-malware systems using a known clean and safe system; mitigate what the scan discovers. Then, restore critical servers and control systems in a similar manner.",
    "choice_c": "Using a known clean system and the latest anti-malware system, scan all elements of the corporate data center, mitigating anything it discovers. Then start to do the same for endpoints, and then for the OT controllers and systems.",
    "choice_d": "Using an alternate work location and your existing cloud services provider, have employees use their own laptops, desktops, or smartphones to start bringing critical business functions back into operation. As they do this, validate the content of the corporate databases that are hosted in the cloud. Then, use this solid base to launch off from as you restore on-premises capabilities, OT systems, and other endpoints.",
    "correct_answer": "D",
    "explanation": "The supply chain perspective emphasizes how the organization rebuilds the trusted computing base of each system, and across a chain of systems that support each critical process. From that perspective, option D is the least secure (and most worrisome) approach. Even with strong mobile device management in place prior to the attack, these user-owned and user-controlled devices could be infected with malware now, or as work is shifted to alternate locations (such as work from home) may become infected as the device is not kept properly safe and secure, such as through other browsing and use. <br>Option B or option C represent strong, secure paths out of this situation, with organizational priorities needing to designate where to start to get which critical processes back into operation. <br>Option A is also not advised, as it places too much reliance on the backup copies; it also seems to ignore the potential for onboard firmware having been corrupted by the attackers.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      264,
      265,
      234,
      237,
      240
    ],
    "source": ""
  },
  {
    "id": 1251,
    "question": "One of your co-workers says that while nonrepudiation is all well and good, it has no bearing on risk management. <br>Which statement best reflects your professional response?",
    "choice_a": "You agree; this is one of many low-level security controls that doesn't actually reduce the risk of a system or process failing.",
    "choice_b": "You disagree; nonrepudiation acts in real time to keep supply chains, communications, and contracts for services in fully working order, and those have a direct bearing on risk reduction and mitigation, and thus on risk management.",
    "choice_c": "You agree; while it is one of many security controls that have a direct bearing on risk reduction and mitigation, those are follow-on activities to risk management, and not part of risk management as a set of processes and decisions itself.",
    "choice_d": "You disagree; nonrepudiation combines integrity and authentication to ensure that systems function properly, and this reduces risk of attack, and thus it plays a role in risk management.",
    "correct_answer": "B",
    "explanation": "Option A is incorrect; nonrepudiation plays an important role in achieving and protecting systems integrity, for example. <br>Option C is incorrect, as risk mitigation and reduction are not separate from risk management. <br>Option D is incorrect in that nonrepudiation supports integrity and authentication as processes, rather than the other way around. <br>Option B correctly describes nonrepudiation's role in real time and relates that to risk management.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      38,
      41,
      59,
      58,
      56
    ],
    "source": ""
  },
  {
    "id": 1252,
    "question": "You're working with a small start-up organization that so far has not made any real efforts to establish an information security risk management process, strategy, or approach. The managers say that this is because those processes are big, formal, and complex, and require a lot of documentation to support them, and as a startup organization, they just don't have the labor, time, or talent to do all of that first and then get on with creating their new business. <br>Which statement would be your best professional advice in response?",
    "choice_a": "Agree; this is unfortunately one of the bigger risks that start-up organizations just have to ignore.",
    "choice_b": "Disagree, and point out that a commonsense approach that starts with basic computing and communications hygiene and security measures must be the bare minimum condition, if the business is to survive.",
    "choice_c": "Agree in part, but suggest instead that an incremental, discovery-based process can bring each risk, vulnerability, issue, or system element into risk management and control in a stepwise manner.",
    "choice_d": "Disagree, and point out that there are probably compliance requirements that they are ignoring, and at some point, those could become risks themselves that could put them all out of business.",
    "correct_answer": "C",
    "explanation": "Option A is incorrect; this doesn't really help take what seems like an insurmountable problem and offer any practical ways to work to solve it. <br>Option B is also incorrect; while such computing hygiene measures are quite common, they are not an either-or, must-have set of remedies. <br>Option C provides a nuanced approach and can help management see that risk management itself is manageable and affordable. <br>Option D is incorrect; this may be true, but a nonconfrontational approach, such as in Option C, provides a safer way to assess the organization's risk posture identify against these compliance requirements, one by one.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      36,
      56,
      47,
      59,
      65
    ],
    "source": ""
  },
  {
    "id": 1253,
    "question": "Many processes play a role in establishing and operating an effective information asset risk management program. Which statement places its set of processes in the most correct and logical sequence, flow, or order?",
    "choice_a": "Identify compliance requirements, establish classifications, establish categories, establish security baselines",
    "choice_b": "Establish classifications, establish categories, implement security controls, establish security baselines",
    "choice_c": "Establish categories, establish classifications, implement security controls, establish security baselines",
    "choice_d": "Assess vulnerabilities, establish classifications, identify categories, establish security baselines",
    "correct_answer": "A",
    "explanation": "Option A correctly shows the sequence, starting with externally imposed needs to protect different aspects of information security as they pertain to information assets the organization holds, creates, uses, or shares. <br>Option B is partly correct, but puts implementation of controls before establishing baselines; it should be after the baselines (which capture information about required controls) is created. <br>Option C is incorrect; see Option A. <br>Option D is incorrect, as vulnerability assessment needs the classifications to be established at a minimum to be meaningful.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      36,
      57,
      42,
      45,
      58
    ],
    "source": ""
  },
  {
    "id": 1254,
    "question": "Many in the security profession consider all things that are capable of causing a security disruption as threats; others separate threats from hazards and treat them somewhat differently. Which is used to separate threats from hazards?",
    "choice_a": "Identity: those actions that require some form of system access, and therefore an identity, are considered threats, while those that do not are classed as hazards.",
    "choice_b": "Insurance regulations: whether the insurance underwriters or regulations classify an action as a hazard, or as a threat",
    "choice_c": "Intention: accidents and natural events such as storms do not choose to happen, whereas disgruntled employees or cybercriminals choose to cause disruption to suit their own agendas.",
    "choice_d": "Customer perceptions: those actions that customers, investors, or other stakeholders consider as threats are called threats, the rest can be classed as hazards.",
    "correct_answer": "C",
    "explanation": "Option C is most correct, in that it focuses on whether there is conscious, willful intention behind the action or not. An employee who sneezes while typing a critical command or parameter does not make this error deliberately, nor are earthquakes caused by conscious choice. <br>Option A is incorrect; while many attack vectors require access to a system, not all of these require an identity to do so, such as side-channel attacks. <br>Option B is incorrect, even though most insurance markets, providers, and underwriters use the concepts of option C (natural, accidental, or intentional causes) in their underwriting. <br>Option D is also incorrect; this makes no meaningful or actionable distinction that would help a risk manager.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      34,
      46,
      42,
      55,
      56
    ],
    "source": ""
  },
  {
    "id": 1255,
    "question": "The large business that Jack works for has been using noncentralized logging for years. They have recently started to implement centralized logging, however, and as they reviewed logs, they discovered a breach that appeared to have involved a malicious insider. <br>How can Jack best ensure accountability for actions taken on systems in his environment?",
    "choice_a": "Review the logs and require digital signatures for each log.",
    "choice_b": "Require authentication for all actions taken and capture logs centrally.",
    "choice_c": "Log the use of administrative credentials and encrypt log data in transit.",
    "choice_d": "Require authorization and capture logs centrally.",
    "correct_answer": "B",
    "explanation": "Requiring authentication can help provide accountability by ensuring that any action taken can be tracked back to a specific user. Storing logs centrally ensures that users can't erase the evidence of actions that they have taken. Reviewing the logs can be useful when identifying issues, but digital signatures are not a typical part of a logging environment. Logging the use of administrative credentials helps for users with privileged access but won't cover all users, and encrypting the logs doesn't help with accountability. Authorization helps, but being able to specifically identify users through authentication is more important.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      369,
      726,
      342,
      433,
      374
    ],
    "source": ""
  },
  {
    "id": 1256,
    "question": "Veronica is responsible for her organization's asset management program. During what stage of the process would she select the controls that will be used to protect assets from theft?",
    "choice_a": "Implementation/assessment",
    "choice_b": "Operation/maintenance",
    "choice_c": "Inventory and licensing",
    "choice_d": "Process, planning, design, and initiation",
    "correct_answer": "D",
    "explanation": "Selecting security controls is a design task, so it should be done during the design phase of the program's development. The selected controls would later be implemented/assessed and operated/maintained during the appropriate phases. The inventory and licensing phase would track the assets used in her organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      314,
      321,
      357,
      345,
      273
    ],
    "source": ""
  },
  {
    "id": 1257,
    "question": "Under what type of software license does the recipient of software have an unlimited right to copy, modify, distribute, or resell a software package?",
    "choice_a": "GNU Public License",
    "choice_b": "Freeware",
    "choice_c": "Open source",
    "choice_d": "Public domain",
    "correct_answer": "D",
    "explanation": "If software is released into the public domain, anyone may use it for any purpose, without restriction. All other license types may contain at least some level of restriction.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      765,
      766,
      767,
      328,
      325
    ],
    "source": ""
  },
  {
    "id": 1258,
    "question": "When an attacker called an organization's help desk and persuaded them to reset a pass- word due to the help desk employee's trust and willingness to help, what type of attack succeeded?",
    "choice_a": "Trojan horse",
    "choice_b": "Social engineering",
    "choice_c": "Phishing",
    "choice_d": "Whaling",
    "correct_answer": "B",
    "explanation": "Social engineering exploits humans to allow attacks to succeed. Since help desk employees are specifically tasked with being helpful, they may be targeted by attackers posing as legitimate employees. Trojans are a type of malware, whereas phishing is an attack via electronic communication methods intended to capture passwords or other sensitive data. Whaling is a type of phishing aimed at high-profile or important targets.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      413,
      414,
      415,
      420,
      331
    ],
    "source": ""
  },
  {
    "id": 1259,
    "question": "In a zero-trust network architecture, what criterion is used to make trust decisions?",
    "choice_a": "Identity of a user or device",
    "choice_b": "IP address",
    "choice_c": "Network segment",
    "choice_d": "VLAN membership",
    "correct_answer": "A",
    "explanation": "Zero-trust network architectures make trust decisions based upon the identity of the user or device making the request. They do not make trust decisions based upon network location characteristics, such as an IP address, VLAN assignment, or network segment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      720,
      25,
      22,
      569,
      586
    ],
    "source": ""
  },
  {
    "id": 1260,
    "question": "Naomi wants to put a system in place that will allow her team to aggregate and correlate event information from a variety of systems and devices in her organization. She then wants to automate the investigation process using workflows with the correlated data. <br>What type of system should she put in place?",
    "choice_a": "A NAS",
    "choice_b": "An IPS",
    "choice_c": "A SOAR",
    "choice_d": "An MDR",
    "correct_answer": "C",
    "explanation": "A security orchestration, automation, and response (SOAR) system is designed to do just what Naomi wants. SOAR systems extend the capabilities of SIEM systems beyond aggregation and correlation into response and workflows. A network-attached storage (NAS) device is used to store data, not for security purposes. An IPS would allow her to detect attacks, but does not aggregate and correlate event data from other devices. An MDR is a managed detection and response system and is a third-party solution. Since Naomi wants to have the tasks performed by her team, rather than outsourcing, an MDR is not an appropriate solution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      61,
      59,
      471,
      609
    ],
    "source": ""
  },
  {
    "id": 1261,
    "question": "Murali wants to determine if SQL injection attacks are being attempted against his web application. Which of the following potential source systems will not be useful when identi- fying SQL injection?",
    "choice_a": "Application logs",
    "choice_b": "WAF logs",
    "choice_c": "Network switch logs",
    "choice_d": "Database logs",
    "correct_answer": "C",
    "explanation": "SQL injection attack details can typically be found in application logs like those found on a web server where the query will be logged. They can also be found in web application firewall (WAF) logs and in the logs from the database itself when actions are taken. Network switches, however, are unlikely to contain useful detail in their logs about SQL injection attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      472,
      61,
      51,
      53
    ],
    "source": ""
  },
  {
    "id": 1262,
    "question": "Li has completed the discovery of assets across her organization's network. What is the most likely next step in her vulnerability management lifecycle?",
    "choice_a": "Prioritizing the assets",
    "choice_b": "Applying patches to any vulnerable systems",
    "choice_c": "Testing the vulnerabilities using proof-of-concept exploits",
    "choice_d": "Identifying all vulnerabilities that have not been patched since the last scan",
    "correct_answer": "A",
    "explanation": "Once a discovery process is complete, assets are typically prioritized. Once that is complete, baseline risk profiles are created as part of the assessment process, and then reporting, remediation, and verification are conducted.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      56,
      617,
      42,
      66
    ],
    "source": ""
  },
  {
    "id": 1263,
    "question": "Diego's organization has applied controls to all risks that it has prioritized. It would not be cost effective to remediate or prevent the remaining risks, and he needs to determine what to do with them. What risk response option is most appropriate to this scenario?",
    "choice_a": "Transferring the risks",
    "choice_b": "Ignoring the risks",
    "choice_c": "Reviewing for possible new mitigations",
    "choice_d": "Accepting the risks",
    "correct_answer": "D",
    "explanation": "While it may be tempting to ignore the risks, even residual risks need to be accepted rather than being ignored. Thus, Diego should document the risks and ensure that an appropriate owner accepts them. Transferring or mitigating the risks was noted as not cost effective, so Diego already knows that those two answers would not work for his organization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      56,
      62,
      63,
      52
    ],
    "source": ""
  },
  {
    "id": 1264,
    "question": "Kathleen's organization has a mature risk assessment process with strong sponsorship from leadership, but also has very low tolerance for risk. Which of the following is most likely to be true about their process for handling risks?",
    "choice_a": "They are likely to accept many risks.",
    "choice_b": "They are likely to spend resources to mitigate as many risks as possible.",
    "choice_c": "They are likely to ignore as many risks as possible.",
    "choice_d": "They are likely to spend as few resources as possible to mitigate risks.",
    "correct_answer": "B",
    "explanation": "Kathleen's organization is likely to spend more resources to mitigate risks due to their low risk tolerance combined with strong executive support. They are unlikely to avoid or accept risks if they have a low risk tolerance, and they are also unlikely to avoid spending resources if they have strong executive support and risk assessment processes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      63,
      64,
      56,
      66
    ],
    "source": ""
  },
  {
    "id": 1265,
    "question": "Megan is reviewing her organization's risks and identifies a single point of failure due to the fiber-optic cable connection to a local fiber ring that her organization built and maintains. What type of risk does this describe?",
    "choice_a": "An intrinsic risk",
    "choice_b": "An architecture risk",
    "choice_c": "A supplier risk",
    "choice_d": "A contractual risk",
    "correct_answer": "B",
    "explanation": "Megan should note this as an architecture risk. Her organization may want to seek an additional backup path to the Internet and should ensure that it uses a physically distinct path as well as a different Internet service provider to be a fully effective backup link. A supplier risk would involve a third party, and no third party is mentioned in the question. Similarly, no contract is specified. Finally, intrinsic risk is not a commonly used term in information security risk practice.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      45,
      44,
      48,
      47
    ],
    "source": ""
  },
  {
    "id": 1266,
    "question": "Unusual outbound network traffic, irregularities in geographic or time-based login infor- mation, privileged users account activity changes, and unexpected traffic on nonstandard ports are all common examples of what?",
    "choice_a": "Vulnerability scanning artifacts",
    "choice_b": "SQL injection log entries",
    "choice_c": "Indicators of Compromise",
    "choice_d": "Key performance indicators",
    "correct_answer": "C",
    "explanation": "Indicators of compromise (IoCs) are data that is likely to indicate a compromise has occurred or is being attempted. Unusual traffic, logins, service ports or traffic, and use of privileges are all common IoCs. While some of these might be caused by vulnerability scans, not all of them are likely to be caused by such scans. SQL injection log data is often found in server logs, and key performance indicators (KPIs) are metrics used to determine if an organization or service is performing well.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      472,
      53,
      55,
      620,
      40
    ],
    "source": ""
  },
  {
    "id": 1267,
    "question": "Susan wants to use her SIEM to deliver notifications when events occur. Which of the following should she ensure is set to prevent responders from ignoring the notifications?",
    "choice_a": "An automated daily email with dashboard information",
    "choice_b": "A required login when notifications are sent",
    "choice_c": "Automated timeline creation for incident data",
    "choice_d": "Appropriate thresholds for notification",
    "correct_answer": "D",
    "explanation": "One of the most common reasons for notifications to be ignored is receiving too many due to improperly set thresholds. Susan should work with responders and administrators to ensure that thresholds are set to effectively detect incidents without generating undue numbers of notifications. Automated email is useful to ensure that recipients get information, but won't meet the need for real-time notification for actual issues. Requiring logins when notifications are sent can help to ensure data is not exposed, but this does not help with preventing staff from ignoring them; adding another step may cause fewer staff to read them. Finally, timelines are useful, but they won't prevent notifications from being ignored.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      625,
      40,
      65,
      60,
      57
    ],
    "source": ""
  },
  {
    "id": 1268,
    "question": "Henry's company is being sued for breach of contract. What type of law will cover this?",
    "choice_a": "Civil law",
    "choice_b": "Administrative law",
    "choice_c": "Criminal law",
    "choice_d": "Ethical standards",
    "correct_answer": "A",
    "explanation": "Civil law covers behavior that could cause injury to a corporation, individual, or other party. Criminal law covers behavior that could cause harm to society or the state. Administrative law regulates government agencies. Ethical standards are not a type of law.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      658,
      659,
      639,
      83,
      84
    ],
    "source": ""
  },
  {
    "id": 1269,
    "question": "The forensic investigation that Joanna has conducted is complete, and the report has been provided to organizational leadership in preparation for a human resources action. What should Joanna do once the report has been provided?",
    "choice_a": "Delete all files and notes about the forensic case.",
    "choice_b": "Notify the subject of the forensic investigation that it is complete.",
    "choice_c": "Notify law enforcement that the forensic investigation is complete.",
    "choice_d": "Preserve the forensic materials and notes in case they are needed.",
    "correct_answer": "D",
    "explanation": "When a forensic investigation is complete and the materials may be needed for legal or administrative actions, they should be secured and preserved. Since this case involves a human resources action, Joanna should preserve them. Notifying the subject of a forensic investigation is not a typical process when the investigation is done, nor is notifying law enforcement without a specific need to do so.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      632,
      640,
      644,
      660,
      101
    ],
    "source": ""
  },
  {
    "id": 1270,
    "question": "Which of the following is not an event that is typically prepared for in an emergency response plan?",
    "choice_a": "A supply chain disruption",
    "choice_b": "A pandemic",
    "choice_c": "A natural disaster",
    "choice_d": "A man-made disaster",
    "correct_answer": "A",
    "explanation": "Supply chain disruptions are not typically considered in emergency response plans. They're more likely to be handled through procurement processes and supplier management practices. Man-made and natural disasters as well as pandemics are all commonly addressed in emergency response plans.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      71,
      99,
      83,
      79,
      101
    ],
    "source": ""
  },
  {
    "id": 1271,
    "question": "Miguel is preparing a crisis management process for his organization. What step will typically come after \u201cRespond\u201d in the following cycle? <br><img src=\"/question_assets/SSCP/img_pt_4_1.png\"/>",
    "choice_a": "Analyze",
    "choice_b": "Recover",
    "choice_c": "Evaluate",
    "choice_d": "Identify",
    "correct_answer": "B",
    "explanation": "Crisis management is much like other forms of incident response, and once a crisis has occurred, response and then recovery must occur. Once recovery has happened, mitigation and preparation for the next event can begin.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      69,
      72,
      79,
      84,
      71
    ],
    "source": ""
  },
  {
    "id": 1272,
    "question": "Emma's organization is planning for natural disasters and wants to have a backup site available to move operations to. What important factor in backup site selection will help Emma avoid a single disaster disrupting operations for her organization?",
    "choice_a": "Network bandwidth",
    "choice_b": "Availability of backup power",
    "choice_c": "Geographic location",
    "choice_d": "Risk of natural disasters for the locations",
    "correct_answer": "C",
    "explanation": "The most important factor when selecting backup site locations is to identify a location that is unlikely to be impacted by the same natural disaster. In many cases, this is a location 50 to 90 miles away, but other factors can come into play when selecting a site. Examples include placing backup facilities for a site that may be impacted by a hurricane inland so that a single weather event is unlikely to impact both locations. Network bandwidth, availability of backup power, and the risk of natural disasters are all factors, but geographic dispersion is the most important element to consider.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      651,
      652,
      653,
      654,
      72
    ],
    "source": ""
  },
  {
    "id": 1273,
    "question": "Enterprise using an EAP-based protocol that uses certificate- based authentication. Which of the following EAP versions should she select?",
    "choice_a": "LEAP",
    "choice_b": "EAP-FAST",
    "choice_c": "EAP-TLS",
    "choice_d": "EAP-PKI",
    "correct_answer": "C",
    "explanation": "EAP-TLS uses certificate-based authentication. This requires management of certificates, but is useful for security reasons due to the ease of supporting full encryption. EAP-FAST uses Protected Access Credentials rather than certificates. The Lightweight Extensible Authentication Protocol (LEAP) uses dynamically generated WEP keys for encryption. EAP-PKI does not exist.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      180,
      182,
      189,
      167,
      192
    ],
    "source": ""
  },
  {
    "id": 1274,
    "question": "Ben wants to control lateral movement between servers in a data center where workloads move dynamically due to virtualization. What technology would be the most effective to implement to accomplish this?",
    "choice_a": "Software-defined networking",
    "choice_b": "OSI-based span control",
    "choice_c": "Hardware-controlled networking",
    "choice_d": "VPN",
    "correct_answer": "A",
    "explanation": "Software-defined networking allows exactly this type of control, moving and creating security boundaries and virtual firewalls as workloads move through a network. OSI- based span control and hardware-controlled networking do not exist, and a VPN is useful for connecting to or from security zones but isn't a solution that is well suited to this scenario.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      178,
      175,
      176,
      179
    ],
    "source": ""
  },
  {
    "id": 1275,
    "question": "Mikayla's organization uses virtual machines as their primary deployment method for servers and wants to add intrusion prevention capabilities inside their data center. Mikayla wants to be able to deploy the IPS devices to cover each of multiple clusters of machines based on their purpose, hosted in their VMware cluster. What deployment location will minimize latency, maximize network bandwidth, and allow the maximum degree of flexibility through automation for deployments?",
    "choice_a": "The IPSs should be inline with the VMware servers.",
    "choice_b": "The IPSs should be physical devices to handle the throughput required.",
    "choice_c": "The IPSs should be virtual, just like the VMware virtual machines.",
    "choice_d": "The IPSs should be software based and placed on each virtual machine.",
    "correct_answer": "C",
    "explanation": "Using virtual appliances in a deployment where they can protect virtual machines in the same infrastructure allows Mikayla to easily manage the devices using the same tools she uses for the other machines. At the same time, she can take advantage of virtual network fabrics for high-speed connectivity and flexibility. Inline placement is useful for IPS and firewall systems that are protecting specific devices and is often used for physical devices, but physical devices require either physical network changes or changes done in a separate management layer, making them take extra steps when flexibility and ease of management are important. Software-based IPS might work, but placing them on each virtual machine does not allow the IPS devices to cover clusters of systems since each is running on a single host.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      689,
      179,
      178,
      683,
      504
    ],
    "source": ""
  },
  {
    "id": 1276,
    "question": "Charles is reviewing data communications for cellular-enabled devices in his organization's field locations. He wants to ensure that traffic is encrypted between the data collection devices and his company's data logging service. What should he note about the connection if he knows that the devices are connecting via LTE (4G) cellular connections from a commercial carrier?",
    "choice_a": "The connections will be encrypted from end to end between the device and the server.",
    "choice_b": "The connections will be encrypted between the device and the cellular base station.",
    "choice_c": "The connections will not be encrypted by default.",
    "choice_d": "The connections will be encrypted and then decrypted and re-encrypted at each hop in the cellular network.",
    "correct_answer": "B",
    "explanation": "4G networks encrypt traffic between the cellular device and the base station but do not provide encryption after that point. If Charles wanted to provide end-to-end encryption, he would need to use a technology such as TLS to encrypt data at the device and then decrypt it once it reaches his servers.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      179,
      505,
      502,
      200,
      770
    ],
    "source": ""
  },
  {
    "id": 1277,
    "question": "Li wants to create a layer 2 network that spans multiple layer 3 networks. What network virtualization technology can she use to accomplish this task?",
    "choice_a": "VXLAN",
    "choice_b": "VMLAN",
    "choice_c": "802.2n",
    "choice_d": "802.1v",
    "correct_answer": "A",
    "explanation": "Virtual extensible local area networks (VXLANs) allow virtual layer 2 networks to be created overlaid on top of layer 3 networks. This can provide a powerful tool when multiple networks need to appear to be part of the same network such as between distinct physical buildings or sites. The rest of the answers for this question do not exist.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      505,
      504,
      179,
      200,
      178
    ],
    "source": ""
  },
  {
    "id": 1278,
    "question": "Henry wants to create a custom rule for his web application firewall that will prevent attackers from deleting data from his database. Which of the following rules is best suited to stop that type of attack?",
    "choice_a": "Block all queries that include the string UNION.",
    "choice_b": "Block all queries that include the string DROP.",
    "choice_c": "Block all queries that contain the string +OR+1=1.",
    "choice_d": "Block all queries that include the string SELECT.",
    "correct_answer": "B",
    "explanation": "SQL injection attacks use valid SQL code added to existing queries. The DROP command can be used to drop (delete) data from a database. While the other commands could be used as part of an attack, DROP is the only command that specifically threatens to perform data deletion like Henry is concerned about.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      769,
      768,
      770,
      533,
      685
    ],
    "source": ""
  },
  {
    "id": 1279,
    "question": "Ruchika wants to deploy a WPA2 network that is accessible for her customers. What WPA2 mode should she deploy if she wants to provide a security code to her customers without having to create accounts for them to log in with?",
    "choice_a": "WPA2 PSK",
    "choice_b": "WPA2 Open",
    "choice_c": "WPA2 Enterprise",
    "choice_d": "WPA2 Home",
    "correct_answer": "A",
    "explanation": "WPA2's preshared keys (PSK) mode uses a passcode, but does not require each user to have an account or an authentication server. This provides encryption unlike an open, unencrypted network, but does not provide the same level of security that enterprise mode does since you cannot identify individual users based on their accounts.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      182,
      180,
      178,
      195,
      174
    ],
    "source": ""
  },
  {
    "id": 1280,
    "question": "Tony's organization has suffered repeated, large-scale distributed denial-of-service attacks against its websites. Tony has been assigned to design a more robust infrastructure than the current design, which uses a cluster of load-balanced physical servers located in a data center at his organization's headquarters. Which of the following solutions is most likely to keep the website online during a distributed denial-of-service attack?",
    "choice_a": "Using a CDN",
    "choice_b": "Using a WAF to filter out all SQL injection attacks",
    "choice_c": "Moving to virtual machines hosted in the data center to allow greater scalability across existing hardware",
    "choice_d": "Moving to a containerized cluster of machines hosted in a third-party data center that can have multiple new systems added during heavy load",
    "correct_answer": "A",
    "explanation": "A content delivery network (CDN) is designed to host copies of a site at strategic points around the world, allowing greater scalability and throughput while reducing latency. They can also provide a high degree of resilience against distributed denial-of- service attacks due to their scale and built-in defenses against attacks. A WAF that is designed to prevent SQL injection will not stop most distributed denial-of-service attacks since they focus on bandwidth and other resource exhaustion rather than injection attacks. Scaling machines inside a local or remote data center, even with containers or VMs, will still result in scalability issues during a large distributed denial-of-service attack.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      729,
      730,
      770,
      768,
      178
    ],
    "source": ""
  },
  {
    "id": 1281,
    "question": "Yuri wants to protect his organization's IoT devices. They connect to a wireless WiFi network using WPA2, but do not support enterprise mode, so they have to use PSK mode. Which of the following techniques will best help to protect the IoT devices from attacks?",
    "choice_a": "Switch to WEP to ensure that a more secure protocol is used.",
    "choice_b": "Regularly change the preshared key to prevent attackers from brute-forcing it.",
    "choice_c": "Place the IoT devices on a separate wireless VLAN from other users and devices.",
    "choice_d": "Force all traffic from the devices to use TLS so that the traffic remains secure even if the wireless key is compromised.",
    "correct_answer": "C",
    "explanation": "Internet of Things (IoT) devices often have limitations on their capabilities, and it isn't uncommon to have devices on a network that cannot handle enterprise authentication modes for WPA2 or WPA3. That means segmenting those devices onto a separate VLAN to keep them away from other users and devices is a common best practice. WEP is less secure and older than WPA and should not be used. Changing the preshared key on a regular basis could create a massive amount of additional work to reconfigure devices that may not allow central or enterprise management. Forcing all traffic to use TLS may also be challenging since the devices may not support TLS for all data traffic or may not even use HTTPS as their primary communication mode.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      200,
      178,
      181,
      174,
      175
    ],
    "source": ""
  },
  {
    "id": 1282,
    "question": "Which of the following capabilities is not common for a software-defined wide area network (SD-WAN) solution?",
    "choice_a": "Traffic classification and optimization",
    "choice_b": "Responding to packet loss and latency issues",
    "choice_c": "Micro-segmentation and zone-based firewalling",
    "choice_d": "Automated malware detection and reporting",
    "correct_answer": "D",
    "explanation": "Software-defined wide area networking (SD-WAN) solutions provide central control of wide area networks, learning what traffic needs to flow and how, often with templates guiding initial configurations. Monitoring tools then allow the network to be adjusted to handle issues such as packet loss, latency, and jitter through techniques such as traffic classification, optimization, and routing changes. They also support capabilities like micro- segmentation and quality-of-service controls.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      688,
      178,
      184,
      200,
      730
    ],
    "source": ""
  },
  {
    "id": 1283,
    "question": "Ghita believes that her organization is having problems with fileless viruses. What Windows component is most likely being leveraged by the malware?",
    "choice_a": "Windows Remote Desktop",
    "choice_b": "Windows Defender",
    "choice_c": "PowerShell",
    "choice_d": "Windows Hello",
    "correct_answer": "C",
    "explanation": "PowerShell is frequently used by fileless viruses to perform actions on compromised systems. Ghita may want to recommend additional monitoring tools and capabilities for systems as well as utilities that can track the state of a system to monitor for unexpected changes. Remote Desktop is sometimes used for remote control, but is not commonly exploited by fileless malware; Defender might be part of the solution to stop the malware; and Windows Hello is used for local login.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 1284,
    "question": "Liu wants to use a publicly available container image to run a service in his cloud-hosted containerization environment. Which of the following best practices will best help him avoid malicious containers?",
    "choice_a": "Validating the container's digital signature",
    "choice_b": "Scanning the container for malicious software",
    "choice_c": "Running only containers that have been published for at least a week so problems can be identified by others",
    "choice_d": "Preventing container updates to avoid the introduction of new malicious code",
    "correct_answer": "A",
    "explanation": "Liu should validate the digital signature of the container to ensure that the container matches the original. Scanning the container for malicious software can be helpful, but scripts and other malicious tools might still be resident, or malware might not be detected. One of the advantages of containers is frequent easy updates, and waiting a week for each update might leave Liu's infrastructure vulnerable. Finally, preventing updates to avoid malware is also likely to leave the containers vulnerable.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      268,
      229,
      240,
      692,
      690
    ],
    "source": ""
  },
  {
    "id": 1285,
    "question": "Which of the following is not a common indicator of advanced persistent threat activity?",
    "choice_a": "Unexpected data flows to new or atypical destinations",
    "choice_b": "Remote-access Trojans installed on multiple systems",
    "choice_c": "An increase in spam email",
    "choice_d": "Use of elevated privileges by users who should not have that access",
    "correct_answer": "C",
    "explanation": "While advanced persistent threats (APTs) take advantage of a wide range of techniques and capabilities, unexpected data flows, use of remote access Trojans, and abuse of elevated privileges from unauthorized accounts are all common artifacts of an APT. Increases in spam email are not a direct indicator of an APT, but an increase in targeted phishing email might be.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      699,
      264,
      267,
      272,
      231
    ],
    "source": ""
  },
  {
    "id": 1286,
    "question": "Sara has been asked to explain to her organization what an endpoint detection and response (EDR) system could help the organization do. Which of the following functions is not a typical function for an EDR system?",
    "choice_a": "Endpoint data collection and central analysis",
    "choice_b": "Automated responses to threats",
    "choice_c": "Forensic analysis to help with threat response and detection",
    "choice_d": "Cloud and network data collection and central analysis",
    "correct_answer": "D",
    "explanation": "Endpoint detection and response (EDR) tools do not collect data like network traffic or cloud infrastructure. They do collect data from endpoints and centralize it for analysis and response, including forensic and threat detection capabilities.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      690,
      700,
      701,
      699,
      734
    ],
    "source": ""
  },
  {
    "id": 1287,
    "question": "Ian discovers the following URL in a web server log and believes it is some form of web- based attack: <br><code>http://example.com/ref?file=../../../../etc/passwd</code> <br>What type of attack should Ian identify this as?",
    "choice_a": "A denial-of-service attack",
    "choice_b": "A SQL injection attack",
    "choice_c": "A directory traversal attack",
    "choice_d": "A brute-force attack",
    "correct_answer": "C",
    "explanation": "This is an example of a directory traversal attack. In this case, it is aimed at accessing the <code>/etc/passwd</code> file on a Linux server. There is no indication of a denial-of-service attack that would attempt to crash a service or consume resources, and SQL injection will have escape characters and SQL code. Brute-force attacks simply try to gain access through minor variations until they succeed, and this doesn't have any indications of that type of attack.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      266
    ],
    "source": ""
  },
  {
    "id": 1288,
    "question": "Murali wants to ensure that if one of his organization's laptops is stolen, the data on it cannot be accessed. If he uses whole-disk encryption, when could data on the drives on his organization's laptops be accessed?",
    "choice_a": "When the systems are off, if the drives are removed and accessed using an external enclosure.",
    "choice_b": "When the laptops are booted and users are logged in.",
    "choice_c": "When the laptops are booted up but users are not logged in.",
    "choice_d": "The data is encrypted both at rest and when the user is logged in.",
    "correct_answer": "B",
    "explanation": "Whole-disk (often also called full-disk) encryption protects data at rest. When a user logs in, data from the drive can be accessed in unencrypted form.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      227,
      269,
      228,
      252,
      221
    ],
    "source": ""
  },
  {
    "id": 1289,
    "question": "Murali also wants to ensure that data is protected on his organization's mobile devices. His organization uses iPhones and iPads as their corporate devices. When can he expect data to be encrypted on his corporate mobile devices?",
    "choice_a": "When the phone is unlocked",
    "choice_b": "When the phone is locked if he enables encryption on the iPhones and iPads",
    "choice_c": "When the phone is locked, with or without a passcode",
    "choice_d": "When the phone is locked with a passcode, FaceID, or TouchID",
    "correct_answer": "D",
    "explanation": "By default, modern versions of iOS encrypt data when the device is locked using a passcode, TouchID, or FaceID. Locked devices that do not have a code set up will not be encrypted, and data can be accessed in unencrypted form on unlocked devices.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      227,
      252,
      244,
      221,
      254
    ],
    "source": ""
  },
  {
    "id": 1290,
    "question": "Olivia wants to use data from systems and devices in her network to identify potential advanced persistent threat activity. What type of analytics should she focus on to provide the best chance of detecting APTs based on indicators of compromise (IoCs) like data exfil- tration and privilege misuse?",
    "choice_a": "Signature-based detection",
    "choice_b": "Regression analysis",
    "choice_c": "Behavior analytics",
    "choice_d": "Trend-based analytics",
    "correct_answer": "C",
    "explanation": "Olivia should look for systems that provide behavior-based analytics that rely on AI, machine learning, or other data analytics capabilities to detect common indicators of compromise and malicious behavior. Signature-based detection often misses modern malware due to design features that change signatures to avoid detection. Trend-based analytics may be helpful to determine patterns, but behavior-based analytics will allow Olivia to detect issues rather than just trends. Finally, regression analysis techniques look at the relationship between multiple variables and are used for statistical modeling rather as a specific APT detection technique.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      701,
      700,
      699,
      272,
      704
    ],
    "source": ""
  },
  {
    "id": 1291,
    "question": "Greg's company has selected a bring your own device (BYOD) model for employee mobile devices. Greg has been tasked with recommending how to ensure that corporate data stays secure despite being on personally owned devices. Which of the following techniques is best suited to this in a BYOD environment?",
    "choice_a": "Require the use of a remote desktop environment from the mobile devices.",
    "choice_b": "Use MDM application-based containerization.",
    "choice_c": "Require a SIM swap when switching roles.",
    "choice_d": "Use a SIEM system to control application security.",
    "correct_answer": "B",
    "explanation": "Containers can allow controls to be applied at the container level, and using a mobile device management system can help keep data from being shared between personal applications and corporate applications. Similarly, controls on screenshots and other security concerns can also be controlled while keeping containerized apps secure. <br>While a remote desktop environment would work, it can be a challenge if bandwidth is restricted or if reception is poor. SIM swaps wouldn't change the applications or controls, just which cellular provider or account is in use. Finally, SIEMs are used to centralize security information and events, not to manage mobile devices.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      707,
      705,
      706,
      201,
      231
    ],
    "source": ""
  },
  {
    "id": 1292,
    "question": "Rosa wants to decrease the chances of both inadvertent data exposure and intentional data exfiltration from her organization. What technology can she implement to help with tag- ging and protecting data to prevent this scenario?",
    "choice_a": "COPE",
    "choice_b": "APT",
    "choice_c": "DLP",
    "choice_d": "SLA",
    "correct_answer": "C",
    "explanation": "Data loss prevention (DLP) tools rely on tagging, pattern recognition, and other techniques to identify data that should be protected and to detect if it is being sent or used in ways that do not fit organizational policy. DLP can be a useful control against both inadvertent exposures and intentional data exfiltration attempts. COPE is a mobile device deployment scheme for company owned, personally enabled devices; APTs are advanced persistent threats; and SLAs are service level agreements.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      272,
      253,
      231,
      201,
      266
    ],
    "source": ""
  },
  {
    "id": 1293,
    "question": "Keisha's organization has begun to purchase mobile devices for use by sales staff who oper- ate outside of the office. Since the devices are in use as their primary phones, the salespeople often have personal applications loaded on them, which has created a security concern for the company since sensitive corporate data, including sales numbers and proprietary customer databases, are stored on or accessed via the phones. What technology should Keisha deploy to control applications on the phones?",
    "choice_a": "TPM",
    "choice_b": "SCCM",
    "choice_c": "MAM",
    "choice_d": "MTM",
    "correct_answer": "C",
    "explanation": "A mobile application management (MAM) tool, or an MDM tool that has MAM capabilities built in, will allow Keisha to control what applications are installed, what version they are, and other important settings. TPM is a trusted platform module, used for security and encryption on devices. SCCM was Microsoft's System Center Configuration Manager, which has now become the Microsoft Endpoint Configuration Manager, and MTM isn't a security-related term or acronym.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      693,
      266,
      256,
      265,
      252
    ],
    "source": ""
  }
];
